// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/react-json-pretty/themes/acai.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/react-mde/lib/styles/css/react-mde-all.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/@paylixecommerce/shared/dist/cjs/assets/style.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fontawesome/scss/webfonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fontawesome/scss/webfonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fontawesome/scss/webfonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fontawesome/scss/webfonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fontawesome/scss/webfonts/fa-light-300.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fontawesome/scss/webfonts/fa-light-300.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fontawesome/scss/webfonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/fontawesome/scss/webfonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("assets/fontawesome/scss/webfonts/fa-thin-100.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("assets/fontawesome/scss/webfonts/fa-thin-100.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("assets/NEW/font/Inter.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSA3LjVMMTAgMTIuNUwxNSA3LjUiIHN0cm9rZT0iI0EyQUFCNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 fill=%27none%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M12.5 5L7.5 10L12.5 15%27 stroke=%27white%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 fill=%27none%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M12.5 5L7.5 10L12.5 15%27 stroke=%27%23555D67%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 fill=%27none%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M7.5 5L12.5 10L7.5 15%27 stroke=%27white%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 fill=%27none%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M7.5 5L12.5 10L7.5 15%27 stroke=%27%23555D67%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
html {
  --black9: #121417;
  --black8: #1B1F23;
  --black7: #262A30;
  --black6: #454C56;
  --black5: #555D67;
  --black4: #777F89;
  --black3: #A2AAB4;
  --black2: #DFE5E9;
  --black1: #E8EDF0;
  --black0: #F5F7F8;
  --white: white;
  --black: #121417;
  --purple9: #43248E;
  --purple8: #5129AE;
  --purple7: #6132cf;
  --purple6: #6a3ce2;
  --purple5: #8164ee;
  --purple4: #a191f4;
  --purple3: #c0b9f9;
  --purple2: #dbd8fc;
  --purple1: #eceafd;
  --purple0: #f4f4fe;
  --red9: #381E1D;
  --red8: #60211F;
  --red7: #A53E3E;
  --red6: #D24242;
  --red5: #E85757;
  --red4: #f87171;
  --red3: #fca5a5;
  --red2: #fecaca;
  --red1: #fee2e2;
  --red0: #fef2f2;
  --orange9: #35241E;
  --orange8: #753621;
  --orange7: #BC542A;
  --orange6: #E16727;
  --orange5: #F17C2A;
  --orange4: #F69546;
  --orange3: #FCB871;
  --orange2: #fed7aa;
  --orange1: #F9ECDB;
  --orange0: #fff7ed;
  --green9: #143120;
  --green8: #166534;
  --green7: #15803d;
  --green6: #239F51;
  --green5: #35C068;
  --green4: #66DB91;
  --green3: #8CEDAF;
  --green2: #bbf7d0;
  --green1: #E3F5E9;
  --green0: #f0fdf4;
  --pink9: #701338;
  --pink8: #9D174D;
  --pink7: #BE185D;
  --pink6: #DB2777;
  --pink5: #EC4899;
  --pink4: #F472B6;
  --pink3: #F9A8D4;
  --pink2: #FBCFE8;
  --pink1: #FCE7F3;
  --pink0: #FDF2F8;
  --blue9: #1E3A8A;
  --blue8: #1E40AF;
  --blue7: #1D4ED8;
  --blue6: #2563EB;
  --blue5: #3B82F6;
  --blue4: #60A5FA;
  --blue3: #93C5FD;
  --blue2: #BFDBFE;
  --blue1: #DBEAFE;
  --blue0: #EFF6FF;
  --cyan9: #164E63;
  --cyan8: #155E75;
  --cyan7: #0E7490;
  --cyan6: #0891B2;
  --cyan5: #06B6D4;
  --cyan4: #22D3EE;
  --cyan3: #67E8F9;
  --cyan2: #A5F3FC;
  --cyan1: #D4F6F9;
  --cyan0: #EEF7F8;
}

.black9 {
  color: #121417;
  --black9: #121417;
}

.black8 {
  color: #1B1F23;
  --black8: #1B1F23;
}

.black7 {
  color: #32373E;
  --black7: #32373E;
}

.black6 {
  color: #454C56;
  --black6: #454C56;
}

.black5 {
  color: #555D67;
  --black5: #555D67;
}

.black4 {
  color: #777F89;
  --black4: #777F89;
}

.black3 {
  color: #A2AAB4;
  --black3: #A2AAB4;
}

.black2 {
  color: #CBD2D8;
  --black2: #CBD2D8;
}

.black1 {
  color: #E8EDF0;
  --black1: #E8EDF0;
}

.black0 {
  color: #F5F7F8;
  --black0: #F5F7F8;
}

.white {
  color: white;
  --white: #000000;
}

.purple9 {
  color: #43248E;
  --purple9: #43248E;
}

.purple8 {
  color: #5129AE;
  --purple8: #5129AE;
}

.purple7 {
  color: #6132cf;
  --purple7: #6132cf;
}

.purple6 {
  color: #6a3ce2;
  --purple6: #6a3ce2;
}

.purple5 {
  color: #8164ee;
  --purple5: #8164ee;
}

.purple4 {
  color: #a191f4;
  --purple4: #a191f4;
}

.purple3 {
  color: #c0b9f9;
  --purple3: #c0b9f9;
}

.purple2 {
  color: #dbd8fc;
  --purple2: #dbd8fc;
}

.purple1 {
  color: #eceafd;
  --purple1: #eceafd;
}

.purple0 {
  color: #f4f4fe;
  --purple0: #f4f4fe;
}

.red9 {
  color: #7f1d1d;
  --red9: #7f1d1d;
}

.red8 {
  color: #991b1b;
  --red8: #991b1b;
}

.red7 {
  color: #b91c1c;
  --red7: #b91c1c;
}

.red6 {
  color: #dc2626;
  --red6: #dc2626;
}

.red5 {
  color: #ef4444;
  --red5: #ef4444;
}

.red4 {
  color: #f87171;
  --red4: #f87171;
}

.red3 {
  color: #fca5a5;
  --red3: #fca5a5;
}

.red2 {
  color: #fecaca;
  --red2: #fecaca;
}

.red1 {
  color: #fee2e2;
  --red1: #fee2e2;
}

.red0 {
  color: #fef2f2;
  --red0: #fef2f2;
}

.orange9 {
  color: #7c2d12;
  --orange9: #7c2d12;
}

.orange8 {
  color: #9a3412;
  --orange8: #9a3412;
}

.orange7 {
  color: #c2410c;
  --orange7: #c2410c;
}

.orange6 {
  color: #ea580c;
  --orange6: #ea580c;
}

.orange5 {
  color: #f97316;
  --orange5: #f97316;
}

.orange4 {
  color: #fb923c;
  --orange4: #fb923c;
}

.orange3 {
  color: #fdba74;
  --orange3: #fdba74;
}

.orange2 {
  color: #fed7aa;
  --orange2: #fed7aa;
}

.orange1 {
  color: #ffedd5;
  --orange1: #ffedd5;
}

.orange0 {
  color: #fff7ed;
  --orange0: #fff7ed;
}

.green9 {
  color: #0B321B;
  --green9: #0B321B;
}

.green8 {
  color: #166534;
  --green8: #166534;
}

.green7 {
  color: #15803d;
  --green7: #15803d;
}

.green6 {
  color: #16a34a;
  --green6: #16a34a;
}

.green5 {
  color: #22c55e;
  --green5: #22c55e;
}

.green4 {
  color: #4ade80;
  --green4: #4ade80;
}

.green3 {
  color: #86efac;
  --green3: #86efac;
}

.green2 {
  color: #bbf7d0;
  --green2: #bbf7d0;
}

.green1 {
  color: #dcfce7;
  --green1: #dcfce7;
}

.green0 {
  color: #f0fdf4;
  --green0: #f0fdf4;
}

.font {
  font-family: "Inter";
  font-style: normal;
  color: var(--black9);
}

.font-normal {
  font-weight: 500;
  --font-normal: 500;
}

.font-thin {
  font-weight: 400;
  --font-thin: 400;
}

.font-size-7 {
  font-size: 40px;
  line-height: 48px;
}

.font-size-6 {
  font-size: 32px;
  line-height: 39px;
}

.font-size-5 {
  font-size: 24px;
  line-height: 29px;
}

.font-size-4 {
  font-size: 18px;
  line-height: 22px;
}

.font-size-3 {
  font-size: 16px;
  line-height: 19px;
}

.font-size-2 {
  font-size: 14px;
  line-height: 17px;
}

.font-size-1 {
  font-size: 13px;
  line-height: 16px;
}

.font-size-0 {
  font-size: 12px;
  line-height: 15px;
}

/*!
 * Bootstrap v5.0.2 (https://getbootstrap.com/)
 * Copyright 2011-2021 The Bootstrap Authors
 * Copyright 2011-2021 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-font-sans-serif);
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  background-color: currentColor;
  border: 0;
  opacity: 0.25;
}

hr:not([size]) {
  height: 1px;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-bs-original-title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

mark, .mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

sub,
sup {
  position: relative;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #0d6efd;
  text-decoration: underline;
}
a:hover {
  color: #0a58ca;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  direction: ltr /* rtl:ignore */;
  unicode-bidi: bidi-override;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
}
pre code {
  color: inherit;
  word-break: normal;
}

code {
  color: #d63384;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #6c757d;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]::-webkit-calendar-picker-indicator {
  display: none;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
*::-webkit-search-decoration {
  -webkit-appearance: none;
}

*::-webkit-color-swatch-wrapper {
  padding: 0;
}

*::file-selector-button {
  font: inherit;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
}

.initialism {
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
}
.btn:hover {
  color: #212529;
}
.btn-check:focus + .btn, .btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  pointer-events: none;
  opacity: 0.65;
}

.btn-link {
  font-weight: 400;
  color: #0d6efd;
  text-decoration: underline;
}
.btn-link:hover {
  color: #0a58ca;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
}

.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}

.pagination {
  display: flex;
}

.page-link {
  position: relative;
  display: block;
  color: #0d6efd;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: #0a58ca;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  color: #0a58ca;
  background-color: #e9ecef;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  border-color: #0d6efd;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
.react-code-input {
  width: 100%;
}
.react-code-input input {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  box-shadow: none !important;
  border: 1px solid var(--black1) !important;
  background: var(--white) !important;
  border-radius: 0 !important;
  color: var(--black9) !important;
  transition: border 0.3s ease !important;
  height: 48px !important;
  outline: none !important;
  border-right: none !important;
  text-align: center;
  margin: 0 !important;
  padding: 0 0.25rem !important;
  font-size: 32px;
  width: 12.5% !important;
  font-family: "Inter", sans-serif !important;
  -moz-appearance: textfield !important;
}
.react-code-input input:first-child {
  border-radius: 0.5rem 0 0 0.5rem !important;
}
.react-code-input input:last-child {
  border-radius: 0 0.5rem 0.5rem 0 !important;
  border-right: 1px solid var(--black1) !important;
}
.react-code-input input[type=number] {
  -moz-appearance: textfield !important;
}
.react-code-input input[type=number]:hover, .react-code-input input[type=number]:focus {
  -moz-appearance: textfield !important;
}
.react-code-input input[type=number]::-webkit-inner-spin-button, .react-code-input input[type=number]::-webkit-outer-spin-button, .react-code-input input[type=number]:hover::-webkit-inner-spin-button, .react-code-input input[type=number]:hover::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: textfield;
  appearance: none;
  margin: 0;
}
.react-code-input input::-webkit-outer-spin-button, .react-code-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.react-code-input input[type=number] {
  -moz-appearance: textfield !important;
}

/*!
 * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
.fa {
  font-family: var(--fa-style-family, "Font Awesome 6 Pro");
  font-weight: var(--fa-style, 900);
}

.fa,
.fas,
.fa-solid,
.far,
.fa-regular,
.fal,
.fa-light,
.fat,
.fa-thin,
.fad,
.fa-duotone,
.fab,
.fa-brands {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flash {
  animation-name: fa-flash;
  animation-delay: var(--fa-animation-delay, 0);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
  .fa-fade,
  .fa-flash,
  .fa-flip,
  .fa-pulse,
  .fa-spin,
  .fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-flash {
  0%, 100% {
    opacity: var(--fa-flash-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-flash-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: var(--fa-stack-z-index, auto);
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.fa-0::before {
  content: "\\30 ";
}

.fa-1::before {
  content: "\\31 ";
}

.fa-2::before {
  content: "\\32 ";
}

.fa-3::before {
  content: "\\33 ";
}

.fa-4::before {
  content: "\\34 ";
}

.fa-5::before {
  content: "\\35 ";
}

.fa-6::before {
  content: "\\36 ";
}

.fa-7::before {
  content: "\\37 ";
}

.fa-8::before {
  content: "\\38 ";
}

.fa-9::before {
  content: "\\39 ";
}

.fa-360-degrees::before {
  content: "\\e2dc";
}

.fa-a::before {
  content: "A";
}

.fa-abacus::before {
  content: "\\f640";
}

.fa-accent-grave::before {
  content: "\\\`";
}

.fa-acorn::before {
  content: "\\f6ae";
}

.fa-address-book::before {
  content: "\\f2b9";
}

.fa-contact-book::before {
  content: "\\f2b9";
}

.fa-address-card::before {
  content: "\\f2bb";
}

.fa-contact-card::before {
  content: "\\f2bb";
}

.fa-vcard::before {
  content: "\\f2bb";
}

.fa-air-conditioner::before {
  content: "\\f8f4";
}

.fa-airplay::before {
  content: "\\e089";
}

.fa-alarm-clock::before {
  content: "\\f34e";
}

.fa-alarm-exclamation::before {
  content: "\\f843";
}

.fa-alarm-plus::before {
  content: "\\f844";
}

.fa-alarm-snooze::before {
  content: "\\f845";
}

.fa-album::before {
  content: "\\f89f";
}

.fa-album-collection::before {
  content: "\\f8a0";
}

.fa-alicorn::before {
  content: "\\f6b0";
}

.fa-alien::before {
  content: "\\f8f5";
}

.fa-alien-8bit::before {
  content: "\\f8f6";
}

.fa-alien-monster::before {
  content: "\\f8f6";
}

.fa-align-center::before {
  content: "\\f037";
}

.fa-align-justify::before {
  content: "\\f039";
}

.fa-align-left::before {
  content: "\\f036";
}

.fa-align-right::before {
  content: "\\f038";
}

.fa-align-slash::before {
  content: "\\f846";
}

.fa-alt::before {
  content: "\\e08a";
}

.fa-amp-guitar::before {
  content: "\\f8a1";
}

.fa-ampersand::before {
  content: "\\&";
}

.fa-anchor::before {
  content: "\\f13d";
}

.fa-angel::before {
  content: "\\f779";
}

.fa-angle::before {
  content: "\\e08c";
}

.fa-angle-90::before {
  content: "\\e08d";
}

.fa-angle-down::before {
  content: "\\f107";
}

.fa-angle-left::before {
  content: "\\f104";
}

.fa-angle-right::before {
  content: "\\f105";
}

.fa-angle-up::before {
  content: "\\f106";
}

.fa-angles-down::before {
  content: "\\f103";
}

.fa-angle-double-down::before {
  content: "\\f103";
}

.fa-angles-left::before {
  content: "\\f100";
}

.fa-angle-double-left::before {
  content: "\\f100";
}

.fa-angles-right::before {
  content: "\\f101";
}

.fa-angle-double-right::before {
  content: "\\f101";
}

.fa-angles-up::before {
  content: "\\f102";
}

.fa-angle-double-up::before {
  content: "\\f102";
}

.fa-ankh::before {
  content: "\\f644";
}

.fa-aperture::before {
  content: "\\e2df";
}

.fa-apostrophe::before {
  content: "\\'";
}

.fa-apple-core::before {
  content: "\\e08f";
}

.fa-apple-whole::before {
  content: "\\f5d1";
}

.fa-apple-alt::before {
  content: "\\f5d1";
}

.fa-archway::before {
  content: "\\f557";
}

.fa-arrow-down::before {
  content: "\\f063";
}

.fa-arrow-down-1-9::before {
  content: "\\f162";
}

.fa-sort-numeric-asc::before {
  content: "\\f162";
}

.fa-sort-numeric-down::before {
  content: "\\f162";
}

.fa-arrow-down-9-1::before {
  content: "\\f886";
}

.fa-sort-numeric-desc::before {
  content: "\\f886";
}

.fa-sort-numeric-down-alt::before {
  content: "\\f886";
}

.fa-arrow-down-a-z::before {
  content: "\\f15d";
}

.fa-sort-alpha-asc::before {
  content: "\\f15d";
}

.fa-sort-alpha-down::before {
  content: "\\f15d";
}

.fa-arrow-down-arrow-up::before {
  content: "\\f883";
}

.fa-sort-alt::before {
  content: "\\f883";
}

.fa-arrow-down-big-small::before {
  content: "\\f88c";
}

.fa-sort-size-down::before {
  content: "\\f88c";
}

.fa-arrow-down-from-dotted-line::before {
  content: "\\e090";
}

.fa-arrow-down-from-line::before {
  content: "\\f345";
}

.fa-arrow-from-top::before {
  content: "\\f345";
}

.fa-arrow-down-left::before {
  content: "\\e091";
}

.fa-arrow-down-left-and-arrow-up-right-to-center::before {
  content: "\\e092";
}

.fa-arrow-down-long::before {
  content: "\\f175";
}

.fa-long-arrow-down::before {
  content: "\\f175";
}

.fa-arrow-down-right::before {
  content: "\\e093";
}

.fa-arrow-down-short-wide::before {
  content: "\\f884";
}

.fa-sort-amount-desc::before {
  content: "\\f884";
}

.fa-sort-amount-down-alt::before {
  content: "\\f884";
}

.fa-arrow-down-small-big::before {
  content: "\\f88d";
}

.fa-sort-size-down-alt::before {
  content: "\\f88d";
}

.fa-arrow-down-square-triangle::before {
  content: "\\f889";
}

.fa-sort-shapes-down-alt::before {
  content: "\\f889";
}

.fa-arrow-down-to-bracket::before {
  content: "\\e094";
}

.fa-arrow-down-to-dotted-line::before {
  content: "\\e095";
}

.fa-arrow-down-to-line::before {
  content: "\\f33d";
}

.fa-arrow-to-bottom::before {
  content: "\\f33d";
}

.fa-arrow-down-to-square::before {
  content: "\\e096";
}

.fa-arrow-down-triangle-square::before {
  content: "\\f888";
}

.fa-sort-shapes-down::before {
  content: "\\f888";
}

.fa-arrow-down-wide-short::before {
  content: "\\f160";
}

.fa-sort-amount-asc::before {
  content: "\\f160";
}

.fa-sort-amount-down::before {
  content: "\\f160";
}

.fa-arrow-down-z-a::before {
  content: "\\f881";
}

.fa-sort-alpha-desc::before {
  content: "\\f881";
}

.fa-sort-alpha-down-alt::before {
  content: "\\f881";
}

.fa-arrow-left::before {
  content: "\\f060";
}

.fa-arrow-left-from-line::before {
  content: "\\f344";
}

.fa-arrow-from-right::before {
  content: "\\f344";
}

.fa-arrow-left-long::before {
  content: "\\f177";
}

.fa-long-arrow-left::before {
  content: "\\f177";
}

.fa-arrow-left-long-to-line::before {
  content: "\\e3d4";
}

.fa-arrow-left-to-line::before {
  content: "\\f33e";
}

.fa-arrow-to-left::before {
  content: "\\f33e";
}

.fa-arrow-pointer::before {
  content: "\\f245";
}

.fa-mouse-pointer::before {
  content: "\\f245";
}

.fa-arrow-right::before {
  content: "\\f061";
}

.fa-arrow-right-arrow-left::before {
  content: "\\f0ec";
}

.fa-exchange::before {
  content: "\\f0ec";
}

.fa-arrow-right-from-bracket::before {
  content: "\\f08b";
}

.fa-sign-out::before {
  content: "\\f08b";
}

.fa-arrow-right-from-line::before {
  content: "\\f343";
}

.fa-arrow-from-left::before {
  content: "\\f343";
}

.fa-arrow-right-long::before {
  content: "\\f178";
}

.fa-long-arrow-right::before {
  content: "\\f178";
}

.fa-arrow-right-long-to-line::before {
  content: "\\e3d5";
}

.fa-arrow-right-to-bracket::before {
  content: "\\f090";
}

.fa-sign-in::before {
  content: "\\f090";
}

.fa-arrow-right-to-line::before {
  content: "\\f340";
}

.fa-arrow-to-right::before {
  content: "\\f340";
}

.fa-arrow-rotate-left::before {
  content: "\\f0e2";
}

.fa-arrow-left-rotate::before {
  content: "\\f0e2";
}

.fa-arrow-rotate-back::before {
  content: "\\f0e2";
}

.fa-arrow-rotate-backward::before {
  content: "\\f0e2";
}

.fa-undo::before {
  content: "\\f0e2";
}

.fa-arrow-rotate-right::before {
  content: "\\f01e";
}

.fa-arrow-right-rotate::before {
  content: "\\f01e";
}

.fa-arrow-rotate-forward::before {
  content: "\\f01e";
}

.fa-redo::before {
  content: "\\f01e";
}

.fa-arrow-trend-down::before {
  content: "\\e097";
}

.fa-arrow-trend-up::before {
  content: "\\e098";
}

.fa-arrow-turn-down::before {
  content: "\\f149";
}

.fa-level-down::before {
  content: "\\f149";
}

.fa-arrow-turn-down-left::before {
  content: "\\e2e1";
}

.fa-arrow-turn-down-right::before {
  content: "\\e3d6";
}

.fa-arrow-turn-up::before {
  content: "\\f148";
}

.fa-level-up::before {
  content: "\\f148";
}

.fa-arrow-up::before {
  content: "\\f062";
}

.fa-arrow-up-1-9::before {
  content: "\\f163";
}

.fa-sort-numeric-up::before {
  content: "\\f163";
}

.fa-arrow-up-9-1::before {
  content: "\\f887";
}

.fa-sort-numeric-up-alt::before {
  content: "\\f887";
}

.fa-arrow-up-a-z::before {
  content: "\\f15e";
}

.fa-sort-alpha-up::before {
  content: "\\f15e";
}

.fa-arrow-up-arrow-down::before {
  content: "\\e099";
}

.fa-sort-up-down::before {
  content: "\\e099";
}

.fa-arrow-up-big-small::before {
  content: "\\f88e";
}

.fa-sort-size-up::before {
  content: "\\f88e";
}

.fa-arrow-up-from-bracket::before {
  content: "\\e09a";
}

.fa-arrow-up-from-dotted-line::before {
  content: "\\e09b";
}

.fa-arrow-up-from-line::before {
  content: "\\f342";
}

.fa-arrow-from-bottom::before {
  content: "\\f342";
}

.fa-arrow-up-from-square::before {
  content: "\\e09c";
}

.fa-arrow-up-left::before {
  content: "\\e09d";
}

.fa-arrow-up-left-from-circle::before {
  content: "\\e09e";
}

.fa-arrow-up-long::before {
  content: "\\f176";
}

.fa-long-arrow-up::before {
  content: "\\f176";
}

.fa-arrow-up-right::before {
  content: "\\e09f";
}

.fa-arrow-up-right-and-arrow-down-left-from-center::before {
  content: "\\e0a0";
}

.fa-arrow-up-right-from-square::before {
  content: "\\f08e";
}

.fa-external-link::before {
  content: "\\f08e";
}

.fa-arrow-up-short-wide::before {
  content: "\\f885";
}

.fa-sort-amount-up-alt::before {
  content: "\\f885";
}

.fa-arrow-up-small-big::before {
  content: "\\f88f";
}

.fa-sort-size-up-alt::before {
  content: "\\f88f";
}

.fa-arrow-up-square-triangle::before {
  content: "\\f88b";
}

.fa-sort-shapes-up-alt::before {
  content: "\\f88b";
}

.fa-arrow-up-to-dotted-line::before {
  content: "\\e0a1";
}

.fa-arrow-up-to-line::before {
  content: "\\f341";
}

.fa-arrow-to-top::before {
  content: "\\f341";
}

.fa-arrow-up-triangle-square::before {
  content: "\\f88a";
}

.fa-sort-shapes-up::before {
  content: "\\f88a";
}

.fa-arrow-up-wide-short::before {
  content: "\\f161";
}

.fa-sort-amount-up::before {
  content: "\\f161";
}

.fa-arrow-up-z-a::before {
  content: "\\f882";
}

.fa-sort-alpha-up-alt::before {
  content: "\\f882";
}

.fa-arrows-cross::before {
  content: "\\e0a2";
}

.fa-arrows-from-dotted-line::before {
  content: "\\e0a3";
}

.fa-arrows-from-line::before {
  content: "\\e0a4";
}

.fa-arrows-left-right::before {
  content: "\\f07e";
}

.fa-arrows-h::before {
  content: "\\f07e";
}

.fa-arrows-maximize::before {
  content: "\\f31d";
}

.fa-expand-arrows::before {
  content: "\\f31d";
}

.fa-arrows-minimize::before {
  content: "\\e0a5";
}

.fa-compress-arrows::before {
  content: "\\e0a5";
}

.fa-arrows-repeat::before {
  content: "\\f364";
}

.fa-repeat-alt::before {
  content: "\\f364";
}

.fa-arrows-repeat-1::before {
  content: "\\f366";
}

.fa-repeat-1-alt::before {
  content: "\\f366";
}

.fa-arrows-retweet::before {
  content: "\\f361";
}

.fa-retweet-alt::before {
  content: "\\f361";
}

.fa-arrows-rotate::before {
  content: "\\f021";
}

.fa-refresh::before {
  content: "\\f021";
}

.fa-sync::before {
  content: "\\f021";
}

.fa-arrows-to-dotted-line::before {
  content: "\\e0a6";
}

.fa-arrows-to-line::before {
  content: "\\e0a7";
}

.fa-arrows-up-down::before {
  content: "\\f07d";
}

.fa-arrows-v::before {
  content: "\\f07d";
}

.fa-arrows-up-down-left-right::before {
  content: "\\f047";
}

.fa-arrows::before {
  content: "\\f047";
}

.fa-asterisk::before {
  content: "\\*";
}

.fa-at::before {
  content: "\\@";
}

.fa-atom::before {
  content: "\\f5d2";
}

.fa-atom-simple::before {
  content: "\\f5d3";
}

.fa-atom-alt::before {
  content: "\\f5d3";
}

.fa-audio-description::before {
  content: "\\f29e";
}

.fa-audio-description-slash::before {
  content: "\\e0a8";
}

.fa-austral-sign::before {
  content: "\\e0a9";
}

.fa-avocado::before {
  content: "\\e0aa";
}

.fa-award::before {
  content: "\\f559";
}

.fa-award-simple::before {
  content: "\\e0ab";
}

.fa-axe::before {
  content: "\\f6b2";
}

.fa-axe-battle::before {
  content: "\\f6b3";
}

.fa-b::before {
  content: "B";
}

.fa-baby::before {
  content: "\\f77c";
}

.fa-baby-carriage::before {
  content: "\\f77d";
}

.fa-carriage-baby::before {
  content: "\\f77d";
}

.fa-backpack::before {
  content: "\\f5d4";
}

.fa-backward::before {
  content: "\\f04a";
}

.fa-backward-fast::before {
  content: "\\f049";
}

.fa-fast-backward::before {
  content: "\\f049";
}

.fa-backward-step::before {
  content: "\\f048";
}

.fa-step-backward::before {
  content: "\\f048";
}

.fa-bacon::before {
  content: "\\f7e5";
}

.fa-bacteria::before {
  content: "\\e059";
}

.fa-bacterium::before {
  content: "\\e05a";
}

.fa-badge::before {
  content: "\\f335";
}

.fa-badge-check::before {
  content: "\\f336";
}

.fa-badge-dollar::before {
  content: "\\f645";
}

.fa-badge-percent::before {
  content: "\\f646";
}

.fa-badge-sheriff::before {
  content: "\\f8a2";
}

.fa-badger-honey::before {
  content: "\\f6b4";
}

.fa-badminton::before {
  content: "\\e33a";
}

.fa-bag-shopping::before {
  content: "\\f290";
}

.fa-shopping-bag::before {
  content: "\\f290";
}

.fa-bagel::before {
  content: "\\e3d7";
}

.fa-bags-shopping::before {
  content: "\\f847";
}

.fa-baguette::before {
  content: "\\e3d8";
}

.fa-bahai::before {
  content: "\\f666";
}

.fa-baht-sign::before {
  content: "\\e0ac";
}

.fa-ball-pile::before {
  content: "\\f77e";
}

.fa-balloon::before {
  content: "\\e2e3";
}

.fa-balloons::before {
  content: "\\e2e4";
}

.fa-ballot::before {
  content: "\\f732";
}

.fa-ballot-check::before {
  content: "\\f733";
}

.fa-ban::before {
  content: "\\f05e";
}

.fa-cancel::before {
  content: "\\f05e";
}

.fa-ban-bug::before {
  content: "\\f7f9";
}

.fa-debug::before {
  content: "\\f7f9";
}

.fa-ban-parking::before {
  content: "\\f616";
}

.fa-parking-circle-slash::before {
  content: "\\f616";
}

.fa-ban-smoking::before {
  content: "\\f54d";
}

.fa-smoking-ban::before {
  content: "\\f54d";
}

.fa-banana::before {
  content: "\\e2e5";
}

.fa-bandage::before {
  content: "\\f462";
}

.fa-band-aid::before {
  content: "\\f462";
}

.fa-bangladeshi-taka-sign::before {
  content: "\\e2e6";
}

.fa-banjo::before {
  content: "\\f8a3";
}

.fa-bank::before {
  content: "\\f19c";
}

.fa-institution::before {
  content: "\\f19c";
}

.fa-university::before {
  content: "\\f19c";
}

.fa-barcode::before {
  content: "\\f02a";
}

.fa-barcode-read::before {
  content: "\\f464";
}

.fa-barcode-scan::before {
  content: "\\f465";
}

.fa-bars::before {
  content: "\\f0c9";
}

.fa-navicon::before {
  content: "\\f0c9";
}

.fa-bars-filter::before {
  content: "\\e0ad";
}

.fa-bars-progress::before {
  content: "\\f828";
}

.fa-tasks-alt::before {
  content: "\\f828";
}

.fa-bars-sort::before {
  content: "\\e0ae";
}

.fa-bars-staggered::before {
  content: "\\f550";
}

.fa-reorder::before {
  content: "\\f550";
}

.fa-stream::before {
  content: "\\f550";
}

.fa-baseball::before {
  content: "\\f433";
}

.fa-baseball-ball::before {
  content: "\\f433";
}

.fa-baseball-bat-ball::before {
  content: "\\f432";
}

.fa-basket-shopping::before {
  content: "\\f291";
}

.fa-shopping-basket::before {
  content: "\\f291";
}

.fa-basket-shopping-simple::before {
  content: "\\e0af";
}

.fa-shopping-basket-alt::before {
  content: "\\e0af";
}

.fa-basketball::before {
  content: "\\f434";
}

.fa-basketball-ball::before {
  content: "\\f434";
}

.fa-basketball-hoop::before {
  content: "\\f435";
}

.fa-bat::before {
  content: "\\f6b5";
}

.fa-bath::before {
  content: "\\f2cd";
}

.fa-bathtub::before {
  content: "\\f2cd";
}

.fa-battery-bolt::before {
  content: "\\f376";
}

.fa-battery-empty::before {
  content: "\\f244";
}

.fa-battery-0::before {
  content: "\\f244";
}

.fa-battery-exclamation::before {
  content: "\\e0b0";
}

.fa-battery-full::before {
  content: "\\f240";
}

.fa-battery::before {
  content: "\\f240";
}

.fa-battery-5::before {
  content: "\\f240";
}

.fa-battery-half::before {
  content: "\\f242";
}

.fa-battery-3::before {
  content: "\\f242";
}

.fa-battery-low::before {
  content: "\\e0b1";
}

.fa-battery-1::before {
  content: "\\e0b1";
}

.fa-battery-quarter::before {
  content: "\\f243";
}

.fa-battery-2::before {
  content: "\\f243";
}

.fa-battery-slash::before {
  content: "\\f377";
}

.fa-battery-three-quarters::before {
  content: "\\f241";
}

.fa-battery-4::before {
  content: "\\f241";
}

.fa-bed::before {
  content: "\\f236";
}

.fa-bed-bunk::before {
  content: "\\f8f8";
}

.fa-bed-empty::before {
  content: "\\f8f9";
}

.fa-bed-front::before {
  content: "\\f8f7";
}

.fa-bed-alt::before {
  content: "\\f8f7";
}

.fa-bed-pulse::before {
  content: "\\f487";
}

.fa-procedures::before {
  content: "\\f487";
}

.fa-bee::before {
  content: "\\e0b2";
}

.fa-beer-mug::before {
  content: "\\e0b3";
}

.fa-beer-foam::before {
  content: "\\e0b3";
}

.fa-beer-mug-empty::before {
  content: "\\f0fc";
}

.fa-beer::before {
  content: "\\f0fc";
}

.fa-bell::before {
  content: "\\f0f3";
}

.fa-bell-concierge::before {
  content: "\\f562";
}

.fa-concierge-bell::before {
  content: "\\f562";
}

.fa-bell-exclamation::before {
  content: "\\f848";
}

.fa-bell-on::before {
  content: "\\f8fa";
}

.fa-bell-plus::before {
  content: "\\f849";
}

.fa-bell-school::before {
  content: "\\f5d5";
}

.fa-bell-school-slash::before {
  content: "\\f5d6";
}

.fa-bell-slash::before {
  content: "\\f1f6";
}

.fa-bells::before {
  content: "\\f77f";
}

.fa-bench-tree::before {
  content: "\\e2e7";
}

.fa-bezier-curve::before {
  content: "\\f55b";
}

.fa-bicycle::before {
  content: "\\f206";
}

.fa-binary::before {
  content: "\\e33b";
}

.fa-binary-circle-check::before {
  content: "\\e33c";
}

.fa-binary-lock::before {
  content: "\\e33d";
}

.fa-binary-slash::before {
  content: "\\e33e";
}

.fa-binoculars::before {
  content: "\\f1e5";
}

.fa-biohazard::before {
  content: "\\f780";
}

.fa-bitcoin-sign::before {
  content: "\\e0b4";
}

.fa-blanket::before {
  content: "\\f498";
}

.fa-blanket-fire::before {
  content: "\\e3da";
}

.fa-blender::before {
  content: "\\f517";
}

.fa-blender-phone::before {
  content: "\\f6b6";
}

.fa-blinds::before {
  content: "\\f8fb";
}

.fa-blinds-open::before {
  content: "\\f8fc";
}

.fa-blinds-raised::before {
  content: "\\f8fd";
}

.fa-block-brick::before {
  content: "\\e3db";
}

.fa-wall-brick::before {
  content: "\\e3db";
}

.fa-block-brick-fire::before {
  content: "\\e3dc";
}

.fa-firewall::before {
  content: "\\e3dc";
}

.fa-block-question::before {
  content: "\\e3dd";
}

.fa-block-quote::before {
  content: "\\e0b5";
}

.fa-blog::before {
  content: "\\f781";
}

.fa-blueberries::before {
  content: "\\e2e8";
}

.fa-bold::before {
  content: "\\f032";
}

.fa-bolt::before {
  content: "\\f0e7";
}

.fa-flash::before {
  content: "\\f0e7";
}

.fa-bolt-auto::before {
  content: "\\e0b6";
}

.fa-bolt-lightning::before {
  content: "\\e0b7";
}

.fa-bolt-slash::before {
  content: "\\e0b8";
}

.fa-bomb::before {
  content: "\\f1e2";
}

.fa-bone::before {
  content: "\\f5d7";
}

.fa-bone-break::before {
  content: "\\f5d8";
}

.fa-bong::before {
  content: "\\f55c";
}

.fa-book::before {
  content: "\\f02d";
}

.fa-book-arrow-right::before {
  content: "\\e0b9";
}

.fa-book-arrow-up::before {
  content: "\\e0ba";
}

.fa-book-atlas::before {
  content: "\\f558";
}

.fa-atlas::before {
  content: "\\f558";
}

.fa-book-bible::before {
  content: "\\f647";
}

.fa-bible::before {
  content: "\\f647";
}

.fa-book-blank::before {
  content: "\\f5d9";
}

.fa-book-alt::before {
  content: "\\f5d9";
}

.fa-book-bookmark::before {
  content: "\\e0bb";
}

.fa-book-circle-arrow-right::before {
  content: "\\e0bc";
}

.fa-book-circle-arrow-up::before {
  content: "\\e0bd";
}

.fa-book-copy::before {
  content: "\\e0be";
}

.fa-book-font::before {
  content: "\\e0bf";
}

.fa-book-heart::before {
  content: "\\f499";
}

.fa-book-journal-whills::before {
  content: "\\f66a";
}

.fa-journal-whills::before {
  content: "\\f66a";
}

.fa-book-medical::before {
  content: "\\f7e6";
}

.fa-book-open::before {
  content: "\\f518";
}

.fa-book-open-cover::before {
  content: "\\e0c0";
}

.fa-book-open-alt::before {
  content: "\\e0c0";
}

.fa-book-open-reader::before {
  content: "\\f5da";
}

.fa-book-reader::before {
  content: "\\f5da";
}

.fa-book-quran::before {
  content: "\\f687";
}

.fa-quran::before {
  content: "\\f687";
}

.fa-book-section::before {
  content: "\\e0c1";
}

.fa-book-law::before {
  content: "\\e0c1";
}

.fa-book-skull::before {
  content: "\\f6b7";
}

.fa-book-dead::before {
  content: "\\f6b7";
}

.fa-book-sparkles::before {
  content: "\\f6b8";
}

.fa-book-spells::before {
  content: "\\f6b8";
}

.fa-book-tanakh::before {
  content: "\\f827";
}

.fa-tanakh::before {
  content: "\\f827";
}

.fa-book-user::before {
  content: "\\f7e7";
}

.fa-bookmark::before {
  content: "\\f02e";
}

.fa-bookmark-slash::before {
  content: "\\e0c2";
}

.fa-books::before {
  content: "\\f5db";
}

.fa-books-medical::before {
  content: "\\f7e8";
}

.fa-boombox::before {
  content: "\\f8a5";
}

.fa-boot::before {
  content: "\\f782";
}

.fa-boot-heeled::before {
  content: "\\e33f";
}

.fa-booth-curtain::before {
  content: "\\f734";
}

.fa-border-all::before {
  content: "\\f84c";
}

.fa-border-bottom::before {
  content: "\\f84d";
}

.fa-border-bottom-right::before {
  content: "\\f854";
}

.fa-border-style-alt::before {
  content: "\\f854";
}

.fa-border-center-h::before {
  content: "\\f89c";
}

.fa-border-center-v::before {
  content: "\\f89d";
}

.fa-border-inner::before {
  content: "\\f84e";
}

.fa-border-left::before {
  content: "\\f84f";
}

.fa-border-none::before {
  content: "\\f850";
}

.fa-border-outer::before {
  content: "\\f851";
}

.fa-border-right::before {
  content: "\\f852";
}

.fa-border-top::before {
  content: "\\f855";
}

.fa-border-top-left::before {
  content: "\\f853";
}

.fa-border-style::before {
  content: "\\f853";
}

.fa-bow-arrow::before {
  content: "\\f6b9";
}

.fa-bowl-chopsticks::before {
  content: "\\e2e9";
}

.fa-bowl-chopsticks-noodles::before {
  content: "\\e2ea";
}

.fa-bowl-hot::before {
  content: "\\f823";
}

.fa-soup::before {
  content: "\\f823";
}

.fa-bowl-rice::before {
  content: "\\e2eb";
}

.fa-bowl-scoop::before {
  content: "\\e3de";
}

.fa-bowl-shaved-ice::before {
  content: "\\e3de";
}

.fa-bowl-scoops::before {
  content: "\\e3df";
}

.fa-bowl-spoon::before {
  content: "\\e3e0";
}

.fa-bowling-ball::before {
  content: "\\f436";
}

.fa-bowling-ball-pin::before {
  content: "\\e0c3";
}

.fa-bowling-pins::before {
  content: "\\f437";
}

.fa-box::before {
  content: "\\f466";
}

.fa-box-archive::before {
  content: "\\f187";
}

.fa-archive::before {
  content: "\\f187";
}

.fa-box-ballot::before {
  content: "\\f735";
}

.fa-box-check::before {
  content: "\\f467";
}

.fa-box-circle-check::before {
  content: "\\e0c4";
}

.fa-box-dollar::before {
  content: "\\f4a0";
}

.fa-box-usd::before {
  content: "\\f4a0";
}

.fa-box-heart::before {
  content: "\\f49d";
}

.fa-box-open::before {
  content: "\\f49e";
}

.fa-box-open-full::before {
  content: "\\f49c";
}

.fa-box-full::before {
  content: "\\f49c";
}

.fa-box-taped::before {
  content: "\\f49a";
}

.fa-box-alt::before {
  content: "\\f49a";
}

.fa-box-tissue::before {
  content: "\\e05b";
}

.fa-boxes-stacked::before {
  content: "\\f468";
}

.fa-boxes::before {
  content: "\\f468";
}

.fa-boxes-alt::before {
  content: "\\f468";
}

.fa-boxing-glove::before {
  content: "\\f438";
}

.fa-glove-boxing::before {
  content: "\\f438";
}

.fa-bracket-curly::before {
  content: "\\{";
}

.fa-bracket-curly-left::before {
  content: "\\{";
}

.fa-bracket-curly-right::before {
  content: "\\}";
}

.fa-bracket-round::before {
  content: "\\(";
}

.fa-parenthesis::before {
  content: "\\(";
}

.fa-bracket-round-right::before {
  content: "\\)";
}

.fa-bracket-square::before {
  content: "\\[";
}

.fa-bracket::before {
  content: "\\[";
}

.fa-bracket-left::before {
  content: "\\[";
}

.fa-bracket-square-right::before {
  content: "\\]";
}

.fa-brackets-curly::before {
  content: "\\f7ea";
}

.fa-brackets-round::before {
  content: "\\e0c5";
}

.fa-parentheses::before {
  content: "\\e0c5";
}

.fa-brackets-square::before {
  content: "\\f7e9";
}

.fa-brackets::before {
  content: "\\f7e9";
}

.fa-braille::before {
  content: "\\f2a1";
}

.fa-brain::before {
  content: "\\f5dc";
}

.fa-brain-arrow-curved-right::before {
  content: "\\f677";
}

.fa-mind-share::before {
  content: "\\f677";
}

.fa-brain-circuit::before {
  content: "\\e0c6";
}

.fa-brake-warning::before {
  content: "\\e0c7";
}

.fa-bread-loaf::before {
  content: "\\f7eb";
}

.fa-bread-slice::before {
  content: "\\f7ec";
}

.fa-bread-slice-butter::before {
  content: "\\e3e1";
}

.fa-briefcase::before {
  content: "\\f0b1";
}

.fa-briefcase-arrow-right::before {
  content: "\\e2f2";
}

.fa-briefcase-blank::before {
  content: "\\e0c8";
}

.fa-briefcase-medical::before {
  content: "\\f469";
}

.fa-brightness::before {
  content: "\\e0c9";
}

.fa-brightness-low::before {
  content: "\\e0ca";
}

.fa-bring-forward::before {
  content: "\\f856";
}

.fa-bring-front::before {
  content: "\\f857";
}

.fa-broccoli::before {
  content: "\\e3e2";
}

.fa-broom::before {
  content: "\\f51a";
}

.fa-browser::before {
  content: "\\f37e";
}

.fa-browsers::before {
  content: "\\e0cb";
}

.fa-brush::before {
  content: "\\f55d";
}

.fa-bug::before {
  content: "\\f188";
}

.fa-building::before {
  content: "\\f1ad";
}

.fa-buildings::before {
  content: "\\e0cc";
}

.fa-bullhorn::before {
  content: "\\f0a1";
}

.fa-bullseye::before {
  content: "\\f140";
}

.fa-bullseye-arrow::before {
  content: "\\f648";
}

.fa-bullseye-pointer::before {
  content: "\\f649";
}

.fa-burger::before {
  content: "\\f805";
}

.fa-hamburger::before {
  content: "\\f805";
}

.fa-burger-cheese::before {
  content: "\\f7f1";
}

.fa-cheeseburger::before {
  content: "\\f7f1";
}

.fa-burger-fries::before {
  content: "\\e0cd";
}

.fa-burger-glass::before {
  content: "\\e0ce";
}

.fa-burger-lettuce::before {
  content: "\\e3e3";
}

.fa-burger-soda::before {
  content: "\\f858";
}

.fa-burrito::before {
  content: "\\f7ed";
}

.fa-bus::before {
  content: "\\f207";
}

.fa-bus-school::before {
  content: "\\f5dd";
}

.fa-bus-simple::before {
  content: "\\f55e";
}

.fa-bus-alt::before {
  content: "\\f55e";
}

.fa-business-time::before {
  content: "\\f64a";
}

.fa-briefcase-clock::before {
  content: "\\f64a";
}

.fa-butter::before {
  content: "\\e3e4";
}

.fa-c::before {
  content: "C";
}

.fa-cabinet-filing::before {
  content: "\\f64b";
}

.fa-cable-car::before {
  content: "\\e0cf";
}

.fa-cactus::before {
  content: "\\f8a7";
}

.fa-cake-candles::before {
  content: "\\f1fd";
}

.fa-birthday-cake::before {
  content: "\\f1fd";
}

.fa-cake-slice::before {
  content: "\\e3e5";
}

.fa-shortcake::before {
  content: "\\e3e5";
}

.fa-calculator::before {
  content: "\\f1ec";
}

.fa-calculator-simple::before {
  content: "\\f64c";
}

.fa-calculator-alt::before {
  content: "\\f64c";
}

.fa-calendar::before {
  content: "\\f133";
}

.fa-calendar-arrow-down::before {
  content: "\\e0d0";
}

.fa-calendar-download::before {
  content: "\\e0d0";
}

.fa-calendar-arrow-up::before {
  content: "\\e0d1";
}

.fa-calendar-upload::before {
  content: "\\e0d1";
}

.fa-calendar-check::before {
  content: "\\f274";
}

.fa-calendar-clock::before {
  content: "\\e0d2";
}

.fa-calendar-time::before {
  content: "\\e0d2";
}

.fa-calendar-day::before {
  content: "\\f783";
}

.fa-calendar-days::before {
  content: "\\f073";
}

.fa-calendar-alt::before {
  content: "\\f073";
}

.fa-calendar-exclamation::before {
  content: "\\f334";
}

.fa-calendar-heart::before {
  content: "\\e0d3";
}

.fa-calendar-image::before {
  content: "\\e0d4";
}

.fa-calendar-lines::before {
  content: "\\e0d5";
}

.fa-calendar-note::before {
  content: "\\e0d5";
}

.fa-calendar-minus::before {
  content: "\\f272";
}

.fa-calendar-pen::before {
  content: "\\f333";
}

.fa-calendar-edit::before {
  content: "\\f333";
}

.fa-calendar-plus::before {
  content: "\\f271";
}

.fa-calendar-range::before {
  content: "\\e0d6";
}

.fa-calendar-star::before {
  content: "\\f736";
}

.fa-calendar-week::before {
  content: "\\f784";
}

.fa-calendar-xmark::before {
  content: "\\f273";
}

.fa-calendar-times::before {
  content: "\\f273";
}

.fa-calendars::before {
  content: "\\e0d7";
}

.fa-camcorder::before {
  content: "\\f8a8";
}

.fa-video-handheld::before {
  content: "\\f8a8";
}

.fa-camera::before {
  content: "\\f030";
}

.fa-camera-alt::before {
  content: "\\f030";
}

.fa-camera-cctv::before {
  content: "\\f8ac";
}

.fa-cctv::before {
  content: "\\f8ac";
}

.fa-camera-movie::before {
  content: "\\f8a9";
}

.fa-camera-polaroid::before {
  content: "\\f8aa";
}

.fa-camera-retro::before {
  content: "\\f083";
}

.fa-camera-rotate::before {
  content: "\\e0d8";
}

.fa-camera-security::before {
  content: "\\f8fe";
}

.fa-camera-home::before {
  content: "\\f8fe";
}

.fa-camera-slash::before {
  content: "\\e0d9";
}

.fa-camera-viewfinder::before {
  content: "\\e0da";
}

.fa-camera-web::before {
  content: "\\f832";
}

.fa-webcam::before {
  content: "\\f832";
}

.fa-camera-web-slash::before {
  content: "\\f833";
}

.fa-webcam-slash::before {
  content: "\\f833";
}

.fa-campfire::before {
  content: "\\f6ba";
}

.fa-campground::before {
  content: "\\f6bb";
}

.fa-can-food::before {
  content: "\\e3e6";
}

.fa-candle-holder::before {
  content: "\\f6bc";
}

.fa-candy::before {
  content: "\\e3e7";
}

.fa-candy-bar::before {
  content: "\\e3e8";
}

.fa-chocolate-bar::before {
  content: "\\e3e8";
}

.fa-candy-cane::before {
  content: "\\f786";
}

.fa-candy-corn::before {
  content: "\\f6bd";
}

.fa-cannabis::before {
  content: "\\f55f";
}

.fa-capsules::before {
  content: "\\f46b";
}

.fa-car::before {
  content: "\\f1b9";
}

.fa-automobile::before {
  content: "\\f1b9";
}

.fa-car-battery::before {
  content: "\\f5df";
}

.fa-battery-car::before {
  content: "\\f5df";
}

.fa-car-bolt::before {
  content: "\\e341";
}

.fa-car-building::before {
  content: "\\f859";
}

.fa-car-bump::before {
  content: "\\f5e0";
}

.fa-car-bus::before {
  content: "\\f85a";
}

.fa-car-circle-bolt::before {
  content: "\\e342";
}

.fa-car-crash::before {
  content: "\\f5e1";
}

.fa-car-garage::before {
  content: "\\f5e2";
}

.fa-car-mirrors::before {
  content: "\\e343";
}

.fa-car-rear::before {
  content: "\\f5de";
}

.fa-car-alt::before {
  content: "\\f5de";
}

.fa-car-side::before {
  content: "\\f5e4";
}

.fa-car-side-bolt::before {
  content: "\\e344";
}

.fa-car-tilt::before {
  content: "\\f5e5";
}

.fa-car-wash::before {
  content: "\\f5e6";
}

.fa-car-wrench::before {
  content: "\\f5e3";
}

.fa-car-mechanic::before {
  content: "\\f5e3";
}

.fa-caravan::before {
  content: "\\f8ff";
}

.fa-caravan-simple::before {
  content: "\\e000";
}

.fa-caravan-alt::before {
  content: "\\e000";
}

.fa-card-club::before {
  content: "\\e3e9";
}

.fa-card-diamond::before {
  content: "\\e3ea";
}

.fa-card-heart::before {
  content: "\\e3eb";
}

.fa-card-spade::before {
  content: "\\e3ec";
}

.fa-cards::before {
  content: "\\e3ed";
}

.fa-caret-down::before {
  content: "\\f0d7";
}

.fa-caret-left::before {
  content: "\\f0d9";
}

.fa-caret-right::before {
  content: "\\f0da";
}

.fa-caret-up::before {
  content: "\\f0d8";
}

.fa-carrot::before {
  content: "\\f787";
}

.fa-cars::before {
  content: "\\f85b";
}

.fa-cart-arrow-down::before {
  content: "\\f218";
}

.fa-cart-arrow-up::before {
  content: "\\e3ee";
}

.fa-cart-circle-arrow-down::before {
  content: "\\e3ef";
}

.fa-cart-circle-arrow-up::before {
  content: "\\e3f0";
}

.fa-cart-circle-check::before {
  content: "\\e3f1";
}

.fa-cart-circle-exclamation::before {
  content: "\\e3f2";
}

.fa-cart-circle-plus::before {
  content: "\\e3f3";
}

.fa-cart-circle-xmark::before {
  content: "\\e3f4";
}

.fa-cart-flatbed::before {
  content: "\\f474";
}

.fa-dolly-flatbed::before {
  content: "\\f474";
}

.fa-cart-flatbed-boxes::before {
  content: "\\f475";
}

.fa-dolly-flatbed-alt::before {
  content: "\\f475";
}

.fa-cart-flatbed-empty::before {
  content: "\\f476";
}

.fa-dolly-flatbed-empty::before {
  content: "\\f476";
}

.fa-cart-flatbed-suitcase::before {
  content: "\\f59d";
}

.fa-luggage-cart::before {
  content: "\\f59d";
}

.fa-cart-minus::before {
  content: "\\e0db";
}

.fa-cart-plus::before {
  content: "\\f217";
}

.fa-cart-shopping::before {
  content: "\\f07a";
}

.fa-shopping-cart::before {
  content: "\\f07a";
}

.fa-cart-shopping-fast::before {
  content: "\\e0dc";
}

.fa-cart-xmark::before {
  content: "\\e0dd";
}

.fa-cash-register::before {
  content: "\\f788";
}

.fa-cassette-betamax::before {
  content: "\\f8a4";
}

.fa-betamax::before {
  content: "\\f8a4";
}

.fa-cassette-tape::before {
  content: "\\f8ab";
}

.fa-cassette-vhs::before {
  content: "\\f8ec";
}

.fa-vhs::before {
  content: "\\f8ec";
}

.fa-castle::before {
  content: "\\e0de";
}

.fa-cat::before {
  content: "\\f6be";
}

.fa-cat-space::before {
  content: "\\e001";
}

.fa-cauldron::before {
  content: "\\f6bf";
}

.fa-cedi-sign::before {
  content: "\\e0df";
}

.fa-cent-sign::before {
  content: "\\e3f5";
}

.fa-certificate::before {
  content: "\\f0a3";
}

.fa-chair::before {
  content: "\\f6c0";
}

.fa-chair-office::before {
  content: "\\f6c1";
}

.fa-chalkboard::before {
  content: "\\f51b";
}

.fa-blackboard::before {
  content: "\\f51b";
}

.fa-chalkboard-user::before {
  content: "\\f51c";
}

.fa-chalkboard-teacher::before {
  content: "\\f51c";
}

.fa-champagne-glass::before {
  content: "\\f79e";
}

.fa-glass-champagne::before {
  content: "\\f79e";
}

.fa-champagne-glasses::before {
  content: "\\f79f";
}

.fa-glass-cheers::before {
  content: "\\f79f";
}

.fa-charging-station::before {
  content: "\\f5e7";
}

.fa-chart-area::before {
  content: "\\f1fe";
}

.fa-area-chart::before {
  content: "\\f1fe";
}

.fa-chart-bar::before {
  content: "\\f080";
}

.fa-bar-chart::before {
  content: "\\f080";
}

.fa-chart-bullet::before {
  content: "\\e0e1";
}

.fa-chart-candlestick::before {
  content: "\\e0e2";
}

.fa-chart-column::before {
  content: "\\e0e3";
}

.fa-chart-gantt::before {
  content: "\\e0e4";
}

.fa-chart-line::before {
  content: "\\f201";
}

.fa-line-chart::before {
  content: "\\f201";
}

.fa-chart-line-down::before {
  content: "\\f64d";
}

.fa-chart-line-up::before {
  content: "\\e0e5";
}

.fa-chart-mixed::before {
  content: "\\f643";
}

.fa-analytics::before {
  content: "\\f643";
}

.fa-chart-network::before {
  content: "\\f78a";
}

.fa-chart-pie::before {
  content: "\\f200";
}

.fa-pie-chart::before {
  content: "\\f200";
}

.fa-chart-pie-simple::before {
  content: "\\f64e";
}

.fa-chart-pie-alt::before {
  content: "\\f64e";
}

.fa-chart-pyramid::before {
  content: "\\e0e6";
}

.fa-chart-radar::before {
  content: "\\e0e7";
}

.fa-chart-scatter::before {
  content: "\\f7ee";
}

.fa-chart-scatter-3d::before {
  content: "\\e0e8";
}

.fa-chart-scatter-bubble::before {
  content: "\\e0e9";
}

.fa-chart-tree-map::before {
  content: "\\e0ea";
}

.fa-chart-user::before {
  content: "\\f6a3";
}

.fa-user-chart::before {
  content: "\\f6a3";
}

.fa-chart-waterfall::before {
  content: "\\e0eb";
}

.fa-check::before {
  content: "\\f00c";
}

.fa-check-double::before {
  content: "\\f560";
}

.fa-check-to-slot::before {
  content: "\\f772";
}

.fa-vote-yea::before {
  content: "\\f772";
}

.fa-cheese::before {
  content: "\\f7ef";
}

.fa-cheese-swiss::before {
  content: "\\f7f0";
}

.fa-cherries::before {
  content: "\\e0ec";
}

.fa-chess::before {
  content: "\\f439";
}

.fa-chess-bishop::before {
  content: "\\f43a";
}

.fa-chess-bishop-piece::before {
  content: "\\f43b";
}

.fa-chess-bishop-alt::before {
  content: "\\f43b";
}

.fa-chess-board::before {
  content: "\\f43c";
}

.fa-chess-clock::before {
  content: "\\f43d";
}

.fa-chess-clock-flip::before {
  content: "\\f43e";
}

.fa-chess-clock-alt::before {
  content: "\\f43e";
}

.fa-chess-king::before {
  content: "\\f43f";
}

.fa-chess-king-piece::before {
  content: "\\f440";
}

.fa-chess-king-alt::before {
  content: "\\f440";
}

.fa-chess-knight::before {
  content: "\\f441";
}

.fa-chess-knight-piece::before {
  content: "\\f442";
}

.fa-chess-knight-alt::before {
  content: "\\f442";
}

.fa-chess-pawn::before {
  content: "\\f443";
}

.fa-chess-pawn-piece::before {
  content: "\\f444";
}

.fa-chess-pawn-alt::before {
  content: "\\f444";
}

.fa-chess-queen::before {
  content: "\\f445";
}

.fa-chess-queen-piece::before {
  content: "\\f446";
}

.fa-chess-queen-alt::before {
  content: "\\f446";
}

.fa-chess-rook::before {
  content: "\\f447";
}

.fa-chess-rook-piece::before {
  content: "\\f448";
}

.fa-chess-rook-alt::before {
  content: "\\f448";
}

.fa-chestnut::before {
  content: "\\e3f6";
}

.fa-chevron-down::before {
  content: "\\f078";
}

.fa-chevron-left::before {
  content: "\\f053";
}

.fa-chevron-right::before {
  content: "\\f054";
}

.fa-chevron-up::before {
  content: "\\f077";
}

.fa-chevrons-down::before {
  content: "\\f322";
}

.fa-chevron-double-down::before {
  content: "\\f322";
}

.fa-chevrons-left::before {
  content: "\\f323";
}

.fa-chevron-double-left::before {
  content: "\\f323";
}

.fa-chevrons-right::before {
  content: "\\f324";
}

.fa-chevron-double-right::before {
  content: "\\f324";
}

.fa-chevrons-up::before {
  content: "\\f325";
}

.fa-chevron-double-up::before {
  content: "\\f325";
}

.fa-child::before {
  content: "\\f1ae";
}

.fa-chimney::before {
  content: "\\f78b";
}

.fa-chopsticks::before {
  content: "\\e3f7";
}

.fa-church::before {
  content: "\\f51d";
}

.fa-circle::before {
  content: "\\f111";
}

.fa-circle-0::before {
  content: "\\e0ed";
}

.fa-circle-1::before {
  content: "\\e0ee";
}

.fa-circle-2::before {
  content: "\\e0ef";
}

.fa-circle-3::before {
  content: "\\e0f0";
}

.fa-circle-4::before {
  content: "\\e0f1";
}

.fa-circle-5::before {
  content: "\\e0f2";
}

.fa-circle-6::before {
  content: "\\e0f3";
}

.fa-circle-7::before {
  content: "\\e0f4";
}

.fa-circle-8::before {
  content: "\\e0f5";
}

.fa-circle-9::before {
  content: "\\e0f6";
}

.fa-circle-a::before {
  content: "\\e0f7";
}

.fa-circle-ampersand::before {
  content: "\\e0f8";
}

.fa-circle-arrow-down::before {
  content: "\\f0ab";
}

.fa-arrow-circle-down::before {
  content: "\\f0ab";
}

.fa-circle-arrow-down-left::before {
  content: "\\e0f9";
}

.fa-circle-arrow-down-right::before {
  content: "\\e0fa";
}

.fa-circle-arrow-left::before {
  content: "\\f0a8";
}

.fa-arrow-circle-left::before {
  content: "\\f0a8";
}

.fa-circle-arrow-right::before {
  content: "\\f0a9";
}

.fa-arrow-circle-right::before {
  content: "\\f0a9";
}

.fa-circle-arrow-up::before {
  content: "\\f0aa";
}

.fa-arrow-circle-up::before {
  content: "\\f0aa";
}

.fa-circle-arrow-up-left::before {
  content: "\\e0fb";
}

.fa-circle-arrow-up-right::before {
  content: "\\e0fc";
}

.fa-circle-b::before {
  content: "\\e0fd";
}

.fa-circle-bolt::before {
  content: "\\e0fe";
}

.fa-circle-book-open::before {
  content: "\\e0ff";
}

.fa-book-circle::before {
  content: "\\e0ff";
}

.fa-circle-bookmark::before {
  content: "\\e100";
}

.fa-bookmark-circle::before {
  content: "\\e100";
}

.fa-circle-c::before {
  content: "\\e101";
}

.fa-circle-calendar::before {
  content: "\\e102";
}

.fa-calendar-circle::before {
  content: "\\e102";
}

.fa-circle-camera::before {
  content: "\\e103";
}

.fa-camera-circle::before {
  content: "\\e103";
}

.fa-circle-caret-down::before {
  content: "\\f32d";
}

.fa-caret-circle-down::before {
  content: "\\f32d";
}

.fa-circle-caret-left::before {
  content: "\\f32e";
}

.fa-caret-circle-left::before {
  content: "\\f32e";
}

.fa-circle-caret-right::before {
  content: "\\f330";
}

.fa-caret-circle-right::before {
  content: "\\f330";
}

.fa-circle-caret-up::before {
  content: "\\f331";
}

.fa-caret-circle-up::before {
  content: "\\f331";
}

.fa-circle-check::before {
  content: "\\f058";
}

.fa-check-circle::before {
  content: "\\f058";
}

.fa-circle-chevron-down::before {
  content: "\\f13a";
}

.fa-chevron-circle-down::before {
  content: "\\f13a";
}

.fa-circle-chevron-left::before {
  content: "\\f137";
}

.fa-chevron-circle-left::before {
  content: "\\f137";
}

.fa-circle-chevron-right::before {
  content: "\\f138";
}

.fa-chevron-circle-right::before {
  content: "\\f138";
}

.fa-circle-chevron-up::before {
  content: "\\f139";
}

.fa-chevron-circle-up::before {
  content: "\\f139";
}

.fa-circle-d::before {
  content: "\\e104";
}

.fa-circle-dashed::before {
  content: "\\e105";
}

.fa-circle-divide::before {
  content: "\\e106";
}

.fa-circle-dollar::before {
  content: "\\f2e8";
}

.fa-dollar-circle::before {
  content: "\\f2e8";
}

.fa-usd-circle::before {
  content: "\\f2e8";
}

.fa-circle-dollar-to-slot::before {
  content: "\\f4b9";
}

.fa-donate::before {
  content: "\\f4b9";
}

.fa-circle-dot::before {
  content: "\\f192";
}

.fa-dot-circle::before {
  content: "\\f192";
}

.fa-circle-down::before {
  content: "\\f358";
}

.fa-arrow-alt-circle-down::before {
  content: "\\f358";
}

.fa-circle-down-left::before {
  content: "\\e107";
}

.fa-circle-down-right::before {
  content: "\\e108";
}

.fa-circle-e::before {
  content: "\\e109";
}

.fa-circle-ellipsis::before {
  content: "\\e10a";
}

.fa-circle-ellipsis-vertical::before {
  content: "\\e10b";
}

.fa-circle-envelope::before {
  content: "\\e10c";
}

.fa-envelope-circle::before {
  content: "\\e10c";
}

.fa-circle-exclamation::before {
  content: "\\f06a";
}

.fa-exclamation-circle::before {
  content: "\\f06a";
}

.fa-circle-exclamation-check::before {
  content: "\\e10d";
}

.fa-circle-f::before {
  content: "\\e10e";
}

.fa-circle-g::before {
  content: "\\e10f";
}

.fa-circle-h::before {
  content: "\\f47e";
}

.fa-hospital-symbol::before {
  content: "\\f47e";
}

.fa-circle-half::before {
  content: "\\e110";
}

.fa-circle-half-stroke::before {
  content: "\\f042";
}

.fa-adjust::before {
  content: "\\f042";
}

.fa-circle-heart::before {
  content: "\\f4c7";
}

.fa-heart-circle::before {
  content: "\\f4c7";
}

.fa-circle-i::before {
  content: "\\e111";
}

.fa-circle-info::before {
  content: "\\f05a";
}

.fa-info-circle::before {
  content: "\\f05a";
}

.fa-circle-j::before {
  content: "\\e112";
}

.fa-circle-k::before {
  content: "\\e113";
}

.fa-circle-l::before {
  content: "\\e114";
}

.fa-circle-left::before {
  content: "\\f359";
}

.fa-arrow-alt-circle-left::before {
  content: "\\f359";
}

.fa-circle-location-arrow::before {
  content: "\\f602";
}

.fa-location-circle::before {
  content: "\\f602";
}

.fa-circle-m::before {
  content: "\\e115";
}

.fa-circle-microphone::before {
  content: "\\e116";
}

.fa-microphone-circle::before {
  content: "\\e116";
}

.fa-circle-microphone-lines::before {
  content: "\\e117";
}

.fa-microphone-circle-alt::before {
  content: "\\e117";
}

.fa-circle-minus::before {
  content: "\\f056";
}

.fa-minus-circle::before {
  content: "\\f056";
}

.fa-circle-n::before {
  content: "\\e118";
}

.fa-circle-notch::before {
  content: "\\f1ce";
}

.fa-circle-o::before {
  content: "\\e119";
}

.fa-circle-p::before {
  content: "\\e11a";
}

.fa-circle-parking::before {
  content: "\\f615";
}

.fa-parking-circle::before {
  content: "\\f615";
}

.fa-circle-pause::before {
  content: "\\f28b";
}

.fa-pause-circle::before {
  content: "\\f28b";
}

.fa-circle-phone::before {
  content: "\\e11b";
}

.fa-phone-circle::before {
  content: "\\e11b";
}

.fa-circle-phone-flip::before {
  content: "\\e11c";
}

.fa-phone-circle-alt::before {
  content: "\\e11c";
}

.fa-circle-phone-hangup::before {
  content: "\\e11d";
}

.fa-phone-circle-down::before {
  content: "\\e11d";
}

.fa-circle-play::before {
  content: "\\f144";
}

.fa-play-circle::before {
  content: "\\f144";
}

.fa-circle-plus::before {
  content: "\\f055";
}

.fa-plus-circle::before {
  content: "\\f055";
}

.fa-circle-q::before {
  content: "\\e11e";
}

.fa-circle-quarter::before {
  content: "\\e11f";
}

.fa-circle-quarters::before {
  content: "\\e3f8";
}

.fa-circle-question::before {
  content: "\\f059";
}

.fa-question-circle::before {
  content: "\\f059";
}

.fa-circle-r::before {
  content: "\\e120";
}

.fa-circle-radiation::before {
  content: "\\f7ba";
}

.fa-radiation-alt::before {
  content: "\\f7ba";
}

.fa-circle-right::before {
  content: "\\f35a";
}

.fa-arrow-alt-circle-right::before {
  content: "\\f35a";
}

.fa-circle-s::before {
  content: "\\e121";
}

.fa-circle-small::before {
  content: "\\e122";
}

.fa-circle-sort::before {
  content: "\\e030";
}

.fa-sort-circle::before {
  content: "\\e030";
}

.fa-circle-sort-down::before {
  content: "\\e031";
}

.fa-sort-circle-down::before {
  content: "\\e031";
}

.fa-circle-sort-up::before {
  content: "\\e032";
}

.fa-sort-circle-up::before {
  content: "\\e032";
}

.fa-circle-star::before {
  content: "\\e123";
}

.fa-star-circle::before {
  content: "\\e123";
}

.fa-circle-stop::before {
  content: "\\f28d";
}

.fa-stop-circle::before {
  content: "\\f28d";
}

.fa-circle-t::before {
  content: "\\e124";
}

.fa-circle-three-quarters::before {
  content: "\\e125";
}

.fa-circle-trash::before {
  content: "\\e126";
}

.fa-trash-circle::before {
  content: "\\e126";
}

.fa-circle-u::before {
  content: "\\e127";
}

.fa-circle-up::before {
  content: "\\f35b";
}

.fa-arrow-alt-circle-up::before {
  content: "\\f35b";
}

.fa-circle-up-left::before {
  content: "\\e128";
}

.fa-circle-up-right::before {
  content: "\\e129";
}

.fa-circle-user::before {
  content: "\\f2bd";
}

.fa-user-circle::before {
  content: "\\f2bd";
}

.fa-circle-v::before {
  content: "\\e12a";
}

.fa-circle-video::before {
  content: "\\e12b";
}

.fa-video-circle::before {
  content: "\\e12b";
}

.fa-circle-w::before {
  content: "\\e12c";
}

.fa-circle-waveform-lines::before {
  content: "\\e12d";
}

.fa-waveform-circle::before {
  content: "\\e12d";
}

.fa-circle-x::before {
  content: "\\e12e";
}

.fa-circle-xmark::before {
  content: "\\f057";
}

.fa-times-circle::before {
  content: "\\f057";
}

.fa-xmark-circle::before {
  content: "\\f057";
}

.fa-circle-y::before {
  content: "\\e12f";
}

.fa-circle-z::before {
  content: "\\e130";
}

.fa-citrus::before {
  content: "\\e2f4";
}

.fa-citrus-slice::before {
  content: "\\e2f5";
}

.fa-city::before {
  content: "\\f64f";
}

.fa-clapperboard::before {
  content: "\\e131";
}

.fa-clapperboard-play::before {
  content: "\\e132";
}

.fa-clarinet::before {
  content: "\\f8ad";
}

.fa-claw-marks::before {
  content: "\\f6c2";
}

.fa-clipboard::before {
  content: "\\f328";
}

.fa-clipboard-check::before {
  content: "\\f46c";
}

.fa-clipboard-list::before {
  content: "\\f46d";
}

.fa-clipboard-list-check::before {
  content: "\\f737";
}

.fa-clipboard-medical::before {
  content: "\\e133";
}

.fa-clipboard-prescription::before {
  content: "\\f5e8";
}

.fa-clipboard-user::before {
  content: "\\f7f3";
}

.fa-clock::before {
  content: "\\f017";
}

.fa-clock-four::before {
  content: "\\f017";
}

.fa-clock-desk::before {
  content: "\\e134";
}

.fa-clock-eight::before {
  content: "\\e345";
}

.fa-clock-eight-thirty::before {
  content: "\\e346";
}

.fa-clock-eleven::before {
  content: "\\e347";
}

.fa-clock-eleven-thirty::before {
  content: "\\e348";
}

.fa-clock-five::before {
  content: "\\e349";
}

.fa-clock-five-thirty::before {
  content: "\\e34a";
}

.fa-clock-four-thirty::before {
  content: "\\e34b";
}

.fa-clock-nine::before {
  content: "\\e34c";
}

.fa-clock-nine-thirty::before {
  content: "\\e34d";
}

.fa-clock-one::before {
  content: "\\e34e";
}

.fa-clock-one-thirty::before {
  content: "\\e34f";
}

.fa-clock-rotate-left::before {
  content: "\\f1da";
}

.fa-history::before {
  content: "\\f1da";
}

.fa-clock-seven::before {
  content: "\\e350";
}

.fa-clock-seven-thirty::before {
  content: "\\e351";
}

.fa-clock-six::before {
  content: "\\e352";
}

.fa-clock-six-thirty::before {
  content: "\\e353";
}

.fa-clock-ten::before {
  content: "\\e354";
}

.fa-clock-ten-thirty::before {
  content: "\\e355";
}

.fa-clock-three::before {
  content: "\\e356";
}

.fa-clock-three-thirty::before {
  content: "\\e357";
}

.fa-clock-twelve::before {
  content: "\\e358";
}

.fa-clock-twelve-thirty::before {
  content: "\\e359";
}

.fa-clock-two::before {
  content: "\\e35a";
}

.fa-clock-two-thirty::before {
  content: "\\e35b";
}

.fa-clone::before {
  content: "\\f24d";
}

.fa-closed-captioning::before {
  content: "\\f20a";
}

.fa-closed-captioning-slash::before {
  content: "\\e135";
}

.fa-clothes-hanger::before {
  content: "\\e136";
}

.fa-cloud::before {
  content: "\\f0c2";
}

.fa-cloud-arrow-down::before {
  content: "\\f0ed";
}

.fa-cloud-download::before {
  content: "\\f0ed";
}

.fa-cloud-download-alt::before {
  content: "\\f0ed";
}

.fa-cloud-arrow-up::before {
  content: "\\f0ee";
}

.fa-cloud-upload::before {
  content: "\\f0ee";
}

.fa-cloud-upload-alt::before {
  content: "\\f0ee";
}

.fa-cloud-bolt::before {
  content: "\\f76c";
}

.fa-thunderstorm::before {
  content: "\\f76c";
}

.fa-cloud-bolt-moon::before {
  content: "\\f76d";
}

.fa-thunderstorm-moon::before {
  content: "\\f76d";
}

.fa-cloud-bolt-sun::before {
  content: "\\f76e";
}

.fa-thunderstorm-sun::before {
  content: "\\f76e";
}

.fa-cloud-check::before {
  content: "\\e35c";
}

.fa-cloud-drizzle::before {
  content: "\\f738";
}

.fa-cloud-fog::before {
  content: "\\f74e";
}

.fa-fog::before {
  content: "\\f74e";
}

.fa-cloud-hail::before {
  content: "\\f739";
}

.fa-cloud-hail-mixed::before {
  content: "\\f73a";
}

.fa-cloud-meatball::before {
  content: "\\f73b";
}

.fa-cloud-minus::before {
  content: "\\e35d";
}

.fa-cloud-moon::before {
  content: "\\f6c3";
}

.fa-cloud-moon-rain::before {
  content: "\\f73c";
}

.fa-cloud-music::before {
  content: "\\f8ae";
}

.fa-cloud-plus::before {
  content: "\\e35e";
}

.fa-cloud-rain::before {
  content: "\\f73d";
}

.fa-cloud-rainbow::before {
  content: "\\f73e";
}

.fa-cloud-showers::before {
  content: "\\f73f";
}

.fa-cloud-showers-heavy::before {
  content: "\\f740";
}

.fa-cloud-slash::before {
  content: "\\e137";
}

.fa-cloud-sleet::before {
  content: "\\f741";
}

.fa-cloud-snow::before {
  content: "\\f742";
}

.fa-cloud-sun::before {
  content: "\\f6c4";
}

.fa-cloud-sun-rain::before {
  content: "\\f743";
}

.fa-cloud-word::before {
  content: "\\e138";
}

.fa-cloud-xmark::before {
  content: "\\e35f";
}

.fa-clouds::before {
  content: "\\f744";
}

.fa-clouds-moon::before {
  content: "\\f745";
}

.fa-clouds-sun::before {
  content: "\\f746";
}

.fa-clover::before {
  content: "\\e139";
}

.fa-club::before {
  content: "\\f327";
}

.fa-coconut::before {
  content: "\\e2f6";
}

.fa-code::before {
  content: "\\f121";
}

.fa-code-branch::before {
  content: "\\f126";
}

.fa-code-commit::before {
  content: "\\f386";
}

.fa-code-compare::before {
  content: "\\e13a";
}

.fa-code-fork::before {
  content: "\\e13b";
}

.fa-code-merge::before {
  content: "\\f387";
}

.fa-code-pull-request::before {
  content: "\\e13c";
}

.fa-code-pull-request-closed::before {
  content: "\\e3f9";
}

.fa-code-pull-request-draft::before {
  content: "\\e3fa";
}

.fa-code-simple::before {
  content: "\\e13d";
}

.fa-coffee-bean::before {
  content: "\\e13e";
}

.fa-coffee-beans::before {
  content: "\\e13f";
}

.fa-coffee-pot::before {
  content: "\\e002";
}

.fa-coffin::before {
  content: "\\f6c6";
}

.fa-coffin-cross::before {
  content: "\\e051";
}

.fa-coin::before {
  content: "\\f85c";
}

.fa-coin-blank::before {
  content: "\\e3fb";
}

.fa-coin-front::before {
  content: "\\e3fc";
}

.fa-coin-vertical::before {
  content: "\\e3fd";
}

.fa-coins::before {
  content: "\\f51e";
}

.fa-colon::before {
  content: "\\:";
}

.fa-colon-sign::before {
  content: "\\e140";
}

.fa-columns-3::before {
  content: "\\e361";
}

.fa-comet::before {
  content: "\\e003";
}

.fa-comma::before {
  content: "\\,";
}

.fa-command::before {
  content: "\\e142";
}

.fa-comment::before {
  content: "\\f075";
}

.fa-comment-arrow-down::before {
  content: "\\e143";
}

.fa-comment-arrow-up::before {
  content: "\\e144";
}

.fa-comment-arrow-up-right::before {
  content: "\\e145";
}

.fa-comment-captions::before {
  content: "\\e146";
}

.fa-comment-check::before {
  content: "\\f4ac";
}

.fa-comment-code::before {
  content: "\\e147";
}

.fa-comment-dollar::before {
  content: "\\f651";
}

.fa-comment-dots::before {
  content: "\\f4ad";
}

.fa-commenting::before {
  content: "\\f4ad";
}

.fa-comment-exclamation::before {
  content: "\\f4af";
}

.fa-comment-image::before {
  content: "\\e148";
}

.fa-comment-lines::before {
  content: "\\f4b0";
}

.fa-comment-medical::before {
  content: "\\f7f5";
}

.fa-comment-middle::before {
  content: "\\e149";
}

.fa-comment-middle-top::before {
  content: "\\e14a";
}

.fa-comment-minus::before {
  content: "\\f4b1";
}

.fa-comment-music::before {
  content: "\\f8b0";
}

.fa-comment-pen::before {
  content: "\\f4ae";
}

.fa-comment-edit::before {
  content: "\\f4ae";
}

.fa-comment-plus::before {
  content: "\\f4b2";
}

.fa-comment-question::before {
  content: "\\e14b";
}

.fa-comment-quote::before {
  content: "\\e14c";
}

.fa-comment-slash::before {
  content: "\\f4b3";
}

.fa-comment-smile::before {
  content: "\\f4b4";
}

.fa-comment-sms::before {
  content: "\\f7cd";
}

.fa-sms::before {
  content: "\\f7cd";
}

.fa-comment-text::before {
  content: "\\e14d";
}

.fa-comment-xmark::before {
  content: "\\f4b5";
}

.fa-comment-times::before {
  content: "\\f4b5";
}

.fa-comments::before {
  content: "\\f086";
}

.fa-comments-dollar::before {
  content: "\\f653";
}

.fa-comments-question::before {
  content: "\\e14e";
}

.fa-comments-question-check::before {
  content: "\\e14f";
}

.fa-compact-disc::before {
  content: "\\f51f";
}

.fa-compass::before {
  content: "\\f14e";
}

.fa-compass-drafting::before {
  content: "\\f568";
}

.fa-drafting-compass::before {
  content: "\\f568";
}

.fa-compass-slash::before {
  content: "\\f5e9";
}

.fa-compress::before {
  content: "\\f066";
}

.fa-compress-wide::before {
  content: "\\f326";
}

.fa-computer-classic::before {
  content: "\\f8b1";
}

.fa-computer-mouse::before {
  content: "\\f8cc";
}

.fa-mouse::before {
  content: "\\f8cc";
}

.fa-computer-mouse-scrollwheel::before {
  content: "\\f8cd";
}

.fa-mouse-alt::before {
  content: "\\f8cd";
}

.fa-computer-speaker::before {
  content: "\\f8b2";
}

.fa-container-storage::before {
  content: "\\f4b7";
}

.fa-conveyor-belt::before {
  content: "\\f46e";
}

.fa-conveyor-belt-boxes::before {
  content: "\\f46f";
}

.fa-conveyor-belt-alt::before {
  content: "\\f46f";
}

.fa-conveyor-belt-empty::before {
  content: "\\e150";
}

.fa-cookie::before {
  content: "\\f563";
}

.fa-cookie-bite::before {
  content: "\\f564";
}

.fa-copy::before {
  content: "\\f0c5";
}

.fa-copyright::before {
  content: "\\f1f9";
}

.fa-corn::before {
  content: "\\f6c7";
}

.fa-corner::before {
  content: "\\e3fe";
}

.fa-couch::before {
  content: "\\f4b8";
}

.fa-cow::before {
  content: "\\f6c8";
}

.fa-cowbell::before {
  content: "\\f8b3";
}

.fa-cowbell-circle-plus::before {
  content: "\\f8b4";
}

.fa-cowbell-more::before {
  content: "\\f8b4";
}

.fa-crab::before {
  content: "\\e3ff";
}

.fa-crate-apple::before {
  content: "\\f6b1";
}

.fa-apple-crate::before {
  content: "\\f6b1";
}

.fa-crate-empty::before {
  content: "\\e151";
}

.fa-credit-card::before {
  content: "\\f09d";
}

.fa-credit-card-alt::before {
  content: "\\f09d";
}

.fa-credit-card-blank::before {
  content: "\\f389";
}

.fa-credit-card-front::before {
  content: "\\f38a";
}

.fa-creemee::before {
  content: "\\e400";
}

.fa-soft-serve::before {
  content: "\\e400";
}

.fa-cricket-bat-ball::before {
  content: "\\f449";
}

.fa-cricket::before {
  content: "\\f449";
}

.fa-croissant::before {
  content: "\\f7f6";
}

.fa-crop::before {
  content: "\\f125";
}

.fa-crop-simple::before {
  content: "\\f565";
}

.fa-crop-alt::before {
  content: "\\f565";
}

.fa-cross::before {
  content: "\\f654";
}

.fa-crosshairs::before {
  content: "\\f05b";
}

.fa-crow::before {
  content: "\\f520";
}

.fa-crown::before {
  content: "\\f521";
}

.fa-crutch::before {
  content: "\\f7f7";
}

.fa-crutches::before {
  content: "\\f7f8";
}

.fa-cruzeiro-sign::before {
  content: "\\e152";
}

.fa-crystal-ball::before {
  content: "\\e362";
}

.fa-cube::before {
  content: "\\f1b2";
}

.fa-cubes::before {
  content: "\\f1b3";
}

.fa-cucumber::before {
  content: "\\e401";
}

.fa-cup-straw::before {
  content: "\\e363";
}

.fa-cup-straw-swoosh::before {
  content: "\\e364";
}

.fa-cup-togo::before {
  content: "\\f6c5";
}

.fa-coffee-togo::before {
  content: "\\f6c5";
}

.fa-cupcake::before {
  content: "\\e402";
}

.fa-curling-stone::before {
  content: "\\f44a";
}

.fa-curling::before {
  content: "\\f44a";
}

.fa-custard::before {
  content: "\\e403";
}

.fa-d::before {
  content: "D";
}

.fa-dagger::before {
  content: "\\f6cb";
}

.fa-dash::before {
  content: "\\e404";
}

.fa-database::before {
  content: "\\f1c0";
}

.fa-deer::before {
  content: "\\f78e";
}

.fa-deer-rudolph::before {
  content: "\\f78f";
}

.fa-delete-left::before {
  content: "\\f55a";
}

.fa-backspace::before {
  content: "\\f55a";
}

.fa-delete-right::before {
  content: "\\e154";
}

.fa-democrat::before {
  content: "\\f747";
}

.fa-desktop::before {
  content: "\\f390";
}

.fa-desktop-alt::before {
  content: "\\f390";
}

.fa-desktop-arrow-down::before {
  content: "\\e155";
}

.fa-dharmachakra::before {
  content: "\\f655";
}

.fa-diagram-lean-canvas::before {
  content: "\\e156";
}

.fa-diagram-nested::before {
  content: "\\e157";
}

.fa-diagram-project::before {
  content: "\\f542";
}

.fa-project-diagram::before {
  content: "\\f542";
}

.fa-diagram-sankey::before {
  content: "\\e158";
}

.fa-diagram-venn::before {
  content: "\\e15a";
}

.fa-dial::before {
  content: "\\e15b";
}

.fa-dial-med-high::before {
  content: "\\e15b";
}

.fa-dial-high::before {
  content: "\\e15c";
}

.fa-dial-low::before {
  content: "\\e15d";
}

.fa-dial-max::before {
  content: "\\e15e";
}

.fa-dial-med::before {
  content: "\\e15f";
}

.fa-dial-med-low::before {
  content: "\\e160";
}

.fa-dial-min::before {
  content: "\\e161";
}

.fa-dial-off::before {
  content: "\\e162";
}

.fa-diamond::before {
  content: "\\f219";
}

.fa-diamond-exclamation::before {
  content: "\\e405";
}

.fa-diamond-turn-right::before {
  content: "\\f5eb";
}

.fa-directions::before {
  content: "\\f5eb";
}

.fa-dice::before {
  content: "\\f522";
}

.fa-dice-d10::before {
  content: "\\f6cd";
}

.fa-dice-d12::before {
  content: "\\f6ce";
}

.fa-dice-d20::before {
  content: "\\f6cf";
}

.fa-dice-d4::before {
  content: "\\f6d0";
}

.fa-dice-d6::before {
  content: "\\f6d1";
}

.fa-dice-d8::before {
  content: "\\f6d2";
}

.fa-dice-five::before {
  content: "\\f523";
}

.fa-dice-four::before {
  content: "\\f524";
}

.fa-dice-one::before {
  content: "\\f525";
}

.fa-dice-six::before {
  content: "\\f526";
}

.fa-dice-three::before {
  content: "\\f527";
}

.fa-dice-two::before {
  content: "\\f528";
}

.fa-diploma::before {
  content: "\\f5ea";
}

.fa-scroll-ribbon::before {
  content: "\\f5ea";
}

.fa-disc-drive::before {
  content: "\\f8b5";
}

.fa-disease::before {
  content: "\\f7fa";
}

.fa-display::before {
  content: "\\e163";
}

.fa-display-arrow-down::before {
  content: "\\e164";
}

.fa-display-code::before {
  content: "\\e165";
}

.fa-desktop-code::before {
  content: "\\e165";
}

.fa-display-medical::before {
  content: "\\e166";
}

.fa-desktop-medical::before {
  content: "\\e166";
}

.fa-display-slash::before {
  content: "\\e2fa";
}

.fa-desktop-slash::before {
  content: "\\e2fa";
}

.fa-distribute-spacing-horizontal::before {
  content: "\\e365";
}

.fa-distribute-spacing-vertical::before {
  content: "\\e366";
}

.fa-ditto::before {
  content: "\\"";
}

.fa-divide::before {
  content: "\\f529";
}

.fa-dna::before {
  content: "\\f471";
}

.fa-do-not-enter::before {
  content: "\\f5ec";
}

.fa-dog::before {
  content: "\\f6d3";
}

.fa-dog-leashed::before {
  content: "\\f6d4";
}

.fa-dollar-sign::before {
  content: "\\\$";
}

.fa-dollar::before {
  content: "\\\$";
}

.fa-usd::before {
  content: "\\\$";
}

.fa-dolly::before {
  content: "\\f472";
}

.fa-dolly-box::before {
  content: "\\f472";
}

.fa-dolly-empty::before {
  content: "\\f473";
}

.fa-dolphin::before {
  content: "\\e168";
}

.fa-dong-sign::before {
  content: "\\e169";
}

.fa-donut::before {
  content: "\\e406";
}

.fa-doughnut::before {
  content: "\\e406";
}

.fa-door-closed::before {
  content: "\\f52a";
}

.fa-door-open::before {
  content: "\\f52b";
}

.fa-dove::before {
  content: "\\f4ba";
}

.fa-down::before {
  content: "\\f354";
}

.fa-arrow-alt-down::before {
  content: "\\f354";
}

.fa-down-from-dotted-line::before {
  content: "\\e407";
}

.fa-down-from-line::before {
  content: "\\f349";
}

.fa-arrow-alt-from-top::before {
  content: "\\f349";
}

.fa-down-left::before {
  content: "\\e16a";
}

.fa-down-left-and-up-right-to-center::before {
  content: "\\f422";
}

.fa-compress-alt::before {
  content: "\\f422";
}

.fa-down-long::before {
  content: "\\f309";
}

.fa-long-arrow-alt-down::before {
  content: "\\f309";
}

.fa-down-right::before {
  content: "\\e16b";
}

.fa-down-to-dotted-line::before {
  content: "\\e408";
}

.fa-down-to-line::before {
  content: "\\f34a";
}

.fa-arrow-alt-to-bottom::before {
  content: "\\f34a";
}

.fa-download::before {
  content: "\\f019";
}

.fa-dragon::before {
  content: "\\f6d5";
}

.fa-draw-circle::before {
  content: "\\f5ed";
}

.fa-draw-polygon::before {
  content: "\\f5ee";
}

.fa-draw-square::before {
  content: "\\f5ef";
}

.fa-dreidel::before {
  content: "\\f792";
}

.fa-drone::before {
  content: "\\f85f";
}

.fa-drone-front::before {
  content: "\\f860";
}

.fa-drone-alt::before {
  content: "\\f860";
}

.fa-droplet::before {
  content: "\\f043";
}

.fa-tint::before {
  content: "\\f043";
}

.fa-droplet-degree::before {
  content: "\\f748";
}

.fa-dewpoint::before {
  content: "\\f748";
}

.fa-droplet-percent::before {
  content: "\\f750";
}

.fa-humidity::before {
  content: "\\f750";
}

.fa-droplet-slash::before {
  content: "\\f5c7";
}

.fa-tint-slash::before {
  content: "\\f5c7";
}

.fa-drum::before {
  content: "\\f569";
}

.fa-drum-steelpan::before {
  content: "\\f56a";
}

.fa-drumstick::before {
  content: "\\f6d6";
}

.fa-drumstick-bite::before {
  content: "\\f6d7";
}

.fa-dryer::before {
  content: "\\f861";
}

.fa-dryer-heat::before {
  content: "\\f862";
}

.fa-dryer-alt::before {
  content: "\\f862";
}

.fa-duck::before {
  content: "\\f6d8";
}

.fa-dumbbell::before {
  content: "\\f44b";
}

.fa-dumpster::before {
  content: "\\f793";
}

.fa-dumpster-fire::before {
  content: "\\f794";
}

.fa-dungeon::before {
  content: "\\f6d9";
}

.fa-e::before {
  content: "E";
}

.fa-ear::before {
  content: "\\f5f0";
}

.fa-ear-deaf::before {
  content: "\\f2a4";
}

.fa-deaf::before {
  content: "\\f2a4";
}

.fa-deafness::before {
  content: "\\f2a4";
}

.fa-hard-of-hearing::before {
  content: "\\f2a4";
}

.fa-ear-listen::before {
  content: "\\f2a2";
}

.fa-assistive-listening-systems::before {
  content: "\\f2a2";
}

.fa-ear-muffs::before {
  content: "\\f795";
}

.fa-earth-africa::before {
  content: "\\f57c";
}

.fa-globe-africa::before {
  content: "\\f57c";
}

.fa-earth-americas::before {
  content: "\\f57d";
}

.fa-earth::before {
  content: "\\f57d";
}

.fa-globe-americas::before {
  content: "\\f57d";
}

.fa-earth-asia::before {
  content: "\\f57e";
}

.fa-globe-asia::before {
  content: "\\f57e";
}

.fa-earth-europa::before {
  content: "\\f7a2";
}

.fa-globe-europe::before {
  content: "\\f7a2";
}

.fa-eclipse::before {
  content: "\\f749";
}

.fa-egg::before {
  content: "\\f7fb";
}

.fa-egg-fried::before {
  content: "\\f7fc";
}

.fa-eggplant::before {
  content: "\\e16c";
}

.fa-eject::before {
  content: "\\f052";
}

.fa-elephant::before {
  content: "\\f6da";
}

.fa-elevator::before {
  content: "\\e16d";
}

.fa-ellipsis::before {
  content: "\\f141";
}

.fa-ellipsis-h::before {
  content: "\\f141";
}

.fa-ellipsis-stroke::before {
  content: "\\f39b";
}

.fa-ellipsis-h-alt::before {
  content: "\\f39b";
}

.fa-ellipsis-stroke-vertical::before {
  content: "\\f39c";
}

.fa-ellipsis-v-alt::before {
  content: "\\f39c";
}

.fa-ellipsis-vertical::before {
  content: "\\f142";
}

.fa-ellipsis-v::before {
  content: "\\f142";
}

.fa-empty-set::before {
  content: "\\f656";
}

.fa-engine::before {
  content: "\\e16e";
}

.fa-engine-warning::before {
  content: "\\f5f2";
}

.fa-engine-exclamation::before {
  content: "\\f5f2";
}

.fa-envelope::before {
  content: "\\f0e0";
}

.fa-envelope-dot::before {
  content: "\\e16f";
}

.fa-envelope-badge::before {
  content: "\\e16f";
}

.fa-envelope-open::before {
  content: "\\f2b6";
}

.fa-envelope-open-dollar::before {
  content: "\\f657";
}

.fa-envelope-open-text::before {
  content: "\\f658";
}

.fa-envelopes::before {
  content: "\\e170";
}

.fa-envelopes-bulk::before {
  content: "\\f674";
}

.fa-mail-bulk::before {
  content: "\\f674";
}

.fa-equals::before {
  content: "\\=";
}

.fa-eraser::before {
  content: "\\f12d";
}

.fa-escalator::before {
  content: "\\e171";
}

.fa-ethernet::before {
  content: "\\f796";
}

.fa-euro-sign::before {
  content: "\\f153";
}

.fa-eur::before {
  content: "\\f153";
}

.fa-euro::before {
  content: "\\f153";
}

.fa-exclamation::before {
  content: "\\!";
}

.fa-expand::before {
  content: "\\f065";
}

.fa-expand-wide::before {
  content: "\\f320";
}

.fa-eye::before {
  content: "\\f06e";
}

.fa-eye-dropper::before {
  content: "\\f1fb";
}

.fa-eye-dropper-empty::before {
  content: "\\f1fb";
}

.fa-eyedropper::before {
  content: "\\f1fb";
}

.fa-eye-dropper-full::before {
  content: "\\e172";
}

.fa-eye-dropper-half::before {
  content: "\\e173";
}

.fa-eye-evil::before {
  content: "\\f6db";
}

.fa-eye-low-vision::before {
  content: "\\f2a8";
}

.fa-low-vision::before {
  content: "\\f2a8";
}

.fa-eye-slash::before {
  content: "\\f070";
}

.fa-eyes::before {
  content: "\\e367";
}

.fa-f::before {
  content: "F";
}

.fa-face-angry::before {
  content: "\\f556";
}

.fa-angry::before {
  content: "\\f556";
}

.fa-face-angry-horns::before {
  content: "\\e368";
}

.fa-face-anguished::before {
  content: "\\e369";
}

.fa-face-anxious-sweat::before {
  content: "\\e36a";
}

.fa-face-astonished::before {
  content: "\\e36b";
}

.fa-face-awesome::before {
  content: "\\e409";
}

.fa-gave-dandy::before {
  content: "\\e409";
}

.fa-face-confounded::before {
  content: "\\e36c";
}

.fa-face-confused::before {
  content: "\\e36d";
}

.fa-face-cowboy-hat::before {
  content: "\\e36e";
}

.fa-face-disappointed::before {
  content: "\\e36f";
}

.fa-face-disguise::before {
  content: "\\e370";
}

.fa-face-dizzy::before {
  content: "\\f567";
}

.fa-dizzy::before {
  content: "\\f567";
}

.fa-face-downcast-sweat::before {
  content: "\\e371";
}

.fa-face-drooling::before {
  content: "\\e372";
}

.fa-face-explode::before {
  content: "\\e2fe";
}

.fa-exploding-head::before {
  content: "\\e2fe";
}

.fa-face-expressionless::before {
  content: "\\e373";
}

.fa-face-eyes-xmarks::before {
  content: "\\e374";
}

.fa-face-fearful::before {
  content: "\\e375";
}

.fa-face-flushed::before {
  content: "\\f579";
}

.fa-flushed::before {
  content: "\\f579";
}

.fa-face-frown::before {
  content: "\\f119";
}

.fa-frown::before {
  content: "\\f119";
}

.fa-face-frown-open::before {
  content: "\\f57a";
}

.fa-frown-open::before {
  content: "\\f57a";
}

.fa-face-frown-slight::before {
  content: "\\e376";
}

.fa-face-glasses::before {
  content: "\\e377";
}

.fa-face-grimace::before {
  content: "\\f57f";
}

.fa-grimace::before {
  content: "\\f57f";
}

.fa-face-grin::before {
  content: "\\f580";
}

.fa-grin::before {
  content: "\\f580";
}

.fa-face-grin-beam::before {
  content: "\\f582";
}

.fa-grin-beam::before {
  content: "\\f582";
}

.fa-face-grin-beam-sweat::before {
  content: "\\f583";
}

.fa-grin-beam-sweat::before {
  content: "\\f583";
}

.fa-face-grin-hearts::before {
  content: "\\f584";
}

.fa-grin-hearts::before {
  content: "\\f584";
}

.fa-face-grin-squint::before {
  content: "\\f585";
}

.fa-grin-squint::before {
  content: "\\f585";
}

.fa-face-grin-squint-tears::before {
  content: "\\f586";
}

.fa-grin-squint-tears::before {
  content: "\\f586";
}

.fa-face-grin-stars::before {
  content: "\\f587";
}

.fa-grin-stars::before {
  content: "\\f587";
}

.fa-face-grin-tears::before {
  content: "\\f588";
}

.fa-grin-tears::before {
  content: "\\f588";
}

.fa-face-grin-tongue::before {
  content: "\\f589";
}

.fa-grin-tongue::before {
  content: "\\f589";
}

.fa-face-grin-tongue-squint::before {
  content: "\\f58a";
}

.fa-grin-tongue-squint::before {
  content: "\\f58a";
}

.fa-face-grin-tongue-wink::before {
  content: "\\f58b";
}

.fa-grin-tongue-wink::before {
  content: "\\f58b";
}

.fa-face-grin-wide::before {
  content: "\\f581";
}

.fa-grin-alt::before {
  content: "\\f581";
}

.fa-face-grin-wink::before {
  content: "\\f58c";
}

.fa-grin-wink::before {
  content: "\\f58c";
}

.fa-face-hand-over-mouth::before {
  content: "\\e378";
}

.fa-face-hand-yawn::before {
  content: "\\e379";
}

.fa-face-head-bandage::before {
  content: "\\e37a";
}

.fa-face-hushed::before {
  content: "\\e37b";
}

.fa-face-icicles::before {
  content: "\\e37c";
}

.fa-face-kiss::before {
  content: "\\f596";
}

.fa-kiss::before {
  content: "\\f596";
}

.fa-face-kiss-beam::before {
  content: "\\f597";
}

.fa-kiss-beam::before {
  content: "\\f597";
}

.fa-face-kiss-closed-eyes::before {
  content: "\\e37d";
}

.fa-face-kiss-wink-heart::before {
  content: "\\f598";
}

.fa-kiss-wink-heart::before {
  content: "\\f598";
}

.fa-face-laugh::before {
  content: "\\f599";
}

.fa-laugh::before {
  content: "\\f599";
}

.fa-face-laugh-beam::before {
  content: "\\f59a";
}

.fa-laugh-beam::before {
  content: "\\f59a";
}

.fa-face-laugh-squint::before {
  content: "\\f59b";
}

.fa-laugh-squint::before {
  content: "\\f59b";
}

.fa-face-laugh-wink::before {
  content: "\\f59c";
}

.fa-laugh-wink::before {
  content: "\\f59c";
}

.fa-face-lying::before {
  content: "\\e37e";
}

.fa-face-mask::before {
  content: "\\e37f";
}

.fa-face-meh::before {
  content: "\\f11a";
}

.fa-meh::before {
  content: "\\f11a";
}

.fa-face-meh-blank::before {
  content: "\\f5a4";
}

.fa-meh-blank::before {
  content: "\\f5a4";
}

.fa-face-monocle::before {
  content: "\\e380";
}

.fa-face-nauseated::before {
  content: "\\e381";
}

.fa-face-nose-steam::before {
  content: "\\e382";
}

.fa-face-party::before {
  content: "\\e383";
}

.fa-face-pensive::before {
  content: "\\e384";
}

.fa-face-persevering::before {
  content: "\\e385";
}

.fa-face-pleading::before {
  content: "\\e386";
}

.fa-face-pouting::before {
  content: "\\e387";
}

.fa-face-raised-eyebrow::before {
  content: "\\e388";
}

.fa-face-relieved::before {
  content: "\\e389";
}

.fa-face-rolling-eyes::before {
  content: "\\f5a5";
}

.fa-meh-rolling-eyes::before {
  content: "\\f5a5";
}

.fa-face-sad-cry::before {
  content: "\\f5b3";
}

.fa-sad-cry::before {
  content: "\\f5b3";
}

.fa-face-sad-sweat::before {
  content: "\\e38a";
}

.fa-face-sad-tear::before {
  content: "\\f5b4";
}

.fa-sad-tear::before {
  content: "\\f5b4";
}

.fa-face-scream::before {
  content: "\\e38b";
}

.fa-face-shush::before {
  content: "\\e38c";
}

.fa-face-sleeping::before {
  content: "\\e38d";
}

.fa-face-sleepy::before {
  content: "\\e38e";
}

.fa-face-smile::before {
  content: "\\f118";
}

.fa-smile::before {
  content: "\\f118";
}

.fa-face-smile-beam::before {
  content: "\\f5b8";
}

.fa-smile-beam::before {
  content: "\\f5b8";
}

.fa-face-smile-halo::before {
  content: "\\e38f";
}

.fa-face-smile-hearts::before {
  content: "\\e390";
}

.fa-face-smile-horns::before {
  content: "\\e391";
}

.fa-face-smile-plus::before {
  content: "\\f5b9";
}

.fa-smile-plus::before {
  content: "\\f5b9";
}

.fa-face-smile-relaxed::before {
  content: "\\e392";
}

.fa-face-smile-tear::before {
  content: "\\e393";
}

.fa-face-smile-tongue::before {
  content: "\\e394";
}

.fa-face-smile-upside-down::before {
  content: "\\e395";
}

.fa-face-smile-wink::before {
  content: "\\f4da";
}

.fa-smile-wink::before {
  content: "\\f4da";
}

.fa-face-smiling-hands::before {
  content: "\\e396";
}

.fa-face-smirking::before {
  content: "\\e397";
}

.fa-face-sunglasses::before {
  content: "\\e398";
}

.fa-face-surprise::before {
  content: "\\f5c2";
}

.fa-surprise::before {
  content: "\\f5c2";
}

.fa-face-swear::before {
  content: "\\e399";
}

.fa-face-thermometer::before {
  content: "\\e39a";
}

.fa-face-thinking::before {
  content: "\\e39b";
}

.fa-face-tired::before {
  content: "\\f5c8";
}

.fa-tired::before {
  content: "\\f5c8";
}

.fa-face-tissue::before {
  content: "\\e39c";
}

.fa-face-tongue-money::before {
  content: "\\e39d";
}

.fa-face-tongue-sweat::before {
  content: "\\e39e";
}

.fa-face-unamused::before {
  content: "\\e39f";
}

.fa-face-viewfinder::before {
  content: "\\e2ff";
}

.fa-face-vomit::before {
  content: "\\e3a0";
}

.fa-face-weary::before {
  content: "\\e3a1";
}

.fa-face-woozy::before {
  content: "\\e3a2";
}

.fa-face-worried::before {
  content: "\\e3a3";
}

.fa-face-zany::before {
  content: "\\e3a4";
}

.fa-face-zipper::before {
  content: "\\e3a5";
}

.fa-falafel::before {
  content: "\\e40a";
}

.fa-family::before {
  content: "\\e300";
}

.fa-family-dress::before {
  content: "\\e301";
}

.fa-family-pants::before {
  content: "\\e302";
}

.fa-fan::before {
  content: "\\f863";
}

.fa-fan-table::before {
  content: "\\e004";
}

.fa-farm::before {
  content: "\\f864";
}

.fa-barn-silo::before {
  content: "\\f864";
}

.fa-faucet::before {
  content: "\\e005";
}

.fa-faucet-drip::before {
  content: "\\e006";
}

.fa-fax::before {
  content: "\\f1ac";
}

.fa-feather::before {
  content: "\\f52d";
}

.fa-feather-pointed::before {
  content: "\\f56b";
}

.fa-feather-alt::before {
  content: "\\f56b";
}

.fa-fence::before {
  content: "\\e303";
}

.fa-ferris-wheel::before {
  content: "\\e174";
}

.fa-field-hockey-stick-ball::before {
  content: "\\f44c";
}

.fa-field-hockey::before {
  content: "\\f44c";
}

.fa-file::before {
  content: "\\f15b";
}

.fa-file-arrow-down::before {
  content: "\\f56d";
}

.fa-file-download::before {
  content: "\\f56d";
}

.fa-file-arrow-up::before {
  content: "\\f574";
}

.fa-file-upload::before {
  content: "\\f574";
}

.fa-file-audio::before {
  content: "\\f1c7";
}

.fa-file-binary::before {
  content: "\\e175";
}

.fa-file-certificate::before {
  content: "\\f5f3";
}

.fa-file-award::before {
  content: "\\f5f3";
}

.fa-file-chart-column::before {
  content: "\\f659";
}

.fa-file-chart-line::before {
  content: "\\f659";
}

.fa-file-chart-pie::before {
  content: "\\f65a";
}

.fa-file-check::before {
  content: "\\f316";
}

.fa-file-code::before {
  content: "\\f1c9";
}

.fa-file-contract::before {
  content: "\\f56c";
}

.fa-file-csv::before {
  content: "\\f6dd";
}

.fa-file-dashed-line::before {
  content: "\\f877";
}

.fa-page-break::before {
  content: "\\f877";
}

.fa-file-excel::before {
  content: "\\f1c3";
}

.fa-file-exclamation::before {
  content: "\\f31a";
}

.fa-file-export::before {
  content: "\\f56e";
}

.fa-arrow-right-from-file::before {
  content: "\\f56e";
}

.fa-file-heart::before {
  content: "\\e176";
}

.fa-file-image::before {
  content: "\\f1c5";
}

.fa-file-import::before {
  content: "\\f56f";
}

.fa-arrow-right-to-file::before {
  content: "\\f56f";
}

.fa-file-invoice::before {
  content: "\\f570";
}

.fa-file-invoice-dollar::before {
  content: "\\f571";
}

.fa-file-lines::before {
  content: "\\f15c";
}

.fa-file-alt::before {
  content: "\\f15c";
}

.fa-file-text::before {
  content: "\\f15c";
}

.fa-file-lock::before {
  content: "\\e3a6";
}

.fa-file-magnifying-glass::before {
  content: "\\f865";
}

.fa-file-search::before {
  content: "\\f865";
}

.fa-file-medical::before {
  content: "\\f477";
}

.fa-file-minus::before {
  content: "\\f318";
}

.fa-file-music::before {
  content: "\\f8b6";
}

.fa-file-pdf::before {
  content: "\\f1c1";
}

.fa-file-pen::before {
  content: "\\f31c";
}

.fa-file-edit::before {
  content: "\\f31c";
}

.fa-file-plus::before {
  content: "\\f319";
}

.fa-file-plus-minus::before {
  content: "\\e177";
}

.fa-file-powerpoint::before {
  content: "\\f1c4";
}

.fa-file-prescription::before {
  content: "\\f572";
}

.fa-file-signature::before {
  content: "\\f573";
}

.fa-file-slash::before {
  content: "\\e3a7";
}

.fa-file-spreadsheet::before {
  content: "\\f65b";
}

.fa-file-user::before {
  content: "\\f65c";
}

.fa-file-video::before {
  content: "\\f1c8";
}

.fa-file-waveform::before {
  content: "\\f478";
}

.fa-file-medical-alt::before {
  content: "\\f478";
}

.fa-file-word::before {
  content: "\\f1c2";
}

.fa-file-xmark::before {
  content: "\\f317";
}

.fa-file-times::before {
  content: "\\f317";
}

.fa-file-zipper::before {
  content: "\\f1c6";
}

.fa-file-archive::before {
  content: "\\f1c6";
}

.fa-files::before {
  content: "\\e178";
}

.fa-files-medical::before {
  content: "\\f7fd";
}

.fa-fill::before {
  content: "\\f575";
}

.fa-fill-drip::before {
  content: "\\f576";
}

.fa-film::before {
  content: "\\f008";
}

.fa-film-canister::before {
  content: "\\f8b7";
}

.fa-film-simple::before {
  content: "\\f3a0";
}

.fa-film-alt::before {
  content: "\\f3a0";
}

.fa-film-slash::before {
  content: "\\e179";
}

.fa-films::before {
  content: "\\e17a";
}

.fa-filter::before {
  content: "\\f0b0";
}

.fa-filter-circle-dollar::before {
  content: "\\f662";
}

.fa-funnel-dollar::before {
  content: "\\f662";
}

.fa-filter-circle-xmark::before {
  content: "\\e17b";
}

.fa-filter-list::before {
  content: "\\e17c";
}

.fa-filter-slash::before {
  content: "\\e17d";
}

.fa-filters::before {
  content: "\\e17e";
}

.fa-fingerprint::before {
  content: "\\f577";
}

.fa-fire::before {
  content: "\\f06d";
}

.fa-fire-extinguisher::before {
  content: "\\f134";
}

.fa-fire-flame::before {
  content: "\\f6df";
}

.fa-flame::before {
  content: "\\f6df";
}

.fa-fire-flame-curved::before {
  content: "\\f7e4";
}

.fa-fire-alt::before {
  content: "\\f7e4";
}

.fa-fire-flame-simple::before {
  content: "\\f46a";
}

.fa-burn::before {
  content: "\\f46a";
}

.fa-fire-hydrant::before {
  content: "\\e17f";
}

.fa-fire-smoke::before {
  content: "\\f74b";
}

.fa-fireplace::before {
  content: "\\f79a";
}

.fa-fish::before {
  content: "\\f578";
}

.fa-fish-bones::before {
  content: "\\e304";
}

.fa-fish-cooked::before {
  content: "\\f7fe";
}

.fa-fishing-rod::before {
  content: "\\e3a8";
}

.fa-flag::before {
  content: "\\f024";
}

.fa-flag-checkered::before {
  content: "\\f11e";
}

.fa-flag-pennant::before {
  content: "\\f456";
}

.fa-pennant::before {
  content: "\\f456";
}

.fa-flag-swallowtail::before {
  content: "\\f74c";
}

.fa-flag-alt::before {
  content: "\\f74c";
}

.fa-flag-usa::before {
  content: "\\f74d";
}

.fa-flashlight::before {
  content: "\\f8b8";
}

.fa-flask::before {
  content: "\\f0c3";
}

.fa-flask-round-poison::before {
  content: "\\f6e0";
}

.fa-flask-poison::before {
  content: "\\f6e0";
}

.fa-flask-round-potion::before {
  content: "\\f6e1";
}

.fa-flask-potion::before {
  content: "\\f6e1";
}

.fa-flatbread::before {
  content: "\\e40b";
}

.fa-flatbread-stuffed::before {
  content: "\\e40c";
}

.fa-floppy-disk::before {
  content: "\\f0c7";
}

.fa-save::before {
  content: "\\f0c7";
}

.fa-floppy-disk-circle-arrow-right::before {
  content: "\\e180";
}

.fa-save-circle-arrow-right::before {
  content: "\\e180";
}

.fa-floppy-disk-circle-xmark::before {
  content: "\\e181";
}

.fa-floppy-disk-times::before {
  content: "\\e181";
}

.fa-save-circle-xmark::before {
  content: "\\e181";
}

.fa-save-times::before {
  content: "\\e181";
}

.fa-floppy-disk-pen::before {
  content: "\\e182";
}

.fa-floppy-disks::before {
  content: "\\e183";
}

.fa-florin-sign::before {
  content: "\\e184";
}

.fa-flower::before {
  content: "\\f7ff";
}

.fa-flower-daffodil::before {
  content: "\\f800";
}

.fa-flower-tulip::before {
  content: "\\f801";
}

.fa-flute::before {
  content: "\\f8b9";
}

.fa-flux-capacitor::before {
  content: "\\f8ba";
}

.fa-flying-disc::before {
  content: "\\e3a9";
}

.fa-folder::before {
  content: "\\f07b";
}

.fa-folder-arrow-down::before {
  content: "\\e053";
}

.fa-folder-download::before {
  content: "\\e053";
}

.fa-folder-arrow-up::before {
  content: "\\e054";
}

.fa-folder-upload::before {
  content: "\\e054";
}

.fa-folder-blank::before {
  content: "\\e185";
}

.fa-folder-bookmark::before {
  content: "\\e186";
}

.fa-folder-gear::before {
  content: "\\e187";
}

.fa-folder-cog::before {
  content: "\\e187";
}

.fa-folder-grid::before {
  content: "\\e188";
}

.fa-folder-heart::before {
  content: "\\e189";
}

.fa-folder-image::before {
  content: "\\e18a";
}

.fa-folder-magnifying-glass::before {
  content: "\\e18b";
}

.fa-folder-search::before {
  content: "\\e18b";
}

.fa-folder-medical::before {
  content: "\\e18c";
}

.fa-folder-minus::before {
  content: "\\f65d";
}

.fa-folder-music::before {
  content: "\\e18d";
}

.fa-folder-open::before {
  content: "\\f07c";
}

.fa-folder-plus::before {
  content: "\\f65e";
}

.fa-folder-tree::before {
  content: "\\f802";
}

.fa-folder-user::before {
  content: "\\e18e";
}

.fa-folder-xmark::before {
  content: "\\f65f";
}

.fa-folder-times::before {
  content: "\\f65f";
}

.fa-folders::before {
  content: "\\f660";
}

.fa-fondue-pot::before {
  content: "\\e40d";
}

.fa-font::before {
  content: "\\f031";
}

.fa-font-case::before {
  content: "\\f866";
}

.fa-football::before {
  content: "\\f44e";
}

.fa-football-ball::before {
  content: "\\f44e";
}

.fa-football-helmet::before {
  content: "\\f44f";
}

.fa-fork::before {
  content: "\\f2e3";
}

.fa-utensil-fork::before {
  content: "\\f2e3";
}

.fa-fork-knife::before {
  content: "\\f2e6";
}

.fa-utensils-alt::before {
  content: "\\f2e6";
}

.fa-forklift::before {
  content: "\\f47a";
}

.fa-forward::before {
  content: "\\f04e";
}

.fa-forward-fast::before {
  content: "\\f050";
}

.fa-fast-forward::before {
  content: "\\f050";
}

.fa-forward-step::before {
  content: "\\f051";
}

.fa-step-forward::before {
  content: "\\f051";
}

.fa-franc-sign::before {
  content: "\\e18f";
}

.fa-french-fries::before {
  content: "\\f803";
}

.fa-frog::before {
  content: "\\f52e";
}

.fa-function::before {
  content: "\\f661";
}

.fa-futbol::before {
  content: "\\f1e3";
}

.fa-futbol-ball::before {
  content: "\\f1e3";
}

.fa-soccer-ball::before {
  content: "\\f1e3";
}

.fa-g::before {
  content: "G";
}

.fa-galaxy::before {
  content: "\\e008";
}

.fa-gallery-thumbnails::before {
  content: "\\e3aa";
}

.fa-game-board::before {
  content: "\\f867";
}

.fa-game-board-simple::before {
  content: "\\f868";
}

.fa-game-board-alt::before {
  content: "\\f868";
}

.fa-game-console-handheld::before {
  content: "\\f8bb";
}

.fa-gamepad::before {
  content: "\\f11b";
}

.fa-gamepad-modern::before {
  content: "\\f8bc";
}

.fa-gamepad-alt::before {
  content: "\\f8bc";
}

.fa-garage::before {
  content: "\\e009";
}

.fa-garage-car::before {
  content: "\\e00a";
}

.fa-garage-open::before {
  content: "\\e00b";
}

.fa-garlic::before {
  content: "\\e40e";
}

.fa-gas-pump::before {
  content: "\\f52f";
}

.fa-gas-pump-slash::before {
  content: "\\f5f4";
}

.fa-gauge::before {
  content: "\\f625";
}

.fa-dashboard::before {
  content: "\\f625";
}

.fa-gauge-high::before {
  content: "\\f625";
}

.fa-tachometer-alt::before {
  content: "\\f625";
}

.fa-tachometer-alt-fast::before {
  content: "\\f625";
}

.fa-gauge-low::before {
  content: "\\f627";
}

.fa-tachometer-alt-slow::before {
  content: "\\f627";
}

.fa-gauge-max::before {
  content: "\\f626";
}

.fa-tachometer-alt-fastest::before {
  content: "\\f626";
}

.fa-gauge-med::before {
  content: "\\f624";
}

.fa-tachometer-alt-average::before {
  content: "\\f624";
}

.fa-gauge-min::before {
  content: "\\f628";
}

.fa-tachometer-alt-slowest::before {
  content: "\\f628";
}

.fa-gauge-simple::before {
  content: "\\f62a";
}

.fa-gauge-simple-high::before {
  content: "\\f62a";
}

.fa-tachometer::before {
  content: "\\f62a";
}

.fa-gauge-simple-low::before {
  content: "\\f62c";
}

.fa-tachometer-slow::before {
  content: "\\f62c";
}

.fa-gauge-simple-max::before {
  content: "\\f62b";
}

.fa-tachometer-fastest::before {
  content: "\\f62b";
}

.fa-gauge-simple-med::before {
  content: "\\f629";
}

.fa-tachometer-average::before {
  content: "\\f629";
}

.fa-gauge-simple-min::before {
  content: "\\f62d";
}

.fa-tachometer-slowest::before {
  content: "\\f62d";
}

.fa-gavel::before {
  content: "\\f0e3";
}

.fa-legal::before {
  content: "\\f0e3";
}

.fa-gear::before {
  content: "\\f013";
}

.fa-cog::before {
  content: "\\f013";
}

.fa-gears::before {
  content: "\\f085";
}

.fa-cogs::before {
  content: "\\f085";
}

.fa-gem::before {
  content: "\\f3a5";
}

.fa-genderless::before {
  content: "\\f22d";
}

.fa-ghost::before {
  content: "\\f6e2";
}

.fa-gif::before {
  content: "\\e190";
}

.fa-gift::before {
  content: "\\f06b";
}

.fa-gift-card::before {
  content: "\\f663";
}

.fa-gifts::before {
  content: "\\f79c";
}

.fa-gingerbread-man::before {
  content: "\\f79d";
}

.fa-glass::before {
  content: "\\f804";
}

.fa-glass-citrus::before {
  content: "\\f869";
}

.fa-glass-empty::before {
  content: "\\e191";
}

.fa-glass-half::before {
  content: "\\e192";
}

.fa-glass-half-empty::before {
  content: "\\e192";
}

.fa-glass-half-full::before {
  content: "\\e192";
}

.fa-glasses::before {
  content: "\\f530";
}

.fa-glasses-round::before {
  content: "\\f5f5";
}

.fa-glasses-alt::before {
  content: "\\f5f5";
}

.fa-globe::before {
  content: "\\f0ac";
}

.fa-globe-snow::before {
  content: "\\f7a3";
}

.fa-globe-stand::before {
  content: "\\f5f6";
}

.fa-goal-net::before {
  content: "\\e3ab";
}

.fa-golf-ball-tee::before {
  content: "\\f450";
}

.fa-golf-ball::before {
  content: "\\f450";
}

.fa-golf-club::before {
  content: "\\f451";
}

.fa-golf-flag-hole::before {
  content: "\\e3ac";
}

.fa-gopuram::before {
  content: "\\f664";
}

.fa-graduation-cap::before {
  content: "\\f19d";
}

.fa-mortar-board::before {
  content: "\\f19d";
}

.fa-gramophone::before {
  content: "\\f8bd";
}

.fa-grapes::before {
  content: "\\e306";
}

.fa-grate::before {
  content: "\\e193";
}

.fa-grate-droplet::before {
  content: "\\e194";
}

.fa-greater-than::before {
  content: "\\>";
}

.fa-greater-than-equal::before {
  content: "\\f532";
}

.fa-grid::before {
  content: "\\e195";
}

.fa-grid-3::before {
  content: "\\e195";
}

.fa-grid-2::before {
  content: "\\e196";
}

.fa-grid-2-plus::before {
  content: "\\e197";
}

.fa-grid-4::before {
  content: "\\e198";
}

.fa-grid-5::before {
  content: "\\e199";
}

.fa-grid-dividers::before {
  content: "\\e3ad";
}

.fa-grid-horizontal::before {
  content: "\\e307";
}

.fa-grip::before {
  content: "\\f58d";
}

.fa-grip-horizontal::before {
  content: "\\f58d";
}

.fa-grip-dots::before {
  content: "\\e410";
}

.fa-grip-dots-vertical::before {
  content: "\\e411";
}

.fa-grip-lines::before {
  content: "\\f7a4";
}

.fa-grip-lines-vertical::before {
  content: "\\f7a5";
}

.fa-grip-vertical::before {
  content: "\\f58e";
}

.fa-guarani-sign::before {
  content: "\\e19a";
}

.fa-guitar::before {
  content: "\\f7a6";
}

.fa-guitar-electric::before {
  content: "\\f8be";
}

.fa-guitars::before {
  content: "\\f8bf";
}

.fa-gun::before {
  content: "\\e19b";
}

.fa-gun-slash::before {
  content: "\\e19c";
}

.fa-gun-squirt::before {
  content: "\\e19d";
}

.fa-h::before {
  content: "H";
}

.fa-h1::before {
  content: "\\f313";
}

.fa-h2::before {
  content: "\\f314";
}

.fa-h3::before {
  content: "\\f315";
}

.fa-h4::before {
  content: "\\f86a";
}

.fa-h5::before {
  content: "\\e412";
}

.fa-h6::before {
  content: "\\e413";
}

.fa-hammer::before {
  content: "\\f6e3";
}

.fa-hammer-crash::before {
  content: "\\e414";
}

.fa-hammer-war::before {
  content: "\\f6e4";
}

.fa-hamsa::before {
  content: "\\f665";
}

.fa-hand::before {
  content: "\\f256";
}

.fa-hand-paper::before {
  content: "\\f256";
}

.fa-hand-back-fist::before {
  content: "\\f255";
}

.fa-hand-rock::before {
  content: "\\f255";
}

.fa-hand-back-point-down::before {
  content: "\\e19e";
}

.fa-hand-back-point-left::before {
  content: "\\e19f";
}

.fa-hand-back-point-ribbon::before {
  content: "\\e1a0";
}

.fa-hand-back-point-right::before {
  content: "\\e1a1";
}

.fa-hand-back-point-up::before {
  content: "\\e1a2";
}

.fa-hand-dots::before {
  content: "\\f461";
}

.fa-allergies::before {
  content: "\\f461";
}

.fa-hand-fingers-crossed::before {
  content: "\\e1a3";
}

.fa-hand-fist::before {
  content: "\\f6de";
}

.fa-fist-raised::before {
  content: "\\f6de";
}

.fa-hand-heart::before {
  content: "\\f4bc";
}

.fa-hand-holding::before {
  content: "\\f4bd";
}

.fa-hand-holding-box::before {
  content: "\\f47b";
}

.fa-hand-holding-dollar::before {
  content: "\\f4c0";
}

.fa-hand-holding-usd::before {
  content: "\\f4c0";
}

.fa-hand-holding-droplet::before {
  content: "\\f4c1";
}

.fa-hand-holding-water::before {
  content: "\\f4c1";
}

.fa-hand-holding-heart::before {
  content: "\\f4be";
}

.fa-hand-holding-magic::before {
  content: "\\f6e5";
}

.fa-hand-holding-medical::before {
  content: "\\e05c";
}

.fa-hand-holding-seedling::before {
  content: "\\f4bf";
}

.fa-hand-holding-skull::before {
  content: "\\e1a4";
}

.fa-hand-horns::before {
  content: "\\e1a9";
}

.fa-hand-lizard::before {
  content: "\\f258";
}

.fa-hand-love::before {
  content: "\\e1a5";
}

.fa-hand-middle-finger::before {
  content: "\\f806";
}

.fa-hand-peace::before {
  content: "\\f25b";
}

.fa-hand-point-down::before {
  content: "\\f0a7";
}

.fa-hand-point-left::before {
  content: "\\f0a5";
}

.fa-hand-point-ribbon::before {
  content: "\\e1a6";
}

.fa-hand-point-right::before {
  content: "\\f0a4";
}

.fa-hand-point-up::before {
  content: "\\f0a6";
}

.fa-hand-pointer::before {
  content: "\\f25a";
}

.fa-hand-scissors::before {
  content: "\\f257";
}

.fa-hand-sparkles::before {
  content: "\\e05d";
}

.fa-hand-spock::before {
  content: "\\f259";
}

.fa-hand-wave::before {
  content: "\\e1a7";
}

.fa-hands::before {
  content: "\\f2a7";
}

.fa-sign-language::before {
  content: "\\f2a7";
}

.fa-signing::before {
  content: "\\f2a7";
}

.fa-hands-asl-interpreting::before {
  content: "\\f2a3";
}

.fa-american-sign-language-interpreting::before {
  content: "\\f2a3";
}

.fa-asl-interpreting::before {
  content: "\\f2a3";
}

.fa-hands-american-sign-language-interpreting::before {
  content: "\\f2a3";
}

.fa-hands-bubbles::before {
  content: "\\e05e";
}

.fa-hands-wash::before {
  content: "\\e05e";
}

.fa-hands-clapping::before {
  content: "\\e1a8";
}

.fa-hands-holding::before {
  content: "\\f4c2";
}

.fa-hands-holding-diamond::before {
  content: "\\f47c";
}

.fa-hand-receiving::before {
  content: "\\f47c";
}

.fa-hands-holding-dollar::before {
  content: "\\f4c5";
}

.fa-hands-usd::before {
  content: "\\f4c5";
}

.fa-hands-holding-heart::before {
  content: "\\f4c3";
}

.fa-hands-heart::before {
  content: "\\f4c3";
}

.fa-hands-praying::before {
  content: "\\f684";
}

.fa-praying-hands::before {
  content: "\\f684";
}

.fa-handshake::before {
  content: "\\f2b5";
}

.fa-handshake-angle::before {
  content: "\\f4c4";
}

.fa-hands-helping::before {
  content: "\\f4c4";
}

.fa-handshake-simple::before {
  content: "\\f4c6";
}

.fa-handshake-alt::before {
  content: "\\f4c6";
}

.fa-handshake-simple-slash::before {
  content: "\\e05f";
}

.fa-handshake-alt-slash::before {
  content: "\\e05f";
}

.fa-handshake-slash::before {
  content: "\\e060";
}

.fa-hanukiah::before {
  content: "\\f6e6";
}

.fa-hard-drive::before {
  content: "\\f0a0";
}

.fa-hdd::before {
  content: "\\f0a0";
}

.fa-hashtag::before {
  content: "\\#";
}

.fa-hashtag-lock::before {
  content: "\\e415";
}

.fa-hat-chef::before {
  content: "\\f86b";
}

.fa-hat-cowboy::before {
  content: "\\f8c0";
}

.fa-hat-cowboy-side::before {
  content: "\\f8c1";
}

.fa-hat-santa::before {
  content: "\\f7a7";
}

.fa-hat-winter::before {
  content: "\\f7a8";
}

.fa-hat-witch::before {
  content: "\\f6e7";
}

.fa-hat-wizard::before {
  content: "\\f6e8";
}

.fa-head-side::before {
  content: "\\f6e9";
}

.fa-head-side-brain::before {
  content: "\\f808";
}

.fa-head-side-cough::before {
  content: "\\e061";
}

.fa-head-side-cough-slash::before {
  content: "\\e062";
}

.fa-head-side-goggles::before {
  content: "\\f6ea";
}

.fa-head-vr::before {
  content: "\\f6ea";
}

.fa-head-side-headphones::before {
  content: "\\f8c2";
}

.fa-head-side-heart::before {
  content: "\\e1aa";
}

.fa-head-side-mask::before {
  content: "\\e063";
}

.fa-head-side-medical::before {
  content: "\\f809";
}

.fa-head-side-virus::before {
  content: "\\e064";
}

.fa-heading::before {
  content: "\\f1dc";
}

.fa-header::before {
  content: "\\f1dc";
}

.fa-headphones::before {
  content: "\\f025";
}

.fa-headphones-simple::before {
  content: "\\f58f";
}

.fa-headphones-alt::before {
  content: "\\f58f";
}

.fa-headset::before {
  content: "\\f590";
}

.fa-heart::before {
  content: "\\f004";
}

.fa-heart-crack::before {
  content: "\\f7a9";
}

.fa-heart-broken::before {
  content: "\\f7a9";
}

.fa-heart-half::before {
  content: "\\e1ab";
}

.fa-heart-half-stroke::before {
  content: "\\e1ac";
}

.fa-heart-half-alt::before {
  content: "\\e1ac";
}

.fa-heart-pulse::before {
  content: "\\f21e";
}

.fa-heartbeat::before {
  content: "\\f21e";
}

.fa-heat::before {
  content: "\\e00c";
}

.fa-helicopter::before {
  content: "\\f533";
}

.fa-helmet-battle::before {
  content: "\\f6eb";
}

.fa-helmet-safety::before {
  content: "\\f807";
}

.fa-hard-hat::before {
  content: "\\f807";
}

.fa-hat-hard::before {
  content: "\\f807";
}

.fa-hexagon::before {
  content: "\\f312";
}

.fa-hexagon-check::before {
  content: "\\e416";
}

.fa-hexagon-divide::before {
  content: "\\e1ad";
}

.fa-hexagon-exclamation::before {
  content: "\\e417";
}

.fa-hexagon-minus::before {
  content: "\\f307";
}

.fa-minus-hexagon::before {
  content: "\\f307";
}

.fa-hexagon-plus::before {
  content: "\\f300";
}

.fa-plus-hexagon::before {
  content: "\\f300";
}

.fa-hexagon-xmark::before {
  content: "\\f2ee";
}

.fa-times-hexagon::before {
  content: "\\f2ee";
}

.fa-xmark-hexagon::before {
  content: "\\f2ee";
}

.fa-high-definition::before {
  content: "\\e1ae";
}

.fa-rectangle-hd::before {
  content: "\\e1ae";
}

.fa-highlighter::before {
  content: "\\f591";
}

.fa-highlighter-line::before {
  content: "\\e1af";
}

.fa-hippo::before {
  content: "\\f6ed";
}

.fa-hockey-mask::before {
  content: "\\f6ee";
}

.fa-hockey-puck::before {
  content: "\\f453";
}

.fa-hockey-stick-puck::before {
  content: "\\e3ae";
}

.fa-hockey-sticks::before {
  content: "\\f454";
}

.fa-holly-berry::before {
  content: "\\f7aa";
}

.fa-honey-pot::before {
  content: "\\e418";
}

.fa-hood-cloak::before {
  content: "\\f6ef";
}

.fa-horizontal-rule::before {
  content: "\\f86c";
}

.fa-horse::before {
  content: "\\f6f0";
}

.fa-horse-head::before {
  content: "\\f7ab";
}

.fa-horse-saddle::before {
  content: "\\f8c3";
}

.fa-hose::before {
  content: "\\e419";
}

.fa-hose-reel::before {
  content: "\\e41a";
}

.fa-hospital::before {
  content: "\\f0f8";
}

.fa-hospital-user::before {
  content: "\\f80d";
}

.fa-hospital-wide::before {
  content: "\\f47d";
}

.fa-hospital-alt::before {
  content: "\\f47d";
}

.fa-hospitals::before {
  content: "\\f80e";
}

.fa-hot-tub-person::before {
  content: "\\f593";
}

.fa-hot-tub::before {
  content: "\\f593";
}

.fa-hotdog::before {
  content: "\\f80f";
}

.fa-hotel::before {
  content: "\\f594";
}

.fa-hourglass::before {
  content: "\\f254";
}

.fa-hourglass-2::before {
  content: "\\f254";
}

.fa-hourglass-half::before {
  content: "\\f254";
}

.fa-hourglass-clock::before {
  content: "\\e41b";
}

.fa-hourglass-empty::before {
  content: "\\f252";
}

.fa-hourglass-end::before {
  content: "\\f253";
}

.fa-hourglass-3::before {
  content: "\\f253";
}

.fa-hourglass-start::before {
  content: "\\f251";
}

.fa-hourglass-1::before {
  content: "\\f251";
}

.fa-house::before {
  content: "\\f015";
}

.fa-home::before {
  content: "\\f015";
}

.fa-house-blank::before {
  content: "\\f80a";
}

.fa-home-blank::before {
  content: "\\f80a";
}

.fa-home-lg-alt::before {
  content: "\\f80a";
}

.fa-house-building::before {
  content: "\\e1b1";
}

.fa-house-chimney::before {
  content: "\\e3af";
}

.fa-home-lg::before {
  content: "\\e3af";
}

.fa-house-chimney-blank::before {
  content: "\\e3b0";
}

.fa-house-chimney-crack::before {
  content: "\\f6f1";
}

.fa-house-damage::before {
  content: "\\f6f1";
}

.fa-house-chimney-heart::before {
  content: "\\e1b2";
}

.fa-house-chimney-medical::before {
  content: "\\f7f2";
}

.fa-clinic-medical::before {
  content: "\\f7f2";
}

.fa-house-chimney-user::before {
  content: "\\e065";
}

.fa-house-chimney-window::before {
  content: "\\e00d";
}

.fa-house-crack::before {
  content: "\\e3b1";
}

.fa-house-day::before {
  content: "\\e00e";
}

.fa-house-flood::before {
  content: "\\f74f";
}

.fa-house-heart::before {
  content: "\\f4c9";
}

.fa-home-heart::before {
  content: "\\f4c9";
}

.fa-house-laptop::before {
  content: "\\e066";
}

.fa-laptop-house::before {
  content: "\\e066";
}

.fa-house-medical::before {
  content: "\\e3b2";
}

.fa-house-night::before {
  content: "\\e010";
}

.fa-house-person-leave::before {
  content: "\\e00f";
}

.fa-house-person-depart::before {
  content: "\\e00f";
}

.fa-house-person-return::before {
  content: "\\e011";
}

.fa-house-person-arrive::before {
  content: "\\e011";
}

.fa-house-signal::before {
  content: "\\e012";
}

.fa-house-tree::before {
  content: "\\e1b3";
}

.fa-house-turret::before {
  content: "\\e1b4";
}

.fa-house-user::before {
  content: "\\e1b0";
}

.fa-home-user::before {
  content: "\\e1b0";
}

.fa-house-window::before {
  content: "\\e3b3";
}

.fa-hryvnia-sign::before {
  content: "\\f6f2";
}

.fa-hryvnia::before {
  content: "\\f6f2";
}

.fa-hundred-points::before {
  content: "\\e41c";
}

.fa-100::before {
  content: "\\e41c";
}

.fa-hurricane::before {
  content: "\\f751";
}

.fa-hyphen::before {
  content: "\\-";
}

.fa-i::before {
  content: "I";
}

.fa-i-cursor::before {
  content: "\\f246";
}

.fa-ice-cream::before {
  content: "\\f810";
}

.fa-ice-skate::before {
  content: "\\f7ac";
}

.fa-icicles::before {
  content: "\\f7ad";
}

.fa-icons::before {
  content: "\\f86d";
}

.fa-heart-music-camera-bolt::before {
  content: "\\f86d";
}

.fa-id-badge::before {
  content: "\\f2c1";
}

.fa-id-card::before {
  content: "\\f2c2";
}

.fa-drivers-license::before {
  content: "\\f2c2";
}

.fa-id-card-clip::before {
  content: "\\f47f";
}

.fa-id-card-alt::before {
  content: "\\f47f";
}

.fa-igloo::before {
  content: "\\f7ae";
}

.fa-image::before {
  content: "\\f03e";
}

.fa-image-landscape::before {
  content: "\\e1b5";
}

.fa-landscape::before {
  content: "\\e1b5";
}

.fa-image-polaroid::before {
  content: "\\f8c4";
}

.fa-image-polaroid-user::before {
  content: "\\e1b6";
}

.fa-image-portrait::before {
  content: "\\f3e0";
}

.fa-portrait::before {
  content: "\\f3e0";
}

.fa-image-slash::before {
  content: "\\e1b7";
}

.fa-image-user::before {
  content: "\\e1b8";
}

.fa-images::before {
  content: "\\f302";
}

.fa-images-user::before {
  content: "\\e1b9";
}

.fa-inbox::before {
  content: "\\f01c";
}

.fa-inbox-full::before {
  content: "\\e1ba";
}

.fa-inbox-in::before {
  content: "\\f310";
}

.fa-inbox-arrow-down::before {
  content: "\\f310";
}

.fa-inbox-out::before {
  content: "\\f311";
}

.fa-inbox-arrow-up::before {
  content: "\\f311";
}

.fa-inboxes::before {
  content: "\\e1bb";
}

.fa-indent::before {
  content: "\\f03c";
}

.fa-indian-rupee-sign::before {
  content: "\\e1bc";
}

.fa-indian-rupee::before {
  content: "\\e1bc";
}

.fa-inr::before {
  content: "\\e1bc";
}

.fa-industry::before {
  content: "\\f275";
}

.fa-industry-windows::before {
  content: "\\f3b3";
}

.fa-industry-alt::before {
  content: "\\f3b3";
}

.fa-infinity::before {
  content: "\\f534";
}

.fa-info::before {
  content: "\\f129";
}

.fa-inhaler::before {
  content: "\\f5f9";
}

.fa-input-numeric::before {
  content: "\\e1bd";
}

.fa-input-pipe::before {
  content: "\\e1be";
}

.fa-input-text::before {
  content: "\\e1bf";
}

.fa-integral::before {
  content: "\\f667";
}

.fa-intersection::before {
  content: "\\f668";
}

.fa-island-tropical::before {
  content: "\\f811";
}

.fa-island-tree-palm::before {
  content: "\\f811";
}

.fa-italic::before {
  content: "\\f033";
}

.fa-j::before {
  content: "J";
}

.fa-jack-o-lantern::before {
  content: "\\f30e";
}

.fa-jedi::before {
  content: "\\f669";
}

.fa-jet-fighter::before {
  content: "\\f0fb";
}

.fa-fighter-jet::before {
  content: "\\f0fb";
}

.fa-joint::before {
  content: "\\f595";
}

.fa-joystick::before {
  content: "\\f8c5";
}

.fa-jug::before {
  content: "\\f8c6";
}

.fa-k::before {
  content: "K";
}

.fa-kaaba::before {
  content: "\\f66b";
}

.fa-kazoo::before {
  content: "\\f8c7";
}

.fa-kerning::before {
  content: "\\f86f";
}

.fa-key::before {
  content: "\\f084";
}

.fa-key-skeleton::before {
  content: "\\f6f3";
}

.fa-key-skeleton-left-right::before {
  content: "\\e3b4";
}

.fa-keyboard::before {
  content: "\\f11c";
}

.fa-keyboard-brightness::before {
  content: "\\e1c0";
}

.fa-keyboard-brightness-low::before {
  content: "\\e1c1";
}

.fa-keyboard-down::before {
  content: "\\e1c2";
}

.fa-keyboard-left::before {
  content: "\\e1c3";
}

.fa-keynote::before {
  content: "\\f66c";
}

.fa-khanda::before {
  content: "\\f66d";
}

.fa-kidneys::before {
  content: "\\f5fb";
}

.fa-kip-sign::before {
  content: "\\e1c4";
}

.fa-kit-medical::before {
  content: "\\f479";
}

.fa-first-aid::before {
  content: "\\f479";
}

.fa-kite::before {
  content: "\\f6f4";
}

.fa-kiwi-bird::before {
  content: "\\f535";
}

.fa-kiwi-fruit::before {
  content: "\\e30c";
}

.fa-knife::before {
  content: "\\f2e4";
}

.fa-utensil-knife::before {
  content: "\\f2e4";
}

.fa-knife-kitchen::before {
  content: "\\f6f5";
}

.fa-l::before {
  content: "L";
}

.fa-lacrosse-stick::before {
  content: "\\e3b5";
}

.fa-lacrosse-stick-ball::before {
  content: "\\e3b6";
}

.fa-lambda::before {
  content: "\\f66e";
}

.fa-lamp::before {
  content: "\\f4ca";
}

.fa-lamp-desk::before {
  content: "\\e014";
}

.fa-lamp-floor::before {
  content: "\\e015";
}

.fa-lamp-street::before {
  content: "\\e1c5";
}

.fa-landmark::before {
  content: "\\f66f";
}

.fa-landmark-dome::before {
  content: "\\f752";
}

.fa-landmark-alt::before {
  content: "\\f752";
}

.fa-language::before {
  content: "\\f1ab";
}

.fa-laptop::before {
  content: "\\f109";
}

.fa-laptop-arrow-down::before {
  content: "\\e1c6";
}

.fa-laptop-code::before {
  content: "\\f5fc";
}

.fa-laptop-medical::before {
  content: "\\f812";
}

.fa-laptop-mobile::before {
  content: "\\f87a";
}

.fa-phone-laptop::before {
  content: "\\f87a";
}

.fa-laptop-slash::before {
  content: "\\e1c7";
}

.fa-lari-sign::before {
  content: "\\e1c8";
}

.fa-lasso::before {
  content: "\\f8c8";
}

.fa-lasso-sparkles::before {
  content: "\\e1c9";
}

.fa-layer-group::before {
  content: "\\f5fd";
}

.fa-layer-minus::before {
  content: "\\f5fe";
}

.fa-layer-group-minus::before {
  content: "\\f5fe";
}

.fa-layer-plus::before {
  content: "\\f5ff";
}

.fa-layer-group-plus::before {
  content: "\\f5ff";
}

.fa-leaf::before {
  content: "\\f06c";
}

.fa-leaf-heart::before {
  content: "\\f4cb";
}

.fa-leaf-maple::before {
  content: "\\f6f6";
}

.fa-leaf-oak::before {
  content: "\\f6f7";
}

.fa-leafy-green::before {
  content: "\\e41d";
}

.fa-left::before {
  content: "\\f355";
}

.fa-arrow-alt-left::before {
  content: "\\f355";
}

.fa-left-from-line::before {
  content: "\\f348";
}

.fa-arrow-alt-from-right::before {
  content: "\\f348";
}

.fa-left-long::before {
  content: "\\f30a";
}

.fa-long-arrow-alt-left::before {
  content: "\\f30a";
}

.fa-left-long-to-line::before {
  content: "\\e41e";
}

.fa-left-right::before {
  content: "\\f337";
}

.fa-arrows-alt-h::before {
  content: "\\f337";
}

.fa-left-to-line::before {
  content: "\\f34b";
}

.fa-arrow-alt-to-left::before {
  content: "\\f34b";
}

.fa-lemon::before {
  content: "\\f094";
}

.fa-less-than::before {
  content: "\\<";
}

.fa-less-than-equal::before {
  content: "\\f537";
}

.fa-life-ring::before {
  content: "\\f1cd";
}

.fa-light-ceiling::before {
  content: "\\e016";
}

.fa-light-emergency::before {
  content: "\\e41f";
}

.fa-light-emergency-on::before {
  content: "\\e420";
}

.fa-light-switch::before {
  content: "\\e017";
}

.fa-light-switch-off::before {
  content: "\\e018";
}

.fa-light-switch-on::before {
  content: "\\e019";
}

.fa-lightbulb::before {
  content: "\\f0eb";
}

.fa-lightbulb-dollar::before {
  content: "\\f670";
}

.fa-lightbulb-exclamation::before {
  content: "\\f671";
}

.fa-lightbulb-exclamation-on::before {
  content: "\\e1ca";
}

.fa-lightbulb-on::before {
  content: "\\f672";
}

.fa-lightbulb-slash::before {
  content: "\\f673";
}

.fa-lights-holiday::before {
  content: "\\f7b2";
}

.fa-line-columns::before {
  content: "\\f870";
}

.fa-line-height::before {
  content: "\\f871";
}

.fa-link::before {
  content: "\\f0c1";
}

.fa-chain::before {
  content: "\\f0c1";
}

.fa-link-horizontal::before {
  content: "\\e1cb";
}

.fa-chain-horizontal::before {
  content: "\\e1cb";
}

.fa-link-horizontal-slash::before {
  content: "\\e1cc";
}

.fa-chain-horizontal-slash::before {
  content: "\\e1cc";
}

.fa-link-simple::before {
  content: "\\e1cd";
}

.fa-link-simple-slash::before {
  content: "\\e1ce";
}

.fa-link-slash::before {
  content: "\\f127";
}

.fa-chain-broken::before {
  content: "\\f127";
}

.fa-chain-slash::before {
  content: "\\f127";
}

.fa-unlink::before {
  content: "\\f127";
}

.fa-lips::before {
  content: "\\f600";
}

.fa-lira-sign::before {
  content: "\\f195";
}

.fa-list::before {
  content: "\\f03a";
}

.fa-list-squares::before {
  content: "\\f03a";
}

.fa-list-check::before {
  content: "\\f0ae";
}

.fa-tasks::before {
  content: "\\f0ae";
}

.fa-list-dropdown::before {
  content: "\\e1cf";
}

.fa-list-music::before {
  content: "\\f8c9";
}

.fa-list-ol::before {
  content: "\\f0cb";
}

.fa-list-1-2::before {
  content: "\\f0cb";
}

.fa-list-numeric::before {
  content: "\\f0cb";
}

.fa-list-radio::before {
  content: "\\e1d0";
}

.fa-list-timeline::before {
  content: "\\e1d1";
}

.fa-list-tree::before {
  content: "\\e1d2";
}

.fa-list-ul::before {
  content: "\\f0ca";
}

.fa-list-dots::before {
  content: "\\f0ca";
}

.fa-litecoin-sign::before {
  content: "\\e1d3";
}

.fa-loader::before {
  content: "\\e1d4";
}

.fa-lobster::before {
  content: "\\e421";
}

.fa-location-arrow::before {
  content: "\\f124";
}

.fa-location-check::before {
  content: "\\f606";
}

.fa-map-marker-check::before {
  content: "\\f606";
}

.fa-location-crosshairs::before {
  content: "\\f601";
}

.fa-location::before {
  content: "\\f601";
}

.fa-location-crosshairs-slash::before {
  content: "\\f603";
}

.fa-location-slash::before {
  content: "\\f603";
}

.fa-location-dot::before {
  content: "\\f3c5";
}

.fa-map-marker-alt::before {
  content: "\\f3c5";
}

.fa-location-dot-slash::before {
  content: "\\f605";
}

.fa-map-marker-alt-slash::before {
  content: "\\f605";
}

.fa-location-exclamation::before {
  content: "\\f608";
}

.fa-map-marker-exclamation::before {
  content: "\\f608";
}

.fa-location-minus::before {
  content: "\\f609";
}

.fa-map-marker-minus::before {
  content: "\\f609";
}

.fa-location-pen::before {
  content: "\\f607";
}

.fa-map-marker-edit::before {
  content: "\\f607";
}

.fa-location-pin::before {
  content: "\\f041";
}

.fa-map-marker::before {
  content: "\\f041";
}

.fa-location-pin-slash::before {
  content: "\\f60c";
}

.fa-map-marker-slash::before {
  content: "\\f60c";
}

.fa-location-plus::before {
  content: "\\f60a";
}

.fa-map-marker-plus::before {
  content: "\\f60a";
}

.fa-location-question::before {
  content: "\\f60b";
}

.fa-map-marker-question::before {
  content: "\\f60b";
}

.fa-location-smile::before {
  content: "\\f60d";
}

.fa-map-marker-smile::before {
  content: "\\f60d";
}

.fa-location-xmark::before {
  content: "\\f60e";
}

.fa-map-marker-times::before {
  content: "\\f60e";
}

.fa-map-marker-xmark::before {
  content: "\\f60e";
}

.fa-lock::before {
  content: "\\f023";
}

.fa-lock-a::before {
  content: "\\e422";
}

.fa-lock-hashtag::before {
  content: "\\e423";
}

.fa-lock-keyhole::before {
  content: "\\f30d";
}

.fa-lock-alt::before {
  content: "\\f30d";
}

.fa-lock-keyhole-open::before {
  content: "\\f3c2";
}

.fa-lock-open-alt::before {
  content: "\\f3c2";
}

.fa-lock-open::before {
  content: "\\f3c1";
}

.fa-lollipop::before {
  content: "\\e424";
}

.fa-lollypop::before {
  content: "\\e424";
}

.fa-loveseat::before {
  content: "\\f4cc";
}

.fa-couch-small::before {
  content: "\\f4cc";
}

.fa-luchador-mask::before {
  content: "\\f455";
}

.fa-luchador::before {
  content: "\\f455";
}

.fa-mask-luchador::before {
  content: "\\f455";
}

.fa-lungs::before {
  content: "\\f604";
}

.fa-lungs-virus::before {
  content: "\\e067";
}

.fa-m::before {
  content: "M";
}

.fa-mace::before {
  content: "\\f6f8";
}

.fa-magnet::before {
  content: "\\f076";
}

.fa-magnifying-glass::before {
  content: "\\f002";
}

.fa-search::before {
  content: "\\f002";
}

.fa-magnifying-glass-dollar::before {
  content: "\\f688";
}

.fa-search-dollar::before {
  content: "\\f688";
}

.fa-magnifying-glass-location::before {
  content: "\\f689";
}

.fa-search-location::before {
  content: "\\f689";
}

.fa-magnifying-glass-minus::before {
  content: "\\f010";
}

.fa-search-minus::before {
  content: "\\f010";
}

.fa-magnifying-glass-plus::before {
  content: "\\f00e";
}

.fa-search-plus::before {
  content: "\\f00e";
}

.fa-mailbox::before {
  content: "\\f813";
}

.fa-manat-sign::before {
  content: "\\e1d5";
}

.fa-mandolin::before {
  content: "\\f6f9";
}

.fa-mango::before {
  content: "\\e30f";
}

.fa-manhole::before {
  content: "\\e1d6";
}

.fa-map::before {
  content: "\\f279";
}

.fa-map-location::before {
  content: "\\f59f";
}

.fa-map-marked::before {
  content: "\\f59f";
}

.fa-map-location-dot::before {
  content: "\\f5a0";
}

.fa-map-marked-alt::before {
  content: "\\f5a0";
}

.fa-map-pin::before {
  content: "\\f276";
}

.fa-marker::before {
  content: "\\f5a1";
}

.fa-mars::before {
  content: "\\f222";
}

.fa-mars-and-venus::before {
  content: "\\f224";
}

.fa-mars-double::before {
  content: "\\f227";
}

.fa-mars-stroke::before {
  content: "\\f229";
}

.fa-mars-stroke-right::before {
  content: "\\f22b";
}

.fa-mars-stroke-h::before {
  content: "\\f22b";
}

.fa-mars-stroke-up::before {
  content: "\\f22a";
}

.fa-mars-stroke-v::before {
  content: "\\f22a";
}

.fa-martini-glass::before {
  content: "\\f57b";
}

.fa-glass-martini-alt::before {
  content: "\\f57b";
}

.fa-martini-glass-citrus::before {
  content: "\\f561";
}

.fa-cocktail::before {
  content: "\\f561";
}

.fa-martini-glass-empty::before {
  content: "\\f000";
}

.fa-glass-martini::before {
  content: "\\f000";
}

.fa-mask::before {
  content: "\\f6fa";
}

.fa-mask-face::before {
  content: "\\e1d7";
}

.fa-mask-snorkel::before {
  content: "\\e3b7";
}

.fa-masks-theater::before {
  content: "\\f630";
}

.fa-theater-masks::before {
  content: "\\f630";
}

.fa-maximize::before {
  content: "\\f31e";
}

.fa-expand-arrows-alt::before {
  content: "\\f31e";
}

.fa-meat::before {
  content: "\\f814";
}

.fa-medal::before {
  content: "\\f5a2";
}

.fa-megaphone::before {
  content: "\\f675";
}

.fa-melon::before {
  content: "\\e310";
}

.fa-melon-slice::before {
  content: "\\e311";
}

.fa-memo::before {
  content: "\\e1d8";
}

.fa-memo-circle-check::before {
  content: "\\e1d9";
}

.fa-memo-pad::before {
  content: "\\e1da";
}

.fa-memory::before {
  content: "\\f538";
}

.fa-menorah::before {
  content: "\\f676";
}

.fa-mercury::before {
  content: "\\f223";
}

.fa-message::before {
  content: "\\f27a";
}

.fa-comment-alt::before {
  content: "\\f27a";
}

.fa-message-arrow-down::before {
  content: "\\e1db";
}

.fa-comment-alt-arrow-down::before {
  content: "\\e1db";
}

.fa-message-arrow-up::before {
  content: "\\e1dc";
}

.fa-comment-alt-arrow-up::before {
  content: "\\e1dc";
}

.fa-message-arrow-up-right::before {
  content: "\\e1dd";
}

.fa-message-bot::before {
  content: "\\e3b8";
}

.fa-message-captions::before {
  content: "\\e1de";
}

.fa-comment-alt-captions::before {
  content: "\\e1de";
}

.fa-message-check::before {
  content: "\\f4a2";
}

.fa-comment-alt-check::before {
  content: "\\f4a2";
}

.fa-message-code::before {
  content: "\\e1df";
}

.fa-message-dollar::before {
  content: "\\f650";
}

.fa-comment-alt-dollar::before {
  content: "\\f650";
}

.fa-message-dots::before {
  content: "\\f4a3";
}

.fa-comment-alt-dots::before {
  content: "\\f4a3";
}

.fa-messaging::before {
  content: "\\f4a3";
}

.fa-message-exclamation::before {
  content: "\\f4a5";
}

.fa-comment-alt-exclamation::before {
  content: "\\f4a5";
}

.fa-message-image::before {
  content: "\\e1e0";
}

.fa-comment-alt-image::before {
  content: "\\e1e0";
}

.fa-message-lines::before {
  content: "\\f4a6";
}

.fa-comment-alt-lines::before {
  content: "\\f4a6";
}

.fa-message-medical::before {
  content: "\\f7f4";
}

.fa-comment-alt-medical::before {
  content: "\\f7f4";
}

.fa-message-middle::before {
  content: "\\e1e1";
}

.fa-comment-middle-alt::before {
  content: "\\e1e1";
}

.fa-message-middle-top::before {
  content: "\\e1e2";
}

.fa-comment-middle-top-alt::before {
  content: "\\e1e2";
}

.fa-message-minus::before {
  content: "\\f4a7";
}

.fa-comment-alt-minus::before {
  content: "\\f4a7";
}

.fa-message-music::before {
  content: "\\f8af";
}

.fa-comment-alt-music::before {
  content: "\\f8af";
}

.fa-message-pen::before {
  content: "\\f4a4";
}

.fa-comment-alt-edit::before {
  content: "\\f4a4";
}

.fa-message-edit::before {
  content: "\\f4a4";
}

.fa-message-plus::before {
  content: "\\f4a8";
}

.fa-comment-alt-plus::before {
  content: "\\f4a8";
}

.fa-message-question::before {
  content: "\\e1e3";
}

.fa-message-quote::before {
  content: "\\e1e4";
}

.fa-comment-alt-quote::before {
  content: "\\e1e4";
}

.fa-message-slash::before {
  content: "\\f4a9";
}

.fa-comment-alt-slash::before {
  content: "\\f4a9";
}

.fa-message-smile::before {
  content: "\\f4aa";
}

.fa-comment-alt-smile::before {
  content: "\\f4aa";
}

.fa-message-sms::before {
  content: "\\e1e5";
}

.fa-message-text::before {
  content: "\\e1e6";
}

.fa-comment-alt-text::before {
  content: "\\e1e6";
}

.fa-message-xmark::before {
  content: "\\f4ab";
}

.fa-comment-alt-times::before {
  content: "\\f4ab";
}

.fa-message-times::before {
  content: "\\f4ab";
}

.fa-messages::before {
  content: "\\f4b6";
}

.fa-comments-alt::before {
  content: "\\f4b6";
}

.fa-messages-dollar::before {
  content: "\\f652";
}

.fa-comments-alt-dollar::before {
  content: "\\f652";
}

.fa-messages-question::before {
  content: "\\e1e7";
}

.fa-meteor::before {
  content: "\\f753";
}

.fa-meter::before {
  content: "\\e1e8";
}

.fa-meter-bolt::before {
  content: "\\e1e9";
}

.fa-meter-droplet::before {
  content: "\\e1ea";
}

.fa-meter-fire::before {
  content: "\\e1eb";
}

.fa-microchip::before {
  content: "\\f2db";
}

.fa-microchip-ai::before {
  content: "\\e1ec";
}

.fa-microphone::before {
  content: "\\f130";
}

.fa-microphone-lines::before {
  content: "\\f3c9";
}

.fa-microphone-alt::before {
  content: "\\f3c9";
}

.fa-microphone-lines-slash::before {
  content: "\\f539";
}

.fa-microphone-alt-slash::before {
  content: "\\f539";
}

.fa-microphone-slash::before {
  content: "\\f131";
}

.fa-microphone-stand::before {
  content: "\\f8cb";
}

.fa-microscope::before {
  content: "\\f610";
}

.fa-microwave::before {
  content: "\\e01b";
}

.fa-mill-sign::before {
  content: "\\e1ed";
}

.fa-minimize::before {
  content: "\\f78c";
}

.fa-compress-arrows-alt::before {
  content: "\\f78c";
}

.fa-minus::before {
  content: "\\f068";
}

.fa-subtract::before {
  content: "\\f068";
}

.fa-mistletoe::before {
  content: "\\f7b4";
}

.fa-mitten::before {
  content: "\\f7b5";
}

.fa-mobile::before {
  content: "\\f3ce";
}

.fa-mobile-android::before {
  content: "\\f3ce";
}

.fa-mobile-phone::before {
  content: "\\f3ce";
}

.fa-mobile-button::before {
  content: "\\f10b";
}

.fa-mobile-notch::before {
  content: "\\e1ee";
}

.fa-mobile-iphone::before {
  content: "\\e1ee";
}

.fa-mobile-screen::before {
  content: "\\f3cf";
}

.fa-mobile-android-alt::before {
  content: "\\f3cf";
}

.fa-mobile-screen-button::before {
  content: "\\f3cd";
}

.fa-mobile-alt::before {
  content: "\\f3cd";
}

.fa-mobile-signal::before {
  content: "\\e1ef";
}

.fa-mobile-signal-out::before {
  content: "\\e1f0";
}

.fa-money-bill::before {
  content: "\\f0d6";
}

.fa-money-bill-1::before {
  content: "\\f3d1";
}

.fa-money-bill-alt::before {
  content: "\\f3d1";
}

.fa-money-bill-1-wave::before {
  content: "\\f53b";
}

.fa-money-bill-wave-alt::before {
  content: "\\f53b";
}

.fa-money-bill-simple::before {
  content: "\\e1f1";
}

.fa-money-bill-simple-wave::before {
  content: "\\e1f2";
}

.fa-money-bill-wave::before {
  content: "\\f53a";
}

.fa-money-bills::before {
  content: "\\e1f3";
}

.fa-money-bills-simple::before {
  content: "\\e1f4";
}

.fa-money-bills-alt::before {
  content: "\\e1f4";
}

.fa-money-check::before {
  content: "\\f53c";
}

.fa-money-check-dollar::before {
  content: "\\f53d";
}

.fa-money-check-alt::before {
  content: "\\f53d";
}

.fa-money-check-dollar-pen::before {
  content: "\\f873";
}

.fa-money-check-edit-alt::before {
  content: "\\f873";
}

.fa-money-check-pen::before {
  content: "\\f872";
}

.fa-money-check-edit::before {
  content: "\\f872";
}

.fa-money-from-bracket::before {
  content: "\\e312";
}

.fa-money-simple-from-bracket::before {
  content: "\\e313";
}

.fa-monitor-waveform::before {
  content: "\\f611";
}

.fa-monitor-heart-rate::before {
  content: "\\f611";
}

.fa-monkey::before {
  content: "\\f6fb";
}

.fa-monument::before {
  content: "\\f5a6";
}

.fa-moon::before {
  content: "\\f186";
}

.fa-moon-cloud::before {
  content: "\\f754";
}

.fa-moon-over-sun::before {
  content: "\\f74a";
}

.fa-eclipse-alt::before {
  content: "\\f74a";
}

.fa-moon-stars::before {
  content: "\\f755";
}

.fa-moped::before {
  content: "\\e3b9";
}

.fa-mortar-pestle::before {
  content: "\\f5a7";
}

.fa-mosque::before {
  content: "\\f678";
}

.fa-motorcycle::before {
  content: "\\f21c";
}

.fa-mountain::before {
  content: "\\f6fc";
}

.fa-mountains::before {
  content: "\\f6fd";
}

.fa-mp3-player::before {
  content: "\\f8ce";
}

.fa-mug::before {
  content: "\\f874";
}

.fa-mug-hot::before {
  content: "\\f7b6";
}

.fa-mug-marshmallows::before {
  content: "\\f7b7";
}

.fa-mug-saucer::before {
  content: "\\f0f4";
}

.fa-coffee::before {
  content: "\\f0f4";
}

.fa-mug-tea::before {
  content: "\\f875";
}

.fa-mug-tea-saucer::before {
  content: "\\e1f5";
}

.fa-mushroom::before {
  content: "\\e425";
}

.fa-music::before {
  content: "\\f001";
}

.fa-music-note::before {
  content: "\\f8cf";
}

.fa-music-alt::before {
  content: "\\f8cf";
}

.fa-music-note-slash::before {
  content: "\\f8d0";
}

.fa-music-alt-slash::before {
  content: "\\f8d0";
}

.fa-music-slash::before {
  content: "\\f8d1";
}

.fa-n::before {
  content: "N";
}

.fa-naira-sign::before {
  content: "\\e1f6";
}

.fa-narwhal::before {
  content: "\\f6fe";
}

.fa-nesting-dolls::before {
  content: "\\e3ba";
}

.fa-network-wired::before {
  content: "\\f6ff";
}

.fa-neuter::before {
  content: "\\f22c";
}

.fa-newspaper::before {
  content: "\\f1ea";
}

.fa-nfc::before {
  content: "\\e1f7";
}

.fa-nfc-lock::before {
  content: "\\e1f8";
}

.fa-nfc-magnifying-glass::before {
  content: "\\e1f9";
}

.fa-nfc-pen::before {
  content: "\\e1fa";
}

.fa-nfc-signal::before {
  content: "\\e1fb";
}

.fa-nfc-slash::before {
  content: "\\e1fc";
}

.fa-nfc-trash::before {
  content: "\\e1fd";
}

.fa-not-equal::before {
  content: "\\f53e";
}

.fa-notdef::before {
  content: "\\e1fe";
}

.fa-note::before {
  content: "\\e1ff";
}

.fa-note-medical::before {
  content: "\\e200";
}

.fa-note-sticky::before {
  content: "\\f249";
}

.fa-sticky-note::before {
  content: "\\f249";
}

.fa-notebook::before {
  content: "\\e201";
}

.fa-notes::before {
  content: "\\e202";
}

.fa-notes-medical::before {
  content: "\\f481";
}

.fa-o::before {
  content: "O";
}

.fa-object-group::before {
  content: "\\f247";
}

.fa-object-ungroup::before {
  content: "\\f248";
}

.fa-objects-align-bottom::before {
  content: "\\e3bb";
}

.fa-objects-align-center-horizontal::before {
  content: "\\e3bc";
}

.fa-objects-align-center-vertical::before {
  content: "\\e3bd";
}

.fa-objects-align-left::before {
  content: "\\e3be";
}

.fa-objects-align-right::before {
  content: "\\e3bf";
}

.fa-objects-align-top::before {
  content: "\\e3c0";
}

.fa-objects-column::before {
  content: "\\e3c1";
}

.fa-octagon::before {
  content: "\\f306";
}

.fa-octagon-check::before {
  content: "\\e426";
}

.fa-octagon-divide::before {
  content: "\\e203";
}

.fa-octagon-exclamation::before {
  content: "\\e204";
}

.fa-octagon-minus::before {
  content: "\\f308";
}

.fa-minus-octagon::before {
  content: "\\f308";
}

.fa-octagon-plus::before {
  content: "\\f301";
}

.fa-plus-octagon::before {
  content: "\\f301";
}

.fa-octagon-xmark::before {
  content: "\\f2f0";
}

.fa-times-octagon::before {
  content: "\\f2f0";
}

.fa-xmark-octagon::before {
  content: "\\f2f0";
}

.fa-oil-can::before {
  content: "\\f613";
}

.fa-oil-can-drip::before {
  content: "\\e205";
}

.fa-oil-temperature::before {
  content: "\\f614";
}

.fa-oil-temp::before {
  content: "\\f614";
}

.fa-olive::before {
  content: "\\e316";
}

.fa-olive-branch::before {
  content: "\\e317";
}

.fa-om::before {
  content: "\\f679";
}

.fa-omega::before {
  content: "\\f67a";
}

.fa-onion::before {
  content: "\\e427";
}

.fa-option::before {
  content: "\\e318";
}

.fa-ornament::before {
  content: "\\f7b8";
}

.fa-otter::before {
  content: "\\f700";
}

.fa-outdent::before {
  content: "\\f03b";
}

.fa-dedent::before {
  content: "\\f03b";
}

.fa-outlet::before {
  content: "\\e01c";
}

.fa-oven::before {
  content: "\\e01d";
}

.fa-overline::before {
  content: "\\f876";
}

.fa-p::before {
  content: "P";
}

.fa-page::before {
  content: "\\e428";
}

.fa-page-caret-down::before {
  content: "\\e429";
}

.fa-file-caret-down::before {
  content: "\\e429";
}

.fa-page-caret-up::before {
  content: "\\e42a";
}

.fa-file-caret-up::before {
  content: "\\e42a";
}

.fa-pager::before {
  content: "\\f815";
}

.fa-paint-brush::before {
  content: "\\f1fc";
}

.fa-paint-brush-fine::before {
  content: "\\f5a9";
}

.fa-paint-brush-alt::before {
  content: "\\f5a9";
}

.fa-paint-roller::before {
  content: "\\f5aa";
}

.fa-paintbrush-pencil::before {
  content: "\\e206";
}

.fa-palette::before {
  content: "\\f53f";
}

.fa-pallet::before {
  content: "\\f482";
}

.fa-pallet-box::before {
  content: "\\e208";
}

.fa-pallet-boxes::before {
  content: "\\f483";
}

.fa-palette-boxes::before {
  content: "\\f483";
}

.fa-pallet-alt::before {
  content: "\\f483";
}

.fa-pan-food::before {
  content: "\\e42b";
}

.fa-pan-frying::before {
  content: "\\e42c";
}

.fa-pancakes::before {
  content: "\\e42d";
}

.fa-panel-ews::before {
  content: "\\e42e";
}

.fa-panel-fire::before {
  content: "\\e42f";
}

.fa-panorama::before {
  content: "\\e209";
}

.fa-paper-plane::before {
  content: "\\f1d8";
}

.fa-paper-plane-top::before {
  content: "\\e20a";
}

.fa-paper-plane-alt::before {
  content: "\\e20a";
}

.fa-send::before {
  content: "\\e20a";
}

.fa-paperclip::before {
  content: "\\f0c6";
}

.fa-paperclip-vertical::before {
  content: "\\e3c2";
}

.fa-parachute-box::before {
  content: "\\f4cd";
}

.fa-paragraph::before {
  content: "\\f1dd";
}

.fa-paragraph-left::before {
  content: "\\f878";
}

.fa-paragraph-rtl::before {
  content: "\\f878";
}

.fa-party-bell::before {
  content: "\\e31a";
}

.fa-party-horn::before {
  content: "\\e31b";
}

.fa-passport::before {
  content: "\\f5ab";
}

.fa-paste::before {
  content: "\\f0ea";
}

.fa-file-clipboard::before {
  content: "\\f0ea";
}

.fa-pause::before {
  content: "\\f04c";
}

.fa-paw::before {
  content: "\\f1b0";
}

.fa-paw-claws::before {
  content: "\\f702";
}

.fa-paw-simple::before {
  content: "\\f701";
}

.fa-paw-alt::before {
  content: "\\f701";
}

.fa-peace::before {
  content: "\\f67c";
}

.fa-peach::before {
  content: "\\e20b";
}

.fa-peanut::before {
  content: "\\e430";
}

.fa-peanuts::before {
  content: "\\e431";
}

.fa-peapod::before {
  content: "\\e31c";
}

.fa-pear::before {
  content: "\\e20c";
}

.fa-pedestal::before {
  content: "\\e20d";
}

.fa-pegasus::before {
  content: "\\f703";
}

.fa-pen::before {
  content: "\\f304";
}

.fa-pen-circle::before {
  content: "\\e20e";
}

.fa-pen-clip::before {
  content: "\\f305";
}

.fa-pen-alt::before {
  content: "\\f305";
}

.fa-pen-clip-slash::before {
  content: "\\e20f";
}

.fa-pen-alt-slash::before {
  content: "\\e20f";
}

.fa-pen-fancy::before {
  content: "\\f5ac";
}

.fa-pen-fancy-slash::before {
  content: "\\e210";
}

.fa-pen-field::before {
  content: "\\e211";
}

.fa-pen-line::before {
  content: "\\e212";
}

.fa-pen-nib::before {
  content: "\\f5ad";
}

.fa-pen-paintbrush::before {
  content: "\\f618";
}

.fa-pencil-paintbrush::before {
  content: "\\f618";
}

.fa-pen-ruler::before {
  content: "\\f5ae";
}

.fa-pencil-ruler::before {
  content: "\\f5ae";
}

.fa-pen-slash::before {
  content: "\\e213";
}

.fa-pen-swirl::before {
  content: "\\e214";
}

.fa-pen-to-square::before {
  content: "\\f044";
}

.fa-edit::before {
  content: "\\f044";
}

.fa-pencil::before {
  content: "\\f303";
}

.fa-pencil-alt::before {
  content: "\\f303";
}

.fa-pencil-slash::before {
  content: "\\e215";
}

.fa-people::before {
  content: "\\e216";
}

.fa-people-arrows-left-right::before {
  content: "\\e068";
}

.fa-people-arrows::before {
  content: "\\e068";
}

.fa-people-carry-box::before {
  content: "\\f4ce";
}

.fa-people-carry::before {
  content: "\\f4ce";
}

.fa-people-dress::before {
  content: "\\e217";
}

.fa-people-dress-simple::before {
  content: "\\e218";
}

.fa-people-pants::before {
  content: "\\e219";
}

.fa-people-pants-simple::before {
  content: "\\e21a";
}

.fa-people-simple::before {
  content: "\\e21b";
}

.fa-pepper::before {
  content: "\\e432";
}

.fa-pepper-hot::before {
  content: "\\f816";
}

.fa-percent::before {
  content: "\\%";
}

.fa-percentage::before {
  content: "\\%";
}

.fa-period::before {
  content: "\\.";
}

.fa-person::before {
  content: "\\f183";
}

.fa-male::before {
  content: "\\f183";
}

.fa-person-biking::before {
  content: "\\f84a";
}

.fa-biking::before {
  content: "\\f84a";
}

.fa-person-biking-mountain::before {
  content: "\\f84b";
}

.fa-biking-mountain::before {
  content: "\\f84b";
}

.fa-person-booth::before {
  content: "\\f756";
}

.fa-person-carry-box::before {
  content: "\\f4cf";
}

.fa-person-carry::before {
  content: "\\f4cf";
}

.fa-person-digging::before {
  content: "\\f85e";
}

.fa-digging::before {
  content: "\\f85e";
}

.fa-person-dolly::before {
  content: "\\f4d0";
}

.fa-person-dolly-empty::before {
  content: "\\f4d1";
}

.fa-person-dots-from-line::before {
  content: "\\f470";
}

.fa-diagnoses::before {
  content: "\\f470";
}

.fa-person-dress::before {
  content: "\\f182";
}

.fa-female::before {
  content: "\\f182";
}

.fa-person-dress-simple::before {
  content: "\\e21c";
}

.fa-person-from-portal::before {
  content: "\\e023";
}

.fa-portal-exit::before {
  content: "\\e023";
}

.fa-person-hiking::before {
  content: "\\f6ec";
}

.fa-hiking::before {
  content: "\\f6ec";
}

.fa-person-pinball::before {
  content: "\\e21d";
}

.fa-person-praying::before {
  content: "\\f683";
}

.fa-pray::before {
  content: "\\f683";
}

.fa-person-pregnant::before {
  content: "\\e31e";
}

.fa-person-running::before {
  content: "\\f70c";
}

.fa-running::before {
  content: "\\f70c";
}

.fa-person-seat::before {
  content: "\\e21e";
}

.fa-person-seat-reclined::before {
  content: "\\e21f";
}

.fa-person-sign::before {
  content: "\\f757";
}

.fa-person-simple::before {
  content: "\\e220";
}

.fa-person-skating::before {
  content: "\\f7c5";
}

.fa-skating::before {
  content: "\\f7c5";
}

.fa-person-ski-jumping::before {
  content: "\\f7c7";
}

.fa-ski-jump::before {
  content: "\\f7c7";
}

.fa-person-ski-lift::before {
  content: "\\f7c8";
}

.fa-ski-lift::before {
  content: "\\f7c8";
}

.fa-person-skiing::before {
  content: "\\f7c9";
}

.fa-skiing::before {
  content: "\\f7c9";
}

.fa-person-skiing-nordic::before {
  content: "\\f7ca";
}

.fa-skiing-nordic::before {
  content: "\\f7ca";
}

.fa-person-sledding::before {
  content: "\\f7cb";
}

.fa-sledding::before {
  content: "\\f7cb";
}

.fa-person-snowboarding::before {
  content: "\\f7ce";
}

.fa-snowboarding::before {
  content: "\\f7ce";
}

.fa-person-snowmobiling::before {
  content: "\\f7d1";
}

.fa-snowmobile::before {
  content: "\\f7d1";
}

.fa-person-swimming::before {
  content: "\\f5c4";
}

.fa-swimmer::before {
  content: "\\f5c4";
}

.fa-person-to-door::before {
  content: "\\e433";
}

.fa-person-to-portal::before {
  content: "\\e022";
}

.fa-portal-enter::before {
  content: "\\e022";
}

.fa-person-walking::before {
  content: "\\f554";
}

.fa-walking::before {
  content: "\\f554";
}

.fa-person-walking-with-cane::before {
  content: "\\f29d";
}

.fa-blind::before {
  content: "\\f29d";
}

.fa-peseta-sign::before {
  content: "\\e221";
}

.fa-peso-sign::before {
  content: "\\e222";
}

.fa-phone::before {
  content: "\\f095";
}

.fa-phone-arrow-down-left::before {
  content: "\\e223";
}

.fa-phone-arrow-down::before {
  content: "\\e223";
}

.fa-phone-incoming::before {
  content: "\\e223";
}

.fa-phone-arrow-up-right::before {
  content: "\\e224";
}

.fa-phone-arrow-up::before {
  content: "\\e224";
}

.fa-phone-outgoing::before {
  content: "\\e224";
}

.fa-phone-flip::before {
  content: "\\f879";
}

.fa-phone-alt::before {
  content: "\\f879";
}

.fa-phone-hangup::before {
  content: "\\e225";
}

.fa-phone-intercom::before {
  content: "\\e434";
}

.fa-phone-missed::before {
  content: "\\e226";
}

.fa-phone-office::before {
  content: "\\f67d";
}

.fa-phone-plus::before {
  content: "\\f4d2";
}

.fa-phone-rotary::before {
  content: "\\f8d3";
}

.fa-phone-slash::before {
  content: "\\f3dd";
}

.fa-phone-volume::before {
  content: "\\f2a0";
}

.fa-volume-control-phone::before {
  content: "\\f2a0";
}

.fa-phone-xmark::before {
  content: "\\e227";
}

.fa-photo-film::before {
  content: "\\f87c";
}

.fa-photo-video::before {
  content: "\\f87c";
}

.fa-photo-film-music::before {
  content: "\\e228";
}

.fa-pi::before {
  content: "\\f67e";
}

.fa-piano::before {
  content: "\\f8d4";
}

.fa-piano-keyboard::before {
  content: "\\f8d5";
}

.fa-pickleball::before {
  content: "\\e435";
}

.fa-pie::before {
  content: "\\f705";
}

.fa-pig::before {
  content: "\\f706";
}

.fa-piggy-bank::before {
  content: "\\f4d3";
}

.fa-pills::before {
  content: "\\f484";
}

.fa-pinata::before {
  content: "\\e3c3";
}

.fa-pinball::before {
  content: "\\e229";
}

.fa-pineapple::before {
  content: "\\e31f";
}

.fa-pipe::before {
  content: "\\|";
}

.fa-pipe-circle-check::before {
  content: "\\e436";
}

.fa-pipe-collar::before {
  content: "\\e437";
}

.fa-pipe-section::before {
  content: "\\e438";
}

.fa-pipe-smoking::before {
  content: "\\e3c4";
}

.fa-pipe-valve::before {
  content: "\\e439";
}

.fa-pizza::before {
  content: "\\f817";
}

.fa-pizza-slice::before {
  content: "\\f818";
}

.fa-place-of-worship::before {
  content: "\\f67f";
}

.fa-plane::before {
  content: "\\f072";
}

.fa-plane-arrival::before {
  content: "\\f5af";
}

.fa-plane-departure::before {
  content: "\\f5b0";
}

.fa-plane-engines::before {
  content: "\\f3de";
}

.fa-plane-alt::before {
  content: "\\f3de";
}

.fa-plane-prop::before {
  content: "\\e22b";
}

.fa-plane-slash::before {
  content: "\\e069";
}

.fa-plane-tail::before {
  content: "\\e22c";
}

.fa-plane-up::before {
  content: "\\e22d";
}

.fa-plane-up-slash::before {
  content: "\\e22e";
}

.fa-planet-moon::before {
  content: "\\e01f";
}

.fa-planet-ringed::before {
  content: "\\e020";
}

.fa-plate-utensils::before {
  content: "\\e43b";
}

.fa-play::before {
  content: "\\f04b";
}

.fa-play-pause::before {
  content: "\\e22f";
}

.fa-plug::before {
  content: "\\f1e6";
}

.fa-plus::before {
  content: "\\+";
}

.fa-add::before {
  content: "\\+";
}

.fa-plus-minus::before {
  content: "\\e43c";
}

.fa-podcast::before {
  content: "\\f2ce";
}

.fa-podium::before {
  content: "\\f680";
}

.fa-podium-star::before {
  content: "\\f758";
}

.fa-police-box::before {
  content: "\\e021";
}

.fa-poll-people::before {
  content: "\\f759";
}

.fa-pompebled::before {
  content: "\\e43d";
}

.fa-poo::before {
  content: "\\f2fe";
}

.fa-poo-storm::before {
  content: "\\f75a";
}

.fa-poo-bolt::before {
  content: "\\f75a";
}

.fa-pool-8-ball::before {
  content: "\\e3c5";
}

.fa-poop::before {
  content: "\\f619";
}

.fa-popcorn::before {
  content: "\\f819";
}

.fa-popsicle::before {
  content: "\\e43e";
}

.fa-pot-food::before {
  content: "\\e43f";
}

.fa-potato::before {
  content: "\\e440";
}

.fa-power-off::before {
  content: "\\f011";
}

.fa-prescription::before {
  content: "\\f5b1";
}

.fa-prescription-bottle::before {
  content: "\\f485";
}

.fa-prescription-bottle-medical::before {
  content: "\\f486";
}

.fa-prescription-bottle-alt::before {
  content: "\\f486";
}

.fa-presentation-screen::before {
  content: "\\f685";
}

.fa-presentation::before {
  content: "\\f685";
}

.fa-pretzel::before {
  content: "\\e441";
}

.fa-print::before {
  content: "\\f02f";
}

.fa-print-magnifying-glass::before {
  content: "\\f81a";
}

.fa-print-search::before {
  content: "\\f81a";
}

.fa-print-slash::before {
  content: "\\f686";
}

.fa-projector::before {
  content: "\\f8d6";
}

.fa-pump::before {
  content: "\\e442";
}

.fa-pump-medical::before {
  content: "\\e06a";
}

.fa-pump-soap::before {
  content: "\\e06b";
}

.fa-pumpkin::before {
  content: "\\f707";
}

.fa-puzzle::before {
  content: "\\e443";
}

.fa-puzzle-piece::before {
  content: "\\f12e";
}

.fa-puzzle-piece-simple::before {
  content: "\\e231";
}

.fa-puzzle-piece-alt::before {
  content: "\\e231";
}

.fa-q::before {
  content: "Q";
}

.fa-qrcode::before {
  content: "\\f029";
}

.fa-question::before {
  content: "\\?";
}

.fa-quidditch::before {
  content: "\\f458";
}

.fa-broom-ball::before {
  content: "\\f458";
}

.fa-quidditch-broom-ball::before {
  content: "\\f458";
}

.fa-quote-left::before {
  content: "\\f10d";
}

.fa-quote-left-alt::before {
  content: "\\f10d";
}

.fa-quote-right::before {
  content: "\\f10e";
}

.fa-quote-right-alt::before {
  content: "\\f10e";
}

.fa-quotes::before {
  content: "\\e234";
}

.fa-r::before {
  content: "R";
}

.fa-rabbit::before {
  content: "\\f708";
}

.fa-rabbit-running::before {
  content: "\\f709";
}

.fa-rabbit-fast::before {
  content: "\\f709";
}

.fa-racquet::before {
  content: "\\f45a";
}

.fa-radar::before {
  content: "\\e024";
}

.fa-radiation::before {
  content: "\\f7b9";
}

.fa-radio::before {
  content: "\\f8d7";
}

.fa-radio-tuner::before {
  content: "\\f8d8";
}

.fa-radio-alt::before {
  content: "\\f8d8";
}

.fa-rainbow::before {
  content: "\\f75b";
}

.fa-raindrops::before {
  content: "\\f75c";
}

.fa-ram::before {
  content: "\\f70a";
}

.fa-ramp-loading::before {
  content: "\\f4d4";
}

.fa-raygun::before {
  content: "\\e025";
}

.fa-receipt::before {
  content: "\\f543";
}

.fa-record-vinyl::before {
  content: "\\f8d9";
}

.fa-rectangle::before {
  content: "\\f2fa";
}

.fa-rectangle-landscape::before {
  content: "\\f2fa";
}

.fa-rectangle-ad::before {
  content: "\\f641";
}

.fa-ad::before {
  content: "\\f641";
}

.fa-rectangle-barcode::before {
  content: "\\f463";
}

.fa-barcode-alt::before {
  content: "\\f463";
}

.fa-rectangle-code::before {
  content: "\\e322";
}

.fa-rectangle-list::before {
  content: "\\f022";
}

.fa-list-alt::before {
  content: "\\f022";
}

.fa-rectangle-pro::before {
  content: "\\e235";
}

.fa-pro::before {
  content: "\\e235";
}

.fa-rectangle-terminal::before {
  content: "\\e236";
}

.fa-rectangle-vertical::before {
  content: "\\f2fb";
}

.fa-rectangle-portrait::before {
  content: "\\f2fb";
}

.fa-rectangle-vertical-history::before {
  content: "\\e237";
}

.fa-rectangle-wide::before {
  content: "\\f2fc";
}

.fa-rectangle-xmark::before {
  content: "\\f410";
}

.fa-rectangle-times::before {
  content: "\\f410";
}

.fa-times-rectangle::before {
  content: "\\f410";
}

.fa-window-close::before {
  content: "\\f410";
}

.fa-rectangles-mixed::before {
  content: "\\e323";
}

.fa-recycle::before {
  content: "\\f1b8";
}

.fa-reel::before {
  content: "\\e238";
}

.fa-refrigerator::before {
  content: "\\e026";
}

.fa-registered::before {
  content: "\\f25d";
}

.fa-repeat::before {
  content: "\\f363";
}

.fa-repeat-1::before {
  content: "\\f365";
}

.fa-reply::before {
  content: "\\f3e5";
}

.fa-mail-reply::before {
  content: "\\f3e5";
}

.fa-reply-all::before {
  content: "\\f122";
}

.fa-mail-reply-all::before {
  content: "\\f122";
}

.fa-reply-clock::before {
  content: "\\e239";
}

.fa-reply-time::before {
  content: "\\e239";
}

.fa-republican::before {
  content: "\\f75e";
}

.fa-restroom::before {
  content: "\\f7bd";
}

.fa-restroom-simple::before {
  content: "\\e23a";
}

.fa-retweet::before {
  content: "\\f079";
}

.fa-rhombus::before {
  content: "\\e23b";
}

.fa-ribbon::before {
  content: "\\f4d6";
}

.fa-right::before {
  content: "\\f356";
}

.fa-arrow-alt-right::before {
  content: "\\f356";
}

.fa-right-from-bracket::before {
  content: "\\f2f5";
}

.fa-sign-out-alt::before {
  content: "\\f2f5";
}

.fa-right-from-line::before {
  content: "\\f347";
}

.fa-arrow-alt-from-left::before {
  content: "\\f347";
}

.fa-right-left::before {
  content: "\\f362";
}

.fa-exchange-alt::before {
  content: "\\f362";
}

.fa-right-long::before {
  content: "\\f30b";
}

.fa-long-arrow-alt-right::before {
  content: "\\f30b";
}

.fa-right-long-to-line::before {
  content: "\\e444";
}

.fa-right-to-bracket::before {
  content: "\\f2f6";
}

.fa-sign-in-alt::before {
  content: "\\f2f6";
}

.fa-right-to-line::before {
  content: "\\f34c";
}

.fa-arrow-alt-to-right::before {
  content: "\\f34c";
}

.fa-ring::before {
  content: "\\f70b";
}

.fa-rings-wedding::before {
  content: "\\f81b";
}

.fa-road::before {
  content: "\\f018";
}

.fa-robot::before {
  content: "\\f544";
}

.fa-robot-astromech::before {
  content: "\\e2d2";
}

.fa-rocket::before {
  content: "\\f135";
}

.fa-rocket-launch::before {
  content: "\\e027";
}

.fa-roller-coaster::before {
  content: "\\e324";
}

.fa-rotate::before {
  content: "\\f2f1";
}

.fa-sync-alt::before {
  content: "\\f2f1";
}

.fa-rotate-exclamation::before {
  content: "\\e23c";
}

.fa-rotate-left::before {
  content: "\\f2ea";
}

.fa-rotate-back::before {
  content: "\\f2ea";
}

.fa-rotate-backward::before {
  content: "\\f2ea";
}

.fa-undo-alt::before {
  content: "\\f2ea";
}

.fa-rotate-right::before {
  content: "\\f2f9";
}

.fa-redo-alt::before {
  content: "\\f2f9";
}

.fa-rotate-forward::before {
  content: "\\f2f9";
}

.fa-route::before {
  content: "\\f4d7";
}

.fa-route-highway::before {
  content: "\\f61a";
}

.fa-route-interstate::before {
  content: "\\f61b";
}

.fa-router::before {
  content: "\\f8da";
}

.fa-rss::before {
  content: "\\f09e";
}

.fa-feed::before {
  content: "\\f09e";
}

.fa-ruble-sign::before {
  content: "\\f158";
}

.fa-rouble::before {
  content: "\\f158";
}

.fa-rub::before {
  content: "\\f158";
}

.fa-ruble::before {
  content: "\\f158";
}

.fa-rugby-ball::before {
  content: "\\e3c6";
}

.fa-ruler::before {
  content: "\\f545";
}

.fa-ruler-combined::before {
  content: "\\f546";
}

.fa-ruler-horizontal::before {
  content: "\\f547";
}

.fa-ruler-triangle::before {
  content: "\\f61c";
}

.fa-ruler-vertical::before {
  content: "\\f548";
}

.fa-rupee-sign::before {
  content: "\\f156";
}

.fa-rupee::before {
  content: "\\f156";
}

.fa-rupiah-sign::before {
  content: "\\e23d";
}

.fa-rv::before {
  content: "\\f7be";
}

.fa-s::before {
  content: "S";
}

.fa-sack::before {
  content: "\\f81c";
}

.fa-sack-dollar::before {
  content: "\\f81d";
}

.fa-sailboat::before {
  content: "\\e445";
}

.fa-salad::before {
  content: "\\f81e";
}

.fa-bowl-salad::before {
  content: "\\f81e";
}

.fa-salt-shaker::before {
  content: "\\e446";
}

.fa-sandwich::before {
  content: "\\f81f";
}

.fa-satellite::before {
  content: "\\f7bf";
}

.fa-satellite-dish::before {
  content: "\\f7c0";
}

.fa-sausage::before {
  content: "\\f820";
}

.fa-saxophone::before {
  content: "\\f8dc";
}

.fa-saxophone-fire::before {
  content: "\\f8db";
}

.fa-sax-hot::before {
  content: "\\f8db";
}

.fa-scale-balanced::before {
  content: "\\f24e";
}

.fa-balance-scale::before {
  content: "\\f24e";
}

.fa-scale-unbalanced::before {
  content: "\\f515";
}

.fa-balance-scale-left::before {
  content: "\\f515";
}

.fa-scale-unbalanced-flip::before {
  content: "\\f516";
}

.fa-balance-scale-right::before {
  content: "\\f516";
}

.fa-scalpel::before {
  content: "\\f61d";
}

.fa-scalpel-line-dashed::before {
  content: "\\f61e";
}

.fa-scalpel-path::before {
  content: "\\f61e";
}

.fa-scanner::before {
  content: "\\f8f3";
}

.fa-scanner-image::before {
  content: "\\f8f3";
}

.fa-scanner-gun::before {
  content: "\\f488";
}

.fa-scanner-keyboard::before {
  content: "\\f489";
}

.fa-scanner-touchscreen::before {
  content: "\\f48a";
}

.fa-scarecrow::before {
  content: "\\f70d";
}

.fa-scarf::before {
  content: "\\f7c1";
}

.fa-school::before {
  content: "\\f549";
}

.fa-scissors::before {
  content: "\\f0c4";
}

.fa-cut::before {
  content: "\\f0c4";
}

.fa-screen-users::before {
  content: "\\f63d";
}

.fa-users-class::before {
  content: "\\f63d";
}

.fa-screencast::before {
  content: "\\e23e";
}

.fa-screwdriver::before {
  content: "\\f54a";
}

.fa-screwdriver-wrench::before {
  content: "\\f7d9";
}

.fa-tools::before {
  content: "\\f7d9";
}

.fa-scribble::before {
  content: "\\e23f";
}

.fa-scroll::before {
  content: "\\f70e";
}

.fa-scroll-old::before {
  content: "\\f70f";
}

.fa-scroll-torah::before {
  content: "\\f6a0";
}

.fa-torah::before {
  content: "\\f6a0";
}

.fa-scrubber::before {
  content: "\\f2f8";
}

.fa-scythe::before {
  content: "\\f710";
}

.fa-sd-card::before {
  content: "\\f7c2";
}

.fa-sd-cards::before {
  content: "\\e240";
}

.fa-seal::before {
  content: "\\e241";
}

.fa-seal-exclamation::before {
  content: "\\e242";
}

.fa-seal-question::before {
  content: "\\e243";
}

.fa-seat-airline::before {
  content: "\\e244";
}

.fa-section::before {
  content: "\\e447";
}

.fa-seedling::before {
  content: "\\f4d8";
}

.fa-sprout::before {
  content: "\\f4d8";
}

.fa-semicolon::before {
  content: "\\;";
}

.fa-send-back::before {
  content: "\\f87e";
}

.fa-send-backward::before {
  content: "\\f87f";
}

.fa-sensor::before {
  content: "\\e028";
}

.fa-sensor-cloud::before {
  content: "\\e02c";
}

.fa-sensor-smoke::before {
  content: "\\e02c";
}

.fa-sensor-fire::before {
  content: "\\e02a";
}

.fa-sensor-on::before {
  content: "\\e02b";
}

.fa-sensor-triangle-exclamation::before {
  content: "\\e029";
}

.fa-sensor-alert::before {
  content: "\\e029";
}

.fa-server::before {
  content: "\\f233";
}

.fa-shapes::before {
  content: "\\f61f";
}

.fa-triangle-circle-square::before {
  content: "\\f61f";
}

.fa-share::before {
  content: "\\f064";
}

.fa-arrow-turn-right::before {
  content: "\\f064";
}

.fa-mail-forward::before {
  content: "\\f064";
}

.fa-share-all::before {
  content: "\\f367";
}

.fa-arrows-turn-right::before {
  content: "\\f367";
}

.fa-share-from-square::before {
  content: "\\f14d";
}

.fa-share-square::before {
  content: "\\f14d";
}

.fa-share-nodes::before {
  content: "\\f1e0";
}

.fa-share-alt::before {
  content: "\\f1e0";
}

.fa-sheep::before {
  content: "\\f711";
}

.fa-shekel-sign::before {
  content: "\\f20b";
}

.fa-ils::before {
  content: "\\f20b";
}

.fa-shekel::before {
  content: "\\f20b";
}

.fa-sheqel::before {
  content: "\\f20b";
}

.fa-sheqel-sign::before {
  content: "\\f20b";
}

.fa-shelves::before {
  content: "\\f480";
}

.fa-inventory::before {
  content: "\\f480";
}

.fa-shelves-empty::before {
  content: "\\e246";
}

.fa-shield::before {
  content: "\\f132";
}

.fa-shield-blank::before {
  content: "\\f3ed";
}

.fa-shield-alt::before {
  content: "\\f3ed";
}

.fa-shield-check::before {
  content: "\\f2f7";
}

.fa-shield-cross::before {
  content: "\\f712";
}

.fa-shield-exclamation::before {
  content: "\\e247";
}

.fa-shield-keyhole::before {
  content: "\\e248";
}

.fa-shield-minus::before {
  content: "\\e249";
}

.fa-shield-plus::before {
  content: "\\e24a";
}

.fa-shield-slash::before {
  content: "\\e24b";
}

.fa-shield-virus::before {
  content: "\\e06c";
}

.fa-shield-xmark::before {
  content: "\\e24c";
}

.fa-shield-times::before {
  content: "\\e24c";
}

.fa-ship::before {
  content: "\\f21a";
}

.fa-shirt::before {
  content: "\\f553";
}

.fa-t-shirt::before {
  content: "\\f553";
}

.fa-tshirt::before {
  content: "\\f553";
}

.fa-shirt-long-sleeve::before {
  content: "\\e3c7";
}

.fa-shirt-running::before {
  content: "\\e3c8";
}

.fa-shirt-tank-top::before {
  content: "\\e3c9";
}

.fa-shish-kebab::before {
  content: "\\f821";
}

.fa-shoe-prints::before {
  content: "\\f54b";
}

.fa-shop::before {
  content: "\\f54f";
}

.fa-store-alt::before {
  content: "\\f54f";
}

.fa-shop-slash::before {
  content: "\\e070";
}

.fa-store-alt-slash::before {
  content: "\\e070";
}

.fa-shovel::before {
  content: "\\f713";
}

.fa-shovel-snow::before {
  content: "\\f7c3";
}

.fa-shower::before {
  content: "\\f2cc";
}

.fa-shower-down::before {
  content: "\\e24d";
}

.fa-shower-alt::before {
  content: "\\e24d";
}

.fa-shredder::before {
  content: "\\f68a";
}

.fa-shrimp::before {
  content: "\\e448";
}

.fa-shuffle::before {
  content: "\\f074";
}

.fa-random::before {
  content: "\\f074";
}

.fa-shutters::before {
  content: "\\e449";
}

.fa-shuttle-space::before {
  content: "\\f197";
}

.fa-space-shuttle::before {
  content: "\\f197";
}

.fa-shuttlecock::before {
  content: "\\f45b";
}

.fa-sickle::before {
  content: "\\f822";
}

.fa-sidebar::before {
  content: "\\e24e";
}

.fa-sidebar-flip::before {
  content: "\\e24f";
}

.fa-sigma::before {
  content: "\\f68b";
}

.fa-sign-hanging::before {
  content: "\\f4d9";
}

.fa-sign::before {
  content: "\\f4d9";
}

.fa-signal::before {
  content: "\\f012";
}

.fa-signal-5::before {
  content: "\\f012";
}

.fa-signal-perfect::before {
  content: "\\f012";
}

.fa-signal-bars::before {
  content: "\\f690";
}

.fa-signal-alt::before {
  content: "\\f690";
}

.fa-signal-alt-4::before {
  content: "\\f690";
}

.fa-signal-bars-strong::before {
  content: "\\f690";
}

.fa-signal-bars-fair::before {
  content: "\\f692";
}

.fa-signal-alt-2::before {
  content: "\\f692";
}

.fa-signal-bars-good::before {
  content: "\\f693";
}

.fa-signal-alt-3::before {
  content: "\\f693";
}

.fa-signal-bars-slash::before {
  content: "\\f694";
}

.fa-signal-alt-slash::before {
  content: "\\f694";
}

.fa-signal-bars-weak::before {
  content: "\\f691";
}

.fa-signal-alt-1::before {
  content: "\\f691";
}

.fa-signal-fair::before {
  content: "\\f68d";
}

.fa-signal-2::before {
  content: "\\f68d";
}

.fa-signal-good::before {
  content: "\\f68e";
}

.fa-signal-3::before {
  content: "\\f68e";
}

.fa-signal-slash::before {
  content: "\\f695";
}

.fa-signal-stream::before {
  content: "\\f8dd";
}

.fa-signal-stream-slash::before {
  content: "\\e250";
}

.fa-signal-strong::before {
  content: "\\f68f";
}

.fa-signal-4::before {
  content: "\\f68f";
}

.fa-signal-weak::before {
  content: "\\f68c";
}

.fa-signal-1::before {
  content: "\\f68c";
}

.fa-signature::before {
  content: "\\f5b7";
}

.fa-signature-lock::before {
  content: "\\e3ca";
}

.fa-signature-slash::before {
  content: "\\e3cb";
}

.fa-signs-post::before {
  content: "\\f277";
}

.fa-map-signs::before {
  content: "\\f277";
}

.fa-sim-card::before {
  content: "\\f7c4";
}

.fa-sim-cards::before {
  content: "\\e251";
}

.fa-sink::before {
  content: "\\e06d";
}

.fa-siren::before {
  content: "\\e02d";
}

.fa-siren-on::before {
  content: "\\e02e";
}

.fa-sitemap::before {
  content: "\\f0e8";
}

.fa-skeleton::before {
  content: "\\f620";
}

.fa-ski-boot::before {
  content: "\\e3cc";
}

.fa-ski-boot-ski::before {
  content: "\\e3cd";
}

.fa-skull::before {
  content: "\\f54c";
}

.fa-skull-cow::before {
  content: "\\f8de";
}

.fa-skull-crossbones::before {
  content: "\\f714";
}

.fa-slash::before {
  content: "\\f715";
}

.fa-slash-back::before {
  content: "\\\\";
}

.fa-slash-forward::before {
  content: "\\/";
}

.fa-sleigh::before {
  content: "\\f7cc";
}

.fa-slider::before {
  content: "\\e252";
}

.fa-sliders::before {
  content: "\\f1de";
}

.fa-sliders-h::before {
  content: "\\f1de";
}

.fa-sliders-simple::before {
  content: "\\e253";
}

.fa-sliders-up::before {
  content: "\\f3f1";
}

.fa-sliders-v::before {
  content: "\\f3f1";
}

.fa-slot-machine::before {
  content: "\\e3ce";
}

.fa-smog::before {
  content: "\\f75f";
}

.fa-smoke::before {
  content: "\\f760";
}

.fa-smoking::before {
  content: "\\f48d";
}

.fa-snake::before {
  content: "\\f716";
}

.fa-snooze::before {
  content: "\\f880";
}

.fa-zzz::before {
  content: "\\f880";
}

.fa-snow-blowing::before {
  content: "\\f761";
}

.fa-snowflake::before {
  content: "\\f2dc";
}

.fa-snowflakes::before {
  content: "\\f7cf";
}

.fa-snowman::before {
  content: "\\f7d0";
}

.fa-snowman-head::before {
  content: "\\f79b";
}

.fa-frosty-head::before {
  content: "\\f79b";
}

.fa-snowplow::before {
  content: "\\f7d2";
}

.fa-soap::before {
  content: "\\e06e";
}

.fa-socks::before {
  content: "\\f696";
}

.fa-solar-panel::before {
  content: "\\f5ba";
}

.fa-solar-system::before {
  content: "\\e02f";
}

.fa-sort::before {
  content: "\\f0dc";
}

.fa-unsorted::before {
  content: "\\f0dc";
}

.fa-sort-down::before {
  content: "\\f0dd";
}

.fa-sort-desc::before {
  content: "\\f0dd";
}

.fa-sort-up::before {
  content: "\\f0de";
}

.fa-sort-asc::before {
  content: "\\f0de";
}

.fa-spa::before {
  content: "\\f5bb";
}

.fa-space-station-moon::before {
  content: "\\e033";
}

.fa-space-station-moon-construction::before {
  content: "\\e034";
}

.fa-space-station-moon-alt::before {
  content: "\\e034";
}

.fa-spade::before {
  content: "\\f2f4";
}

.fa-spaghetti-monster-flying::before {
  content: "\\f67b";
}

.fa-pastafarianism::before {
  content: "\\f67b";
}

.fa-sparkles::before {
  content: "\\f890";
}

.fa-speaker::before {
  content: "\\f8df";
}

.fa-speakers::before {
  content: "\\f8e0";
}

.fa-spell-check::before {
  content: "\\f891";
}

.fa-spider::before {
  content: "\\f717";
}

.fa-spider-black-widow::before {
  content: "\\f718";
}

.fa-spider-web::before {
  content: "\\f719";
}

.fa-spinner::before {
  content: "\\f110";
}

.fa-spinner-third::before {
  content: "\\f3f4";
}

.fa-split::before {
  content: "\\e254";
}

.fa-splotch::before {
  content: "\\f5bc";
}

.fa-spoon::before {
  content: "\\f2e5";
}

.fa-utensil-spoon::before {
  content: "\\f2e5";
}

.fa-sportsball::before {
  content: "\\e44b";
}

.fa-spray-can::before {
  content: "\\f5bd";
}

.fa-spray-can-sparkles::before {
  content: "\\f5d0";
}

.fa-air-freshener::before {
  content: "\\f5d0";
}

.fa-sprinkler::before {
  content: "\\e035";
}

.fa-sprinkler-ceiling::before {
  content: "\\e44c";
}

.fa-square::before {
  content: "\\f0c8";
}

.fa-square-0::before {
  content: "\\e255";
}

.fa-square-1::before {
  content: "\\e256";
}

.fa-square-2::before {
  content: "\\e257";
}

.fa-square-3::before {
  content: "\\e258";
}

.fa-square-4::before {
  content: "\\e259";
}

.fa-square-5::before {
  content: "\\e25a";
}

.fa-square-6::before {
  content: "\\e25b";
}

.fa-square-7::before {
  content: "\\e25c";
}

.fa-square-8::before {
  content: "\\e25d";
}

.fa-square-9::before {
  content: "\\e25e";
}

.fa-square-a::before {
  content: "\\e25f";
}

.fa-square-a-lock::before {
  content: "\\e44d";
}

.fa-square-ampersand::before {
  content: "\\e260";
}

.fa-square-arrow-down::before {
  content: "\\f339";
}

.fa-arrow-square-down::before {
  content: "\\f339";
}

.fa-square-arrow-down-left::before {
  content: "\\e261";
}

.fa-square-arrow-down-right::before {
  content: "\\e262";
}

.fa-square-arrow-left::before {
  content: "\\f33a";
}

.fa-arrow-square-left::before {
  content: "\\f33a";
}

.fa-square-arrow-right::before {
  content: "\\f33b";
}

.fa-arrow-square-right::before {
  content: "\\f33b";
}

.fa-square-arrow-up::before {
  content: "\\f33c";
}

.fa-arrow-square-up::before {
  content: "\\f33c";
}

.fa-square-arrow-up-left::before {
  content: "\\e263";
}

.fa-square-arrow-up-right::before {
  content: "\\f14c";
}

.fa-external-link-square::before {
  content: "\\f14c";
}

.fa-square-b::before {
  content: "\\e264";
}

.fa-square-bolt::before {
  content: "\\e265";
}

.fa-square-c::before {
  content: "\\e266";
}

.fa-square-caret-down::before {
  content: "\\f150";
}

.fa-caret-square-down::before {
  content: "\\f150";
}

.fa-square-caret-left::before {
  content: "\\f191";
}

.fa-caret-square-left::before {
  content: "\\f191";
}

.fa-square-caret-right::before {
  content: "\\f152";
}

.fa-caret-square-right::before {
  content: "\\f152";
}

.fa-square-caret-up::before {
  content: "\\f151";
}

.fa-caret-square-up::before {
  content: "\\f151";
}

.fa-square-check::before {
  content: "\\f14a";
}

.fa-check-square::before {
  content: "\\f14a";
}

.fa-square-chevron-down::before {
  content: "\\f329";
}

.fa-chevron-square-down::before {
  content: "\\f329";
}

.fa-square-chevron-left::before {
  content: "\\f32a";
}

.fa-chevron-square-left::before {
  content: "\\f32a";
}

.fa-square-chevron-right::before {
  content: "\\f32b";
}

.fa-chevron-square-right::before {
  content: "\\f32b";
}

.fa-square-chevron-up::before {
  content: "\\f32c";
}

.fa-chevron-square-up::before {
  content: "\\f32c";
}

.fa-square-code::before {
  content: "\\e267";
}

.fa-square-d::before {
  content: "\\e268";
}

.fa-square-dashed::before {
  content: "\\e269";
}

.fa-square-divide::before {
  content: "\\e26a";
}

.fa-square-dollar::before {
  content: "\\f2e9";
}

.fa-dollar-square::before {
  content: "\\f2e9";
}

.fa-usd-square::before {
  content: "\\f2e9";
}

.fa-square-down::before {
  content: "\\f350";
}

.fa-arrow-alt-square-down::before {
  content: "\\f350";
}

.fa-square-down-left::before {
  content: "\\e26b";
}

.fa-square-down-right::before {
  content: "\\e26c";
}

.fa-square-e::before {
  content: "\\e26d";
}

.fa-square-ellipsis::before {
  content: "\\e26e";
}

.fa-square-ellipsis-vertical::before {
  content: "\\e26f";
}

.fa-square-envelope::before {
  content: "\\f199";
}

.fa-envelope-square::before {
  content: "\\f199";
}

.fa-square-exclamation::before {
  content: "\\f321";
}

.fa-exclamation-square::before {
  content: "\\f321";
}

.fa-square-f::before {
  content: "\\e270";
}

.fa-square-fragile::before {
  content: "\\f49b";
}

.fa-box-fragile::before {
  content: "\\f49b";
}

.fa-square-wine-glass-crack::before {
  content: "\\f49b";
}

.fa-square-full::before {
  content: "\\f45c";
}

.fa-square-g::before {
  content: "\\e271";
}

.fa-square-h::before {
  content: "\\f0fd";
}

.fa-h-square::before {
  content: "\\f0fd";
}

.fa-square-heart::before {
  content: "\\f4c8";
}

.fa-heart-square::before {
  content: "\\f4c8";
}

.fa-square-i::before {
  content: "\\e272";
}

.fa-square-info::before {
  content: "\\f30f";
}

.fa-info-square::before {
  content: "\\f30f";
}

.fa-square-j::before {
  content: "\\e273";
}

.fa-square-k::before {
  content: "\\e274";
}

.fa-square-l::before {
  content: "\\e275";
}

.fa-square-left::before {
  content: "\\f351";
}

.fa-arrow-alt-square-left::before {
  content: "\\f351";
}

.fa-square-m::before {
  content: "\\e276";
}

.fa-square-minus::before {
  content: "\\f146";
}

.fa-minus-square::before {
  content: "\\f146";
}

.fa-square-n::before {
  content: "\\e277";
}

.fa-square-o::before {
  content: "\\e278";
}

.fa-square-p::before {
  content: "\\e279";
}

.fa-square-parking::before {
  content: "\\f540";
}

.fa-parking::before {
  content: "\\f540";
}

.fa-square-parking-slash::before {
  content: "\\f617";
}

.fa-parking-slash::before {
  content: "\\f617";
}

.fa-square-pen::before {
  content: "\\f14b";
}

.fa-pen-square::before {
  content: "\\f14b";
}

.fa-pencil-square::before {
  content: "\\f14b";
}

.fa-square-phone::before {
  content: "\\f098";
}

.fa-phone-square::before {
  content: "\\f098";
}

.fa-square-phone-flip::before {
  content: "\\f87b";
}

.fa-phone-square-alt::before {
  content: "\\f87b";
}

.fa-square-phone-hangup::before {
  content: "\\e27a";
}

.fa-phone-square-down::before {
  content: "\\e27a";
}

.fa-square-plus::before {
  content: "\\f0fe";
}

.fa-plus-square::before {
  content: "\\f0fe";
}

.fa-square-poll-horizontal::before {
  content: "\\f682";
}

.fa-poll-h::before {
  content: "\\f682";
}

.fa-square-poll-vertical::before {
  content: "\\f681";
}

.fa-poll::before {
  content: "\\f681";
}

.fa-square-q::before {
  content: "\\e27b";
}

.fa-square-quarters::before {
  content: "\\e44e";
}

.fa-square-question::before {
  content: "\\f2fd";
}

.fa-question-square::before {
  content: "\\f2fd";
}

.fa-square-quote::before {
  content: "\\e329";
}

.fa-square-r::before {
  content: "\\e27c";
}

.fa-square-right::before {
  content: "\\f352";
}

.fa-arrow-alt-square-right::before {
  content: "\\f352";
}

.fa-square-ring::before {
  content: "\\e44f";
}

.fa-square-root::before {
  content: "\\f697";
}

.fa-square-root-variable::before {
  content: "\\f698";
}

.fa-square-root-alt::before {
  content: "\\f698";
}

.fa-square-rss::before {
  content: "\\f143";
}

.fa-rss-square::before {
  content: "\\f143";
}

.fa-square-s::before {
  content: "\\e27d";
}

.fa-square-share-nodes::before {
  content: "\\f1e1";
}

.fa-share-alt-square::before {
  content: "\\f1e1";
}

.fa-square-sliders::before {
  content: "\\f3f0";
}

.fa-sliders-h-square::before {
  content: "\\f3f0";
}

.fa-square-sliders-vertical::before {
  content: "\\f3f2";
}

.fa-sliders-v-square::before {
  content: "\\f3f2";
}

.fa-square-small::before {
  content: "\\e27e";
}

.fa-square-star::before {
  content: "\\e27f";
}

.fa-square-t::before {
  content: "\\e280";
}

.fa-square-terminal::before {
  content: "\\e32a";
}

.fa-square-this-way-up::before {
  content: "\\f49f";
}

.fa-box-up::before {
  content: "\\f49f";
}

.fa-square-u::before {
  content: "\\e281";
}

.fa-square-up::before {
  content: "\\f353";
}

.fa-arrow-alt-square-up::before {
  content: "\\f353";
}

.fa-square-up-left::before {
  content: "\\e282";
}

.fa-square-up-right::before {
  content: "\\f360";
}

.fa-external-link-square-alt::before {
  content: "\\f360";
}

.fa-square-user::before {
  content: "\\e283";
}

.fa-square-v::before {
  content: "\\e284";
}

.fa-square-w::before {
  content: "\\e285";
}

.fa-square-x::before {
  content: "\\e286";
}

.fa-square-xmark::before {
  content: "\\f2d3";
}

.fa-times-square::before {
  content: "\\f2d3";
}

.fa-xmark-square::before {
  content: "\\f2d3";
}

.fa-square-y::before {
  content: "\\e287";
}

.fa-square-z::before {
  content: "\\e288";
}

.fa-squid::before {
  content: "\\e450";
}

.fa-squirrel::before {
  content: "\\f71a";
}

.fa-staff::before {
  content: "\\f71b";
}

.fa-stairs::before {
  content: "\\e289";
}

.fa-stamp::before {
  content: "\\f5bf";
}

.fa-standard-definition::before {
  content: "\\e28a";
}

.fa-rectangle-sd::before {
  content: "\\e28a";
}

.fa-star::before {
  content: "\\f005";
}

.fa-star-and-crescent::before {
  content: "\\f699";
}

.fa-star-christmas::before {
  content: "\\f7d4";
}

.fa-star-exclamation::before {
  content: "\\f2f3";
}

.fa-star-half::before {
  content: "\\f089";
}

.fa-star-half-stroke::before {
  content: "\\f5c0";
}

.fa-star-half-alt::before {
  content: "\\f5c0";
}

.fa-star-of-david::before {
  content: "\\f69a";
}

.fa-star-of-life::before {
  content: "\\f621";
}

.fa-star-sharp::before {
  content: "\\e28b";
}

.fa-star-sharp-half::before {
  content: "\\e28c";
}

.fa-star-sharp-half-stroke::before {
  content: "\\e28d";
}

.fa-star-sharp-half-alt::before {
  content: "\\e28d";
}

.fa-star-shooting::before {
  content: "\\e036";
}

.fa-starfighter::before {
  content: "\\e037";
}

.fa-starfighter-twin-ion-engine::before {
  content: "\\e038";
}

.fa-starfighter-alt::before {
  content: "\\e038";
}

.fa-starfighter-twin-ion-engine-advanced::before {
  content: "\\e28e";
}

.fa-starfighter-alt-advanced::before {
  content: "\\e28e";
}

.fa-stars::before {
  content: "\\f762";
}

.fa-starship::before {
  content: "\\e039";
}

.fa-starship-freighter::before {
  content: "\\e03a";
}

.fa-steak::before {
  content: "\\f824";
}

.fa-steering-wheel::before {
  content: "\\f622";
}

.fa-sterling-sign::before {
  content: "\\f154";
}

.fa-gbp::before {
  content: "\\f154";
}

.fa-pound-sign::before {
  content: "\\f154";
}

.fa-stethoscope::before {
  content: "\\f0f1";
}

.fa-stocking::before {
  content: "\\f7d5";
}

.fa-stomach::before {
  content: "\\f623";
}

.fa-stop::before {
  content: "\\f04d";
}

.fa-stopwatch::before {
  content: "\\f2f2";
}

.fa-stopwatch-20::before {
  content: "\\e06f";
}

.fa-store::before {
  content: "\\f54e";
}

.fa-store-slash::before {
  content: "\\e071";
}

.fa-strawberry::before {
  content: "\\e32b";
}

.fa-street-view::before {
  content: "\\f21d";
}

.fa-stretcher::before {
  content: "\\f825";
}

.fa-strikethrough::before {
  content: "\\f0cc";
}

.fa-stroopwafel::before {
  content: "\\f551";
}

.fa-subscript::before {
  content: "\\f12c";
}

.fa-suitcase::before {
  content: "\\f0f2";
}

.fa-suitcase-medical::before {
  content: "\\f0fa";
}

.fa-medkit::before {
  content: "\\f0fa";
}

.fa-suitcase-rolling::before {
  content: "\\f5c1";
}

.fa-sun::before {
  content: "\\f185";
}

.fa-sun-bright::before {
  content: "\\e28f";
}

.fa-sun-alt::before {
  content: "\\e28f";
}

.fa-sun-cloud::before {
  content: "\\f763";
}

.fa-sun-dust::before {
  content: "\\f764";
}

.fa-sun-haze::before {
  content: "\\f765";
}

.fa-sunglasses::before {
  content: "\\f892";
}

.fa-sunrise::before {
  content: "\\f766";
}

.fa-sunset::before {
  content: "\\f767";
}

.fa-superscript::before {
  content: "\\f12b";
}

.fa-swatchbook::before {
  content: "\\f5c3";
}

.fa-sword::before {
  content: "\\f71c";
}

.fa-sword-laser::before {
  content: "\\e03b";
}

.fa-sword-laser-alt::before {
  content: "\\e03c";
}

.fa-swords::before {
  content: "\\f71d";
}

.fa-swords-laser::before {
  content: "\\e03d";
}

.fa-symbols::before {
  content: "\\f86e";
}

.fa-icons-alt::before {
  content: "\\f86e";
}

.fa-synagogue::before {
  content: "\\f69b";
}

.fa-syringe::before {
  content: "\\f48e";
}

.fa-t::before {
  content: "T";
}

.fa-table::before {
  content: "\\f0ce";
}

.fa-table-cells::before {
  content: "\\f00a";
}

.fa-th::before {
  content: "\\f00a";
}

.fa-table-cells-large::before {
  content: "\\f009";
}

.fa-th-large::before {
  content: "\\f009";
}

.fa-table-columns::before {
  content: "\\f0db";
}

.fa-columns::before {
  content: "\\f0db";
}

.fa-table-layout::before {
  content: "\\e290";
}

.fa-table-list::before {
  content: "\\f00b";
}

.fa-th-list::before {
  content: "\\f00b";
}

.fa-table-picnic::before {
  content: "\\e32d";
}

.fa-table-pivot::before {
  content: "\\e291";
}

.fa-table-rows::before {
  content: "\\e292";
}

.fa-rows::before {
  content: "\\e292";
}

.fa-table-tennis-paddle-ball::before {
  content: "\\f45d";
}

.fa-ping-pong-paddle-ball::before {
  content: "\\f45d";
}

.fa-table-tennis::before {
  content: "\\f45d";
}

.fa-table-tree::before {
  content: "\\e293";
}

.fa-tablet::before {
  content: "\\f3fb";
}

.fa-tablet-android::before {
  content: "\\f3fb";
}

.fa-tablet-button::before {
  content: "\\f10a";
}

.fa-tablet-rugged::before {
  content: "\\f48f";
}

.fa-tablet-screen::before {
  content: "\\f3fc";
}

.fa-tablet-android-alt::before {
  content: "\\f3fc";
}

.fa-tablet-screen-button::before {
  content: "\\f3fa";
}

.fa-tablet-alt::before {
  content: "\\f3fa";
}

.fa-tablets::before {
  content: "\\f490";
}

.fa-tachograph-digital::before {
  content: "\\f566";
}

.fa-digital-tachograph::before {
  content: "\\f566";
}

.fa-taco::before {
  content: "\\f826";
}

.fa-tag::before {
  content: "\\f02b";
}

.fa-tags::before {
  content: "\\f02c";
}

.fa-tally::before {
  content: "\\f69c";
}

.fa-tally-5::before {
  content: "\\f69c";
}

.fa-tally-1::before {
  content: "\\e294";
}

.fa-tally-2::before {
  content: "\\e295";
}

.fa-tally-3::before {
  content: "\\e296";
}

.fa-tally-4::before {
  content: "\\e297";
}

.fa-tamale::before {
  content: "\\e451";
}

.fa-tank-water::before {
  content: "\\e452";
}

.fa-tape::before {
  content: "\\f4db";
}

.fa-taxi::before {
  content: "\\f1ba";
}

.fa-cab::before {
  content: "\\f1ba";
}

.fa-taxi-bus::before {
  content: "\\e298";
}

.fa-teddy-bear::before {
  content: "\\e3cf";
}

.fa-teeth::before {
  content: "\\f62e";
}

.fa-teeth-open::before {
  content: "\\f62f";
}

.fa-telescope::before {
  content: "\\e03e";
}

.fa-temperature-arrow-down::before {
  content: "\\e03f";
}

.fa-temperature-down::before {
  content: "\\e03f";
}

.fa-temperature-arrow-up::before {
  content: "\\e040";
}

.fa-temperature-up::before {
  content: "\\e040";
}

.fa-temperature-empty::before {
  content: "\\f2cb";
}

.fa-temperature-0::before {
  content: "\\f2cb";
}

.fa-thermometer-0::before {
  content: "\\f2cb";
}

.fa-thermometer-empty::before {
  content: "\\f2cb";
}

.fa-temperature-full::before {
  content: "\\f2c7";
}

.fa-temperature-4::before {
  content: "\\f2c7";
}

.fa-thermometer-4::before {
  content: "\\f2c7";
}

.fa-thermometer-full::before {
  content: "\\f2c7";
}

.fa-temperature-half::before {
  content: "\\f2c9";
}

.fa-temperature-2::before {
  content: "\\f2c9";
}

.fa-thermometer-2::before {
  content: "\\f2c9";
}

.fa-thermometer-half::before {
  content: "\\f2c9";
}

.fa-temperature-high::before {
  content: "\\f769";
}

.fa-temperature-list::before {
  content: "\\e299";
}

.fa-temperature-low::before {
  content: "\\f76b";
}

.fa-temperature-quarter::before {
  content: "\\f2ca";
}

.fa-temperature-1::before {
  content: "\\f2ca";
}

.fa-thermometer-1::before {
  content: "\\f2ca";
}

.fa-thermometer-quarter::before {
  content: "\\f2ca";
}

.fa-temperature-snow::before {
  content: "\\f768";
}

.fa-temperature-frigid::before {
  content: "\\f768";
}

.fa-temperature-sun::before {
  content: "\\f76a";
}

.fa-temperature-hot::before {
  content: "\\f76a";
}

.fa-temperature-three-quarters::before {
  content: "\\f2c8";
}

.fa-temperature-3::before {
  content: "\\f2c8";
}

.fa-thermometer-3::before {
  content: "\\f2c8";
}

.fa-thermometer-three-quarters::before {
  content: "\\f2c8";
}

.fa-tenge-sign::before {
  content: "\\f7d7";
}

.fa-tenge::before {
  content: "\\f7d7";
}

.fa-tennis-ball::before {
  content: "\\f45e";
}

.fa-terminal::before {
  content: "\\f120";
}

.fa-text::before {
  content: "\\f893";
}

.fa-text-height::before {
  content: "\\f034";
}

.fa-text-size::before {
  content: "\\f894";
}

.fa-text-slash::before {
  content: "\\f87d";
}

.fa-remove-format::before {
  content: "\\f87d";
}

.fa-text-width::before {
  content: "\\f035";
}

.fa-thermometer::before {
  content: "\\f491";
}

.fa-theta::before {
  content: "\\f69e";
}

.fa-thought-bubble::before {
  content: "\\e32e";
}

.fa-thumbs-down::before {
  content: "\\f165";
}

.fa-thumbs-up::before {
  content: "\\f164";
}

.fa-thumbtack::before {
  content: "\\f08d";
}

.fa-thumb-tack::before {
  content: "\\f08d";
}

.fa-tick::before {
  content: "\\e32f";
}

.fa-ticket::before {
  content: "\\f145";
}

.fa-ticket-airline::before {
  content: "\\e29a";
}

.fa-ticket-simple::before {
  content: "\\f3ff";
}

.fa-ticket-alt::before {
  content: "\\f3ff";
}

.fa-tickets-airline::before {
  content: "\\e29b";
}

.fa-tilde::before {
  content: "\\~";
}

.fa-timeline::before {
  content: "\\e29c";
}

.fa-timeline-arrow::before {
  content: "\\e29d";
}

.fa-timer::before {
  content: "\\e29e";
}

.fa-tire::before {
  content: "\\f631";
}

.fa-tire-flat::before {
  content: "\\f632";
}

.fa-tire-pressure-warning::before {
  content: "\\f633";
}

.fa-tire-rugged::before {
  content: "\\f634";
}

.fa-toggle-off::before {
  content: "\\f204";
}

.fa-toggle-on::before {
  content: "\\f205";
}

.fa-toilet::before {
  content: "\\f7d8";
}

.fa-toilet-paper::before {
  content: "\\f71e";
}

.fa-toilet-paper-blank::before {
  content: "\\f71f";
}

.fa-toilet-paper-alt::before {
  content: "\\f71f";
}

.fa-toilet-paper-blank-under::before {
  content: "\\e29f";
}

.fa-toilet-paper-reverse-alt::before {
  content: "\\e29f";
}

.fa-toilet-paper-slash::before {
  content: "\\e072";
}

.fa-toilet-paper-under::before {
  content: "\\e2a0";
}

.fa-toilet-paper-reverse::before {
  content: "\\e2a0";
}

.fa-toilet-paper-under-slash::before {
  content: "\\e2a1";
}

.fa-toilet-paper-reverse-slash::before {
  content: "\\e2a1";
}

.fa-tomato::before {
  content: "\\e330";
}

.fa-tombstone::before {
  content: "\\f720";
}

.fa-tombstone-blank::before {
  content: "\\f721";
}

.fa-tombstone-alt::before {
  content: "\\f721";
}

.fa-toolbox::before {
  content: "\\f552";
}

.fa-tooth::before {
  content: "\\f5c9";
}

.fa-toothbrush::before {
  content: "\\f635";
}

.fa-torii-gate::before {
  content: "\\f6a1";
}

.fa-tornado::before {
  content: "\\f76f";
}

.fa-tower-broadcast::before {
  content: "\\f519";
}

.fa-broadcast-tower::before {
  content: "\\f519";
}

.fa-tower-control::before {
  content: "\\e2a2";
}

.fa-tractor::before {
  content: "\\f722";
}

.fa-trademark::before {
  content: "\\f25c";
}

.fa-traffic-cone::before {
  content: "\\f636";
}

.fa-traffic-light::before {
  content: "\\f637";
}

.fa-traffic-light-go::before {
  content: "\\f638";
}

.fa-traffic-light-slow::before {
  content: "\\f639";
}

.fa-traffic-light-stop::before {
  content: "\\f63a";
}

.fa-trailer::before {
  content: "\\e041";
}

.fa-train::before {
  content: "\\f238";
}

.fa-train-subway::before {
  content: "\\f239";
}

.fa-subway::before {
  content: "\\f239";
}

.fa-train-subway-tunnel::before {
  content: "\\e2a3";
}

.fa-subway-tunnel::before {
  content: "\\e2a3";
}

.fa-train-track::before {
  content: "\\e453";
}

.fa-train-tram::before {
  content: "\\f7da";
}

.fa-tram::before {
  content: "\\f7da";
}

.fa-train-tunnel::before {
  content: "\\e454";
}

.fa-transformer-bolt::before {
  content: "\\e2a4";
}

.fa-transgender::before {
  content: "\\f225";
}

.fa-transgender-alt::before {
  content: "\\f225";
}

.fa-transporter::before {
  content: "\\e042";
}

.fa-transporter-1::before {
  content: "\\e043";
}

.fa-transporter-2::before {
  content: "\\e044";
}

.fa-transporter-3::before {
  content: "\\e045";
}

.fa-transporter-4::before {
  content: "\\e2a5";
}

.fa-transporter-5::before {
  content: "\\e2a6";
}

.fa-transporter-6::before {
  content: "\\e2a7";
}

.fa-transporter-7::before {
  content: "\\e2a8";
}

.fa-transporter-empty::before {
  content: "\\e046";
}

.fa-trash::before {
  content: "\\f1f8";
}

.fa-trash-arrow-up::before {
  content: "\\f829";
}

.fa-trash-restore::before {
  content: "\\f829";
}

.fa-trash-can::before {
  content: "\\f2ed";
}

.fa-trash-alt::before {
  content: "\\f2ed";
}

.fa-trash-can-arrow-up::before {
  content: "\\f82a";
}

.fa-trash-restore-alt::before {
  content: "\\f82a";
}

.fa-trash-can-check::before {
  content: "\\e2a9";
}

.fa-trash-can-clock::before {
  content: "\\e2aa";
}

.fa-trash-can-list::before {
  content: "\\e2ab";
}

.fa-trash-can-plus::before {
  content: "\\e2ac";
}

.fa-trash-can-slash::before {
  content: "\\e2ad";
}

.fa-trash-alt-slash::before {
  content: "\\e2ad";
}

.fa-trash-can-undo::before {
  content: "\\f896";
}

.fa-trash-can-arrow-turn-left::before {
  content: "\\f896";
}

.fa-trash-undo-alt::before {
  content: "\\f896";
}

.fa-trash-can-xmark::before {
  content: "\\e2ae";
}

.fa-trash-check::before {
  content: "\\e2af";
}

.fa-trash-clock::before {
  content: "\\e2b0";
}

.fa-trash-list::before {
  content: "\\e2b1";
}

.fa-trash-plus::before {
  content: "\\e2b2";
}

.fa-trash-slash::before {
  content: "\\e2b3";
}

.fa-trash-undo::before {
  content: "\\f895";
}

.fa-trash-arrow-turn-left::before {
  content: "\\f895";
}

.fa-trash-xmark::before {
  content: "\\e2b4";
}

.fa-treasure-chest::before {
  content: "\\f723";
}

.fa-tree::before {
  content: "\\f1bb";
}

.fa-tree-christmas::before {
  content: "\\f7db";
}

.fa-tree-deciduous::before {
  content: "\\f400";
}

.fa-tree-alt::before {
  content: "\\f400";
}

.fa-tree-decorated::before {
  content: "\\f7dc";
}

.fa-tree-large::before {
  content: "\\f7dd";
}

.fa-tree-palm::before {
  content: "\\f82b";
}

.fa-trees::before {
  content: "\\f724";
}

.fa-triangle::before {
  content: "\\f2ec";
}

.fa-triangle-exclamation::before {
  content: "\\f071";
}

.fa-exclamation-triangle::before {
  content: "\\f071";
}

.fa-warning::before {
  content: "\\f071";
}

.fa-triangle-instrument::before {
  content: "\\f8e2";
}

.fa-triangle-music::before {
  content: "\\f8e2";
}

.fa-triangle-person-digging::before {
  content: "\\f85d";
}

.fa-construction::before {
  content: "\\f85d";
}

.fa-trophy::before {
  content: "\\f091";
}

.fa-trophy-star::before {
  content: "\\f2eb";
}

.fa-trophy-alt::before {
  content: "\\f2eb";
}

.fa-truck::before {
  content: "\\f0d1";
}

.fa-truck-bolt::before {
  content: "\\e3d0";
}

.fa-truck-clock::before {
  content: "\\f48c";
}

.fa-shipping-timed::before {
  content: "\\f48c";
}

.fa-truck-container::before {
  content: "\\f4dc";
}

.fa-truck-container-empty::before {
  content: "\\e2b5";
}

.fa-truck-fast::before {
  content: "\\f48b";
}

.fa-shipping-fast::before {
  content: "\\f48b";
}

.fa-truck-flatbed::before {
  content: "\\e2b6";
}

.fa-truck-front::before {
  content: "\\e2b7";
}

.fa-truck-medical::before {
  content: "\\f0f9";
}

.fa-ambulance::before {
  content: "\\f0f9";
}

.fa-truck-monster::before {
  content: "\\f63b";
}

.fa-truck-moving::before {
  content: "\\f4df";
}

.fa-truck-pickup::before {
  content: "\\f63c";
}

.fa-truck-plow::before {
  content: "\\f7de";
}

.fa-truck-ramp::before {
  content: "\\f4e0";
}

.fa-truck-ramp-box::before {
  content: "\\f4de";
}

.fa-truck-loading::before {
  content: "\\f4de";
}

.fa-truck-ramp-couch::before {
  content: "\\f4dd";
}

.fa-truck-couch::before {
  content: "\\f4dd";
}

.fa-truck-tow::before {
  content: "\\e2b8";
}

.fa-trumpet::before {
  content: "\\f8e3";
}

.fa-tty::before {
  content: "\\f1e4";
}

.fa-teletype::before {
  content: "\\f1e4";
}

.fa-tty-answer::before {
  content: "\\e2b9";
}

.fa-teletype-answer::before {
  content: "\\e2b9";
}

.fa-tugrik-sign::before {
  content: "\\e2ba";
}

.fa-turkey::before {
  content: "\\f725";
}

.fa-turkish-lira-sign::before {
  content: "\\e2bb";
}

.fa-try::before {
  content: "\\e2bb";
}

.fa-turkish-lira::before {
  content: "\\e2bb";
}

.fa-turn-down::before {
  content: "\\f3be";
}

.fa-level-down-alt::before {
  content: "\\f3be";
}

.fa-turn-down-left::before {
  content: "\\e331";
}

.fa-turn-down-right::before {
  content: "\\e455";
}

.fa-turn-up::before {
  content: "\\f3bf";
}

.fa-level-up-alt::before {
  content: "\\f3bf";
}

.fa-turntable::before {
  content: "\\f8e4";
}

.fa-turtle::before {
  content: "\\f726";
}

.fa-tv::before {
  content: "\\f26c";
}

.fa-television::before {
  content: "\\f26c";
}

.fa-tv-alt::before {
  content: "\\f26c";
}

.fa-tv-music::before {
  content: "\\f8e6";
}

.fa-tv-retro::before {
  content: "\\f401";
}

.fa-typewriter::before {
  content: "\\f8e7";
}

.fa-u::before {
  content: "U";
}

.fa-ufo::before {
  content: "\\e047";
}

.fa-ufo-beam::before {
  content: "\\e048";
}

.fa-umbrella::before {
  content: "\\f0e9";
}

.fa-umbrella-beach::before {
  content: "\\f5ca";
}

.fa-umbrella-simple::before {
  content: "\\e2bc";
}

.fa-umbrella-alt::before {
  content: "\\e2bc";
}

.fa-underline::before {
  content: "\\f0cd";
}

.fa-unicorn::before {
  content: "\\f727";
}

.fa-uniform-martial-arts::before {
  content: "\\e3d1";
}

.fa-union::before {
  content: "\\f6a2";
}

.fa-universal-access::before {
  content: "\\f29a";
}

.fa-unlock::before {
  content: "\\f09c";
}

.fa-unlock-keyhole::before {
  content: "\\f13e";
}

.fa-unlock-alt::before {
  content: "\\f13e";
}

.fa-up::before {
  content: "\\f357";
}

.fa-arrow-alt-up::before {
  content: "\\f357";
}

.fa-up-down::before {
  content: "\\f338";
}

.fa-arrows-alt-v::before {
  content: "\\f338";
}

.fa-up-down-left-right::before {
  content: "\\f0b2";
}

.fa-arrows-alt::before {
  content: "\\f0b2";
}

.fa-up-from-dotted-line::before {
  content: "\\e456";
}

.fa-up-from-line::before {
  content: "\\f346";
}

.fa-arrow-alt-from-bottom::before {
  content: "\\f346";
}

.fa-up-left::before {
  content: "\\e2bd";
}

.fa-up-long::before {
  content: "\\f30c";
}

.fa-long-arrow-alt-up::before {
  content: "\\f30c";
}

.fa-up-right::before {
  content: "\\e2be";
}

.fa-up-right-and-down-left-from-center::before {
  content: "\\f424";
}

.fa-expand-alt::before {
  content: "\\f424";
}

.fa-up-right-from-square::before {
  content: "\\f35d";
}

.fa-external-link-alt::before {
  content: "\\f35d";
}

.fa-up-to-dotted-line::before {
  content: "\\e457";
}

.fa-up-to-line::before {
  content: "\\f34d";
}

.fa-arrow-alt-to-top::before {
  content: "\\f34d";
}

.fa-upload::before {
  content: "\\f093";
}

.fa-usb-drive::before {
  content: "\\f8e9";
}

.fa-user::before {
  content: "\\f007";
}

.fa-user-alien::before {
  content: "\\e04a";
}

.fa-user-astronaut::before {
  content: "\\f4fb";
}

.fa-user-bounty-hunter::before {
  content: "\\e2bf";
}

.fa-user-check::before {
  content: "\\f4fc";
}

.fa-user-chef::before {
  content: "\\e3d2";
}

.fa-user-clock::before {
  content: "\\f4fd";
}

.fa-user-cowboy::before {
  content: "\\f8ea";
}

.fa-user-crown::before {
  content: "\\f6a4";
}

.fa-user-doctor::before {
  content: "\\f0f0";
}

.fa-user-md::before {
  content: "\\f0f0";
}

.fa-user-doctor-hair::before {
  content: "\\e458";
}

.fa-user-doctor-hair-long::before {
  content: "\\e459";
}

.fa-user-doctor-message::before {
  content: "\\f82e";
}

.fa-user-md-chat::before {
  content: "\\f82e";
}

.fa-user-gear::before {
  content: "\\f4fe";
}

.fa-user-cog::before {
  content: "\\f4fe";
}

.fa-user-graduate::before {
  content: "\\f501";
}

.fa-user-group::before {
  content: "\\f500";
}

.fa-user-friends::before {
  content: "\\f500";
}

.fa-user-group-crown::before {
  content: "\\f6a5";
}

.fa-users-crown::before {
  content: "\\f6a5";
}

.fa-user-hair::before {
  content: "\\e45a";
}

.fa-user-hair-buns::before {
  content: "\\e3d3";
}

.fa-user-hair-long::before {
  content: "\\e45b";
}

.fa-user-hair-mullet::before {
  content: "\\e45c";
}

.fa-business-front::before {
  content: "\\e45c";
}

.fa-party-back::before {
  content: "\\e45c";
}

.fa-trian-balbot::before {
  content: "\\e45c";
}

.fa-user-headset::before {
  content: "\\f82d";
}

.fa-user-helmet-safety::before {
  content: "\\f82c";
}

.fa-user-construction::before {
  content: "\\f82c";
}

.fa-user-hard-hat::before {
  content: "\\f82c";
}

.fa-user-injured::before {
  content: "\\f728";
}

.fa-user-large::before {
  content: "\\f406";
}

.fa-user-alt::before {
  content: "\\f406";
}

.fa-user-large-slash::before {
  content: "\\f4fa";
}

.fa-user-alt-slash::before {
  content: "\\f4fa";
}

.fa-user-lock::before {
  content: "\\f502";
}

.fa-user-minus::before {
  content: "\\f503";
}

.fa-user-music::before {
  content: "\\f8eb";
}

.fa-user-ninja::before {
  content: "\\f504";
}

.fa-user-nurse::before {
  content: "\\f82f";
}

.fa-user-nurse-hair::before {
  content: "\\e45d";
}

.fa-user-nurse-hair-long::before {
  content: "\\e45e";
}

.fa-user-pen::before {
  content: "\\f4ff";
}

.fa-user-edit::before {
  content: "\\f4ff";
}

.fa-user-pilot::before {
  content: "\\e2c0";
}

.fa-user-pilot-tie::before {
  content: "\\e2c1";
}

.fa-user-plus::before {
  content: "\\f234";
}

.fa-user-police::before {
  content: "\\e333";
}

.fa-user-police-tie::before {
  content: "\\e334";
}

.fa-user-robot::before {
  content: "\\e04b";
}

.fa-user-secret::before {
  content: "\\f21b";
}

.fa-user-shakespeare::before {
  content: "\\e2c2";
}

.fa-user-shield::before {
  content: "\\f505";
}

.fa-user-slash::before {
  content: "\\f506";
}

.fa-user-tag::before {
  content: "\\f507";
}

.fa-user-tie::before {
  content: "\\f508";
}

.fa-user-tie-hair::before {
  content: "\\e45f";
}

.fa-user-tie-hair-long::before {
  content: "\\e460";
}

.fa-user-unlock::before {
  content: "\\e058";
}

.fa-user-visor::before {
  content: "\\e04c";
}

.fa-user-vneck::before {
  content: "\\e461";
}

.fa-user-vneck-hair::before {
  content: "\\e462";
}

.fa-user-vneck-hair-long::before {
  content: "\\e463";
}

.fa-user-xmark::before {
  content: "\\f235";
}

.fa-user-times::before {
  content: "\\f235";
}

.fa-users::before {
  content: "\\f0c0";
}

.fa-group::before {
  content: "\\f0c0";
}

.fa-users-gear::before {
  content: "\\f509";
}

.fa-users-cog::before {
  content: "\\f509";
}

.fa-users-medical::before {
  content: "\\f830";
}

.fa-users-slash::before {
  content: "\\e073";
}

.fa-utensils::before {
  content: "\\f2e7";
}

.fa-cutlery::before {
  content: "\\f2e7";
}

.fa-utensils-slash::before {
  content: "\\e464";
}

.fa-utility-pole::before {
  content: "\\e2c3";
}

.fa-utility-pole-double::before {
  content: "\\e2c4";
}

.fa-v::before {
  content: "V";
}

.fa-vacuum::before {
  content: "\\e04d";
}

.fa-vacuum-robot::before {
  content: "\\e04e";
}

.fa-value-absolute::before {
  content: "\\f6a6";
}

.fa-van-shuttle::before {
  content: "\\f5b6";
}

.fa-shuttle-van::before {
  content: "\\f5b6";
}

.fa-vault::before {
  content: "\\e2c5";
}

.fa-vector-circle::before {
  content: "\\e2c6";
}

.fa-vector-polygon::before {
  content: "\\e2c7";
}

.fa-vector-square::before {
  content: "\\f5cb";
}

.fa-vent-damper::before {
  content: "\\e465";
}

.fa-venus::before {
  content: "\\f221";
}

.fa-venus-double::before {
  content: "\\f226";
}

.fa-venus-mars::before {
  content: "\\f228";
}

.fa-vest::before {
  content: "\\e085";
}

.fa-vest-patches::before {
  content: "\\e086";
}

.fa-vial::before {
  content: "\\f492";
}

.fa-vials::before {
  content: "\\f493";
}

.fa-video::before {
  content: "\\f03d";
}

.fa-video-camera::before {
  content: "\\f03d";
}

.fa-video-arrow-down-left::before {
  content: "\\e2c8";
}

.fa-video-arrow-up-right::before {
  content: "\\e2c9";
}

.fa-video-plus::before {
  content: "\\f4e1";
}

.fa-video-slash::before {
  content: "\\f4e2";
}

.fa-vihara::before {
  content: "\\f6a7";
}

.fa-violin::before {
  content: "\\f8ed";
}

.fa-virus::before {
  content: "\\e074";
}

.fa-virus-slash::before {
  content: "\\e075";
}

.fa-viruses::before {
  content: "\\e076";
}

.fa-voicemail::before {
  content: "\\f897";
}

.fa-volcano::before {
  content: "\\f770";
}

.fa-volleyball::before {
  content: "\\f45f";
}

.fa-volleyball-ball::before {
  content: "\\f45f";
}

.fa-volume::before {
  content: "\\f6a8";
}

.fa-volume-medium::before {
  content: "\\f6a8";
}

.fa-volume-high::before {
  content: "\\f028";
}

.fa-volume-up::before {
  content: "\\f028";
}

.fa-volume-low::before {
  content: "\\f027";
}

.fa-volume-down::before {
  content: "\\f027";
}

.fa-volume-off::before {
  content: "\\f026";
}

.fa-volume-slash::before {
  content: "\\f2e2";
}

.fa-volume-xmark::before {
  content: "\\f6a9";
}

.fa-volume-mute::before {
  content: "\\f6a9";
}

.fa-volume-times::before {
  content: "\\f6a9";
}

.fa-vr-cardboard::before {
  content: "\\f729";
}

.fa-w::before {
  content: "W";
}

.fa-waffle::before {
  content: "\\e466";
}

.fa-wagon-covered::before {
  content: "\\f8ee";
}

.fa-walker::before {
  content: "\\f831";
}

.fa-walkie-talkie::before {
  content: "\\f8ef";
}

.fa-wallet::before {
  content: "\\f555";
}

.fa-wand::before {
  content: "\\f72a";
}

.fa-wand-magic::before {
  content: "\\f0d0";
}

.fa-magic::before {
  content: "\\f0d0";
}

.fa-wand-magic-sparkles::before {
  content: "\\e2ca";
}

.fa-magic-wand-sparkles::before {
  content: "\\e2ca";
}

.fa-wand-sparkles::before {
  content: "\\f72b";
}

.fa-warehouse::before {
  content: "\\f494";
}

.fa-warehouse-full::before {
  content: "\\f495";
}

.fa-warehouse-alt::before {
  content: "\\f495";
}

.fa-washing-machine::before {
  content: "\\f898";
}

.fa-washer::before {
  content: "\\f898";
}

.fa-watch::before {
  content: "\\f2e1";
}

.fa-watch-apple::before {
  content: "\\e2cb";
}

.fa-watch-calculator::before {
  content: "\\f8f0";
}

.fa-watch-fitness::before {
  content: "\\f63e";
}

.fa-watch-smart::before {
  content: "\\e2cc";
}

.fa-water::before {
  content: "\\f773";
}

.fa-water-arrow-down::before {
  content: "\\f774";
}

.fa-water-lower::before {
  content: "\\f774";
}

.fa-water-arrow-up::before {
  content: "\\f775";
}

.fa-water-rise::before {
  content: "\\f775";
}

.fa-water-ladder::before {
  content: "\\f5c5";
}

.fa-ladder-water::before {
  content: "\\f5c5";
}

.fa-swimming-pool::before {
  content: "\\f5c5";
}

.fa-watermelon-slice::before {
  content: "\\e337";
}

.fa-wave-pulse::before {
  content: "\\f5f8";
}

.fa-heart-rate::before {
  content: "\\f5f8";
}

.fa-wave-sine::before {
  content: "\\f899";
}

.fa-wave-square::before {
  content: "\\f83e";
}

.fa-wave-triangle::before {
  content: "\\f89a";
}

.fa-waveform::before {
  content: "\\f8f1";
}

.fa-waveform-lines::before {
  content: "\\f8f2";
}

.fa-weight-hanging::before {
  content: "\\f5cd";
}

.fa-weight-scale::before {
  content: "\\f496";
}

.fa-weight::before {
  content: "\\f496";
}

.fa-whale::before {
  content: "\\f72c";
}

.fa-wheat::before {
  content: "\\f72d";
}

.fa-wheat-awn::before {
  content: "\\e2cd";
}

.fa-wheat-alt::before {
  content: "\\e2cd";
}

.fa-wheat-awn-slash::before {
  content: "\\e338";
}

.fa-wheat-slash::before {
  content: "\\e339";
}

.fa-wheelchair::before {
  content: "\\f193";
}

.fa-wheelchair-move::before {
  content: "\\e2ce";
}

.fa-wheelchair-alt::before {
  content: "\\e2ce";
}

.fa-whiskey-glass::before {
  content: "\\f7a0";
}

.fa-glass-whiskey::before {
  content: "\\f7a0";
}

.fa-whiskey-glass-ice::before {
  content: "\\f7a1";
}

.fa-glass-whiskey-rocks::before {
  content: "\\f7a1";
}

.fa-whistle::before {
  content: "\\f460";
}

.fa-wifi::before {
  content: "\\f1eb";
}

.fa-wifi-3::before {
  content: "\\f1eb";
}

.fa-wifi-strong::before {
  content: "\\f1eb";
}

.fa-wifi-exclamation::before {
  content: "\\e2cf";
}

.fa-wifi-fair::before {
  content: "\\f6ab";
}

.fa-wifi-2::before {
  content: "\\f6ab";
}

.fa-wifi-slash::before {
  content: "\\f6ac";
}

.fa-wifi-weak::before {
  content: "\\f6aa";
}

.fa-wifi-1::before {
  content: "\\f6aa";
}

.fa-wind::before {
  content: "\\f72e";
}

.fa-wind-turbine::before {
  content: "\\f89b";
}

.fa-wind-warning::before {
  content: "\\f776";
}

.fa-wind-circle-exclamation::before {
  content: "\\f776";
}

.fa-window::before {
  content: "\\f40e";
}

.fa-window-flip::before {
  content: "\\f40f";
}

.fa-window-alt::before {
  content: "\\f40f";
}

.fa-window-frame::before {
  content: "\\e04f";
}

.fa-window-frame-open::before {
  content: "\\e050";
}

.fa-window-maximize::before {
  content: "\\f2d0";
}

.fa-window-minimize::before {
  content: "\\f2d1";
}

.fa-window-restore::before {
  content: "\\f2d2";
}

.fa-windsock::before {
  content: "\\f777";
}

.fa-wine-bottle::before {
  content: "\\f72f";
}

.fa-wine-glass::before {
  content: "\\f4e3";
}

.fa-wine-glass-crack::before {
  content: "\\f4bb";
}

.fa-fragile::before {
  content: "\\f4bb";
}

.fa-wine-glass-empty::before {
  content: "\\f5ce";
}

.fa-wine-glass-alt::before {
  content: "\\f5ce";
}

.fa-won-sign::before {
  content: "\\f159";
}

.fa-krw::before {
  content: "\\f159";
}

.fa-won::before {
  content: "\\f159";
}

.fa-wreath::before {
  content: "\\f7e2";
}

.fa-wrench::before {
  content: "\\f0ad";
}

.fa-wrench-simple::before {
  content: "\\e2d1";
}

.fa-x::before {
  content: "X";
}

.fa-x-ray::before {
  content: "\\f497";
}

.fa-xmark::before {
  content: "\\f00d";
}

.fa-close::before {
  content: "\\f00d";
}

.fa-multiply::before {
  content: "\\f00d";
}

.fa-remove::before {
  content: "\\f00d";
}

.fa-times::before {
  content: "\\f00d";
}

.fa-xmark-to-slot::before {
  content: "\\f771";
}

.fa-times-to-slot::before {
  content: "\\f771";
}

.fa-vote-nay::before {
  content: "\\f771";
}

.fa-y::before {
  content: "Y";
}

.fa-yen-sign::before {
  content: "\\f157";
}

.fa-cny::before {
  content: "\\f157";
}

.fa-jpy::before {
  content: "\\f157";
}

.fa-rmb::before {
  content: "\\f157";
}

.fa-yen::before {
  content: "\\f157";
}

.fa-yin-yang::before {
  content: "\\f6ad";
}

.fa-z::before {
  content: "Z";
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/*!
 * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
@font-face {
  font-family: "Font Awesome 6 Brands";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
.fab,
.fa-brands {
  font-family: "Font Awesome 6 Brands";
  font-weight: 400;
}

.fa-42-group:before {
  content: "\\e080";
}

.fa-innosoft:before {
  content: "\\e080";
}

.fa-500px:before {
  content: "\\f26e";
}

.fa-accessible-icon:before {
  content: "\\f368";
}

.fa-accusoft:before {
  content: "\\f369";
}

.fa-acquisitions-incorporated:before {
  content: "\\f6af";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-adversal:before {
  content: "\\f36a";
}

.fa-affiliatetheme:before {
  content: "\\f36b";
}

.fa-airbnb:before {
  content: "\\f834";
}

.fa-algolia:before {
  content: "\\f36c";
}

.fa-alipay:before {
  content: "\\f642";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-amazon-pay:before {
  content: "\\f42c";
}

.fa-amilia:before {
  content: "\\f36d";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-angrycreative:before {
  content: "\\f36e";
}

.fa-angular:before {
  content: "\\f420";
}

.fa-app-store:before {
  content: "\\f36f";
}

.fa-app-store-ios:before {
  content: "\\f370";
}

.fa-apper:before {
  content: "\\f371";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-apple-pay:before {
  content: "\\f415";
}

.fa-artstation:before {
  content: "\\f77a";
}

.fa-asymmetrik:before {
  content: "\\f372";
}

.fa-atlassian:before {
  content: "\\f77b";
}

.fa-audible:before {
  content: "\\f373";
}

.fa-autoprefixer:before {
  content: "\\f41c";
}

.fa-avianex:before {
  content: "\\f374";
}

.fa-aviato:before {
  content: "\\f421";
}

.fa-aws:before {
  content: "\\f375";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-battle-net:before {
  content: "\\f835";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-bilibili:before {
  content: "\\e3d9";
}

.fa-bimobject:before {
  content: "\\f378";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-bitcoin:before {
  content: "\\f379";
}

.fa-bity:before {
  content: "\\f37a";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-blackberry:before {
  content: "\\f37b";
}

.fa-blogger:before {
  content: "\\f37c";
}

.fa-blogger-b:before {
  content: "\\f37d";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-bootstrap:before {
  content: "\\f836";
}

.fa-bots:before {
  content: "\\e340";
}

.fa-btc:before {
  content: "\\f15a";
}

.fa-buffer:before {
  content: "\\f837";
}

.fa-buromobelexperte:before {
  content: "\\f37f";
}

.fa-buy-n-large:before {
  content: "\\f8a6";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-canadian-maple-leaf:before {
  content: "\\f785";
}

.fa-cc-amazon-pay:before {
  content: "\\f42d";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-cc-apple-pay:before {
  content: "\\f416";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-centercode:before {
  content: "\\f380";
}

.fa-centos:before {
  content: "\\f789";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-chromecast:before {
  content: "\\f838";
}

.fa-cloudflare:before {
  content: "\\e07d";
}

.fa-cloudscale:before {
  content: "\\f383";
}

.fa-cloudsmith:before {
  content: "\\f384";
}

.fa-cloudversify:before {
  content: "\\f385";
}

.fa-cmplid:before {
  content: "\\e360";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-confluence:before {
  content: "\\f78d";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-cotton-bureau:before {
  content: "\\f89e";
}

.fa-cpanel:before {
  content: "\\f388";
}

.fa-creative-commons:before {
  content: "\\f25e";
}

.fa-creative-commons-by:before {
  content: "\\f4e7";
}

.fa-creative-commons-nc:before {
  content: "\\f4e8";
}

.fa-creative-commons-nc-eu:before {
  content: "\\f4e9";
}

.fa-creative-commons-nc-jp:before {
  content: "\\f4ea";
}

.fa-creative-commons-nd:before {
  content: "\\f4eb";
}

.fa-creative-commons-pd:before {
  content: "\\f4ec";
}

.fa-creative-commons-pd-alt:before {
  content: "\\f4ed";
}

.fa-creative-commons-remix:before {
  content: "\\f4ee";
}

.fa-creative-commons-sa:before {
  content: "\\f4ef";
}

.fa-creative-commons-sampling:before {
  content: "\\f4f0";
}

.fa-creative-commons-sampling-plus:before {
  content: "\\f4f1";
}

.fa-creative-commons-share:before {
  content: "\\f4f2";
}

.fa-creative-commons-zero:before {
  content: "\\f4f3";
}

.fa-critical-role:before {
  content: "\\f6c9";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-css3-alt:before {
  content: "\\f38b";
}

.fa-cuttlefish:before {
  content: "\\f38c";
}

.fa-d-and-d:before {
  content: "\\f38d";
}

.fa-d-and-d-beyond:before {
  content: "\\f6ca";
}

.fa-dailymotion:before {
  content: "\\e052";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-deezer:before {
  content: "\\e077";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-deploydog:before {
  content: "\\f38e";
}

.fa-deskpro:before {
  content: "\\f38f";
}

.fa-dev:before {
  content: "\\f6cc";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-dhl:before {
  content: "\\f790";
}

.fa-diaspora:before {
  content: "\\f791";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-digital-ocean:before {
  content: "\\f391";
}

.fa-discord:before {
  content: "\\f392";
}

.fa-discourse:before {
  content: "\\f393";
}

.fa-dochub:before {
  content: "\\f394";
}

.fa-docker:before {
  content: "\\f395";
}

.fa-draft2digital:before {
  content: "\\f396";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-dribbble-square:before {
  content: "\\f397";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-dyalog:before {
  content: "\\f399";
}

.fa-earlybirds:before {
  content: "\\f39a";
}

.fa-ebay:before {
  content: "\\f4f4";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-edge-legacy:before {
  content: "\\e078";
}

.fa-elementor:before {
  content: "\\f430";
}

.fa-ello:before {
  content: "\\f5f1";
}

.fa-ember:before {
  content: "\\f423";
}

.fa-empire:before {
  content: "\\f1d1";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-erlang:before {
  content: "\\f39d";
}

.fa-ethereum:before {
  content: "\\f42e";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-evernote:before {
  content: "\\f839";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-facebook:before {
  content: "\\f09a";
}

.fa-facebook-f:before {
  content: "\\f39e";
}

.fa-facebook-messenger:before {
  content: "\\f39f";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-fantasy-flight-games:before {
  content: "\\f6dc";
}

.fa-fedex:before {
  content: "\\f797";
}

.fa-fedora:before {
  content: "\\f798";
}

.fa-figma:before {
  content: "\\f799";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-firefox-browser:before {
  content: "\\e007";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-first-order-alt:before {
  content: "\\f50a";
}

.fa-firstdraft:before {
  content: "\\f3a1";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-flipboard:before {
  content: "\\f44d";
}

.fa-fly:before {
  content: "\\f417";
}

.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-font-awesome-flag:before {
  content: "\\f2b4";
}

.fa-font-awesome-logo-full:before {
  content: "\\f2b4";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-fonticons-fi:before {
  content: "\\f3a2";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-fort-awesome-alt:before {
  content: "\\f3a3";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-freebsd:before {
  content: "\\f3a4";
}

.fa-fulcrum:before {
  content: "\\f50b";
}

.fa-galactic-republic:before {
  content: "\\f50c";
}

.fa-galactic-senate:before {
  content: "\\f50d";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-git-alt:before {
  content: "\\f841";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-gitkraken:before {
  content: "\\f3a6";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-gitter:before {
  content: "\\f426";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-gofore:before {
  content: "\\f3a7";
}

.fa-golang:before {
  content: "\\e40f";
}

.fa-goodreads:before {
  content: "\\f3a8";
}

.fa-goodreads-g:before {
  content: "\\f3a9";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-google-drive:before {
  content: "\\f3aa";
}

.fa-google-pay:before {
  content: "\\e079";
}

.fa-google-play:before {
  content: "\\f3ab";
}

.fa-google-plus:before {
  content: "\\f2b3";
}

.fa-google-plus-g:before {
  content: "\\f0d5";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-gratipay:before {
  content: "\\f184";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-gripfire:before {
  content: "\\f3ac";
}

.fa-grunt:before {
  content: "\\f3ad";
}

.fa-guilded:before {
  content: "\\e07e";
}

.fa-gulp:before {
  content: "\\f3ae";
}

.fa-hacker-news:before {
  content: "\\f1d4";
}

.fa-hacker-news-square:before {
  content: "\\f3af";
}

.fa-hackerrank:before {
  content: "\\f5f7";
}

.fa-hips:before {
  content: "\\f452";
}

.fa-hire-a-helper:before {
  content: "\\f3b0";
}

.fa-hive:before {
  content: "\\e07f";
}

.fa-hooli:before {
  content: "\\f427";
}

.fa-hornbill:before {
  content: "\\f592";
}

.fa-hotjar:before {
  content: "\\f3b1";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-hubspot:before {
  content: "\\f3b2";
}

.fa-ideal:before {
  content: "\\e013";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-instagram-square:before {
  content: "\\e055";
}

.fa-instalod:before {
  content: "\\e081";
}

.fa-intercom:before {
  content: "\\f7af";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-invision:before {
  content: "\\f7b0";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-itch-io:before {
  content: "\\f83a";
}

.fa-itunes:before {
  content: "\\f3b4";
}

.fa-itunes-note:before {
  content: "\\f3b5";
}

.fa-java:before {
  content: "\\f4e4";
}

.fa-jedi-order:before {
  content: "\\f50e";
}

.fa-jenkins:before {
  content: "\\f3b6";
}

.fa-jira:before {
  content: "\\f7b1";
}

.fa-joget:before {
  content: "\\f3b7";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-js:before {
  content: "\\f3b8";
}

.fa-js-square:before {
  content: "\\f3b9";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-kaggle:before {
  content: "\\f5fa";
}

.fa-keybase:before {
  content: "\\f4f5";
}

.fa-keycdn:before {
  content: "\\f3ba";
}

.fa-kickstarter:before {
  content: "\\f3bb";
}

.fa-kickstarter-k:before {
  content: "\\f3bc";
}

.fa-korvue:before {
  content: "\\f42f";
}

.fa-laravel:before {
  content: "\\f3bd";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-less:before {
  content: "\\f41d";
}

.fa-line:before {
  content: "\\f3c0";
}

.fa-linkedin:before {
  content: "\\f08c";
}

.fa-linkedin-in:before {
  content: "\\f0e1";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-lyft:before {
  content: "\\f3c3";
}

.fa-magento:before {
  content: "\\f3c4";
}

.fa-mailchimp:before {
  content: "\\f59e";
}

.fa-mandalorian:before {
  content: "\\f50f";
}

.fa-markdown:before {
  content: "\\f60f";
}

.fa-mastodon:before {
  content: "\\f4f6";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-mdb:before {
  content: "\\f8ca";
}

.fa-medapps:before {
  content: "\\f3c6";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-medium-m:before {
  content: "\\f23a";
}

.fa-medrt:before {
  content: "\\f3c8";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.fa-megaport:before {
  content: "\\f5a3";
}

.fa-mendeley:before {
  content: "\\f7b3";
}

.fa-microblog:before {
  content: "\\e01a";
}

.fa-microsoft:before {
  content: "\\f3ca";
}

.fa-mix:before {
  content: "\\f3cb";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-mixer:before {
  content: "\\e056";
}

.fa-mizuni:before {
  content: "\\f3cc";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-monero:before {
  content: "\\f3d0";
}

.fa-napster:before {
  content: "\\f3d2";
}

.fa-neos:before {
  content: "\\f612";
}

.fa-nimblr:before {
  content: "\\f5a8";
}

.fa-node:before {
  content: "\\f419";
}

.fa-node-js:before {
  content: "\\f3d3";
}

.fa-npm:before {
  content: "\\f3d4";
}

.fa-ns8:before {
  content: "\\f3d5";
}

.fa-nutritionix:before {
  content: "\\f3d6";
}

.fa-octopus-deploy:before {
  content: "\\e082";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-old-republic:before {
  content: "\\f510";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-orcid:before {
  content: "\\f8d2";
}

.fa-osi:before {
  content: "\\f41a";
}

.fa-page4:before {
  content: "\\f3d7";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-palfed:before {
  content: "\\f3d8";
}

.fa-patreon:before {
  content: "\\f3d9";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-penny-arcade:before {
  content: "\\f704";
}

.fa-perbyte:before {
  content: "\\e083";
}

.fa-periscope:before {
  content: "\\f3da";
}

.fa-phabricator:before {
  content: "\\f3db";
}

.fa-phoenix-framework:before {
  content: "\\f3dc";
}

.fa-phoenix-squadron:before {
  content: "\\f511";
}

.fa-php:before {
  content: "\\f457";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-pied-piper-hat:before {
  content: "\\f4e5";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-pied-piper-square:before {
  content: "\\e01e";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-pix:before {
  content: "\\e43a";
}

.fa-playstation:before {
  content: "\\f3df";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-pushed:before {
  content: "\\f3e1";
}

.fa-python:before {
  content: "\\f3e2";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-quinscape:before {
  content: "\\f459";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-r-project:before {
  content: "\\f4f7";
}

.fa-raspberry-pi:before {
  content: "\\f7bb";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-react:before {
  content: "\\f41b";
}

.fa-reacteurope:before {
  content: "\\f75d";
}

.fa-readme:before {
  content: "\\f4d5";
}

.fa-rebel:before {
  content: "\\f1d0";
}

.fa-red-river:before {
  content: "\\f3e3";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-redhat:before {
  content: "\\f7bc";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-replyd:before {
  content: "\\f3e6";
}

.fa-researchgate:before {
  content: "\\f4f8";
}

.fa-resolving:before {
  content: "\\f3e7";
}

.fa-rev:before {
  content: "\\f5b2";
}

.fa-rocketchat:before {
  content: "\\f3e8";
}

.fa-rockrms:before {
  content: "\\f3e9";
}

.fa-rust:before {
  content: "\\e07a";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-salesforce:before {
  content: "\\f83b";
}

.fa-sass:before {
  content: "\\f41e";
}

.fa-schlix:before {
  content: "\\f3ea";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-searchengin:before {
  content: "\\f3eb";
}

.fa-sellcast:before {
  content: "\\f2da";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-servicestack:before {
  content: "\\f3ec";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-shopify:before {
  content: "\\e057";
}

.fa-shopware:before {
  content: "\\f5b5";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-sistrix:before {
  content: "\\f3ee";
}

.fa-sith:before {
  content: "\\f512";
}

.fa-sitrox:before {
  content: "\\e44a";
}

.fa-sketch:before {
  content: "\\f7c6";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-slack-hash:before {
  content: "\\f198";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ab";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-sourcetree:before {
  content: "\\f7d3";
}

.fa-speakap:before {
  content: "\\f3f3";
}

.fa-speaker-deck:before {
  content: "\\f83c";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-square-font-awesome:before {
  content: "\\f425";
}

.fa-square-font-awesome-stroke:before {
  content: "\\f35c";
}

.fa-font-awesome-alt:before {
  content: "\\f35c";
}

.fa-squarespace:before {
  content: "\\f5be";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-stackpath:before {
  content: "\\f842";
}

.fa-staylinked:before {
  content: "\\f3f5";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-steam-symbol:before {
  content: "\\f3f6";
}

.fa-sticker-mule:before {
  content: "\\f3f7";
}

.fa-strava:before {
  content: "\\f428";
}

.fa-stripe:before {
  content: "\\f429";
}

.fa-stripe-s:before {
  content: "\\f42a";
}

.fa-studiovinari:before {
  content: "\\f3f8";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-supple:before {
  content: "\\f3f9";
}

.fa-suse:before {
  content: "\\f7d6";
}

.fa-swift:before {
  content: "\\f8e1";
}

.fa-symfony:before {
  content: "\\f83d";
}

.fa-teamspeak:before {
  content: "\\f4f9";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-telegram-plane:before {
  content: "\\f2c6";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-the-red-yeti:before {
  content: "\\f69d";
}

.fa-themeco:before {
  content: "\\f5c6";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-think-peaks:before {
  content: "\\f731";
}

.fa-tiktok:before {
  content: "\\e07b";
}

.fa-trade-federation:before {
  content: "\\f513";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-typo3:before {
  content: "\\f42b";
}

.fa-uber:before {
  content: "\\f402";
}

.fa-ubuntu:before {
  content: "\\f7df";
}

.fa-uikit:before {
  content: "\\f403";
}

.fa-umbraco:before {
  content: "\\f8e8";
}

.fa-uncharted:before {
  content: "\\e084";
}

.fa-uniregistry:before {
  content: "\\f404";
}

.fa-unity:before {
  content: "\\e049";
}

.fa-unsplash:before {
  content: "\\e07c";
}

.fa-untappd:before {
  content: "\\f405";
}

.fa-ups:before {
  content: "\\f7e0";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-usps:before {
  content: "\\f7e1";
}

.fa-ussunnah:before {
  content: "\\f407";
}

.fa-vaadin:before {
  content: "\\f408";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-viber:before {
  content: "\\f409";
}

.fa-vimeo:before {
  content: "\\f40a";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-vimeo-v:before {
  content: "\\f27d";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-vnv:before {
  content: "\\f40b";
}

.fa-vuejs:before {
  content: "\\f41f";
}

.fa-watchman-monitoring:before {
  content: "\\e087";
}

.fa-waze:before {
  content: "\\f83f";
}

.fa-weebly:before {
  content: "\\f5cc";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-weixin:before {
  content: "\\f1d7";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-whatsapp-square:before {
  content: "\\f40c";
}

.fa-whmcs:before {
  content: "\\f40d";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-wirsindhandwerk:before {
  content: "\\e2d0";
}

.fa-wsh:before {
  content: "\\e2d0";
}

.fa-wix:before {
  content: "\\f5cf";
}

.fa-wizards-of-the-coast:before {
  content: "\\f730";
}

.fa-wodu:before {
  content: "\\e088";
}

.fa-wolf-pack-battalion:before {
  content: "\\f514";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-wordpress-simple:before {
  content: "\\f411";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-wpressr:before {
  content: "\\f3e4";
}

.fa-xbox:before {
  content: "\\f412";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-y-combinator:before {
  content: "\\f23b";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-yammer:before {
  content: "\\f840";
}

.fa-yandex:before {
  content: "\\f413";
}

.fa-yandex-international:before {
  content: "\\f414";
}

.fa-yarn:before {
  content: "\\f7e3";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-youtube-square:before {
  content: "\\f431";
}

.fa-zhihu:before {
  content: "\\f63f";
}

/*!
 * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
@font-face {
  font-family: "Font Awesome 6 Pro";
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
.fas,
.fa-solid {
  font-family: "Font Awesome 6 Pro";
  font-weight: 900;
}

/*!
 * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
@font-face {
  font-family: "Font Awesome 6 Pro";
  font-style: normal;
  font-weight: 300;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
.fal,
.fa-light {
  font-family: "Font Awesome 6 Pro";
  font-weight: 300;
}

/*!
 * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
@font-face {
  font-family: "Font Awesome 6 Pro";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
.far,
.fa-regular {
  font-family: "Font Awesome 6 Pro";
  font-weight: 400;
}

/*!
 * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
@font-face {
  font-family: "Font Awesome 6 Pro";
  font-style: normal;
  font-weight: 100;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
.fat,
.fa-thin {
  font-family: "Font Awesome 6 Pro";
  font-weight: 100;
}

@font-face {
  font-family: "Inter";
  font-weight: 100 900;
  font-display: swap;
  font-style: normal;
  font-named-instance: "Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 200;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-extraleicht.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 300;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-leicht.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 400;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-buch.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 500;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-kraftig.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 600;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-halbfett.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 700;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-dreiviertelfett.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 800;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-fett.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 900;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-extrafett.woff2");
}
.skeleton1 {
  animation: pulse1 2.3s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.skeleton2 {
  animation: pulse2 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.skeleton3 {
  animation: pulse3 2.7s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.skeleton4 {
  animation: pulse4 1.9s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.skeleton5 {
  animation: pulse5 2.3s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.skeleton6 {
  animation: pulse6 2.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.skeleton7 {
  animation: pulse7 3.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.skeleton {
  background: var(--black3);
  height: 20px;
  border-radius: 0.5rem;
}
.skeleton.medium {
  background: var(--black2);
  height: 15px;
  border-radius: 0.25rem;
}
.skeleton.small {
  background: var(--black2);
  height: 10px;
  border-radius: 0.25rem;
}
.skeleton.static {
  animation: none;
}

@keyframes pulse1 {
  0%, 100% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.2;
  }
}
@keyframes pulse2 {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.5;
  }
}
@keyframes pulse3 {
  0%, 100% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.3;
  }
}
@keyframes pulse4 {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.05;
  }
}
@keyframes pulse5 {
  0%, 100% {
    opacity: 0.05;
  }
  50% {
    opacity: 0.2;
  }
}
@keyframes pulse6 {
  0%, 100% {
    opacity: 0.15;
  }
  50% {
    opacity: 0.05;
  }
}
@keyframes pulse7 {
  0%, 100% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.15;
  }
}
html {
  width: 100vw;
  margin-left: 0;
  background-color: white;
  overflow-x: hidden;
}
html.embed {
  background-color: transparent !important;
}
html.embed #app {
  background-color: transparent !important;
}

* {
  box-sizing: border-box;
}

h1, .h1 {
  margin-top: 0;
}

h2, .h2 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

h4, .h4 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

h6, .h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

h5, .h5 {
  font-size: 1.25rem;
}

body {
  transition: background 0.9s;
  background-color: rgba(0, 0, 0, 0);
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  font-family: "Inter", sans-serif !important;
  margin: 0;
}

*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: transparent;
}
*::-webkit-scrollbar-track {
  background-color: transparent;
}
*::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
}

.uppercase {
  text-transform: lowercase;
}
.uppercase:first-letter {
  text-transform: uppercase;
}

@media (max-width: 375px) {
  .g-recaptcha {
    margin: 0 auto;
    transform: scale(0.98);
    -webkit-transform: scale(0.98);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
  }
}
@media (max-width: 360px) {
  .g-recaptcha {
    margin: 0 auto;
    transform: scale(0.92);
    -webkit-transform: scale(0.92);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
  }
}
@media (max-width: 320px) {
  .g-recaptcha {
    margin: 0 auto;
    transform: scale(0.8);
    -webkit-transform: scale(0.8);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
  }
}
.selectable {
  -webkit-user-select: text;
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.underline {
  text-decoration: underline !important;
}

.transparent-bg {
  background-color: transparent;
}

.cursor-pointer {
  cursor: pointer;
}

.notransition * {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  -ms-transition: none !important;
  transition: none !important;
}

a {
  color: #6a32e6;
  text-decoration: none;
  background-color: transparent;
}

.is-invalid ~ .invalid-feedback {
  display: block;
}

h4, .h4 {
  font-size: 18px;
}

.flag-icon {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 2rem;
  line-height: 1em;
  border-radius: 0.25rem;
  object-fit: cover;
}
.flag-icon:before {
  content: " ";
}

.flag-icon {
  position: relative;
  display: inline-block;
  width: 1.3333333333em;
  line-height: 1em;
  object-fit: cover;
}
.flag-icon:before {
  content: " ";
}

.text-green {
  color: #28a745 !important;
}

.text-gold {
  color: gold !important;
}

.text-grey {
  color: dimgrey !important;
}

.text-red {
  color: #dc3545 !important;
}

.grecaptcha-badge {
  visibility: hidden;
}

.unselectable {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  user-select: none;
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-scroll {
  overflow: scroll;
}

.notransition * {
  -webkit-transition: none;
  -moz-transition: none;
  -o-transition: none;
  transition: none;
}

hr {
  width: 100%;
}

.button {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  user-select: none;
  border: 1px solid rgba(0, 0, 0, 0);
  line-height: 1.5;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  padding: 0 20px;
  white-space: nowrap;
  background-color: var(--purple6);
  font-family: "Inter", sans-serif !important;
}
.button:hover {
  opacity: 0.9;
}
.button:disabled {
  opacity: 0.7;
  cursor: default;
}
.button.thin {
  min-height: 30px;
  font-size: 12px;
  padding: 0 10px;
  border-radius: 6px;
}

.button-ghost {
  background: rgba(0, 0, 0, 0);
  border-color: var(--black1);
  border-radius: 0.5rem;
  color: var(--black9);
}
.button-ghost:hover {
  background: var(--black1);
}

.w-90 {
  width: 90% !important;
}

.w-80 {
  width: 80% !important;
}

.w-70 {
  width: 70% !important;
}

.w-60 {
  width: 60%;
}

.w-50 {
  width: 50%;
}

.w-40 {
  width: 40%;
}

.w-30 {
  width: 30% !important;
}

.w-20 {
  width: 20%;
}

.w-10 {
  width: 10%;
}

.purple-color {
  color: var(--purple6) !important;
}

.text-nowrap {
  white-space: nowrap;
}

.w-max {
  width: max-content !important;
}

.link-like {
  color: var(--purple6);
  text-decoration: underline;
  cursor: pointer;
}

.recharts-cartesian-axis-tick text {
  fill: var(--black3) !important;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  text-transform: uppercase;
}
.recharts-cartesian-axis-tick-line {
  display: none;
}
.recharts-cartesian-grid-horizontal line {
  stroke: var(--black1);
  stroke-dasharray: 3 3;
}

.recharts-xAxis line {
  display: none;
}

.recharts-yAxis line {
  display: none;
}

.recharts-custom-tooltip {
  border-radius: 0.25rem;
  padding: 0;
  overflow: hidden;
  padding-bottom: 0.5rem;
  background: var(--black7);
  color: var(--white);
  width: 180px;
  padding-bottom: 0;
}
.recharts-custom-tooltip .label {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--black6);
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: var(--white);
  margin-bottom: 0;
}
.recharts-custom-tooltip .intro {
  padding: 1rem;
  display: flex;
  align-items: center;
  margin: 0;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  justify-content: space-between;
}
.recharts-custom-tooltip .intro > span {
  display: flex;
  align-items: center;
}
.recharts-custom-tooltip .intro:last-child {
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 0;
}
.recharts-custom-tooltip .intro:last-of-type i {
  background: var(--purple6);
}
.recharts-custom-tooltip .intro i {
  display: flex;
  margin-right: 0.5rem;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background: var(--black5);
}
.recharts-custom-tooltip .intro:last-child {
  padding-bottom: 1rem;
}

.screen-title {
  margin-top: 0.5rem;
  margin-bottom: 0;
  font-size: 1.5rem !important;
  white-space: nowrap;
  align-items: center;
  display: flex;
  margin-right: 1.5rem;
  width: auto;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  line-height: 29px;
  color: var(--black9) !important;
}
.screen-title + div {
  width: auto;
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .screen-title {
    font-weight: 500;
    font-size: 1.5rem !important;
  }
}
.screen-title-container {
  display: flex;
}
@media (max-width: 768px) {
  .screen-title-container {
    flex-wrap: wrap;
  }
}
.screen-note {
  margin: 1rem 0;
  font-size: 0.8rem;
  line-height: 1.2rem;
  color: var(--black9);
}
@media (max-width: 768px) {
  .screen-note {
    margin: 0.5rem 0;
  }
}
.screen-header {
  padding: 1.5rem 0;
  align-items: flex-end;
  justify-content: space-between;
  display: flex;
  position: relative;
}
@media (max-width: 768px) {
  .screen-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem 0;
  }
}
.screen-filters {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap-reverse;
  gap: 0.75rem;
}
.screen-filters-button {
  margin-left: 1rem;
}
@media (max-width: 768px) {
  .screen-filters-button {
    margin-left: 0;
  }
}
@media (max-width: 768px) {
  .screen-filters {
    width: 100%;
    margin-top: 0.25rem;
    display: flex;
    flex-direction: column;
  }
}
@media (max-width: 768px) {
  .screen-filters .paylixecommerce-date-picker {
    width: 100%;
    justify-content: center;
  }
}
.screen-select {
  max-width: 30%;
}
.screen-select.long {
  max-width: 50%;
}

@media (max-width: 768px) {
  .screen-title {
    font-weight: 500;
    font-size: 1.5rem !important;
  }
  .screen-title-container {
    flex-wrap: wrap;
  }
  .screen-note {
    margin: 0.5rem 0;
  }
  .screen-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem 0;
  }
  .screen-filters {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 0.25rem;
    display: flex;
    flex-direction: column;
  }
  .screen-filters-button {
    margin-left: 0;
  }
  .screen-filters .paylixecommerce-date-picker {
    width: 100%;
    justify-content: center;
  }
}
.badge {
  width: fit-content;
  padding-left: 6px;
  padding-right: 6px;
  height: 20px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  text-transform: capitalize;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: var(--purple6);
}
.badge img {
  margin-right: 0.3rem;
}

.badge-pending, .badge-waiting-for-seller-response, .badge-file, .badge-ip, .badge-customer_dispute_ongoing {
  background: var(--orange0) !important;
  color: var(--orange6) !important;
}

.badge-asn, .badge-info-card, .badge-info, .badge-waiting_for_confirmations {
  background: var(--orange0) !important;
  color: var(--orange6) !important;
}

.badge-cancelled, .badge-voided, .badge-canceled, .badge-disabled, .badge-rejected, .badge-error, .badge-failed, .badge-none, .badge-unverified, .badge-bad {
  background: var(--red0) !important;
  color: var(--red6) !important;
}

.badge-completed, .badge-subscription, .badge-active, .badge-approved, .badge-isp, .badge-success, .badge-verified, .badge-good {
  background: var(--green0) !important;
  color: var(--green6) !important;
}

.badge-confirmation, .badge-country, .badge-partial {
  background: var(--cyan0) !important;
  color: var(--cyan6) !important;
}

.badge-trialing, .badge-waiting, .badge-dns, .badge-serials, .badge-developer, .badge-waiting_shop_action {
  background: var(--blue0) !important;
  color: var(--blue6) !important;
}

.badge-reversed, .badge-dynamic, .badge-host, .badge-reason {
  background: var(--pink0) !important;
  color: var(--pink6) !important;
}

.badge-refunded {
  background: rgba(63, 74, 96, 0.0784313725) !important;
  color: #3F4A60 !important;
}

.badge-ongoing, .badge-email, .badge-warning, .badge-service, .badge-paylixecommerce {
  background: var(--purple1) !important;
  color: var(--purple6) !important;
}

.badge-mark {
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  font-size: 16px !important;
  font-weight: normal;
  padding: 3px 10px;
  margin: 2px;
  vertical-align: middle;
  background-color: var(--purple1) !important;
  color: var(--purple6) !important;
}
.badge-mark.gray {
  background-color: var(--purple0) !important;
  color: var(--black6) !important;
}

.dark .paylixecommerce-select {
  background-color: var(--black1);
}
.dark .paylixecommerce-label {
  color: var(--black);
}
.dark .paylixecommerce-input {
  background-color: var(--black1);
}
.dark textarea.paylixecommerce-input {
  background-color: var(--black1);
}
.dark .react-mde .mde-textarea-wrapper textarea.mde-text {
  background-color: var(--black1);
  border-color: var(--black6);
  border-bottom: none;
  border-right: none;
  border-left: none;
}
.dark .react-mde .mde-header {
  background-color: var(--black1);
}
.dark .switcher input:checked + .switcher-slider::before {
  background: var(--black);
}
.dark .switcher .switcher-slider {
  background: var(--black3);
}

.paylixecommerce-note {
  display: block;
  align-items: end;
  margin-top: 0.75rem;
  margin-bottom: 0;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: var(--black5);
}
@media (max-width: 768px) {
  .paylixecommerce-note {
    font-weight: 400;
  }
}
.paylixecommerce-note b {
  color: var(--black9) !important;
  font-weight: 600 !important;
}
.paylixecommerce-note a {
  color: var(--purple6) !important;
  font-weight: 600 !important;
}

.paylixecommerce-note-big {
  display: block;
  align-items: end;
  margin-top: 0.75rem;
  margin-bottom: 0;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: var(--black5);
}
.paylixecommerce-note-big b {
  color: var(--black9) !important;
  font-weight: 500 !important;
}
.paylixecommerce-note-big a {
  color: var(--purple6) !important;
  font-weight: 600 !important;
}

.d-block {
  display: block;
}

.paylixecommerce-label {
  margin-bottom: 0.75rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 17px;
  color: var(--black5);
  display: flex;
  align-items: center;
}

.paylixecommerce-input-visible {
  position: absolute;
  right: 1rem;
  bottom: 0.6rem;
  cursor: pointer;
}

.paylixecommerce-input-prefix {
  position: absolute;
  height: 40px;
  bottom: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 1rem;
  font-weight: bold;
  color: var(--black9);
  top: 29px;
  right: 0;
  border-left: 1px solid var(--black2);
}
.paylixecommerce-input-prefix + div input {
  padding-right: 2.5rem;
}

.paylixecommerce-select {
  cursor: pointer;
  padding: 0 2rem 0 14px;
  height: 40px;
  max-height: 40px;
  width: 100%;
  transition: border 0.3s ease;
  outline: none;
  border-radius: 0.5rem;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  margin: 0;
  color: var(--black9);
  border: 1px solid var(--black2);
  box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.05);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-position-x: calc(100% - 1rem);
  background-position-y: 0.5rem;
}
.paylixecommerce-select[disabled] {
  background: var(--black0);
  border-color: var(--black2);
  cursor: default;
}
.paylixecommerce-select:active {
  border-color: var(--purple6);
}
.paylixecommerce-select:focus {
  border-color: var(--purple6);
}
.paylixecommerce-select:hover {
  border-color: var(--purple6);
}
.paylixecommerce-select::-ms-expand {
  display: none;
}
.paylixecommerce-select.is-invalid {
  border: 1px solid var(--red6) !important;
}
.paylixecommerce-select.is-invalid:hover {
  border-color: var(--red6) !important;
}
.paylixecommerce-select.is-invalid:focus {
  border-color: var(--red6) !important;
}

.switcher {
  width: 2.75rem;
  min-width: 2.75rem;
  height: 1.5rem;
  margin: 0 0 0 1rem;
}
.switcher-label {
  cursor: pointer;
  width: calc(100% - 3.75rem);
}
.switcher-label .paylixecommerce-note {
  font-weight: 400;
  margin: 0;
}
.switcher.left {
  margin-right: 0;
}
.switcher-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
}
.switcher-container.withBorder {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--black1);
}
.switcher-container.right .switcher {
  margin-left: 0;
  margin-right: 1rem;
}
.switcher-container.right .switcher-label {
  width: calc(100% - 3.75rem);
}
.switcher input {
  display: none;
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
  width: 50px;
}
.switcher input:checked ~ .switcher-slider::before {
  transform: translateX(19px);
}
.switcher input:checked + .switcher-slider {
  background-color: var(--purple6);
  border-color: var(--purple6);
}
.switcher input:checked + .switcher-slider::before {
  border-color: var(--purple6);
}
.switcher .switcher-slider {
  background-color: var(--black1);
  border: none;
  border-radius: 50em;
  font-size: 12px;
  position: relative;
  display: block;
  height: inherit;
  cursor: pointer;
  transition: 0.15s ease-out;
}
.switcher .switcher-slider:before {
  width: 20px;
  height: 20px;
  top: 2px;
  border-radius: 100%;
  position: absolute;
  left: 2px;
  box-sizing: border-box;
  content: "";
  background-color: var(--white);
  border: 1px solid var(--black1);
  transition: 0.15s ease-out;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
}
.switcher .switcher-slider span {
  border-radius: 50em;
  font-size: 12px;
  background-color: var(--black0);
  border: none;
  position: relative;
  display: block;
  height: inherit;
  cursor: pointer;
  transition: 0.15s ease-out;
}

.paylixecommerce-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 1px solid var(--black2);
  box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 0.5rem;
  background: var(--white);
  width: 100%;
  padding: 0 14px;
  transition: border 0.3s ease !important;
  height: 40px;
  max-height: 40px;
  outline: none;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
}
.paylixecommerce-input.textarea {
  height: auto;
  max-height: none;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid var(--black2);
  box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.05);
  min-height: 80px;
}
.paylixecommerce-input.is-invalid {
  border: 1px solid var(--red6) !important;
}
.paylixecommerce-input.is-invalid:hover {
  border-color: var(--red6) !important;
}
.paylixecommerce-input.is-invalid:focus {
  border-color: var(--red6) !important;
}
.paylixecommerce-input:active {
  border-color: var(--purple6);
}
.paylixecommerce-input:focus {
  border-color: var(--purple6);
}
.paylixecommerce-input:hover {
  border-color: var(--purple6) !important;
}
.paylixecommerce-input::placeholder {
  color: var(--black3);
}
.paylixecommerce-input[disabled] {
  background: var(--black0);
  border-color: var(--black2);
}
.paylixecommerce-input[disabled]:focus {
  border-color: var(--black2);
}

.paylixecommerce-checkbox {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid rgba(0, 0, 0, 0);
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  cursor: pointer;
  font-weight: 500;
  margin-bottom: 1rem;
  margin-right: 1.5rem;
}
.paylixecommerce-checkbox input {
  box-sizing: border-box;
  padding: 0;
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.paylixecommerce-checkbox input:not(:disabled):active ~ label::before {
  color: #fff;
  background-color: var(--black0);
  border-color: var(--black3);
}
.paylixecommerce-checkbox input:focus ~ label::before {
  border-color: var(--purple6);
  box-shadow: 0 0 0 0.2rem rgba(97, 59, 234, 0.25);
}
.paylixecommerce-checkbox input:checked ~ label::before {
  color: #fff;
  border-color: var(--purple6);
  background-color: var(--purple6);
}
.paylixecommerce-checkbox input:checked ~ label {
  color: var(--black9);
}
.paylixecommerce-checkbox input:checked ~ label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) !important;
  border: 1px solid var(--purple6);
}
.paylixecommerce-checkbox label {
  position: relative;
  margin-bottom: 0;
  font-weight: 400;
}
.paylixecommerce-checkbox label:before {
  position: absolute;
  cursor: pointer;
  display: block;
  pointer-events: none;
  content: "";
  background-color: var(--white);
  top: 50%;
  transform: translateY(-50%);
  border-radius: 2px;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 18px;
  height: 18px;
  left: -1.75rem;
  border: 1px solid var(--black5) !important;
}
.paylixecommerce-checkbox label:after {
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  position: absolute;
  display: block;
  content: "";
  background: no-repeat 50%/50% 50%;
  width: 18px;
  height: 18px;
  left: -1.75rem;
  border-radius: 2px;
}

.is-invalid .react-mde textarea {
  border: 1px solid var(--red6) !important;
}
.is-invalid .react-mde textarea:focus {
  border-color: var(--red6) !important;
}

.react-mde {
  border: none;
  border-radius: 0.5rem;
}
.react-mde .grip {
  border-top: none;
  background: var(--black9);
}
.react-mde ul.mde-header-group {
  padding: 0 0.5rem;
  margin: 0.5rem 0;
}
.react-mde ul.mde-header-group li {
  display: flex !important;
  align-items: center;
}
.react-mde .mde-header {
  background: var(--white);
  border: 1px solid var(--black2);
  border-radius: 0.5rem 0.5rem 0 0;
  border-bottom: none;
}
.react-mde .mde-header svg path {
  fill: var(--black5);
}
.react-mde .mde-header i {
  color: var(--black5);
}
.react-mde .mde-header .mde-tabs button {
  border: none;
  text-align: center;
  margin: 0.5rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0 1rem;
  text-align: center;
  font-family: "Inter" !important;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  line-height: 18px;
  box-sizing: border-box;
  user-select: none;
  border: none;
  color: var(--white);
  background-color: var(--black9);
  font-weight: 600;
  height: 1.75rem;
  font-size: 0.813rem;
}
.react-mde .mde-header .mde-tabs button.selected {
  display: none;
}
.react-mde .mde-textarea-wrapper textarea.mde-text {
  padding: 1rem !important;
  border: 1px solid var(--black2);
  border-radius: 0 0 0.5rem 0.5rem;
  box-shadow: inset 0px 1px 2px rgba(16, 24, 40, 0.05);
  height: 100px;
  font-size: 14px;
  background: var(--white);
  color: var(--black9) !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.react-mde .mde-textarea-wrapper textarea.mde-text:focus {
  outline: none;
  border-color: var(--purple6);
}

.invalid-feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: var(--red6);
}

.paylixecommerce-text, div.mde-preview div.mde-preview-content {
  color: var(--black6);
}
.paylixecommerce-text h1, .paylixecommerce-text .h1, div.mde-preview div.mde-preview-content h1, div.mde-preview div.mde-preview-content .h1 {
  font-size: 1.6rem;
  line-height: 3rem;
}
.paylixecommerce-text h2, .paylixecommerce-text .h2, div.mde-preview div.mde-preview-content h2, div.mde-preview div.mde-preview-content .h2 {
  font-size: 1.4rem;
  line-height: 2.5rem;
}
.paylixecommerce-text h3, .paylixecommerce-text .h3, div.mde-preview div.mde-preview-content h3, div.mde-preview div.mde-preview-content .h3 {
  font-size: 1.3rem;
  line-height: 2.4rem;
}
.paylixecommerce-text h4, .paylixecommerce-text .h4, div.mde-preview div.mde-preview-content h4, div.mde-preview div.mde-preview-content .h4 {
  font-size: 1.1rem;
  line-height: 2rem;
}
.paylixecommerce-text h6, .paylixecommerce-text .h6, div.mde-preview div.mde-preview-content h6, div.mde-preview div.mde-preview-content .h6 {
  font-weight: 500;
}
.paylixecommerce-text p, div.mde-preview div.mde-preview-content p {
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.2rem;
  margin-bottom: 0.6rem;
  color: var(--black9);
}
.paylixecommerce-text input[type=checkbox], div.mde-preview div.mde-preview-content input[type=checkbox] {
  width: 30px;
  height: 20px;
  cursor: pointer;
  font-size: 21px;
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem -2rem;
  transform: scale(1.25);
}
.paylixecommerce-text input[type=checkbox]:after, div.mde-preview div.mde-preview-content input[type=checkbox]:after {
  content: " ";
  background-color: #fff;
  display: inline-block;
  margin-left: 10px;
  padding-bottom: 5px;
  color: #221d3e;
  width: 17px;
  height: 17px;
  visibility: visible;
  border: 2px solid #181432;
  padding-left: 3px;
  border-radius: 2px;
}
.paylixecommerce-text input[type=checkbox]:checked:after, div.mde-preview div.mde-preview-content input[type=checkbox]:checked:after {
  content: "x";
  font-weight: bold;
  font-size: 0.8rem;
  color: #181432;
  position: relative;
  padding-bottom: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: left;
  cursor: pointer;
}
.paylixecommerce-text pre, div.mde-preview div.mde-preview-content pre {
  padding: 1rem;
  border-radius: 2px;
  margin-top: 1rem;
  overflow: auto;
  display: block;
  line-height: 1rem;
}
.paylixecommerce-text ul, .paylixecommerce-text ol, div.mde-preview div.mde-preview-content ul, div.mde-preview div.mde-preview-content ol {
  line-height: 1.5rem;
  padding-left: 1.5rem;
}
.paylixecommerce-text ol, div.mde-preview div.mde-preview-content ol {
  list-style: auto;
  padding-top: 0.5rem;
}
.paylixecommerce-text img, div.mde-preview div.mde-preview-content img {
  max-width: 100%;
  border-radius: 0.5rem;
}

.dark .edit-modal .info-table {
  background: var(--white);
  border: 1px solid var(--black2);
}
.dark .edit-modal .info-table .info-table-header {
  background: var(--black1);
}
.dark .edit-modal .info-table .info-table-body > div:not(.paylixecommerce-table-container) {
  border-color: var(--black2);
}
.dark .edit-modal .info-table.table .info-table-header {
  background: var(--black1);
  border-bottom-color: var(--black0);
}
.dark .edit-modal .info-table.table .info-table-header .screen-search input {
  background: var(--black0);
}
.dark .edit-modal .info-table.table .info-table-body {
  background-color: var(--black1);
  border-radius: 0 0 0.5rem 0.5rem;
}
.dark .info-table {
  background: var(--white);
  border-color: transparent;
}
.dark .info-table .info-table-header {
  background: var(--black1);
}
.dark .info-table .info-table-body > div:not(.paylixecommerce-table-container) {
  border-color: var(--black1);
}
.dark .info-table.table .info-table-header {
  background: var(--black1);
  border-bottom-color: var(--black0);
}
.dark .info-table.table .info-table-header .screen-search input {
  background: var(--black0);
}
.dark .info-table.table .info-table-body {
  background-color: var(--black1);
  border-radius: 0 0 0.5rem 0.5rem;
}

.info-table {
  display: flex !important;
  flex-direction: column;
  width: 100%;
  background: var(--white);
  border-radius: 0.5rem;
  border: 1px solid var(--black1);
  margin-bottom: 1rem;
  margin-top: 0;
}
.info-table.table .paylixecommerce-table-container {
  padding: 0;
  box-shadow: none;
}
.info-table.table .paylixecommerce-table-container .paylixecommerce-table {
  padding: 0;
  box-shadow: none;
}
.info-table.table .paylixecommerce-table-container .paylixecommerce-table table thead th {
  padding: 0.5rem 0.75rem;
}
.info-table.table .paylixecommerce-table-container .paylixecommerce-table table tbody tr td {
  border-top-color: var(--black1) !important;
}
.info-table.table .paylixecommerce-table-container .paylixecommerce-table-container {
  padding: 0;
}
.info-table.with-shadow {
  box-shadow: 0px 1px 3px rgba(7, 14, 35, 0.06), 0px 2px 8px -1px rgba(7, 14, 35, 0.05);
  border: none;
}
.info-table.collapsed .info-table-header {
  border-bottom: none;
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
}
.info-table-header {
  padding: 1.25rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: var(--black9);
  cursor: pointer;
  border-radius: 0.5rem 0.5rem 0 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--black1);
}
.info-table-body > div:not(.paylixecommerce-table-container) {
  display: flex;
  width: 100%;
  border-top: 1px solid var(--black1);
  padding: 1rem 1.25rem;
  justify-content: space-between;
  color: var(--black4);
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  border-radius: 0 0 0.5rem 0.5rem;
}
.info-table-body > div:not(.paylixecommerce-table-container):first-child {
  border-top: none;
}
.info-table-body > div:not(.paylixecommerce-table-container) span:first-child {
  width: 30%;
}
.info-table-body > div:not(.paylixecommerce-table-container) span:last-child {
  width: 70%;
  text-align: right;
  color: var(--black9);
  word-break: break-word;
}

@media (max-width: 768px) {
  .info-table.table .paylixecommerce-table-container .paylixecommerce-table table thead th {
    padding: 0.5rem 0.75rem;
  }
  .info-table-header {
    padding: 1rem;
  }
  .info-table-body > div:not(.paylixecommerce-table-container) {
    padding: 0.75rem 1rem;
  }
}
.is-invalid-select > div:first-of-type {
  border: 1px solid var(--red6) !important;
}
.is-invalid-select > div:first-of-type:hover {
  border-color: var(--red6) !important;
}
.is-invalid-select > div:first-of-type:focus {
  border-color: var(--red6) !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.flex-column {
  flex-direction: column !important;
}

.d-none {
  display: none !important;
}

.d-flex {
  display: flex !important;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-5 {
  gap: 1.25rem;
}

.gap-6 {
  gap: 1.5rem;
}

.d-inline {
  display: inline-flex !important;
}

.align-items-center {
  align-items: center !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.p-1 {
  padding: 0.25rem;
}

.p-2 {
  padding: 0.5rem;
}

.p-3 {
  padding: 1rem;
}

.p-4 {
  padding: 1.5rem;
}

.p-5 {
  padding: 1.5rem;
}

.p-0 {
  padding: 0;
}

.m-1 {
  margin: 0.25rem;
}

.m-2 {
  margin: 0.5rem;
}

.m-3 {
  margin: 1rem;
}

.m-4 {
  margin: 1.5rem;
}

.m-5 {
  margin: 1.5rem;
}

.m-0 {
  margin: 0;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.m-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.mr-0 {
  margin-right: 0 !important;
}

.mr-1 {
  margin-right: 0.25rem !important;
}

.mr-2 {
  margin-right: 0.5rem !important;
}

.mr-3 {
  margin-right: 1rem !important;
}

.mr-4 {
  margin-right: 1.5rem !important;
}

.mr-5 {
  margin-right: 3rem !important;
}

.ml-0 {
  margin-left: 0 !important;
}

.ml-1 {
  margin-left: 0.25rem !important;
}

.ml-2 {
  margin-left: 0.5rem !important;
}

.ml-3 {
  margin-left: 1rem !important;
}

.ml-4 {
  margin-left: 1.5rem !important;
}

.ml-5 {
  margin-left: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ml-auto {
  margin-left: auto;
}

.mr-auto {
  margin-right: auto;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pr-0 {
  padding-right: 0 !important;
}

.pr-1 {
  padding-right: 0.25rem !important;
}

.pr-2 {
  padding-right: 0.5rem !important;
}

.pr-3 {
  padding-right: 1rem !important;
}

.pr-4 {
  padding-right: 1.5rem !important;
}

.pr-5 {
  padding-right: 3rem !important;
}

.pl-0 {
  padding-left: 0 !important;
}

.pl-1 {
  padding-left: 0.25rem !important;
}

.pl-2 {
  padding-left: 0.5rem !important;
}

.pl-3 {
  padding-left: 1rem !important;
}

.pl-4 {
  padding-left: 1.5rem !important;
}

.pl-5 {
  padding-left: 3rem !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.d-none {
  display: none !important;
}

.d-flex {
  display: flex !important;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-5 {
  gap: 1.25rem;
}

.gap-6 {
  gap: 1.5rem;
}

.d-inline {
  display: inline-flex !important;
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h3, .h3 {
  font-size: 1.75rem;
}

h6, .h6 {
  font-size: 1rem;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid var(--black1);
}

small, .small {
  font-size: 80%;
  font-weight: 400;
}

a {
  color: #6a3ce2;
  text-decoration: none;
  background-color: rgba(0, 0, 0, 0);
}
a:hover {
  text-decoration: none;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.__react-grand-tour__highlight {
  transition: transform 0.5s ease, height 0.3s ease, width 0.3s ease !important;
}

.__react-grand-tour__modal-position-track {
  transition: all 0.3s !important;
}

.dark .__react-grand-tour__highlight {
  box-shadow: 0 0 0 calc(200vh + 200vw) rgba(0, 0, 0, 0.7) !important;
}

.__react-grand-tour__highlight {
  box-shadow: 0 0 0 calc(200vh + 200vw) rgba(255, 255, 255, 0.92) !important;
  position: relative;
}
.__react-grand-tour__highlight.left:after {
  right: auto;
  top: calc(50% - 8px);
  left: calc(100% - 8px);
}
.__react-grand-tour__highlight.top:after {
  left: calc(50% - 8px);
  top: -10px;
}
.__react-grand-tour__highlight.right:after {
  right: calc(100% - 10px);
  top: calc(50% - 8px);
  left: auto;
}
.__react-grand-tour__highlight:after {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  background: var(--purple6);
  border-radius: 100%;
  border: 1px solid var(--purple6);
  box-shadow: 0 0 0 2px inset var(--white);
  left: calc(100% - 12px);
  top: calc(50% - 10px);
}

.paylixecommerce-onboarding {
  font-size: 13px;
  font-weight: 400;
  color: var(--black5);
}
.paylixecommerce-onboarding b {
  display: flex;
  width: 100%;
  margin-bottom: 0.5rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  color: var(--black9);
}
.paylixecommerce-onboarding-navigation {
  margin-top: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 296px;
  width: 100%;
}
.paylixecommerce-onboarding-navigation-note {
  font-size: 0.7rem;
  color: var(--black4);
  text-align: center;
  margin-top: 0.5rem;
}
.paylixecommerce-onboarding-navigation-dots {
  display: flex;
  flex-wrap: wrap;
  margin: 0 0.5rem;
  gap: 0.25rem;
}
.paylixecommerce-onboarding-navigation-dots > div {
  width: 1rem;
  height: 1rem;
  border: 1px solid var(--black3);
  border-radius: 0.25rem;
  cursor: pointer;
}
.paylixecommerce-onboarding-navigation-dots > div:nth-child(11n) {
  margin-right: 0;
}
.paylixecommerce-onboarding-navigation-dots > div.active {
  background: var(--purple6);
  border: 1px solid var(--purple6);
}
.paylixecommerce-onboarding-navigation i {
  cursor: pointer;
}
.paylixecommerce-onboarding-close {
  position: relative;
  font-size: 1rem !important;
  color: var(--black4) !important;
}
.paylixecommerce-onboarding-container {
  background: var(--white);
  border: 1px solid var(--black2);
  padding: 1.25rem;
  border-radius: 0.5rem;
  color: var(--black9);
  position: relative;
}
.paylixecommerce-onboarding-container .__react-grand-tour__close-button {
  background: var(--black1);
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 100%;
  top: 1.25rem;
  right: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dark .edit-modal-footer {
  background: var(--black0);
}
.dark .edit-modal-header {
  background: var(--black0);
}

.edit-modal {
  position: fixed;
  top: 1rem;
  height: calc(100vh - 2rem);
  max-height: calc(100vh - 2rem);
  min-height: calc(100vh - 2rem);
  overflow: auto;
  width: 50vw;
  right: 1rem;
  background: var(--white);
  padding: 2rem;
  border-radius: 0.5rem;
  z-index: 999999999;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.edit-modal-body::-webkit-scrollbar {
  width: 0;
  height: 0;
  background-color: transparent;
}
.edit-modal-body::-webkit-scrollbar-track {
  background-color: transparent;
}
.edit-modal-body::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
}
.edit-modal::-webkit-scrollbar {
  width: 0;
  height: 0;
  background-color: transparent;
}
.edit-modal::-webkit-scrollbar-track {
  background-color: transparent;
}
.edit-modal::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
}
.edit-modal-header {
  padding: 0;
  flex-shrink: 0;
  position: relative;
}
.edit-modal-header-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: var(--black9);
}
.edit-modal-header-badge {
  position: absolute;
  top: 1.75rem;
  right: 2rem;
}
.edit-modal-header-ref {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--black5);
  border-bottom: 1px solid var(--black1);
  margin-bottom: 2rem;
  margin-top: 0.5rem;
}
.edit-modal-header-ref p {
  margin-bottom: 1rem;
}
.edit-modal-header-ref p:last-child {
  margin-bottom: 0;
}
.edit-modal-body {
  flex-grow: 1;
  padding-bottom: calc(5rem - 1px) !important;
}
.edit-modal-footer {
  flex-shrink: 0;
  display: flex;
  padding: 1.25rem;
  box-shadow: 0px -1px 3px rgba(7, 14, 35, 0.04), 0px -4px 8px -1px rgba(7, 14, 35, 0.04);
  justify-content: flex-end;
  height: calc(5rem - 1px);
  position: fixed;
  bottom: 1rem;
  width: 50%;
  background: var(--white);
  border-radius: 0 0 0.5rem 0.5rem;
  z-index: 2;
  gap: 1rem;
}
.edit-modal.padding {
  padding: 0;
}
.edit-modal.padding .edit-modal-header {
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  border-bottom: 1px solid var(--black2);
}
.edit-modal.padding .edit-modal-header-ref {
  margin-bottom: 0;
  border-bottom: 0;
}
.edit-modal-overlay {
  position: fixed;
  background: rgba(0, 0, 0, 0.3137254902);
  width: 100vw;
  height: 100vh;
  top: 0;
  right: 0;
  cursor: pointer;
  z-index: 999999999;
  backdrop-filter: blur(2px);
}

@media (max-width: 768px) {
  .edit-modal {
    width: 100vw;
    height: 100%;
    max-height: 100%;
    min-height: 100%;
    border-radius: 0;
    top: 0;
    right: 0;
    padding: 1.25rem 1rem;
  }
  .edit-modal-body {
    padding-bottom: 6rem !important;
  }
  .edit-modal-header {
    padding: 1.25rem 1rem;
  }
  .edit-modal-header-title {
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
  }
  .edit-modal-header-badge {
    top: 1rem;
    right: 1rem;
  }
  .edit-modal-header-ref {
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    margin-top: 0.75rem;
  }
  .edit-modal-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: var(--white);
    z-index: 9;
  }
  .edit-modal.padding .edit-modal-header {
    padding: 1rem 1.25rem;
  }
}
.table-mobile-card {
  background: var(--white);
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}
.table-mobile-card-header {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid var(--black1);
}
.table-mobile-card-header-main {
  display: flex;
  flex-direction: column;
}
.table-mobile-card-header-main > a {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: var(--black9);
  display: flex;
}
.table-mobile-card-header-main div {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--black4);
  display: flex;
  margin-top: 0.25rem;
}
.table-mobile-card-header-icon {
  background: var(--black0);
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  object-fit: fill;
  margin-right: 0.75rem;
  background: var(--black0);
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-mobile-card-header-icon svg * {
  stroke: var(--black3);
}
.table-mobile-card-header-icon img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  overflow: hidden;
  border-radius: 0.5rem;
}
.table-mobile-card-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}
.table-mobile-card-body-list {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.table-mobile-card-body-list > div {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: var(--black5);
  margin-bottom: 0.75rem;
}
.table-mobile-card-body-list > div:last-child {
  margin-bottom: 0;
}
.table-mobile-card-body-list > div > div:first-child {
  padding-right: 1rem;
}
.table-mobile-card-body-list > div > div:last-child {
  color: var(--black9);
}
.table-mobile-card-body-info {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: var(--black9);
}
@media (max-width: 360px) {
  .table-mobile-card-body-info div {
    width: 100%;
    margin-bottom: 0.5rem;
    margin-right: 0 !important;
    display: flex;
    justify-content: flex-end;
  }
  .table-mobile-card-body-info div:last-child {
    margin-bottom: 0;
  }
}
.table-mobile-card-footer {
  display: flex;
  padding: 1rem;
  padding-top: 0;
  justify-content: space-between;
}
.table-mobile-card-footer button {
  width: calc(50% - 0.5rem);
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {
  border-color: #ccc;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: block;
  height: 9px;
  position: absolute;
  top: 6px;
  width: 9px;
}

.react-datepicker__header.react-datepicker__header--time.react-datepicker__header--time--only {
  padding-top: 0.75rem;
  padding-left: 0;
  padding-right: 0;
}

.react-datepicker__time-container .react-datepicker__time {
  padding-top: 0.5rem;
  background-color: var(--black0) !important;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  background: var(--black0);
  color: var(--black9);
  width: 100%;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  background-color: var(--black1) !important;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  margin-left: -4px;
  position: absolute;
  width: 0;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  box-sizing: content-box;
  position: absolute;
  border: 8px solid transparent;
  height: 0;
  width: 1px;
  content: "";
  z-index: -1;
  border-width: 8px;
  left: -8px;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  top: 0;
  margin-top: -8px;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  border-top: none;
  border-bottom-color: #f0f0f0;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  top: 0;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  top: -1px;
  border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {
  bottom: 0;
  margin-bottom: -8px;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {
  border-bottom: none;
  border-top-color: #fff;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {
  bottom: 0;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  bottom: -1px;
  border-top-color: #aeaeae;
}

.react-datepicker-wrapper {
  display: inline-block;
  padding: 0;
  border: 0;
}

.react-datepicker {
  font-family: "Helvetica Neue", helvetica, arial, sans-serif;
  font-size: 0.8rem;
  background-color: #fff;
  color: #000;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  display: inline-block;
  position: relative;
}

.react-datepicker--time-only .react-datepicker__triangle {
  left: 35px;
}

.react-datepicker--time-only .react-datepicker__time-container {
  border-left: 0;
}

.react-datepicker--time-only .react-datepicker__time,
.react-datepicker--time-only .react-datepicker__time-box {
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__triangle {
  position: absolute;
  left: 50px;
}

.react-datepicker-popper {
  z-index: 1;
}

.react-datepicker-popper[data-placement^=bottom] {
  padding-top: 10px;
}

.react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle, .react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle {
  left: auto;
  right: 50px;
}

.react-datepicker-popper[data-placement^=top] {
  padding-bottom: 10px;
}

.react-datepicker-popper[data-placement^=right] {
  padding-left: 8px;
}

.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {
  left: auto;
  right: 42px;
}

.react-datepicker-popper[data-placement^=left] {
  padding-right: 8px;
}

.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {
  left: 42px;
  right: auto;
}

.react-datepicker__header {
  text-align: center;
  background-color: #f0f0f0;
  border-bottom: 1px solid #aeaeae;
  border-top-left-radius: 0.3rem;
  padding: 8px 0;
  position: relative;
}

.react-datepicker__header--time {
  padding-bottom: 8px;
  padding-left: 5px;
  padding-right: 5px;
}

.react-datepicker__header--time:not(.react-datepicker__header--time--only) {
  border-top-left-radius: 0;
}

.react-datepicker__header:not(.react-datepicker__header--has-time-select) {
  border-top-right-radius: 0.3rem;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
  display: inline-block;
  margin: 0 15px;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  margin-top: 0;
  color: #000;
  font-weight: bold;
  font-size: 0.944rem;
}

.react-datepicker-time__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-datepicker__navigation {
  align-items: center;
  background: none;
  display: flex;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 2px;
  padding: 0;
  border: none;
  z-index: 1;
  height: 32px;
  width: 32px;
  text-indent: -999em;
  overflow: hidden;
}

.react-datepicker__navigation--previous {
  left: 2px;
}

.react-datepicker__navigation--next {
  right: 2px;
}

.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 85px;
}

.react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.react-datepicker__navigation--years-previous {
  top: 4px;
}

.react-datepicker__navigation--years-upcoming {
  top: -4px;
}

.react-datepicker__navigation:hover *::before {
  border-color: #a6a6a6;
}

.react-datepicker__navigation-icon {
  position: relative;
  top: -1px;
  font-size: 20px;
  width: 0;
}

.react-datepicker__navigation-icon--next {
  left: -2px;
}

.react-datepicker__navigation-icon--next::before {
  transform: rotate(45deg);
  left: -7px;
}

.react-datepicker__navigation-icon--previous {
  right: -2px;
}

.react-datepicker__navigation-icon--previous::before {
  transform: rotate(225deg);
  right: -7px;
}

.react-datepicker__month-container {
  float: left;
}

.react-datepicker__year {
  margin: 0.4rem;
  text-align: center;
}

.react-datepicker__year-wrapper {
  display: flex;
  flex-wrap: wrap;
  max-width: 180px;
}

.react-datepicker__year .react-datepicker__year-text {
  display: inline-block;
  width: 4rem;
  margin: 2px;
}

.react-datepicker__month {
  margin: 0.4rem;
  text-align: center;
}

.react-datepicker__month .react-datepicker__month-text,
.react-datepicker__month .react-datepicker__quarter-text {
  display: inline-block;
  width: 4rem;
  margin: 2px;
}

.react-datepicker__input-time-container {
  clear: both;
  width: 100%;
  float: left;
  margin: 5px 0 10px 15px;
  text-align: left;
}

.react-datepicker__input-time-container .react-datepicker-time__caption {
  display: inline-block;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container {
  display: inline-block;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {
  display: inline-block;
  margin-left: 10px;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {
  width: auto;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {
  -moz-appearance: textfield;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {
  margin-left: 5px;
  display: inline-block;
}

.react-datepicker__time-container {
  float: right;
  border-left: 1px solid #aeaeae;
  width: 85px;
}

.react-datepicker__time-container--with-today-button {
  display: inline;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  position: absolute;
  right: -87px;
  top: 0;
}

.react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: white;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 85px;
  overflow-x: hidden;
  margin: 0 auto;
  text-align: center;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  height: calc(195px + 0.85rem);
  overflow-y: scroll;
  padding-right: 0;
  padding-left: 0;
  width: 100%;
  box-sizing: content-box;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  height: 30px;
  padding: 5px 10px;
  white-space: nowrap;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #f0f0f0;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #216ba5;
  color: white;
  font-weight: bold;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: #216ba5;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
  color: #ccc;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__week-number {
  color: #ccc;
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  border-radius: 0.3rem;
  background-color: #f0f0f0;
}

.react-datepicker__day-names,
.react-datepicker__week {
  white-space: nowrap;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: #000;
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__day,
.react-datepicker__month-text,
.react-datepicker__quarter-text,
.react-datepicker__year-text {
  cursor: pointer;
}

.react-datepicker__day:hover,
.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover,
.react-datepicker__year-text:hover {
  border-radius: 0.3rem;
  background-color: #f0f0f0;
}

.react-datepicker__day--today,
.react-datepicker__month-text--today,
.react-datepicker__quarter-text--today,
.react-datepicker__year-text--today {
  font-weight: bold;
}

.react-datepicker__day--highlighted,
.react-datepicker__month-text--highlighted,
.react-datepicker__quarter-text--highlighted,
.react-datepicker__year-text--highlighted {
  border-radius: 0.3rem;
  background-color: #3dcc4a;
  color: #fff;
}

.react-datepicker__day--highlighted:hover,
.react-datepicker__month-text--highlighted:hover,
.react-datepicker__quarter-text--highlighted:hover,
.react-datepicker__year-text--highlighted:hover {
  background-color: #32be3f;
}

.react-datepicker__day--highlighted-custom-1,
.react-datepicker__month-text--highlighted-custom-1,
.react-datepicker__quarter-text--highlighted-custom-1,
.react-datepicker__year-text--highlighted-custom-1 {
  color: magenta;
}

.react-datepicker__day--highlighted-custom-2,
.react-datepicker__month-text--highlighted-custom-2,
.react-datepicker__quarter-text--highlighted-custom-2,
.react-datepicker__year-text--highlighted-custom-2 {
  color: green;
}

.react-datepicker__day--holidays,
.react-datepicker__month-text--holidays,
.react-datepicker__quarter-text--holidays,
.react-datepicker__year-text--holidays {
  position: relative;
  border-radius: 0.3rem;
  background-color: #ff6803;
  color: #fff;
}

.react-datepicker__day--holidays .holiday-overlay,
.react-datepicker__month-text--holidays .holiday-overlay,
.react-datepicker__quarter-text--holidays .holiday-overlay,
.react-datepicker__year-text--holidays .holiday-overlay {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 4px;
  border-radius: 4px;
  white-space: nowrap;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.3s ease-in-out;
}

.react-datepicker__day--holidays:hover,
.react-datepicker__month-text--holidays:hover,
.react-datepicker__quarter-text--holidays:hover,
.react-datepicker__year-text--holidays:hover {
  background-color: #cf5300;
}

.react-datepicker__day--holidays:hover .holiday-overlay,
.react-datepicker__month-text--holidays:hover .holiday-overlay,
.react-datepicker__quarter-text--holidays:hover .holiday-overlay,
.react-datepicker__year-text--holidays:hover .holiday-overlay {
  visibility: visible;
  opacity: 1;
}

.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
  border-radius: 0.3rem;
  background-color: #216ba5;
  color: #fff;
}

.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,
.react-datepicker__month-text--selected:hover,
.react-datepicker__month-text--in-selecting-range:hover,
.react-datepicker__month-text--in-range:hover,
.react-datepicker__quarter-text--selected:hover,
.react-datepicker__quarter-text--in-selecting-range:hover,
.react-datepicker__quarter-text--in-range:hover,
.react-datepicker__year-text--selected:hover,
.react-datepicker__year-text--in-selecting-range:hover,
.react-datepicker__year-text--in-range:hover {
  background-color: #1d5d90;
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  border-radius: 0.3rem;
  background-color: #bad9f1;
  color: rgb(0, 0, 0);
}

.react-datepicker__day--keyboard-selected:hover,
.react-datepicker__month-text--keyboard-selected:hover,
.react-datepicker__quarter-text--keyboard-selected:hover,
.react-datepicker__year-text--keyboard-selected:hover {
  background-color: #1d5d90;
}

.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range) {
  background-color: rgba(33, 107, 165, 0.5);
}

.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range) {
  background-color: #f0f0f0;
  color: #000;
}

.react-datepicker__day--disabled,
.react-datepicker__month-text--disabled,
.react-datepicker__quarter-text--disabled,
.react-datepicker__year-text--disabled {
  cursor: default;
  color: #ccc;
}

.react-datepicker__day--disabled:hover,
.react-datepicker__month-text--disabled:hover,
.react-datepicker__quarter-text--disabled:hover,
.react-datepicker__year-text--disabled:hover {
  background-color: transparent;
}

.react-datepicker__input-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.react-datepicker__input-container .react-datepicker__calendar-icon {
  position: absolute;
  padding: 0.5rem;
}

.react-datepicker__view-calendar-icon input {
  padding: 6px 10px 5px 25px;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  border: 1px solid transparent;
  border-radius: 0.3rem;
  position: relative;
}

.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
  cursor: pointer;
}

.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
  border-top-color: #b3b3b3;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  transform: rotate(135deg);
  right: -16px;
  top: 0;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #f0f0f0;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 30px;
  z-index: 1;
  text-align: center;
  border-radius: 0.3rem;
  border: 1px solid #aeaeae;
}

.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
  cursor: pointer;
}

.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
  height: 150px;
  overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
  line-height: 20px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}

.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #ccc;
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
  border-bottom-color: #b3b3b3;
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
  border-top-color: #b3b3b3;
}

.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  position: absolute;
  left: 15px;
}

.react-datepicker__close-icon {
  cursor: pointer;
  background-color: transparent;
  border: 0;
  outline: 0;
  padding: 0 6px 0 0;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: table-cell;
  vertical-align: middle;
}

.react-datepicker__close-icon::after {
  cursor: pointer;
  background-color: #216ba5;
  color: #fff;
  border-radius: 50%;
  height: 16px;
  width: 16px;
  padding: 2px;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  content: "×";
}

.react-datepicker__today-button {
  background: #f0f0f0;
  border-top: 1px solid #aeaeae;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  padding: 5px 0;
  clear: left;
}

.react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 2147483647;
}

.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}

@media (max-width: 400px), (max-height: 550px) {
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    line-height: 2rem;
  }
}
.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.44rem;
}

.react-datepicker__children-container {
  width: 13.8rem;
  margin: 0.4rem;
  padding-right: 0.2rem;
  padding-left: 0.2rem;
  height: auto;
}

.react-datepicker__aria-live {
  position: absolute;
  clip-path: circle(0);
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  width: 1px;
  white-space: nowrap;
}

.react-datepicker__calendar-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
}

.react-datepicker-popper {
  z-index: 2;
}

.paylixecommerce-date-picker-wrapper {
  width: 100%;
}

.react-datepicker {
  --mainBackPicker: white;
  --mainColorPicker: #121417;
  background-color: white;
}

.dark .react-datepicker {
  --mainBackPicker: #121417 !important;
  --mainColorPicker: white !important;
  background-color: #121417;
}
.dark .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .dark .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  border-bottom-color: #131417;
}
.dark .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .dark .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {
  border-top-color: #131417;
}

.react-datepicker__triangle {
  position: absolute !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  border-bottom-color: white !important;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  border-top-color: white !important;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  --mainBackPicker: #454C56;
  --mainColorPicker: white;
  border-bottom-color: white;
}

.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=left] .react-datepicker__triangle::before {
  border-bottom-color: var(--mainBackPicker) !important;
}

.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=right] .react-datepicker__triangle::before {
  border-top-color: var(--mainBackPicker) !important;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #6a3ce2;
  color: white;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: #6a3ce2;
}

.react-datepicker-popper {
  background: transparent;
  border-radius: 3px;
}
.react-datepicker-popper .react-datepicker {
  box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08), 0 2px 24px -2px rgba(7, 14, 35, 0.12);
  border-radius: 0.5rem;
  border: none;
}
.react-datepicker-popper .react-datepicker__triangle::before {
  border: none !important;
}
.react-datepicker-popper .react-datepicker__header {
  border-bottom: 0;
  border-radius: 0.5rem 0.5rem 0 0;
  background: var(--mainBackPicker);
  padding-top: 1.25rem;
}
.react-datepicker-popper .react-datepicker__day--keyboard-selected {
  border-radius: 100% !important;
  background-color: #6a3ce2 !important;
}
.react-datepicker-popper .react-datepicker__day:hover {
  border-radius: 100% !important;
  background-color: #a191f4 !important;
  color: white;
}
.react-datepicker-popper .react-datepicker__day--disabled, .react-datepicker-popper .react-datepicker__month-text--disabled, .react-datepicker-popper .react-datepicker__quarter-text--disabled {
  color: #b4aebc !important;
}
.react-datepicker-popper .react-datepicker__day--selected, .react-datepicker-popper .react-datepicker__day--in-selecting-range, .react-datepicker-popper .react-datepicker__day--in-range, .react-datepicker-popper .react-datepicker__month-text--selected, .react-datepicker-popper .react-datepicker__month-text--in-selecting-range, .react-datepicker-popper .react-datepicker__month-text--in-range, .react-datepicker-popper .react-datepicker__quarter-text--selected, .react-datepicker-popper .react-datepicker__quarter-text--in-selecting-range, .react-datepicker-popper .react-datepicker__quarter-text--in-range {
  background: #6a3ce2;
  color: white !important;
  font-weight: 600;
}
.react-datepicker-popper .react-datepicker__day--selected:hover, .react-datepicker-popper .react-datepicker__day--in-selecting-range:hover, .react-datepicker-popper .react-datepicker__day--in-range:hover, .react-datepicker-popper .react-datepicker__month-text--selected:hover, .react-datepicker-popper .react-datepicker__month-text--in-selecting-range:hover, .react-datepicker-popper .react-datepicker__month-text--in-range:hover, .react-datepicker-popper .react-datepicker__quarter-text--selected:hover, .react-datepicker-popper .react-datepicker__quarter-text--in-selecting-range:hover, .react-datepicker-popper .react-datepicker__quarter-text--in-range:hover {
  background-color: #6a3ce2;
}
.react-datepicker-popper .react-datepicker__current-month, .react-datepicker-popper .react-datepicker-time__header, .react-datepicker-popper .react-datepicker-year-header {
  color: var(--mainColorPicker);
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
}
.react-datepicker-popper .react-datepicker__navigation {
  top: 0.75rem;
}
.react-datepicker-popper .react-datepicker__navigation:focus {
  outline: none;
  border-radius: 3px;
}
.react-datepicker-popper .react-datepicker__day-names {
  padding-top: 0.5rem;
  padding-bottom: 0;
  color: var(--mainColorPicker);
  margin: 0;
}
.react-datepicker-popper .react-datepicker__day-name, .react-datepicker-popper .react-datepicker__day, .react-datepicker-popper .react-datepicker__time-name {
  height: 40px;
  width: 40px;
  line-height: 40px;
  font-size: 13px;
  font-weight: 500;
  margin: 0;
  border-radius: 100%;
  background-color: #6a3ce2;
}
.react-datepicker-popper .react-datepicker__day-name:focus, .react-datepicker-popper .react-datepicker__day:focus, .react-datepicker-popper .react-datepicker__time-name:focus {
  border-radius: 3px;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  border-bottom-color: var(--mainBackPicker) !important;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  border-top-color: var(--mainBackPicker) !important;
}

.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=left] .react-datepicker__triangle::before {
  border-bottom-color: var(--mainBackPicker) !important;
}

.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=right] .react-datepicker__triangle::before {
  border-top-color: var(--mainBackPicker) !important;
}

.dark .react-datepicker-popper .react-datepicker__day--selected, .dark .react-datepicker-popper .react-datepicker__day--in-selecting-range, .dark .react-datepicker-popper .react-datepicker__day--in-range, .dark .react-datepicker-popper .react-datepicker__month-text--selected, .dark .react-datepicker-popper .react-datepicker__month-text--in-selecting-range, .dark .react-datepicker-popper .react-datepicker__month-text--in-range, .dark .react-datepicker-popper .react-datepicker__quarter-text--selected, .dark .react-datepicker-popper .react-datepicker__quarter-text--in-selecting-range, .dark .react-datepicker-popper .react-datepicker__quarter-text--in-range {
  background: var(--mainColorPicker);
  color: white !important;
  border-radius: 100%;
}
.dark .react-datepicker-popper .react-datepicker__day--selected:hover, .dark .react-datepicker-popper .react-datepicker__day--in-selecting-range:hover, .dark .react-datepicker-popper .react-datepicker__day--in-range:hover, .dark .react-datepicker-popper .react-datepicker__month-text--selected:hover, .dark .react-datepicker-popper .react-datepicker__month-text--in-selecting-range:hover, .dark .react-datepicker-popper .react-datepicker__month-text--in-range:hover, .dark .react-datepicker-popper .react-datepicker__quarter-text--selected:hover, .dark .react-datepicker-popper .react-datepicker__quarter-text--in-selecting-range:hover, .dark .react-datepicker-popper .react-datepicker__quarter-text--in-range:hover {
  background: var(--mainColorPicker);
  color: var(--mainBackPicker) !important;
}
.dark .react-datepicker-popper .react-datepicker__current-month, .dark .react-datepicker-popper .react-datepicker-time__header, .dark .react-datepicker-popper .react-datepicker-year-header {
  color: var(--mainColorPicker);
}
.dark .react-datepicker-popper .react-datepicker__day-name, .dark .react-datepicker-popper .react-datepicker__day, .dark .react-datepicker-popper .react-datepicker__time-name {
  color: white;
  background-color: var(--mainBackPicker);
}

.react-datepicker-popper .react-datepicker {
  border: none;
}
.react-datepicker-popper .react-datepicker__header {
  background: var(--mainBackPicker);
  padding-top: 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: 0;
  border: none;
}
.react-datepicker-popper .react-datepicker__day--disabled, .react-datepicker-popper .react-datepicker__month-text--disabled, .react-datepicker-popper .react-datepicker__quarter-text--disabled {
  color: #b4aebc !important;
}
.react-datepicker-popper .react-datepicker__day--selected, .react-datepicker-popper .react-datepicker__day--in-selecting-range, .react-datepicker-popper .react-datepicker__day--in-range, .react-datepicker-popper .react-datepicker__month-text--selected, .react-datepicker-popper .react-datepicker__month-text--in-selecting-range, .react-datepicker-popper .react-datepicker__month-text--in-range, .react-datepicker-popper .react-datepicker__quarter-text--selected, .react-datepicker-popper .react-datepicker__quarter-text--in-selecting-range, .react-datepicker-popper .react-datepicker__quarter-text--in-range {
  background: var(--mainColorPicker);
  color: white !important;
  border-radius: 100%;
}
.react-datepicker-popper .react-datepicker__day--selected:hover, .react-datepicker-popper .react-datepicker__day--in-selecting-range:hover, .react-datepicker-popper .react-datepicker__day--in-range:hover, .react-datepicker-popper .react-datepicker__month-text--selected:hover, .react-datepicker-popper .react-datepicker__month-text--in-selecting-range:hover, .react-datepicker-popper .react-datepicker__month-text--in-range:hover, .react-datepicker-popper .react-datepicker__quarter-text--selected:hover, .react-datepicker-popper .react-datepicker__quarter-text--in-selecting-range:hover, .react-datepicker-popper .react-datepicker__quarter-text--in-range:hover {
  background: var(--mainColorPicker);
  color: var(--mainBackPicker) !important;
}
.react-datepicker-popper .react-datepicker__current-month, .react-datepicker-popper .react-datepicker-time__header, .react-datepicker-popper .react-datepicker-year-header {
  color: var(--mainColorPicker);
}
.react-datepicker-popper .react-datepicker__day-name, .react-datepicker-popper .react-datepicker__day, .react-datepicker-popper .react-datepicker__time-name {
  color: #121417;
  background-color: var(--mainBackPicker);
}
.react-datepicker-popper .react-datepicker__day-name--selected, .react-datepicker-popper .react-datepicker__day--selected, .react-datepicker-popper .react-datepicker__time-name--selected {
  background-color: #6a3ce2 !important;
}

.react-datepicker-popper .react-datepicker__navigation {
  top: 1rem;
}

.react-datepicker__navigation-icon {
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  right: 0;
}

.react-datepicker__navigation.react-datepicker__navigation--previous {
  left: 1.5rem;
  right: auto;
}

.dark .react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

.react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  width: 20px;
  height: 20px;
  border: none;
  transform: none;
  left: 0;
  top: 0;
}

.react-datepicker__navigation.react-datepicker__navigation--next {
  right: 1.5rem;
  left: auto;
}

.dark .react-datepicker__navigation-icon.react-datepicker__navigation-icon--next:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.react-datepicker__navigation-icon.react-datepicker__navigation-icon--next:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  width: 20px;
  height: 20px;
  border: none;
  transform: none;
  left: 0;
  top: 0;
}

.react-datepicker__month {
  margin: 0;
  padding-bottom: 1.5rem;
}

.shadow-none {
  box-shadow: none !important;
}

@media (max-width: 768px) {
  .md\\:shadow-none {
    box-shadow: none !important;
  }
}
.dropdown-custom-item-option {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 0 0.5rem;
  height: 36px;
  cursor: pointer;
  border-radius: 0.375rem;
  gap: 0.75rem;
  color: var(--black5);
  font-weight: 500;
}
.dropdown-custom-item-option.selected {
  background-color: var(--black1);
  color: var(--black9);
}
.dropdown-custom-item-option:hover {
  background-color: var(--black1);
  color: var(--black9);
}
.dropdown-custom-item-option img {
  width: 1.75rem;
  height: 1.125rem;
}
.dropdown-custom-item-value {
  display: flex;
  width: 100%;
  padding: 0.25rem 1rem;
  cursor: pointer;
  position: absolute;
  pointer-events: none;
  align-items: center;
  justify-content: flex-start;
  color: var(--black9);
  gap: 0.75rem;
  font-weight: 500;
}
.dropdown-custom-item-value img {
  width: 1.75rem;
  height: 1.125rem;
}

html.dark {
  --black0: #121417;
  --black1: #262A30;
  --black2: #262A30;
  --black3: #A2AAB4;
  --black4: #777F89;
  --black5: #777F89;
  --black6: #454C56;
  --black7: #A2AAB4;
  --black9: white;
  --white: #1B1F23;
  --black: white;
  --purple0: #43248e57;
  --purple1: #43248e57;
  --red0: #381E1D;
  --orange0: #35241E;
  --green0: #14312075;
  --pink0: #70133875;
  --blue0: #1E3A8A75;
  --cyan0: #164E6375;
}

html {
  height: 100%;
  height: -webkit-fill-available;
  min-height: 100%;
  overflow: hidden;
}
html body {
  height: 100%;
  height: -webkit-fill-available;
  min-height: 100%;
  background-color: var(--black0);
  font-family: "Inter", sans-serif !important;
}
html body #app {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  background: var(--black0);
  height: 100%;
  height: -webkit-fill-available;
  min-height: 100%;
}
html body #app .app {
  width: 100%;
  height: 100%;
  height: -webkit-fill-available;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
html body #app .app-body {
  display: flex;
  background: var(--black0);
  flex: 1;
  width: 100%;
  max-width: 100%;
  height: 100%;
}
html body #app .app-body > .main {
  flex: 1;
  min-width: 0;
  background: var(--black0);
  transition: margin-left 0.3s ease;
  margin-left: 240px;
  overflow-x: hidden;
  overflow-y: auto;
}
html body #app .app-body > .main *::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  background-color: transparent;
}
html body #app .app-body > .main *::-webkit-scrollbar-track {
  border-radius: 3px;
  background-color: transparent;
}
html body #app .app-body > .main *::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.3);
}
html body #app .app-body > .main.minimized {
  margin-left: 68px;
}
@media (max-width: 768px) {
  html body #app .app-body > .main.minimized {
    margin-left: 0;
  }
}
html body #app .app-body > .main .container {
  max-width: 1280px;
  width: 100%;
  padding: 0 1.5rem;
  margin-right: auto;
  margin-left: auto;
  background: var(--black0);
  padding-bottom: 1.5rem;
}
@media (max-width: 768px) {
  html body #app .app-body > .main .container {
    padding: 0 1rem;
    padding-bottom: 1rem;
  }
}
@media (max-width: 768px) {
  html body #app .app-body > .main {
    margin-left: 0;
  }
}
html a {
  color: var(--purple6);
  text-decoration: none;
  background-color: rgba(0, 0, 0, 0);
  transition: all 0.3s ease;
}
html a:hover {
  color: var(--purple5);
}

.standard-block {
  padding: 1.25rem;
  background: var(--white);
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08), 0px 2px 8px -2px rgba(7, 14, 35, 0.05);
}
@media (max-width: 768px) {
  .standard-block {
    padding: 1rem;
  }
}

.standard-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  margin-bottom: 1rem;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .standard-title {
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 0.5rem;
  }
}

html *, html :before, html :after {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: transparent;
}
html img, html svg {
  display: inline;
}
html .table {
  display: initial;
}

.intercom-namespace .intercom-app > div:not(.intercom-messenger-frame) {
  z-index: 9999999;
}

.custom-animation {
  -webkit-transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  will-change: transform;
  transform: translate3d(0, 0, 0);
}

.flipIn {
  -webkit-backface-visibility: visible !important;
  backface-visibility: visible !important;
  -webkit-animation-name: flipIn;
  -webkit-animation-duration: 0.35s;
  -webkit-animation-fill-mode: both;
  animation-name: flipIn;
  animation-duration: 0.35s;
  animation-fill-mode: both;
}

@keyframes flipIn {
  0% {
    -webkit-transform: perspective(600px) rotateX(50deg);
    transform: perspective(600px) rotateX(50deg);
    opacity: 0.5;
  }
  0%, 40% {
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  40% {
    -webkit-transform: perspective(600px) rotateX(0deg);
    transform: perspective(600px) rotateX(0deg);
  }
  60% {
    -webkit-transform: perspective(600px) rotateX(0deg);
    transform: perspective(600px) rotateX(0deg);
    opacity: 1;
  }
  80% {
    -webkit-transform: perspective(600px) rotateX(0deg);
    transform: perspective(600px) rotateX(0deg);
  }
  to {
    -webkit-transform: perspective(600px);
    transform: perspective(600px);
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/app.scss","webpack://./client/entrypoints/dashboard/styles.scss","webpack://./client/assets/scss/bootstrap.scss","webpack://./client/assets/scss/_root.scss","webpack://./client/assets/scss/_reboot.scss","webpack://./client/assets/scss/_variables.scss","webpack://./client/assets/scss/_type.scss","webpack://./client/assets/scss/_buttons.scss","webpack://./client/assets/scss/_transitions.scss","webpack://./client/assets/scss/_button-group.scss","webpack://./client/assets/scss/_pagination.scss","webpack://./client/assets/scss/_spinners.scss","webpack://./client/assets/NEW/_react-code.scss","webpack://./client/assets/fontawesome/scss/fontawesome.scss","webpack://./client/assets/fontawesome/scss/_core.scss","webpack://./client/assets/fontawesome/scss/_sizing.scss","webpack://./client/assets/fontawesome/scss/_mixins.scss","webpack://./client/assets/fontawesome/scss/_fixed-width.scss","webpack://./client/assets/fontawesome/scss/_variables.scss","webpack://./client/assets/fontawesome/scss/_list.scss","webpack://./client/assets/fontawesome/scss/_bordered-pulled.scss","webpack://./client/assets/fontawesome/scss/_animated.scss","webpack://./client/assets/fontawesome/scss/_rotated-flipped.scss","webpack://./client/assets/fontawesome/scss/_stacked.scss","webpack://./client/assets/fontawesome/scss/_icons.scss","webpack://./client/assets/fontawesome/scss/_screen-reader.scss","webpack://./client/assets/fontawesome/scss/brands.scss","webpack://./client/assets/fontawesome/scss/solid.scss","webpack://./client/assets/fontawesome/scss/light.scss","webpack://./client/assets/fontawesome/scss/regular.scss","webpack://./client/assets/fontawesome/scss/thin.scss","webpack://./client/assets/NEW/_font.scss","webpack://./client/assets/NEW/_skeleton.scss","webpack://./client/assets/NEW/_basic.scss","webpack://./client/assets/NEW/_react-chart.scss","webpack://./client/assets/NEW/_screen.scss","webpack://./client/assets/NEW/_badge.scss","webpack://./client/assets/NEW/_fields.scss","webpack://./client/assets/NEW/_sizing.scss","webpack://./client/assets/NEW/onboarding.scss","webpack://./client/assets/NEW/page-modal.scss","webpack://./client/assets/NEW/table-mobile-card.scss","webpack://./client/assets/datepicker/datepicker.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACI,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EAEA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;ADFJ;;ACKA;EACE,cAAA;EACA,iBAAA;ADFF;;ACIA;EACE,cAAA;EACA,iBAAA;ADDF;;ACGA;EACE,cAAA;EACA,iBAAA;ADAF;;ACEA;EACE,cAAA;EACA,iBAAA;ADCF;;ACCA;EACE,cAAA;EACA,iBAAA;ADEF;;ACAA;EACE,cAAA;EACA,iBAAA;ADGF;;ACDA;EACE,cAAA;EACA,iBAAA;ADIF;;ACFA;EACE,cAAA;EACA,iBAAA;ADKF;;ACHA;EACE,cAAA;EACA,iBAAA;ADMF;;ACJA;EACE,cAAA;EACA,iBAAA;ADOF;;ACJA;EACE,YAAA;EACA,gBAAA;ADOF;;ACHA;EACE,cAAA;EACA,kBAAA;ADMF;;ACJA;EACE,cAAA;EACA,kBAAA;ADOF;;ACLA;EACE,cAAA;EACA,kBAAA;ADQF;;ACNA;EACE,cAAA;EACA,kBAAA;ADSF;;ACPA;EACE,cAAA;EACA,kBAAA;ADUF;;ACRA;EACE,cAAA;EACA,kBAAA;ADWF;;ACTA;EACE,cAAA;EACA,kBAAA;ADYF;;ACVA;EACE,cAAA;EACA,kBAAA;ADaF;;ACXA;EACE,cAAA;EACA,kBAAA;ADcF;;ACZA;EACE,cAAA;EACA,kBAAA;ADeF;;ACXA;EACE,cAAA;EACA,eAAA;ADcF;;ACZA;EACE,cAAA;EACA,eAAA;ADeF;;ACbA;EACE,cAAA;EACA,eAAA;ADgBF;;ACdA;EACE,cAAA;EACA,eAAA;ADiBF;;ACfA;EACE,cAAA;EACA,eAAA;ADkBF;;AChBA;EACE,cAAA;EACA,eAAA;ADmBF;;ACjBA;EACE,cAAA;EACA,eAAA;ADoBF;;AClBA;EACE,cAAA;EACA,eAAA;ADqBF;;ACnBA;EACE,cAAA;EACA,eAAA;ADsBF;;ACpBA;EACE,cAAA;EACA,eAAA;ADuBF;;ACnBA;EACE,cAAA;EACA,kBAAA;ADsBF;;ACpBA;EACE,cAAA;EACA,kBAAA;ADuBF;;ACrBA;EACE,cAAA;EACA,kBAAA;ADwBF;;ACtBA;EACE,cAAA;EACA,kBAAA;ADyBF;;ACvBA;EACE,cAAA;EACA,kBAAA;AD0BF;;ACxBA;EACE,cAAA;EACA,kBAAA;AD2BF;;ACzBA;EACE,cAAA;EACA,kBAAA;AD4BF;;AC1BA;EACE,cAAA;EACA,kBAAA;AD6BF;;AC3BA;EACE,cAAA;EACA,kBAAA;AD8BF;;AC5BA;EACE,cAAA;EACA,kBAAA;AD+BF;;AC1BA;EACE,cAAA;EACA,iBAAA;AD6BF;;AC3BA;EACE,cAAA;EACA,iBAAA;AD8BF;;AC5BA;EACE,cAAA;EACA,iBAAA;AD+BF;;AC7BA;EACE,cAAA;EACA,iBAAA;ADgCF;;AC9BA;EACE,cAAA;EACA,iBAAA;ADiCF;;AC/BA;EACE,cAAA;EACA,iBAAA;ADkCF;;AChCA;EACE,cAAA;EACA,iBAAA;ADmCF;;ACjCA;EACE,cAAA;EACA,iBAAA;ADoCF;;AClCA;EACE,cAAA;EACA,iBAAA;ADqCF;;ACnCA;EACE,cAAA;EACA,iBAAA;ADsCF;;ACjCA;EACE,oBAAA;EACA,kBAAA;EACA,oBAAA;ADoCF;;ACjCA;EACE,gBAAA;EACA,kBAAA;ADoCF;;AClCA;EACE,gBAAA;EACA,gBAAA;ADqCF;;ACjCA;EACE,eAAA;EACA,iBAAA;ADoCF;;AClCA;EACE,eAAA;EACA,iBAAA;ADqCF;;ACnCA;EACE,eAAA;EACA,iBAAA;ADsCF;;ACpCA;EACE,eAAA;EACA,iBAAA;ADuCF;;ACrCA;EACE,eAAA;EACA,iBAAA;ADwCF;;ACtCA;EACE,eAAA;EACA,iBAAA;ADyCF;;ACvCA;EACE,eAAA;EACA,iBAAA;AD0CF;;ACxCA;EACE,eAAA;EACA,iBAAA;AD2CF;;AE9YA;;;;;EAAA;ACAA;EAGI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAKF,qNAAA;EACA,yGAAA;EACA,yFAAA;AHiaF;;AIhaA;;;EAGE,sBAAA;AJmaF;;AItZI;EAJJ;IAKM,uBAAA;EJ0ZJ;AACF;;AI9YA;EACE,SAAA;EACA,sCCgX4B;ED/W5B,gBC2X4B;ED1X5B,gBCkY4B;EDjY5B,cCjCS;EDmCT,sBC5CS;ED6CT,8BAAA;EACA,6CAAA;AJgZF;;AIvYA;EACE,cAAA;EACA,cCkb4B;EDjb5B,8BAAA;EACA,SAAA;EACA,aCib4B;ALvC9B;;AIvYA;EACE,WC0R4B;ALgH9B;;AIhYA;EACE,aAAA;EACA,qBCuX4B;EDpX5B,gBCuX4B;EDtX5B,gBCuX4B;ALU9B;;AI/VA;EACE,aAAA;EACA,mBCgL0B;ALkL5B;;AIvVA;;EAEE,iCAAA;EACA,YAAA;EACA,8BAAA;AJ0VF;;AIpVA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AJuVF;;AIjVA;;EAEE,kBAAA;AJoVF;;AIjVA;;;EAGE,aAAA;EACA,mBAAA;AJoVF;;AIjVA;;;;EAIE,gBAAA;AJoVF;;AIjVA;EACE,gBCgQ4B;ALoF9B;;AI/UA;EACE,qBAAA;EACA,cAAA;AJkVF;;AI5UA;EACE,gBAAA;AJ+UF;;AIvUA;;EAEE,mBCyO4B;ALiG9B;;AI3TA;EACE,cCqS4B;EDpS5B,yBC4S4B;ALkB9B;;AIrTA;;EAEE,kBAAA;EACA,cAAA;EACA,wBAAA;AJwTF;;AIrTA;EAAM,eAAA;AJyTN;;AIxTA;EAAM,WAAA;AJ4TN;;AIvTA;EACE,cCxMQ;EDyMR,0BCiDwC;ALyQ1C;AIxTE;EACE,cCgDsC;AL0Q1C;;AI/SE;EAEE,cAAA;EACA,qBAAA;AJiTJ;;AI1SA;;;;EAIE,qCCqJ4B;EDpJ5B,+BAAA;EACA,2BAAA;AJ6SF;;AItSA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AJySF;AIrSE;EACE,cAAA;EACA,kBAAA;AJuSJ;;AInSA;EACE,cC1PQ;ED2PR,qBAAA;AJsSF;AInSE;EACE,cAAA;AJqSJ;;AI5RA;EACE,gBAAA;AJ+RF;;AIzRA;;EAEE,sBAAA;AJ4RF;;AIpRA;EACE,oBAAA;EACA,yBAAA;AJuRF;;AIpRA;EACE,mBCoM4B;EDnM5B,sBCmM4B;EDlM5B,cC5TS;ED6TT,gBAAA;AJuRF;;AIhRA;EAEE,mBAAA;EACA,gCAAA;AJkRF;;AI/QA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AJkRF;;AI1QA;EACE,qBAAA;AJ6QF;;AIvQA;EAEE,gBAAA;AJyQF;;AIjQA;EACE,UAAA;AJoQF;;AI/PA;;;;;EAKE,SAAA;EACA,oBAAA;EACA,oBAAA;AJkQF;;AI9PA;;EAEE,oBAAA;AJiQF;;AI5PA;EACE,eAAA;AJ+PF;;AI5PA;EAGE,iBAAA;AJ6PF;AI1PE;EACE,UAAA;AJ4PJ;;AIrPA;EACE,aAAA;AJwPF;;AIhPA;;;;EAIE,0BAAA;AJmPF;AIhPI;;;;EACE,eAAA;AJqPN;;AI9OA;EACE,UAAA;EACA,kBAAA;AJiPF;;AI5OA;EACE,gBAAA;AJ+OF;;AIrOA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AJwOF;;AIhOA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBC0B4B;EDxB5B,oBAAA;AJkOF;AIhOE;EACE,WAAA;AJkOJ;;AI3NA;;;;;;;EAOE,UAAA;AJ8NF;;AI3NA;EACE,YAAA;AJ8NF;;AIrNA;EACE,oBAAA;EACA,6BAAA;AJwNF;;AIhNA;;;;;;;CAAA;AAWA;EACE,wBAAA;AJgNF;;AI3MA;EACE,UAAA;AJ8MF;;AIxMA;EACE,aAAA;AJ2MF;;AIrMA;EACE,aAAA;EACA,0BAAA;AJwMF;;AInMA;EACE,qBAAA;AJsMF;;AIjMA;EACE,SAAA;AJoMF;;AI7LA;EACE,kBAAA;EACA,eAAA;AJgMF;;AIxLA;EACE,wBAAA;AJ2LF;;AInLA;EACE,wBAAA;AJsLF;;AMzuBA;EACE,gBDsc4B;ALsS9B;;AMvuBE;EACE,gBD0bkB;ECzblB,gBD2a0B;AL+T9B;;AM5uBE;EACE,gBD0bkB;ECzblB,gBD2a0B;ALoU9B;;AMjvBE;EACE,gBD0bkB;ECzblB,gBD2a0B;ALyU9B;;AMtvBE;EACE,gBD0bkB;ECzblB,gBD2a0B;AL8U9B;;AM3vBE;EACE,gBD0bkB;ECzblB,gBD2a0B;ALmV9B;;AMhwBE;EACE,gBD0bkB;ECzblB,gBD2a0B;ALwV9B;;AMnvBA;EACE,yBAAA;ANsvBF;;AMlvBA;EACE,mBD+LO;ALsjBT;AMnvBE;EACE,gBAAA;ANqvBJ;;AMjvBA;EACE,iBAAA;EACA,mBDsLO;ECrLP,cDtDS;AL0yBX;AMlvBE;EACE,aAAA;ANovBJ;;AOvzBA;EACE,qBAAA;EAEA,gBFoa4B;EEna5B,gBF2a4B;EE1a5B,cFQS;EEPT,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;APwzBF;AOtzBE;EACE,cFHO;AL2zBX;AOpzBE;EAEE,UAAA;EACA,kDFojB4B;ALiQhC;AO3yBE;EAGE,oBAAA;EACA,aF8kB0B;AL6N9B;;AO7xBA;EACE,gBFmX4B;EElX5B,cFnBQ;EEoBR,0BFsOwC;AL0jB1C;AO9xBE;EACE,cFqOsC;AL2jB1C;AOxxBE;EAEE,cFzDO;ALk1BX;;AQ/1BE;EACE,UAAA;ARk2BJ;;AQ71BE;EACE,aAAA;ARg2BJ;;AQ51BA;EACE,SAAA;EACA,gBAAA;AR+1BF;;AS52BA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AT+2BF;AS72BE;;EACE,kBAAA;EACA,cAAA;ATg3BJ;AS32BE;;;;;;;;;;;;EAME,UAAA;ATm3BJ;;AS92BA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ATi3BF;AS/2BE;EACE,WAAA;ATi3BJ;;AS32BE;;EAEE,iBAAA;AT82BJ;;AS91BA;EACE,wBAAA;EACA,uBAAA;ATi2BF;AS/1BE;EAGE,cAAA;AT+1BJ;AS51BE;EACE,eAAA;AT81BJ;;AS11BA;EACE,uBAAA;EACA,sBAAA;AT61BF;;AS11BA;EACE,sBAAA;EACA,qBAAA;AT61BF;;ASr1BA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ATw1BF;ASt1BE;;EAEE,WAAA;ATw1BJ;ASr1BE;;EAEE,gBAAA;ATu1BJ;;AUx7BA;EACE,aAAA;AV27BF;;AUx7BA;EACE,kBAAA;EACA,cAAA;EACA,cL+BQ;EK9BR,qBAAA;EACA,sBLDS;EKET,yBAAA;AV27BF;AUz7BE;EACE,UAAA;EACA,cLoRsC;EKlRtC,yBLNO;EKOP,qBLNO;ALg8BX;AUv7BE;EACE,UAAA;EACA,cL4QsC;EK3QtC,yBLbO;EKcP,ULqgCgC;EKpgChC,kDLsjB4B;ALmYhC;;AUp7BE;EACE,iBLw/BgC;ALjEpC;AUp7BE;EACE,UAAA;EACA,WL5BO;EK6BP,qBLCM;ALq7BV;AUn7BE;EACE,cL3BO;EK4BP,oBAAA;EACA,sBLnCO;EKoCP,qBLjCO;ALs9BX;;AW59BA;EACE;IAAK,0CAAA;EXg+BL;AACF;AW79BA;EACE,qBAAA;EACA,WNqxCwB;EMpxCxB,YNoxCwB;EMnxCxB,wBNqxCwB;EMpxCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AX89BF;;AW39BA;EACE,WNgxCwB;EM/wCxB,YN+wCwB;EM9wCxB,mBNgxCwB;ALlT1B;;AWt9BA;EACE;IACE,mBAAA;EXy9BF;EWv9BA;IACE,UAAA;IACA,eAAA;EXy9BF;AACF;AWr9BA;EACE,qBAAA;EACA,WNmvCwB;EMlvCxB,YNkvCwB;EMjvCxB,wBNmvCwB;EMlvCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AXs9BF;;AWn9BA;EACE,WN8uCwB;EM7uCxB,YN6uCwB;ALvR1B;;AWl9BE;EACE;;IAEE,wBAAA;EXq9BJ;AACF;AYvhCA;EACE,WAAA;AZyhCF;AYvhCE;EACE,mCAAA;EACA,gCAAA;EACA,2BAAA;EACA,2BAAA;EACA,0CAAA;EACA,mCAAA;EACA,2BAAA;EACA,+BAAA;EACA,uCAAA;EACA,uBAAA;EACA,wBAAA;EACA,6BAAA;EACA,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,eAAA;EACA,uBAAA;EACA,2CAAA;EACA,qCAAA;AZyhCJ;AYvhCI;EACE,2CAAA;AZyhCN;AYvhCI;EACE,2CAAA;EACA,gDAAA;AZyhCN;AYthCI;EACE,qCAAA;AZwhCN;AYthCI;EAEE,qCAAA;AZuhCN;AYphCI;EAIE,wBAAA;EACA,0BAAA;EACA,gBAAA;EACA,SAAA;AZmhCN;AYhhCI;EAEE,wBAAA;EACA,SAAA;AZihCN;AY/gCI;EACE,qCAAA;AZihCN;;AazkCA;;;EAAA;ACGA;EACE,yDAAA;EACA,iCAAA;Ad6kCF;;Ac1kCA;;;;;;;;;;;;;EAaE,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;Ad6kCF;;AenmCE;EACE,cAAA;AfsmCJ;;AevmCE;EACE,cAAA;Af0mCJ;;Ae3mCE;EACE,cAAA;Af8mCJ;;Ae/mCE;EACE,cAAA;AfknCJ;;AennCE;EACE,cAAA;AfsnCJ;;AevnCE;EACE,cAAA;Af0nCJ;;Ae3nCE;EACE,cAAA;Af8nCJ;;Ae/nCE;EACE,cAAA;AfkoCJ;;AenoCE;EACE,cAAA;AfsoCJ;;AevoCE;EACE,eAAA;Af0oCJ;;AepoCE;ECIA,kBAAA;EACA,kBAAA;EACA,uBAAA;AhBooCF;;Ae1oCE;ECIA,iBAAA;EACA,2BAAA;EACA,uBAAA;AhB0oCF;;AehpCE;ECIA,kBAAA;EACA,2BAAA;EACA,8BAAA;AhBgpCF;;AetpCE;ECIA,iBAAA;EACA,mBAAA;EACA,wBAAA;AhBspCF;;Ae5pCE;ECIA,gBAAA;EACA,2BAAA;EACA,wBAAA;AhB4pCF;;AelqCE;ECIA,cAAA;EACA,sBAAA;EACA,yBAAA;AhBkqCF;;AiBjrCA;EACE,kBAAA;EACA,aCIwB;AlBgrC1B;;AmBtrCA;EACE,qBAAA;EACA,uCAAA;EACA,eAAA;AnByrCF;AmBvrCE;EAAO,kBAAA;AnB0rCT;;AmBvrCA;EACE,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;AnB0rCF;;AoBvsCA;EACE,0CAAA;EACA,6CAAA;EACA,2CAAA;EACA,4CAAA;EACA,sDAAA;ApB0sCF;;AoBvsCA;EACE,WAAA;EACA,0CAAA;ApB0sCF;;AoBvsCA;EACE,YAAA;EACA,yCAAA;ApB0sCF;;AqBztCA;EACE,uBAAA;EACA,6CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;ArB4tCF;;AqBztCA;EACE,uBAAA;EACA,6CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;ArB4tCF;;AqBztCA;EACE,wBAAA;EACA,6CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;ArB4tCF;;AqBztCA;EACE,uBAAA;EACA,6CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;ArB4tCF;;AqBztCA;EACE,uBAAA;EACA,6CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,6DAAA;ArB4tCF;;AqBztCA;EACE,iCAAA;ArB4tCF;;AqBztCA;;EAEE,uBAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,+DAAA;ArB4tCF;;AqBttCA;EACE;;;;;;;IAOE,qBAAA;IACA,uBAAA;IACA,4BAAA;IACA,oBAAA;IACA,uBAAA;ErBytCF;AACF;AqBttCA;EACE;IAAU,mBAAA;ErBytCV;EqBxtCA;IAAM,4CAAA;ErB2tCN;AACF;AqBztCA;EACE;IAAM,oCAAA;ErB4tCN;AACF;AqB1tCA;EACE;IACE,qCAAA;IACA,mBAAA;ErB4tCF;EqB1tCA;IACE,UAAA;IACA,8CAAA;ErB4tCF;AACF;AqBztCA;EACE;IACE,iHAAA;ErB2tCF;AACF;AqBxtCA;EACE;IAAK,uBAAA;ErB2tCL;EqB1tCA;IAAO,yBAAA;ErB6tCP;AACF;AsBv0CA;EACE,wBAAA;AtBy0CF;;AsBt0CA;EACE,yBAAA;AtBy0CF;;AsBt0CA;EACE,yBAAA;AtBy0CF;;AsBt0CA;EACE,uBAAA;AtBy0CF;;AsBt0CA;EACE,uBAAA;AtBy0CF;;AsBt0CA;;EAEE,wBAAA;AtBy0CF;;AsBt0CA;EACE,+CAAA;AtBy0CF;;AuBn2CA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBLmCwB;EKlCxB,YLmCwB;AlBm0C1B;;AuBn2CA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;AvBs2CF;;AuBn2CA;EACE,oBAAA;AvBs2CF;;AuBn2CA;EACE,cAAA;AvBs2CF;;AuBn2CA;EACE,8BAAA;AvBs2CF;;AwBj4CA;gEAAA;AAIE;EAAsC,eAAA;AxBm4CxC;;AwBn4CE;EAAsC,eAAA;AxBu4CxC;;AwBv4CE;EAAsC,eAAA;AxB24CxC;;AwB34CE;EAAsC,eAAA;AxB+4CxC;;AwB/4CE;EAAsC,eAAA;AxBm5CxC;;AwBn5CE;EAAsC,eAAA;AxBu5CxC;;AwBv5CE;EAAsC,eAAA;AxB25CxC;;AwB35CE;EAAsC,eAAA;AxB+5CxC;;AwB/5CE;EAAsC,eAAA;AxBm6CxC;;AwBn6CE;EAAsC,eAAA;AxBu6CxC;;AwBv6CE;EAAsC,gBAAA;AxB26CxC;;AwB36CE;EAAsC,YAAA;AxB+6CxC;;AwB/6CE;EAAsC,gBAAA;AxBm7CxC;;AwBn7CE;EAAsC,aAAA;AxBu7CxC;;AwBv7CE;EAAsC,gBAAA;AxB27CxC;;AwB37CE;EAAsC,gBAAA;AxB+7CxC;;AwB/7CE;EAAsC,gBAAA;AxBm8CxC;;AwBn8CE;EAAsC,gBAAA;AxBu8CxC;;AwBv8CE;EAAsC,gBAAA;AxB28CxC;;AwB38CE;EAAsC,gBAAA;AxB+8CxC;;AwB/8CE;EAAsC,gBAAA;AxBm9CxC;;AwBn9CE;EAAsC,gBAAA;AxBu9CxC;;AwBv9CE;EAAsC,gBAAA;AxB29CxC;;AwB39CE;EAAsC,gBAAA;AxB+9CxC;;AwB/9CE;EAAsC,gBAAA;AxBm+CxC;;AwBn+CE;EAAsC,gBAAA;AxBu+CxC;;AwBv+CE;EAAsC,gBAAA;AxB2+CxC;;AwB3+CE;EAAsC,gBAAA;AxB++CxC;;AwB/+CE;EAAsC,gBAAA;AxBm/CxC;;AwBn/CE;EAAsC,gBAAA;AxBu/CxC;;AwBv/CE;EAAsC,gBAAA;AxB2/CxC;;AwB3/CE;EAAsC,gBAAA;AxB+/CxC;;AwB//CE;EAAsC,gBAAA;AxBmgDxC;;AwBngDE;EAAsC,gBAAA;AxBugDxC;;AwBvgDE;EAAsC,gBAAA;AxB2gDxC;;AwB3gDE;EAAsC,gBAAA;AxB+gDxC;;AwB/gDE;EAAsC,gBAAA;AxBmhDxC;;AwBnhDE;EAAsC,gBAAA;AxBuhDxC;;AwBvhDE;EAAsC,gBAAA;AxB2hDxC;;AwB3hDE;EAAsC,aAAA;AxB+hDxC;;AwB/hDE;EAAsC,gBAAA;AxBmiDxC;;AwBniDE;EAAsC,gBAAA;AxBuiDxC;;AwBviDE;EAAsC,gBAAA;AxB2iDxC;;AwB3iDE;EAAsC,gBAAA;AxB+iDxC;;AwB/iDE;EAAsC,gBAAA;AxBmjDxC;;AwBnjDE;EAAsC,gBAAA;AxBujDxC;;AwBvjDE;EAAsC,gBAAA;AxB2jDxC;;AwB3jDE;EAAsC,gBAAA;AxB+jDxC;;AwB/jDE;EAAsC,gBAAA;AxBmkDxC;;AwBnkDE;EAAsC,gBAAA;AxBukDxC;;AwBvkDE;EAAsC,gBAAA;AxB2kDxC;;AwB3kDE;EAAsC,gBAAA;AxB+kDxC;;AwB/kDE;EAAsC,gBAAA;AxBmlDxC;;AwBnlDE;EAAsC,gBAAA;AxBulDxC;;AwBvlDE;EAAsC,gBAAA;AxB2lDxC;;AwB3lDE;EAAsC,gBAAA;AxB+lDxC;;AwB/lDE;EAAsC,gBAAA;AxBmmDxC;;AwBnmDE;EAAsC,gBAAA;AxBumDxC;;AwBvmDE;EAAsC,aAAA;AxB2mDxC;;AwB3mDE;EAAsC,gBAAA;AxB+mDxC;;AwB/mDE;EAAsC,gBAAA;AxBmnDxC;;AwBnnDE;EAAsC,gBAAA;AxBunDxC;;AwBvnDE;EAAsC,gBAAA;AxB2nDxC;;AwB3nDE;EAAsC,gBAAA;AxB+nDxC;;AwB/nDE;EAAsC,gBAAA;AxBmoDxC;;AwBnoDE;EAAsC,gBAAA;AxBuoDxC;;AwBvoDE;EAAsC,gBAAA;AxB2oDxC;;AwB3oDE;EAAsC,gBAAA;AxB+oDxC;;AwB/oDE;EAAsC,gBAAA;AxBmpDxC;;AwBnpDE;EAAsC,gBAAA;AxBupDxC;;AwBvpDE;EAAsC,gBAAA;AxB2pDxC;;AwB3pDE;EAAsC,gBAAA;AxB+pDxC;;AwB/pDE;EAAsC,gBAAA;AxBmqDxC;;AwBnqDE;EAAsC,gBAAA;AxBuqDxC;;AwBvqDE;EAAsC,gBAAA;AxB2qDxC;;AwB3qDE;EAAsC,gBAAA;AxB+qDxC;;AwB/qDE;EAAsC,gBAAA;AxBmrDxC;;AwBnrDE;EAAsC,gBAAA;AxBurDxC;;AwBvrDE;EAAsC,gBAAA;AxB2rDxC;;AwB3rDE;EAAsC,gBAAA;AxB+rDxC;;AwB/rDE;EAAsC,gBAAA;AxBmsDxC;;AwBnsDE;EAAsC,gBAAA;AxBusDxC;;AwBvsDE;EAAsC,gBAAA;AxB2sDxC;;AwB3sDE;EAAsC,gBAAA;AxB+sDxC;;AwB/sDE;EAAsC,gBAAA;AxBmtDxC;;AwBntDE;EAAsC,gBAAA;AxButDxC;;AwBvtDE;EAAsC,gBAAA;AxB2tDxC;;AwB3tDE;EAAsC,gBAAA;AxB+tDxC;;AwB/tDE;EAAsC,gBAAA;AxBmuDxC;;AwBnuDE;EAAsC,gBAAA;AxBuuDxC;;AwBvuDE;EAAsC,gBAAA;AxB2uDxC;;AwB3uDE;EAAsC,gBAAA;AxB+uDxC;;AwB/uDE;EAAsC,gBAAA;AxBmvDxC;;AwBnvDE;EAAsC,gBAAA;AxBuvDxC;;AwBvvDE;EAAsC,gBAAA;AxB2vDxC;;AwB3vDE;EAAsC,gBAAA;AxB+vDxC;;AwB/vDE;EAAsC,gBAAA;AxBmwDxC;;AwBnwDE;EAAsC,gBAAA;AxBuwDxC;;AwBvwDE;EAAsC,gBAAA;AxB2wDxC;;AwB3wDE;EAAsC,gBAAA;AxB+wDxC;;AwB/wDE;EAAsC,gBAAA;AxBmxDxC;;AwBnxDE;EAAsC,gBAAA;AxBuxDxC;;AwBvxDE;EAAsC,gBAAA;AxB2xDxC;;AwB3xDE;EAAsC,gBAAA;AxB+xDxC;;AwB/xDE;EAAsC,gBAAA;AxBmyDxC;;AwBnyDE;EAAsC,gBAAA;AxBuyDxC;;AwBvyDE;EAAsC,gBAAA;AxB2yDxC;;AwB3yDE;EAAsC,gBAAA;AxB+yDxC;;AwB/yDE;EAAsC,gBAAA;AxBmzDxC;;AwBnzDE;EAAsC,gBAAA;AxBuzDxC;;AwBvzDE;EAAsC,gBAAA;AxB2zDxC;;AwB3zDE;EAAsC,gBAAA;AxB+zDxC;;AwB/zDE;EAAsC,gBAAA;AxBm0DxC;;AwBn0DE;EAAsC,gBAAA;AxBu0DxC;;AwBv0DE;EAAsC,gBAAA;AxB20DxC;;AwB30DE;EAAsC,gBAAA;AxB+0DxC;;AwB/0DE;EAAsC,gBAAA;AxBm1DxC;;AwBn1DE;EAAsC,gBAAA;AxBu1DxC;;AwBv1DE;EAAsC,gBAAA;AxB21DxC;;AwB31DE;EAAsC,gBAAA;AxB+1DxC;;AwB/1DE;EAAsC,gBAAA;AxBm2DxC;;AwBn2DE;EAAsC,gBAAA;AxBu2DxC;;AwBv2DE;EAAsC,gBAAA;AxB22DxC;;AwB32DE;EAAsC,gBAAA;AxB+2DxC;;AwB/2DE;EAAsC,gBAAA;AxBm3DxC;;AwBn3DE;EAAsC,gBAAA;AxBu3DxC;;AwBv3DE;EAAsC,gBAAA;AxB23DxC;;AwB33DE;EAAsC,gBAAA;AxB+3DxC;;AwB/3DE;EAAsC,gBAAA;AxBm4DxC;;AwBn4DE;EAAsC,gBAAA;AxBu4DxC;;AwBv4DE;EAAsC,gBAAA;AxB24DxC;;AwB34DE;EAAsC,gBAAA;AxB+4DxC;;AwB/4DE;EAAsC,gBAAA;AxBm5DxC;;AwBn5DE;EAAsC,gBAAA;AxBu5DxC;;AwBv5DE;EAAsC,gBAAA;AxB25DxC;;AwB35DE;EAAsC,gBAAA;AxB+5DxC;;AwB/5DE;EAAsC,gBAAA;AxBm6DxC;;AwBn6DE;EAAsC,gBAAA;AxBu6DxC;;AwBv6DE;EAAsC,gBAAA;AxB26DxC;;AwB36DE;EAAsC,gBAAA;AxB+6DxC;;AwB/6DE;EAAsC,gBAAA;AxBm7DxC;;AwBn7DE;EAAsC,gBAAA;AxBu7DxC;;AwBv7DE;EAAsC,gBAAA;AxB27DxC;;AwB37DE;EAAsC,gBAAA;AxB+7DxC;;AwB/7DE;EAAsC,gBAAA;AxBm8DxC;;AwBn8DE;EAAsC,gBAAA;AxBu8DxC;;AwBv8DE;EAAsC,gBAAA;AxB28DxC;;AwB38DE;EAAsC,gBAAA;AxB+8DxC;;AwB/8DE;EAAsC,gBAAA;AxBm9DxC;;AwBn9DE;EAAsC,gBAAA;AxBu9DxC;;AwBv9DE;EAAsC,gBAAA;AxB29DxC;;AwB39DE;EAAsC,gBAAA;AxB+9DxC;;AwB/9DE;EAAsC,gBAAA;AxBm+DxC;;AwBn+DE;EAAsC,gBAAA;AxBu+DxC;;AwBv+DE;EAAsC,gBAAA;AxB2+DxC;;AwB3+DE;EAAsC,gBAAA;AxB++DxC;;AwB/+DE;EAAsC,gBAAA;AxBm/DxC;;AwBn/DE;EAAsC,gBAAA;AxBu/DxC;;AwBv/DE;EAAsC,gBAAA;AxB2/DxC;;AwB3/DE;EAAsC,gBAAA;AxB+/DxC;;AwB//DE;EAAsC,gBAAA;AxBmgExC;;AwBngEE;EAAsC,gBAAA;AxBugExC;;AwBvgEE;EAAsC,gBAAA;AxB2gExC;;AwB3gEE;EAAsC,gBAAA;AxB+gExC;;AwB/gEE;EAAsC,gBAAA;AxBmhExC;;AwBnhEE;EAAsC,gBAAA;AxBuhExC;;AwBvhEE;EAAsC,gBAAA;AxB2hExC;;AwB3hEE;EAAsC,gBAAA;AxB+hExC;;AwB/hEE;EAAsC,gBAAA;AxBmiExC;;AwBniEE;EAAsC,gBAAA;AxBuiExC;;AwBviEE;EAAsC,gBAAA;AxB2iExC;;AwB3iEE;EAAsC,gBAAA;AxB+iExC;;AwB/iEE;EAAsC,gBAAA;AxBmjExC;;AwBnjEE;EAAsC,gBAAA;AxBujExC;;AwBvjEE;EAAsC,gBAAA;AxB2jExC;;AwB3jEE;EAAsC,gBAAA;AxB+jExC;;AwB/jEE;EAAsC,gBAAA;AxBmkExC;;AwBnkEE;EAAsC,gBAAA;AxBukExC;;AwBvkEE;EAAsC,gBAAA;AxB2kExC;;AwB3kEE;EAAsC,gBAAA;AxB+kExC;;AwB/kEE;EAAsC,gBAAA;AxBmlExC;;AwBnlEE;EAAsC,gBAAA;AxBulExC;;AwBvlEE;EAAsC,gBAAA;AxB2lExC;;AwB3lEE;EAAsC,gBAAA;AxB+lExC;;AwB/lEE;EAAsC,gBAAA;AxBmmExC;;AwBnmEE;EAAsC,gBAAA;AxBumExC;;AwBvmEE;EAAsC,gBAAA;AxB2mExC;;AwB3mEE;EAAsC,gBAAA;AxB+mExC;;AwB/mEE;EAAsC,gBAAA;AxBmnExC;;AwBnnEE;EAAsC,gBAAA;AxBunExC;;AwBvnEE;EAAsC,gBAAA;AxB2nExC;;AwB3nEE;EAAsC,gBAAA;AxB+nExC;;AwB/nEE;EAAsC,gBAAA;AxBmoExC;;AwBnoEE;EAAsC,gBAAA;AxBuoExC;;AwBvoEE;EAAsC,gBAAA;AxB2oExC;;AwB3oEE;EAAsC,gBAAA;AxB+oExC;;AwB/oEE;EAAsC,gBAAA;AxBmpExC;;AwBnpEE;EAAsC,gBAAA;AxBupExC;;AwBvpEE;EAAsC,gBAAA;AxB2pExC;;AwB3pEE;EAAsC,gBAAA;AxB+pExC;;AwB/pEE;EAAsC,gBAAA;AxBmqExC;;AwBnqEE;EAAsC,gBAAA;AxBuqExC;;AwBvqEE;EAAsC,gBAAA;AxB2qExC;;AwB3qEE;EAAsC,gBAAA;AxB+qExC;;AwB/qEE;EAAsC,gBAAA;AxBmrExC;;AwBnrEE;EAAsC,gBAAA;AxBurExC;;AwBvrEE;EAAsC,gBAAA;AxB2rExC;;AwB3rEE;EAAsC,gBAAA;AxB+rExC;;AwB/rEE;EAAsC,gBAAA;AxBmsExC;;AwBnsEE;EAAsC,aAAA;AxBusExC;;AwBvsEE;EAAsC,aAAA;AxB2sExC;;AwB3sEE;EAAsC,gBAAA;AxB+sExC;;AwB/sEE;EAAsC,gBAAA;AxBmtExC;;AwBntEE;EAAsC,gBAAA;AxButExC;;AwBvtEE;EAAsC,gBAAA;AxB2tExC;;AwB3tEE;EAAsC,gBAAA;AxB+tExC;;AwB/tEE;EAAsC,gBAAA;AxBmuExC;;AwBnuEE;EAAsC,gBAAA;AxBuuExC;;AwBvuEE;EAAsC,gBAAA;AxB2uExC;;AwB3uEE;EAAsC,gBAAA;AxB+uExC;;AwB/uEE;EAAsC,gBAAA;AxBmvExC;;AwBnvEE;EAAsC,gBAAA;AxBuvExC;;AwBvvEE;EAAsC,YAAA;AxB2vExC;;AwB3vEE;EAAsC,gBAAA;AxB+vExC;;AwB/vEE;EAAsC,gBAAA;AxBmwExC;;AwBnwEE;EAAsC,gBAAA;AxBuwExC;;AwBvwEE;EAAsC,gBAAA;AxB2wExC;;AwB3wEE;EAAsC,gBAAA;AxB+wExC;;AwB/wEE;EAAsC,gBAAA;AxBmxExC;;AwBnxEE;EAAsC,gBAAA;AxBuxExC;;AwBvxEE;EAAsC,gBAAA;AxB2xExC;;AwB3xEE;EAAsC,gBAAA;AxB+xExC;;AwB/xEE;EAAsC,gBAAA;AxBmyExC;;AwBnyEE;EAAsC,gBAAA;AxBuyExC;;AwBvyEE;EAAsC,gBAAA;AxB2yExC;;AwB3yEE;EAAsC,gBAAA;AxB+yExC;;AwB/yEE;EAAsC,gBAAA;AxBmzExC;;AwBnzEE;EAAsC,gBAAA;AxBuzExC;;AwBvzEE;EAAsC,gBAAA;AxB2zExC;;AwB3zEE;EAAsC,gBAAA;AxB+zExC;;AwB/zEE;EAAsC,gBAAA;AxBm0ExC;;AwBn0EE;EAAsC,gBAAA;AxBu0ExC;;AwBv0EE;EAAsC,gBAAA;AxB20ExC;;AwB30EE;EAAsC,gBAAA;AxB+0ExC;;AwB/0EE;EAAsC,gBAAA;AxBm1ExC;;AwBn1EE;EAAsC,gBAAA;AxBu1ExC;;AwBv1EE;EAAsC,gBAAA;AxB21ExC;;AwB31EE;EAAsC,gBAAA;AxB+1ExC;;AwB/1EE;EAAsC,gBAAA;AxBm2ExC;;AwBn2EE;EAAsC,gBAAA;AxBu2ExC;;AwBv2EE;EAAsC,gBAAA;AxB22ExC;;AwB32EE;EAAsC,gBAAA;AxB+2ExC;;AwB/2EE;EAAsC,gBAAA;AxBm3ExC;;AwBn3EE;EAAsC,gBAAA;AxBu3ExC;;AwBv3EE;EAAsC,gBAAA;AxB23ExC;;AwB33EE;EAAsC,gBAAA;AxB+3ExC;;AwB/3EE;EAAsC,gBAAA;AxBm4ExC;;AwBn4EE;EAAsC,gBAAA;AxBu4ExC;;AwBv4EE;EAAsC,gBAAA;AxB24ExC;;AwB34EE;EAAsC,gBAAA;AxB+4ExC;;AwB/4EE;EAAsC,gBAAA;AxBm5ExC;;AwBn5EE;EAAsC,gBAAA;AxBu5ExC;;AwBv5EE;EAAsC,gBAAA;AxB25ExC;;AwB35EE;EAAsC,gBAAA;AxB+5ExC;;AwB/5EE;EAAsC,gBAAA;AxBm6ExC;;AwBn6EE;EAAsC,gBAAA;AxBu6ExC;;AwBv6EE;EAAsC,gBAAA;AxB26ExC;;AwB36EE;EAAsC,gBAAA;AxB+6ExC;;AwB/6EE;EAAsC,gBAAA;AxBm7ExC;;AwBn7EE;EAAsC,gBAAA;AxBu7ExC;;AwBv7EE;EAAsC,gBAAA;AxB27ExC;;AwB37EE;EAAsC,gBAAA;AxB+7ExC;;AwB/7EE;EAAsC,gBAAA;AxBm8ExC;;AwBn8EE;EAAsC,gBAAA;AxBu8ExC;;AwBv8EE;EAAsC,gBAAA;AxB28ExC;;AwB38EE;EAAsC,gBAAA;AxB+8ExC;;AwB/8EE;EAAsC,gBAAA;AxBm9ExC;;AwBn9EE;EAAsC,gBAAA;AxBu9ExC;;AwBv9EE;EAAsC,gBAAA;AxB29ExC;;AwB39EE;EAAsC,gBAAA;AxB+9ExC;;AwB/9EE;EAAsC,gBAAA;AxBm+ExC;;AwBn+EE;EAAsC,gBAAA;AxBu+ExC;;AwBv+EE;EAAsC,gBAAA;AxB2+ExC;;AwB3+EE;EAAsC,gBAAA;AxB++ExC;;AwB/+EE;EAAsC,gBAAA;AxBm/ExC;;AwBn/EE;EAAsC,gBAAA;AxBu/ExC;;AwBv/EE;EAAsC,gBAAA;AxB2/ExC;;AwB3/EE;EAAsC,gBAAA;AxB+/ExC;;AwB//EE;EAAsC,gBAAA;AxBmgFxC;;AwBngFE;EAAsC,gBAAA;AxBugFxC;;AwBvgFE;EAAsC,gBAAA;AxB2gFxC;;AwB3gFE;EAAsC,gBAAA;AxB+gFxC;;AwB/gFE;EAAsC,gBAAA;AxBmhFxC;;AwBnhFE;EAAsC,gBAAA;AxBuhFxC;;AwBvhFE;EAAsC,gBAAA;AxB2hFxC;;AwB3hFE;EAAsC,gBAAA;AxB+hFxC;;AwB/hFE;EAAsC,gBAAA;AxBmiFxC;;AwBniFE;EAAsC,gBAAA;AxBuiFxC;;AwBviFE;EAAsC,gBAAA;AxB2iFxC;;AwB3iFE;EAAsC,gBAAA;AxB+iFxC;;AwB/iFE;EAAsC,gBAAA;AxBmjFxC;;AwBnjFE;EAAsC,gBAAA;AxBujFxC;;AwBvjFE;EAAsC,gBAAA;AxB2jFxC;;AwB3jFE;EAAsC,gBAAA;AxB+jFxC;;AwB/jFE;EAAsC,gBAAA;AxBmkFxC;;AwBnkFE;EAAsC,gBAAA;AxBukFxC;;AwBvkFE;EAAsC,gBAAA;AxB2kFxC;;AwB3kFE;EAAsC,gBAAA;AxB+kFxC;;AwB/kFE;EAAsC,gBAAA;AxBmlFxC;;AwBnlFE;EAAsC,gBAAA;AxBulFxC;;AwBvlFE;EAAsC,gBAAA;AxB2lFxC;;AwB3lFE;EAAsC,gBAAA;AxB+lFxC;;AwB/lFE;EAAsC,gBAAA;AxBmmFxC;;AwBnmFE;EAAsC,gBAAA;AxBumFxC;;AwBvmFE;EAAsC,gBAAA;AxB2mFxC;;AwB3mFE;EAAsC,gBAAA;AxB+mFxC;;AwB/mFE;EAAsC,gBAAA;AxBmnFxC;;AwBnnFE;EAAsC,gBAAA;AxBunFxC;;AwBvnFE;EAAsC,gBAAA;AxB2nFxC;;AwB3nFE;EAAsC,gBAAA;AxB+nFxC;;AwB/nFE;EAAsC,gBAAA;AxBmoFxC;;AwBnoFE;EAAsC,gBAAA;AxBuoFxC;;AwBvoFE;EAAsC,gBAAA;AxB2oFxC;;AwB3oFE;EAAsC,gBAAA;AxB+oFxC;;AwB/oFE;EAAsC,gBAAA;AxBmpFxC;;AwBnpFE;EAAsC,gBAAA;AxBupFxC;;AwBvpFE;EAAsC,gBAAA;AxB2pFxC;;AwB3pFE;EAAsC,gBAAA;AxB+pFxC;;AwB/pFE;EAAsC,gBAAA;AxBmqFxC;;AwBnqFE;EAAsC,gBAAA;AxBuqFxC;;AwBvqFE;EAAsC,gBAAA;AxB2qFxC;;AwB3qFE;EAAsC,gBAAA;AxB+qFxC;;AwB/qFE;EAAsC,gBAAA;AxBmrFxC;;AwBnrFE;EAAsC,gBAAA;AxBurFxC;;AwBvrFE;EAAsC,gBAAA;AxB2rFxC;;AwB3rFE;EAAsC,gBAAA;AxB+rFxC;;AwB/rFE;EAAsC,gBAAA;AxBmsFxC;;AwBnsFE;EAAsC,gBAAA;AxBusFxC;;AwBvsFE;EAAsC,gBAAA;AxB2sFxC;;AwB3sFE;EAAsC,gBAAA;AxB+sFxC;;AwB/sFE;EAAsC,gBAAA;AxBmtFxC;;AwBntFE;EAAsC,gBAAA;AxButFxC;;AwBvtFE;EAAsC,gBAAA;AxB2tFxC;;AwB3tFE;EAAsC,gBAAA;AxB+tFxC;;AwB/tFE;EAAsC,gBAAA;AxBmuFxC;;AwBnuFE;EAAsC,gBAAA;AxBuuFxC;;AwBvuFE;EAAsC,gBAAA;AxB2uFxC;;AwB3uFE;EAAsC,gBAAA;AxB+uFxC;;AwB/uFE;EAAsC,gBAAA;AxBmvFxC;;AwBnvFE;EAAsC,gBAAA;AxBuvFxC;;AwBvvFE;EAAsC,gBAAA;AxB2vFxC;;AwB3vFE;EAAsC,gBAAA;AxB+vFxC;;AwB/vFE;EAAsC,gBAAA;AxBmwFxC;;AwBnwFE;EAAsC,gBAAA;AxBuwFxC;;AwBvwFE;EAAsC,gBAAA;AxB2wFxC;;AwB3wFE;EAAsC,gBAAA;AxB+wFxC;;AwB/wFE;EAAsC,gBAAA;AxBmxFxC;;AwBnxFE;EAAsC,gBAAA;AxBuxFxC;;AwBvxFE;EAAsC,gBAAA;AxB2xFxC;;AwB3xFE;EAAsC,gBAAA;AxB+xFxC;;AwB/xFE;EAAsC,gBAAA;AxBmyFxC;;AwBnyFE;EAAsC,gBAAA;AxBuyFxC;;AwBvyFE;EAAsC,gBAAA;AxB2yFxC;;AwB3yFE;EAAsC,gBAAA;AxB+yFxC;;AwB/yFE;EAAsC,gBAAA;AxBmzFxC;;AwBnzFE;EAAsC,gBAAA;AxBuzFxC;;AwBvzFE;EAAsC,gBAAA;AxB2zFxC;;AwB3zFE;EAAsC,gBAAA;AxB+zFxC;;AwB/zFE;EAAsC,gBAAA;AxBm0FxC;;AwBn0FE;EAAsC,gBAAA;AxBu0FxC;;AwBv0FE;EAAsC,gBAAA;AxB20FxC;;AwB30FE;EAAsC,gBAAA;AxB+0FxC;;AwB/0FE;EAAsC,gBAAA;AxBm1FxC;;AwBn1FE;EAAsC,gBAAA;AxBu1FxC;;AwBv1FE;EAAsC,gBAAA;AxB21FxC;;AwB31FE;EAAsC,gBAAA;AxB+1FxC;;AwB/1FE;EAAsC,gBAAA;AxBm2FxC;;AwBn2FE;EAAsC,gBAAA;AxBu2FxC;;AwBv2FE;EAAsC,gBAAA;AxB22FxC;;AwB32FE;EAAsC,gBAAA;AxB+2FxC;;AwB/2FE;EAAsC,gBAAA;AxBm3FxC;;AwBn3FE;EAAsC,gBAAA;AxBu3FxC;;AwBv3FE;EAAsC,gBAAA;AxB23FxC;;AwB33FE;EAAsC,gBAAA;AxB+3FxC;;AwB/3FE;EAAsC,gBAAA;AxBm4FxC;;AwBn4FE;EAAsC,gBAAA;AxBu4FxC;;AwBv4FE;EAAsC,gBAAA;AxB24FxC;;AwB34FE;EAAsC,gBAAA;AxB+4FxC;;AwB/4FE;EAAsC,gBAAA;AxBm5FxC;;AwBn5FE;EAAsC,gBAAA;AxBu5FxC;;AwBv5FE;EAAsC,gBAAA;AxB25FxC;;AwB35FE;EAAsC,gBAAA;AxB+5FxC;;AwB/5FE;EAAsC,gBAAA;AxBm6FxC;;AwBn6FE;EAAsC,gBAAA;AxBu6FxC;;AwBv6FE;EAAsC,gBAAA;AxB26FxC;;AwB36FE;EAAsC,gBAAA;AxB+6FxC;;AwB/6FE;EAAsC,gBAAA;AxBm7FxC;;AwBn7FE;EAAsC,gBAAA;AxBu7FxC;;AwBv7FE;EAAsC,gBAAA;AxB27FxC;;AwB37FE;EAAsC,gBAAA;AxB+7FxC;;AwB/7FE;EAAsC,gBAAA;AxBm8FxC;;AwBn8FE;EAAsC,gBAAA;AxBu8FxC;;AwBv8FE;EAAsC,gBAAA;AxB28FxC;;AwB38FE;EAAsC,gBAAA;AxB+8FxC;;AwB/8FE;EAAsC,gBAAA;AxBm9FxC;;AwBn9FE;EAAsC,gBAAA;AxBu9FxC;;AwBv9FE;EAAsC,gBAAA;AxB29FxC;;AwB39FE;EAAsC,gBAAA;AxB+9FxC;;AwB/9FE;EAAsC,gBAAA;AxBm+FxC;;AwBn+FE;EAAsC,gBAAA;AxBu+FxC;;AwBv+FE;EAAsC,gBAAA;AxB2+FxC;;AwB3+FE;EAAsC,gBAAA;AxB++FxC;;AwB/+FE;EAAsC,gBAAA;AxBm/FxC;;AwBn/FE;EAAsC,gBAAA;AxBu/FxC;;AwBv/FE;EAAsC,gBAAA;AxB2/FxC;;AwB3/FE;EAAsC,gBAAA;AxB+/FxC;;AwB//FE;EAAsC,gBAAA;AxBmgGxC;;AwBngGE;EAAsC,gBAAA;AxBugGxC;;AwBvgGE;EAAsC,gBAAA;AxB2gGxC;;AwB3gGE;EAAsC,gBAAA;AxB+gGxC;;AwB/gGE;EAAsC,gBAAA;AxBmhGxC;;AwBnhGE;EAAsC,gBAAA;AxBuhGxC;;AwBvhGE;EAAsC,gBAAA;AxB2hGxC;;AwB3hGE;EAAsC,gBAAA;AxB+hGxC;;AwB/hGE;EAAsC,gBAAA;AxBmiGxC;;AwBniGE;EAAsC,gBAAA;AxBuiGxC;;AwBviGE;EAAsC,gBAAA;AxB2iGxC;;AwB3iGE;EAAsC,gBAAA;AxB+iGxC;;AwB/iGE;EAAsC,gBAAA;AxBmjGxC;;AwBnjGE;EAAsC,gBAAA;AxBujGxC;;AwBvjGE;EAAsC,gBAAA;AxB2jGxC;;AwB3jGE;EAAsC,gBAAA;AxB+jGxC;;AwB/jGE;EAAsC,gBAAA;AxBmkGxC;;AwBnkGE;EAAsC,gBAAA;AxBukGxC;;AwBvkGE;EAAsC,gBAAA;AxB2kGxC;;AwB3kGE;EAAsC,gBAAA;AxB+kGxC;;AwB/kGE;EAAsC,gBAAA;AxBmlGxC;;AwBnlGE;EAAsC,gBAAA;AxBulGxC;;AwBvlGE;EAAsC,gBAAA;AxB2lGxC;;AwB3lGE;EAAsC,gBAAA;AxB+lGxC;;AwB/lGE;EAAsC,gBAAA;AxBmmGxC;;AwBnmGE;EAAsC,gBAAA;AxBumGxC;;AwBvmGE;EAAsC,gBAAA;AxB2mGxC;;AwB3mGE;EAAsC,gBAAA;AxB+mGxC;;AwB/mGE;EAAsC,gBAAA;AxBmnGxC;;AwBnnGE;EAAsC,gBAAA;AxBunGxC;;AwBvnGE;EAAsC,gBAAA;AxB2nGxC;;AwB3nGE;EAAsC,gBAAA;AxB+nGxC;;AwB/nGE;EAAsC,gBAAA;AxBmoGxC;;AwBnoGE;EAAsC,gBAAA;AxBuoGxC;;AwBvoGE;EAAsC,gBAAA;AxB2oGxC;;AwB3oGE;EAAsC,gBAAA;AxB+oGxC;;AwB/oGE;EAAsC,gBAAA;AxBmpGxC;;AwBnpGE;EAAsC,gBAAA;AxBupGxC;;AwBvpGE;EAAsC,gBAAA;AxB2pGxC;;AwB3pGE;EAAsC,gBAAA;AxB+pGxC;;AwB/pGE;EAAsC,gBAAA;AxBmqGxC;;AwBnqGE;EAAsC,aAAA;AxBuqGxC;;AwBvqGE;EAAsC,aAAA;AxB2qGxC;;AwB3qGE;EAAsC,aAAA;AxB+qGxC;;AwB/qGE;EAAsC,aAAA;AxBmrGxC;;AwBnrGE;EAAsC,aAAA;AxBurGxC;;AwBvrGE;EAAsC,aAAA;AxB2rGxC;;AwB3rGE;EAAsC,aAAA;AxB+rGxC;;AwB/rGE;EAAsC,aAAA;AxBmsGxC;;AwBnsGE;EAAsC,aAAA;AxBusGxC;;AwBvsGE;EAAsC,aAAA;AxB2sGxC;;AwB3sGE;EAAsC,gBAAA;AxB+sGxC;;AwB/sGE;EAAsC,gBAAA;AxBmtGxC;;AwBntGE;EAAsC,gBAAA;AxButGxC;;AwBvtGE;EAAsC,gBAAA;AxB2tGxC;;AwB3tGE;EAAsC,gBAAA;AxB+tGxC;;AwB/tGE;EAAsC,gBAAA;AxBmuGxC;;AwBnuGE;EAAsC,gBAAA;AxBuuGxC;;AwBvuGE;EAAsC,gBAAA;AxB2uGxC;;AwB3uGE;EAAsC,gBAAA;AxB+uGxC;;AwB/uGE;EAAsC,gBAAA;AxBmvGxC;;AwBnvGE;EAAsC,gBAAA;AxBuvGxC;;AwBvvGE;EAAsC,gBAAA;AxB2vGxC;;AwB3vGE;EAAsC,gBAAA;AxB+vGxC;;AwB/vGE;EAAsC,gBAAA;AxBmwGxC;;AwBnwGE;EAAsC,gBAAA;AxBuwGxC;;AwBvwGE;EAAsC,gBAAA;AxB2wGxC;;AwB3wGE;EAAsC,gBAAA;AxB+wGxC;;AwB/wGE;EAAsC,gBAAA;AxBmxGxC;;AwBnxGE;EAAsC,gBAAA;AxBuxGxC;;AwBvxGE;EAAsC,gBAAA;AxB2xGxC;;AwB3xGE;EAAsC,gBAAA;AxB+xGxC;;AwB/xGE;EAAsC,gBAAA;AxBmyGxC;;AwBnyGE;EAAsC,gBAAA;AxBuyGxC;;AwBvyGE;EAAsC,gBAAA;AxB2yGxC;;AwB3yGE;EAAsC,gBAAA;AxB+yGxC;;AwB/yGE;EAAsC,gBAAA;AxBmzGxC;;AwBnzGE;EAAsC,gBAAA;AxBuzGxC;;AwBvzGE;EAAsC,gBAAA;AxB2zGxC;;AwB3zGE;EAAsC,gBAAA;AxB+zGxC;;AwB/zGE;EAAsC,gBAAA;AxBm0GxC;;AwBn0GE;EAAsC,gBAAA;AxBu0GxC;;AwBv0GE;EAAsC,gBAAA;AxB20GxC;;AwB30GE;EAAsC,gBAAA;AxB+0GxC;;AwB/0GE;EAAsC,gBAAA;AxBm1GxC;;AwBn1GE;EAAsC,gBAAA;AxBu1GxC;;AwBv1GE;EAAsC,gBAAA;AxB21GxC;;AwB31GE;EAAsC,gBAAA;AxB+1GxC;;AwB/1GE;EAAsC,gBAAA;AxBm2GxC;;AwBn2GE;EAAsC,gBAAA;AxBu2GxC;;AwBv2GE;EAAsC,gBAAA;AxB22GxC;;AwB32GE;EAAsC,gBAAA;AxB+2GxC;;AwB/2GE;EAAsC,gBAAA;AxBm3GxC;;AwBn3GE;EAAsC,gBAAA;AxBu3GxC;;AwBv3GE;EAAsC,gBAAA;AxB23GxC;;AwB33GE;EAAsC,gBAAA;AxB+3GxC;;AwB/3GE;EAAsC,gBAAA;AxBm4GxC;;AwBn4GE;EAAsC,gBAAA;AxBu4GxC;;AwBv4GE;EAAsC,gBAAA;AxB24GxC;;AwB34GE;EAAsC,gBAAA;AxB+4GxC;;AwB/4GE;EAAsC,gBAAA;AxBm5GxC;;AwBn5GE;EAAsC,YAAA;AxBu5GxC;;AwBv5GE;EAAsC,gBAAA;AxB25GxC;;AwB35GE;EAAsC,gBAAA;AxB+5GxC;;AwB/5GE;EAAsC,gBAAA;AxBm6GxC;;AwBn6GE;EAAsC,gBAAA;AxBu6GxC;;AwBv6GE;EAAsC,gBAAA;AxB26GxC;;AwB36GE;EAAsC,gBAAA;AxB+6GxC;;AwB/6GE;EAAsC,gBAAA;AxBm7GxC;;AwBn7GE;EAAsC,gBAAA;AxBu7GxC;;AwBv7GE;EAAsC,gBAAA;AxB27GxC;;AwB37GE;EAAsC,gBAAA;AxB+7GxC;;AwB/7GE;EAAsC,gBAAA;AxBm8GxC;;AwBn8GE;EAAsC,gBAAA;AxBu8GxC;;AwBv8GE;EAAsC,gBAAA;AxB28GxC;;AwB38GE;EAAsC,gBAAA;AxB+8GxC;;AwB/8GE;EAAsC,gBAAA;AxBm9GxC;;AwBn9GE;EAAsC,gBAAA;AxBu9GxC;;AwBv9GE;EAAsC,gBAAA;AxB29GxC;;AwB39GE;EAAsC,gBAAA;AxB+9GxC;;AwB/9GE;EAAsC,gBAAA;AxBm+GxC;;AwBn+GE;EAAsC,gBAAA;AxBu+GxC;;AwBv+GE;EAAsC,gBAAA;AxB2+GxC;;AwB3+GE;EAAsC,gBAAA;AxB++GxC;;AwB/+GE;EAAsC,gBAAA;AxBm/GxC;;AwBn/GE;EAAsC,gBAAA;AxBu/GxC;;AwBv/GE;EAAsC,gBAAA;AxB2/GxC;;AwB3/GE;EAAsC,gBAAA;AxB+/GxC;;AwB//GE;EAAsC,gBAAA;AxBmgHxC;;AwBngHE;EAAsC,gBAAA;AxBugHxC;;AwBvgHE;EAAsC,gBAAA;AxB2gHxC;;AwB3gHE;EAAsC,gBAAA;AxB+gHxC;;AwB/gHE;EAAsC,gBAAA;AxBmhHxC;;AwBnhHE;EAAsC,gBAAA;AxBuhHxC;;AwBvhHE;EAAsC,gBAAA;AxB2hHxC;;AwB3hHE;EAAsC,gBAAA;AxB+hHxC;;AwB/hHE;EAAsC,gBAAA;AxBmiHxC;;AwBniHE;EAAsC,gBAAA;AxBuiHxC;;AwBviHE;EAAsC,gBAAA;AxB2iHxC;;AwB3iHE;EAAsC,gBAAA;AxB+iHxC;;AwB/iHE;EAAsC,gBAAA;AxBmjHxC;;AwBnjHE;EAAsC,gBAAA;AxBujHxC;;AwBvjHE;EAAsC,gBAAA;AxB2jHxC;;AwB3jHE;EAAsC,gBAAA;AxB+jHxC;;AwB/jHE;EAAsC,gBAAA;AxBmkHxC;;AwBnkHE;EAAsC,gBAAA;AxBukHxC;;AwBvkHE;EAAsC,gBAAA;AxB2kHxC;;AwB3kHE;EAAsC,gBAAA;AxB+kHxC;;AwB/kHE;EAAsC,gBAAA;AxBmlHxC;;AwBnlHE;EAAsC,gBAAA;AxBulHxC;;AwBvlHE;EAAsC,gBAAA;AxB2lHxC;;AwB3lHE;EAAsC,gBAAA;AxB+lHxC;;AwB/lHE;EAAsC,gBAAA;AxBmmHxC;;AwBnmHE;EAAsC,gBAAA;AxBumHxC;;AwBvmHE;EAAsC,gBAAA;AxB2mHxC;;AwB3mHE;EAAsC,gBAAA;AxB+mHxC;;AwB/mHE;EAAsC,gBAAA;AxBmnHxC;;AwBnnHE;EAAsC,gBAAA;AxBunHxC;;AwBvnHE;EAAsC,gBAAA;AxB2nHxC;;AwB3nHE;EAAsC,gBAAA;AxB+nHxC;;AwB/nHE;EAAsC,gBAAA;AxBmoHxC;;AwBnoHE;EAAsC,gBAAA;AxBuoHxC;;AwBvoHE;EAAsC,gBAAA;AxB2oHxC;;AwB3oHE;EAAsC,gBAAA;AxB+oHxC;;AwB/oHE;EAAsC,gBAAA;AxBmpHxC;;AwBnpHE;EAAsC,gBAAA;AxBupHxC;;AwBvpHE;EAAsC,gBAAA;AxB2pHxC;;AwB3pHE;EAAsC,gBAAA;AxB+pHxC;;AwB/pHE;EAAsC,gBAAA;AxBmqHxC;;AwBnqHE;EAAsC,gBAAA;AxBuqHxC;;AwBvqHE;EAAsC,gBAAA;AxB2qHxC;;AwB3qHE;EAAsC,gBAAA;AxB+qHxC;;AwB/qHE;EAAsC,gBAAA;AxBmrHxC;;AwBnrHE;EAAsC,gBAAA;AxBurHxC;;AwBvrHE;EAAsC,gBAAA;AxB2rHxC;;AwB3rHE;EAAsC,gBAAA;AxB+rHxC;;AwB/rHE;EAAsC,gBAAA;AxBmsHxC;;AwBnsHE;EAAsC,gBAAA;AxBusHxC;;AwBvsHE;EAAsC,gBAAA;AxB2sHxC;;AwB3sHE;EAAsC,gBAAA;AxB+sHxC;;AwB/sHE;EAAsC,gBAAA;AxBmtHxC;;AwBntHE;EAAsC,gBAAA;AxButHxC;;AwBvtHE;EAAsC,gBAAA;AxB2tHxC;;AwB3tHE;EAAsC,gBAAA;AxB+tHxC;;AwB/tHE;EAAsC,gBAAA;AxBmuHxC;;AwBnuHE;EAAsC,gBAAA;AxBuuHxC;;AwBvuHE;EAAsC,gBAAA;AxB2uHxC;;AwB3uHE;EAAsC,gBAAA;AxB+uHxC;;AwB/uHE;EAAsC,gBAAA;AxBmvHxC;;AwBnvHE;EAAsC,gBAAA;AxBuvHxC;;AwBvvHE;EAAsC,gBAAA;AxB2vHxC;;AwB3vHE;EAAsC,gBAAA;AxB+vHxC;;AwB/vHE;EAAsC,gBAAA;AxBmwHxC;;AwBnwHE;EAAsC,gBAAA;AxBuwHxC;;AwBvwHE;EAAsC,gBAAA;AxB2wHxC;;AwB3wHE;EAAsC,gBAAA;AxB+wHxC;;AwB/wHE;EAAsC,gBAAA;AxBmxHxC;;AwBnxHE;EAAsC,gBAAA;AxBuxHxC;;AwBvxHE;EAAsC,gBAAA;AxB2xHxC;;AwB3xHE;EAAsC,gBAAA;AxB+xHxC;;AwB/xHE;EAAsC,gBAAA;AxBmyHxC;;AwBnyHE;EAAsC,gBAAA;AxBuyHxC;;AwBvyHE;EAAsC,gBAAA;AxB2yHxC;;AwB3yHE;EAAsC,gBAAA;AxB+yHxC;;AwB/yHE;EAAsC,gBAAA;AxBmzHxC;;AwBnzHE;EAAsC,gBAAA;AxBuzHxC;;AwBvzHE;EAAsC,gBAAA;AxB2zHxC;;AwB3zHE;EAAsC,gBAAA;AxB+zHxC;;AwB/zHE;EAAsC,gBAAA;AxBm0HxC;;AwBn0HE;EAAsC,gBAAA;AxBu0HxC;;AwBv0HE;EAAsC,gBAAA;AxB20HxC;;AwB30HE;EAAsC,gBAAA;AxB+0HxC;;AwB/0HE;EAAsC,gBAAA;AxBm1HxC;;AwBn1HE;EAAsC,gBAAA;AxBu1HxC;;AwBv1HE;EAAsC,gBAAA;AxB21HxC;;AwB31HE;EAAsC,gBAAA;AxB+1HxC;;AwB/1HE;EAAsC,gBAAA;AxBm2HxC;;AwBn2HE;EAAsC,gBAAA;AxBu2HxC;;AwBv2HE;EAAsC,gBAAA;AxB22HxC;;AwB32HE;EAAsC,gBAAA;AxB+2HxC;;AwB/2HE;EAAsC,gBAAA;AxBm3HxC;;AwBn3HE;EAAsC,gBAAA;AxBu3HxC;;AwBv3HE;EAAsC,gBAAA;AxB23HxC;;AwB33HE;EAAsC,gBAAA;AxB+3HxC;;AwB/3HE;EAAsC,gBAAA;AxBm4HxC;;AwBn4HE;EAAsC,gBAAA;AxBu4HxC;;AwBv4HE;EAAsC,gBAAA;AxB24HxC;;AwB34HE;EAAsC,gBAAA;AxB+4HxC;;AwB/4HE;EAAsC,gBAAA;AxBm5HxC;;AwBn5HE;EAAsC,gBAAA;AxBu5HxC;;AwBv5HE;EAAsC,gBAAA;AxB25HxC;;AwB35HE;EAAsC,gBAAA;AxB+5HxC;;AwB/5HE;EAAsC,gBAAA;AxBm6HxC;;AwBn6HE;EAAsC,gBAAA;AxBu6HxC;;AwBv6HE;EAAsC,gBAAA;AxB26HxC;;AwB36HE;EAAsC,gBAAA;AxB+6HxC;;AwB/6HE;EAAsC,gBAAA;AxBm7HxC;;AwBn7HE;EAAsC,gBAAA;AxBu7HxC;;AwBv7HE;EAAsC,gBAAA;AxB27HxC;;AwB37HE;EAAsC,gBAAA;AxB+7HxC;;AwB/7HE;EAAsC,gBAAA;AxBm8HxC;;AwBn8HE;EAAsC,gBAAA;AxBu8HxC;;AwBv8HE;EAAsC,gBAAA;AxB28HxC;;AwB38HE;EAAsC,gBAAA;AxB+8HxC;;AwB/8HE;EAAsC,gBAAA;AxBm9HxC;;AwBn9HE;EAAsC,gBAAA;AxBu9HxC;;AwBv9HE;EAAsC,gBAAA;AxB29HxC;;AwB39HE;EAAsC,gBAAA;AxB+9HxC;;AwB/9HE;EAAsC,gBAAA;AxBm+HxC;;AwBn+HE;EAAsC,gBAAA;AxBu+HxC;;AwBv+HE;EAAsC,gBAAA;AxB2+HxC;;AwB3+HE;EAAsC,gBAAA;AxB++HxC;;AwB/+HE;EAAsC,gBAAA;AxBm/HxC;;AwBn/HE;EAAsC,gBAAA;AxBu/HxC;;AwBv/HE;EAAsC,gBAAA;AxB2/HxC;;AwB3/HE;EAAsC,gBAAA;AxB+/HxC;;AwB//HE;EAAsC,gBAAA;AxBmgIxC;;AwBngIE;EAAsC,gBAAA;AxBugIxC;;AwBvgIE;EAAsC,gBAAA;AxB2gIxC;;AwB3gIE;EAAsC,gBAAA;AxB+gIxC;;AwB/gIE;EAAsC,gBAAA;AxBmhIxC;;AwBnhIE;EAAsC,gBAAA;AxBuhIxC;;AwBvhIE;EAAsC,gBAAA;AxB2hIxC;;AwB3hIE;EAAsC,gBAAA;AxB+hIxC;;AwB/hIE;EAAsC,gBAAA;AxBmiIxC;;AwBniIE;EAAsC,gBAAA;AxBuiIxC;;AwBviIE;EAAsC,gBAAA;AxB2iIxC;;AwB3iIE;EAAsC,gBAAA;AxB+iIxC;;AwB/iIE;EAAsC,gBAAA;AxBmjIxC;;AwBnjIE;EAAsC,gBAAA;AxBujIxC;;AwBvjIE;EAAsC,gBAAA;AxB2jIxC;;AwB3jIE;EAAsC,gBAAA;AxB+jIxC;;AwB/jIE;EAAsC,gBAAA;AxBmkIxC;;AwBnkIE;EAAsC,gBAAA;AxBukIxC;;AwBvkIE;EAAsC,gBAAA;AxB2kIxC;;AwB3kIE;EAAsC,gBAAA;AxB+kIxC;;AwB/kIE;EAAsC,gBAAA;AxBmlIxC;;AwBnlIE;EAAsC,gBAAA;AxBulIxC;;AwBvlIE;EAAsC,gBAAA;AxB2lIxC;;AwB3lIE;EAAsC,gBAAA;AxB+lIxC;;AwB/lIE;EAAsC,gBAAA;AxBmmIxC;;AwBnmIE;EAAsC,gBAAA;AxBumIxC;;AwBvmIE;EAAsC,gBAAA;AxB2mIxC;;AwB3mIE;EAAsC,gBAAA;AxB+mIxC;;AwB/mIE;EAAsC,gBAAA;AxBmnIxC;;AwBnnIE;EAAsC,gBAAA;AxBunIxC;;AwBvnIE;EAAsC,gBAAA;AxB2nIxC;;AwB3nIE;EAAsC,gBAAA;AxB+nIxC;;AwB/nIE;EAAsC,gBAAA;AxBmoIxC;;AwBnoIE;EAAsC,gBAAA;AxBuoIxC;;AwBvoIE;EAAsC,gBAAA;AxB2oIxC;;AwB3oIE;EAAsC,gBAAA;AxB+oIxC;;AwB/oIE;EAAsC,gBAAA;AxBmpIxC;;AwBnpIE;EAAsC,gBAAA;AxBupIxC;;AwBvpIE;EAAsC,gBAAA;AxB2pIxC;;AwB3pIE;EAAsC,gBAAA;AxB+pIxC;;AwB/pIE;EAAsC,gBAAA;AxBmqIxC;;AwBnqIE;EAAsC,gBAAA;AxBuqIxC;;AwBvqIE;EAAsC,gBAAA;AxB2qIxC;;AwB3qIE;EAAsC,gBAAA;AxB+qIxC;;AwB/qIE;EAAsC,gBAAA;AxBmrIxC;;AwBnrIE;EAAsC,gBAAA;AxBurIxC;;AwBvrIE;EAAsC,gBAAA;AxB2rIxC;;AwB3rIE;EAAsC,gBAAA;AxB+rIxC;;AwB/rIE;EAAsC,gBAAA;AxBmsIxC;;AwBnsIE;EAAsC,gBAAA;AxBusIxC;;AwBvsIE;EAAsC,gBAAA;AxB2sIxC;;AwB3sIE;EAAsC,gBAAA;AxB+sIxC;;AwB/sIE;EAAsC,gBAAA;AxBmtIxC;;AwBntIE;EAAsC,gBAAA;AxButIxC;;AwBvtIE;EAAsC,gBAAA;AxB2tIxC;;AwB3tIE;EAAsC,gBAAA;AxB+tIxC;;AwB/tIE;EAAsC,gBAAA;AxBmuIxC;;AwBnuIE;EAAsC,gBAAA;AxBuuIxC;;AwBvuIE;EAAsC,gBAAA;AxB2uIxC;;AwB3uIE;EAAsC,gBAAA;AxB+uIxC;;AwB/uIE;EAAsC,gBAAA;AxBmvIxC;;AwBnvIE;EAAsC,gBAAA;AxBuvIxC;;AwBvvIE;EAAsC,gBAAA;AxB2vIxC;;AwB3vIE;EAAsC,gBAAA;AxB+vIxC;;AwB/vIE;EAAsC,gBAAA;AxBmwIxC;;AwBnwIE;EAAsC,gBAAA;AxBuwIxC;;AwBvwIE;EAAsC,gBAAA;AxB2wIxC;;AwB3wIE;EAAsC,gBAAA;AxB+wIxC;;AwB/wIE;EAAsC,gBAAA;AxBmxIxC;;AwBnxIE;EAAsC,gBAAA;AxBuxIxC;;AwBvxIE;EAAsC,gBAAA;AxB2xIxC;;AwB3xIE;EAAsC,gBAAA;AxB+xIxC;;AwB/xIE;EAAsC,gBAAA;AxBmyIxC;;AwBnyIE;EAAsC,gBAAA;AxBuyIxC;;AwBvyIE;EAAsC,gBAAA;AxB2yIxC;;AwB3yIE;EAAsC,gBAAA;AxB+yIxC;;AwB/yIE;EAAsC,gBAAA;AxBmzIxC;;AwBnzIE;EAAsC,gBAAA;AxBuzIxC;;AwBvzIE;EAAsC,gBAAA;AxB2zIxC;;AwB3zIE;EAAsC,gBAAA;AxB+zIxC;;AwB/zIE;EAAsC,gBAAA;AxBm0IxC;;AwBn0IE;EAAsC,gBAAA;AxBu0IxC;;AwBv0IE;EAAsC,gBAAA;AxB20IxC;;AwB30IE;EAAsC,gBAAA;AxB+0IxC;;AwB/0IE;EAAsC,gBAAA;AxBm1IxC;;AwBn1IE;EAAsC,gBAAA;AxBu1IxC;;AwBv1IE;EAAsC,gBAAA;AxB21IxC;;AwB31IE;EAAsC,gBAAA;AxB+1IxC;;AwB/1IE;EAAsC,gBAAA;AxBm2IxC;;AwBn2IE;EAAsC,gBAAA;AxBu2IxC;;AwBv2IE;EAAsC,gBAAA;AxB22IxC;;AwB32IE;EAAsC,gBAAA;AxB+2IxC;;AwB/2IE;EAAsC,gBAAA;AxBm3IxC;;AwBn3IE;EAAsC,gBAAA;AxBu3IxC;;AwBv3IE;EAAsC,gBAAA;AxB23IxC;;AwB33IE;EAAsC,gBAAA;AxB+3IxC;;AwB/3IE;EAAsC,gBAAA;AxBm4IxC;;AwBn4IE;EAAsC,gBAAA;AxBu4IxC;;AwBv4IE;EAAsC,gBAAA;AxB24IxC;;AwB34IE;EAAsC,gBAAA;AxB+4IxC;;AwB/4IE;EAAsC,gBAAA;AxBm5IxC;;AwBn5IE;EAAsC,gBAAA;AxBu5IxC;;AwBv5IE;EAAsC,gBAAA;AxB25IxC;;AwB35IE;EAAsC,gBAAA;AxB+5IxC;;AwB/5IE;EAAsC,gBAAA;AxBm6IxC;;AwBn6IE;EAAsC,gBAAA;AxBu6IxC;;AwBv6IE;EAAsC,gBAAA;AxB26IxC;;AwB36IE;EAAsC,gBAAA;AxB+6IxC;;AwB/6IE;EAAsC,gBAAA;AxBm7IxC;;AwBn7IE;EAAsC,gBAAA;AxBu7IxC;;AwBv7IE;EAAsC,gBAAA;AxB27IxC;;AwB37IE;EAAsC,gBAAA;AxB+7IxC;;AwB/7IE;EAAsC,gBAAA;AxBm8IxC;;AwBn8IE;EAAsC,gBAAA;AxBu8IxC;;AwBv8IE;EAAsC,gBAAA;AxB28IxC;;AwB38IE;EAAsC,gBAAA;AxB+8IxC;;AwB/8IE;EAAsC,gBAAA;AxBm9IxC;;AwBn9IE;EAAsC,gBAAA;AxBu9IxC;;AwBv9IE;EAAsC,gBAAA;AxB29IxC;;AwB39IE;EAAsC,gBAAA;AxB+9IxC;;AwB/9IE;EAAsC,gBAAA;AxBm+IxC;;AwBn+IE;EAAsC,gBAAA;AxBu+IxC;;AwBv+IE;EAAsC,gBAAA;AxB2+IxC;;AwB3+IE;EAAsC,gBAAA;AxB++IxC;;AwB/+IE;EAAsC,gBAAA;AxBm/IxC;;AwBn/IE;EAAsC,gBAAA;AxBu/IxC;;AwBv/IE;EAAsC,gBAAA;AxB2/IxC;;AwB3/IE;EAAsC,gBAAA;AxB+/IxC;;AwB//IE;EAAsC,gBAAA;AxBmgJxC;;AwBngJE;EAAsC,gBAAA;AxBugJxC;;AwBvgJE;EAAsC,gBAAA;AxB2gJxC;;AwB3gJE;EAAsC,gBAAA;AxB+gJxC;;AwB/gJE;EAAsC,gBAAA;AxBmhJxC;;AwBnhJE;EAAsC,gBAAA;AxBuhJxC;;AwBvhJE;EAAsC,gBAAA;AxB2hJxC;;AwB3hJE;EAAsC,gBAAA;AxB+hJxC;;AwB/hJE;EAAsC,gBAAA;AxBmiJxC;;AwBniJE;EAAsC,gBAAA;AxBuiJxC;;AwBviJE;EAAsC,gBAAA;AxB2iJxC;;AwB3iJE;EAAsC,gBAAA;AxB+iJxC;;AwB/iJE;EAAsC,gBAAA;AxBmjJxC;;AwBnjJE;EAAsC,gBAAA;AxBujJxC;;AwBvjJE;EAAsC,gBAAA;AxB2jJxC;;AwB3jJE;EAAsC,gBAAA;AxB+jJxC;;AwB/jJE;EAAsC,gBAAA;AxBmkJxC;;AwBnkJE;EAAsC,gBAAA;AxBukJxC;;AwBvkJE;EAAsC,gBAAA;AxB2kJxC;;AwB3kJE;EAAsC,gBAAA;AxB+kJxC;;AwB/kJE;EAAsC,gBAAA;AxBmlJxC;;AwBnlJE;EAAsC,gBAAA;AxBulJxC;;AwBvlJE;EAAsC,gBAAA;AxB2lJxC;;AwB3lJE;EAAsC,gBAAA;AxB+lJxC;;AwB/lJE;EAAsC,gBAAA;AxBmmJxC;;AwBnmJE;EAAsC,gBAAA;AxBumJxC;;AwBvmJE;EAAsC,gBAAA;AxB2mJxC;;AwB3mJE;EAAsC,gBAAA;AxB+mJxC;;AwB/mJE;EAAsC,gBAAA;AxBmnJxC;;AwBnnJE;EAAsC,gBAAA;AxBunJxC;;AwBvnJE;EAAsC,gBAAA;AxB2nJxC;;AwB3nJE;EAAsC,gBAAA;AxB+nJxC;;AwB/nJE;EAAsC,gBAAA;AxBmoJxC;;AwBnoJE;EAAsC,gBAAA;AxBuoJxC;;AwBvoJE;EAAsC,gBAAA;AxB2oJxC;;AwB3oJE;EAAsC,gBAAA;AxB+oJxC;;AwB/oJE;EAAsC,gBAAA;AxBmpJxC;;AwBnpJE;EAAsC,gBAAA;AxBupJxC;;AwBvpJE;EAAsC,gBAAA;AxB2pJxC;;AwB3pJE;EAAsC,gBAAA;AxB+pJxC;;AwB/pJE;EAAsC,gBAAA;AxBmqJxC;;AwBnqJE;EAAsC,gBAAA;AxBuqJxC;;AwBvqJE;EAAsC,gBAAA;AxB2qJxC;;AwB3qJE;EAAsC,gBAAA;AxB+qJxC;;AwB/qJE;EAAsC,gBAAA;AxBmrJxC;;AwBnrJE;EAAsC,gBAAA;AxBurJxC;;AwBvrJE;EAAsC,gBAAA;AxB2rJxC;;AwB3rJE;EAAsC,gBAAA;AxB+rJxC;;AwB/rJE;EAAsC,gBAAA;AxBmsJxC;;AwBnsJE;EAAsC,gBAAA;AxBusJxC;;AwBvsJE;EAAsC,gBAAA;AxB2sJxC;;AwB3sJE;EAAsC,gBAAA;AxB+sJxC;;AwB/sJE;EAAsC,gBAAA;AxBmtJxC;;AwBntJE;EAAsC,gBAAA;AxButJxC;;AwBvtJE;EAAsC,gBAAA;AxB2tJxC;;AwB3tJE;EAAsC,gBAAA;AxB+tJxC;;AwB/tJE;EAAsC,gBAAA;AxBmuJxC;;AwBnuJE;EAAsC,gBAAA;AxBuuJxC;;AwBvuJE;EAAsC,gBAAA;AxB2uJxC;;AwB3uJE;EAAsC,gBAAA;AxB+uJxC;;AwB/uJE;EAAsC,gBAAA;AxBmvJxC;;AwBnvJE;EAAsC,gBAAA;AxBuvJxC;;AwBvvJE;EAAsC,gBAAA;AxB2vJxC;;AwB3vJE;EAAsC,gBAAA;AxB+vJxC;;AwB/vJE;EAAsC,gBAAA;AxBmwJxC;;AwBnwJE;EAAsC,gBAAA;AxBuwJxC;;AwBvwJE;EAAsC,gBAAA;AxB2wJxC;;AwB3wJE;EAAsC,gBAAA;AxB+wJxC;;AwB/wJE;EAAsC,gBAAA;AxBmxJxC;;AwBnxJE;EAAsC,gBAAA;AxBuxJxC;;AwBvxJE;EAAsC,gBAAA;AxB2xJxC;;AwB3xJE;EAAsC,gBAAA;AxB+xJxC;;AwB/xJE;EAAsC,gBAAA;AxBmyJxC;;AwBnyJE;EAAsC,gBAAA;AxBuyJxC;;AwBvyJE;EAAsC,gBAAA;AxB2yJxC;;AwB3yJE;EAAsC,gBAAA;AxB+yJxC;;AwB/yJE;EAAsC,gBAAA;AxBmzJxC;;AwBnzJE;EAAsC,gBAAA;AxBuzJxC;;AwBvzJE;EAAsC,gBAAA;AxB2zJxC;;AwB3zJE;EAAsC,gBAAA;AxB+zJxC;;AwB/zJE;EAAsC,gBAAA;AxBm0JxC;;AwBn0JE;EAAsC,gBAAA;AxBu0JxC;;AwBv0JE;EAAsC,gBAAA;AxB20JxC;;AwB30JE;EAAsC,gBAAA;AxB+0JxC;;AwB/0JE;EAAsC,gBAAA;AxBm1JxC;;AwBn1JE;EAAsC,gBAAA;AxBu1JxC;;AwBv1JE;EAAsC,gBAAA;AxB21JxC;;AwB31JE;EAAsC,gBAAA;AxB+1JxC;;AwB/1JE;EAAsC,gBAAA;AxBm2JxC;;AwBn2JE;EAAsC,gBAAA;AxBu2JxC;;AwBv2JE;EAAsC,gBAAA;AxB22JxC;;AwB32JE;EAAsC,gBAAA;AxB+2JxC;;AwB/2JE;EAAsC,gBAAA;AxBm3JxC;;AwBn3JE;EAAsC,gBAAA;AxBu3JxC;;AwBv3JE;EAAsC,gBAAA;AxB23JxC;;AwB33JE;EAAsC,gBAAA;AxB+3JxC;;AwB/3JE;EAAsC,gBAAA;AxBm4JxC;;AwBn4JE;EAAsC,gBAAA;AxBu4JxC;;AwBv4JE;EAAsC,gBAAA;AxB24JxC;;AwB34JE;EAAsC,gBAAA;AxB+4JxC;;AwB/4JE;EAAsC,gBAAA;AxBm5JxC;;AwBn5JE;EAAsC,gBAAA;AxBu5JxC;;AwBv5JE;EAAsC,gBAAA;AxB25JxC;;AwB35JE;EAAsC,gBAAA;AxB+5JxC;;AwB/5JE;EAAsC,gBAAA;AxBm6JxC;;AwBn6JE;EAAsC,gBAAA;AxBu6JxC;;AwBv6JE;EAAsC,gBAAA;AxB26JxC;;AwB36JE;EAAsC,gBAAA;AxB+6JxC;;AwB/6JE;EAAsC,gBAAA;AxBm7JxC;;AwBn7JE;EAAsC,gBAAA;AxBu7JxC;;AwBv7JE;EAAsC,gBAAA;AxB27JxC;;AwB37JE;EAAsC,gBAAA;AxB+7JxC;;AwB/7JE;EAAsC,gBAAA;AxBm8JxC;;AwBn8JE;EAAsC,gBAAA;AxBu8JxC;;AwBv8JE;EAAsC,gBAAA;AxB28JxC;;AwB38JE;EAAsC,gBAAA;AxB+8JxC;;AwB/8JE;EAAsC,gBAAA;AxBm9JxC;;AwBn9JE;EAAsC,gBAAA;AxBu9JxC;;AwBv9JE;EAAsC,gBAAA;AxB29JxC;;AwB39JE;EAAsC,gBAAA;AxB+9JxC;;AwB/9JE;EAAsC,gBAAA;AxBm+JxC;;AwBn+JE;EAAsC,gBAAA;AxBu+JxC;;AwBv+JE;EAAsC,gBAAA;AxB2+JxC;;AwB3+JE;EAAsC,gBAAA;AxB++JxC;;AwB/+JE;EAAsC,gBAAA;AxBm/JxC;;AwBn/JE;EAAsC,gBAAA;AxBu/JxC;;AwBv/JE;EAAsC,gBAAA;AxB2/JxC;;AwB3/JE;EAAsC,gBAAA;AxB+/JxC;;AwB//JE;EAAsC,gBAAA;AxBmgKxC;;AwBngKE;EAAsC,gBAAA;AxBugKxC;;AwBvgKE;EAAsC,gBAAA;AxB2gKxC;;AwB3gKE;EAAsC,gBAAA;AxB+gKxC;;AwB/gKE;EAAsC,gBAAA;AxBmhKxC;;AwBnhKE;EAAsC,gBAAA;AxBuhKxC;;AwBvhKE;EAAsC,gBAAA;AxB2hKxC;;AwB3hKE;EAAsC,gBAAA;AxB+hKxC;;AwB/hKE;EAAsC,gBAAA;AxBmiKxC;;AwBniKE;EAAsC,gBAAA;AxBuiKxC;;AwBviKE;EAAsC,gBAAA;AxB2iKxC;;AwB3iKE;EAAsC,gBAAA;AxB+iKxC;;AwB/iKE;EAAsC,gBAAA;AxBmjKxC;;AwBnjKE;EAAsC,gBAAA;AxBujKxC;;AwBvjKE;EAAsC,gBAAA;AxB2jKxC;;AwB3jKE;EAAsC,gBAAA;AxB+jKxC;;AwB/jKE;EAAsC,gBAAA;AxBmkKxC;;AwBnkKE;EAAsC,gBAAA;AxBukKxC;;AwBvkKE;EAAsC,gBAAA;AxB2kKxC;;AwB3kKE;EAAsC,gBAAA;AxB+kKxC;;AwB/kKE;EAAsC,gBAAA;AxBmlKxC;;AwBnlKE;EAAsC,gBAAA;AxBulKxC;;AwBvlKE;EAAsC,gBAAA;AxB2lKxC;;AwB3lKE;EAAsC,gBAAA;AxB+lKxC;;AwB/lKE;EAAsC,gBAAA;AxBmmKxC;;AwBnmKE;EAAsC,gBAAA;AxBumKxC;;AwBvmKE;EAAsC,gBAAA;AxB2mKxC;;AwB3mKE;EAAsC,gBAAA;AxB+mKxC;;AwB/mKE;EAAsC,gBAAA;AxBmnKxC;;AwBnnKE;EAAsC,gBAAA;AxBunKxC;;AwBvnKE;EAAsC,gBAAA;AxB2nKxC;;AwB3nKE;EAAsC,gBAAA;AxB+nKxC;;AwB/nKE;EAAsC,gBAAA;AxBmoKxC;;AwBnoKE;EAAsC,gBAAA;AxBuoKxC;;AwBvoKE;EAAsC,gBAAA;AxB2oKxC;;AwB3oKE;EAAsC,gBAAA;AxB+oKxC;;AwB/oKE;EAAsC,gBAAA;AxBmpKxC;;AwBnpKE;EAAsC,gBAAA;AxBupKxC;;AwBvpKE;EAAsC,gBAAA;AxB2pKxC;;AwB3pKE;EAAsC,gBAAA;AxB+pKxC;;AwB/pKE;EAAsC,gBAAA;AxBmqKxC;;AwBnqKE;EAAsC,gBAAA;AxBuqKxC;;AwBvqKE;EAAsC,gBAAA;AxB2qKxC;;AwB3qKE;EAAsC,gBAAA;AxB+qKxC;;AwB/qKE;EAAsC,gBAAA;AxBmrKxC;;AwBnrKE;EAAsC,gBAAA;AxBurKxC;;AwBvrKE;EAAsC,gBAAA;AxB2rKxC;;AwB3rKE;EAAsC,gBAAA;AxB+rKxC;;AwB/rKE;EAAsC,gBAAA;AxBmsKxC;;AwBnsKE;EAAsC,gBAAA;AxBusKxC;;AwBvsKE;EAAsC,gBAAA;AxB2sKxC;;AwB3sKE;EAAsC,gBAAA;AxB+sKxC;;AwB/sKE;EAAsC,gBAAA;AxBmtKxC;;AwBntKE;EAAsC,gBAAA;AxButKxC;;AwBvtKE;EAAsC,gBAAA;AxB2tKxC;;AwB3tKE;EAAsC,gBAAA;AxB+tKxC;;AwB/tKE;EAAsC,gBAAA;AxBmuKxC;;AwBnuKE;EAAsC,gBAAA;AxBuuKxC;;AwBvuKE;EAAsC,gBAAA;AxB2uKxC;;AwB3uKE;EAAsC,gBAAA;AxB+uKxC;;AwB/uKE;EAAsC,gBAAA;AxBmvKxC;;AwBnvKE;EAAsC,gBAAA;AxBuvKxC;;AwBvvKE;EAAsC,gBAAA;AxB2vKxC;;AwB3vKE;EAAsC,gBAAA;AxB+vKxC;;AwB/vKE;EAAsC,gBAAA;AxBmwKxC;;AwBnwKE;EAAsC,gBAAA;AxBuwKxC;;AwBvwKE;EAAsC,gBAAA;AxB2wKxC;;AwB3wKE;EAAsC,gBAAA;AxB+wKxC;;AwB/wKE;EAAsC,gBAAA;AxBmxKxC;;AwBnxKE;EAAsC,gBAAA;AxBuxKxC;;AwBvxKE;EAAsC,gBAAA;AxB2xKxC;;AwB3xKE;EAAsC,gBAAA;AxB+xKxC;;AwB/xKE;EAAsC,gBAAA;AxBmyKxC;;AwBnyKE;EAAsC,gBAAA;AxBuyKxC;;AwBvyKE;EAAsC,gBAAA;AxB2yKxC;;AwB3yKE;EAAsC,gBAAA;AxB+yKxC;;AwB/yKE;EAAsC,gBAAA;AxBmzKxC;;AwBnzKE;EAAsC,gBAAA;AxBuzKxC;;AwBvzKE;EAAsC,gBAAA;AxB2zKxC;;AwB3zKE;EAAsC,gBAAA;AxB+zKxC;;AwB/zKE;EAAsC,gBAAA;AxBm0KxC;;AwBn0KE;EAAsC,gBAAA;AxBu0KxC;;AwBv0KE;EAAsC,gBAAA;AxB20KxC;;AwB30KE;EAAsC,aAAA;AxB+0KxC;;AwB/0KE;EAAsC,gBAAA;AxBm1KxC;;AwBn1KE;EAAsC,gBAAA;AxBu1KxC;;AwBv1KE;EAAsC,gBAAA;AxB21KxC;;AwB31KE;EAAsC,aAAA;AxB+1KxC;;AwB/1KE;EAAsC,gBAAA;AxBm2KxC;;AwBn2KE;EAAsC,gBAAA;AxBu2KxC;;AwBv2KE;EAAsC,gBAAA;AxB22KxC;;AwB32KE;EAAsC,gBAAA;AxB+2KxC;;AwB/2KE;EAAsC,gBAAA;AxBm3KxC;;AwBn3KE;EAAsC,gBAAA;AxBu3KxC;;AwBv3KE;EAAsC,gBAAA;AxB23KxC;;AwB33KE;EAAsC,gBAAA;AxB+3KxC;;AwB/3KE;EAAsC,gBAAA;AxBm4KxC;;AwBn4KE;EAAsC,gBAAA;AxBu4KxC;;AwBv4KE;EAAsC,gBAAA;AxB24KxC;;AwB34KE;EAAsC,gBAAA;AxB+4KxC;;AwB/4KE;EAAsC,gBAAA;AxBm5KxC;;AwBn5KE;EAAsC,gBAAA;AxBu5KxC;;AwBv5KE;EAAsC,gBAAA;AxB25KxC;;AwB35KE;EAAsC,gBAAA;AxB+5KxC;;AwB/5KE;EAAsC,gBAAA;AxBm6KxC;;AwBn6KE;EAAsC,gBAAA;AxBu6KxC;;AwBv6KE;EAAsC,gBAAA;AxB26KxC;;AwB36KE;EAAsC,gBAAA;AxB+6KxC;;AwB/6KE;EAAsC,gBAAA;AxBm7KxC;;AwBn7KE;EAAsC,gBAAA;AxBu7KxC;;AwBv7KE;EAAsC,gBAAA;AxB27KxC;;AwB37KE;EAAsC,gBAAA;AxB+7KxC;;AwB/7KE;EAAsC,gBAAA;AxBm8KxC;;AwBn8KE;EAAsC,gBAAA;AxBu8KxC;;AwBv8KE;EAAsC,gBAAA;AxB28KxC;;AwB38KE;EAAsC,gBAAA;AxB+8KxC;;AwB/8KE;EAAsC,gBAAA;AxBm9KxC;;AwBn9KE;EAAsC,gBAAA;AxBu9KxC;;AwBv9KE;EAAsC,gBAAA;AxB29KxC;;AwB39KE;EAAsC,gBAAA;AxB+9KxC;;AwB/9KE;EAAsC,gBAAA;AxBm+KxC;;AwBn+KE;EAAsC,gBAAA;AxBu+KxC;;AwBv+KE;EAAsC,gBAAA;AxB2+KxC;;AwB3+KE;EAAsC,gBAAA;AxB++KxC;;AwB/+KE;EAAsC,gBAAA;AxBm/KxC;;AwBn/KE;EAAsC,gBAAA;AxBu/KxC;;AwBv/KE;EAAsC,gBAAA;AxB2/KxC;;AwB3/KE;EAAsC,gBAAA;AxB+/KxC;;AwB//KE;EAAsC,gBAAA;AxBmgLxC;;AwBngLE;EAAsC,gBAAA;AxBugLxC;;AwBvgLE;EAAsC,gBAAA;AxB2gLxC;;AwB3gLE;EAAsC,gBAAA;AxB+gLxC;;AwB/gLE;EAAsC,gBAAA;AxBmhLxC;;AwBnhLE;EAAsC,gBAAA;AxBuhLxC;;AwBvhLE;EAAsC,gBAAA;AxB2hLxC;;AwB3hLE;EAAsC,gBAAA;AxB+hLxC;;AwB/hLE;EAAsC,gBAAA;AxBmiLxC;;AwBniLE;EAAsC,gBAAA;AxBuiLxC;;AwBviLE;EAAsC,gBAAA;AxB2iLxC;;AwB3iLE;EAAsC,gBAAA;AxB+iLxC;;AwB/iLE;EAAsC,gBAAA;AxBmjLxC;;AwBnjLE;EAAsC,gBAAA;AxBujLxC;;AwBvjLE;EAAsC,gBAAA;AxB2jLxC;;AwB3jLE;EAAsC,gBAAA;AxB+jLxC;;AwB/jLE;EAAsC,gBAAA;AxBmkLxC;;AwBnkLE;EAAsC,gBAAA;AxBukLxC;;AwBvkLE;EAAsC,gBAAA;AxB2kLxC;;AwB3kLE;EAAsC,gBAAA;AxB+kLxC;;AwB/kLE;EAAsC,gBAAA;AxBmlLxC;;AwBnlLE;EAAsC,gBAAA;AxBulLxC;;AwBvlLE;EAAsC,gBAAA;AxB2lLxC;;AwB3lLE;EAAsC,gBAAA;AxB+lLxC;;AwB/lLE;EAAsC,gBAAA;AxBmmLxC;;AwBnmLE;EAAsC,gBAAA;AxBumLxC;;AwBvmLE;EAAsC,gBAAA;AxB2mLxC;;AwB3mLE;EAAsC,gBAAA;AxB+mLxC;;AwB/mLE;EAAsC,gBAAA;AxBmnLxC;;AwBnnLE;EAAsC,gBAAA;AxBunLxC;;AwBvnLE;EAAsC,gBAAA;AxB2nLxC;;AwB3nLE;EAAsC,gBAAA;AxB+nLxC;;AwB/nLE;EAAsC,gBAAA;AxBmoLxC;;AwBnoLE;EAAsC,gBAAA;AxBuoLxC;;AwBvoLE;EAAsC,gBAAA;AxB2oLxC;;AwB3oLE;EAAsC,gBAAA;AxB+oLxC;;AwB/oLE;EAAsC,gBAAA;AxBmpLxC;;AwBnpLE;EAAsC,gBAAA;AxBupLxC;;AwBvpLE;EAAsC,gBAAA;AxB2pLxC;;AwB3pLE;EAAsC,gBAAA;AxB+pLxC;;AwB/pLE;EAAsC,gBAAA;AxBmqLxC;;AwBnqLE;EAAsC,gBAAA;AxBuqLxC;;AwBvqLE;EAAsC,gBAAA;AxB2qLxC;;AwB3qLE;EAAsC,gBAAA;AxB+qLxC;;AwB/qLE;EAAsC,gBAAA;AxBmrLxC;;AwBnrLE;EAAsC,gBAAA;AxBurLxC;;AwBvrLE;EAAsC,gBAAA;AxB2rLxC;;AwB3rLE;EAAsC,gBAAA;AxB+rLxC;;AwB/rLE;EAAsC,gBAAA;AxBmsLxC;;AwBnsLE;EAAsC,gBAAA;AxBusLxC;;AwBvsLE;EAAsC,gBAAA;AxB2sLxC;;AwB3sLE;EAAsC,gBAAA;AxB+sLxC;;AwB/sLE;EAAsC,gBAAA;AxBmtLxC;;AwBntLE;EAAsC,gBAAA;AxButLxC;;AwBvtLE;EAAsC,gBAAA;AxB2tLxC;;AwB3tLE;EAAsC,gBAAA;AxB+tLxC;;AwB/tLE;EAAsC,gBAAA;AxBmuLxC;;AwBnuLE;EAAsC,gBAAA;AxBuuLxC;;AwBvuLE;EAAsC,gBAAA;AxB2uLxC;;AwB3uLE;EAAsC,YAAA;AxB+uLxC;;AwB/uLE;EAAsC,gBAAA;AxBmvLxC;;AwBnvLE;EAAsC,gBAAA;AxBuvLxC;;AwBvvLE;EAAsC,gBAAA;AxB2vLxC;;AwB3vLE;EAAsC,gBAAA;AxB+vLxC;;AwB/vLE;EAAsC,gBAAA;AxBmwLxC;;AwBnwLE;EAAsC,gBAAA;AxBuwLxC;;AwBvwLE;EAAsC,gBAAA;AxB2wLxC;;AwB3wLE;EAAsC,gBAAA;AxB+wLxC;;AwB/wLE;EAAsC,gBAAA;AxBmxLxC;;AwBnxLE;EAAsC,gBAAA;AxBuxLxC;;AwBvxLE;EAAsC,gBAAA;AxB2xLxC;;AwB3xLE;EAAsC,gBAAA;AxB+xLxC;;AwB/xLE;EAAsC,gBAAA;AxBmyLxC;;AwBnyLE;EAAsC,gBAAA;AxBuyLxC;;AwBvyLE;EAAsC,gBAAA;AxB2yLxC;;AwB3yLE;EAAsC,gBAAA;AxB+yLxC;;AwB/yLE;EAAsC,gBAAA;AxBmzLxC;;AwBnzLE;EAAsC,gBAAA;AxBuzLxC;;AwBvzLE;EAAsC,gBAAA;AxB2zLxC;;AwB3zLE;EAAsC,gBAAA;AxB+zLxC;;AwB/zLE;EAAsC,gBAAA;AxBm0LxC;;AwBn0LE;EAAsC,gBAAA;AxBu0LxC;;AwBv0LE;EAAsC,gBAAA;AxB20LxC;;AwB30LE;EAAsC,gBAAA;AxB+0LxC;;AwB/0LE;EAAsC,gBAAA;AxBm1LxC;;AwBn1LE;EAAsC,gBAAA;AxBu1LxC;;AwBv1LE;EAAsC,gBAAA;AxB21LxC;;AwB31LE;EAAsC,gBAAA;AxB+1LxC;;AwB/1LE;EAAsC,gBAAA;AxBm2LxC;;AwBn2LE;EAAsC,gBAAA;AxBu2LxC;;AwBv2LE;EAAsC,gBAAA;AxB22LxC;;AwB32LE;EAAsC,gBAAA;AxB+2LxC;;AwB/2LE;EAAsC,gBAAA;AxBm3LxC;;AwBn3LE;EAAsC,gBAAA;AxBu3LxC;;AwBv3LE;EAAsC,gBAAA;AxB23LxC;;AwB33LE;EAAsC,gBAAA;AxB+3LxC;;AwB/3LE;EAAsC,gBAAA;AxBm4LxC;;AwBn4LE;EAAsC,gBAAA;AxBu4LxC;;AwBv4LE;EAAsC,gBAAA;AxB24LxC;;AwB34LE;EAAsC,gBAAA;AxB+4LxC;;AwB/4LE;EAAsC,gBAAA;AxBm5LxC;;AwBn5LE;EAAsC,gBAAA;AxBu5LxC;;AwBv5LE;EAAsC,gBAAA;AxB25LxC;;AwB35LE;EAAsC,gBAAA;AxB+5LxC;;AwB/5LE;EAAsC,gBAAA;AxBm6LxC;;AwBn6LE;EAAsC,gBAAA;AxBu6LxC;;AwBv6LE;EAAsC,gBAAA;AxB26LxC;;AwB36LE;EAAsC,gBAAA;AxB+6LxC;;AwB/6LE;EAAsC,gBAAA;AxBm7LxC;;AwBn7LE;EAAsC,gBAAA;AxBu7LxC;;AwBv7LE;EAAsC,gBAAA;AxB27LxC;;AwB37LE;EAAsC,gBAAA;AxB+7LxC;;AwB/7LE;EAAsC,gBAAA;AxBm8LxC;;AwBn8LE;EAAsC,gBAAA;AxBu8LxC;;AwBv8LE;EAAsC,gBAAA;AxB28LxC;;AwB38LE;EAAsC,gBAAA;AxB+8LxC;;AwB/8LE;EAAsC,gBAAA;AxBm9LxC;;AwBn9LE;EAAsC,gBAAA;AxBu9LxC;;AwBv9LE;EAAsC,gBAAA;AxB29LxC;;AwB39LE;EAAsC,aAAA;AxB+9LxC;;AwB/9LE;EAAsC,gBAAA;AxBm+LxC;;AwBn+LE;EAAsC,gBAAA;AxBu+LxC;;AwBv+LE;EAAsC,gBAAA;AxB2+LxC;;AwB3+LE;EAAsC,gBAAA;AxB++LxC;;AwB/+LE;EAAsC,gBAAA;AxBm/LxC;;AwBn/LE;EAAsC,aAAA;AxBu/LxC;;AwBv/LE;EAAsC,aAAA;AxB2/LxC;;AwB3/LE;EAAsC,aAAA;AxB+/LxC;;AwB//LE;EAAsC,gBAAA;AxBmgMxC;;AwBngME;EAAsC,gBAAA;AxBugMxC;;AwBvgME;EAAsC,gBAAA;AxB2gMxC;;AwB3gME;EAAsC,gBAAA;AxB+gMxC;;AwB/gME;EAAsC,gBAAA;AxBmhMxC;;AwBnhME;EAAsC,gBAAA;AxBuhMxC;;AwBvhME;EAAsC,gBAAA;AxB2hMxC;;AwB3hME;EAAsC,gBAAA;AxB+hMxC;;AwB/hME;EAAsC,gBAAA;AxBmiMxC;;AwBniME;EAAsC,gBAAA;AxBuiMxC;;AwBviME;EAAsC,gBAAA;AxB2iMxC;;AwB3iME;EAAsC,gBAAA;AxB+iMxC;;AwB/iME;EAAsC,gBAAA;AxBmjMxC;;AwBnjME;EAAsC,gBAAA;AxBujMxC;;AwBvjME;EAAsC,gBAAA;AxB2jMxC;;AwB3jME;EAAsC,gBAAA;AxB+jMxC;;AwB/jME;EAAsC,gBAAA;AxBmkMxC;;AwBnkME;EAAsC,gBAAA;AxBukMxC;;AwBvkME;EAAsC,gBAAA;AxB2kMxC;;AwB3kME;EAAsC,gBAAA;AxB+kMxC;;AwB/kME;EAAsC,gBAAA;AxBmlMxC;;AwBnlME;EAAsC,gBAAA;AxBulMxC;;AwBvlME;EAAsC,gBAAA;AxB2lMxC;;AwB3lME;EAAsC,gBAAA;AxB+lMxC;;AwB/lME;EAAsC,gBAAA;AxBmmMxC;;AwBnmME;EAAsC,gBAAA;AxBumMxC;;AwBvmME;EAAsC,gBAAA;AxB2mMxC;;AwB3mME;EAAsC,gBAAA;AxB+mMxC;;AwB/mME;EAAsC,gBAAA;AxBmnMxC;;AwBnnME;EAAsC,gBAAA;AxBunMxC;;AwBvnME;EAAsC,gBAAA;AxB2nMxC;;AwB3nME;EAAsC,gBAAA;AxB+nMxC;;AwB/nME;EAAsC,gBAAA;AxBmoMxC;;AwBnoME;EAAsC,gBAAA;AxBuoMxC;;AwBvoME;EAAsC,gBAAA;AxB2oMxC;;AwB3oME;EAAsC,gBAAA;AxB+oMxC;;AwB/oME;EAAsC,gBAAA;AxBmpMxC;;AwBnpME;EAAsC,gBAAA;AxBupMxC;;AwBvpME;EAAsC,gBAAA;AxB2pMxC;;AwB3pME;EAAsC,gBAAA;AxB+pMxC;;AwB/pME;EAAsC,gBAAA;AxBmqMxC;;AwBnqME;EAAsC,gBAAA;AxBuqMxC;;AwBvqME;EAAsC,gBAAA;AxB2qMxC;;AwB3qME;EAAsC,gBAAA;AxB+qMxC;;AwB/qME;EAAsC,gBAAA;AxBmrMxC;;AwBnrME;EAAsC,gBAAA;AxBurMxC;;AwBvrME;EAAsC,gBAAA;AxB2rMxC;;AwB3rME;EAAsC,gBAAA;AxB+rMxC;;AwB/rME;EAAsC,gBAAA;AxBmsMxC;;AwBnsME;EAAsC,gBAAA;AxBusMxC;;AwBvsME;EAAsC,gBAAA;AxB2sMxC;;AwB3sME;EAAsC,gBAAA;AxB+sMxC;;AwB/sME;EAAsC,gBAAA;AxBmtMxC;;AwBntME;EAAsC,YAAA;AxButMxC;;AwBvtME;EAAsC,gBAAA;AxB2tMxC;;AwB3tME;EAAsC,gBAAA;AxB+tMxC;;AwB/tME;EAAsC,gBAAA;AxBmuMxC;;AwBnuME;EAAsC,gBAAA;AxBuuMxC;;AwBvuME;EAAsC,gBAAA;AxB2uMxC;;AwB3uME;EAAsC,gBAAA;AxB+uMxC;;AwB/uME;EAAsC,gBAAA;AxBmvMxC;;AwBnvME;EAAsC,gBAAA;AxBuvMxC;;AwBvvME;EAAsC,gBAAA;AxB2vMxC;;AwB3vME;EAAsC,gBAAA;AxB+vMxC;;AwB/vME;EAAsC,gBAAA;AxBmwMxC;;AwBnwME;EAAsC,gBAAA;AxBuwMxC;;AwBvwME;EAAsC,gBAAA;AxB2wMxC;;AwB3wME;EAAsC,gBAAA;AxB+wMxC;;AwB/wME;EAAsC,gBAAA;AxBmxMxC;;AwBnxME;EAAsC,gBAAA;AxBuxMxC;;AwBvxME;EAAsC,gBAAA;AxB2xMxC;;AwB3xME;EAAsC,gBAAA;AxB+xMxC;;AwB/xME;EAAsC,gBAAA;AxBmyMxC;;AwBnyME;EAAsC,gBAAA;AxBuyMxC;;AwBvyME;EAAsC,gBAAA;AxB2yMxC;;AwB3yME;EAAsC,gBAAA;AxB+yMxC;;AwB/yME;EAAsC,gBAAA;AxBmzMxC;;AwBnzME;EAAsC,gBAAA;AxBuzMxC;;AwBvzME;EAAsC,gBAAA;AxB2zMxC;;AwB3zME;EAAsC,gBAAA;AxB+zMxC;;AwB/zME;EAAsC,gBAAA;AxBm0MxC;;AwBn0ME;EAAsC,gBAAA;AxBu0MxC;;AwBv0ME;EAAsC,gBAAA;AxB20MxC;;AwB30ME;EAAsC,gBAAA;AxB+0MxC;;AwB/0ME;EAAsC,gBAAA;AxBm1MxC;;AwBn1ME;EAAsC,gBAAA;AxBu1MxC;;AwBv1ME;EAAsC,gBAAA;AxB21MxC;;AwB31ME;EAAsC,gBAAA;AxB+1MxC;;AwB/1ME;EAAsC,gBAAA;AxBm2MxC;;AwBn2ME;EAAsC,gBAAA;AxBu2MxC;;AwBv2ME;EAAsC,gBAAA;AxB22MxC;;AwB32ME;EAAsC,gBAAA;AxB+2MxC;;AwB/2ME;EAAsC,gBAAA;AxBm3MxC;;AwBn3ME;EAAsC,gBAAA;AxBu3MxC;;AwBv3ME;EAAsC,gBAAA;AxB23MxC;;AwB33ME;EAAsC,gBAAA;AxB+3MxC;;AwB/3ME;EAAsC,gBAAA;AxBm4MxC;;AwBn4ME;EAAsC,gBAAA;AxBu4MxC;;AwBv4ME;EAAsC,gBAAA;AxB24MxC;;AwB34ME;EAAsC,aAAA;AxB+4MxC;;AwB/4ME;EAAsC,gBAAA;AxBm5MxC;;AwBn5ME;EAAsC,gBAAA;AxBu5MxC;;AwBv5ME;EAAsC,gBAAA;AxB25MxC;;AwB35ME;EAAsC,gBAAA;AxB+5MxC;;AwB/5ME;EAAsC,gBAAA;AxBm6MxC;;AwBn6ME;EAAsC,gBAAA;AxBu6MxC;;AwBv6ME;EAAsC,aAAA;AxB26MxC;;AwB36ME;EAAsC,gBAAA;AxB+6MxC;;AwB/6ME;EAAsC,gBAAA;AxBm7MxC;;AwBn7ME;EAAsC,gBAAA;AxBu7MxC;;AwBv7ME;EAAsC,gBAAA;AxB27MxC;;AwB37ME;EAAsC,gBAAA;AxB+7MxC;;AwB/7ME;EAAsC,gBAAA;AxBm8MxC;;AwBn8ME;EAAsC,gBAAA;AxBu8MxC;;AwBv8ME;EAAsC,gBAAA;AxB28MxC;;AwB38ME;EAAsC,gBAAA;AxB+8MxC;;AwB/8ME;EAAsC,gBAAA;AxBm9MxC;;AwBn9ME;EAAsC,gBAAA;AxBu9MxC;;AwBv9ME;EAAsC,gBAAA;AxB29MxC;;AwB39ME;EAAsC,gBAAA;AxB+9MxC;;AwB/9ME;EAAsC,YAAA;AxBm+MxC;;AwBn+ME;EAAsC,gBAAA;AxBu+MxC;;AwBv+ME;EAAsC,gBAAA;AxB2+MxC;;AwB3+ME;EAAsC,gBAAA;AxB++MxC;;AwB/+ME;EAAsC,gBAAA;AxBm/MxC;;AwBn/ME;EAAsC,gBAAA;AxBu/MxC;;AwBv/ME;EAAsC,gBAAA;AxB2/MxC;;AwB3/ME;EAAsC,gBAAA;AxB+/MxC;;AwB//ME;EAAsC,gBAAA;AxBmgNxC;;AwBngNE;EAAsC,gBAAA;AxBugNxC;;AwBvgNE;EAAsC,gBAAA;AxB2gNxC;;AwB3gNE;EAAsC,gBAAA;AxB+gNxC;;AwB/gNE;EAAsC,gBAAA;AxBmhNxC;;AwBnhNE;EAAsC,gBAAA;AxBuhNxC;;AwBvhNE;EAAsC,gBAAA;AxB2hNxC;;AwB3hNE;EAAsC,gBAAA;AxB+hNxC;;AwB/hNE;EAAsC,gBAAA;AxBmiNxC;;AwBniNE;EAAsC,gBAAA;AxBuiNxC;;AwBviNE;EAAsC,gBAAA;AxB2iNxC;;AwB3iNE;EAAsC,gBAAA;AxB+iNxC;;AwB/iNE;EAAsC,gBAAA;AxBmjNxC;;AwBnjNE;EAAsC,gBAAA;AxBujNxC;;AwBvjNE;EAAsC,gBAAA;AxB2jNxC;;AwB3jNE;EAAsC,gBAAA;AxB+jNxC;;AwB/jNE;EAAsC,gBAAA;AxBmkNxC;;AwBnkNE;EAAsC,gBAAA;AxBukNxC;;AwBvkNE;EAAsC,gBAAA;AxB2kNxC;;AwB3kNE;EAAsC,gBAAA;AxB+kNxC;;AwB/kNE;EAAsC,gBAAA;AxBmlNxC;;AwBnlNE;EAAsC,gBAAA;AxBulNxC;;AwBvlNE;EAAsC,gBAAA;AxB2lNxC;;AwB3lNE;EAAsC,gBAAA;AxB+lNxC;;AwB/lNE;EAAsC,gBAAA;AxBmmNxC;;AwBnmNE;EAAsC,gBAAA;AxBumNxC;;AwBvmNE;EAAsC,gBAAA;AxB2mNxC;;AwB3mNE;EAAsC,gBAAA;AxB+mNxC;;AwB/mNE;EAAsC,gBAAA;AxBmnNxC;;AwBnnNE;EAAsC,gBAAA;AxBunNxC;;AwBvnNE;EAAsC,gBAAA;AxB2nNxC;;AwB3nNE;EAAsC,gBAAA;AxB+nNxC;;AwB/nNE;EAAsC,gBAAA;AxBmoNxC;;AwBnoNE;EAAsC,gBAAA;AxBuoNxC;;AwBvoNE;EAAsC,gBAAA;AxB2oNxC;;AwB3oNE;EAAsC,gBAAA;AxB+oNxC;;AwB/oNE;EAAsC,gBAAA;AxBmpNxC;;AwBnpNE;EAAsC,gBAAA;AxBupNxC;;AwBvpNE;EAAsC,gBAAA;AxB2pNxC;;AwB3pNE;EAAsC,gBAAA;AxB+pNxC;;AwB/pNE;EAAsC,gBAAA;AxBmqNxC;;AwBnqNE;EAAsC,gBAAA;AxBuqNxC;;AwBvqNE;EAAsC,gBAAA;AxB2qNxC;;AwB3qNE;EAAsC,gBAAA;AxB+qNxC;;AwB/qNE;EAAsC,gBAAA;AxBmrNxC;;AwBnrNE;EAAsC,gBAAA;AxBurNxC;;AwBvrNE;EAAsC,gBAAA;AxB2rNxC;;AwB3rNE;EAAsC,gBAAA;AxB+rNxC;;AwB/rNE;EAAsC,gBAAA;AxBmsNxC;;AwBnsNE;EAAsC,gBAAA;AxBusNxC;;AwBvsNE;EAAsC,gBAAA;AxB2sNxC;;AwB3sNE;EAAsC,gBAAA;AxB+sNxC;;AwB/sNE;EAAsC,gBAAA;AxBmtNxC;;AwBntNE;EAAsC,gBAAA;AxButNxC;;AwBvtNE;EAAsC,gBAAA;AxB2tNxC;;AwB3tNE;EAAsC,gBAAA;AxB+tNxC;;AwB/tNE;EAAsC,gBAAA;AxBmuNxC;;AwBnuNE;EAAsC,gBAAA;AxBuuNxC;;AwBvuNE;EAAsC,gBAAA;AxB2uNxC;;AwB3uNE;EAAsC,gBAAA;AxB+uNxC;;AwB/uNE;EAAsC,gBAAA;AxBmvNxC;;AwBnvNE;EAAsC,gBAAA;AxBuvNxC;;AwBvvNE;EAAsC,gBAAA;AxB2vNxC;;AwB3vNE;EAAsC,gBAAA;AxB+vNxC;;AwB/vNE;EAAsC,gBAAA;AxBmwNxC;;AwBnwNE;EAAsC,gBAAA;AxBuwNxC;;AwBvwNE;EAAsC,gBAAA;AxB2wNxC;;AwB3wNE;EAAsC,gBAAA;AxB+wNxC;;AwB/wNE;EAAsC,gBAAA;AxBmxNxC;;AwBnxNE;EAAsC,gBAAA;AxBuxNxC;;AwBvxNE;EAAsC,gBAAA;AxB2xNxC;;AwB3xNE;EAAsC,gBAAA;AxB+xNxC;;AwB/xNE;EAAsC,gBAAA;AxBmyNxC;;AwBnyNE;EAAsC,gBAAA;AxBuyNxC;;AwBvyNE;EAAsC,gBAAA;AxB2yNxC;;AwB3yNE;EAAsC,gBAAA;AxB+yNxC;;AwB/yNE;EAAsC,gBAAA;AxBmzNxC;;AwBnzNE;EAAsC,gBAAA;AxBuzNxC;;AwBvzNE;EAAsC,gBAAA;AxB2zNxC;;AwB3zNE;EAAsC,gBAAA;AxB+zNxC;;AwB/zNE;EAAsC,gBAAA;AxBm0NxC;;AwBn0NE;EAAsC,gBAAA;AxBu0NxC;;AwBv0NE;EAAsC,gBAAA;AxB20NxC;;AwB30NE;EAAsC,gBAAA;AxB+0NxC;;AwB/0NE;EAAsC,gBAAA;AxBm1NxC;;AwBn1NE;EAAsC,gBAAA;AxBu1NxC;;AwBv1NE;EAAsC,gBAAA;AxB21NxC;;AwB31NE;EAAsC,gBAAA;AxB+1NxC;;AwB/1NE;EAAsC,gBAAA;AxBm2NxC;;AwBn2NE;EAAsC,gBAAA;AxBu2NxC;;AwBv2NE;EAAsC,gBAAA;AxB22NxC;;AwB32NE;EAAsC,gBAAA;AxB+2NxC;;AwB/2NE;EAAsC,gBAAA;AxBm3NxC;;AwBn3NE;EAAsC,gBAAA;AxBu3NxC;;AwBv3NE;EAAsC,gBAAA;AxB23NxC;;AwB33NE;EAAsC,gBAAA;AxB+3NxC;;AwB/3NE;EAAsC,gBAAA;AxBm4NxC;;AwBn4NE;EAAsC,gBAAA;AxBu4NxC;;AwBv4NE;EAAsC,gBAAA;AxB24NxC;;AwB34NE;EAAsC,gBAAA;AxB+4NxC;;AwB/4NE;EAAsC,gBAAA;AxBm5NxC;;AwBn5NE;EAAsC,gBAAA;AxBu5NxC;;AwBv5NE;EAAsC,gBAAA;AxB25NxC;;AwB35NE;EAAsC,gBAAA;AxB+5NxC;;AwB/5NE;EAAsC,gBAAA;AxBm6NxC;;AwBn6NE;EAAsC,gBAAA;AxBu6NxC;;AwBv6NE;EAAsC,gBAAA;AxB26NxC;;AwB36NE;EAAsC,gBAAA;AxB+6NxC;;AwB/6NE;EAAsC,gBAAA;AxBm7NxC;;AwBn7NE;EAAsC,gBAAA;AxBu7NxC;;AwBv7NE;EAAsC,gBAAA;AxB27NxC;;AwB37NE;EAAsC,gBAAA;AxB+7NxC;;AwB/7NE;EAAsC,gBAAA;AxBm8NxC;;AwBn8NE;EAAsC,gBAAA;AxBu8NxC;;AwBv8NE;EAAsC,gBAAA;AxB28NxC;;AwB38NE;EAAsC,gBAAA;AxB+8NxC;;AwB/8NE;EAAsC,gBAAA;AxBm9NxC;;AwBn9NE;EAAsC,gBAAA;AxBu9NxC;;AwBv9NE;EAAsC,gBAAA;AxB29NxC;;AwB39NE;EAAsC,gBAAA;AxB+9NxC;;AwB/9NE;EAAsC,gBAAA;AxBm+NxC;;AwBn+NE;EAAsC,gBAAA;AxBu+NxC;;AwBv+NE;EAAsC,gBAAA;AxB2+NxC;;AwB3+NE;EAAsC,gBAAA;AxB++NxC;;AwB/+NE;EAAsC,gBAAA;AxBm/NxC;;AwBn/NE;EAAsC,gBAAA;AxBu/NxC;;AwBv/NE;EAAsC,gBAAA;AxB2/NxC;;AwB3/NE;EAAsC,gBAAA;AxB+/NxC;;AwB//NE;EAAsC,gBAAA;AxBmgOxC;;AwBngOE;EAAsC,gBAAA;AxBugOxC;;AwBvgOE;EAAsC,gBAAA;AxB2gOxC;;AwB3gOE;EAAsC,gBAAA;AxB+gOxC;;AwB/gOE;EAAsC,gBAAA;AxBmhOxC;;AwBnhOE;EAAsC,gBAAA;AxBuhOxC;;AwBvhOE;EAAsC,gBAAA;AxB2hOxC;;AwB3hOE;EAAsC,gBAAA;AxB+hOxC;;AwB/hOE;EAAsC,gBAAA;AxBmiOxC;;AwBniOE;EAAsC,gBAAA;AxBuiOxC;;AwBviOE;EAAsC,gBAAA;AxB2iOxC;;AwB3iOE;EAAsC,gBAAA;AxB+iOxC;;AwB/iOE;EAAsC,gBAAA;AxBmjOxC;;AwBnjOE;EAAsC,gBAAA;AxBujOxC;;AwBvjOE;EAAsC,gBAAA;AxB2jOxC;;AwB3jOE;EAAsC,gBAAA;AxB+jOxC;;AwB/jOE;EAAsC,gBAAA;AxBmkOxC;;AwBnkOE;EAAsC,gBAAA;AxBukOxC;;AwBvkOE;EAAsC,gBAAA;AxB2kOxC;;AwB3kOE;EAAsC,gBAAA;AxB+kOxC;;AwB/kOE;EAAsC,gBAAA;AxBmlOxC;;AwBnlOE;EAAsC,gBAAA;AxBulOxC;;AwBvlOE;EAAsC,gBAAA;AxB2lOxC;;AwB3lOE;EAAsC,gBAAA;AxB+lOxC;;AwB/lOE;EAAsC,gBAAA;AxBmmOxC;;AwBnmOE;EAAsC,gBAAA;AxBumOxC;;AwBvmOE;EAAsC,gBAAA;AxB2mOxC;;AwB3mOE;EAAsC,gBAAA;AxB+mOxC;;AwB/mOE;EAAsC,gBAAA;AxBmnOxC;;AwBnnOE;EAAsC,gBAAA;AxBunOxC;;AwBvnOE;EAAsC,gBAAA;AxB2nOxC;;AwB3nOE;EAAsC,gBAAA;AxB+nOxC;;AwB/nOE;EAAsC,gBAAA;AxBmoOxC;;AwBnoOE;EAAsC,gBAAA;AxBuoOxC;;AwBvoOE;EAAsC,gBAAA;AxB2oOxC;;AwB3oOE;EAAsC,gBAAA;AxB+oOxC;;AwB/oOE;EAAsC,gBAAA;AxBmpOxC;;AwBnpOE;EAAsC,gBAAA;AxBupOxC;;AwBvpOE;EAAsC,gBAAA;AxB2pOxC;;AwB3pOE;EAAsC,gBAAA;AxB+pOxC;;AwB/pOE;EAAsC,gBAAA;AxBmqOxC;;AwBnqOE;EAAsC,gBAAA;AxBuqOxC;;AwBvqOE;EAAsC,gBAAA;AxB2qOxC;;AwB3qOE;EAAsC,gBAAA;AxB+qOxC;;AwB/qOE;EAAsC,gBAAA;AxBmrOxC;;AwBnrOE;EAAsC,gBAAA;AxBurOxC;;AwBvrOE;EAAsC,gBAAA;AxB2rOxC;;AwB3rOE;EAAsC,gBAAA;AxB+rOxC;;AwB/rOE;EAAsC,gBAAA;AxBmsOxC;;AwBnsOE;EAAsC,gBAAA;AxBusOxC;;AwBvsOE;EAAsC,gBAAA;AxB2sOxC;;AwB3sOE;EAAsC,gBAAA;AxB+sOxC;;AwB/sOE;EAAsC,gBAAA;AxBmtOxC;;AwBntOE;EAAsC,gBAAA;AxButOxC;;AwBvtOE;EAAsC,gBAAA;AxB2tOxC;;AwB3tOE;EAAsC,gBAAA;AxB+tOxC;;AwB/tOE;EAAsC,gBAAA;AxBmuOxC;;AwBnuOE;EAAsC,gBAAA;AxBuuOxC;;AwBvuOE;EAAsC,gBAAA;AxB2uOxC;;AwB3uOE;EAAsC,gBAAA;AxB+uOxC;;AwB/uOE;EAAsC,gBAAA;AxBmvOxC;;AwBnvOE;EAAsC,gBAAA;AxBuvOxC;;AwBvvOE;EAAsC,gBAAA;AxB2vOxC;;AwB3vOE;EAAsC,gBAAA;AxB+vOxC;;AwB/vOE;EAAsC,gBAAA;AxBmwOxC;;AwBnwOE;EAAsC,gBAAA;AxBuwOxC;;AwBvwOE;EAAsC,gBAAA;AxB2wOxC;;AwB3wOE;EAAsC,gBAAA;AxB+wOxC;;AwB/wOE;EAAsC,gBAAA;AxBmxOxC;;AwBnxOE;EAAsC,gBAAA;AxBuxOxC;;AwBvxOE;EAAsC,gBAAA;AxB2xOxC;;AwB3xOE;EAAsC,gBAAA;AxB+xOxC;;AwB/xOE;EAAsC,gBAAA;AxBmyOxC;;AwBnyOE;EAAsC,gBAAA;AxBuyOxC;;AwBvyOE;EAAsC,gBAAA;AxB2yOxC;;AwB3yOE;EAAsC,gBAAA;AxB+yOxC;;AwB/yOE;EAAsC,gBAAA;AxBmzOxC;;AwBnzOE;EAAsC,gBAAA;AxBuzOxC;;AwBvzOE;EAAsC,gBAAA;AxB2zOxC;;AwB3zOE;EAAsC,gBAAA;AxB+zOxC;;AwB/zOE;EAAsC,gBAAA;AxBm0OxC;;AwBn0OE;EAAsC,gBAAA;AxBu0OxC;;AwBv0OE;EAAsC,gBAAA;AxB20OxC;;AwB30OE;EAAsC,gBAAA;AxB+0OxC;;AwB/0OE;EAAsC,gBAAA;AxBm1OxC;;AwBn1OE;EAAsC,gBAAA;AxBu1OxC;;AwBv1OE;EAAsC,gBAAA;AxB21OxC;;AwB31OE;EAAsC,gBAAA;AxB+1OxC;;AwB/1OE;EAAsC,gBAAA;AxBm2OxC;;AwBn2OE;EAAsC,gBAAA;AxBu2OxC;;AwBv2OE;EAAsC,gBAAA;AxB22OxC;;AwB32OE;EAAsC,gBAAA;AxB+2OxC;;AwB/2OE;EAAsC,gBAAA;AxBm3OxC;;AwBn3OE;EAAsC,gBAAA;AxBu3OxC;;AwBv3OE;EAAsC,gBAAA;AxB23OxC;;AwB33OE;EAAsC,gBAAA;AxB+3OxC;;AwB/3OE;EAAsC,gBAAA;AxBm4OxC;;AwBn4OE;EAAsC,gBAAA;AxBu4OxC;;AwBv4OE;EAAsC,gBAAA;AxB24OxC;;AwB34OE;EAAsC,gBAAA;AxB+4OxC;;AwB/4OE;EAAsC,gBAAA;AxBm5OxC;;AwBn5OE;EAAsC,gBAAA;AxBu5OxC;;AwBv5OE;EAAsC,gBAAA;AxB25OxC;;AwB35OE;EAAsC,gBAAA;AxB+5OxC;;AwB/5OE;EAAsC,gBAAA;AxBm6OxC;;AwBn6OE;EAAsC,gBAAA;AxBu6OxC;;AwBv6OE;EAAsC,gBAAA;AxB26OxC;;AwB36OE;EAAsC,gBAAA;AxB+6OxC;;AwB/6OE;EAAsC,gBAAA;AxBm7OxC;;AwBn7OE;EAAsC,gBAAA;AxBu7OxC;;AwBv7OE;EAAsC,gBAAA;AxB27OxC;;AwB37OE;EAAsC,gBAAA;AxB+7OxC;;AwB/7OE;EAAsC,gBAAA;AxBm8OxC;;AwBn8OE;EAAsC,gBAAA;AxBu8OxC;;AwBv8OE;EAAsC,gBAAA;AxB28OxC;;AwB38OE;EAAsC,gBAAA;AxB+8OxC;;AwB/8OE;EAAsC,gBAAA;AxBm9OxC;;AwBn9OE;EAAsC,gBAAA;AxBu9OxC;;AwBv9OE;EAAsC,gBAAA;AxB29OxC;;AwB39OE;EAAsC,gBAAA;AxB+9OxC;;AwB/9OE;EAAsC,gBAAA;AxBm+OxC;;AwBn+OE;EAAsC,gBAAA;AxBu+OxC;;AwBv+OE;EAAsC,gBAAA;AxB2+OxC;;AwB3+OE;EAAsC,gBAAA;AxB++OxC;;AwB/+OE;EAAsC,gBAAA;AxBm/OxC;;AwBn/OE;EAAsC,gBAAA;AxBu/OxC;;AwBv/OE;EAAsC,gBAAA;AxB2/OxC;;AwB3/OE;EAAsC,gBAAA;AxB+/OxC;;AwB//OE;EAAsC,gBAAA;AxBmgPxC;;AwBngPE;EAAsC,gBAAA;AxBugPxC;;AwBvgPE;EAAsC,gBAAA;AxB2gPxC;;AwB3gPE;EAAsC,gBAAA;AxB+gPxC;;AwB/gPE;EAAsC,gBAAA;AxBmhPxC;;AwBnhPE;EAAsC,gBAAA;AxBuhPxC;;AwBvhPE;EAAsC,gBAAA;AxB2hPxC;;AwB3hPE;EAAsC,gBAAA;AxB+hPxC;;AwB/hPE;EAAsC,gBAAA;AxBmiPxC;;AwBniPE;EAAsC,gBAAA;AxBuiPxC;;AwBviPE;EAAsC,gBAAA;AxB2iPxC;;AwB3iPE;EAAsC,gBAAA;AxB+iPxC;;AwB/iPE;EAAsC,gBAAA;AxBmjPxC;;AwBnjPE;EAAsC,gBAAA;AxBujPxC;;AwBvjPE;EAAsC,gBAAA;AxB2jPxC;;AwB3jPE;EAAsC,gBAAA;AxB+jPxC;;AwB/jPE;EAAsC,gBAAA;AxBmkPxC;;AwBnkPE;EAAsC,gBAAA;AxBukPxC;;AwBvkPE;EAAsC,gBAAA;AxB2kPxC;;AwB3kPE;EAAsC,gBAAA;AxB+kPxC;;AwB/kPE;EAAsC,gBAAA;AxBmlPxC;;AwBnlPE;EAAsC,gBAAA;AxBulPxC;;AwBvlPE;EAAsC,gBAAA;AxB2lPxC;;AwB3lPE;EAAsC,gBAAA;AxB+lPxC;;AwB/lPE;EAAsC,gBAAA;AxBmmPxC;;AwBnmPE;EAAsC,gBAAA;AxBumPxC;;AwBvmPE;EAAsC,gBAAA;AxB2mPxC;;AwB3mPE;EAAsC,gBAAA;AxB+mPxC;;AwB/mPE;EAAsC,gBAAA;AxBmnPxC;;AwBnnPE;EAAsC,gBAAA;AxBunPxC;;AwBvnPE;EAAsC,gBAAA;AxB2nPxC;;AwB3nPE;EAAsC,gBAAA;AxB+nPxC;;AwB/nPE;EAAsC,gBAAA;AxBmoPxC;;AwBnoPE;EAAsC,gBAAA;AxBuoPxC;;AwBvoPE;EAAsC,gBAAA;AxB2oPxC;;AwB3oPE;EAAsC,gBAAA;AxB+oPxC;;AwB/oPE;EAAsC,gBAAA;AxBmpPxC;;AwBnpPE;EAAsC,gBAAA;AxBupPxC;;AwBvpPE;EAAsC,gBAAA;AxB2pPxC;;AwB3pPE;EAAsC,gBAAA;AxB+pPxC;;AwB/pPE;EAAsC,gBAAA;AxBmqPxC;;AwBnqPE;EAAsC,gBAAA;AxBuqPxC;;AwBvqPE;EAAsC,gBAAA;AxB2qPxC;;AwB3qPE;EAAsC,gBAAA;AxB+qPxC;;AwB/qPE;EAAsC,gBAAA;AxBmrPxC;;AwBnrPE;EAAsC,gBAAA;AxBurPxC;;AwBvrPE;EAAsC,gBAAA;AxB2rPxC;;AwB3rPE;EAAsC,gBAAA;AxB+rPxC;;AwB/rPE;EAAsC,gBAAA;AxBmsPxC;;AwBnsPE;EAAsC,gBAAA;AxBusPxC;;AwBvsPE;EAAsC,gBAAA;AxB2sPxC;;AwB3sPE;EAAsC,gBAAA;AxB+sPxC;;AwB/sPE;EAAsC,gBAAA;AxBmtPxC;;AwBntPE;EAAsC,gBAAA;AxButPxC;;AwBvtPE;EAAsC,gBAAA;AxB2tPxC;;AwB3tPE;EAAsC,gBAAA;AxB+tPxC;;AwB/tPE;EAAsC,gBAAA;AxBmuPxC;;AwBnuPE;EAAsC,gBAAA;AxBuuPxC;;AwBvuPE;EAAsC,gBAAA;AxB2uPxC;;AwB3uPE;EAAsC,gBAAA;AxB+uPxC;;AwB/uPE;EAAsC,gBAAA;AxBmvPxC;;AwBnvPE;EAAsC,gBAAA;AxBuvPxC;;AwBvvPE;EAAsC,gBAAA;AxB2vPxC;;AwB3vPE;EAAsC,gBAAA;AxB+vPxC;;AwB/vPE;EAAsC,YAAA;AxBmwPxC;;AwBnwPE;EAAsC,gBAAA;AxBuwPxC;;AwBvwPE;EAAsC,gBAAA;AxB2wPxC;;AwB3wPE;EAAsC,gBAAA;AxB+wPxC;;AwB/wPE;EAAsC,gBAAA;AxBmxPxC;;AwBnxPE;EAAsC,gBAAA;AxBuxPxC;;AwBvxPE;EAAsC,gBAAA;AxB2xPxC;;AwB3xPE;EAAsC,gBAAA;AxB+xPxC;;AwB/xPE;EAAsC,gBAAA;AxBmyPxC;;AwBnyPE;EAAsC,gBAAA;AxBuyPxC;;AwBvyPE;EAAsC,gBAAA;AxB2yPxC;;AwB3yPE;EAAsC,gBAAA;AxB+yPxC;;AwB/yPE;EAAsC,gBAAA;AxBmzPxC;;AwBnzPE;EAAsC,gBAAA;AxBuzPxC;;AwBvzPE;EAAsC,gBAAA;AxB2zPxC;;AwB3zPE;EAAsC,gBAAA;AxB+zPxC;;AwB/zPE;EAAsC,gBAAA;AxBm0PxC;;AwBn0PE;EAAsC,gBAAA;AxBu0PxC;;AwBv0PE;EAAsC,gBAAA;AxB20PxC;;AwB30PE;EAAsC,gBAAA;AxB+0PxC;;AwB/0PE;EAAsC,gBAAA;AxBm1PxC;;AwBn1PE;EAAsC,gBAAA;AxBu1PxC;;AwBv1PE;EAAsC,gBAAA;AxB21PxC;;AwB31PE;EAAsC,gBAAA;AxB+1PxC;;AwB/1PE;EAAsC,gBAAA;AxBm2PxC;;AwBn2PE;EAAsC,gBAAA;AxBu2PxC;;AwBv2PE;EAAsC,gBAAA;AxB22PxC;;AwB32PE;EAAsC,gBAAA;AxB+2PxC;;AwB/2PE;EAAsC,gBAAA;AxBm3PxC;;AwBn3PE;EAAsC,gBAAA;AxBu3PxC;;AwBv3PE;EAAsC,gBAAA;AxB23PxC;;AwB33PE;EAAsC,gBAAA;AxB+3PxC;;AwB/3PE;EAAsC,gBAAA;AxBm4PxC;;AwBn4PE;EAAsC,gBAAA;AxBu4PxC;;AwBv4PE;EAAsC,gBAAA;AxB24PxC;;AwB34PE;EAAsC,gBAAA;AxB+4PxC;;AwB/4PE;EAAsC,gBAAA;AxBm5PxC;;AwBn5PE;EAAsC,gBAAA;AxBu5PxC;;AwBv5PE;EAAsC,gBAAA;AxB25PxC;;AwB35PE;EAAsC,gBAAA;AxB+5PxC;;AwB/5PE;EAAsC,gBAAA;AxBm6PxC;;AwBn6PE;EAAsC,gBAAA;AxBu6PxC;;AwBv6PE;EAAsC,gBAAA;AxB26PxC;;AwB36PE;EAAsC,gBAAA;AxB+6PxC;;AwB/6PE;EAAsC,gBAAA;AxBm7PxC;;AwBn7PE;EAAsC,gBAAA;AxBu7PxC;;AwBv7PE;EAAsC,gBAAA;AxB27PxC;;AwB37PE;EAAsC,gBAAA;AxB+7PxC;;AwB/7PE;EAAsC,gBAAA;AxBm8PxC;;AwBn8PE;EAAsC,gBAAA;AxBu8PxC;;AwBv8PE;EAAsC,gBAAA;AxB28PxC;;AwB38PE;EAAsC,gBAAA;AxB+8PxC;;AwB/8PE;EAAsC,gBAAA;AxBm9PxC;;AwBn9PE;EAAsC,gBAAA;AxBu9PxC;;AwBv9PE;EAAsC,gBAAA;AxB29PxC;;AwB39PE;EAAsC,gBAAA;AxB+9PxC;;AwB/9PE;EAAsC,gBAAA;AxBm+PxC;;AwBn+PE;EAAsC,gBAAA;AxBu+PxC;;AwBv+PE;EAAsC,gBAAA;AxB2+PxC;;AwB3+PE;EAAsC,gBAAA;AxB++PxC;;AwB/+PE;EAAsC,gBAAA;AxBm/PxC;;AwBn/PE;EAAsC,gBAAA;AxBu/PxC;;AwBv/PE;EAAsC,gBAAA;AxB2/PxC;;AwB3/PE;EAAsC,gBAAA;AxB+/PxC;;AwB//PE;EAAsC,gBAAA;AxBmgQxC;;AwBngQE;EAAsC,gBAAA;AxBugQxC;;AwBvgQE;EAAsC,gBAAA;AxB2gQxC;;AwB3gQE;EAAsC,gBAAA;AxB+gQxC;;AwB/gQE;EAAsC,gBAAA;AxBmhQxC;;AwBnhQE;EAAsC,gBAAA;AxBuhQxC;;AwBvhQE;EAAsC,gBAAA;AxB2hQxC;;AwB3hQE;EAAsC,gBAAA;AxB+hQxC;;AwB/hQE;EAAsC,gBAAA;AxBmiQxC;;AwBniQE;EAAsC,gBAAA;AxBuiQxC;;AwBviQE;EAAsC,gBAAA;AxB2iQxC;;AwB3iQE;EAAsC,gBAAA;AxB+iQxC;;AwB/iQE;EAAsC,gBAAA;AxBmjQxC;;AwBnjQE;EAAsC,gBAAA;AxBujQxC;;AwBvjQE;EAAsC,aAAA;AxB2jQxC;;AwB3jQE;EAAsC,gBAAA;AxB+jQxC;;AwB/jQE;EAAsC,gBAAA;AxBmkQxC;;AwBnkQE;EAAsC,gBAAA;AxBukQxC;;AwBvkQE;EAAsC,gBAAA;AxB2kQxC;;AwB3kQE;EAAsC,gBAAA;AxB+kQxC;;AwB/kQE;EAAsC,gBAAA;AxBmlQxC;;AwBnlQE;EAAsC,gBAAA;AxBulQxC;;AwBvlQE;EAAsC,gBAAA;AxB2lQxC;;AwB3lQE;EAAsC,gBAAA;AxB+lQxC;;AwB/lQE;EAAsC,gBAAA;AxBmmQxC;;AwBnmQE;EAAsC,gBAAA;AxBumQxC;;AwBvmQE;EAAsC,gBAAA;AxB2mQxC;;AwB3mQE;EAAsC,gBAAA;AxB+mQxC;;AwB/mQE;EAAsC,gBAAA;AxBmnQxC;;AwBnnQE;EAAsC,gBAAA;AxBunQxC;;AwBvnQE;EAAsC,gBAAA;AxB2nQxC;;AwB3nQE;EAAsC,gBAAA;AxB+nQxC;;AwB/nQE;EAAsC,gBAAA;AxBmoQxC;;AwBnoQE;EAAsC,gBAAA;AxBuoQxC;;AwBvoQE;EAAsC,gBAAA;AxB2oQxC;;AwB3oQE;EAAsC,gBAAA;AxB+oQxC;;AwB/oQE;EAAsC,gBAAA;AxBmpQxC;;AwBnpQE;EAAsC,gBAAA;AxBupQxC;;AwBvpQE;EAAsC,YAAA;AxB2pQxC;;AwB3pQE;EAAsC,gBAAA;AxB+pQxC;;AwB/pQE;EAAsC,gBAAA;AxBmqQxC;;AwBnqQE;EAAsC,gBAAA;AxBuqQxC;;AwBvqQE;EAAsC,gBAAA;AxB2qQxC;;AwB3qQE;EAAsC,gBAAA;AxB+qQxC;;AwB/qQE;EAAsC,gBAAA;AxBmrQxC;;AwBnrQE;EAAsC,gBAAA;AxBurQxC;;AwBvrQE;EAAsC,gBAAA;AxB2rQxC;;AwB3rQE;EAAsC,gBAAA;AxB+rQxC;;AwB/rQE;EAAsC,gBAAA;AxBmsQxC;;AwBnsQE;EAAsC,gBAAA;AxBusQxC;;AwBvsQE;EAAsC,gBAAA;AxB2sQxC;;AwB3sQE;EAAsC,gBAAA;AxB+sQxC;;AwB/sQE;EAAsC,gBAAA;AxBmtQxC;;AwBntQE;EAAsC,gBAAA;AxButQxC;;AwBvtQE;EAAsC,gBAAA;AxB2tQxC;;AwB3tQE;EAAsC,gBAAA;AxB+tQxC;;AwB/tQE;EAAsC,gBAAA;AxBmuQxC;;AwBnuQE;EAAsC,gBAAA;AxBuuQxC;;AwBvuQE;EAAsC,gBAAA;AxB2uQxC;;AwB3uQE;EAAsC,gBAAA;AxB+uQxC;;AwB/uQE;EAAsC,gBAAA;AxBmvQxC;;AwBnvQE;EAAsC,gBAAA;AxBuvQxC;;AwBvvQE;EAAsC,gBAAA;AxB2vQxC;;AwB3vQE;EAAsC,gBAAA;AxB+vQxC;;AwB/vQE;EAAsC,gBAAA;AxBmwQxC;;AwBnwQE;EAAsC,gBAAA;AxBuwQxC;;AwBvwQE;EAAsC,gBAAA;AxB2wQxC;;AwB3wQE;EAAsC,gBAAA;AxB+wQxC;;AwB/wQE;EAAsC,gBAAA;AxBmxQxC;;AwBnxQE;EAAsC,gBAAA;AxBuxQxC;;AwBvxQE;EAAsC,gBAAA;AxB2xQxC;;AwB3xQE;EAAsC,gBAAA;AxB+xQxC;;AwB/xQE;EAAsC,gBAAA;AxBmyQxC;;AwBnyQE;EAAsC,gBAAA;AxBuyQxC;;AwBvyQE;EAAsC,gBAAA;AxB2yQxC;;AwB3yQE;EAAsC,gBAAA;AxB+yQxC;;AwB/yQE;EAAsC,gBAAA;AxBmzQxC;;AwBnzQE;EAAsC,gBAAA;AxBuzQxC;;AwBvzQE;EAAsC,gBAAA;AxB2zQxC;;AwB3zQE;EAAsC,gBAAA;AxB+zQxC;;AwB/zQE;EAAsC,gBAAA;AxBm0QxC;;AwBn0QE;EAAsC,gBAAA;AxBu0QxC;;AwBv0QE;EAAsC,gBAAA;AxB20QxC;;AwB30QE;EAAsC,gBAAA;AxB+0QxC;;AwB/0QE;EAAsC,gBAAA;AxBm1QxC;;AwBn1QE;EAAsC,gBAAA;AxBu1QxC;;AwBv1QE;EAAsC,gBAAA;AxB21QxC;;AwB31QE;EAAsC,gBAAA;AxB+1QxC;;AwB/1QE;EAAsC,gBAAA;AxBm2QxC;;AwBn2QE;EAAsC,gBAAA;AxBu2QxC;;AwBv2QE;EAAsC,gBAAA;AxB22QxC;;AwB32QE;EAAsC,gBAAA;AxB+2QxC;;AwB/2QE;EAAsC,gBAAA;AxBm3QxC;;AwBn3QE;EAAsC,gBAAA;AxBu3QxC;;AwBv3QE;EAAsC,gBAAA;AxB23QxC;;AwB33QE;EAAsC,gBAAA;AxB+3QxC;;AwB/3QE;EAAsC,gBAAA;AxBm4QxC;;AwBn4QE;EAAsC,gBAAA;AxBu4QxC;;AwBv4QE;EAAsC,gBAAA;AxB24QxC;;AwB34QE;EAAsC,gBAAA;AxB+4QxC;;AwB/4QE;EAAsC,gBAAA;AxBm5QxC;;AwBn5QE;EAAsC,gBAAA;AxBu5QxC;;AwBv5QE;EAAsC,gBAAA;AxB25QxC;;AwB35QE;EAAsC,gBAAA;AxB+5QxC;;AwB/5QE;EAAsC,gBAAA;AxBm6QxC;;AwBn6QE;EAAsC,gBAAA;AxBu6QxC;;AwBv6QE;EAAsC,gBAAA;AxB26QxC;;AwB36QE;EAAsC,gBAAA;AxB+6QxC;;AwB/6QE;EAAsC,gBAAA;AxBm7QxC;;AwBn7QE;EAAsC,gBAAA;AxBu7QxC;;AwBv7QE;EAAsC,gBAAA;AxB27QxC;;AwB37QE;EAAsC,gBAAA;AxB+7QxC;;AwB/7QE;EAAsC,gBAAA;AxBm8QxC;;AwBn8QE;EAAsC,gBAAA;AxBu8QxC;;AwBv8QE;EAAsC,gBAAA;AxB28QxC;;AwB38QE;EAAsC,gBAAA;AxB+8QxC;;AwB/8QE;EAAsC,gBAAA;AxBm9QxC;;AwBn9QE;EAAsC,gBAAA;AxBu9QxC;;AwBv9QE;EAAsC,gBAAA;AxB29QxC;;AwB39QE;EAAsC,gBAAA;AxB+9QxC;;AwB/9QE;EAAsC,aAAA;AxBm+QxC;;AwBn+QE;EAAsC,gBAAA;AxBu+QxC;;AwBv+QE;EAAsC,gBAAA;AxB2+QxC;;AwB3+QE;EAAsC,gBAAA;AxB++QxC;;AwB/+QE;EAAsC,gBAAA;AxBm/QxC;;AwBn/QE;EAAsC,gBAAA;AxBu/QxC;;AwBv/QE;EAAsC,gBAAA;AxB2/QxC;;AwB3/QE;EAAsC,gBAAA;AxB+/QxC;;AwB//QE;EAAsC,gBAAA;AxBmgRxC;;AwBngRE;EAAsC,gBAAA;AxBugRxC;;AwBvgRE;EAAsC,gBAAA;AxB2gRxC;;AwB3gRE;EAAsC,gBAAA;AxB+gRxC;;AwB/gRE;EAAsC,gBAAA;AxBmhRxC;;AwBnhRE;EAAsC,gBAAA;AxBuhRxC;;AwBvhRE;EAAsC,gBAAA;AxB2hRxC;;AwB3hRE;EAAsC,gBAAA;AxB+hRxC;;AwB/hRE;EAAsC,gBAAA;AxBmiRxC;;AwBniRE;EAAsC,gBAAA;AxBuiRxC;;AwBviRE;EAAsC,gBAAA;AxB2iRxC;;AwB3iRE;EAAsC,gBAAA;AxB+iRxC;;AwB/iRE;EAAsC,gBAAA;AxBmjRxC;;AwBnjRE;EAAsC,gBAAA;AxBujRxC;;AwBvjRE;EAAsC,gBAAA;AxB2jRxC;;AwB3jRE;EAAsC,gBAAA;AxB+jRxC;;AwB/jRE;EAAsC,gBAAA;AxBmkRxC;;AwBnkRE;EAAsC,gBAAA;AxBukRxC;;AwBvkRE;EAAsC,gBAAA;AxB2kRxC;;AwB3kRE;EAAsC,gBAAA;AxB+kRxC;;AwB/kRE;EAAsC,gBAAA;AxBmlRxC;;AwBnlRE;EAAsC,gBAAA;AxBulRxC;;AwBvlRE;EAAsC,gBAAA;AxB2lRxC;;AwB3lRE;EAAsC,gBAAA;AxB+lRxC;;AwB/lRE;EAAsC,gBAAA;AxBmmRxC;;AwBnmRE;EAAsC,gBAAA;AxBumRxC;;AwBvmRE;EAAsC,gBAAA;AxB2mRxC;;AwB3mRE;EAAsC,gBAAA;AxB+mRxC;;AwB/mRE;EAAsC,gBAAA;AxBmnRxC;;AwBnnRE;EAAsC,gBAAA;AxBunRxC;;AwBvnRE;EAAsC,gBAAA;AxB2nRxC;;AwB3nRE;EAAsC,gBAAA;AxB+nRxC;;AwB/nRE;EAAsC,gBAAA;AxBmoRxC;;AwBnoRE;EAAsC,gBAAA;AxBuoRxC;;AwBvoRE;EAAsC,gBAAA;AxB2oRxC;;AwB3oRE;EAAsC,gBAAA;AxB+oRxC;;AwB/oRE;EAAsC,gBAAA;AxBmpRxC;;AwBnpRE;EAAsC,gBAAA;AxBupRxC;;AwBvpRE;EAAsC,gBAAA;AxB2pRxC;;AwB3pRE;EAAsC,gBAAA;AxB+pRxC;;AwB/pRE;EAAsC,gBAAA;AxBmqRxC;;AwBnqRE;EAAsC,gBAAA;AxBuqRxC;;AwBvqRE;EAAsC,gBAAA;AxB2qRxC;;AwB3qRE;EAAsC,gBAAA;AxB+qRxC;;AwB/qRE;EAAsC,gBAAA;AxBmrRxC;;AwBnrRE;EAAsC,gBAAA;AxBurRxC;;AwBvrRE;EAAsC,gBAAA;AxB2rRxC;;AwB3rRE;EAAsC,gBAAA;AxB+rRxC;;AwB/rRE;EAAsC,gBAAA;AxBmsRxC;;AwBnsRE;EAAsC,gBAAA;AxBusRxC;;AwBvsRE;EAAsC,gBAAA;AxB2sRxC;;AwB3sRE;EAAsC,gBAAA;AxB+sRxC;;AwB/sRE;EAAsC,gBAAA;AxBmtRxC;;AwBntRE;EAAsC,gBAAA;AxButRxC;;AwBvtRE;EAAsC,gBAAA;AxB2tRxC;;AwB3tRE;EAAsC,gBAAA;AxB+tRxC;;AwB/tRE;EAAsC,gBAAA;AxBmuRxC;;AwBnuRE;EAAsC,gBAAA;AxBuuRxC;;AwBvuRE;EAAsC,gBAAA;AxB2uRxC;;AwB3uRE;EAAsC,gBAAA;AxB+uRxC;;AwB/uRE;EAAsC,gBAAA;AxBmvRxC;;AwBnvRE;EAAsC,gBAAA;AxBuvRxC;;AwBvvRE;EAAsC,gBAAA;AxB2vRxC;;AwB3vRE;EAAsC,gBAAA;AxB+vRxC;;AwB/vRE;EAAsC,gBAAA;AxBmwRxC;;AwBnwRE;EAAsC,gBAAA;AxBuwRxC;;AwBvwRE;EAAsC,gBAAA;AxB2wRxC;;AwB3wRE;EAAsC,gBAAA;AxB+wRxC;;AwB/wRE;EAAsC,gBAAA;AxBmxRxC;;AwBnxRE;EAAsC,gBAAA;AxBuxRxC;;AwBvxRE;EAAsC,gBAAA;AxB2xRxC;;AwB3xRE;EAAsC,gBAAA;AxB+xRxC;;AwB/xRE;EAAsC,gBAAA;AxBmyRxC;;AwBnyRE;EAAsC,gBAAA;AxBuyRxC;;AwBvyRE;EAAsC,gBAAA;AxB2yRxC;;AwB3yRE;EAAsC,gBAAA;AxB+yRxC;;AwB/yRE;EAAsC,gBAAA;AxBmzRxC;;AwBnzRE;EAAsC,gBAAA;AxBuzRxC;;AwBvzRE;EAAsC,gBAAA;AxB2zRxC;;AwB3zRE;EAAsC,gBAAA;AxB+zRxC;;AwB/zRE;EAAsC,gBAAA;AxBm0RxC;;AwBn0RE;EAAsC,gBAAA;AxBu0RxC;;AwBv0RE;EAAsC,gBAAA;AxB20RxC;;AwB30RE;EAAsC,gBAAA;AxB+0RxC;;AwB/0RE;EAAsC,gBAAA;AxBm1RxC;;AwBn1RE;EAAsC,gBAAA;AxBu1RxC;;AwBv1RE;EAAsC,gBAAA;AxB21RxC;;AwB31RE;EAAsC,gBAAA;AxB+1RxC;;AwB/1RE;EAAsC,gBAAA;AxBm2RxC;;AwBn2RE;EAAsC,gBAAA;AxBu2RxC;;AwBv2RE;EAAsC,gBAAA;AxB22RxC;;AwB32RE;EAAsC,gBAAA;AxB+2RxC;;AwB/2RE;EAAsC,gBAAA;AxBm3RxC;;AwBn3RE;EAAsC,gBAAA;AxBu3RxC;;AwBv3RE;EAAsC,gBAAA;AxB23RxC;;AwB33RE;EAAsC,gBAAA;AxB+3RxC;;AwB/3RE;EAAsC,gBAAA;AxBm4RxC;;AwBn4RE;EAAsC,gBAAA;AxBu4RxC;;AwBv4RE;EAAsC,gBAAA;AxB24RxC;;AwB34RE;EAAsC,gBAAA;AxB+4RxC;;AwB/4RE;EAAsC,gBAAA;AxBm5RxC;;AwBn5RE;EAAsC,gBAAA;AxBu5RxC;;AwBv5RE;EAAsC,gBAAA;AxB25RxC;;AwB35RE;EAAsC,gBAAA;AxB+5RxC;;AwB/5RE;EAAsC,gBAAA;AxBm6RxC;;AwBn6RE;EAAsC,gBAAA;AxBu6RxC;;AwBv6RE;EAAsC,gBAAA;AxB26RxC;;AwB36RE;EAAsC,gBAAA;AxB+6RxC;;AwB/6RE;EAAsC,gBAAA;AxBm7RxC;;AwBn7RE;EAAsC,gBAAA;AxBu7RxC;;AwBv7RE;EAAsC,gBAAA;AxB27RxC;;AwB37RE;EAAsC,gBAAA;AxB+7RxC;;AwB/7RE;EAAsC,gBAAA;AxBm8RxC;;AwBn8RE;EAAsC,gBAAA;AxBu8RxC;;AwBv8RE;EAAsC,gBAAA;AxB28RxC;;AwB38RE;EAAsC,gBAAA;AxB+8RxC;;AwB/8RE;EAAsC,gBAAA;AxBm9RxC;;AwBn9RE;EAAsC,gBAAA;AxBu9RxC;;AwBv9RE;EAAsC,gBAAA;AxB29RxC;;AwB39RE;EAAsC,aAAA;AxB+9RxC;;AwB/9RE;EAAsC,YAAA;AxBm+RxC;;AwBn+RE;EAAsC,gBAAA;AxBu+RxC;;AwBv+RE;EAAsC,gBAAA;AxB2+RxC;;AwB3+RE;EAAsC,gBAAA;AxB++RxC;;AwB/+RE;EAAsC,gBAAA;AxBm/RxC;;AwBn/RE;EAAsC,gBAAA;AxBu/RxC;;AwBv/RE;EAAsC,gBAAA;AxB2/RxC;;AwB3/RE;EAAsC,gBAAA;AxB+/RxC;;AwB//RE;EAAsC,gBAAA;AxBmgSxC;;AwBngSE;EAAsC,gBAAA;AxBugSxC;;AwBvgSE;EAAsC,gBAAA;AxB2gSxC;;AwB3gSE;EAAsC,gBAAA;AxB+gSxC;;AwB/gSE;EAAsC,gBAAA;AxBmhSxC;;AwBnhSE;EAAsC,gBAAA;AxBuhSxC;;AwBvhSE;EAAsC,gBAAA;AxB2hSxC;;AwB3hSE;EAAsC,gBAAA;AxB+hSxC;;AwB/hSE;EAAsC,gBAAA;AxBmiSxC;;AwBniSE;EAAsC,gBAAA;AxBuiSxC;;AwBviSE;EAAsC,gBAAA;AxB2iSxC;;AwB3iSE;EAAsC,gBAAA;AxB+iSxC;;AwB/iSE;EAAsC,gBAAA;AxBmjSxC;;AwBnjSE;EAAsC,gBAAA;AxBujSxC;;AwBvjSE;EAAsC,gBAAA;AxB2jSxC;;AwB3jSE;EAAsC,gBAAA;AxB+jSxC;;AwB/jSE;EAAsC,gBAAA;AxBmkSxC;;AwBnkSE;EAAsC,gBAAA;AxBukSxC;;AwBvkSE;EAAsC,gBAAA;AxB2kSxC;;AwB3kSE;EAAsC,gBAAA;AxB+kSxC;;AwB/kSE;EAAsC,gBAAA;AxBmlSxC;;AwBnlSE;EAAsC,gBAAA;AxBulSxC;;AwBvlSE;EAAsC,gBAAA;AxB2lSxC;;AwB3lSE;EAAsC,gBAAA;AxB+lSxC;;AwB/lSE;EAAsC,gBAAA;AxBmmSxC;;AwBnmSE;EAAsC,gBAAA;AxBumSxC;;AwBvmSE;EAAsC,gBAAA;AxB2mSxC;;AwB3mSE;EAAsC,gBAAA;AxB+mSxC;;AwB/mSE;EAAsC,gBAAA;AxBmnSxC;;AwBnnSE;EAAsC,gBAAA;AxBunSxC;;AwBvnSE;EAAsC,gBAAA;AxB2nSxC;;AwB3nSE;EAAsC,gBAAA;AxB+nSxC;;AwB/nSE;EAAsC,gBAAA;AxBmoSxC;;AwBnoSE;EAAsC,gBAAA;AxBuoSxC;;AwBvoSE;EAAsC,gBAAA;AxB2oSxC;;AwB3oSE;EAAsC,gBAAA;AxB+oSxC;;AwB/oSE;EAAsC,gBAAA;AxBmpSxC;;AwBnpSE;EAAsC,gBAAA;AxBupSxC;;AwBvpSE;EAAsC,gBAAA;AxB2pSxC;;AwB3pSE;EAAsC,gBAAA;AxB+pSxC;;AwB/pSE;EAAsC,gBAAA;AxBmqSxC;;AwBnqSE;EAAsC,YAAA;AxBuqSxC;;AwBvqSE;EAAsC,gBAAA;AxB2qSxC;;AwB3qSE;EAAsC,gBAAA;AxB+qSxC;;AwB/qSE;EAAsC,gBAAA;AxBmrSxC;;AwBnrSE;EAAsC,gBAAA;AxBurSxC;;AwBvrSE;EAAsC,gBAAA;AxB2rSxC;;AwB3rSE;EAAsC,gBAAA;AxB+rSxC;;AwB/rSE;EAAsC,gBAAA;AxBmsSxC;;AwBnsSE;EAAsC,YAAA;AxBusSxC;;AwBvsSE;EAAsC,gBAAA;AxB2sSxC;;AwB3sSE;EAAsC,gBAAA;AxB+sSxC;;AwB/sSE;EAAsC,gBAAA;AxBmtSxC;;AwBntSE;EAAsC,gBAAA;AxButSxC;;AwBvtSE;EAAsC,gBAAA;AxB2tSxC;;AwB3tSE;EAAsC,gBAAA;AxB+tSxC;;AwB/tSE;EAAsC,gBAAA;AxBmuSxC;;AwBnuSE;EAAsC,gBAAA;AxBuuSxC;;AwBvuSE;EAAsC,gBAAA;AxB2uSxC;;AwB3uSE;EAAsC,gBAAA;AxB+uSxC;;AwB/uSE;EAAsC,gBAAA;AxBmvSxC;;AwBnvSE;EAAsC,gBAAA;AxBuvSxC;;AwBvvSE;EAAsC,gBAAA;AxB2vSxC;;AwB3vSE;EAAsC,gBAAA;AxB+vSxC;;AwB/vSE;EAAsC,gBAAA;AxBmwSxC;;AwBnwSE;EAAsC,gBAAA;AxBuwSxC;;AwBvwSE;EAAsC,gBAAA;AxB2wSxC;;AwB3wSE;EAAsC,gBAAA;AxB+wSxC;;AwB/wSE;EAAsC,gBAAA;AxBmxSxC;;AwBnxSE;EAAsC,gBAAA;AxBuxSxC;;AwBvxSE;EAAsC,gBAAA;AxB2xSxC;;AwB3xSE;EAAsC,gBAAA;AxB+xSxC;;AwB/xSE;EAAsC,gBAAA;AxBmySxC;;AwBnySE;EAAsC,YAAA;AxBuySxC;;AwBvySE;EAAsC,gBAAA;AxB2ySxC;;AwB3ySE;EAAsC,gBAAA;AxB+ySxC;;AwB/ySE;EAAsC,gBAAA;AxBmzSxC;;AwBnzSE;EAAsC,gBAAA;AxBuzSxC;;AwBvzSE;EAAsC,gBAAA;AxB2zSxC;;AwB3zSE;EAAsC,gBAAA;AxB+zSxC;;AwB/zSE;EAAsC,gBAAA;AxBm0SxC;;AwBn0SE;EAAsC,gBAAA;AxBu0SxC;;AwBv0SE;EAAsC,gBAAA;AxB20SxC;;AwB30SE;EAAsC,gBAAA;AxB+0SxC;;AwB/0SE;EAAsC,gBAAA;AxBm1SxC;;AwBn1SE;EAAsC,gBAAA;AxBu1SxC;;AwBv1SE;EAAsC,gBAAA;AxB21SxC;;AwB31SE;EAAsC,gBAAA;AxB+1SxC;;AwB/1SE;EAAsC,gBAAA;AxBm2SxC;;AwBn2SE;EAAsC,gBAAA;AxBu2SxC;;AwBv2SE;EAAsC,gBAAA;AxB22SxC;;AwB32SE;EAAsC,gBAAA;AxB+2SxC;;AwB/2SE;EAAsC,gBAAA;AxBm3SxC;;AwBn3SE;EAAsC,gBAAA;AxBu3SxC;;AwBv3SE;EAAsC,gBAAA;AxB23SxC;;AwB33SE;EAAsC,gBAAA;AxB+3SxC;;AwB/3SE;EAAsC,gBAAA;AxBm4SxC;;AwBn4SE;EAAsC,gBAAA;AxBu4SxC;;AwBv4SE;EAAsC,gBAAA;AxB24SxC;;AwB34SE;EAAsC,gBAAA;AxB+4SxC;;AwB/4SE;EAAsC,gBAAA;AxBm5SxC;;AwBn5SE;EAAsC,gBAAA;AxBu5SxC;;AwBv5SE;EAAsC,gBAAA;AxB25SxC;;AwB35SE;EAAsC,gBAAA;AxB+5SxC;;AwB/5SE;EAAsC,gBAAA;AxBm6SxC;;AwBn6SE;EAAsC,gBAAA;AxBu6SxC;;AwBv6SE;EAAsC,gBAAA;AxB26SxC;;AwB36SE;EAAsC,gBAAA;AxB+6SxC;;AwB/6SE;EAAsC,gBAAA;AxBm7SxC;;AwBn7SE;EAAsC,gBAAA;AxBu7SxC;;AwBv7SE;EAAsC,gBAAA;AxB27SxC;;AwB37SE;EAAsC,gBAAA;AxB+7SxC;;AwB/7SE;EAAsC,gBAAA;AxBm8SxC;;AwBn8SE;EAAsC,gBAAA;AxBu8SxC;;AwBv8SE;EAAsC,gBAAA;AxB28SxC;;AwB38SE;EAAsC,gBAAA;AxB+8SxC;;AwB/8SE;EAAsC,gBAAA;AxBm9SxC;;AwBn9SE;EAAsC,aAAA;AxBu9SxC;;AwBv9SE;EAAsC,gBAAA;AxB29SxC;;AwB39SE;EAAsC,gBAAA;AxB+9SxC;;AwB/9SE;EAAsC,gBAAA;AxBm+SxC;;AwBn+SE;EAAsC,gBAAA;AxBu+SxC;;AwBv+SE;EAAsC,gBAAA;AxB2+SxC;;AwB3+SE;EAAsC,gBAAA;AxB++SxC;;AwB/+SE;EAAsC,gBAAA;AxBm/SxC;;AwBn/SE;EAAsC,gBAAA;AxBu/SxC;;AwBv/SE;EAAsC,gBAAA;AxB2/SxC;;AwB3/SE;EAAsC,gBAAA;AxB+/SxC;;AwB//SE;EAAsC,gBAAA;AxBmgTxC;;AwBngTE;EAAsC,gBAAA;AxBugTxC;;AwBvgTE;EAAsC,gBAAA;AxB2gTxC;;AwB3gTE;EAAsC,gBAAA;AxB+gTxC;;AwB/gTE;EAAsC,gBAAA;AxBmhTxC;;AwBnhTE;EAAsC,gBAAA;AxBuhTxC;;AwBvhTE;EAAsC,gBAAA;AxB2hTxC;;AwB3hTE;EAAsC,gBAAA;AxB+hTxC;;AwB/hTE;EAAsC,gBAAA;AxBmiTxC;;AwBniTE;EAAsC,gBAAA;AxBuiTxC;;AwBviTE;EAAsC,gBAAA;AxB2iTxC;;AwB3iTE;EAAsC,gBAAA;AxB+iTxC;;AwB/iTE;EAAsC,gBAAA;AxBmjTxC;;AwBnjTE;EAAsC,gBAAA;AxBujTxC;;AwBvjTE;EAAsC,gBAAA;AxB2jTxC;;AwB3jTE;EAAsC,gBAAA;AxB+jTxC;;AwB/jTE;EAAsC,gBAAA;AxBmkTxC;;AwBnkTE;EAAsC,gBAAA;AxBukTxC;;AwBvkTE;EAAsC,gBAAA;AxB2kTxC;;AwB3kTE;EAAsC,gBAAA;AxB+kTxC;;AwB/kTE;EAAsC,gBAAA;AxBmlTxC;;AwBnlTE;EAAsC,gBAAA;AxBulTxC;;AwBvlTE;EAAsC,gBAAA;AxB2lTxC;;AwB3lTE;EAAsC,gBAAA;AxB+lTxC;;AwB/lTE;EAAsC,gBAAA;AxBmmTxC;;AwBnmTE;EAAsC,gBAAA;AxBumTxC;;AwBvmTE;EAAsC,gBAAA;AxB2mTxC;;AwB3mTE;EAAsC,gBAAA;AxB+mTxC;;AwB/mTE;EAAsC,gBAAA;AxBmnTxC;;AwBnnTE;EAAsC,gBAAA;AxBunTxC;;AwBvnTE;EAAsC,gBAAA;AxB2nTxC;;AwB3nTE;EAAsC,gBAAA;AxB+nTxC;;AwB/nTE;EAAsC,gBAAA;AxBmoTxC;;AwBnoTE;EAAsC,gBAAA;AxBuoTxC;;AwBvoTE;EAAsC,gBAAA;AxB2oTxC;;AwB3oTE;EAAsC,gBAAA;AxB+oTxC;;AwB/oTE;EAAsC,gBAAA;AxBmpTxC;;AwBnpTE;EAAsC,gBAAA;AxBupTxC;;AwBvpTE;EAAsC,gBAAA;AxB2pTxC;;AwB3pTE;EAAsC,gBAAA;AxB+pTxC;;AwB/pTE;EAAsC,gBAAA;AxBmqTxC;;AwBnqTE;EAAsC,gBAAA;AxBuqTxC;;AwBvqTE;EAAsC,gBAAA;AxB2qTxC;;AwB3qTE;EAAsC,gBAAA;AxB+qTxC;;AwB/qTE;EAAsC,gBAAA;AxBmrTxC;;AwBnrTE;EAAsC,gBAAA;AxBurTxC;;AwBvrTE;EAAsC,gBAAA;AxB2rTxC;;AwB3rTE;EAAsC,gBAAA;AxB+rTxC;;AwB/rTE;EAAsC,gBAAA;AxBmsTxC;;AwBnsTE;EAAsC,gBAAA;AxBusTxC;;AwBvsTE;EAAsC,gBAAA;AxB2sTxC;;AwB3sTE;EAAsC,gBAAA;AxB+sTxC;;AwB/sTE;EAAsC,gBAAA;AxBmtTxC;;AwBntTE;EAAsC,gBAAA;AxButTxC;;AwBvtTE;EAAsC,gBAAA;AxB2tTxC;;AwB3tTE;EAAsC,gBAAA;AxB+tTxC;;AwB/tTE;EAAsC,gBAAA;AxBmuTxC;;AwBnuTE;EAAsC,gBAAA;AxBuuTxC;;AwBvuTE;EAAsC,gBAAA;AxB2uTxC;;AwB3uTE;EAAsC,gBAAA;AxB+uTxC;;AwB/uTE;EAAsC,gBAAA;AxBmvTxC;;AwBnvTE;EAAsC,gBAAA;AxBuvTxC;;AwBvvTE;EAAsC,gBAAA;AxB2vTxC;;AwB3vTE;EAAsC,gBAAA;AxB+vTxC;;AwB/vTE;EAAsC,gBAAA;AxBmwTxC;;AwBnwTE;EAAsC,gBAAA;AxBuwTxC;;AwBvwTE;EAAsC,gBAAA;AxB2wTxC;;AwB3wTE;EAAsC,gBAAA;AxB+wTxC;;AwB/wTE;EAAsC,gBAAA;AxBmxTxC;;AwBnxTE;EAAsC,gBAAA;AxBuxTxC;;AwBvxTE;EAAsC,gBAAA;AxB2xTxC;;AwB3xTE;EAAsC,gBAAA;AxB+xTxC;;AwB/xTE;EAAsC,gBAAA;AxBmyTxC;;AwBnyTE;EAAsC,gBAAA;AxBuyTxC;;AwBvyTE;EAAsC,gBAAA;AxB2yTxC;;AwB3yTE;EAAsC,gBAAA;AxB+yTxC;;AwB/yTE;EAAsC,gBAAA;AxBmzTxC;;AwBnzTE;EAAsC,gBAAA;AxBuzTxC;;AwBvzTE;EAAsC,gBAAA;AxB2zTxC;;AwB3zTE;EAAsC,gBAAA;AxB+zTxC;;AwB/zTE;EAAsC,gBAAA;AxBm0TxC;;AwBn0TE;EAAsC,gBAAA;AxBu0TxC;;AwBv0TE;EAAsC,gBAAA;AxB20TxC;;AwB30TE;EAAsC,gBAAA;AxB+0TxC;;AwB/0TE;EAAsC,gBAAA;AxBm1TxC;;AwBn1TE;EAAsC,YAAA;AxBu1TxC;;AwBv1TE;EAAsC,gBAAA;AxB21TxC;;AwB31TE;EAAsC,gBAAA;AxB+1TxC;;AwB/1TE;EAAsC,gBAAA;AxBm2TxC;;AwBn2TE;EAAsC,gBAAA;AxBu2TxC;;AwBv2TE;EAAsC,gBAAA;AxB22TxC;;AwB32TE;EAAsC,gBAAA;AxB+2TxC;;AwB/2TE;EAAsC,gBAAA;AxBm3TxC;;AwBn3TE;EAAsC,gBAAA;AxBu3TxC;;AwBv3TE;EAAsC,gBAAA;AxB23TxC;;AwB33TE;EAAsC,gBAAA;AxB+3TxC;;AwB/3TE;EAAsC,gBAAA;AxBm4TxC;;AwBn4TE;EAAsC,gBAAA;AxBu4TxC;;AwBv4TE;EAAsC,gBAAA;AxB24TxC;;AwB34TE;EAAsC,gBAAA;AxB+4TxC;;AwB/4TE;EAAsC,gBAAA;AxBm5TxC;;AwBn5TE;EAAsC,gBAAA;AxBu5TxC;;AwBv5TE;EAAsC,gBAAA;AxB25TxC;;AwB35TE;EAAsC,gBAAA;AxB+5TxC;;AwB/5TE;EAAsC,gBAAA;AxBm6TxC;;AwBn6TE;EAAsC,gBAAA;AxBu6TxC;;AwBv6TE;EAAsC,gBAAA;AxB26TxC;;AwB36TE;EAAsC,gBAAA;AxB+6TxC;;AwB/6TE;EAAsC,gBAAA;AxBm7TxC;;AwBn7TE;EAAsC,gBAAA;AxBu7TxC;;AwBv7TE;EAAsC,gBAAA;AxB27TxC;;AwB37TE;EAAsC,gBAAA;AxB+7TxC;;AwB/7TE;EAAsC,gBAAA;AxBm8TxC;;AwBn8TE;EAAsC,gBAAA;AxBu8TxC;;AwBv8TE;EAAsC,gBAAA;AxB28TxC;;AwB38TE;EAAsC,gBAAA;AxB+8TxC;;AwB/8TE;EAAsC,gBAAA;AxBm9TxC;;AwBn9TE;EAAsC,gBAAA;AxBu9TxC;;AwBv9TE;EAAsC,gBAAA;AxB29TxC;;AwB39TE;EAAsC,gBAAA;AxB+9TxC;;AwB/9TE;EAAsC,gBAAA;AxBm+TxC;;AwBn+TE;EAAsC,gBAAA;AxBu+TxC;;AwBv+TE;EAAsC,gBAAA;AxB2+TxC;;AwB3+TE;EAAsC,gBAAA;AxB++TxC;;AwB/+TE;EAAsC,gBAAA;AxBm/TxC;;AwBn/TE;EAAsC,gBAAA;AxBu/TxC;;AwBv/TE;EAAsC,gBAAA;AxB2/TxC;;AwB3/TE;EAAsC,gBAAA;AxB+/TxC;;AwB//TE;EAAsC,gBAAA;AxBmgUxC;;AwBngUE;EAAsC,gBAAA;AxBugUxC;;AwBvgUE;EAAsC,gBAAA;AxB2gUxC;;AwB3gUE;EAAsC,gBAAA;AxB+gUxC;;AwB/gUE;EAAsC,gBAAA;AxBmhUxC;;AwBnhUE;EAAsC,gBAAA;AxBuhUxC;;AwBvhUE;EAAsC,gBAAA;AxB2hUxC;;AwB3hUE;EAAsC,gBAAA;AxB+hUxC;;AwB/hUE;EAAsC,gBAAA;AxBmiUxC;;AwBniUE;EAAsC,gBAAA;AxBuiUxC;;AwBviUE;EAAsC,gBAAA;AxB2iUxC;;AwB3iUE;EAAsC,gBAAA;AxB+iUxC;;AwB/iUE;EAAsC,gBAAA;AxBmjUxC;;AwBnjUE;EAAsC,gBAAA;AxBujUxC;;AwBvjUE;EAAsC,gBAAA;AxB2jUxC;;AwB3jUE;EAAsC,gBAAA;AxB+jUxC;;AwB/jUE;EAAsC,gBAAA;AxBmkUxC;;AwBnkUE;EAAsC,gBAAA;AxBukUxC;;AwBvkUE;EAAsC,gBAAA;AxB2kUxC;;AwB3kUE;EAAsC,gBAAA;AxB+kUxC;;AwB/kUE;EAAsC,gBAAA;AxBmlUxC;;AwBnlUE;EAAsC,gBAAA;AxBulUxC;;AwBvlUE;EAAsC,gBAAA;AxB2lUxC;;AwB3lUE;EAAsC,gBAAA;AxB+lUxC;;AwB/lUE;EAAsC,gBAAA;AxBmmUxC;;AwBnmUE;EAAsC,gBAAA;AxBumUxC;;AwBvmUE;EAAsC,gBAAA;AxB2mUxC;;AwB3mUE;EAAsC,gBAAA;AxB+mUxC;;AwB/mUE;EAAsC,gBAAA;AxBmnUxC;;AwBnnUE;EAAsC,gBAAA;AxBunUxC;;AwBvnUE;EAAsC,gBAAA;AxB2nUxC;;AwB3nUE;EAAsC,gBAAA;AxB+nUxC;;AwB/nUE;EAAsC,gBAAA;AxBmoUxC;;AwBnoUE;EAAsC,gBAAA;AxBuoUxC;;AwBvoUE;EAAsC,gBAAA;AxB2oUxC;;AwB3oUE;EAAsC,gBAAA;AxB+oUxC;;AwB/oUE;EAAsC,gBAAA;AxBmpUxC;;AwBnpUE;EAAsC,gBAAA;AxBupUxC;;AwBvpUE;EAAsC,gBAAA;AxB2pUxC;;AwB3pUE;EAAsC,gBAAA;AxB+pUxC;;AwB/pUE;EAAsC,gBAAA;AxBmqUxC;;AwBnqUE;EAAsC,gBAAA;AxBuqUxC;;AwBvqUE;EAAsC,gBAAA;AxB2qUxC;;AwB3qUE;EAAsC,gBAAA;AxB+qUxC;;AwB/qUE;EAAsC,gBAAA;AxBmrUxC;;AwBnrUE;EAAsC,gBAAA;AxBurUxC;;AwBvrUE;EAAsC,gBAAA;AxB2rUxC;;AwB3rUE;EAAsC,gBAAA;AxB+rUxC;;AwB/rUE;EAAsC,gBAAA;AxBmsUxC;;AwBnsUE;EAAsC,gBAAA;AxBusUxC;;AwBvsUE;EAAsC,gBAAA;AxB2sUxC;;AwB3sUE;EAAsC,gBAAA;AxB+sUxC;;AwB/sUE;EAAsC,gBAAA;AxBmtUxC;;AwBntUE;EAAsC,gBAAA;AxButUxC;;AwBvtUE;EAAsC,gBAAA;AxB2tUxC;;AwB3tUE;EAAsC,gBAAA;AxB+tUxC;;AwB/tUE;EAAsC,gBAAA;AxBmuUxC;;AwBnuUE;EAAsC,gBAAA;AxBuuUxC;;AwBvuUE;EAAsC,gBAAA;AxB2uUxC;;AwB3uUE;EAAsC,gBAAA;AxB+uUxC;;AwB/uUE;EAAsC,gBAAA;AxBmvUxC;;AwBnvUE;EAAsC,gBAAA;AxBuvUxC;;AwBvvUE;EAAsC,gBAAA;AxB2vUxC;;AwB3vUE;EAAsC,gBAAA;AxB+vUxC;;AwB/vUE;EAAsC,gBAAA;AxBmwUxC;;AwBnwUE;EAAsC,gBAAA;AxBuwUxC;;AwBvwUE;EAAsC,gBAAA;AxB2wUxC;;AwB3wUE;EAAsC,gBAAA;AxB+wUxC;;AwB/wUE;EAAsC,gBAAA;AxBmxUxC;;AwBnxUE;EAAsC,gBAAA;AxBuxUxC;;AwBvxUE;EAAsC,gBAAA;AxB2xUxC;;AwB3xUE;EAAsC,gBAAA;AxB+xUxC;;AwB/xUE;EAAsC,gBAAA;AxBmyUxC;;AwBnyUE;EAAsC,gBAAA;AxBuyUxC;;AwBvyUE;EAAsC,gBAAA;AxB2yUxC;;AwB3yUE;EAAsC,gBAAA;AxB+yUxC;;AwB/yUE;EAAsC,gBAAA;AxBmzUxC;;AwBnzUE;EAAsC,gBAAA;AxBuzUxC;;AwBvzUE;EAAsC,gBAAA;AxB2zUxC;;AwB3zUE;EAAsC,gBAAA;AxB+zUxC;;AwB/zUE;EAAsC,gBAAA;AxBm0UxC;;AwBn0UE;EAAsC,gBAAA;AxBu0UxC;;AwBv0UE;EAAsC,gBAAA;AxB20UxC;;AwB30UE;EAAsC,gBAAA;AxB+0UxC;;AwB/0UE;EAAsC,gBAAA;AxBm1UxC;;AwBn1UE;EAAsC,gBAAA;AxBu1UxC;;AwBv1UE;EAAsC,gBAAA;AxB21UxC;;AwB31UE;EAAsC,gBAAA;AxB+1UxC;;AwB/1UE;EAAsC,gBAAA;AxBm2UxC;;AwBn2UE;EAAsC,gBAAA;AxBu2UxC;;AwBv2UE;EAAsC,gBAAA;AxB22UxC;;AwB32UE;EAAsC,gBAAA;AxB+2UxC;;AwB/2UE;EAAsC,gBAAA;AxBm3UxC;;AwBn3UE;EAAsC,gBAAA;AxBu3UxC;;AwBv3UE;EAAsC,gBAAA;AxB23UxC;;AwB33UE;EAAsC,gBAAA;AxB+3UxC;;AwB/3UE;EAAsC,gBAAA;AxBm4UxC;;AwBn4UE;EAAsC,gBAAA;AxBu4UxC;;AwBv4UE;EAAsC,gBAAA;AxB24UxC;;AwB34UE;EAAsC,gBAAA;AxB+4UxC;;AwB/4UE;EAAsC,gBAAA;AxBm5UxC;;AwBn5UE;EAAsC,gBAAA;AxBu5UxC;;AwBv5UE;EAAsC,gBAAA;AxB25UxC;;AwB35UE;EAAsC,gBAAA;AxB+5UxC;;AwB/5UE;EAAsC,gBAAA;AxBm6UxC;;AwBn6UE;EAAsC,gBAAA;AxBu6UxC;;AwBv6UE;EAAsC,gBAAA;AxB26UxC;;AwB36UE;EAAsC,gBAAA;AxB+6UxC;;AwB/6UE;EAAsC,gBAAA;AxBm7UxC;;AwBn7UE;EAAsC,gBAAA;AxBu7UxC;;AwBv7UE;EAAsC,gBAAA;AxB27UxC;;AwB37UE;EAAsC,gBAAA;AxB+7UxC;;AwB/7UE;EAAsC,gBAAA;AxBm8UxC;;AwBn8UE;EAAsC,gBAAA;AxBu8UxC;;AwBv8UE;EAAsC,gBAAA;AxB28UxC;;AwB38UE;EAAsC,gBAAA;AxB+8UxC;;AwB/8UE;EAAsC,gBAAA;AxBm9UxC;;AwBn9UE;EAAsC,gBAAA;AxBu9UxC;;AwBv9UE;EAAsC,gBAAA;AxB29UxC;;AwB39UE;EAAsC,gBAAA;AxB+9UxC;;AwB/9UE;EAAsC,gBAAA;AxBm+UxC;;AwBn+UE;EAAsC,gBAAA;AxBu+UxC;;AwBv+UE;EAAsC,gBAAA;AxB2+UxC;;AwB3+UE;EAAsC,gBAAA;AxB++UxC;;AwB/+UE;EAAsC,gBAAA;AxBm/UxC;;AwBn/UE;EAAsC,gBAAA;AxBu/UxC;;AwBv/UE;EAAsC,gBAAA;AxB2/UxC;;AwB3/UE;EAAsC,gBAAA;AxB+/UxC;;AwB//UE;EAAsC,gBAAA;AxBmgVxC;;AwBngVE;EAAsC,gBAAA;AxBugVxC;;AwBvgVE;EAAsC,gBAAA;AxB2gVxC;;AwB3gVE;EAAsC,gBAAA;AxB+gVxC;;AwB/gVE;EAAsC,gBAAA;AxBmhVxC;;AwBnhVE;EAAsC,gBAAA;AxBuhVxC;;AwBvhVE;EAAsC,gBAAA;AxB2hVxC;;AwB3hVE;EAAsC,gBAAA;AxB+hVxC;;AwB/hVE;EAAsC,gBAAA;AxBmiVxC;;AwBniVE;EAAsC,gBAAA;AxBuiVxC;;AwBviVE;EAAsC,gBAAA;AxB2iVxC;;AwB3iVE;EAAsC,gBAAA;AxB+iVxC;;AwB/iVE;EAAsC,gBAAA;AxBmjVxC;;AwBnjVE;EAAsC,gBAAA;AxBujVxC;;AwBvjVE;EAAsC,gBAAA;AxB2jVxC;;AwB3jVE;EAAsC,gBAAA;AxB+jVxC;;AwB/jVE;EAAsC,gBAAA;AxBmkVxC;;AwBnkVE;EAAsC,gBAAA;AxBukVxC;;AwBvkVE;EAAsC,gBAAA;AxB2kVxC;;AwB3kVE;EAAsC,gBAAA;AxB+kVxC;;AwB/kVE;EAAsC,gBAAA;AxBmlVxC;;AwBnlVE;EAAsC,gBAAA;AxBulVxC;;AwBvlVE;EAAsC,gBAAA;AxB2lVxC;;AwB3lVE;EAAsC,gBAAA;AxB+lVxC;;AwB/lVE;EAAsC,gBAAA;AxBmmVxC;;AwBnmVE;EAAsC,gBAAA;AxBumVxC;;AwBvmVE;EAAsC,gBAAA;AxB2mVxC;;AwB3mVE;EAAsC,gBAAA;AxB+mVxC;;AwB/mVE;EAAsC,YAAA;AxBmnVxC;;AwBnnVE;EAAsC,gBAAA;AxBunVxC;;AwBvnVE;EAAsC,gBAAA;AxB2nVxC;;AwB3nVE;EAAsC,gBAAA;AxB+nVxC;;AwB/nVE;EAAsC,gBAAA;AxBmoVxC;;AwBnoVE;EAAsC,gBAAA;AxBuoVxC;;AwBvoVE;EAAsC,gBAAA;AxB2oVxC;;AwB3oVE;EAAsC,gBAAA;AxB+oVxC;;AwB/oVE;EAAsC,gBAAA;AxBmpVxC;;AwBnpVE;EAAsC,gBAAA;AxBupVxC;;AwBvpVE;EAAsC,gBAAA;AxB2pVxC;;AwB3pVE;EAAsC,gBAAA;AxB+pVxC;;AwB/pVE;EAAsC,gBAAA;AxBmqVxC;;AwBnqVE;EAAsC,gBAAA;AxBuqVxC;;AwBvqVE;EAAsC,gBAAA;AxB2qVxC;;AwB3qVE;EAAsC,gBAAA;AxB+qVxC;;AwB/qVE;EAAsC,gBAAA;AxBmrVxC;;AwBnrVE;EAAsC,gBAAA;AxBurVxC;;AwBvrVE;EAAsC,gBAAA;AxB2rVxC;;AwB3rVE;EAAsC,gBAAA;AxB+rVxC;;AwB/rVE;EAAsC,gBAAA;AxBmsVxC;;AwBnsVE;EAAsC,gBAAA;AxBusVxC;;AwBvsVE;EAAsC,gBAAA;AxB2sVxC;;AwB3sVE;EAAsC,YAAA;AxB+sVxC;;AwB/sVE;EAAsC,gBAAA;AxBmtVxC;;AwBntVE;EAAsC,gBAAA;AxButVxC;;AwBvtVE;EAAsC,gBAAA;AxB2tVxC;;AwB3tVE;EAAsC,gBAAA;AxB+tVxC;;AwB/tVE;EAAsC,gBAAA;AxBmuVxC;;AwBnuVE;EAAsC,gBAAA;AxBuuVxC;;AwBvuVE;EAAsC,gBAAA;AxB2uVxC;;AwB3uVE;EAAsC,gBAAA;AxB+uVxC;;AwB/uVE;EAAsC,gBAAA;AxBmvVxC;;AwBnvVE;EAAsC,gBAAA;AxBuvVxC;;AwBvvVE;EAAsC,gBAAA;AxB2vVxC;;AwB3vVE;EAAsC,gBAAA;AxB+vVxC;;AwB/vVE;EAAsC,gBAAA;AxBmwVxC;;AwBnwVE;EAAsC,gBAAA;AxBuwVxC;;AwBvwVE;EAAsC,gBAAA;AxB2wVxC;;AwB3wVE;EAAsC,gBAAA;AxB+wVxC;;AwB/wVE;EAAsC,gBAAA;AxBmxVxC;;AwBnxVE;EAAsC,gBAAA;AxBuxVxC;;AwBvxVE;EAAsC,gBAAA;AxB2xVxC;;AwB3xVE;EAAsC,gBAAA;AxB+xVxC;;AwB/xVE;EAAsC,gBAAA;AxBmyVxC;;AwBnyVE;EAAsC,gBAAA;AxBuyVxC;;AwBvyVE;EAAsC,gBAAA;AxB2yVxC;;AwB3yVE;EAAsC,gBAAA;AxB+yVxC;;AwB/yVE;EAAsC,gBAAA;AxBmzVxC;;AwBnzVE;EAAsC,gBAAA;AxBuzVxC;;AwBvzVE;EAAsC,gBAAA;AxB2zVxC;;AwB3zVE;EAAsC,gBAAA;AxB+zVxC;;AwB/zVE;EAAsC,gBAAA;AxBm0VxC;;AwBn0VE;EAAsC,gBAAA;AxBu0VxC;;AwBv0VE;EAAsC,gBAAA;AxB20VxC;;AwB30VE;EAAsC,gBAAA;AxB+0VxC;;AwB/0VE;EAAsC,gBAAA;AxBm1VxC;;AwBn1VE;EAAsC,gBAAA;AxBu1VxC;;AwBv1VE;EAAsC,gBAAA;AxB21VxC;;AwB31VE;EAAsC,gBAAA;AxB+1VxC;;AwB/1VE;EAAsC,gBAAA;AxBm2VxC;;AwBn2VE;EAAsC,YAAA;AxBu2VxC;;AwBv2VE;EAAsC,gBAAA;AxB22VxC;;AwB32VE;EAAsC,gBAAA;AxB+2VxC;;AwB/2VE;EAAsC,gBAAA;AxBm3VxC;;AwBn3VE;EAAsC,gBAAA;AxBu3VxC;;AwBv3VE;EAAsC,gBAAA;AxB23VxC;;AwB33VE;EAAsC,gBAAA;AxB+3VxC;;AwB/3VE;EAAsC,gBAAA;AxBm4VxC;;AwBn4VE;EAAsC,gBAAA;AxBu4VxC;;AwBv4VE;EAAsC,gBAAA;AxB24VxC;;AwB34VE;EAAsC,gBAAA;AxB+4VxC;;AwB/4VE;EAAsC,gBAAA;AxBm5VxC;;AwBn5VE;EAAsC,gBAAA;AxBu5VxC;;AwBv5VE;EAAsC,gBAAA;AxB25VxC;;AwB35VE;EAAsC,gBAAA;AxB+5VxC;;AwB/5VE;EAAsC,gBAAA;AxBm6VxC;;AwBn6VE;EAAsC,gBAAA;AxBu6VxC;;AwBv6VE;EAAsC,gBAAA;AxB26VxC;;AwB36VE;EAAsC,gBAAA;AxB+6VxC;;AwB/6VE;EAAsC,gBAAA;AxBm7VxC;;AwBn7VE;EAAsC,gBAAA;AxBu7VxC;;AwBv7VE;EAAsC,gBAAA;AxB27VxC;;AwB37VE;EAAsC,gBAAA;AxB+7VxC;;AwB/7VE;EAAsC,gBAAA;AxBm8VxC;;AwBn8VE;EAAsC,gBAAA;AxBu8VxC;;AwBv8VE;EAAsC,gBAAA;AxB28VxC;;AwB38VE;EAAsC,gBAAA;AxB+8VxC;;AwB/8VE;EAAsC,gBAAA;AxBm9VxC;;AwBn9VE;EAAsC,gBAAA;AxBu9VxC;;AwBv9VE;EAAsC,gBAAA;AxB29VxC;;AwB39VE;EAAsC,gBAAA;AxB+9VxC;;AwB/9VE;EAAsC,gBAAA;AxBm+VxC;;AwBn+VE;EAAsC,gBAAA;AxBu+VxC;;AwBv+VE;EAAsC,gBAAA;AxB2+VxC;;AwB3+VE;EAAsC,gBAAA;AxB++VxC;;AwB/+VE;EAAsC,gBAAA;AxBm/VxC;;AwBn/VE;EAAsC,gBAAA;AxBu/VxC;;AwBv/VE;EAAsC,gBAAA;AxB2/VxC;;AwB3/VE;EAAsC,gBAAA;AxB+/VxC;;AwB//VE;EAAsC,gBAAA;AxBmgWxC;;AwBngWE;EAAsC,gBAAA;AxBugWxC;;AwBvgWE;EAAsC,gBAAA;AxB2gWxC;;AwB3gWE;EAAsC,gBAAA;AxB+gWxC;;AwB/gWE;EAAsC,gBAAA;AxBmhWxC;;AwBnhWE;EAAsC,gBAAA;AxBuhWxC;;AwBvhWE;EAAsC,gBAAA;AxB2hWxC;;AwB3hWE;EAAsC,gBAAA;AxB+hWxC;;AwB/hWE;EAAsC,gBAAA;AxBmiWxC;;AwBniWE;EAAsC,gBAAA;AxBuiWxC;;AwBviWE;EAAsC,gBAAA;AxB2iWxC;;AwB3iWE;EAAsC,gBAAA;AxB+iWxC;;AwB/iWE;EAAsC,gBAAA;AxBmjWxC;;AwBnjWE;EAAsC,gBAAA;AxBujWxC;;AwBvjWE;EAAsC,gBAAA;AxB2jWxC;;AwB3jWE;EAAsC,gBAAA;AxB+jWxC;;AwB/jWE;EAAsC,gBAAA;AxBmkWxC;;AwBnkWE;EAAsC,gBAAA;AxBukWxC;;AwBvkWE;EAAsC,gBAAA;AxB2kWxC;;AwB3kWE;EAAsC,gBAAA;AxB+kWxC;;AwB/kWE;EAAsC,gBAAA;AxBmlWxC;;AwBnlWE;EAAsC,gBAAA;AxBulWxC;;AwBvlWE;EAAsC,gBAAA;AxB2lWxC;;AwB3lWE;EAAsC,gBAAA;AxB+lWxC;;AwB/lWE;EAAsC,gBAAA;AxBmmWxC;;AwBnmWE;EAAsC,gBAAA;AxBumWxC;;AwBvmWE;EAAsC,gBAAA;AxB2mWxC;;AwB3mWE;EAAsC,gBAAA;AxB+mWxC;;AwB/mWE;EAAsC,gBAAA;AxBmnWxC;;AwBnnWE;EAAsC,gBAAA;AxBunWxC;;AwBvnWE;EAAsC,gBAAA;AxB2nWxC;;AwB3nWE;EAAsC,gBAAA;AxB+nWxC;;AwB/nWE;EAAsC,gBAAA;AxBmoWxC;;AwBnoWE;EAAsC,gBAAA;AxBuoWxC;;AwBvoWE;EAAsC,gBAAA;AxB2oWxC;;AwB3oWE;EAAsC,gBAAA;AxB+oWxC;;AwB/oWE;EAAsC,gBAAA;AxBmpWxC;;AwBnpWE;EAAsC,gBAAA;AxBupWxC;;AwBvpWE;EAAsC,gBAAA;AxB2pWxC;;AwB3pWE;EAAsC,gBAAA;AxB+pWxC;;AwB/pWE;EAAsC,gBAAA;AxBmqWxC;;AwBnqWE;EAAsC,gBAAA;AxBuqWxC;;AwBvqWE;EAAsC,gBAAA;AxB2qWxC;;AwB3qWE;EAAsC,gBAAA;AxB+qWxC;;AwB/qWE;EAAsC,gBAAA;AxBmrWxC;;AwBnrWE;EAAsC,gBAAA;AxBurWxC;;AwBvrWE;EAAsC,gBAAA;AxB2rWxC;;AwB3rWE;EAAsC,aAAA;AxB+rWxC;;AwB/rWE;EAAsC,aAAA;AxBmsWxC;;AwBnsWE;EAAsC,aAAA;AxBusWxC;;AwBvsWE;EAAsC,gBAAA;AxB2sWxC;;AwB3sWE;EAAsC,gBAAA;AxB+sWxC;;AwB/sWE;EAAsC,gBAAA;AxBmtWxC;;AwBntWE;EAAsC,gBAAA;AxButWxC;;AwBvtWE;EAAsC,gBAAA;AxB2tWxC;;AwB3tWE;EAAsC,gBAAA;AxB+tWxC;;AwB/tWE;EAAsC,gBAAA;AxBmuWxC;;AwBnuWE;EAAsC,gBAAA;AxBuuWxC;;AwBvuWE;EAAsC,gBAAA;AxB2uWxC;;AwB3uWE;EAAsC,gBAAA;AxB+uWxC;;AwB/uWE;EAAsC,gBAAA;AxBmvWxC;;AwBnvWE;EAAsC,gBAAA;AxBuvWxC;;AwBvvWE;EAAsC,gBAAA;AxB2vWxC;;AwB3vWE;EAAsC,gBAAA;AxB+vWxC;;AwB/vWE;EAAsC,gBAAA;AxBmwWxC;;AwBnwWE;EAAsC,gBAAA;AxBuwWxC;;AwBvwWE;EAAsC,gBAAA;AxB2wWxC;;AwB3wWE;EAAsC,gBAAA;AxB+wWxC;;AwB/wWE;EAAsC,gBAAA;AxBmxWxC;;AwBnxWE;EAAsC,gBAAA;AxBuxWxC;;AwBvxWE;EAAsC,gBAAA;AxB2xWxC;;AwB3xWE;EAAsC,gBAAA;AxB+xWxC;;AwB/xWE;EAAsC,gBAAA;AxBmyWxC;;AwBnyWE;EAAsC,gBAAA;AxBuyWxC;;AwBvyWE;EAAsC,gBAAA;AxB2yWxC;;AwB3yWE;EAAsC,gBAAA;AxB+yWxC;;AwB/yWE;EAAsC,gBAAA;AxBmzWxC;;AwBnzWE;EAAsC,gBAAA;AxBuzWxC;;AwBvzWE;EAAsC,gBAAA;AxB2zWxC;;AwB3zWE;EAAsC,gBAAA;AxB+zWxC;;AwB/zWE;EAAsC,gBAAA;AxBm0WxC;;AwBn0WE;EAAsC,gBAAA;AxBu0WxC;;AwBv0WE;EAAsC,gBAAA;AxB20WxC;;AwB30WE;EAAsC,gBAAA;AxB+0WxC;;AwB/0WE;EAAsC,gBAAA;AxBm1WxC;;AwBn1WE;EAAsC,gBAAA;AxBu1WxC;;AwBv1WE;EAAsC,gBAAA;AxB21WxC;;AwB31WE;EAAsC,gBAAA;AxB+1WxC;;AwB/1WE;EAAsC,gBAAA;AxBm2WxC;;AwBn2WE;EAAsC,gBAAA;AxBu2WxC;;AwBv2WE;EAAsC,gBAAA;AxB22WxC;;AwB32WE;EAAsC,gBAAA;AxB+2WxC;;AwB/2WE;EAAsC,gBAAA;AxBm3WxC;;AwBn3WE;EAAsC,gBAAA;AxBu3WxC;;AwBv3WE;EAAsC,gBAAA;AxB23WxC;;AwB33WE;EAAsC,gBAAA;AxB+3WxC;;AwB/3WE;EAAsC,gBAAA;AxBm4WxC;;AwBn4WE;EAAsC,gBAAA;AxBu4WxC;;AwBv4WE;EAAsC,gBAAA;AxB24WxC;;AwB34WE;EAAsC,gBAAA;AxB+4WxC;;AwB/4WE;EAAsC,gBAAA;AxBm5WxC;;AwBn5WE;EAAsC,gBAAA;AxBu5WxC;;AwBv5WE;EAAsC,gBAAA;AxB25WxC;;AwB35WE;EAAsC,gBAAA;AxB+5WxC;;AwB/5WE;EAAsC,gBAAA;AxBm6WxC;;AwBn6WE;EAAsC,gBAAA;AxBu6WxC;;AwBv6WE;EAAsC,gBAAA;AxB26WxC;;AwB36WE;EAAsC,gBAAA;AxB+6WxC;;AwB/6WE;EAAsC,gBAAA;AxBm7WxC;;AwBn7WE;EAAsC,gBAAA;AxBu7WxC;;AwBv7WE;EAAsC,gBAAA;AxB27WxC;;AwB37WE;EAAsC,gBAAA;AxB+7WxC;;AwB/7WE;EAAsC,gBAAA;AxBm8WxC;;AwBn8WE;EAAsC,gBAAA;AxBu8WxC;;AwBv8WE;EAAsC,gBAAA;AxB28WxC;;AwB38WE;EAAsC,gBAAA;AxB+8WxC;;AwB/8WE;EAAsC,gBAAA;AxBm9WxC;;AwBn9WE;EAAsC,gBAAA;AxBu9WxC;;AwBv9WE;EAAsC,gBAAA;AxB29WxC;;AwB39WE;EAAsC,gBAAA;AxB+9WxC;;AwB/9WE;EAAsC,gBAAA;AxBm+WxC;;AwBn+WE;EAAsC,gBAAA;AxBu+WxC;;AwBv+WE;EAAsC,gBAAA;AxB2+WxC;;AwB3+WE;EAAsC,gBAAA;AxB++WxC;;AwB/+WE;EAAsC,gBAAA;AxBm/WxC;;AwBn/WE;EAAsC,gBAAA;AxBu/WxC;;AwBv/WE;EAAsC,gBAAA;AxB2/WxC;;AwB3/WE;EAAsC,gBAAA;AxB+/WxC;;AwB//WE;EAAsC,gBAAA;AxBmgXxC;;AwBngXE;EAAsC,gBAAA;AxBugXxC;;AwBvgXE;EAAsC,gBAAA;AxB2gXxC;;AwB3gXE;EAAsC,gBAAA;AxB+gXxC;;AwB/gXE;EAAsC,gBAAA;AxBmhXxC;;AwBnhXE;EAAsC,gBAAA;AxBuhXxC;;AwBvhXE;EAAsC,gBAAA;AxB2hXxC;;AwB3hXE;EAAsC,gBAAA;AxB+hXxC;;AwB/hXE;EAAsC,gBAAA;AxBmiXxC;;AwBniXE;EAAsC,gBAAA;AxBuiXxC;;AwBviXE;EAAsC,gBAAA;AxB2iXxC;;AwB3iXE;EAAsC,gBAAA;AxB+iXxC;;AwB/iXE;EAAsC,gBAAA;AxBmjXxC;;AwBnjXE;EAAsC,gBAAA;AxBujXxC;;AwBvjXE;EAAsC,aAAA;AxB2jXxC;;AwB3jXE;EAAsC,gBAAA;AxB+jXxC;;AwB/jXE;EAAsC,gBAAA;AxBmkXxC;;AwBnkXE;EAAsC,gBAAA;AxBukXxC;;AwBvkXE;EAAsC,gBAAA;AxB2kXxC;;AwB3kXE;EAAsC,gBAAA;AxB+kXxC;;AwB/kXE;EAAsC,gBAAA;AxBmlXxC;;AwBnlXE;EAAsC,gBAAA;AxBulXxC;;AwBvlXE;EAAsC,gBAAA;AxB2lXxC;;AwB3lXE;EAAsC,gBAAA;AxB+lXxC;;AwB/lXE;EAAsC,gBAAA;AxBmmXxC;;AwBnmXE;EAAsC,gBAAA;AxBumXxC;;AwBvmXE;EAAsC,gBAAA;AxB2mXxC;;AwB3mXE;EAAsC,gBAAA;AxB+mXxC;;AwB/mXE;EAAsC,gBAAA;AxBmnXxC;;AwBnnXE;EAAsC,gBAAA;AxBunXxC;;AwBvnXE;EAAsC,gBAAA;AxB2nXxC;;AwB3nXE;EAAsC,gBAAA;AxB+nXxC;;AwB/nXE;EAAsC,gBAAA;AxBmoXxC;;AwBnoXE;EAAsC,gBAAA;AxBuoXxC;;AwBvoXE;EAAsC,gBAAA;AxB2oXxC;;AwB3oXE;EAAsC,gBAAA;AxB+oXxC;;AwB/oXE;EAAsC,gBAAA;AxBmpXxC;;AwBnpXE;EAAsC,gBAAA;AxBupXxC;;AwBvpXE;EAAsC,gBAAA;AxB2pXxC;;AwB3pXE;EAAsC,aAAA;AxB+pXxC;;AwB/pXE;EAAsC,aAAA;AxBmqXxC;;AwBnqXE;EAAsC,gBAAA;AxBuqXxC;;AwBvqXE;EAAsC,gBAAA;AxB2qXxC;;AwB3qXE;EAAsC,gBAAA;AxB+qXxC;;AwB/qXE;EAAsC,gBAAA;AxBmrXxC;;AwBnrXE;EAAsC,gBAAA;AxBurXxC;;AwBvrXE;EAAsC,gBAAA;AxB2rXxC;;AwB3rXE;EAAsC,gBAAA;AxB+rXxC;;AwB/rXE;EAAsC,gBAAA;AxBmsXxC;;AwBnsXE;EAAsC,gBAAA;AxBusXxC;;AwBvsXE;EAAsC,gBAAA;AxB2sXxC;;AwB3sXE;EAAsC,gBAAA;AxB+sXxC;;AwB/sXE;EAAsC,gBAAA;AxBmtXxC;;AwBntXE;EAAsC,gBAAA;AxButXxC;;AwBvtXE;EAAsC,gBAAA;AxB2tXxC;;AwB3tXE;EAAsC,gBAAA;AxB+tXxC;;AwB/tXE;EAAsC,gBAAA;AxBmuXxC;;AwBnuXE;EAAsC,gBAAA;AxBuuXxC;;AwBvuXE;EAAsC,gBAAA;AxB2uXxC;;AwB3uXE;EAAsC,gBAAA;AxB+uXxC;;AwB/uXE;EAAsC,gBAAA;AxBmvXxC;;AwBnvXE;EAAsC,gBAAA;AxBuvXxC;;AwBvvXE;EAAsC,gBAAA;AxB2vXxC;;AwB3vXE;EAAsC,gBAAA;AxB+vXxC;;AwB/vXE;EAAsC,gBAAA;AxBmwXxC;;AwBnwXE;EAAsC,gBAAA;AxBuwXxC;;AwBvwXE;EAAsC,gBAAA;AxB2wXxC;;AwB3wXE;EAAsC,gBAAA;AxB+wXxC;;AwB/wXE;EAAsC,gBAAA;AxBmxXxC;;AwBnxXE;EAAsC,gBAAA;AxBuxXxC;;AwBvxXE;EAAsC,gBAAA;AxB2xXxC;;AwB3xXE;EAAsC,gBAAA;AxB+xXxC;;AwB/xXE;EAAsC,gBAAA;AxBmyXxC;;AwBnyXE;EAAsC,gBAAA;AxBuyXxC;;AwBvyXE;EAAsC,gBAAA;AxB2yXxC;;AwB3yXE;EAAsC,gBAAA;AxB+yXxC;;AwB/yXE;EAAsC,gBAAA;AxBmzXxC;;AwBnzXE;EAAsC,gBAAA;AxBuzXxC;;AwBvzXE;EAAsC,YAAA;AxB2zXxC;;AwB3zXE;EAAsC,gBAAA;AxB+zXxC;;AwB/zXE;EAAsC,aAAA;AxBm0XxC;;AwBn0XE;EAAsC,gBAAA;AxBu0XxC;;AwBv0XE;EAAsC,gBAAA;AxB20XxC;;AwB30XE;EAAsC,gBAAA;AxB+0XxC;;AwB/0XE;EAAsC,gBAAA;AxBm1XxC;;AwBn1XE;EAAsC,gBAAA;AxBu1XxC;;AwBv1XE;EAAsC,gBAAA;AxB21XxC;;AwB31XE;EAAsC,gBAAA;AxB+1XxC;;AwB/1XE;EAAsC,gBAAA;AxBm2XxC;;AwBn2XE;EAAsC,YAAA;AxBu2XxC;;AwBv2XE;EAAsC,gBAAA;AxB22XxC;;AwB32XE;EAAsC,gBAAA;AxB+2XxC;;AwB/2XE;EAAsC,gBAAA;AxBm3XxC;;AwBn3XE;EAAsC,gBAAA;AxBu3XxC;;AwBv3XE;EAAsC,gBAAA;AxB23XxC;;AwB33XE;EAAsC,gBAAA;AxB+3XxC;;AwB/3XE;EAAsC,gBAAA;AxBm4XxC;;AwBn4XE;EAAsC,gBAAA;AxBu4XxC;;AwBv4XE;EAAsC,gBAAA;AxB24XxC;;AwB34XE;EAAsC,gBAAA;AxB+4XxC;;AwB/4XE;EAAsC,gBAAA;AxBm5XxC;;AwBn5XE;EAAsC,gBAAA;AxBu5XxC;;AwBv5XE;EAAsC,gBAAA;AxB25XxC;;AwB35XE;EAAsC,gBAAA;AxB+5XxC;;AwB/5XE;EAAsC,gBAAA;AxBm6XxC;;AwBn6XE;EAAsC,gBAAA;AxBu6XxC;;AwBv6XE;EAAsC,gBAAA;AxB26XxC;;AwB36XE;EAAsC,gBAAA;AxB+6XxC;;AwB/6XE;EAAsC,gBAAA;AxBm7XxC;;AwBn7XE;EAAsC,gBAAA;AxBu7XxC;;AwBv7XE;EAAsC,gBAAA;AxB27XxC;;AwB37XE;EAAsC,gBAAA;AxB+7XxC;;AwB/7XE;EAAsC,gBAAA;AxBm8XxC;;AwBn8XE;EAAsC,gBAAA;AxBu8XxC;;AwBv8XE;EAAsC,gBAAA;AxB28XxC;;AwB38XE;EAAsC,gBAAA;AxB+8XxC;;AwB/8XE;EAAsC,gBAAA;AxBm9XxC;;AwBn9XE;EAAsC,gBAAA;AxBu9XxC;;AwBv9XE;EAAsC,gBAAA;AxB29XxC;;AwB39XE;EAAsC,gBAAA;AxB+9XxC;;AwB/9XE;EAAsC,gBAAA;AxBm+XxC;;AwBn+XE;EAAsC,gBAAA;AxBu+XxC;;AwBv+XE;EAAsC,gBAAA;AxB2+XxC;;AwB3+XE;EAAsC,gBAAA;AxB++XxC;;AwB/+XE;EAAsC,gBAAA;AxBm/XxC;;AwBn/XE;EAAsC,gBAAA;AxBu/XxC;;AwBv/XE;EAAsC,gBAAA;AxB2/XxC;;AwB3/XE;EAAsC,gBAAA;AxB+/XxC;;AwB//XE;EAAsC,gBAAA;AxBmgYxC;;AwBngYE;EAAsC,gBAAA;AxBugYxC;;AwBvgYE;EAAsC,gBAAA;AxB2gYxC;;AwB3gYE;EAAsC,gBAAA;AxB+gYxC;;AwB/gYE;EAAsC,gBAAA;AxBmhYxC;;AwBnhYE;EAAsC,gBAAA;AxBuhYxC;;AwBvhYE;EAAsC,gBAAA;AxB2hYxC;;AwB3hYE;EAAsC,gBAAA;AxB+hYxC;;AwB/hYE;EAAsC,gBAAA;AxBmiYxC;;AwBniYE;EAAsC,gBAAA;AxBuiYxC;;AwBviYE;EAAsC,gBAAA;AxB2iYxC;;AwB3iYE;EAAsC,gBAAA;AxB+iYxC;;AwB/iYE;EAAsC,gBAAA;AxBmjYxC;;AwBnjYE;EAAsC,gBAAA;AxBujYxC;;AwBvjYE;EAAsC,gBAAA;AxB2jYxC;;AwB3jYE;EAAsC,gBAAA;AxB+jYxC;;AwB/jYE;EAAsC,gBAAA;AxBmkYxC;;AwBnkYE;EAAsC,gBAAA;AxBukYxC;;AwBvkYE;EAAsC,gBAAA;AxB2kYxC;;AwB3kYE;EAAsC,gBAAA;AxB+kYxC;;AwB/kYE;EAAsC,gBAAA;AxBmlYxC;;AwBnlYE;EAAsC,gBAAA;AxBulYxC;;AwBvlYE;EAAsC,gBAAA;AxB2lYxC;;AwB3lYE;EAAsC,gBAAA;AxB+lYxC;;AwB/lYE;EAAsC,gBAAA;AxBmmYxC;;AwBnmYE;EAAsC,gBAAA;AxBumYxC;;AwBvmYE;EAAsC,gBAAA;AxB2mYxC;;AwB3mYE;EAAsC,gBAAA;AxB+mYxC;;AwB/mYE;EAAsC,gBAAA;AxBmnYxC;;AwBnnYE;EAAsC,gBAAA;AxBunYxC;;AwBvnYE;EAAsC,gBAAA;AxB2nYxC;;AwB3nYE;EAAsC,gBAAA;AxB+nYxC;;AwB/nYE;EAAsC,gBAAA;AxBmoYxC;;AwBnoYE;EAAsC,gBAAA;AxBuoYxC;;AwBvoYE;EAAsC,gBAAA;AxB2oYxC;;AwB3oYE;EAAsC,gBAAA;AxB+oYxC;;AwB/oYE;EAAsC,gBAAA;AxBmpYxC;;AwBnpYE;EAAsC,gBAAA;AxBupYxC;;AwBvpYE;EAAsC,gBAAA;AxB2pYxC;;AwB3pYE;EAAsC,gBAAA;AxB+pYxC;;AwB/pYE;EAAsC,gBAAA;AxBmqYxC;;AwBnqYE;EAAsC,gBAAA;AxBuqYxC;;AwBvqYE;EAAsC,gBAAA;AxB2qYxC;;AwB3qYE;EAAsC,gBAAA;AxB+qYxC;;AwB/qYE;EAAsC,gBAAA;AxBmrYxC;;AwBnrYE;EAAsC,gBAAA;AxBurYxC;;AwBvrYE;EAAsC,gBAAA;AxB2rYxC;;AwB3rYE;EAAsC,gBAAA;AxB+rYxC;;AwB/rYE;EAAsC,gBAAA;AxBmsYxC;;AwBnsYE;EAAsC,gBAAA;AxBusYxC;;AwBvsYE;EAAsC,gBAAA;AxB2sYxC;;AwB3sYE;EAAsC,gBAAA;AxB+sYxC;;AwB/sYE;EAAsC,gBAAA;AxBmtYxC;;AwBntYE;EAAsC,gBAAA;AxButYxC;;AwBvtYE;EAAsC,gBAAA;AxB2tYxC;;AwB3tYE;EAAsC,gBAAA;AxB+tYxC;;AwB/tYE;EAAsC,gBAAA;AxBmuYxC;;AwBnuYE;EAAsC,gBAAA;AxBuuYxC;;AwBvuYE;EAAsC,gBAAA;AxB2uYxC;;AwB3uYE;EAAsC,gBAAA;AxB+uYxC;;AwB/uYE;EAAsC,gBAAA;AxBmvYxC;;AwBnvYE;EAAsC,gBAAA;AxBuvYxC;;AwBvvYE;EAAsC,gBAAA;AxB2vYxC;;AwB3vYE;EAAsC,gBAAA;AxB+vYxC;;AwB/vYE;EAAsC,gBAAA;AxBmwYxC;;AwBnwYE;EAAsC,gBAAA;AxBuwYxC;;AwBvwYE;EAAsC,gBAAA;AxB2wYxC;;AwB3wYE;EAAsC,gBAAA;AxB+wYxC;;AwB/wYE;EAAsC,gBAAA;AxBmxYxC;;AwBnxYE;EAAsC,gBAAA;AxBuxYxC;;AwBvxYE;EAAsC,YAAA;AxB2xYxC;;AwB3xYE;EAAsC,gBAAA;AxB+xYxC;;AwB/xYE;EAAsC,gBAAA;AxBmyYxC;;AwBnyYE;EAAsC,gBAAA;AxBuyYxC;;AwBvyYE;EAAsC,gBAAA;AxB2yYxC;;AwB3yYE;EAAsC,gBAAA;AxB+yYxC;;AwB/yYE;EAAsC,gBAAA;AxBmzYxC;;AwBnzYE;EAAsC,gBAAA;AxBuzYxC;;AwBvzYE;EAAsC,gBAAA;AxB2zYxC;;AwB3zYE;EAAsC,gBAAA;AxB+zYxC;;AwB/zYE;EAAsC,gBAAA;AxBm0YxC;;AwBn0YE;EAAsC,gBAAA;AxBu0YxC;;AwBv0YE;EAAsC,gBAAA;AxB20YxC;;AwB30YE;EAAsC,gBAAA;AxB+0YxC;;AwB/0YE;EAAsC,gBAAA;AxBm1YxC;;AwBn1YE;EAAsC,gBAAA;AxBu1YxC;;AwBv1YE;EAAsC,gBAAA;AxB21YxC;;AwB31YE;EAAsC,gBAAA;AxB+1YxC;;AwB/1YE;EAAsC,gBAAA;AxBm2YxC;;AwBn2YE;EAAsC,gBAAA;AxBu2YxC;;AwBv2YE;EAAsC,gBAAA;AxB22YxC;;AwB32YE;EAAsC,gBAAA;AxB+2YxC;;AwB/2YE;EAAsC,gBAAA;AxBm3YxC;;AwBn3YE;EAAsC,gBAAA;AxBu3YxC;;AwBv3YE;EAAsC,gBAAA;AxB23YxC;;AwB33YE;EAAsC,gBAAA;AxB+3YxC;;AwB/3YE;EAAsC,gBAAA;AxBm4YxC;;AwBn4YE;EAAsC,gBAAA;AxBu4YxC;;AwBv4YE;EAAsC,gBAAA;AxB24YxC;;AwB34YE;EAAsC,gBAAA;AxB+4YxC;;AwB/4YE;EAAsC,gBAAA;AxBm5YxC;;AwBn5YE;EAAsC,gBAAA;AxBu5YxC;;AwBv5YE;EAAsC,gBAAA;AxB25YxC;;AwB35YE;EAAsC,gBAAA;AxB+5YxC;;AwB/5YE;EAAsC,gBAAA;AxBm6YxC;;AwBn6YE;EAAsC,gBAAA;AxBu6YxC;;AwBv6YE;EAAsC,gBAAA;AxB26YxC;;AwB36YE;EAAsC,gBAAA;AxB+6YxC;;AwB/6YE;EAAsC,gBAAA;AxBm7YxC;;AwBn7YE;EAAsC,gBAAA;AxBu7YxC;;AwBv7YE;EAAsC,gBAAA;AxB27YxC;;AwB37YE;EAAsC,gBAAA;AxB+7YxC;;AwB/7YE;EAAsC,gBAAA;AxBm8YxC;;AwBn8YE;EAAsC,gBAAA;AxBu8YxC;;AwBv8YE;EAAsC,gBAAA;AxB28YxC;;AwB38YE;EAAsC,gBAAA;AxB+8YxC;;AwB/8YE;EAAsC,gBAAA;AxBm9YxC;;AwBn9YE;EAAsC,gBAAA;AxBu9YxC;;AwBv9YE;EAAsC,gBAAA;AxB29YxC;;AwB39YE;EAAsC,gBAAA;AxB+9YxC;;AwB/9YE;EAAsC,gBAAA;AxBm+YxC;;AwBn+YE;EAAsC,gBAAA;AxBu+YxC;;AwBv+YE;EAAsC,gBAAA;AxB2+YxC;;AwB3+YE;EAAsC,gBAAA;AxB++YxC;;AwB/+YE;EAAsC,gBAAA;AxBm/YxC;;AwBn/YE;EAAsC,aAAA;AxBu/YxC;;AwBv/YE;EAAsC,gBAAA;AxB2/YxC;;AwB3/YE;EAAsC,gBAAA;AxB+/YxC;;AwB//YE;EAAsC,gBAAA;AxBmgZxC;;AwBngZE;EAAsC,gBAAA;AxBugZxC;;AwBvgZE;EAAsC,gBAAA;AxB2gZxC;;AwB3gZE;EAAsC,gBAAA;AxB+gZxC;;AwB/gZE;EAAsC,gBAAA;AxBmhZxC;;AwBnhZE;EAAsC,gBAAA;AxBuhZxC;;AwBvhZE;EAAsC,gBAAA;AxB2hZxC;;AwB3hZE;EAAsC,gBAAA;AxB+hZxC;;AwB/hZE;EAAsC,gBAAA;AxBmiZxC;;AwBniZE;EAAsC,gBAAA;AxBuiZxC;;AwBviZE;EAAsC,gBAAA;AxB2iZxC;;AwB3iZE;EAAsC,gBAAA;AxB+iZxC;;AwB/iZE;EAAsC,gBAAA;AxBmjZxC;;AwBnjZE;EAAsC,gBAAA;AxBujZxC;;AwBvjZE;EAAsC,gBAAA;AxB2jZxC;;AwB3jZE;EAAsC,gBAAA;AxB+jZxC;;AwB/jZE;EAAsC,gBAAA;AxBmkZxC;;AwBnkZE;EAAsC,gBAAA;AxBukZxC;;AwBvkZE;EAAsC,gBAAA;AxB2kZxC;;AwB3kZE;EAAsC,gBAAA;AxB+kZxC;;AwB/kZE;EAAsC,gBAAA;AxBmlZxC;;AwBnlZE;EAAsC,gBAAA;AxBulZxC;;AwBvlZE;EAAsC,gBAAA;AxB2lZxC;;AwB3lZE;EAAsC,gBAAA;AxB+lZxC;;AwB/lZE;EAAsC,gBAAA;AxBmmZxC;;AwBnmZE;EAAsC,gBAAA;AxBumZxC;;AwBvmZE;EAAsC,gBAAA;AxB2mZxC;;AwB3mZE;EAAsC,gBAAA;AxB+mZxC;;AwB/mZE;EAAsC,gBAAA;AxBmnZxC;;AwBnnZE;EAAsC,gBAAA;AxBunZxC;;AwBvnZE;EAAsC,gBAAA;AxB2nZxC;;AwB3nZE;EAAsC,gBAAA;AxB+nZxC;;AwB/nZE;EAAsC,gBAAA;AxBmoZxC;;AwBnoZE;EAAsC,gBAAA;AxBuoZxC;;AwBvoZE;EAAsC,gBAAA;AxB2oZxC;;AwB3oZE;EAAsC,gBAAA;AxB+oZxC;;AwB/oZE;EAAsC,gBAAA;AxBmpZxC;;AwBnpZE;EAAsC,gBAAA;AxBupZxC;;AwBvpZE;EAAsC,gBAAA;AxB2pZxC;;AwB3pZE;EAAsC,gBAAA;AxB+pZxC;;AwB/pZE;EAAsC,gBAAA;AxBmqZxC;;AwBnqZE;EAAsC,gBAAA;AxBuqZxC;;AwBvqZE;EAAsC,gBAAA;AxB2qZxC;;AwB3qZE;EAAsC,gBAAA;AxB+qZxC;;AwB/qZE;EAAsC,gBAAA;AxBmrZxC;;AwBnrZE;EAAsC,gBAAA;AxBurZxC;;AwBvrZE;EAAsC,gBAAA;AxB2rZxC;;AwB3rZE;EAAsC,gBAAA;AxB+rZxC;;AwB/rZE;EAAsC,gBAAA;AxBmsZxC;;AwBnsZE;EAAsC,gBAAA;AxBusZxC;;AwBvsZE;EAAsC,gBAAA;AxB2sZxC;;AwB3sZE;EAAsC,gBAAA;AxB+sZxC;;AwB/sZE;EAAsC,gBAAA;AxBmtZxC;;AwBntZE;EAAsC,gBAAA;AxButZxC;;AwBvtZE;EAAsC,gBAAA;AxB2tZxC;;AwB3tZE;EAAsC,gBAAA;AxB+tZxC;;AwB/tZE;EAAsC,gBAAA;AxBmuZxC;;AwBnuZE;EAAsC,gBAAA;AxBuuZxC;;AwBvuZE;EAAsC,gBAAA;AxB2uZxC;;AwB3uZE;EAAsC,gBAAA;AxB+uZxC;;AwB/uZE;EAAsC,gBAAA;AxBmvZxC;;AwBnvZE;EAAsC,gBAAA;AxBuvZxC;;AwBvvZE;EAAsC,gBAAA;AxB2vZxC;;AwB3vZE;EAAsC,gBAAA;AxB+vZxC;;AwB/vZE;EAAsC,gBAAA;AxBmwZxC;;AwBnwZE;EAAsC,gBAAA;AxBuwZxC;;AwBvwZE;EAAsC,gBAAA;AxB2wZxC;;AwB3wZE;EAAsC,gBAAA;AxB+wZxC;;AwB/wZE;EAAsC,gBAAA;AxBmxZxC;;AwBnxZE;EAAsC,gBAAA;AxBuxZxC;;AwBvxZE;EAAsC,gBAAA;AxB2xZxC;;AwB3xZE;EAAsC,gBAAA;AxB+xZxC;;AwB/xZE;EAAsC,gBAAA;AxBmyZxC;;AwBnyZE;EAAsC,gBAAA;AxBuyZxC;;AwBvyZE;EAAsC,gBAAA;AxB2yZxC;;AwB3yZE;EAAsC,gBAAA;AxB+yZxC;;AwB/yZE;EAAsC,gBAAA;AxBmzZxC;;AwBnzZE;EAAsC,gBAAA;AxBuzZxC;;AwBvzZE;EAAsC,gBAAA;AxB2zZxC;;AwB3zZE;EAAsC,gBAAA;AxB+zZxC;;AwB/zZE;EAAsC,gBAAA;AxBm0ZxC;;AwBn0ZE;EAAsC,gBAAA;AxBu0ZxC;;AwBv0ZE;EAAsC,gBAAA;AxB20ZxC;;AwB30ZE;EAAsC,gBAAA;AxB+0ZxC;;AwB/0ZE;EAAsC,gBAAA;AxBm1ZxC;;AwBn1ZE;EAAsC,gBAAA;AxBu1ZxC;;AwBv1ZE;EAAsC,gBAAA;AxB21ZxC;;AwB31ZE;EAAsC,gBAAA;AxB+1ZxC;;AwB/1ZE;EAAsC,gBAAA;AxBm2ZxC;;AwBn2ZE;EAAsC,gBAAA;AxBu2ZxC;;AwBv2ZE;EAAsC,gBAAA;AxB22ZxC;;AwB32ZE;EAAsC,gBAAA;AxB+2ZxC;;AwB/2ZE;EAAsC,gBAAA;AxBm3ZxC;;AwBn3ZE;EAAsC,gBAAA;AxBu3ZxC;;AwBv3ZE;EAAsC,gBAAA;AxB23ZxC;;AwB33ZE;EAAsC,gBAAA;AxB+3ZxC;;AwB/3ZE;EAAsC,gBAAA;AxBm4ZxC;;AwBn4ZE;EAAsC,gBAAA;AxBu4ZxC;;AwBv4ZE;EAAsC,gBAAA;AxB24ZxC;;AwB34ZE;EAAsC,gBAAA;AxB+4ZxC;;AwB/4ZE;EAAsC,gBAAA;AxBm5ZxC;;AwBn5ZE;EAAsC,gBAAA;AxBu5ZxC;;AwBv5ZE;EAAsC,gBAAA;AxB25ZxC;;AwB35ZE;EAAsC,gBAAA;AxB+5ZxC;;AwB/5ZE;EAAsC,gBAAA;AxBm6ZxC;;AwBn6ZE;EAAsC,gBAAA;AxBu6ZxC;;AwBv6ZE;EAAsC,gBAAA;AxB26ZxC;;AwB36ZE;EAAsC,gBAAA;AxB+6ZxC;;AwB/6ZE;EAAsC,gBAAA;AxBm7ZxC;;AwBn7ZE;EAAsC,gBAAA;AxBu7ZxC;;AwBv7ZE;EAAsC,gBAAA;AxB27ZxC;;AwB37ZE;EAAsC,gBAAA;AxB+7ZxC;;AwB/7ZE;EAAsC,gBAAA;AxBm8ZxC;;AwBn8ZE;EAAsC,gBAAA;AxBu8ZxC;;AwBv8ZE;EAAsC,gBAAA;AxB28ZxC;;AwB38ZE;EAAsC,gBAAA;AxB+8ZxC;;AwB/8ZE;EAAsC,gBAAA;AxBm9ZxC;;AwBn9ZE;EAAsC,aAAA;AxBu9ZxC;;AwBv9ZE;EAAsC,aAAA;AxB29ZxC;;AwB39ZE;EAAsC,gBAAA;AxB+9ZxC;;AwB/9ZE;EAAsC,gBAAA;AxBm+ZxC;;AwBn+ZE;EAAsC,gBAAA;AxBu+ZxC;;AwBv+ZE;EAAsC,gBAAA;AxB2+ZxC;;AwB3+ZE;EAAsC,gBAAA;AxB++ZxC;;AwB/+ZE;EAAsC,gBAAA;AxBm/ZxC;;AwBn/ZE;EAAsC,gBAAA;AxBu/ZxC;;AwBv/ZE;EAAsC,gBAAA;AxB2/ZxC;;AwB3/ZE;EAAsC,gBAAA;AxB+/ZxC;;AwB//ZE;EAAsC,gBAAA;AxBmgaxC;;AwBngaE;EAAsC,gBAAA;AxBugaxC;;AwBvgaE;EAAsC,gBAAA;AxB2gaxC;;AwB3gaE;EAAsC,gBAAA;AxB+gaxC;;AwB/gaE;EAAsC,gBAAA;AxBmhaxC;;AwBnhaE;EAAsC,gBAAA;AxBuhaxC;;AwBvhaE;EAAsC,gBAAA;AxB2haxC;;AwB3haE;EAAsC,gBAAA;AxB+haxC;;AwB/haE;EAAsC,gBAAA;AxBmiaxC;;AwBniaE;EAAsC,gBAAA;AxBuiaxC;;AwBviaE;EAAsC,gBAAA;AxB2iaxC;;AwB3iaE;EAAsC,gBAAA;AxB+iaxC;;AwB/iaE;EAAsC,gBAAA;AxBmjaxC;;AwBnjaE;EAAsC,gBAAA;AxBujaxC;;AwBvjaE;EAAsC,gBAAA;AxB2jaxC;;AwB3jaE;EAAsC,gBAAA;AxB+jaxC;;AwB/jaE;EAAsC,gBAAA;AxBmkaxC;;AwBnkaE;EAAsC,gBAAA;AxBukaxC;;AwBvkaE;EAAsC,gBAAA;AxB2kaxC;;AwB3kaE;EAAsC,gBAAA;AxB+kaxC;;AwB/kaE;EAAsC,gBAAA;AxBmlaxC;;AwBnlaE;EAAsC,gBAAA;AxBulaxC;;AwBvlaE;EAAsC,gBAAA;AxB2laxC;;AwB3laE;EAAsC,gBAAA;AxB+laxC;;AwB/laE;EAAsC,gBAAA;AxBmmaxC;;AwBnmaE;EAAsC,gBAAA;AxBumaxC;;AwBvmaE;EAAsC,gBAAA;AxB2maxC;;AwB3maE;EAAsC,gBAAA;AxB+maxC;;AwB/maE;EAAsC,gBAAA;AxBmnaxC;;AwBnnaE;EAAsC,gBAAA;AxBunaxC;;AwBvnaE;EAAsC,gBAAA;AxB2naxC;;AwB3naE;EAAsC,gBAAA;AxB+naxC;;AwB/naE;EAAsC,gBAAA;AxBmoaxC;;AwBnoaE;EAAsC,gBAAA;AxBuoaxC;;AwBvoaE;EAAsC,gBAAA;AxB2oaxC;;AwB3oaE;EAAsC,gBAAA;AxB+oaxC;;AwB/oaE;EAAsC,gBAAA;AxBmpaxC;;AwBnpaE;EAAsC,gBAAA;AxBupaxC;;AwBvpaE;EAAsC,gBAAA;AxB2paxC;;AwB3paE;EAAsC,gBAAA;AxB+paxC;;AwB/paE;EAAsC,gBAAA;AxBmqaxC;;AwBnqaE;EAAsC,gBAAA;AxBuqaxC;;AwBvqaE;EAAsC,gBAAA;AxB2qaxC;;AwB3qaE;EAAsC,gBAAA;AxB+qaxC;;AwB/qaE;EAAsC,gBAAA;AxBmraxC;;AwBnraE;EAAsC,gBAAA;AxBuraxC;;AwBvraE;EAAsC,gBAAA;AxB2raxC;;AwB3raE;EAAsC,gBAAA;AxB+raxC;;AwB/raE;EAAsC,gBAAA;AxBmsaxC;;AwBnsaE;EAAsC,gBAAA;AxBusaxC;;AwBvsaE;EAAsC,gBAAA;AxB2saxC;;AwB3saE;EAAsC,gBAAA;AxB+saxC;;AwB/saE;EAAsC,gBAAA;AxBmtaxC;;AwBntaE;EAAsC,gBAAA;AxButaxC;;AwBvtaE;EAAsC,gBAAA;AxB2taxC;;AwB3taE;EAAsC,gBAAA;AxB+taxC;;AwB/taE;EAAsC,gBAAA;AxBmuaxC;;AwBnuaE;EAAsC,gBAAA;AxBuuaxC;;AwBvuaE;EAAsC,gBAAA;AxB2uaxC;;AwB3uaE;EAAsC,gBAAA;AxB+uaxC;;AwB/uaE;EAAsC,gBAAA;AxBmvaxC;;AwBnvaE;EAAsC,gBAAA;AxBuvaxC;;AwBvvaE;EAAsC,gBAAA;AxB2vaxC;;AwB3vaE;EAAsC,gBAAA;AxB+vaxC;;AwB/vaE;EAAsC,gBAAA;AxBmwaxC;;AwBnwaE;EAAsC,gBAAA;AxBuwaxC;;AwBvwaE;EAAsC,gBAAA;AxB2waxC;;AwB3waE;EAAsC,gBAAA;AxB+waxC;;AwB/waE;EAAsC,gBAAA;AxBmxaxC;;AwBnxaE;EAAsC,gBAAA;AxBuxaxC;;AwBvxaE;EAAsC,gBAAA;AxB2xaxC;;AwB3xaE;EAAsC,gBAAA;AxB+xaxC;;AwB/xaE;EAAsC,gBAAA;AxBmyaxC;;AwBnyaE;EAAsC,gBAAA;AxBuyaxC;;AwBvyaE;EAAsC,gBAAA;AxB2yaxC;;AwB3yaE;EAAsC,gBAAA;AxB+yaxC;;AwB/yaE;EAAsC,gBAAA;AxBmzaxC;;AwBnzaE;EAAsC,gBAAA;AxBuzaxC;;AwBvzaE;EAAsC,gBAAA;AxB2zaxC;;AwB3zaE;EAAsC,gBAAA;AxB+zaxC;;AwB/zaE;EAAsC,gBAAA;AxBm0axC;;AwBn0aE;EAAsC,gBAAA;AxBu0axC;;AwBv0aE;EAAsC,gBAAA;AxB20axC;;AwB30aE;EAAsC,gBAAA;AxB+0axC;;AwB/0aE;EAAsC,gBAAA;AxBm1axC;;AwBn1aE;EAAsC,gBAAA;AxBu1axC;;AwBv1aE;EAAsC,gBAAA;AxB21axC;;AwB31aE;EAAsC,gBAAA;AxB+1axC;;AwB/1aE;EAAsC,gBAAA;AxBm2axC;;AwBn2aE;EAAsC,gBAAA;AxBu2axC;;AwBv2aE;EAAsC,gBAAA;AxB22axC;;AwB32aE;EAAsC,gBAAA;AxB+2axC;;AwB/2aE;EAAsC,gBAAA;AxBm3axC;;AwBn3aE;EAAsC,gBAAA;AxBu3axC;;AwBv3aE;EAAsC,gBAAA;AxB23axC;;AwB33aE;EAAsC,gBAAA;AxB+3axC;;AwB/3aE;EAAsC,gBAAA;AxBm4axC;;AwBn4aE;EAAsC,gBAAA;AxBu4axC;;AwBv4aE;EAAsC,gBAAA;AxB24axC;;AwB34aE;EAAsC,gBAAA;AxB+4axC;;AwB/4aE;EAAsC,gBAAA;AxBm5axC;;AwBn5aE;EAAsC,gBAAA;AxBu5axC;;AwBv5aE;EAAsC,gBAAA;AxB25axC;;AwB35aE;EAAsC,gBAAA;AxB+5axC;;AwB/5aE;EAAsC,gBAAA;AxBm6axC;;AwBn6aE;EAAsC,gBAAA;AxBu6axC;;AwBv6aE;EAAsC,gBAAA;AxB26axC;;AwB36aE;EAAsC,gBAAA;AxB+6axC;;AwB/6aE;EAAsC,gBAAA;AxBm7axC;;AwBn7aE;EAAsC,gBAAA;AxBu7axC;;AwBv7aE;EAAsC,gBAAA;AxB27axC;;AwB37aE;EAAsC,gBAAA;AxB+7axC;;AwB/7aE;EAAsC,gBAAA;AxBm8axC;;AwBn8aE;EAAsC,gBAAA;AxBu8axC;;AwBv8aE;EAAsC,gBAAA;AxB28axC;;AwB38aE;EAAsC,gBAAA;AxB+8axC;;AwB/8aE;EAAsC,gBAAA;AxBm9axC;;AwBn9aE;EAAsC,gBAAA;AxBu9axC;;AwBv9aE;EAAsC,gBAAA;AxB29axC;;AwB39aE;EAAsC,gBAAA;AxB+9axC;;AwB/9aE;EAAsC,gBAAA;AxBm+axC;;AwBn+aE;EAAsC,gBAAA;AxBu+axC;;AwBv+aE;EAAsC,gBAAA;AxB2+axC;;AwB3+aE;EAAsC,gBAAA;AxB++axC;;AwB/+aE;EAAsC,gBAAA;AxBm/axC;;AwBn/aE;EAAsC,gBAAA;AxBu/axC;;AwBv/aE;EAAsC,gBAAA;AxB2/axC;;AwB3/aE;EAAsC,gBAAA;AxB+/axC;;AwB//aE;EAAsC,gBAAA;AxBmgbxC;;AwBngbE;EAAsC,gBAAA;AxBugbxC;;AwBvgbE;EAAsC,gBAAA;AxB2gbxC;;AwB3gbE;EAAsC,gBAAA;AxB+gbxC;;AwB/gbE;EAAsC,gBAAA;AxBmhbxC;;AwBnhbE;EAAsC,gBAAA;AxBuhbxC;;AwBvhbE;EAAsC,gBAAA;AxB2hbxC;;AwB3hbE;EAAsC,gBAAA;AxB+hbxC;;AwB/hbE;EAAsC,gBAAA;AxBmibxC;;AwBnibE;EAAsC,gBAAA;AxBuibxC;;AwBvibE;EAAsC,gBAAA;AxB2ibxC;;AwB3ibE;EAAsC,gBAAA;AxB+ibxC;;AwB/ibE;EAAsC,gBAAA;AxBmjbxC;;AwBnjbE;EAAsC,gBAAA;AxBujbxC;;AwBvjbE;EAAsC,gBAAA;AxB2jbxC;;AwB3jbE;EAAsC,gBAAA;AxB+jbxC;;AwB/jbE;EAAsC,gBAAA;AxBmkbxC;;AwBnkbE;EAAsC,gBAAA;AxBukbxC;;AwBvkbE;EAAsC,gBAAA;AxB2kbxC;;AwB3kbE;EAAsC,gBAAA;AxB+kbxC;;AwB/kbE;EAAsC,gBAAA;AxBmlbxC;;AwBnlbE;EAAsC,gBAAA;AxBulbxC;;AwBvlbE;EAAsC,gBAAA;AxB2lbxC;;AwB3lbE;EAAsC,gBAAA;AxB+lbxC;;AwB/lbE;EAAsC,gBAAA;AxBmmbxC;;AwBnmbE;EAAsC,gBAAA;AxBumbxC;;AwBvmbE;EAAsC,gBAAA;AxB2mbxC;;AwB3mbE;EAAsC,gBAAA;AxB+mbxC;;AwB/mbE;EAAsC,gBAAA;AxBmnbxC;;AwBnnbE;EAAsC,gBAAA;AxBunbxC;;AwBvnbE;EAAsC,gBAAA;AxB2nbxC;;AwB3nbE;EAAsC,gBAAA;AxB+nbxC;;AwB/nbE;EAAsC,gBAAA;AxBmobxC;;AwBnobE;EAAsC,gBAAA;AxBuobxC;;AwBvobE;EAAsC,gBAAA;AxB2obxC;;AwB3obE;EAAsC,gBAAA;AxB+obxC;;AwB/obE;EAAsC,gBAAA;AxBmpbxC;;AwBnpbE;EAAsC,gBAAA;AxBupbxC;;AwBvpbE;EAAsC,gBAAA;AxB2pbxC;;AwB3pbE;EAAsC,gBAAA;AxB+pbxC;;AwB/pbE;EAAsC,gBAAA;AxBmqbxC;;AwBnqbE;EAAsC,gBAAA;AxBuqbxC;;AwBvqbE;EAAsC,gBAAA;AxB2qbxC;;AwB3qbE;EAAsC,gBAAA;AxB+qbxC;;AwB/qbE;EAAsC,gBAAA;AxBmrbxC;;AwBnrbE;EAAsC,gBAAA;AxBurbxC;;AwBvrbE;EAAsC,gBAAA;AxB2rbxC;;AwB3rbE;EAAsC,gBAAA;AxB+rbxC;;AwB/rbE;EAAsC,gBAAA;AxBmsbxC;;AwBnsbE;EAAsC,gBAAA;AxBusbxC;;AwBvsbE;EAAsC,gBAAA;AxB2sbxC;;AwB3sbE;EAAsC,gBAAA;AxB+sbxC;;AwB/sbE;EAAsC,gBAAA;AxBmtbxC;;AwBntbE;EAAsC,gBAAA;AxButbxC;;AwBvtbE;EAAsC,gBAAA;AxB2tbxC;;AwB3tbE;EAAsC,gBAAA;AxB+tbxC;;AwB/tbE;EAAsC,gBAAA;AxBmubxC;;AwBnubE;EAAsC,gBAAA;AxBuubxC;;AwBvubE;EAAsC,gBAAA;AxB2ubxC;;AwB3ubE;EAAsC,gBAAA;AxB+ubxC;;AwB/ubE;EAAsC,gBAAA;AxBmvbxC;;AwBnvbE;EAAsC,gBAAA;AxBuvbxC;;AwBvvbE;EAAsC,gBAAA;AxB2vbxC;;AwB3vbE;EAAsC,gBAAA;AxB+vbxC;;AwB/vbE;EAAsC,gBAAA;AxBmwbxC;;AwBnwbE;EAAsC,gBAAA;AxBuwbxC;;AwBvwbE;EAAsC,gBAAA;AxB2wbxC;;AwB3wbE;EAAsC,gBAAA;AxB+wbxC;;AwB/wbE;EAAsC,gBAAA;AxBmxbxC;;AwBnxbE;EAAsC,gBAAA;AxBuxbxC;;AwBvxbE;EAAsC,gBAAA;AxB2xbxC;;AwB3xbE;EAAsC,gBAAA;AxB+xbxC;;AwB/xbE;EAAsC,gBAAA;AxBmybxC;;AwBnybE;EAAsC,gBAAA;AxBuybxC;;AwBvybE;EAAsC,gBAAA;AxB2ybxC;;AwB3ybE;EAAsC,gBAAA;AxB+ybxC;;AwB/ybE;EAAsC,gBAAA;AxBmzbxC;;AwBnzbE;EAAsC,gBAAA;AxBuzbxC;;AwBvzbE;EAAsC,gBAAA;AxB2zbxC;;AwB3zbE;EAAsC,gBAAA;AxB+zbxC;;AwB/zbE;EAAsC,gBAAA;AxBm0bxC;;AwBn0bE;EAAsC,gBAAA;AxBu0bxC;;AwBv0bE;EAAsC,gBAAA;AxB20bxC;;AwB30bE;EAAsC,gBAAA;AxB+0bxC;;AwB/0bE;EAAsC,gBAAA;AxBm1bxC;;AwBn1bE;EAAsC,gBAAA;AxBu1bxC;;AwBv1bE;EAAsC,gBAAA;AxB21bxC;;AwB31bE;EAAsC,gBAAA;AxB+1bxC;;AwB/1bE;EAAsC,gBAAA;AxBm2bxC;;AwBn2bE;EAAsC,gBAAA;AxBu2bxC;;AwBv2bE;EAAsC,gBAAA;AxB22bxC;;AwB32bE;EAAsC,gBAAA;AxB+2bxC;;AwB/2bE;EAAsC,gBAAA;AxBm3bxC;;AwBn3bE;EAAsC,gBAAA;AxBu3bxC;;AwBv3bE;EAAsC,gBAAA;AxB23bxC;;AwB33bE;EAAsC,gBAAA;AxB+3bxC;;AwB/3bE;EAAsC,gBAAA;AxBm4bxC;;AwBn4bE;EAAsC,gBAAA;AxBu4bxC;;AwBv4bE;EAAsC,gBAAA;AxB24bxC;;AwB34bE;EAAsC,gBAAA;AxB+4bxC;;AwB/4bE;EAAsC,gBAAA;AxBm5bxC;;AwBn5bE;EAAsC,gBAAA;AxBu5bxC;;AwBv5bE;EAAsC,gBAAA;AxB25bxC;;AwB35bE;EAAsC,gBAAA;AxB+5bxC;;AwB/5bE;EAAsC,gBAAA;AxBm6bxC;;AwBn6bE;EAAsC,gBAAA;AxBu6bxC;;AwBv6bE;EAAsC,gBAAA;AxB26bxC;;AwB36bE;EAAsC,gBAAA;AxB+6bxC;;AwB/6bE;EAAsC,gBAAA;AxBm7bxC;;AwBn7bE;EAAsC,gBAAA;AxBu7bxC;;AwBv7bE;EAAsC,gBAAA;AxB27bxC;;AwB37bE;EAAsC,gBAAA;AxB+7bxC;;AwB/7bE;EAAsC,gBAAA;AxBm8bxC;;AwBn8bE;EAAsC,gBAAA;AxBu8bxC;;AwBv8bE;EAAsC,gBAAA;AxB28bxC;;AwB38bE;EAAsC,gBAAA;AxB+8bxC;;AwB/8bE;EAAsC,gBAAA;AxBm9bxC;;AwBn9bE;EAAsC,gBAAA;AxBu9bxC;;AwBv9bE;EAAsC,gBAAA;AxB29bxC;;AwB39bE;EAAsC,gBAAA;AxB+9bxC;;AwB/9bE;EAAsC,gBAAA;AxBm+bxC;;AwBn+bE;EAAsC,gBAAA;AxBu+bxC;;AwBv+bE;EAAsC,gBAAA;AxB2+bxC;;AwB3+bE;EAAsC,gBAAA;AxB++bxC;;AwB/+bE;EAAsC,gBAAA;AxBm/bxC;;AwBn/bE;EAAsC,gBAAA;AxBu/bxC;;AwBv/bE;EAAsC,gBAAA;AxB2/bxC;;AwB3/bE;EAAsC,gBAAA;AxB+/bxC;;AwB//bE;EAAsC,gBAAA;AxBmgcxC;;AwBngcE;EAAsC,gBAAA;AxBugcxC;;AwBvgcE;EAAsC,gBAAA;AxB2gcxC;;AwB3gcE;EAAsC,gBAAA;AxB+gcxC;;AwB/gcE;EAAsC,gBAAA;AxBmhcxC;;AwBnhcE;EAAsC,gBAAA;AxBuhcxC;;AwBvhcE;EAAsC,gBAAA;AxB2hcxC;;AwB3hcE;EAAsC,gBAAA;AxB+hcxC;;AwB/hcE;EAAsC,gBAAA;AxBmicxC;;AwBnicE;EAAsC,gBAAA;AxBuicxC;;AwBvicE;EAAsC,gBAAA;AxB2icxC;;AwB3icE;EAAsC,gBAAA;AxB+icxC;;AwB/icE;EAAsC,gBAAA;AxBmjcxC;;AwBnjcE;EAAsC,gBAAA;AxBujcxC;;AwBvjcE;EAAsC,gBAAA;AxB2jcxC;;AwB3jcE;EAAsC,YAAA;AxB+jcxC;;AwB/jcE;EAAsC,gBAAA;AxBmkcxC;;AwBnkcE;EAAsC,gBAAA;AxBukcxC;;AwBvkcE;EAAsC,gBAAA;AxB2kcxC;;AwB3kcE;EAAsC,gBAAA;AxB+kcxC;;AwB/kcE;EAAsC,gBAAA;AxBmlcxC;;AwBnlcE;EAAsC,gBAAA;AxBulcxC;;AwBvlcE;EAAsC,gBAAA;AxB2lcxC;;AwB3lcE;EAAsC,gBAAA;AxB+lcxC;;AwB/lcE;EAAsC,gBAAA;AxBmmcxC;;AwBnmcE;EAAsC,gBAAA;AxBumcxC;;AwBvmcE;EAAsC,gBAAA;AxB2mcxC;;AwB3mcE;EAAsC,gBAAA;AxB+mcxC;;AwB/mcE;EAAsC,gBAAA;AxBmncxC;;AwBnncE;EAAsC,gBAAA;AxBuncxC;;AwBvncE;EAAsC,gBAAA;AxB2ncxC;;AwB3ncE;EAAsC,gBAAA;AxB+ncxC;;AwB/ncE;EAAsC,gBAAA;AxBmocxC;;AwBnocE;EAAsC,gBAAA;AxBuocxC;;AwBvocE;EAAsC,gBAAA;AxB2ocxC;;AwB3ocE;EAAsC,gBAAA;AxB+ocxC;;AwB/ocE;EAAsC,gBAAA;AxBmpcxC;;AwBnpcE;EAAsC,gBAAA;AxBupcxC;;AwBvpcE;EAAsC,gBAAA;AxB2pcxC;;AwB3pcE;EAAsC,gBAAA;AxB+pcxC;;AwB/pcE;EAAsC,gBAAA;AxBmqcxC;;AwBnqcE;EAAsC,gBAAA;AxBuqcxC;;AwBvqcE;EAAsC,gBAAA;AxB2qcxC;;AwB3qcE;EAAsC,gBAAA;AxB+qcxC;;AwB/qcE;EAAsC,gBAAA;AxBmrcxC;;AwBnrcE;EAAsC,gBAAA;AxBurcxC;;AwBvrcE;EAAsC,gBAAA;AxB2rcxC;;AwB3rcE;EAAsC,gBAAA;AxB+rcxC;;AwB/rcE;EAAsC,gBAAA;AxBmscxC;;AwBnscE;EAAsC,gBAAA;AxBuscxC;;AwBvscE;EAAsC,gBAAA;AxB2scxC;;AwB3scE;EAAsC,gBAAA;AxB+scxC;;AwB/scE;EAAsC,gBAAA;AxBmtcxC;;AwBntcE;EAAsC,gBAAA;AxButcxC;;AwBvtcE;EAAsC,gBAAA;AxB2tcxC;;AwB3tcE;EAAsC,gBAAA;AxB+tcxC;;AwB/tcE;EAAsC,gBAAA;AxBmucxC;;AwBnucE;EAAsC,gBAAA;AxBuucxC;;AwBvucE;EAAsC,gBAAA;AxB2ucxC;;AwB3ucE;EAAsC,gBAAA;AxB+ucxC;;AwB/ucE;EAAsC,gBAAA;AxBmvcxC;;AwBnvcE;EAAsC,gBAAA;AxBuvcxC;;AwBvvcE;EAAsC,gBAAA;AxB2vcxC;;AwB3vcE;EAAsC,gBAAA;AxB+vcxC;;AwB/vcE;EAAsC,gBAAA;AxBmwcxC;;AwBnwcE;EAAsC,gBAAA;AxBuwcxC;;AwBvwcE;EAAsC,gBAAA;AxB2wcxC;;AwB3wcE;EAAsC,gBAAA;AxB+wcxC;;AwB/wcE;EAAsC,gBAAA;AxBmxcxC;;AwBnxcE;EAAsC,gBAAA;AxBuxcxC;;AwBvxcE;EAAsC,gBAAA;AxB2xcxC;;AwB3xcE;EAAsC,gBAAA;AxB+xcxC;;AwB/xcE;EAAsC,gBAAA;AxBmycxC;;AwBnycE;EAAsC,gBAAA;AxBuycxC;;AwBvycE;EAAsC,gBAAA;AxB2ycxC;;AwB3ycE;EAAsC,gBAAA;AxB+ycxC;;AwB/ycE;EAAsC,gBAAA;AxBmzcxC;;AwBnzcE;EAAsC,gBAAA;AxBuzcxC;;AwBvzcE;EAAsC,gBAAA;AxB2zcxC;;AwB3zcE;EAAsC,gBAAA;AxB+zcxC;;AwB/zcE;EAAsC,gBAAA;AxBm0cxC;;AwBn0cE;EAAsC,gBAAA;AxBu0cxC;;AwBv0cE;EAAsC,gBAAA;AxB20cxC;;AwB30cE;EAAsC,gBAAA;AxB+0cxC;;AwB/0cE;EAAsC,gBAAA;AxBm1cxC;;AwBn1cE;EAAsC,gBAAA;AxBu1cxC;;AwBv1cE;EAAsC,gBAAA;AxB21cxC;;AwB31cE;EAAsC,gBAAA;AxB+1cxC;;AwB/1cE;EAAsC,gBAAA;AxBm2cxC;;AwBn2cE;EAAsC,gBAAA;AxBu2cxC;;AwBv2cE;EAAsC,gBAAA;AxB22cxC;;AwB32cE;EAAsC,gBAAA;AxB+2cxC;;AwB/2cE;EAAsC,gBAAA;AxBm3cxC;;AwBn3cE;EAAsC,gBAAA;AxBu3cxC;;AwBv3cE;EAAsC,gBAAA;AxB23cxC;;AwB33cE;EAAsC,gBAAA;AxB+3cxC;;AwB/3cE;EAAsC,gBAAA;AxBm4cxC;;AwBn4cE;EAAsC,gBAAA;AxBu4cxC;;AwBv4cE;EAAsC,gBAAA;AxB24cxC;;AwB34cE;EAAsC,gBAAA;AxB+4cxC;;AwB/4cE;EAAsC,gBAAA;AxBm5cxC;;AwBn5cE;EAAsC,gBAAA;AxBu5cxC;;AwBv5cE;EAAsC,gBAAA;AxB25cxC;;AwB35cE;EAAsC,gBAAA;AxB+5cxC;;AwB/5cE;EAAsC,gBAAA;AxBm6cxC;;AwBn6cE;EAAsC,gBAAA;AxBu6cxC;;AwBv6cE;EAAsC,gBAAA;AxB26cxC;;AwB36cE;EAAsC,gBAAA;AxB+6cxC;;AwB/6cE;EAAsC,gBAAA;AxBm7cxC;;AwBn7cE;EAAsC,gBAAA;AxBu7cxC;;AwBv7cE;EAAsC,gBAAA;AxB27cxC;;AwB37cE;EAAsC,gBAAA;AxB+7cxC;;AwB/7cE;EAAsC,gBAAA;AxBm8cxC;;AwBn8cE;EAAsC,gBAAA;AxBu8cxC;;AwBv8cE;EAAsC,gBAAA;AxB28cxC;;AwB38cE;EAAsC,gBAAA;AxB+8cxC;;AwB/8cE;EAAsC,gBAAA;AxBm9cxC;;AwBn9cE;EAAsC,gBAAA;AxBu9cxC;;AwBv9cE;EAAsC,aAAA;AxB29cxC;;AwB39cE;EAAsC,gBAAA;AxB+9cxC;;AwB/9cE;EAAsC,gBAAA;AxBm+cxC;;AwBn+cE;EAAsC,gBAAA;AxBu+cxC;;AwBv+cE;EAAsC,gBAAA;AxB2+cxC;;AwB3+cE;EAAsC,gBAAA;AxB++cxC;;AwB/+cE;EAAsC,gBAAA;AxBm/cxC;;AwBn/cE;EAAsC,gBAAA;AxBu/cxC;;AwBv/cE;EAAsC,gBAAA;AxB2/cxC;;AwB3/cE;EAAsC,gBAAA;AxB+/cxC;;AwB//cE;EAAsC,gBAAA;AxBmgdxC;;AwBngdE;EAAsC,gBAAA;AxBugdxC;;AwBvgdE;EAAsC,gBAAA;AxB2gdxC;;AwB3gdE;EAAsC,gBAAA;AxB+gdxC;;AwB/gdE;EAAsC,gBAAA;AxBmhdxC;;AwBnhdE;EAAsC,gBAAA;AxBuhdxC;;AwBvhdE;EAAsC,gBAAA;AxB2hdxC;;AwB3hdE;EAAsC,gBAAA;AxB+hdxC;;AwB/hdE;EAAsC,gBAAA;AxBmidxC;;AwBnidE;EAAsC,gBAAA;AxBuidxC;;AwBvidE;EAAsC,gBAAA;AxB2idxC;;AwB3idE;EAAsC,gBAAA;AxB+idxC;;AwB/idE;EAAsC,gBAAA;AxBmjdxC;;AwBnjdE;EAAsC,gBAAA;AxBujdxC;;AwBvjdE;EAAsC,gBAAA;AxB2jdxC;;AwB3jdE;EAAsC,gBAAA;AxB+jdxC;;AwB/jdE;EAAsC,gBAAA;AxBmkdxC;;AwBnkdE;EAAsC,gBAAA;AxBukdxC;;AwBvkdE;EAAsC,gBAAA;AxB2kdxC;;AwB3kdE;EAAsC,gBAAA;AxB+kdxC;;AwB/kdE;EAAsC,gBAAA;AxBmldxC;;AwBnldE;EAAsC,gBAAA;AxBuldxC;;AwBvldE;EAAsC,gBAAA;AxB2ldxC;;AwB3ldE;EAAsC,gBAAA;AxB+ldxC;;AwB/ldE;EAAsC,gBAAA;AxBmmdxC;;AwBnmdE;EAAsC,gBAAA;AxBumdxC;;AwBvmdE;EAAsC,gBAAA;AxB2mdxC;;AwB3mdE;EAAsC,gBAAA;AxB+mdxC;;AwB/mdE;EAAsC,gBAAA;AxBmndxC;;AwBnndE;EAAsC,gBAAA;AxBundxC;;AwBvndE;EAAsC,gBAAA;AxB2ndxC;;AwB3ndE;EAAsC,gBAAA;AxB+ndxC;;AwB/ndE;EAAsC,gBAAA;AxBmodxC;;AwBnodE;EAAsC,gBAAA;AxBuodxC;;AwBvodE;EAAsC,gBAAA;AxB2odxC;;AwB3odE;EAAsC,gBAAA;AxB+odxC;;AwB/odE;EAAsC,gBAAA;AxBmpdxC;;AwBnpdE;EAAsC,gBAAA;AxBupdxC;;AwBvpdE;EAAsC,gBAAA;AxB2pdxC;;AwB3pdE;EAAsC,gBAAA;AxB+pdxC;;AwB/pdE;EAAsC,gBAAA;AxBmqdxC;;AwBnqdE;EAAsC,gBAAA;AxBuqdxC;;AwBvqdE;EAAsC,gBAAA;AxB2qdxC;;AwB3qdE;EAAsC,gBAAA;AxB+qdxC;;AwB/qdE;EAAsC,gBAAA;AxBmrdxC;;AwBnrdE;EAAsC,gBAAA;AxBurdxC;;AwBvrdE;EAAsC,gBAAA;AxB2rdxC;;AwB3rdE;EAAsC,gBAAA;AxB+rdxC;;AwB/rdE;EAAsC,gBAAA;AxBmsdxC;;AwBnsdE;EAAsC,gBAAA;AxBusdxC;;AwBvsdE;EAAsC,gBAAA;AxB2sdxC;;AwB3sdE;EAAsC,gBAAA;AxB+sdxC;;AwB/sdE;EAAsC,gBAAA;AxBmtdxC;;AwBntdE;EAAsC,gBAAA;AxButdxC;;AwBvtdE;EAAsC,gBAAA;AxB2tdxC;;AwB3tdE;EAAsC,gBAAA;AxB+tdxC;;AwB/tdE;EAAsC,gBAAA;AxBmudxC;;AwBnudE;EAAsC,gBAAA;AxBuudxC;;AwBvudE;EAAsC,gBAAA;AxB2udxC;;AwB3udE;EAAsC,gBAAA;AxB+udxC;;AwB/udE;EAAsC,gBAAA;AxBmvdxC;;AwBnvdE;EAAsC,gBAAA;AxBuvdxC;;AwBvvdE;EAAsC,gBAAA;AxB2vdxC;;AwB3vdE;EAAsC,gBAAA;AxB+vdxC;;AwB/vdE;EAAsC,gBAAA;AxBmwdxC;;AwBnwdE;EAAsC,gBAAA;AxBuwdxC;;AwBvwdE;EAAsC,gBAAA;AxB2wdxC;;AwB3wdE;EAAsC,gBAAA;AxB+wdxC;;AwB/wdE;EAAsC,gBAAA;AxBmxdxC;;AwBnxdE;EAAsC,gBAAA;AxBuxdxC;;AwBvxdE;EAAsC,gBAAA;AxB2xdxC;;AwB3xdE;EAAsC,gBAAA;AxB+xdxC;;AwB/xdE;EAAsC,gBAAA;AxBmydxC;;AwBnydE;EAAsC,gBAAA;AxBuydxC;;AwBvydE;EAAsC,gBAAA;AxB2ydxC;;AwB3ydE;EAAsC,gBAAA;AxB+ydxC;;AwB/ydE;EAAsC,gBAAA;AxBmzdxC;;AwBnzdE;EAAsC,gBAAA;AxBuzdxC;;AwBvzdE;EAAsC,gBAAA;AxB2zdxC;;AwB3zdE;EAAsC,gBAAA;AxB+zdxC;;AwB/zdE;EAAsC,gBAAA;AxBm0dxC;;AwBn0dE;EAAsC,gBAAA;AxBu0dxC;;AwBv0dE;EAAsC,gBAAA;AxB20dxC;;AwB30dE;EAAsC,gBAAA;AxB+0dxC;;AwB/0dE;EAAsC,gBAAA;AxBm1dxC;;AwBn1dE;EAAsC,gBAAA;AxBu1dxC;;AwBv1dE;EAAsC,gBAAA;AxB21dxC;;AwB31dE;EAAsC,gBAAA;AxB+1dxC;;AwB/1dE;EAAsC,gBAAA;AxBm2dxC;;AwBn2dE;EAAsC,gBAAA;AxBu2dxC;;AwBv2dE;EAAsC,gBAAA;AxB22dxC;;AwB32dE;EAAsC,gBAAA;AxB+2dxC;;AwB/2dE;EAAsC,gBAAA;AxBm3dxC;;AwBn3dE;EAAsC,gBAAA;AxBu3dxC;;AwBv3dE;EAAsC,gBAAA;AxB23dxC;;AwB33dE;EAAsC,gBAAA;AxB+3dxC;;AwB/3dE;EAAsC,gBAAA;AxBm4dxC;;AwBn4dE;EAAsC,gBAAA;AxBu4dxC;;AwBv4dE;EAAsC,gBAAA;AxB24dxC;;AwB34dE;EAAsC,gBAAA;AxB+4dxC;;AwB/4dE;EAAsC,gBAAA;AxBm5dxC;;AwBn5dE;EAAsC,gBAAA;AxBu5dxC;;AwBv5dE;EAAsC,gBAAA;AxB25dxC;;AwB35dE;EAAsC,gBAAA;AxB+5dxC;;AwB/5dE;EAAsC,gBAAA;AxBm6dxC;;AwBn6dE;EAAsC,gBAAA;AxBu6dxC;;AwBv6dE;EAAsC,gBAAA;AxB26dxC;;AwB36dE;EAAsC,gBAAA;AxB+6dxC;;AwB/6dE;EAAsC,gBAAA;AxBm7dxC;;AwBn7dE;EAAsC,gBAAA;AxBu7dxC;;AwBv7dE;EAAsC,gBAAA;AxB27dxC;;AwB37dE;EAAsC,gBAAA;AxB+7dxC;;AwB/7dE;EAAsC,gBAAA;AxBm8dxC;;AwBn8dE;EAAsC,gBAAA;AxBu8dxC;;AwBv8dE;EAAsC,gBAAA;AxB28dxC;;AwB38dE;EAAsC,gBAAA;AxB+8dxC;;AwB/8dE;EAAsC,gBAAA;AxBm9dxC;;AwBn9dE;EAAsC,gBAAA;AxBu9dxC;;AwBv9dE;EAAsC,gBAAA;AxB29dxC;;AwB39dE;EAAsC,gBAAA;AxB+9dxC;;AwB/9dE;EAAsC,gBAAA;AxBm+dxC;;AwBn+dE;EAAsC,gBAAA;AxBu+dxC;;AwBv+dE;EAAsC,gBAAA;AxB2+dxC;;AwB3+dE;EAAsC,gBAAA;AxB++dxC;;AwB/+dE;EAAsC,gBAAA;AxBm/dxC;;AwBn/dE;EAAsC,gBAAA;AxBu/dxC;;AwBv/dE;EAAsC,gBAAA;AxB2/dxC;;AwB3/dE;EAAsC,gBAAA;AxB+/dxC;;AwB//dE;EAAsC,gBAAA;AxBmgexC;;AwBngeE;EAAsC,gBAAA;AxBugexC;;AwBvgeE;EAAsC,gBAAA;AxB2gexC;;AwB3geE;EAAsC,gBAAA;AxB+gexC;;AwB/geE;EAAsC,gBAAA;AxBmhexC;;AwBnheE;EAAsC,gBAAA;AxBuhexC;;AwBvheE;EAAsC,gBAAA;AxB2hexC;;AwB3heE;EAAsC,gBAAA;AxB+hexC;;AwB/heE;EAAsC,gBAAA;AxBmiexC;;AwBnieE;EAAsC,gBAAA;AxBuiexC;;AwBvieE;EAAsC,gBAAA;AxB2iexC;;AwB3ieE;EAAsC,gBAAA;AxB+iexC;;AwB/ieE;EAAsC,gBAAA;AxBmjexC;;AwBnjeE;EAAsC,gBAAA;AxBujexC;;AwBvjeE;EAAsC,gBAAA;AxB2jexC;;AwB3jeE;EAAsC,YAAA;AxB+jexC;;AwB/jeE;EAAsC,gBAAA;AxBmkexC;;AwBnkeE;EAAsC,gBAAA;AxBukexC;;AwBvkeE;EAAsC,gBAAA;AxB2kexC;;AwB3keE;EAAsC,gBAAA;AxB+kexC;;AwB/keE;EAAsC,gBAAA;AxBmlexC;;AwBnleE;EAAsC,gBAAA;AxBulexC;;AwBvleE;EAAsC,gBAAA;AxB2lexC;;AwB3leE;EAAsC,gBAAA;AxB+lexC;;AwB/leE;EAAsC,gBAAA;AxBmmexC;;AwBnmeE;EAAsC,gBAAA;AxBumexC;;AwBvmeE;EAAsC,gBAAA;AxB2mexC;;AwB3meE;EAAsC,gBAAA;AxB+mexC;;AwB/meE;EAAsC,gBAAA;AxBmnexC;;AwBnneE;EAAsC,gBAAA;AxBunexC;;AwBvneE;EAAsC,gBAAA;AxB2nexC;;AwB3neE;EAAsC,gBAAA;AxB+nexC;;AwB/neE;EAAsC,gBAAA;AxBmoexC;;AwBnoeE;EAAsC,gBAAA;AxBuoexC;;AwBvoeE;EAAsC,gBAAA;AxB2oexC;;AwB3oeE;EAAsC,gBAAA;AxB+oexC;;AwB/oeE;EAAsC,gBAAA;AxBmpexC;;AwBnpeE;EAAsC,gBAAA;AxBupexC;;AwBvpeE;EAAsC,gBAAA;AxB2pexC;;AwB3peE;EAAsC,gBAAA;AxB+pexC;;AwB/peE;EAAsC,gBAAA;AxBmqexC;;AwBnqeE;EAAsC,gBAAA;AxBuqexC;;AwBvqeE;EAAsC,gBAAA;AxB2qexC;;AwB3qeE;EAAsC,gBAAA;AxB+qexC;;AwB/qeE;EAAsC,gBAAA;AxBmrexC;;AwBnreE;EAAsC,gBAAA;AxBurexC;;AwBvreE;EAAsC,gBAAA;AxB2rexC;;AwB3reE;EAAsC,gBAAA;AxB+rexC;;AwB/reE;EAAsC,gBAAA;AxBmsexC;;AwBnseE;EAAsC,gBAAA;AxBusexC;;AwBvseE;EAAsC,gBAAA;AxB2sexC;;AwB3seE;EAAsC,gBAAA;AxB+sexC;;AwB/seE;EAAsC,gBAAA;AxBmtexC;;AwBnteE;EAAsC,gBAAA;AxButexC;;AwBvteE;EAAsC,gBAAA;AxB2texC;;AwB3teE;EAAsC,gBAAA;AxB+texC;;AwB/teE;EAAsC,gBAAA;AxBmuexC;;AwBnueE;EAAsC,gBAAA;AxBuuexC;;AwBvueE;EAAsC,gBAAA;AxB2uexC;;AwB3ueE;EAAsC,gBAAA;AxB+uexC;;AwB/ueE;EAAsC,gBAAA;AxBmvexC;;AwBnveE;EAAsC,gBAAA;AxBuvexC;;AwBvveE;EAAsC,gBAAA;AxB2vexC;;AwB3veE;EAAsC,gBAAA;AxB+vexC;;AwB/veE;EAAsC,gBAAA;AxBmwexC;;AwBnweE;EAAsC,gBAAA;AxBuwexC;;AwBvweE;EAAsC,gBAAA;AxB2wexC;;AwB3weE;EAAsC,gBAAA;AxB+wexC;;AwB/weE;EAAsC,gBAAA;AxBmxexC;;AwBnxeE;EAAsC,gBAAA;AxBuxexC;;AwBvxeE;EAAsC,gBAAA;AxB2xexC;;AwB3xeE;EAAsC,gBAAA;AxB+xexC;;AwB/xeE;EAAsC,gBAAA;AxBmyexC;;AwBnyeE;EAAsC,gBAAA;AxBuyexC;;AwBvyeE;EAAsC,gBAAA;AxB2yexC;;AwB3yeE;EAAsC,gBAAA;AxB+yexC;;AwB/yeE;EAAsC,gBAAA;AxBmzexC;;AwBnzeE;EAAsC,gBAAA;AxBuzexC;;AwBvzeE;EAAsC,gBAAA;AxB2zexC;;AwB3zeE;EAAsC,gBAAA;AxB+zexC;;AwB/zeE;EAAsC,gBAAA;AxBm0exC;;AwBn0eE;EAAsC,gBAAA;AxBu0exC;;AwBv0eE;EAAsC,gBAAA;AxB20exC;;AwB30eE;EAAsC,gBAAA;AxB+0exC;;AwB/0eE;EAAsC,gBAAA;AxBm1exC;;AwBn1eE;EAAsC,gBAAA;AxBu1exC;;AwBv1eE;EAAsC,gBAAA;AxB21exC;;AwB31eE;EAAsC,gBAAA;AxB+1exC;;AwB/1eE;EAAsC,gBAAA;AxBm2exC;;AwBn2eE;EAAsC,gBAAA;AxBu2exC;;AwBv2eE;EAAsC,gBAAA;AxB22exC;;AwB32eE;EAAsC,gBAAA;AxB+2exC;;AwB/2eE;EAAsC,gBAAA;AxBm3exC;;AwBn3eE;EAAsC,gBAAA;AxBu3exC;;AwBv3eE;EAAsC,gBAAA;AxB23exC;;AwB33eE;EAAsC,gBAAA;AxB+3exC;;AwB/3eE;EAAsC,gBAAA;AxBm4exC;;AwBn4eE;EAAsC,gBAAA;AxBu4exC;;AwBv4eE;EAAsC,gBAAA;AxB24exC;;AwB34eE;EAAsC,gBAAA;AxB+4exC;;AwB/4eE;EAAsC,gBAAA;AxBm5exC;;AwBn5eE;EAAsC,gBAAA;AxBu5exC;;AwBv5eE;EAAsC,gBAAA;AxB25exC;;AwB35eE;EAAsC,gBAAA;AxB+5exC;;AwB/5eE;EAAsC,gBAAA;AxBm6exC;;AwBn6eE;EAAsC,gBAAA;AxBu6exC;;AwBv6eE;EAAsC,gBAAA;AxB26exC;;AwB36eE;EAAsC,gBAAA;AxB+6exC;;AwB/6eE;EAAsC,gBAAA;AxBm7exC;;AwBn7eE;EAAsC,gBAAA;AxBu7exC;;AwBv7eE;EAAsC,gBAAA;AxB27exC;;AwB37eE;EAAsC,gBAAA;AxB+7exC;;AwB/7eE;EAAsC,gBAAA;AxBm8exC;;AwBn8eE;EAAsC,gBAAA;AxBu8exC;;AwBv8eE;EAAsC,gBAAA;AxB28exC;;AwB38eE;EAAsC,gBAAA;AxB+8exC;;AwB/8eE;EAAsC,gBAAA;AxBm9exC;;AwBn9eE;EAAsC,gBAAA;AxBu9exC;;AwBv9eE;EAAsC,gBAAA;AxB29exC;;AwB39eE;EAAsC,gBAAA;AxB+9exC;;AwB/9eE;EAAsC,gBAAA;AxBm+exC;;AwBn+eE;EAAsC,gBAAA;AxBu+exC;;AwBv+eE;EAAsC,gBAAA;AxB2+exC;;AwB3+eE;EAAsC,gBAAA;AxB++exC;;AwB/+eE;EAAsC,gBAAA;AxBm/exC;;AwBn/eE;EAAsC,gBAAA;AxBu/exC;;AwBv/eE;EAAsC,gBAAA;AxB2/exC;;AwB3/eE;EAAsC,gBAAA;AxB+/exC;;AwB//eE;EAAsC,gBAAA;AxBmgfxC;;AwBngfE;EAAsC,gBAAA;AxBugfxC;;AwBvgfE;EAAsC,gBAAA;AxB2gfxC;;AwB3gfE;EAAsC,YAAA;AxB+gfxC;;AwB/gfE;EAAsC,gBAAA;AxBmhfxC;;AwBnhfE;EAAsC,gBAAA;AxBuhfxC;;AwBvhfE;EAAsC,gBAAA;AxB2hfxC;;AwB3hfE;EAAsC,gBAAA;AxB+hfxC;;AwB/hfE;EAAsC,gBAAA;AxBmifxC;;AwBnifE;EAAsC,gBAAA;AxBuifxC;;AwBvifE;EAAsC,gBAAA;AxB2ifxC;;AwB3ifE;EAAsC,gBAAA;AxB+ifxC;;AwB/ifE;EAAsC,gBAAA;AxBmjfxC;;AwBnjfE;EAAsC,gBAAA;AxBujfxC;;AwBvjfE;EAAsC,gBAAA;AxB2jfxC;;AwB3jfE;EAAsC,gBAAA;AxB+jfxC;;AwB/jfE;EAAsC,gBAAA;AxBmkfxC;;AwBnkfE;EAAsC,gBAAA;AxBukfxC;;AwBvkfE;EAAsC,gBAAA;AxB2kfxC;;AwB3kfE;EAAsC,gBAAA;AxB+kfxC;;AwB/kfE;EAAsC,gBAAA;AxBmlfxC;;AwBnlfE;EAAsC,gBAAA;AxBulfxC;;AwBvlfE;EAAsC,gBAAA;AxB2lfxC;;AwB3lfE;EAAsC,gBAAA;AxB+lfxC;;AwB/lfE;EAAsC,gBAAA;AxBmmfxC;;AwBnmfE;EAAsC,gBAAA;AxBumfxC;;AwBvmfE;EAAsC,gBAAA;AxB2mfxC;;AwB3mfE;EAAsC,gBAAA;AxB+mfxC;;AwB/mfE;EAAsC,gBAAA;AxBmnfxC;;AwBnnfE;EAAsC,gBAAA;AxBunfxC;;AwBvnfE;EAAsC,gBAAA;AxB2nfxC;;AwB3nfE;EAAsC,gBAAA;AxB+nfxC;;AwB/nfE;EAAsC,gBAAA;AxBmofxC;;AwBnofE;EAAsC,gBAAA;AxBuofxC;;AwBvofE;EAAsC,gBAAA;AxB2ofxC;;AwB3ofE;EAAsC,gBAAA;AxB+ofxC;;AwB/ofE;EAAsC,gBAAA;AxBmpfxC;;AwBnpfE;EAAsC,gBAAA;AxBupfxC;;AwBvpfE;EAAsC,gBAAA;AxB2pfxC;;AwB3pfE;EAAsC,gBAAA;AxB+pfxC;;AwB/pfE;EAAsC,gBAAA;AxBmqfxC;;AwBnqfE;EAAsC,gBAAA;AxBuqfxC;;AwBvqfE;EAAsC,gBAAA;AxB2qfxC;;AwB3qfE;EAAsC,gBAAA;AxB+qfxC;;AwB/qfE;EAAsC,gBAAA;AxBmrfxC;;AwBnrfE;EAAsC,gBAAA;AxBurfxC;;AwBvrfE;EAAsC,gBAAA;AxB2rfxC;;AwB3rfE;EAAsC,gBAAA;AxB+rfxC;;AwB/rfE;EAAsC,YAAA;AxBmsfxC;;AwBnsfE;EAAsC,gBAAA;AxBusfxC;;AwBvsfE;EAAsC,gBAAA;AxB2sfxC;;AwB3sfE;EAAsC,gBAAA;AxB+sfxC;;AwB/sfE;EAAsC,gBAAA;AxBmtfxC;;AwBntfE;EAAsC,gBAAA;AxButfxC;;AwBvtfE;EAAsC,gBAAA;AxB2tfxC;;AwB3tfE;EAAsC,gBAAA;AxB+tfxC;;AwB/tfE;EAAsC,gBAAA;AxBmufxC;;AwBnufE;EAAsC,gBAAA;AxBuufxC;;AwBvufE;EAAsC,gBAAA;AxB2ufxC;;AwB3ufE;EAAsC,gBAAA;AxB+ufxC;;AwB/ufE;EAAsC,gBAAA;AxBmvfxC;;AwBnvfE;EAAsC,gBAAA;AxBuvfxC;;AwBvvfE;EAAsC,gBAAA;AxB2vfxC;;AwB3vfE;EAAsC,gBAAA;AxB+vfxC;;AwB/vfE;EAAsC,gBAAA;AxBmwfxC;;AwBnwfE;EAAsC,gBAAA;AxBuwfxC;;AwBvwfE;EAAsC,gBAAA;AxB2wfxC;;AwB3wfE;EAAsC,gBAAA;AxB+wfxC;;AwB/wfE;EAAsC,gBAAA;AxBmxfxC;;AwBnxfE;EAAsC,gBAAA;AxBuxfxC;;AwBvxfE;EAAsC,gBAAA;AxB2xfxC;;AwB3xfE;EAAsC,gBAAA;AxB+xfxC;;AwB/xfE;EAAsC,gBAAA;AxBmyfxC;;AwBnyfE;EAAsC,gBAAA;AxBuyfxC;;AwBvyfE;EAAsC,gBAAA;AxB2yfxC;;AwB3yfE;EAAsC,gBAAA;AxB+yfxC;;AwB/yfE;EAAsC,gBAAA;AxBmzfxC;;AwBnzfE;EAAsC,gBAAA;AxBuzfxC;;AwBvzfE;EAAsC,gBAAA;AxB2zfxC;;AwB3zfE;EAAsC,gBAAA;AxB+zfxC;;AwB/zfE;EAAsC,gBAAA;AxBm0fxC;;AwBn0fE;EAAsC,gBAAA;AxBu0fxC;;AwBv0fE;EAAsC,gBAAA;AxB20fxC;;AwB30fE;EAAsC,gBAAA;AxB+0fxC;;AwB/0fE;EAAsC,gBAAA;AxBm1fxC;;AwBn1fE;EAAsC,gBAAA;AxBu1fxC;;AwBv1fE;EAAsC,gBAAA;AxB21fxC;;AwB31fE;EAAsC,gBAAA;AxB+1fxC;;AwB/1fE;EAAsC,gBAAA;AxBm2fxC;;AwBn2fE;EAAsC,gBAAA;AxBu2fxC;;AwBv2fE;EAAsC,gBAAA;AxB22fxC;;AwB32fE;EAAsC,gBAAA;AxB+2fxC;;AwB/2fE;EAAsC,gBAAA;AxBm3fxC;;AwBn3fE;EAAsC,gBAAA;AxBu3fxC;;AwBv3fE;EAAsC,gBAAA;AxB23fxC;;AwB33fE;EAAsC,gBAAA;AxB+3fxC;;AwB/3fE;EAAsC,gBAAA;AxBm4fxC;;AwBn4fE;EAAsC,gBAAA;AxBu4fxC;;AwBv4fE;EAAsC,gBAAA;AxB24fxC;;AwB34fE;EAAsC,gBAAA;AxB+4fxC;;AwB/4fE;EAAsC,gBAAA;AxBm5fxC;;AwBn5fE;EAAsC,gBAAA;AxBu5fxC;;AwBv5fE;EAAsC,gBAAA;AxB25fxC;;AwB35fE;EAAsC,gBAAA;AxB+5fxC;;AwB/5fE;EAAsC,gBAAA;AxBm6fxC;;AwBn6fE;EAAsC,gBAAA;AxBu6fxC;;AwBv6fE;EAAsC,gBAAA;AxB26fxC;;AwB36fE;EAAsC,gBAAA;AxB+6fxC;;AwB/6fE;EAAsC,gBAAA;AxBm7fxC;;AwBn7fE;EAAsC,gBAAA;AxBu7fxC;;AwBv7fE;EAAsC,gBAAA;AxB27fxC;;AwB37fE;EAAsC,gBAAA;AxB+7fxC;;AwB/7fE;EAAsC,gBAAA;AxBm8fxC;;AwBn8fE;EAAsC,gBAAA;AxBu8fxC;;AwBv8fE;EAAsC,gBAAA;AxB28fxC;;AwB38fE;EAAsC,gBAAA;AxB+8fxC;;AwB/8fE;EAAsC,gBAAA;AxBm9fxC;;AwBn9fE;EAAsC,gBAAA;AxBu9fxC;;AwBv9fE;EAAsC,gBAAA;AxB29fxC;;AwB39fE;EAAsC,gBAAA;AxB+9fxC;;AwB/9fE;EAAsC,gBAAA;AxBm+fxC;;AwBn+fE;EAAsC,gBAAA;AxBu+fxC;;AwBv+fE;EAAsC,gBAAA;AxB2+fxC;;AwB3+fE;EAAsC,gBAAA;AxB++fxC;;AwB/+fE;EAAsC,gBAAA;AxBm/fxC;;AwBn/fE;EAAsC,gBAAA;AxBu/fxC;;AwBv/fE;EAAsC,gBAAA;AxB2/fxC;;AwB3/fE;EAAsC,gBAAA;AxB+/fxC;;AwB//fE;EAAsC,gBAAA;AxBmggBxC;;AwBnggBE;EAAsC,gBAAA;AxBuggBxC;;AwBvggBE;EAAsC,gBAAA;AxB2ggBxC;;AwB3ggBE;EAAsC,gBAAA;AxB+ggBxC;;AwB/ggBE;EAAsC,gBAAA;AxBmhgBxC;;AwBnhgBE;EAAsC,gBAAA;AxBuhgBxC;;AwBvhgBE;EAAsC,gBAAA;AxB2hgBxC;;AwB3hgBE;EAAsC,gBAAA;AxB+hgBxC;;AwB/hgBE;EAAsC,gBAAA;AxBmigBxC;;AwBnigBE;EAAsC,YAAA;AxBuigBxC;;AwBvigBE;EAAsC,gBAAA;AxB2igBxC;;AwB3igBE;EAAsC,gBAAA;AxB+igBxC;;AwB/igBE;EAAsC,gBAAA;AxBmjgBxC;;AwBnjgBE;EAAsC,gBAAA;AxBujgBxC;;AwBvjgBE;EAAsC,gBAAA;AxB2jgBxC;;AwB3jgBE;EAAsC,gBAAA;AxB+jgBxC;;AwB/jgBE;EAAsC,gBAAA;AxBmkgBxC;;AwBnkgBE;EAAsC,gBAAA;AxBukgBxC;;AwBvkgBE;EAAsC,gBAAA;AxB2kgBxC;;AwB3kgBE;EAAsC,YAAA;AxB+kgBxC;;AwB/kgBE;EAAsC,gBAAA;AxBmlgBxC;;AwBnlgBE;EAAsC,gBAAA;AxBulgBxC;;AwBvlgBE;EAAsC,gBAAA;AxB2lgBxC;;AwB3lgBE;EAAsC,gBAAA;AxB+lgBxC;;AwB/lgBE;EAAsC,gBAAA;AxBmmgBxC;;AwBnmgBE;EAAsC,gBAAA;AxBumgBxC;;AwBvmgBE;EAAsC,YAAA;AxB2mgBxC;;AyB9mgBA;;ETqBE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AhB8lgBF;;AgBzlgBE;;EAbA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AhB2mgBF;;A0B5ogBA;;;EAAA;AAOA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBRoCwB;EQnCxB,wHAAA;A1B4ogBF;A0BxogBA;;EAEE,oCAAA;EACA,gBAAA;A1B0ogBF;;A0BtogBE;EAAqC,gBAAA;A1B0ogBvC;;A0B1ogBE;EAAqC,gBAAA;A1B8ogBvC;;A0B9ogBE;EAAqC,gBAAA;A1BkpgBvC;;A0BlpgBE;EAAqC,gBAAA;A1BspgBvC;;A0BtpgBE;EAAqC,gBAAA;A1B0pgBvC;;A0B1pgBE;EAAqC,gBAAA;A1B8pgBvC;;A0B9pgBE;EAAqC,gBAAA;A1BkqgBvC;;A0BlqgBE;EAAqC,gBAAA;A1BsqgBvC;;A0BtqgBE;EAAqC,gBAAA;A1B0qgBvC;;A0B1qgBE;EAAqC,gBAAA;A1B8qgBvC;;A0B9qgBE;EAAqC,gBAAA;A1BkrgBvC;;A0BlrgBE;EAAqC,gBAAA;A1BsrgBvC;;A0BtrgBE;EAAqC,gBAAA;A1B0rgBvC;;A0B1rgBE;EAAqC,gBAAA;A1B8rgBvC;;A0B9rgBE;EAAqC,gBAAA;A1BksgBvC;;A0BlsgBE;EAAqC,gBAAA;A1BssgBvC;;A0BtsgBE;EAAqC,gBAAA;A1B0sgBvC;;A0B1sgBE;EAAqC,gBAAA;A1B8sgBvC;;A0B9sgBE;EAAqC,gBAAA;A1BktgBvC;;A0BltgBE;EAAqC,gBAAA;A1BstgBvC;;A0BttgBE;EAAqC,gBAAA;A1B0tgBvC;;A0B1tgBE;EAAqC,gBAAA;A1B8tgBvC;;A0B9tgBE;EAAqC,gBAAA;A1BkugBvC;;A0BlugBE;EAAqC,gBAAA;A1BsugBvC;;A0BtugBE;EAAqC,gBAAA;A1B0ugBvC;;A0B1ugBE;EAAqC,gBAAA;A1B8ugBvC;;A0B9ugBE;EAAqC,gBAAA;A1BkvgBvC;;A0BlvgBE;EAAqC,gBAAA;A1BsvgBvC;;A0BtvgBE;EAAqC,gBAAA;A1B0vgBvC;;A0B1vgBE;EAAqC,gBAAA;A1B8vgBvC;;A0B9vgBE;EAAqC,gBAAA;A1BkwgBvC;;A0BlwgBE;EAAqC,gBAAA;A1BswgBvC;;A0BtwgBE;EAAqC,gBAAA;A1B0wgBvC;;A0B1wgBE;EAAqC,gBAAA;A1B8wgBvC;;A0B9wgBE;EAAqC,gBAAA;A1BkxgBvC;;A0BlxgBE;EAAqC,gBAAA;A1BsxgBvC;;A0BtxgBE;EAAqC,gBAAA;A1B0xgBvC;;A0B1xgBE;EAAqC,gBAAA;A1B8xgBvC;;A0B9xgBE;EAAqC,gBAAA;A1BkygBvC;;A0BlygBE;EAAqC,gBAAA;A1BsygBvC;;A0BtygBE;EAAqC,gBAAA;A1B0ygBvC;;A0B1ygBE;EAAqC,gBAAA;A1B8ygBvC;;A0B9ygBE;EAAqC,gBAAA;A1BkzgBvC;;A0BlzgBE;EAAqC,gBAAA;A1BszgBvC;;A0BtzgBE;EAAqC,gBAAA;A1B0zgBvC;;A0B1zgBE;EAAqC,gBAAA;A1B8zgBvC;;A0B9zgBE;EAAqC,gBAAA;A1Bk0gBvC;;A0Bl0gBE;EAAqC,gBAAA;A1Bs0gBvC;;A0Bt0gBE;EAAqC,gBAAA;A1B00gBvC;;A0B10gBE;EAAqC,gBAAA;A1B80gBvC;;A0B90gBE;EAAqC,gBAAA;A1Bk1gBvC;;A0Bl1gBE;EAAqC,gBAAA;A1Bs1gBvC;;A0Bt1gBE;EAAqC,gBAAA;A1B01gBvC;;A0B11gBE;EAAqC,gBAAA;A1B81gBvC;;A0B91gBE;EAAqC,gBAAA;A1Bk2gBvC;;A0Bl2gBE;EAAqC,gBAAA;A1Bs2gBvC;;A0Bt2gBE;EAAqC,gBAAA;A1B02gBvC;;A0B12gBE;EAAqC,gBAAA;A1B82gBvC;;A0B92gBE;EAAqC,gBAAA;A1Bk3gBvC;;A0Bl3gBE;EAAqC,gBAAA;A1Bs3gBvC;;A0Bt3gBE;EAAqC,gBAAA;A1B03gBvC;;A0B13gBE;EAAqC,gBAAA;A1B83gBvC;;A0B93gBE;EAAqC,gBAAA;A1Bk4gBvC;;A0Bl4gBE;EAAqC,gBAAA;A1Bs4gBvC;;A0Bt4gBE;EAAqC,gBAAA;A1B04gBvC;;A0B14gBE;EAAqC,gBAAA;A1B84gBvC;;A0B94gBE;EAAqC,gBAAA;A1Bk5gBvC;;A0Bl5gBE;EAAqC,gBAAA;A1Bs5gBvC;;A0Bt5gBE;EAAqC,gBAAA;A1B05gBvC;;A0B15gBE;EAAqC,gBAAA;A1B85gBvC;;A0B95gBE;EAAqC,gBAAA;A1Bk6gBvC;;A0Bl6gBE;EAAqC,gBAAA;A1Bs6gBvC;;A0Bt6gBE;EAAqC,gBAAA;A1B06gBvC;;A0B16gBE;EAAqC,gBAAA;A1B86gBvC;;A0B96gBE;EAAqC,gBAAA;A1Bk7gBvC;;A0Bl7gBE;EAAqC,gBAAA;A1Bs7gBvC;;A0Bt7gBE;EAAqC,gBAAA;A1B07gBvC;;A0B17gBE;EAAqC,gBAAA;A1B87gBvC;;A0B97gBE;EAAqC,gBAAA;A1Bk8gBvC;;A0Bl8gBE;EAAqC,gBAAA;A1Bs8gBvC;;A0Bt8gBE;EAAqC,gBAAA;A1B08gBvC;;A0B18gBE;EAAqC,gBAAA;A1B88gBvC;;A0B98gBE;EAAqC,gBAAA;A1Bk9gBvC;;A0Bl9gBE;EAAqC,gBAAA;A1Bs9gBvC;;A0Bt9gBE;EAAqC,gBAAA;A1B09gBvC;;A0B19gBE;EAAqC,gBAAA;A1B89gBvC;;A0B99gBE;EAAqC,gBAAA;A1Bk+gBvC;;A0Bl+gBE;EAAqC,gBAAA;A1Bs+gBvC;;A0Bt+gBE;EAAqC,gBAAA;A1B0+gBvC;;A0B1+gBE;EAAqC,gBAAA;A1B8+gBvC;;A0B9+gBE;EAAqC,gBAAA;A1Bk/gBvC;;A0Bl/gBE;EAAqC,gBAAA;A1Bs/gBvC;;A0Bt/gBE;EAAqC,gBAAA;A1B0/gBvC;;A0B1/gBE;EAAqC,gBAAA;A1B8/gBvC;;A0B9/gBE;EAAqC,gBAAA;A1BkghBvC;;A0BlghBE;EAAqC,gBAAA;A1BsghBvC;;A0BtghBE;EAAqC,gBAAA;A1B0ghBvC;;A0B1ghBE;EAAqC,gBAAA;A1B8ghBvC;;A0B9ghBE;EAAqC,gBAAA;A1BkhhBvC;;A0BlhhBE;EAAqC,gBAAA;A1BshhBvC;;A0BthhBE;EAAqC,gBAAA;A1B0hhBvC;;A0B1hhBE;EAAqC,gBAAA;A1B8hhBvC;;A0B9hhBE;EAAqC,gBAAA;A1BkihBvC;;A0BlihBE;EAAqC,gBAAA;A1BsihBvC;;A0BtihBE;EAAqC,gBAAA;A1B0ihBvC;;A0B1ihBE;EAAqC,gBAAA;A1B8ihBvC;;A0B9ihBE;EAAqC,gBAAA;A1BkjhBvC;;A0BljhBE;EAAqC,gBAAA;A1BsjhBvC;;A0BtjhBE;EAAqC,gBAAA;A1B0jhBvC;;A0B1jhBE;EAAqC,gBAAA;A1B8jhBvC;;A0B9jhBE;EAAqC,gBAAA;A1BkkhBvC;;A0BlkhBE;EAAqC,gBAAA;A1BskhBvC;;A0BtkhBE;EAAqC,gBAAA;A1B0khBvC;;A0B1khBE;EAAqC,gBAAA;A1B8khBvC;;A0B9khBE;EAAqC,gBAAA;A1BklhBvC;;A0BllhBE;EAAqC,gBAAA;A1BslhBvC;;A0BtlhBE;EAAqC,gBAAA;A1B0lhBvC;;A0B1lhBE;EAAqC,gBAAA;A1B8lhBvC;;A0B9lhBE;EAAqC,gBAAA;A1BkmhBvC;;A0BlmhBE;EAAqC,gBAAA;A1BsmhBvC;;A0BtmhBE;EAAqC,gBAAA;A1B0mhBvC;;A0B1mhBE;EAAqC,gBAAA;A1B8mhBvC;;A0B9mhBE;EAAqC,gBAAA;A1BknhBvC;;A0BlnhBE;EAAqC,gBAAA;A1BsnhBvC;;A0BtnhBE;EAAqC,gBAAA;A1B0nhBvC;;A0B1nhBE;EAAqC,gBAAA;A1B8nhBvC;;A0B9nhBE;EAAqC,gBAAA;A1BkohBvC;;A0BlohBE;EAAqC,gBAAA;A1BsohBvC;;A0BtohBE;EAAqC,gBAAA;A1B0ohBvC;;A0B1ohBE;EAAqC,gBAAA;A1B8ohBvC;;A0B9ohBE;EAAqC,gBAAA;A1BkphBvC;;A0BlphBE;EAAqC,gBAAA;A1BsphBvC;;A0BtphBE;EAAqC,gBAAA;A1B0phBvC;;A0B1phBE;EAAqC,gBAAA;A1B8phBvC;;A0B9phBE;EAAqC,gBAAA;A1BkqhBvC;;A0BlqhBE;EAAqC,gBAAA;A1BsqhBvC;;A0BtqhBE;EAAqC,gBAAA;A1B0qhBvC;;A0B1qhBE;EAAqC,gBAAA;A1B8qhBvC;;A0B9qhBE;EAAqC,gBAAA;A1BkrhBvC;;A0BlrhBE;EAAqC,gBAAA;A1BsrhBvC;;A0BtrhBE;EAAqC,gBAAA;A1B0rhBvC;;A0B1rhBE;EAAqC,gBAAA;A1B8rhBvC;;A0B9rhBE;EAAqC,gBAAA;A1BkshBvC;;A0BlshBE;EAAqC,gBAAA;A1BsshBvC;;A0BtshBE;EAAqC,gBAAA;A1B0shBvC;;A0B1shBE;EAAqC,gBAAA;A1B8shBvC;;A0B9shBE;EAAqC,gBAAA;A1BkthBvC;;A0BlthBE;EAAqC,gBAAA;A1BsthBvC;;A0BtthBE;EAAqC,gBAAA;A1B0thBvC;;A0B1thBE;EAAqC,gBAAA;A1B8thBvC;;A0B9thBE;EAAqC,gBAAA;A1BkuhBvC;;A0BluhBE;EAAqC,gBAAA;A1BsuhBvC;;A0BtuhBE;EAAqC,gBAAA;A1B0uhBvC;;A0B1uhBE;EAAqC,gBAAA;A1B8uhBvC;;A0B9uhBE;EAAqC,gBAAA;A1BkvhBvC;;A0BlvhBE;EAAqC,gBAAA;A1BsvhBvC;;A0BtvhBE;EAAqC,gBAAA;A1B0vhBvC;;A0B1vhBE;EAAqC,gBAAA;A1B8vhBvC;;A0B9vhBE;EAAqC,gBAAA;A1BkwhBvC;;A0BlwhBE;EAAqC,gBAAA;A1BswhBvC;;A0BtwhBE;EAAqC,gBAAA;A1B0whBvC;;A0B1whBE;EAAqC,gBAAA;A1B8whBvC;;A0B9whBE;EAAqC,gBAAA;A1BkxhBvC;;A0BlxhBE;EAAqC,gBAAA;A1BsxhBvC;;A0BtxhBE;EAAqC,gBAAA;A1B0xhBvC;;A0B1xhBE;EAAqC,gBAAA;A1B8xhBvC;;A0B9xhBE;EAAqC,gBAAA;A1BkyhBvC;;A0BlyhBE;EAAqC,gBAAA;A1BsyhBvC;;A0BtyhBE;EAAqC,gBAAA;A1B0yhBvC;;A0B1yhBE;EAAqC,gBAAA;A1B8yhBvC;;A0B9yhBE;EAAqC,gBAAA;A1BkzhBvC;;A0BlzhBE;EAAqC,gBAAA;A1BszhBvC;;A0BtzhBE;EAAqC,gBAAA;A1B0zhBvC;;A0B1zhBE;EAAqC,gBAAA;A1B8zhBvC;;A0B9zhBE;EAAqC,gBAAA;A1Bk0hBvC;;A0Bl0hBE;EAAqC,gBAAA;A1Bs0hBvC;;A0Bt0hBE;EAAqC,gBAAA;A1B00hBvC;;A0B10hBE;EAAqC,gBAAA;A1B80hBvC;;A0B90hBE;EAAqC,gBAAA;A1Bk1hBvC;;A0Bl1hBE;EAAqC,gBAAA;A1Bs1hBvC;;A0Bt1hBE;EAAqC,gBAAA;A1B01hBvC;;A0B11hBE;EAAqC,gBAAA;A1B81hBvC;;A0B91hBE;EAAqC,gBAAA;A1Bk2hBvC;;A0Bl2hBE;EAAqC,gBAAA;A1Bs2hBvC;;A0Bt2hBE;EAAqC,gBAAA;A1B02hBvC;;A0B12hBE;EAAqC,gBAAA;A1B82hBvC;;A0B92hBE;EAAqC,gBAAA;A1Bk3hBvC;;A0Bl3hBE;EAAqC,gBAAA;A1Bs3hBvC;;A0Bt3hBE;EAAqC,gBAAA;A1B03hBvC;;A0B13hBE;EAAqC,gBAAA;A1B83hBvC;;A0B93hBE;EAAqC,gBAAA;A1Bk4hBvC;;A0Bl4hBE;EAAqC,gBAAA;A1Bs4hBvC;;A0Bt4hBE;EAAqC,gBAAA;A1B04hBvC;;A0B14hBE;EAAqC,gBAAA;A1B84hBvC;;A0B94hBE;EAAqC,gBAAA;A1Bk5hBvC;;A0Bl5hBE;EAAqC,gBAAA;A1Bs5hBvC;;A0Bt5hBE;EAAqC,gBAAA;A1B05hBvC;;A0B15hBE;EAAqC,gBAAA;A1B85hBvC;;A0B95hBE;EAAqC,gBAAA;A1Bk6hBvC;;A0Bl6hBE;EAAqC,gBAAA;A1Bs6hBvC;;A0Bt6hBE;EAAqC,gBAAA;A1B06hBvC;;A0B16hBE;EAAqC,gBAAA;A1B86hBvC;;A0B96hBE;EAAqC,gBAAA;A1Bk7hBvC;;A0Bl7hBE;EAAqC,gBAAA;A1Bs7hBvC;;A0Bt7hBE;EAAqC,gBAAA;A1B07hBvC;;A0B17hBE;EAAqC,gBAAA;A1B87hBvC;;A0B97hBE;EAAqC,gBAAA;A1Bk8hBvC;;A0Bl8hBE;EAAqC,gBAAA;A1Bs8hBvC;;A0Bt8hBE;EAAqC,gBAAA;A1B08hBvC;;A0B18hBE;EAAqC,gBAAA;A1B88hBvC;;A0B98hBE;EAAqC,gBAAA;A1Bk9hBvC;;A0Bl9hBE;EAAqC,gBAAA;A1Bs9hBvC;;A0Bt9hBE;EAAqC,gBAAA;A1B09hBvC;;A0B19hBE;EAAqC,gBAAA;A1B89hBvC;;A0B99hBE;EAAqC,gBAAA;A1Bk+hBvC;;A0Bl+hBE;EAAqC,gBAAA;A1Bs+hBvC;;A0Bt+hBE;EAAqC,gBAAA;A1B0+hBvC;;A0B1+hBE;EAAqC,gBAAA;A1B8+hBvC;;A0B9+hBE;EAAqC,gBAAA;A1Bk/hBvC;;A0Bl/hBE;EAAqC,gBAAA;A1Bs/hBvC;;A0Bt/hBE;EAAqC,gBAAA;A1B0/hBvC;;A0B1/hBE;EAAqC,gBAAA;A1B8/hBvC;;A0B9/hBE;EAAqC,gBAAA;A1BkgiBvC;;A0BlgiBE;EAAqC,gBAAA;A1BsgiBvC;;A0BtgiBE;EAAqC,gBAAA;A1B0giBvC;;A0B1giBE;EAAqC,gBAAA;A1B8giBvC;;A0B9giBE;EAAqC,gBAAA;A1BkhiBvC;;A0BlhiBE;EAAqC,gBAAA;A1BshiBvC;;A0BthiBE;EAAqC,gBAAA;A1B0hiBvC;;A0B1hiBE;EAAqC,gBAAA;A1B8hiBvC;;A0B9hiBE;EAAqC,gBAAA;A1BkiiBvC;;A0BliiBE;EAAqC,gBAAA;A1BsiiBvC;;A0BtiiBE;EAAqC,gBAAA;A1B0iiBvC;;A0B1iiBE;EAAqC,gBAAA;A1B8iiBvC;;A0B9iiBE;EAAqC,gBAAA;A1BkjiBvC;;A0BljiBE;EAAqC,gBAAA;A1BsjiBvC;;A0BtjiBE;EAAqC,gBAAA;A1B0jiBvC;;A0B1jiBE;EAAqC,gBAAA;A1B8jiBvC;;A0B9jiBE;EAAqC,gBAAA;A1BkkiBvC;;A0BlkiBE;EAAqC,gBAAA;A1BskiBvC;;A0BtkiBE;EAAqC,gBAAA;A1B0kiBvC;;A0B1kiBE;EAAqC,gBAAA;A1B8kiBvC;;A0B9kiBE;EAAqC,gBAAA;A1BkliBvC;;A0BlliBE;EAAqC,gBAAA;A1BsliBvC;;A0BtliBE;EAAqC,gBAAA;A1B0liBvC;;A0B1liBE;EAAqC,gBAAA;A1B8liBvC;;A0B9liBE;EAAqC,gBAAA;A1BkmiBvC;;A0BlmiBE;EAAqC,gBAAA;A1BsmiBvC;;A0BtmiBE;EAAqC,gBAAA;A1B0miBvC;;A0B1miBE;EAAqC,gBAAA;A1B8miBvC;;A0B9miBE;EAAqC,gBAAA;A1BkniBvC;;A0BlniBE;EAAqC,gBAAA;A1BsniBvC;;A0BtniBE;EAAqC,gBAAA;A1B0niBvC;;A0B1niBE;EAAqC,gBAAA;A1B8niBvC;;A0B9niBE;EAAqC,gBAAA;A1BkoiBvC;;A0BloiBE;EAAqC,gBAAA;A1BsoiBvC;;A0BtoiBE;EAAqC,gBAAA;A1B0oiBvC;;A0B1oiBE;EAAqC,gBAAA;A1B8oiBvC;;A0B9oiBE;EAAqC,gBAAA;A1BkpiBvC;;A0BlpiBE;EAAqC,gBAAA;A1BspiBvC;;A0BtpiBE;EAAqC,gBAAA;A1B0piBvC;;A0B1piBE;EAAqC,gBAAA;A1B8piBvC;;A0B9piBE;EAAqC,gBAAA;A1BkqiBvC;;A0BlqiBE;EAAqC,gBAAA;A1BsqiBvC;;A0BtqiBE;EAAqC,gBAAA;A1B0qiBvC;;A0B1qiBE;EAAqC,gBAAA;A1B8qiBvC;;A0B9qiBE;EAAqC,gBAAA;A1BkriBvC;;A0BlriBE;EAAqC,gBAAA;A1BsriBvC;;A0BtriBE;EAAqC,gBAAA;A1B0riBvC;;A0B1riBE;EAAqC,gBAAA;A1B8riBvC;;A0B9riBE;EAAqC,gBAAA;A1BksiBvC;;A0BlsiBE;EAAqC,gBAAA;A1BssiBvC;;A0BtsiBE;EAAqC,gBAAA;A1B0siBvC;;A0B1siBE;EAAqC,gBAAA;A1B8siBvC;;A0B9siBE;EAAqC,gBAAA;A1BktiBvC;;A0BltiBE;EAAqC,gBAAA;A1BstiBvC;;A0BttiBE;EAAqC,gBAAA;A1B0tiBvC;;A0B1tiBE;EAAqC,gBAAA;A1B8tiBvC;;A0B9tiBE;EAAqC,gBAAA;A1BkuiBvC;;A0BluiBE;EAAqC,gBAAA;A1BsuiBvC;;A0BtuiBE;EAAqC,gBAAA;A1B0uiBvC;;A0B1uiBE;EAAqC,gBAAA;A1B8uiBvC;;A0B9uiBE;EAAqC,gBAAA;A1BkviBvC;;A0BlviBE;EAAqC,gBAAA;A1BsviBvC;;A0BtviBE;EAAqC,gBAAA;A1B0viBvC;;A0B1viBE;EAAqC,gBAAA;A1B8viBvC;;A0B9viBE;EAAqC,gBAAA;A1BkwiBvC;;A0BlwiBE;EAAqC,gBAAA;A1BswiBvC;;A0BtwiBE;EAAqC,gBAAA;A1B0wiBvC;;A0B1wiBE;EAAqC,gBAAA;A1B8wiBvC;;A0B9wiBE;EAAqC,gBAAA;A1BkxiBvC;;A0BlxiBE;EAAqC,gBAAA;A1BsxiBvC;;A0BtxiBE;EAAqC,gBAAA;A1B0xiBvC;;A0B1xiBE;EAAqC,gBAAA;A1B8xiBvC;;A0B9xiBE;EAAqC,gBAAA;A1BkyiBvC;;A0BlyiBE;EAAqC,gBAAA;A1BsyiBvC;;A0BtyiBE;EAAqC,gBAAA;A1B0yiBvC;;A0B1yiBE;EAAqC,gBAAA;A1B8yiBvC;;A0B9yiBE;EAAqC,gBAAA;A1BkziBvC;;A0BlziBE;EAAqC,gBAAA;A1BsziBvC;;A0BtziBE;EAAqC,gBAAA;A1B0ziBvC;;A0B1ziBE;EAAqC,gBAAA;A1B8ziBvC;;A0B9ziBE;EAAqC,gBAAA;A1Bk0iBvC;;A0Bl0iBE;EAAqC,gBAAA;A1Bs0iBvC;;A0Bt0iBE;EAAqC,gBAAA;A1B00iBvC;;A0B10iBE;EAAqC,gBAAA;A1B80iBvC;;A0B90iBE;EAAqC,gBAAA;A1Bk1iBvC;;A0Bl1iBE;EAAqC,gBAAA;A1Bs1iBvC;;A0Bt1iBE;EAAqC,gBAAA;A1B01iBvC;;A0B11iBE;EAAqC,gBAAA;A1B81iBvC;;A0B91iBE;EAAqC,gBAAA;A1Bk2iBvC;;A0Bl2iBE;EAAqC,gBAAA;A1Bs2iBvC;;A0Bt2iBE;EAAqC,gBAAA;A1B02iBvC;;A0B12iBE;EAAqC,gBAAA;A1B82iBvC;;A0B92iBE;EAAqC,gBAAA;A1Bk3iBvC;;A0Bl3iBE;EAAqC,gBAAA;A1Bs3iBvC;;A0Bt3iBE;EAAqC,gBAAA;A1B03iBvC;;A0B13iBE;EAAqC,gBAAA;A1B83iBvC;;A0B93iBE;EAAqC,gBAAA;A1Bk4iBvC;;A0Bl4iBE;EAAqC,gBAAA;A1Bs4iBvC;;A0Bt4iBE;EAAqC,gBAAA;A1B04iBvC;;A0B14iBE;EAAqC,gBAAA;A1B84iBvC;;A0B94iBE;EAAqC,gBAAA;A1Bk5iBvC;;A0Bl5iBE;EAAqC,gBAAA;A1Bs5iBvC;;A0Bt5iBE;EAAqC,gBAAA;A1B05iBvC;;A0B15iBE;EAAqC,gBAAA;A1B85iBvC;;A0B95iBE;EAAqC,gBAAA;A1Bk6iBvC;;A0Bl6iBE;EAAqC,gBAAA;A1Bs6iBvC;;A0Bt6iBE;EAAqC,gBAAA;A1B06iBvC;;A0B16iBE;EAAqC,gBAAA;A1B86iBvC;;A0B96iBE;EAAqC,gBAAA;A1Bk7iBvC;;A0Bl7iBE;EAAqC,gBAAA;A1Bs7iBvC;;A0Bt7iBE;EAAqC,gBAAA;A1B07iBvC;;A0B17iBE;EAAqC,gBAAA;A1B87iBvC;;A0B97iBE;EAAqC,gBAAA;A1Bk8iBvC;;A0Bl8iBE;EAAqC,gBAAA;A1Bs8iBvC;;A0Bt8iBE;EAAqC,gBAAA;A1B08iBvC;;A0B18iBE;EAAqC,gBAAA;A1B88iBvC;;A0B98iBE;EAAqC,gBAAA;A1Bk9iBvC;;A0Bl9iBE;EAAqC,gBAAA;A1Bs9iBvC;;A0Bt9iBE;EAAqC,gBAAA;A1B09iBvC;;A0B19iBE;EAAqC,gBAAA;A1B89iBvC;;A0B99iBE;EAAqC,gBAAA;A1Bk+iBvC;;A0Bl+iBE;EAAqC,gBAAA;A1Bs+iBvC;;A0Bt+iBE;EAAqC,gBAAA;A1B0+iBvC;;A0B1+iBE;EAAqC,gBAAA;A1B8+iBvC;;A0B9+iBE;EAAqC,gBAAA;A1Bk/iBvC;;A0Bl/iBE;EAAqC,gBAAA;A1Bs/iBvC;;A0Bt/iBE;EAAqC,gBAAA;A1B0/iBvC;;A0B1/iBE;EAAqC,gBAAA;A1B8/iBvC;;A0B9/iBE;EAAqC,gBAAA;A1BkgjBvC;;A0BlgjBE;EAAqC,gBAAA;A1BsgjBvC;;A0BtgjBE;EAAqC,gBAAA;A1B0gjBvC;;A0B1gjBE;EAAqC,gBAAA;A1B8gjBvC;;A0B9gjBE;EAAqC,gBAAA;A1BkhjBvC;;A0BlhjBE;EAAqC,gBAAA;A1BshjBvC;;A0BthjBE;EAAqC,gBAAA;A1B0hjBvC;;A0B1hjBE;EAAqC,gBAAA;A1B8hjBvC;;A0B9hjBE;EAAqC,gBAAA;A1BkijBvC;;A0BlijBE;EAAqC,gBAAA;A1BsijBvC;;A0BtijBE;EAAqC,gBAAA;A1B0ijBvC;;A0B1ijBE;EAAqC,gBAAA;A1B8ijBvC;;A0B9ijBE;EAAqC,gBAAA;A1BkjjBvC;;A0BljjBE;EAAqC,gBAAA;A1BsjjBvC;;A0BtjjBE;EAAqC,gBAAA;A1B0jjBvC;;A0B1jjBE;EAAqC,gBAAA;A1B8jjBvC;;A0B9jjBE;EAAqC,gBAAA;A1BkkjBvC;;A0BlkjBE;EAAqC,gBAAA;A1BskjBvC;;A0BtkjBE;EAAqC,gBAAA;A1B0kjBvC;;A0B1kjBE;EAAqC,gBAAA;A1B8kjBvC;;A0B9kjBE;EAAqC,gBAAA;A1BkljBvC;;A0BlljBE;EAAqC,gBAAA;A1BsljBvC;;A0BtljBE;EAAqC,gBAAA;A1B0ljBvC;;A0B1ljBE;EAAqC,gBAAA;A1B8ljBvC;;A0B9ljBE;EAAqC,gBAAA;A1BkmjBvC;;A0BlmjBE;EAAqC,gBAAA;A1BsmjBvC;;A0BtmjBE;EAAqC,gBAAA;A1B0mjBvC;;A0B1mjBE;EAAqC,gBAAA;A1B8mjBvC;;A0B9mjBE;EAAqC,gBAAA;A1BknjBvC;;A0BlnjBE;EAAqC,gBAAA;A1BsnjBvC;;A0BtnjBE;EAAqC,gBAAA;A1B0njBvC;;A0B1njBE;EAAqC,gBAAA;A1B8njBvC;;A0B9njBE;EAAqC,gBAAA;A1BkojBvC;;A0BlojBE;EAAqC,gBAAA;A1BsojBvC;;A0BtojBE;EAAqC,gBAAA;A1B0ojBvC;;A0B1ojBE;EAAqC,gBAAA;A1B8ojBvC;;A0B9ojBE;EAAqC,gBAAA;A1BkpjBvC;;A0BlpjBE;EAAqC,gBAAA;A1BspjBvC;;A0BtpjBE;EAAqC,gBAAA;A1B0pjBvC;;A0B1pjBE;EAAqC,gBAAA;A1B8pjBvC;;A0B9pjBE;EAAqC,gBAAA;A1BkqjBvC;;A0BlqjBE;EAAqC,gBAAA;A1BsqjBvC;;A0BtqjBE;EAAqC,gBAAA;A1B0qjBvC;;A0B1qjBE;EAAqC,gBAAA;A1B8qjBvC;;A0B9qjBE;EAAqC,gBAAA;A1BkrjBvC;;A0BlrjBE;EAAqC,gBAAA;A1BsrjBvC;;A0BtrjBE;EAAqC,gBAAA;A1B0rjBvC;;A0B1rjBE;EAAqC,gBAAA;A1B8rjBvC;;A0B9rjBE;EAAqC,gBAAA;A1BksjBvC;;A0BlsjBE;EAAqC,gBAAA;A1BssjBvC;;A0BtsjBE;EAAqC,gBAAA;A1B0sjBvC;;A0B1sjBE;EAAqC,gBAAA;A1B8sjBvC;;A0B9sjBE;EAAqC,gBAAA;A1BktjBvC;;A0BltjBE;EAAqC,gBAAA;A1BstjBvC;;A0BttjBE;EAAqC,gBAAA;A1B0tjBvC;;A0B1tjBE;EAAqC,gBAAA;A1B8tjBvC;;A0B9tjBE;EAAqC,gBAAA;A1BkujBvC;;A0BlujBE;EAAqC,gBAAA;A1BsujBvC;;A0BtujBE;EAAqC,gBAAA;A1B0ujBvC;;A0B1ujBE;EAAqC,gBAAA;A1B8ujBvC;;A0B9ujBE;EAAqC,gBAAA;A1BkvjBvC;;A0BlvjBE;EAAqC,gBAAA;A1BsvjBvC;;A0BtvjBE;EAAqC,gBAAA;A1B0vjBvC;;A0B1vjBE;EAAqC,gBAAA;A1B8vjBvC;;A0B9vjBE;EAAqC,gBAAA;A1BkwjBvC;;A0BlwjBE;EAAqC,gBAAA;A1BswjBvC;;A0BtwjBE;EAAqC,gBAAA;A1B0wjBvC;;A0B1wjBE;EAAqC,gBAAA;A1B8wjBvC;;A0B9wjBE;EAAqC,gBAAA;A1BkxjBvC;;A0BlxjBE;EAAqC,gBAAA;A1BsxjBvC;;A0BtxjBE;EAAqC,gBAAA;A1B0xjBvC;;A0B1xjBE;EAAqC,gBAAA;A1B8xjBvC;;A0B9xjBE;EAAqC,gBAAA;A1BkyjBvC;;A0BlyjBE;EAAqC,gBAAA;A1BsyjBvC;;A0BtyjBE;EAAqC,gBAAA;A1B0yjBvC;;A0B1yjBE;EAAqC,gBAAA;A1B8yjBvC;;A0B9yjBE;EAAqC,gBAAA;A1BkzjBvC;;A0BlzjBE;EAAqC,gBAAA;A1BszjBvC;;A0BtzjBE;EAAqC,gBAAA;A1B0zjBvC;;A0B1zjBE;EAAqC,gBAAA;A1B8zjBvC;;A0B9zjBE;EAAqC,gBAAA;A1Bk0jBvC;;A0Bl0jBE;EAAqC,gBAAA;A1Bs0jBvC;;A0Bt0jBE;EAAqC,gBAAA;A1B00jBvC;;A0B10jBE;EAAqC,gBAAA;A1B80jBvC;;A0B90jBE;EAAqC,gBAAA;A1Bk1jBvC;;A0Bl1jBE;EAAqC,gBAAA;A1Bs1jBvC;;A0Bt1jBE;EAAqC,gBAAA;A1B01jBvC;;A0B11jBE;EAAqC,gBAAA;A1B81jBvC;;A0B91jBE;EAAqC,gBAAA;A1Bk2jBvC;;A0Bl2jBE;EAAqC,gBAAA;A1Bs2jBvC;;A0Bt2jBE;EAAqC,gBAAA;A1B02jBvC;;A0B12jBE;EAAqC,gBAAA;A1B82jBvC;;A0B92jBE;EAAqC,gBAAA;A1Bk3jBvC;;A0Bl3jBE;EAAqC,gBAAA;A1Bs3jBvC;;A0Bt3jBE;EAAqC,gBAAA;A1B03jBvC;;A0B13jBE;EAAqC,gBAAA;A1B83jBvC;;A0B93jBE;EAAqC,gBAAA;A1Bk4jBvC;;A0Bl4jBE;EAAqC,gBAAA;A1Bs4jBvC;;A0Bt4jBE;EAAqC,gBAAA;A1B04jBvC;;A0B14jBE;EAAqC,gBAAA;A1B84jBvC;;A0B94jBE;EAAqC,gBAAA;A1Bk5jBvC;;A0Bl5jBE;EAAqC,gBAAA;A1Bs5jBvC;;A0Bt5jBE;EAAqC,gBAAA;A1B05jBvC;;A0B15jBE;EAAqC,gBAAA;A1B85jBvC;;A0B95jBE;EAAqC,gBAAA;A1Bk6jBvC;;A0Bl6jBE;EAAqC,gBAAA;A1Bs6jBvC;;A0Bt6jBE;EAAqC,gBAAA;A1B06jBvC;;A0B16jBE;EAAqC,gBAAA;A1B86jBvC;;A0B96jBE;EAAqC,gBAAA;A1Bk7jBvC;;A0Bl7jBE;EAAqC,gBAAA;A1Bs7jBvC;;A0Bt7jBE;EAAqC,gBAAA;A1B07jBvC;;A0B17jBE;EAAqC,gBAAA;A1B87jBvC;;A0B97jBE;EAAqC,gBAAA;A1Bk8jBvC;;A0Bl8jBE;EAAqC,gBAAA;A1Bs8jBvC;;A0Bt8jBE;EAAqC,gBAAA;A1B08jBvC;;A0B18jBE;EAAqC,gBAAA;A1B88jBvC;;A0B98jBE;EAAqC,gBAAA;A1Bk9jBvC;;A0Bl9jBE;EAAqC,gBAAA;A1Bs9jBvC;;A2B7+jBA;;;EAAA;AAOA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBToCwB;ESnCxB,wHAAA;A3B6+jBF;A2Bz+jBA;;EAEE,iCAAA;EACA,gBAAA;A3B2+jBF;;A4B9/jBA;;;EAAA;AAOA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBVoCwB;EUnCxB,wHAAA;A5B8/jBF;A4B1/jBA;;EAEE,iCAAA;EACA,gBAAA;A5B4/jBF;;A6B/gkBA;;;EAAA;AAOA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBXoCwB;EWnCxB,wHAAA;A7B+gkBF;A6B3gkBA;;EAEE,iCAAA;EACA,gBAAA;A7B6gkBF;;A8BhikBA;;;EAAA;AAOA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBZoCwB;EYnCxB,wHAAA;A9BgikBF;A8B5hkBA;;EAEE,iCAAA;EACA,gBAAA;A9B8hkBF;;A+B/ikBA;EACE,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,6DAAA;A/BkjkBF;A+B/ikBA;EACE,qBAAA;EACA,gBAAA;EACA,uEAAA;A/BijkBF;A+B9ikBA;EACE,qBAAA;EACA,gBAAA;EACA,kEAAA;A/BgjkBF;A+B7ikBA;EACE,qBAAA;EACA,gBAAA;EACA,gEAAA;A/B+ikBF;A+B5ikBA;EACE,qBAAA;EACA,gBAAA;EACA,mEAAA;A/B8ikBF;A+B3ikBA;EACE,qBAAA;EACA,gBAAA;EACA,oEAAA;A/B6ikBF;A+B1ikBA;EACE,qBAAA;EACA,gBAAA;EACA,2EAAA;A/B4ikBF;A+BzikBA;EACE,qBAAA;EACA,gBAAA;EACA,gEAAA;A/B2ikBF;A+BxikBA;EACE,qBAAA;EACA,gBAAA;EACA,qEAAA;A/B0ikBF;AgClmkBA;EACE,4DAAA;AhComkBF;;AgClmkBA;EACE,4DAAA;AhCqmkBF;;AgCnmkBA;EACE,4DAAA;AhCsmkBF;;AgCpmkBA;EACE,4DAAA;AhCumkBF;;AgCrmkBA;EACE,4DAAA;AhCwmkBF;;AgCtmkBA;EACE,4DAAA;AhCymkBF;;AgCvmkBA;EACE,4DAAA;AhC0mkBF;;AgCtmkBA;EACE,yBAAA;EACA,YAAA;EACA,qBAAA;AhCymkBF;AgCvmkBE;EACE,yBAAA;EACA,YAAA;EACA,sBAAA;AhCymkBJ;AgCtmkBE;EACE,yBAAA;EACA,YAAA;EACA,sBAAA;AhCwmkBJ;AgCrmkBE;EACE,eAAA;AhCumkBJ;;AgCnmkBA;EACE;IACE,YAAA;EhCsmkBF;EgCnmkBA;IACE,YAAA;EhCqmkBF;AACF;AgCnmkBA;EACE;IACE,YAAA;EhCqmkBF;EgClmkBA;IACE,YAAA;EhComkBF;AACF;AgClmkBA;EACE;IACE,YAAA;EhComkBF;EgCjmkBA;IACE,YAAA;EhCmmkBF;AACF;AgCjmkBA;EACE;IACE,YAAA;EhCmmkBF;EgChmkBA;IACE,aAAA;EhCkmkBF;AACF;AgChmkBA;EACE;IACE,aAAA;EhCkmkBF;EgC/lkBA;IACE,YAAA;EhCimkBF;AACF;AgC/lkBA;EACE;IACE,aAAA;EhCimkBF;EgC9lkBA;IACE,aAAA;EhCgmkBF;AACF;AgC7lkBA;EACE;IACE,YAAA;EhC+lkBF;EgC5lkBA;IACE,aAAA;EhC8lkBF;AACF;AiCzskBA;EACE,YAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;AjC2skBF;AiCzskBE;EACE,wCAAA;AjC2skBJ;AiCzskBI;EACE,wCAAA;AjC2skBN;;AiCrskBA;EACE,sBAAA;AjCwskBF;;AiCrskBA;EACE,aAAA;AjCwskBF;;AiCrskBA;EACE,aAAA;EACA,qBAAA;AjCwskBF;;AiCrskBA;EACE,aAAA;EACA,qBAAA;AjCwskBF;;AiCrskBA;EACE,aAAA;EACA,qBAAA;AjCwskBF;;AiCrskBA;EACE,kBAAA;AjCwskBF;;AiCrskBA;EACE,2BAAA;EACA,kCAAA;EACA,eAAA;EACA,mCAAA;EACA,2CAAA;EACA,SAAA;AjCwskBF;;AiCpskBA;EACE,UAAA;EACA,WAAA;EACA,6BAAA;AjCuskBF;AiCrskBE;EACE,6BAAA;AjCuskBJ;AiCpskBE;EACE,oCAAA;AjCsskBJ;;AiClskBA;EACE,yBAAA;AjCqskBF;AiCnskBE;EACE,yBAAA;AjCqskBJ;;AiCjskBA;EACE;IACE,cAAA;IACA,sBAAA;IACA,8BAAA;IACA,qBAAA;IACA,6BAAA;EjCoskBF;AACF;AiCjskBA;EACE;IACE,cAAA;IACA,sBAAA;IACA,8BAAA;IACA,qBAAA;IACA,6BAAA;EjCmskBF;AACF;AiChskBA;EACE;IACE,cAAA;IACA,qBAAA;IACA,6BAAA;IACA,qBAAA;IACA,6BAAA;EjCkskBF;AACF;AiC/rkBA;EACE,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AjCiskBF;;AiC7rkBA;EACE,qCAAA;AjCgskBF;;AiC7rkBA;EACE,6BAAA;AjCgskBF;;AiC7rkBA;EACE,eAAA;AjCgskBF;;AiC5rkBA;EACE,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;AjC+rkBF;;AiC5rkBA;EACE,cAAA;EACA,qBAAA;EACA,6BAAA;AjC+rkBF;;AiC5rkBA;EACE,cAAA;AjC+rkBF;;AiC5rkBA;EACE,eAAA;AjC+rkBF;;AiC3rkBA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;AjC8rkBF;AiC5rkBE;EACE,YAAA;AjC8rkBJ;;AiC1rkBA;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;AjC6rkBF;AiC3rkBE;EACE,YAAA;AjC6rkBJ;;AiCzrkBA;EACE,yBAAA;AjC4rkBF;;AiCzrkBA;EACE,sBAAA;AjC4rkBF;;AiCzrkBA;EACE,yBAAA;AjC4rkBF;;AiCzrkBA;EACE,yBAAA;AjC4rkBF;;AiCzrkBA;EACE,kBAAA;AjC4rkBF;;AiCzrkBA;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;AjC4rkBF;;AiCzrkBA;EACE,gBAAA;AjC4rkBF;;AiCzrkBA;EACE,gBAAA;AjC4rkBF;;AiCzrkBA;EACE,wBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AjC4rkBF;;AiCzrkBA;EACE,WAAA;AjC4rkBF;;AiCvrkBA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,kCAAA;EACA,gBAAA;EACA,qIAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EAEA,mBAAA;EACA,gCAAA;EACA,2CAAA;AjCyrkBF;AiCvrkBE;EACE,YAAA;AjCyrkBJ;AiCtrkBE;EACE,YAAA;EACA,eAAA;AjCwrkBJ;AiCrrkBE;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AjCurkBJ;;AiCnrkBA;EACE,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,oBAAA;AjCsrkBF;AiCprkBE;EACE,yBAAA;AjCsrkBJ;;AiCjrkBA;EACE,qBAAA;AjCorkBF;;AiClrkBA;EACE,qBAAA;AjCqrkBF;;AiCnrkBA;EACE,qBAAA;AjCsrkBF;;AiCprkBA;EACE,UAAA;AjCurkBF;;AiCrrkBA;EACE,UAAA;AjCwrkBF;;AiCtrkBA;EACE,UAAA;AjCyrkBF;;AiCvrkBA;EACE,qBAAA;AjC0rkBF;;AiCxrkBA;EACE,UAAA;AjC2rkBF;;AiCzrkBA;EACE,UAAA;AjC4rkBF;;AiCvrkBA;EACE,gCAAA;AjC0rkBF;;AiCvrkBA;EACE,mBAAA;AjC0rkBF;;AiCvrkBA;EACE,6BAAA;AjC0rkBF;;AiCvrkBA;EACE,qBAAA;EACA,0BAAA;EACA,eAAA;AjC0rkBF;;AkCt/kBE;EACE,8BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AlCy/kBJ;AkCt/kBE;EACE,aAAA;AlCw/kBJ;AkCr/kBE;EACE,qBAAA;EACA,qBAAA;AlCu/kBJ;;AkCn/kBA;EACE,aAAA;AlCs/kBF;;AkCn/kBA;EACE,aAAA;AlCs/kBF;;AkCl/kBA;EACE,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AlCq/kBF;AkCn/kBE;EACE,qBAAA;EACA,sCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AlCq/kBJ;AkCl/kBE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AlCo/kBJ;AkCl/kBI;EACE,aAAA;EACA,mBAAA;AlCo/kBN;AkCj/kBI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;AlCm/kBN;AkCh/kBI;EACE,0BAAA;AlCk/kBN;AkC/+kBI;EACE,aAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AlCi/kBN;AkC9+kBI;EACE,oBAAA;AlCg/kBN;;AmCxklBE;EACE,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;AnC2klBJ;AmCzklBI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AnC2klBN;AmCxklBI;EArBF;IAsBI,gBAAA;IACA,4BAAA;EnC2klBJ;AACF;AmCzklBI;EACE,aAAA;AnC2klBN;AmCzklBM;EAHF;IAII,eAAA;EnC4klBN;AACF;AmCxklBE;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;AnC0klBJ;AmCxklBI;EANF;IAOI,gBAAA;EnC2klBJ;AACF;AmCxklBE;EACE,iBAAA;EACA,qBAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;AnC0klBJ;AmCxklBI;EAPF;IAQI,sBAAA;IACA,uBAAA;IACA,eAAA;EnC2klBJ;AACF;AmCxklBE;EACE,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;AnC0klBJ;AmCxklBI;EACE,iBAAA;AnC0klBN;AmCxklBM;EAHF;IAII,cAAA;EnC2klBN;AACF;AmCxklBI;EAdF;IAeI,WAAA;IACA,mBAAA;IACA,aAAA;IACA,sBAAA;EnC2klBJ;AACF;AmCxklBM;EADF;IAEI,WAAA;IACA,uBAAA;EnC2klBN;AACF;AmCvklBE;EACE,cAAA;AnCyklBJ;AmCvklBI;EACE,cAAA;AnCyklBN;;AmCnklBA;EAGI;IACE,gBAAA;IACA,4BAAA;EnCoklBJ;EmC9jlBI;IACE,eAAA;EnCgklBN;EmC5jlBE;IACE,gBAAA;EnC8jlBJ;EmC3jlBE;IACE,sBAAA;IACA,uBAAA;IACA,eAAA;EnC6jlBJ;EmC1jlBE;IACE,WAAA;IACA,gBAAA;IACA,sBAAA;IACA,aAAA;IACA,sBAAA;EnC4jlBJ;EmCtjlBI;IACE,cAAA;EnCwjlBN;EmCrjlBI;IACE,WAAA;IACA,uBAAA;EnCujlBN;AACF;AoCxslBA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;ApCyslBF;AoCvslBE;EACE,oBAAA;ApCyslBJ;;AoCrslBA;EACE,qCAAA;EACA,gCAAA;ApCwslBF;;AoCrslBA;EACE,qCAAA;EACA,gCAAA;ApCwslBF;;AoCrslBA;EACE,kCAAA;EACA,6BAAA;ApCwslBF;;AoCrslBA;EACE,oCAAA;EACA,+BAAA;ApCwslBF;;AoCrslBA;EACE,mCAAA;EACA,8BAAA;ApCwslBF;;AoCrslBA;EACE,mCAAA;EACA,8BAAA;ApCwslBF;;AoCrslBA;EACE,mCAAA;EACA,8BAAA;ApCwslBF;;AoCrslBA;EACE,qDAAA;EACA,yBAAA;ApCwslBF;;AoCrslBA;EACE,qCAAA;EACA,gCAAA;ApCwslBF;;AoCrslBA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,2CAAA;EACA,gCAAA;ApCwslBF;AoCtslBE;EACE,2CAAA;EACA,+BAAA;ApCwslBJ;;AqCzxlBE;EACE,+BAAA;ArC4xlBJ;AqCxxlBE;EACE,mBAAA;ArC0xlBJ;AqCvxlBE;EACE,+BAAA;ArCyxlBJ;AqCrxlBE;EACE,+BAAA;ArCuxlBJ;AqCjxlBM;EACE,+BAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;ArCmxlBR;AqC/wlBI;EACE,+BAAA;ArCixlBN;AqC3wlBE;EACE,wBAAA;ArC6wlBJ;AqC1wlBE;EACE,yBAAA;ArC4wlBJ;;AqCrwlBA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;ArCwwlBF;AqCtwlBE;EAZF;IAaI,gBAAA;ErCywlBF;AACF;AqCvwlBE;EACE,+BAAA;EACA,2BAAA;ArCywlBJ;AqCvwlBE;EACE,gCAAA;EACA,2BAAA;ArCywlBJ;;AqCrwlBA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;ArCwwlBF;AqCtwlBE;EACE,+BAAA;EACA,2BAAA;ArCwwlBJ;AqCtwlBE;EACE,gCAAA;EACA,2BAAA;ArCwwlBJ;;AqCpwlBA;EACE,cAAA;ArCuwlBF;;AqCnwlBA;EACE,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EAEA,mBAAA;ArCqwlBF;;AqClwlBA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;ArCqwlBF;;AqClwlBA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,SAAA;EACA,QAAA;EACA,oCAAA;ArCqwlBF;AqCnwlBE;EACE,qBAAA;ArCqwlBJ;;AqCjwlBA;EACE,eAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,4BAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,SAAA;EACA,oBAAA;EACA,+BAAA;EACA,kDAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,wBAAA;EACA,qBAAA;EACA,uBAAA;EACA,0DAAA;EACA,4BAAA;EACA,wCAAA;EACA,6BAAA;ArCmwlBF;AqCjwlBE;EACE,yBAAA;EACA,2BAAA;EACA,eAAA;ArCmwlBJ;AqChwlBE;EACE,4BAAA;ArCkwlBJ;AqChwlBE;EACE,4BAAA;ArCkwlBJ;AqChwlBE;EACE,4BAAA;ArCkwlBJ;AqC/vlBE;EACE,aAAA;ArCiwlBJ;AqC9vlBE;EACE,wCAAA;ArCgwlBJ;AqC9vlBI;EACE,oCAAA;ArCgwlBN;AqC9vlBI;EACE,oCAAA;ArCgwlBN;;AqC1vlBA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;ArC6vlBF;AqC3vlBE;EACE,eAAA;EACA,2BAAA;ArC6vlBJ;AqC3vlBI;EACE,gBAAA;EACA,SAAA;ArC6vlBN;AqCzvlBE;EACE,eAAA;ArC2vlBJ;AqCxvlBE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;ArC0vlBJ;AqCxvlBI;EACE,mBAAA;EACA,oBAAA;EACA,sCAAA;ArC0vlBN;AqCtvlBM;EACE,cAAA;EACA,kBAAA;ArCwvlBR;AqCtvlBQ;EACE,2BAAA;ArCwvlBV;AqClvlBE;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;ArCovlBJ;AqClvlBI;EACE,2BAAA;ArCovlBN;AqClvlBI;EACE,gCAAA;EACA,4BAAA;ArCovlBN;AqClvlBM;EACE,4BAAA;ArCovlBR;AqC/ulBE;EACE,+BAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;ArCivlBJ;AqC/ulBI;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,8BAAA;EACA,+BAAA;EACA,0BAAA;EACA,2CAAA;ArCivlBN;AqC9ulBI;EACE,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;ArCgvlBN;;AqC3ulBA;EACE,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,+BAAA;EACA,kDAAA;EACA,qBAAA;EACA,wBAAA;EACA,WAAA;EACA,eAAA;EACA,uCAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;ArC6ulBF;AqC3ulBE;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,kDAAA;EACA,gBAAA;ArC6ulBJ;AqC1ulBE;EACE,wCAAA;ArC4ulBJ;AqC1ulBI;EACE,oCAAA;ArC4ulBN;AqC1ulBI;EACE,oCAAA;ArC4ulBN;AqCxulBE;EACE,4BAAA;ArC0ulBJ;AqCxulBE;EACE,4BAAA;ArC0ulBJ;AqCxulBE;EACE,uCAAA;ArC0ulBJ;AqCvulBE;EACE,oBAAA;ArCyulBJ;AqCtulBE;EACE,yBAAA;EACA,2BAAA;ArCwulBJ;AqCtulBI;EACE,2BAAA;ArCwulBN;;AqCnulBA;EACE,kCAAA;EACA,kCAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;ArCsulBF;AqCpulBE;EACE,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;ArCsulBJ;AqCpulBI;EACE,WAAA;EACA,+BAAA;EACA,2BAAA;ArCsulBN;AqCnulBI;EACE,4BAAA;EACA,gDAAA;ArCqulBN;AqClulBI;EACE,WAAA;EACA,4BAAA;EACA,gCAAA;ArCoulBN;AqCjulBI;EACE,oBAAA;ArCmulBN;AqChulBI;EACE,qEAAA;EACA,gCAAA;ArCkulBN;AqC9tlBE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;ArCgulBJ;AqCvtlBI;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,WAAA;EACA,8BAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,4GAAA;EAEA,WAAA;EACA,YAAA;EACA,cAAA;EACA,0CAAA;ArCwtlBN;AqCrtlBI;EACE,QAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;ArCutlBN;;AqChtlBE;EACE,wCAAA;ArCmtlBJ;AqCltlBI;EACE,oCAAA;ArCotlBN;;AqC/slBA;EACE,YAAA;EACA,qBAAA;ArCktlBF;AqChtlBE;EACE,gBAAA;EACA,yBAAA;ArCktlBJ;AqC/slBE;EACE,iBAAA;EACA,gBAAA;ArCitlBJ;AqC/slBI;EACE,wBAAA;EACA,mBAAA;ArCitlBN;AqC7slBE;EACE,wBAAA;EACA,+BAAA;EACA,gCAAA;EACA,mBAAA;ArC+slBJ;AqC5slBM;EACE,mBAAA;ArC8slBR;AqC1slBI;EACE,oBAAA;ArC4slBN;AqCxslBM;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kDAAA;EACA,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;ArC0slBR;AqCvslBQ;EACE,aAAA;ArCyslBV;AqClslBI;EACE,wBAAA;EACA,+BAAA;EACA,gCAAA;EACA,oDAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,+BAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;ArCoslBN;AqClslBI;EACI,aAAA;EACA,4BAAA;ArCoslBR;;AqC5rlBA;EACE,WAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;ArC+rlBF;;AqC5rlBA;EACE,oBAAA;ArC+rlBF;AqC7rlBE;EACE,iBAAA;EACA,iBAAA;ArC+rlBJ;AqC7rlBE;EACE,iBAAA;EACA,mBAAA;ArC+rlBJ;AqC7rlBE;EACE,iBAAA;EACA,mBAAA;ArC+rlBJ;AqC7rlBE;EACE,iBAAA;EACA,iBAAA;ArC+rlBJ;AqC7rlBE;EACE,gBAAA;ArC+rlBJ;AqC5rlBE;EACE,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;ArC8rlBJ;AqC3rlBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;ArC6rlBJ;AqC3rlBI;EACE,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;ArC6rlBN;AqC1rlBI;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;ArC4rlBN;AqCxrlBE;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;ArC0rlBJ;AqCvrlBE;EACE,mBAAA;EACA,oBAAA;ArCyrlBJ;AqClrlBE;EACE,gBAAA;EACA,mBAAA;ArCorlBJ;AqCjrlBE;EACE,eAAA;EACA,qBAAA;ArCmrlBJ;;AqC3qlBI;EACE,wBAAA;EACA,+BAAA;ArC8qlBN;AqC5qlBM;EACE,yBAAA;ArC8qlBR;AqC5qlBM;EACE,2BAAA;ArC8qlBR;AqC1qlBQ;EACE,yBAAA;EACA,kCAAA;ArC4qlBV;AqC1qlBU;EACE,yBAAA;ArC4qlBZ;AqCzqlBQ;EACE,+BAAA;EACA,gCAAA;ArC2qlBV;AqCpqlBE;EACE,wBAAA;EACA,yBAAA;ArCsqlBJ;AqCpqlBI;EACE,yBAAA;ArCsqlBN;AqCpqlBI;EACE,2BAAA;ArCsqlBN;AqClqlBM;EACE,yBAAA;EACA,kCAAA;ArCoqlBR;AqClqlBQ;EACE,yBAAA;ArCoqlBV;AqCjqlBM;EACE,+BAAA;EACA,gCAAA;ArCmqlBR;;AqC7plBA;EACE,wBAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;ArCgqlBF;AqC7plBI;EACE,UAAA;EACA,gBAAA;ArC+plBN;AqC7plBM;EACE,UAAA;EACA,gBAAA;ArC+plBR;AqC5plBU;EACE,uBAAA;ArC8plBZ;AqC5plBU;EACE,0CAAA;ArC8plBZ;AqC1plBQ;EACE,UAAA;ArC4plBV;AqCtplBE;EACE,qFAAA;EACA,YAAA;ArCwplBJ;AqCpplBI;EACE,mBAAA;EACA,0CAAA;ArCsplBN;AqClplBE;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gCAAA;EAEA,aAAA;EACA,8BAAA;EACA,sCAAA;ArCmplBJ;AqC/olBI;EACE,aAAA;EACA,WAAA;EACA,mCAAA;EACA,qBAAA;EACA,8BAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;ArCiplBN;AqC/olBM;EACE,gBAAA;ArCiplBR;AqC9olBM;EACE,UAAA;ArCgplBR;AqC7olBM;EACE,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;ArC+olBR;;AqCzolBA;EAUY;IACE,uBAAA;ErCmolBZ;EqC5mlBE;IACE,aAAA;ErC8mlBJ;EqC1mlBI;IACE,qBAAA;ErC4mlBN;AACF;AqC1llBA;EACE,wCAAA;ArC4llBF;AqC1llBE;EACE,oCAAA;ArC4llBJ;AqC1llBE;EACE,oCAAA;ArC4llBJ;;AsCt+mBA;EAAU,0BAAA;AtC0+mBV;;AsCz+mBA;EAAU,2BAAA;AtC6+mBV;;AsC1+mBA;EAAc,2BAAA;AtC8+mBd;;AsC7+mBA;EAAc,4BAAA;AtCi/mBd;;AsC/+mBA;EAAU,uBAAA;AtCm/mBV;;AsCl/mBA;EAAU,wBAAA;AtCs/mBV;;AsCp/mBA;EACE,iCAAA;AtCu/mBF;;AsCp/mBA;EACE,wBAAA;AtCu/mBF;;AsCr/mBA;EACE,wBAAA;AtCw/mBF;;AsCt/mBA;EACE,YAAA;AtCy/mBF;;AsCv/mBA;EACE,WAAA;AtC0/mBF;;AsCx/mBA;EACE,YAAA;AtC2/mBF;;AsCz/mBA;EACE,SAAA;AtC4/mBF;;AsC1/mBA;EACE,YAAA;AtC6/mBF;;AsC3/mBA;EACE,WAAA;AtC8/mBF;;AsC3/mBA;EACE,+BAAA;AtC8/mBF;;AsC3/mBA;EACE,8BAAA;AtC8/mBF;;AsC3/mBA;EACE,kCAAA;AtC8/mBF;;AsC3/mBA;EACE,yCAAA;AtC8/mBF;;AsC3/mBA;EACE,sCAAA;AtC8/mBF;;AsC3/mBA;EACE,oCAAA;AtC8/mBF;;AsC3/mBA;EACE,wBAAA;EACA,2BAAA;AtC8/mBF;;AsC5/mBA;EACE,8BAAA;EACA,iCAAA;AtC+/mBF;;AsC7/mBA;EACE,6BAAA;EACA,gCAAA;AtCggnBF;;AsC9/mBA;EACE,2BAAA;EACA,8BAAA;AtCignBF;;AsC//mBA;EACE,6BAAA;EACA,gCAAA;AtCkgnBF;;AsChgnBA;EACE,2BAAA;EACA,8BAAA;AtCmgnBF;;AsC//mBA;EACE,0BAAA;EACA,yBAAA;AtCkgnBF;;AsChgnBA;EACE,gCAAA;EACA,+BAAA;AtCmgnBF;;AsCjgnBA;EACE,+BAAA;EACA,8BAAA;AtCognBF;;AsClgnBA;EACE,6BAAA;EACA,4BAAA;AtCqgnBF;;AsCngnBA;EACE,+BAAA;EACA,8BAAA;AtCsgnBF;;AsCpgnBA;EACE,6BAAA;EACA,4BAAA;AtCugnBF;;AsCngnBA;EACE,yBAAA;EACA,4BAAA;AtCsgnBF;;AsCpgnBA;EACE,+BAAA;EACA,kCAAA;AtCugnBF;;AsCrgnBA;EACE,8BAAA;EACA,iCAAA;AtCwgnBF;;AsCtgnBA;EACE,4BAAA;EACA,+BAAA;AtCygnBF;;AsCvgnBA;EACE,8BAAA;EACA,iCAAA;AtC0gnBF;;AsCxgnBA;EACE,4BAAA;EACA,+BAAA;AtC2gnBF;;AsCvgnBA;EACE,2BAAA;EACA,0BAAA;AtC0gnBF;;AsCxgnBA;EACE,iCAAA;EACA,gCAAA;AtC2gnBF;;AsCzgnBA;EACE,gCAAA;EACA,+BAAA;AtC4gnBF;;AsC1gnBA;EACE,8BAAA;EACA,6BAAA;AtC6gnBF;;AsC3gnBA;EACE,gCAAA;EACA,+BAAA;AtC8gnBF;;AsC5gnBA;EACE,8BAAA;EACA,6BAAA;AtC+gnBF;;AsC7gnBA;EACE,gBAAA;AtCghnBF;;AsC9gnBA;EACE,eAAA;AtCihnBF;;AsC/gnBA;EACE,aAAA;AtCkhnBF;;AsChhnBA;EACE,eAAA;AtCmhnBF;;AsCjhnBA;EACE,eAAA;AtCohnBF;;AsClhnBA;EACE,UAAA;AtCqhnBF;;AsClhnBA;EACE,eAAA;AtCqhnBF;;AsCnhnBA;EACE,cAAA;AtCshnBF;;AsCphnBA;EACE,YAAA;AtCuhnBF;;AsCrhnBA;EACE,cAAA;AtCwhnBF;;AsCthnBA;EACE,cAAA;AtCyhnBF;;AsCvhnBA;EACE,SAAA;AtC0hnBF;;AsCthnBA;EACE,2BAAA;AtCyhnBF;;AsCvhnBA;EACE,iCAAA;AtC0hnBF;;AsCxhnBA;EACE,gCAAA;AtC2hnBF;;AsCzhnBA;EACE,8BAAA;AtC4hnBF;;AsC1hnBA;EACE,gCAAA;AtC6hnBF;;AsC3hnBA;EACE,8BAAA;AtC8hnBF;;AsC1hnBA;EACE,wBAAA;AtC6hnBF;;AsC3hnBA;EACE,8BAAA;AtC8hnBF;;AsC5hnBA;EACE,6BAAA;AtC+hnBF;;AsC7hnBA;EACE,2BAAA;AtCginBF;;AsC9hnBA;EACE,6BAAA;AtCiinBF;;AsC/hnBA;EACE,2BAAA;AtCkinBF;;AsC9hnBA;EACE,wBAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;AtCiinBF;;AsC/hnBA;EACE,0BAAA;AtCkinBF;;AsChinBA;EACE,gCAAA;AtCminBF;;AsCjinBA;EACE,+BAAA;AtCoinBF;;AsClinBA;EACE,6BAAA;AtCqinBF;;AsCninBA;EACE,+BAAA;AtCsinBF;;AsCpinBA;EACE,6BAAA;AtCuinBF;;AsCninBA;EACE,yBAAA;AtCsinBF;;AsCpinBA;EACE,+BAAA;AtCuinBF;;AsCrinBA;EACE,8BAAA;AtCwinBF;;AsCtinBA;EACE,4BAAA;AtCyinBF;;AsCvinBA;EACE,8BAAA;AtC0inBF;;AsCxinBA;EACE,4BAAA;AtC2inBF;;AsCvinBA;EACE,4BAAA;AtC0inBF;;AsCxinBA;EACE,kCAAA;AtC2inBF;;AsCzinBA;EACE,iCAAA;AtC4inBF;;AsC1inBA;EACE,+BAAA;AtC6inBF;;AsC3inBA;EACE,iCAAA;AtC8inBF;;AsC5inBA;EACE,+BAAA;AtC+inBF;;AsC5inBA;EACE,iBAAA;AtC+inBF;;AsC7inBA;EACE,kBAAA;AtCgjnBF;;AsC9inBA;EACE,iBAAA;EACA,kBAAA;AtCijnBF;;AsC/inBA;EACE,yBAAA;AtCkjnBF;;AsChjnBA;EACE,+BAAA;AtCmjnBF;;AsCjjnBA;EACE,8BAAA;AtCojnBF;;AsCljnBA;EACE,4BAAA;AtCqjnBF;;AsCnjnBA;EACE,8BAAA;AtCsjnBF;;AsCpjnBA;EACE,4BAAA;AtCujnBF;;AsCnjnBA;EACE,2BAAA;AtCsjnBF;;AsCpjnBA;EACE,iCAAA;AtCujnBF;;AsCrjnBA;EACE,gCAAA;AtCwjnBF;;AsCtjnBA;EACE,8BAAA;AtCyjnBF;;AsCvjnBA;EACE,gCAAA;AtC0jnBF;;AsCxjnBA;EACE,8BAAA;AtC2jnBF;;AsCvjnBA;EACE,0BAAA;AtC0jnBF;;AsCxjnBA;EACE,gCAAA;AtC2jnBF;;AsCzjnBA;EACE,+BAAA;AtC4jnBF;;AsC1jnBA;EACE,6BAAA;AtC6jnBF;;AsC3jnBA;EACE,+BAAA;AtC8jnBF;;AsC5jnBA;EACE,6BAAA;AtC+jnBF;;AsC3jnBA;EACE,6BAAA;AtC8jnBF;;AsC3jnBA;EACE,6BAAA;AtC8jnBF;;AsC3jnBA;EACE,wBAAA;AtC8jnBF;;AsC5jnBA;EACE,wBAAA;AtC+jnBF;;AsC7jnBA;EACE,YAAA;AtCgknBF;;AsC9jnBA;EACE,WAAA;AtCiknBF;;AsC/jnBA;EACE,YAAA;AtCkknBF;;AsChknBA;EACE,SAAA;AtCmknBF;;AsCjknBA;EACE,YAAA;AtCoknBF;;AsClknBA;EACE,WAAA;AtCqknBF;;AsClknBA;EACE,+BAAA;AtCqknBF;;AsClknBA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;AtCqknBF;;AsClknBA;EACE,kBAAA;AtCqknBF;;AsClknBA;EACE,eAAA;AtCqknBF;;AsClknBA;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,mCAAA;AtCqknBF;;AsClknBA;EACE,cAAA;EACA,gBAAA;AtCqknBF;;AsC9jnBA;EACE,cAAA;EACA,qBAAA;EACA,kCAAA;AtCiknBF;AsC/jnBE;EACE,qBAAA;AtCiknBJ;;AsC7jnBA;EAAuB,8BAAA;AtCiknBvB;;AsChknBA;EAAuB,iCAAA;AtCoknBvB;;AsCnknBA;EAAuB,sCAAA;AtCuknBvB;;AsCtknBA;EAAuB,yCAAA;AtC0knBvB;;AsCxknBA;EAAqB,0BAAA;AtC4knBrB;;AsC3knBA;EAAqB,4BAAA;AtC+knBrB;;AsC9knBA;EAAqB,kCAAA;AtCklnBrB;;AsCjlnBA;EAAqB,yBAAA;AtCqlnBrB;;AsCnlnBA;EAA2B,sCAAA;AtCulnB3B;;AsCtlnBA;EAA2B,oCAAA;AtC0lnB3B;;AsCzlnBA;EAA2B,kCAAA;AtC6lnB3B;;AsC5lnBA;EAA2B,yCAAA;AtCgmnB3B;;AsC/lnBA;EAA2B,wCAAA;AtCmmnB3B;;AsCjmnBA;EAAwB,kCAAA;AtCqmnBxB;;AsCpmnBA;EAAwB,gCAAA;AtCwmnBxB;;AsCvmnBA;EAAwB,8BAAA;AtC2mnBxB;;AsC1mnBA;EAAwB,gCAAA;AtC8mnBxB;;AsC7mnBA;EAAwB,+BAAA;AtCinnBxB;;AsC/mnBA;EAAyB,oCAAA;AtCmnnBzB;;AsClnnBA;EAAyB,kCAAA;AtCsnnBzB;;AsCrnnBA;EAAyB,gCAAA;AtCynnBzB;;AsCxnnBA;EAAyB,uCAAA;AtC4nnBzB;;AsC3nnBA;EAAyB,sCAAA;AtC+nnBzB;;AsC9nnBA;EAAyB,iCAAA;AtCkonBzB;;AsChonBA;EAAuB,2BAAA;AtCoonBvB;;AsCnonBA;EAAuB,iCAAA;AtCuonBvB;;AsCtonBA;EAAuB,+BAAA;AtC0onBvB;;AsCzonBA;EAAuB,6BAAA;AtC6onBvB;;AsC5onBA;EAAuB,+BAAA;AtCgpnBvB;;AsC/onBA;EAAuB,8BAAA;AtCmpnBvB;;AsCjpnBA;EACE,sBAAA;AtCopnBF;;AsClpnBA;EACE,sBAAA;AtCqpnBF;;AuCrooBA;EACE,6EAAA;AvCwooBF;;AuCrooBA;EACE,+BAAA;AvCwooBF;;AuCrooBA;EACE,mEAAA;AvCwooBF;;AuCpooBA;EACE,0EAAA;EACA,kBAAA;AvCuooBF;AuCpooBI;EACE,WAAA;EACA,oBAAA;EACA,sBAAA;AvCsooBN;AuCjooBI;EACE,qBAAA;EACA,UAAA;AvCmooBN;AuC9noBI;EACE,wBAAA;EACA,oBAAA;EACA,UAAA;AvCgooBN;AuC5noBE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;EACA,gCAAA;EACA,wCAAA;EACA,uBAAA;EACA,qBAAA;AvC8noBJ;;AuCrnoBA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AvCwnoBF;AuCtnoBE;EACE,aAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AvCwnoBJ;AuCrnoBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;AvCunoBJ;AuCrnoBI;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AvCunoBN;AuCpnoBI;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AvCsnoBN;AuCpnoBM;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,sBAAA;EACA,eAAA;AvCsnoBR;AuCpnoBQ;EACE,eAAA;AvCsnoBV;AuCnnoBQ;EACE,0BAAA;EACA,gCAAA;AvCqnoBV;AuChnoBI;EACE,eAAA;AvCknoBN;AuC9moBE;EACE,kBAAA;EACA,0BAAA;EACA,+BAAA;AvCgnoBJ;AuC7moBE;EACE,wBAAA;EACA,+BAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AvC+moBJ;AuC7moBI;EACE,yBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AvC+moBN;;AwC3voBE;EACE,yBAAA;AxC8voBJ;AwC5voBE;EACE,yBAAA;AxC8voBJ;;AwC1voBA;EACE,eAAA;EACA,SAAA;EACA,0BAAA;EACA,8BAAA;EACA,8BAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AxC6voBF;AwC9uoBI;EACE,QAAA;EACA,SAAA;EACA,6BAAA;AxCgvoBN;AwC9uoBM;EACE,6BAAA;AxCgvoBR;AwC7uoBM;EACE,oCAAA;AxC+uoBR;AwCzuoBE;EACE,QAAA;EACA,SAAA;EACA,6BAAA;AxC2uoBJ;AwCzuoBI;EACE,6BAAA;AxC2uoBN;AwCxuoBI;EACE,oCAAA;AxC0uoBN;AwCtuoBE;EACE,UAAA;EACA,cAAA;EACA,kBAAA;AxCwuoBJ;AwCtuoBI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AxCwuoBN;AwCruoBI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AxCuuoBN;AwCpuoBI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sCAAA;EACA,mBAAA;EACA,kBAAA;AxCsuoBN;AwCpuoBM;EACE,mBAAA;AxCsuoBR;AwCpuoBQ;EACE,gBAAA;AxCsuoBV;AwChuoBE;EACE,YAAA;EACA,2CAAA;AxCkuoBJ;AwC/toBE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,uFAAA;EACA,yBAAA;EACA,wBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;EACA,gCAAA;EACA,UAAA;EACA,SAAA;AxCiuoBJ;AwC9toBE;EACE,UAAA;AxCguoBJ;AwC9toBI;EACE,oCAAA;EACA,sCAAA;AxCguoBN;AwC7toBI;EACE,gBAAA;EACA,gBAAA;AxC+toBN;AwC3toBE;EACE,eAAA;EACA,uCAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AxC6toBJ;;AwCxtoBA;EACE;IACE,YAAA;IACA,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,gBAAA;IACA,MAAA;IACA,QAAA;IACA,qBAAA;ExC2toBF;EwCztoBE;IACE,+BAAA;ExC2toBJ;EwCxtoBE;IACE,qBAAA;ExC0toBJ;EwCxtoBI;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;ExC0toBN;EwCvtoBI;IACE,SAAA;IACA,WAAA;ExCytoBN;EwCttoBI;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,mBAAA;ExCwtoBN;EwC7soBE;IACE,eAAA;IACA,SAAA;IACA,WAAA;IACA,wBAAA;IACA,UAAA;ExC+soBJ;EwC/roBI;IACE,qBAAA;ExCisoBN;AACF;AyCj6oBA;EACE,wBAAA;EACA,iFAAA;EACA,qBAAA;EACA,mBAAA;AzCm6oBF;AyCj6oBE;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,sCAAA;AzCm6oBJ;AyCj6oBI;EACE,aAAA;EACA,sBAAA;AzCm6oBN;AyCj6oBM;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;AzCm6oBR;AyCh6oBM;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AzCk6oBR;AyC95oBI;EACE,yBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzCg6oBN;AyC95oBM;EACE,qBAAA;AzCg6oBR;AyC75oBM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AzC+5oBR;AyC15oBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AzC45oBJ;AyC15oBI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AzC45oBN;AyC15oBM;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AzC45oBR;AyC15oBQ;EACE,gBAAA;AzC45oBV;AyCx5oBU;EACE,mBAAA;AzC05oBZ;AyCx5oBU;EACE,oBAAA;AzC05oBZ;AyCp5oBI;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AzCs5oBN;AyCp5oBM;EACE;IACE,WAAA;IACA,qBAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;EzCs5oBR;EyCp5oBQ;IACE,gBAAA;EzCs5oBV;AACF;AyCh5oBE;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,8BAAA;AzCk5oBJ;AyCh5oBI;EACE,yBAAA;AzCk5oBN;;A0C7hpBA;;;EAGE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;A1CgipBF;;A0C7hpBA;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;A1CgipBF;;A0C9hpBA;EACE,mBAAA;EACA,0CAAA;A1CiipBF;A0C/hpBE;EACE,yBAAA;EACA,oBAAA;EACA,WAAA;A1CiipBJ;A0C/hpBI;EACE,0CAAA;A1CiipBN;;A0C5hpBA;EACE,iBAAA;EACA,kBAAA;EACA,QAAA;A1C+hpBF;;A0C7hpBA;EACE,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;A1CgipBF;;A0C9hpBA;EACE,4BAAA;A1CiipBF;;A0C9hpBA;EACE,MAAA;EACA,gBAAA;A1CiipBF;;A0C/hpBA;EACE,gBAAA;EACA,4BAAA;A1CkipBF;;A0ChipBA;EACE,MAAA;A1CmipBF;;A0CjipBA;EACE,SAAA;EACA,4BAAA;A1CoipBF;;A0CjipBA;EACE,SAAA;EACA,mBAAA;A1CoipBF;;A0ClipBA;EACE,mBAAA;EACA,sBAAA;A1CqipBF;;A0CnipBA;EACE,SAAA;A1CsipBF;;A0CpipBA;EACE,YAAA;EACA,yBAAA;A1CuipBF;;A0CpipBA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;A1CuipBF;;A0CpipBA;EACE,2DAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;A1CuipBF;;A0CpipBA;EACE,UAAA;A1CuipBF;;A0CripBA;EACE,cAAA;A1CwipBF;;A0CtipBA;;EAEE,iCAAA;EACA,kCAAA;A1CyipBF;;A0CtipBA;EACE,kBAAA;EACA,UAAA;A1CyipBF;;A0CtipBA;EACE,UAAA;A1CyipBF;;A0CvipBA;EACE,iBAAA;A1C0ipBF;;A0CxipBA;EACE,UAAA;EACA,WAAA;A1C2ipBF;;A0CzipBA;EACE,oBAAA;A1C4ipBF;;A0C1ipBA;EACE,iBAAA;A1C6ipBF;;A0C3ipBA;EACE,UAAA;EACA,WAAA;A1C8ipBF;;A0C5ipBA;EACE,kBAAA;A1C+ipBF;;A0C7ipBA;EACE,UAAA;EACA,WAAA;A1CgjpBF;;A0C7ipBA;EACE,kBAAA;EACA,yBAAA;EACA,gCAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;A1CgjpBF;;A0C9ipBA;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;A1CijpBF;;A0C/ipBA;EACE,yBAAA;A1CkjpBF;;A0ChjpBA;EACE,+BAAA;A1CmjpBF;;A0ChjpBA;;;;;;EAME,qBAAA;EACA,cAAA;A1CmjpBF;;A0ChjpBA;;;EAGE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;A1CmjpBF;;A0ChjpBA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;A1CmjpBF;;A0ChjpBA;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;A1CmjpBF;;A0CjjpBA;EACE,SAAA;A1CojpBF;;A0CljpBA;EACE,UAAA;A1CqjpBF;;A0CnjpBA;EACE,WAAA;A1CsjpBF;;A0CpjpBA;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A1CujpBF;;A0CrjpBA;EACE,QAAA;A1CwjpBF;;A0CtjpBA;EACE,SAAA;A1CyjpBF;;A0CvjpBA;EACE,qBAAA;A1C0jpBF;;A0CvjpBA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,QAAA;A1C0jpBF;;A0CxjpBA;EACE,UAAA;A1C2jpBF;;A0CzjpBA;EACE,wBAAA;EACA,UAAA;A1C4jpBF;;A0C1jpBA;EACE,WAAA;A1C6jpBF;;A0C3jpBA;EACE,yBAAA;EACA,WAAA;A1C8jpBF;;A0C3jpBA;EACE,WAAA;A1C8jpBF;;A0C3jpBA;EACE,cAAA;EACA,kBAAA;A1C8jpBF;;A0C5jpBA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;A1C+jpBF;;A0C7jpBA;EACE,qBAAA;EACA,WAAA;EACA,WAAA;A1CgkpBF;;A0C7jpBA;EACE,cAAA;EACA,kBAAA;A1CgkpBF;;A0C9jpBA;;EAEE,qBAAA;EACA,WAAA;EACA,WAAA;A1CikpBF;;A0C9jpBA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;A1CikpBF;;A0C/jpBA;EACE,qBAAA;A1CkkpBF;;A0ChkpBA;EACE,qBAAA;A1CmkpBF;;A0CjkpBA;EACE,qBAAA;EACA,iBAAA;A1CokpBF;;A0ClkpBA;EACE,WAAA;A1CqkpBF;;A0CnkpBA;;EAEE,wBAAA;EACA,SAAA;A1CskpBF;;A0CpkpBA;EACE,0BAAA;A1CukpBF;;A0CrkpBA;EACE,gBAAA;EACA,qBAAA;A1CwkpBF;;A0CrkpBA;EACE,YAAA;EACA,8BAAA;EACA,WAAA;A1CwkpBF;;A0CtkpBA;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;A1CykpBF;;A0CvkpBA;EACE,kBAAA;EACA,iBAAA;EACA,kCAAA;A1C0kpBF;;A0CxkpBA;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;A1C2kpBF;;A0CzkpBA;EACE,gBAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;A1C4kpBF;;A0C1kpBA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;A1C6kpBF;;A0C3kpBA;EACE,eAAA;EACA,yBAAA;A1C8kpBF;;A0C5kpBA;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;A1C+kpBF;;A0C7kpBA;EACE,yBAAA;A1CglpBF;;A0C9kpBA;EACE,WAAA;A1CilpBF;;A0C/kpBA;EACE,eAAA;EACA,6BAAA;A1CklpBF;;A0C/kpBA;EACE,WAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;A1CklpBF;;A0ChlpBA;EACE,eAAA;A1CmlpBF;;A0CjlpBA;EACE,qBAAA;EACA,yBAAA;A1ColpBF;;A0CjlpBA;;EAEE,mBAAA;A1ColpBF;;A0CjlpBA;;;EAGE,WAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;A1ColpBF;;A0CjlpBA;;;;EAIE,eAAA;A1ColpBF;;A0CllpBA;;;;EAIE,qBAAA;EACA,yBAAA;A1CqlpBF;;A0CnlpBA;;;;EAIE,iBAAA;A1CslpBF;;A0CplpBA;;;;EAIE,qBAAA;EACA,yBAAA;EACA,WAAA;A1CulpBF;;A0CrlpBA;;;;EAIE,yBAAA;A1CwlpBF;;A0CtlpBA;;;;EAIE,cAAA;A1CylpBF;;A0CvlpBA;;;;EAIE,YAAA;A1C0lpBF;;A0CxlpBA;;;;EAIE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;A1C2lpBF;;A0CzlpBA;;;;EAIE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,mDAAA;A1C4lpBF;;A0C1lpBA;;;;EAIE,yBAAA;A1C6lpBF;;A0C3lpBA;;;;EAIE,mBAAA;EACA,UAAA;A1C8lpBF;;A0C5lpBA;;;;;;;;;;EAUE,qBAAA;EACA,yBAAA;EACA,WAAA;A1C+lpBF;;A0C7lpBA;;;;;;;;;;EAUE,yBAAA;A1CgmpBF;;A0C9lpBA;;;;EAIE,qBAAA;EACA,yBAAA;EACA,mBAAA;A1CimpBF;;A0C/lpBA;;;;EAIE,yBAAA;A1CkmpBF;;A0ChmpBA;;;;;;;;;;;;;;;;EAgBE,yCAAA;A1CmmpBF;;A0CjmpBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+BE,yBAAA;EACA,WAAA;A1CqmpBF;;A0CnmpBA;;;;EAIE,eAAA;EACA,WAAA;A1CsmpBF;;A0CpmpBA;;;;EAIE,6BAAA;A1CumpBF;;A0CpmpBA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;A1CumpBF;;A0CrmpBA;EACE,kBAAA;EACA,eAAA;A1CwmpBF;;A0CrmpBA;EACE,0BAAA;A1CwmpBF;;A0CrmpBA;;;EAGE,6BAAA;EACA,qBAAA;EACA,kBAAA;A1CwmpBF;;A0CtmpBA;;;EAGE,eAAA;A1CympBF;;A0CvmpBA;;;;;;EAME,yBAAA;A1C0mpBF;;A0CxmpBA;;;EAGE,yBAAA;EACA,YAAA;EACA,MAAA;A1C2mpBF;;A0CxmpBA;;;EAGE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;A1C2mpBF;;A0CzmpBA;;;EAGE,eAAA;A1C4mpBF;;A0C1mpBA;;;EAGE,aAAA;EACA,kBAAA;A1C6mpBF;;A0C1mpBA;;;EAGE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A1C6mpBF;;A0C3mpBA;;;EAGE,8BAAA;EACA,+BAAA;A1C8mpBF;;A0C5mpBA;;;EAGE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kCAAA;A1C+mpBF;;A0C7mpBA;;;EAGE,sBAAA;A1CgnpBF;;A0C9mpBA;;;EAGE,4BAAA;A1CinpBF;;A0C/mpBA;;;EAGE,yBAAA;A1CknpBF;;A0ChnpBA;;;EAGE,kBAAA;EACA,UAAA;A1CmnpBF;;A0ChnpBA;EACE,eAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;A1CmnpBF;;A0CjnpBA;EACE,eAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;A1ConpBF;;A0CjnpBA;EACE,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;A1ConpBF;;A0CjnpBA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;A1ConpBF;;A0ClnpBA;;;EAGE,WAAA;EACA,iBAAA;A1CqnpBF;;A0CnnpBA;EACE;;;IAGE,WAAA;IACA,iBAAA;E1CsnpBF;AACF;A0CpnpBA;;EAEE,kBAAA;A1CsnpBF;;A0CnnpBA;EACE,cAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,YAAA;A1CsnpBF;;A0CnnpBA;EACE,kBAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;A1CsnpBF;;A0CnnpBA;EACE,UAAA;EACA,WAAA;EACA,wBAAA;A1CsnpBF;;A0CnnpBA;EACE,UAAA;A1CsnpBF;;A0CnnpBA;EACE,WAAA;A1CsnpBF;;A0CnnpBA;EACE,uBAAA;EACA,0BAAA;EAEA,uBAAA;A1CqnpBF;;A0CjnpBE;EACE,oCAAA;EACA,mCAAA;EAEA,yBAAA;A1CmnpBJ;A0ChnpBE;EACE,4BAAA;A1CknpBJ;A0ChnpBE;EACE,yBAAA;A1CknpBJ;;A0C9mpBA;EACE,6BAAA;EACA,oBAAA;EACA,sCAAA;A1CinpBF;;A0C9mpBA;EACE,qCAAA;A1CinpBF;;A0C/mpBA;EACE,kCAAA;A1CknpBF;;A0C/mpBA;EACE,yBAAA;EACA,wBAAA;EACA,0BAAA;A1CknpBF;;A0C7mpBA;EACE,qDAAA;A1CgnpBF;;A0C9mpBA;EACE,kDAAA;A1CinpBF;;A0C9mpBA;EACE,yBAAA;EACA,YAAA;A1CinpBF;A0C9mpBE;EACE,yBAAA;A1CgnpBJ;;A0C5mpBA;EACE,uBAAA;EAEA,kBAAA;A1C8mpBF;A0C5mpBE;EACE,uFAAA;EACA,qBAAA;EACA,YAAA;A1C8mpBJ;A0C5mpBI;EAEE,uBAAA;A1C6mpBN;A0C1mpBI;EACE,gBAAA;EACA,gCAAA;EACA,iCAAA;EACA,oBAAA;A1C4mpBN;A0CzmpBI;EACE,8BAAA;EACA,oCAAA;A1C2mpBN;A0CvmpBM;EACE,8BAAA;EACA,oCAAA;EACA,YAAA;A1CympBR;A0CpmpBI;EAGE,yBAAA;A1CompBN;A0CjmpBI;EASE,mBAAA;EACA,uBAAA;EACA,gBAAA;A1C2lpBN;A0CxlpBI;EASE,yBAAA;A1CklpBN;A0C/kpBI;EAGE,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A1C+kpBN;A0C5kpBI;EACE,YAAA;A1C8kpBN;A0C5kpBM;EACE,aAAA;EAEA,kBAAA;A1C6kpBR;A0CvjpBI;EACE,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A1CyjpBN;A0CtjpBI;EAGE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EAEA,yBAAA;A1CqjpBN;A0CnjpBM;EAEE,kBAAA;A1CojpBR;;A0C7ipBA;EACE,qDAAA;A1CgjpBF;;A0C9ipBA;EACE,kDAAA;A1CijpBF;;A0C7ipBA;EACE,qDAAA;A1CgjpBF;;A0C9ipBA;EACE,kDAAA;A1CijpBF;;A0CzipBI;EASE,kCAAA;EACA,uBAAA;EACA,mBAAA;A1CoipBN;A0CjipBI;EASE,kCAAA;EACA,uCAAA;A1C2hpBN;A0CxhpBI;EAGE,6BAAA;A1CwhpBN;A0CrhpBI;EAGE,YAAA;EACA,uCAAA;A1CqhpBN;;A0C9gpBE;EACE,YAAA;A1CihpBJ;A0C/gpBI;EACE,iCAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;A1CihpBN;A0C9gpBI;EAGE,yBAAA;A1C8gpBN;A0C3gpBI;EASE,kCAAA;EACA,uBAAA;EACA,mBAAA;A1CqgpBN;A0ClgpBI;EASE,kCAAA;EACA,uCAAA;A1C4/oBN;A0Cz/oBI;EAGE,6BAAA;A1Cy/oBN;A0Ct/oBI;EAGE,cAAA;EACA,uCAAA;A1Cs/oBN;A0Cp/oBM;EACE,oCAAA;A1Cs/oBR;;A0C7+oBA;EACE,SAAA;A1Cg/oBF;;A0C7+oBA;EACE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;A1Cg/oBF;;A0C9+oBA;EACE,YAAA;EACA,WAAA;A1Ci/oBF;;A0C/+oBA;EACE,oDAAA;A1Ck/oBF;;A0Ch/oBA;EACE,oDAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;A1Cm/oBF;;A0Cj/oBA;EACE,aAAA;EACA,UAAA;A1Co/oBF;;A0Cl/oBA;EACE,oDAAA;A1Cq/oBF;;A0Cn/oBA;EACE,oDAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;A1Cs/oBF;;A0Cn/oBA;EACE,SAAA;EACA,sBAAA;A1Cs/oBF;;AA1orBA;EACE,2BAAA;AA6orBF;;AA1orBA;EACE;IACE,2BAAA;EA6orBF;AACF;AAvorBE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;AAyorBJ;AAvorBI;EACE,+BAAA;EACA,oBAAA;AAyorBN;AAtorBI;EACE,+BAAA;EACA,oBAAA;AAworBN;AArorBI;EACE,cAAA;EACA,gBAAA;AAuorBN;AAnorBE;EACE,aAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AAqorBJ;AAnorBI;EACE,cAAA;EACA,gBAAA;AAqorBN;;AA9nrBA;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAEA,oBAAA;EACA,oBAAA;EAEA,eAAA;EAEA,kBAAA;EAEA,mBAAA;EAEA,kBAAA;EAEA,kBAAA;EAEA,kBAAA;AA0nrBF;;AAvnrBA;EACE,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;AA0nrBF;AAxnrBE;EACE,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,+BAAA;EACA,2CAAA;AA0nrBJ;AAxnrBI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;AA0nrBN;AAxnrBM;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA0nrBR;AAvnrBQ;EACE,aAAA;EACA,yBAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AAynrBV;AAvnrBU;EACE,OAAA;EACA,YAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAynrBZ;AAvnrBY;EACE,UAAA;EACA,WAAA;EACA,6BAAA;AAynrBd;AAvnrBc;EACE,kBAAA;EACA,6BAAA;AAynrBhB;AAtnrBc;EACE,kBAAA;EACA,oCAAA;AAwnrBhB;AApnrBY;EACE,iBAAA;AAsnrBd;AApnrBc;EAHF;IAII,cAAA;EAunrBd;AACF;AApnrBY;EACE,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;AAsnrBd;AApnrBc;EATF;IAUI,eAAA;IACA,oBAAA;EAunrBd;AACF;AApnrBY;EAhDF;IAiDI,cAAA;EAunrBZ;AACF;AA/mrBE;EACE,qBAAA;EACA,qBAAA;EACA,kCAAA;EACA,yBAAA;AAinrBJ;AA/mrBI;EACE,qBAAA;AAinrBN;;AA1mrBA;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,wFAAA;AA6mrBF;AA3mrBE;EANF;IAOI,aAAA;EA8mrBF;AACF;;AA3mrBA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;AA8mrBF;AA5mrBE;EAVF;IAWI,eAAA;IACA,iBAAA;IACA,qBAAA;EA+mrBF;AACF;;AA1mrBE;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AA6mrBJ;AA1mrBE;EACE,eAAA;AA4mrBJ;AAzmrBE;EACE,gBAAA;AA2mrBJ;;AArmrBE;EACE,gBAAA;AAwmrBJ;;AAnmrBA;EACE,uCAAA;EACA,mCAAA;EACA,2BAAA;EACA,sBAAA;EACA,+BAAA;AAsmrBF;;AAjmrBA;EACE,+CAAA;EACA,uCAAA;EACA,8BAAA;EACA,iCAAA;EACA,iCAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;AAomrBF;;AAjmrBA;EACE;IACE,oDAAA;IACA,4CAAA;IACA,YAAA;EAomrBF;EAjmrBA;IACE,0CAAA;IACA,kCAAA;EAmmrBF;EAhmrBA;IACE,mDAAA;IACA,2CAAA;EAkmrBF;EA/lrBA;IACE,mDAAA;IACA,2CAAA;IACA,UAAA;EAimrBF;EA9lrBA;IACE,mDAAA;IACA,2CAAA;EAgmrBF;EA7lrBA;IACE,qCAAA;IACA,6BAAA;EA+lrBF;AACF","sourcesContent":["@import \"~react-json-pretty/themes/acai.css\";\n@import \"~react-mde/lib/styles/css/react-mde-all.css\";\n@import \"./styles\";\n\n@import \"../../assets/scss/bootstrap\";\n@import \"../../assets/NEW/react-code\";\n@import \"../../assets/NEW/font\";\n@import \"../../assets/NEW/skeleton\";\n@import \"../../assets/NEW/basic\";\n@import \"../../assets/NEW/react-chart\";\n@import \"../../assets/NEW/screen\";\n@import \"../../assets/NEW/select\";\n@import \"../../assets/NEW/badge\";\n@import \"../../assets/NEW/fields\";\n@import \"../../assets/NEW/sizing\";\n@import \"../../assets/NEW/onboarding\";\n@import \"../../assets/NEW/page-modal\";\n@import \"../../assets/NEW/table-mobile-card\";\n@import '../../assets/datepicker/datepicker';\n@import \"../../../node_modules/@paylixecommerce/shared/dist/cjs/assets/style.css\";\n\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n@media (max-width: 768px) {\n  .md\\:shadow-none {\n    box-shadow: none !important;\n  }\n}\n\n\n.dropdown-custom-item {\n\n  &-option {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    padding: 0 0.5rem;\n    height: 36px;\n    cursor: pointer;\n    border-radius: .375rem;\n    gap: .75rem;\n    color: var(--black5);\n    font-weight: 500;\n\n    &.selected {\n      background-color: var(--black1);\n      color: var(--black9);\n    }\n\n    &:hover {\n      background-color: var(--black1);\n      color: var(--black9);\n    }\n\n    & img {\n      width: 1.75rem;\n      height: 1.125rem;\n    }\n  }\n\n  &-value {\n    display: flex;\n    width: 100%;\n    padding: 0.25rem 1rem;\n    cursor: pointer;\n    position: absolute;\n    pointer-events: none;\n    align-items: center;\n    justify-content: flex-start;\n    color: var(--black9);\n    gap: .75rem;\n    font-weight: 500;\n\n    & img {\n      width: 1.75rem;\n      height: 1.125rem;\n    }\n  }\n\n}\n\n\nhtml.dark {\n  --black0: #121417;\n  --black1: #262A30;\n  --black2: #262A30;\n  --black3: #A2AAB4;\n  --black4: #777F89;\n  --black5: #777F89;\n  --black6: #454C56;\n  --black7: #A2AAB4;\n  --black9: white;\n  --white: #1B1F23;\n  --black: white;\n\n  --purple0: #43248e57;\n  --purple1: #43248e57;\n\n  --red0: #381E1D;\n\n  --orange0: #35241E;\n\n  --green0: #14312075;\n\n  --pink0: #70133875;\n\n  --blue0: #1E3A8A75;\n\n  --cyan0: #164E6375;\n}\n\nhtml {\n  height: 100%;\n  height: -webkit-fill-available;\n  min-height: 100%;\n  overflow: hidden;\n\n  body {\n    height: 100%;\n    height: -webkit-fill-available;\n    min-height: 100%;\n    background-color: var(--black0);\n    font-family: \"Inter\", sans-serif !important;\n\n    #app {\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n      align-items: center;\n      background: var(--black0);\n      height: 100%;\n      height: -webkit-fill-available;\n      min-height: 100%;\n\n      .app {\n        width: 100%;\n        height: 100%;\n        height: -webkit-fill-available;\n        min-height: 100%;\n        display: flex;\n        flex-direction: column;\n      }\n\n        .app-body {\n          display: flex;\n          background: var(--black0);\n          flex: 1;\n          width: 100%;\n          max-width: 100%;\n          height: 100%;\n\n          & > .main {\n            flex: 1;\n            min-width: 0;\n            background: var(--black0);\n            transition: margin-left .3s ease;\n            margin-left: 240px;\n            overflow-x: hidden;\n            overflow-y: auto;\n\n            *::-webkit-scrollbar {\n              width: 3px;\n              height: 3px;\n              background-color: transparent;\n\n              &-track {\n                border-radius: 3px;\n                background-color: transparent;\n              }\n\n              &-thumb {\n                border-radius: 3px;\n                background-color: rgba(0, 0, 0, 0.3);\n              }\n            }\n\n            &.minimized {\n              margin-left: 68px;\n\n              @media (max-width: 768px) {\n                margin-left: 0;\n              }\n            }\n\n            .container {\n              max-width: 1280px;\n              width: 100%;\n              padding: 0 1.5rem;\n              margin-right: auto;\n              margin-left: auto;\n              background: var(--black0);\n              padding-bottom: 1.5rem;\n\n              @media (max-width: 768px) {\n                padding: 0 1rem;\n                padding-bottom: 1rem;\n              }\n            }\n\n            @media (max-width: 768px) {\n              margin-left: 0;\n            }\n          }\n\n        }\n\n    }\n  }\n\n  a {\n    color: var(--purple6);\n    text-decoration: none;\n    background-color: #0000;\n    transition: all .3s ease;\n\n    &:hover {\n      color: var(--purple5);\n    }\n  }\n}\n\n\n\n.standard-block {\n  padding: 1.25rem;\n  background: var(--white);\n  border-radius: 0.5rem;\n  box-shadow: 0 2px 4px -1px rgb(7 14 35 / 8%), 0px 2px 8px -2px rgb(7 14 35 / 5%);\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n}\n\n.standard-title {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--black9);\n  margin-bottom: 1rem;\n  white-space: nowrap;\n\n  @media (max-width: 768px) {\n    font-size: 13px;\n    line-height: 16px;\n    margin-bottom: .5rem;\n  }\n}\n\n\nhtml {\n  *, :before, :after {\n    box-sizing: border-box;\n    border-width: 0;\n    border-style: solid;\n    border-color: transparent;\n  }\n\n  img, svg {\n    display: inline;\n  }\n\n  .table {\n    display: initial;\n  }\n\n}\n\n.intercom-namespace .intercom-app > div {\n  &:not(.intercom-messenger-frame) {\n    z-index: 9999999;\n  }\n}\n\n\n.custom-animation {\n  -webkit-transform: translate3d(0, 0, 0);\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  will-change: transform;\n  transform: translate3d(0, 0, 0);\n  //min-width: 200px !important;\n}\n\n\n.flipIn {\n  -webkit-backface-visibility: visible!important;\n  backface-visibility: visible!important;\n  -webkit-animation-name: flipIn;\n  -webkit-animation-duration: .35s;\n  -webkit-animation-fill-mode: both;\n  animation-name: flipIn;\n  animation-duration: .35s;\n  animation-fill-mode: both;\n}\n\n@keyframes flipIn {\n  0% {\n    -webkit-transform: perspective(600px) rotateX(50deg);\n    transform: perspective(600px) rotateX(50deg);\n    opacity: .5;\n  }\n\n  0%,40% {\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in\n  }\n\n  40% {\n    -webkit-transform: perspective(600px) rotateX(0deg);\n    transform: perspective(600px) rotateX(0deg);\n  }\n\n  60% {\n    -webkit-transform: perspective(600px) rotateX(0deg);\n    transform: perspective(600px) rotateX(0deg);\n    opacity: 1;\n  }\n\n  80% {\n    -webkit-transform: perspective(600px) rotateX(0deg);\n    transform: perspective(600px) rotateX(0deg)\n  }\n\n  to {\n    -webkit-transform: perspective(600px);\n    transform: perspective(600px)\n  }\n}\n","html {\n    --black9: #121417;\n    --black8: #1B1F23;\n    --black7: #262A30;\n    --black6: #454C56;\n    --black5: #555D67;\n    --black4: #777F89;\n    --black3: #A2AAB4;\n    --black2: #DFE5E9;\n    --black1: #E8EDF0;\n    --black0: #F5F7F8;\n    --white: white;\n    --black: #121417;\n\n    --purple9: #43248E;\n    --purple8: #5129AE;\n    --purple7: #6132cf;\n    --purple6: #6a3ce2;\n    --purple5: #8164ee;\n    --purple4: #a191f4;\n    --purple3: #c0b9f9;\n    --purple2: #dbd8fc;\n    --purple1: #eceafd;\n    --purple0: #f4f4fe;\n\n    --red9: #381E1D;\n    --red8: #60211F;\n    --red7: #A53E3E;\n    --red6: #D24242;\n    --red5: #E85757;\n    --red4: #f87171;\n    --red3: #fca5a5;\n    --red2: #fecaca;\n    --red1: #fee2e2;\n    --red0: #fef2f2;\n\n    --orange9: #35241E;\n    --orange8: #753621;\n    --orange7: #BC542A;\n    --orange6: #E16727;\n    --orange5: #F17C2A;\n    --orange4: #F69546;\n    --orange3: #FCB871;\n    --orange2: #fed7aa;\n    --orange1: #F9ECDB;\n    --orange0: #fff7ed;\n\n    --green9: #143120;\n    --green8: #166534;\n    --green7: #15803d;\n    --green6: #239F51;\n    --green5: #35C068;\n    --green4: #66DB91;\n    --green3: #8CEDAF;\n    --green2: #bbf7d0;\n    --green1: #E3F5E9;\n    --green0: #f0fdf4;\n\n    --pink9: #701338;\n    --pink8: #9D174D;\n    --pink7: #BE185D;\n    --pink6: #DB2777;\n    --pink5: #EC4899;\n    --pink4: #F472B6;\n    --pink3: #F9A8D4;\n    --pink2: #FBCFE8;\n    --pink1: #FCE7F3;\n    --pink0: #FDF2F8;\n\n    --blue9: #1E3A8A;\n    --blue8: #1E40AF;\n    --blue7: #1D4ED8;\n    --blue6: #2563EB;\n    --blue5: #3B82F6;\n    --blue4: #60A5FA;\n    --blue3: #93C5FD;\n    --blue2: #BFDBFE;\n    --blue1: #DBEAFE;\n    --blue0: #EFF6FF;\n\n    --cyan9: #164E63;\n    --cyan8: #155E75;\n    --cyan7: #0E7490;\n    --cyan6: #0891B2;\n    --cyan5: #06B6D4;\n    --cyan4: #22D3EE;\n    --cyan3: #67E8F9;\n    --cyan2: #A5F3FC;\n    --cyan1: #D4F6F9;\n    --cyan0: #EEF7F8;\n}\n\n.black9 {\n  color: #121417;\n  --black9: #121417;\n}\n.black8 {\n  color: #1B1F23;\n  --black8: #1B1F23;\n}\n.black7 {\n  color: #32373E;\n  --black7: #32373E;\n}\n.black6 {\n  color: #454C56;\n  --black6: #454C56;\n}\n.black5 {\n  color: #555D67;\n  --black5: #555D67;\n}\n.black4 {\n  color: #777F89;\n  --black4: #777F89;\n}\n.black3 {\n  color: #A2AAB4;\n  --black3: #A2AAB4;\n}\n.black2 {\n  color: #CBD2D8;\n  --black2: #CBD2D8;\n}\n.black1 {\n  color: #E8EDF0;\n  --black1: #E8EDF0;\n}\n.black0 {\n  color: #F5F7F8;\n  --black0: #F5F7F8;\n}\n\n.white {\n  color: white;\n  --white: #000000;\n}\n\n\n.purple9 {\n  color: #43248E;\n  --purple9: #43248E;\n}\n.purple8 {\n  color: #5129AE;\n  --purple8: #5129AE;\n}\n.purple7 {\n  color: #6132cf;\n  --purple7: #6132cf;\n}\n.purple6 {\n  color: #6a3ce2;\n  --purple6: #6a3ce2;\n}\n.purple5 {\n  color: #8164ee;\n  --purple5: #8164ee;\n}\n.purple4 {\n  color: #a191f4;\n  --purple4: #a191f4;\n}\n.purple3 {\n  color: #c0b9f9;\n  --purple3: #c0b9f9;\n}\n.purple2 {\n  color: #dbd8fc;\n  --purple2: #dbd8fc;\n}\n.purple1 {\n  color: #eceafd;\n  --purple1: #eceafd;\n}\n.purple0 {\n  color: #f4f4fe;\n  --purple0: #f4f4fe;\n}\n\n\n.red9 {\n  color: #7f1d1d;\n  --red9: #7f1d1d;\n}\n.red8 {\n  color: #991b1b;\n  --red8: #991b1b;\n}\n.red7 {\n  color: #b91c1c;\n  --red7: #b91c1c;\n}\n.red6 {\n  color: #dc2626;\n  --red6: #dc2626;\n}\n.red5 {\n  color: #ef4444;\n  --red5: #ef4444;\n}\n.red4 {\n  color: #f87171;\n  --red4: #f87171;\n}\n.red3 {\n  color: #fca5a5;\n  --red3: #fca5a5;\n}\n.red2 {\n  color: #fecaca;\n  --red2: #fecaca;\n}\n.red1 {\n  color: #fee2e2;\n  --red1: #fee2e2;\n}\n.red0 {\n  color: #fef2f2;\n  --red0: #fef2f2;\n}\n\n\n.orange9 {\n  color: #7c2d12;\n  --orange9: #7c2d12;\n}\n.orange8 {\n  color: #9a3412;\n  --orange8: #9a3412;\n}\n.orange7 {\n  color: #c2410c;\n  --orange7: #c2410c;\n}\n.orange6 {\n  color: #ea580c;\n  --orange6: #ea580c;\n}\n.orange5 {\n  color: #f97316;\n  --orange5: #f97316;\n}\n.orange4 {\n  color: #fb923c;\n  --orange4: #fb923c;\n}\n.orange3 {\n  color: #fdba74;\n  --orange3: #fdba74;\n}\n.orange2 {\n  color: #fed7aa;\n  --orange2: #fed7aa;\n}\n.orange1 {\n  color: #ffedd5;\n  --orange1: #ffedd5;\n}\n.orange0 {\n  color: #fff7ed;\n  --orange0: #fff7ed;\n}\n\n\n\n.green9 {\n  color: #0B321B;\n  --green9: #0B321B;\n}\n.green8 {\n  color: #166534;\n  --green8: #166534;\n}\n.green7 {\n  color: #15803d;\n  --green7: #15803d;\n}\n.green6 {\n  color: #16a34a;\n  --green6: #16a34a;\n}\n.green5 {\n  color: #22c55e;\n  --green5: #22c55e;\n}\n.green4 {\n  color: #4ade80;\n  --green4: #4ade80;\n}\n.green3 {\n  color: #86efac;\n  --green3: #86efac;\n}\n.green2 {\n  color: #bbf7d0;\n  --green2: #bbf7d0;\n}\n.green1 {\n  color: #dcfce7;\n  --green1: #dcfce7;\n}\n.green0 {\n  color: #f0fdf4;\n  --green0: #f0fdf4;\n}\n\n\n\n.font {\n  font-family: \"Inter\";\n  font-style: normal;\n  color: var(--black9);\n}\n\n.font-normal {\n  font-weight: 500;\n  --font-normal: 500;\n}\n.font-thin {\n  font-weight: 400;\n  --font-thin: 400;\n}\n\n\n.font-size-7 {\n  font-size: 40px;\n  line-height: 48px;\n}\n.font-size-6 {\n  font-size: 32px;\n  line-height: 39px;\n}\n.font-size-5 {\n  font-size: 24px;\n  line-height: 29px;\n}\n.font-size-4 {\n  font-size: 18px;\n  line-height: 22px;\n}\n.font-size-3 {\n  font-size: 16px;\n  line-height: 19px;\n}\n.font-size-2 {\n  font-size: 14px;\n  line-height: 17px;\n}\n.font-size-1 {\n  font-size: 13px;\n  line-height: 16px;\n}\n.font-size-0 {\n  font-size: 12px;\n  line-height: 15px;\n}\n\n\n\n\n\n","/*!\n * Bootstrap v5.0.2 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n// scss-docs-start import-stack\n// Configuration\n@import \"functions\";\n@import \"variables\";\n@import \"utilities\";\n\n// Layout & components\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"button-group\";\n@import \"pagination\";\n@import \"spinners\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$variable-prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$variable-prefix}#{$color}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$variable-prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$variable-prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$variable-prefix}gradient: #{$gradient};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  font-size: $font-size-root;\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\nbody {\n  margin: 0;\n  font-family: $font-family-base;\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: $body-text-align;\n  background-color: $body-bg;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba($black, 0);\n}\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n// 2. Set correct height and prevent the `size` attribute to make the `hr` look like an input field\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  background-color: currentColor;\n  border: 0;\n  opacity: $hr-opacity;\n}\n\nhr:not([size]) {\n  height: $hr-height; // 2\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1 {\n  @extend %heading;\n}\n\nh2 {\n  @extend %heading;\n}\n\nh3 {\n  @extend %heading;\n}\n\nh4 {\n  @extend %heading;\n}\n\nh5 {\n  @extend %heading;\n}\n\nh6 {\n  @extend %heading;\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-bs-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-bs-original-title] { // 1\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  text-decoration-skip-ink: none; // 4\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  direction: ltr #{\"/* rtl:ignore */\"};\n  unicode-bidi: bidi-override;\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow in Chrome from inputs built with datalists.\n// See https://stackoverflow.com/a/54997118\n\n[list]::-webkit-calendar-picker-indicator {\n  display: none;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n*::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n*::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// Inherit font family and line height for file input buttons\n\n*::file-selector-button {\n  font: inherit;\n}\n\n// 1. Change font properties to `inherit`\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::-webkit-file-upload-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n$body-text-align:           null !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n$gutters: $spacers !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * .5 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-color:                $gray-300 !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem !default;\n$border-radius-sm:            .2rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$variable-prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$variable-prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n$hr-height:                   $border-width !default;\n$hr-opacity:                  .25 !default;\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    transparent !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-striped-order:         odd !default;\n\n$table-group-separator-color: currentColor !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         .25rem !default;\n$input-btn-focus-color-opacity: .25 !default;\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\n$input-btn-focus-blur:          0 !default;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              $link-color !default;\n$btn-link-hover-color:        $link-hover-color !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       $text-muted !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           $body-color !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 1px solid rgba($black, .25) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba(0, 0, 0, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $gray-200 !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             $gray-300 !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             $gray-500 !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             $input-group-addon-bg !default;\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:       1.25 !default;\n$form-floating-padding-x:         $input-padding-x !default;\n$form-floating-padding-y:         1rem !default;\n$form-floating-input-padding-t:   1.625rem !default;\n$form-floating-input-padding-b:   .625rem !default;\n$form-floating-label-opacity:     .65 !default;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-offcanvas:                  1050 !default;\n$zindex-modal:                      1060 !default;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    $link-color !default;\n$nav-link-hover-color:              $link-hover-color !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .55) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n// scss-docs-end navbar-theme-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         shade-color($gray-900, 10%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-radius:          $border-radius !default;\n$pagination-margin-start:           -$pagination-border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-color:            $link-hover-color !default;\n$pagination-focus-bg:               $gray-200 !default;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n// scss-docs-end pagination-variables\n\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         $body-color !default;\n$accordion-bg:                            $body-bg !default;\n$accordion-border-width:                  $border-width !default;\n$accordion-border-color:                  rgba($black, .125) !default;\n$accordion-border-radius:                 $border-radius !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  $accordion-color !default;\n$accordion-button-bg:                     $accordion-bg !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           $border-radius !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            $border-width !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               $box-shadow-inset !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  $gray-900 !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              $box-shadow-sm !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              $gray-600 !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                $modal-content-bg !default;\n$offcanvas-color:                   $modal-content-color !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         null !default;\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n\n.initialism {\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  line-height: $btn-line-height;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n\n  &:hover {\n    color: $body-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active {\n\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    pointer-events: none;\n    opacity: $btn-disabled-opacity;\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $btn-link-color;\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: $btn-link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n  }\n}\n",".fade {\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n}\n",".pagination {\n  display: flex;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    color: $pagination-focus-color;\n    background-color: $pagination-focus-bg;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n\n}\n\n","//\n// Rotating border\n//\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentColor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: $spinner-animation-speed linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentColor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: $spinner-animation-speed linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: $spinner-animation-speed * 2;\n    }\n  }\n}\n",".react-code-input {\n  width: 100%;\n\n  input {\n    -webkit-appearance: none !important;\n    -moz-appearance: none !important;\n    appearance: none !important;\n    box-shadow: none !important;\n    border: 1px solid var(--black1) !important;\n    background: var(--white) !important;\n    border-radius: 0 !important;\n    color: var(--black9) !important;\n    transition: border 0.3s ease !important;\n    height: 48px !important;\n    outline: none !important;\n    border-right: none !important;\n    text-align: center;\n    margin: 0 !important;\n    padding: 0 0.25rem !important;\n    font-size: 32px;\n    width: calc(100%/8) !important;\n    font-family: \"Inter\", sans-serif !important;\n    -moz-appearance: textfield !important;\n\n    &:first-child {\n      border-radius: .5rem 0 0 .5rem !important;\n    }\n    &:last-child {\n      border-radius: 0 .5rem .5rem 0 !important;\n      border-right: 1px solid var(--black1) !important;\n    }\n\n    &[type=\"number\"] {\n      -moz-appearance: textfield !important;\n    }\n    &[type=\"number\"]:hover,\n    &[type=\"number\"]:focus {\n      -moz-appearance: textfield !important;\n    }\n\n    &[type='number']::-webkit-inner-spin-button,\n    &[type='number']::-webkit-outer-spin-button,\n    &[type='number']:hover::-webkit-inner-spin-button,\n    &[type='number']:hover::-webkit-outer-spin-button {\n      -webkit-appearance: none;\n      -moz-appearance: textfield;\n      appearance: none;\n      margin: 0;\n    }\n\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n    &[type=number] {\n      -moz-appearance: textfield !important;\n    }\n  }\n}","/*!\n * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n// Font Awesome core compile (Web Fonts-based)\n// -------------------------\n\n@import 'functions';\n@import 'variables';\n@import 'mixins';\n@import 'core';\n@import 'sizing';\n@import 'fixed-width';\n@import 'list';\n@import 'bordered-pulled';\n@import 'animated';\n@import 'rotated-flipped';\n@import 'stacked';\n@import 'icons';\n@import 'screen-reader';\n","// base icon class definition\n// -------------------------\n\n.#{$fa-css-prefix} {\n  font-family: var(--#{$fa-css-prefix}-style-family, '#{$fa-style-family}');\n  font-weight: var(--#{$fa-css-prefix}-style, #{$fa-style});\n}\n\n.#{$fa-css-prefix},\n.fas,\n.fa-solid,\n.far,\n.fa-regular,\n.fal,\n.fa-light,\n.fat,\n.fa-thin,\n.fad,\n.fa-duotone,\n.fab,\n.fa-brands {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: var(--#{$fa-css-prefix}-display, #{$fa-display});\n  font-style: normal;\n  font-variant: normal;\n  line-height: 1;\n  text-rendering: auto;\n}\n\n%fa-icon {\n  @include fa-icon;\n}\n","// sizing icons\n// -------------------------\n\n// literal magnification scale\n@for $i from 1 through 10 {\n  .#{$fa-css-prefix}-#{$i}x {\n    font-size: $i * 1em;\n  }\n}\n\n// step-based scale (with alignment)\n@each $size, $value in $fa-sizes {\n  .#{$fa-css-prefix}-#{$size} {\n     @include fa-size($value);\n  }\n}\n","// mixins\n// --------------------------\n\n// base rendering for an icon\n@mixin fa-icon {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  line-height: 1;\n}\n\n// sets relative font-sizing and alignment (in _sizing)\n@mixin fa-size ($font-size) {\n  font-size: (divide($font-size, $fa-size-scale-base)) * 1em; // converts step in sizing scale into an em-based value that's relative to the scale's base\n  line-height: (divide(1, $font-size)) * 1em; // sets the line-height of the icon back to that of it's parent\n  vertical-align: ((divide(6, $font-size)) - (divide(3, 8))) * 1em; // vertically centers the icon taking into account the surrounding text's descender\n}\n\n// only display content to screen readers\n// see: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// see: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n@mixin fa-sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n@mixin fa-sr-only-focusable() {\n  &:not(:focus) {\n    @include fa-sr-only();\n  }\n}\n","// fixed-width icons\n// -------------------------\n\n.#{$fa-css-prefix}-fw {\n  text-align: center;\n  width: $fa-fw-width;\n}\n","// variables\n// --------------------------\n\n$fa-css-prefix          : fa !default;\n$fa-style               : 900 !default;\n$fa-style-family        : \"Font Awesome 6 Pro\" !default;\n\n$fa-display             : inline-block !default;\n\n$fa-fw-width            : (divide(20em, 16));\n$fa-inverse             : #fff !default;\n\n$fa-border-color        : #eee !default;\n$fa-border-padding      : .2em .25em .15em !default;\n$fa-border-radius       : .1em !default;\n$fa-border-style        : solid !default;\n$fa-border-width        : .08em !default;\n\n$fa-size-scale-2xs      : 10 !default;\n$fa-size-scale-xs       : 12 !default;\n$fa-size-scale-sm       : 14 !default;\n$fa-size-scale-base     : 16 !default;\n$fa-size-scale-lg       : 20 !default;\n$fa-size-scale-xl       : 24 !default;\n$fa-size-scale-2xl      : 32 !default;\n\n$fa-sizes: (\n  \"2xs\"                 : $fa-size-scale-2xs,\n  \"xs\"                  : $fa-size-scale-xs,\n  \"sm\"                  : $fa-size-scale-sm,\n  \"lg\"                  : $fa-size-scale-lg,\n  \"xl\"                  : $fa-size-scale-xl,\n  \"2xl\"                 : $fa-size-scale-2xl\n) !default;\n\n$fa-li-width            : 2em !default;\n$fa-li-margin           : ($fa-li-width * divide(5, 4)) !default;\n\n$fa-pull-margin         : .3em !default;\n\n$fa-primary-opacity     : 1 !default;\n$fa-secondary-opacity   : .4 !default;\n\n$fa-stack-vertical-align: middle !default;\n$fa-stack-width         : ($fa-fw-width * 2) !default;\n$fa-stack-z-index       : auto !default;\n\n$fa-font-display        : block !default;\n$fa-font-path           : \"~assets/fontawesome/scss/webfonts\" !default;\n\n// convenience function used to set content property\n@function fa-content($fa-var) {\n  @return unquote(\"\\\"#{ $fa-var }\\\"\");\n}\n\n$fa-var-0: \\30;\n$fa-var-1: \\31;\n$fa-var-2: \\32;\n$fa-var-3: \\33;\n$fa-var-4: \\34;\n$fa-var-5: \\35;\n$fa-var-6: \\36;\n$fa-var-7: \\37;\n$fa-var-8: \\38;\n$fa-var-9: \\39;\n$fa-var-360-degrees: \\e2dc;\n$fa-var-a: \\41;\n$fa-var-abacus: \\f640;\n$fa-var-accent-grave: \\60;\n$fa-var-acorn: \\f6ae;\n$fa-var-address-book: \\f2b9;\n$fa-var-contact-book: \\f2b9;\n$fa-var-address-card: \\f2bb;\n$fa-var-contact-card: \\f2bb;\n$fa-var-vcard: \\f2bb;\n$fa-var-air-conditioner: \\f8f4;\n$fa-var-airplay: \\e089;\n$fa-var-alarm-clock: \\f34e;\n$fa-var-alarm-exclamation: \\f843;\n$fa-var-alarm-plus: \\f844;\n$fa-var-alarm-snooze: \\f845;\n$fa-var-album: \\f89f;\n$fa-var-album-collection: \\f8a0;\n$fa-var-alicorn: \\f6b0;\n$fa-var-alien: \\f8f5;\n$fa-var-alien-8bit: \\f8f6;\n$fa-var-alien-monster: \\f8f6;\n$fa-var-align-center: \\f037;\n$fa-var-align-justify: \\f039;\n$fa-var-align-left: \\f036;\n$fa-var-align-right: \\f038;\n$fa-var-align-slash: \\f846;\n$fa-var-alt: \\e08a;\n$fa-var-amp-guitar: \\f8a1;\n$fa-var-ampersand: \\26;\n$fa-var-anchor: \\f13d;\n$fa-var-angel: \\f779;\n$fa-var-angle: \\e08c;\n$fa-var-angle-90: \\e08d;\n$fa-var-angle-down: \\f107;\n$fa-var-angle-left: \\f104;\n$fa-var-angle-right: \\f105;\n$fa-var-angle-up: \\f106;\n$fa-var-angles-down: \\f103;\n$fa-var-angle-double-down: \\f103;\n$fa-var-angles-left: \\f100;\n$fa-var-angle-double-left: \\f100;\n$fa-var-angles-right: \\f101;\n$fa-var-angle-double-right: \\f101;\n$fa-var-angles-up: \\f102;\n$fa-var-angle-double-up: \\f102;\n$fa-var-ankh: \\f644;\n$fa-var-aperture: \\e2df;\n$fa-var-apostrophe: \\27;\n$fa-var-apple-core: \\e08f;\n$fa-var-apple-whole: \\f5d1;\n$fa-var-apple-alt: \\f5d1;\n$fa-var-archway: \\f557;\n$fa-var-arrow-down: \\f063;\n$fa-var-arrow-down-1-9: \\f162;\n$fa-var-sort-numeric-asc: \\f162;\n$fa-var-sort-numeric-down: \\f162;\n$fa-var-arrow-down-9-1: \\f886;\n$fa-var-sort-numeric-desc: \\f886;\n$fa-var-sort-numeric-down-alt: \\f886;\n$fa-var-arrow-down-a-z: \\f15d;\n$fa-var-sort-alpha-asc: \\f15d;\n$fa-var-sort-alpha-down: \\f15d;\n$fa-var-arrow-down-arrow-up: \\f883;\n$fa-var-sort-alt: \\f883;\n$fa-var-arrow-down-big-small: \\f88c;\n$fa-var-sort-size-down: \\f88c;\n$fa-var-arrow-down-from-dotted-line: \\e090;\n$fa-var-arrow-down-from-line: \\f345;\n$fa-var-arrow-from-top: \\f345;\n$fa-var-arrow-down-left: \\e091;\n$fa-var-arrow-down-left-and-arrow-up-right-to-center: \\e092;\n$fa-var-arrow-down-long: \\f175;\n$fa-var-long-arrow-down: \\f175;\n$fa-var-arrow-down-right: \\e093;\n$fa-var-arrow-down-short-wide: \\f884;\n$fa-var-sort-amount-desc: \\f884;\n$fa-var-sort-amount-down-alt: \\f884;\n$fa-var-arrow-down-small-big: \\f88d;\n$fa-var-sort-size-down-alt: \\f88d;\n$fa-var-arrow-down-square-triangle: \\f889;\n$fa-var-sort-shapes-down-alt: \\f889;\n$fa-var-arrow-down-to-bracket: \\e094;\n$fa-var-arrow-down-to-dotted-line: \\e095;\n$fa-var-arrow-down-to-line: \\f33d;\n$fa-var-arrow-to-bottom: \\f33d;\n$fa-var-arrow-down-to-square: \\e096;\n$fa-var-arrow-down-triangle-square: \\f888;\n$fa-var-sort-shapes-down: \\f888;\n$fa-var-arrow-down-wide-short: \\f160;\n$fa-var-sort-amount-asc: \\f160;\n$fa-var-sort-amount-down: \\f160;\n$fa-var-arrow-down-z-a: \\f881;\n$fa-var-sort-alpha-desc: \\f881;\n$fa-var-sort-alpha-down-alt: \\f881;\n$fa-var-arrow-left: \\f060;\n$fa-var-arrow-left-from-line: \\f344;\n$fa-var-arrow-from-right: \\f344;\n$fa-var-arrow-left-long: \\f177;\n$fa-var-long-arrow-left: \\f177;\n$fa-var-arrow-left-long-to-line: \\e3d4;\n$fa-var-arrow-left-to-line: \\f33e;\n$fa-var-arrow-to-left: \\f33e;\n$fa-var-arrow-pointer: \\f245;\n$fa-var-mouse-pointer: \\f245;\n$fa-var-arrow-right: \\f061;\n$fa-var-arrow-right-arrow-left: \\f0ec;\n$fa-var-exchange: \\f0ec;\n$fa-var-arrow-right-from-bracket: \\f08b;\n$fa-var-sign-out: \\f08b;\n$fa-var-arrow-right-from-line: \\f343;\n$fa-var-arrow-from-left: \\f343;\n$fa-var-arrow-right-long: \\f178;\n$fa-var-long-arrow-right: \\f178;\n$fa-var-arrow-right-long-to-line: \\e3d5;\n$fa-var-arrow-right-to-bracket: \\f090;\n$fa-var-sign-in: \\f090;\n$fa-var-arrow-right-to-line: \\f340;\n$fa-var-arrow-to-right: \\f340;\n$fa-var-arrow-rotate-left: \\f0e2;\n$fa-var-arrow-left-rotate: \\f0e2;\n$fa-var-arrow-rotate-back: \\f0e2;\n$fa-var-arrow-rotate-backward: \\f0e2;\n$fa-var-undo: \\f0e2;\n$fa-var-arrow-rotate-right: \\f01e;\n$fa-var-arrow-right-rotate: \\f01e;\n$fa-var-arrow-rotate-forward: \\f01e;\n$fa-var-redo: \\f01e;\n$fa-var-arrow-trend-down: \\e097;\n$fa-var-arrow-trend-up: \\e098;\n$fa-var-arrow-turn-down: \\f149;\n$fa-var-level-down: \\f149;\n$fa-var-arrow-turn-down-left: \\e2e1;\n$fa-var-arrow-turn-down-right: \\e3d6;\n$fa-var-arrow-turn-up: \\f148;\n$fa-var-level-up: \\f148;\n$fa-var-arrow-up: \\f062;\n$fa-var-arrow-up-1-9: \\f163;\n$fa-var-sort-numeric-up: \\f163;\n$fa-var-arrow-up-9-1: \\f887;\n$fa-var-sort-numeric-up-alt: \\f887;\n$fa-var-arrow-up-a-z: \\f15e;\n$fa-var-sort-alpha-up: \\f15e;\n$fa-var-arrow-up-arrow-down: \\e099;\n$fa-var-sort-up-down: \\e099;\n$fa-var-arrow-up-big-small: \\f88e;\n$fa-var-sort-size-up: \\f88e;\n$fa-var-arrow-up-from-bracket: \\e09a;\n$fa-var-arrow-up-from-dotted-line: \\e09b;\n$fa-var-arrow-up-from-line: \\f342;\n$fa-var-arrow-from-bottom: \\f342;\n$fa-var-arrow-up-from-square: \\e09c;\n$fa-var-arrow-up-left: \\e09d;\n$fa-var-arrow-up-left-from-circle: \\e09e;\n$fa-var-arrow-up-long: \\f176;\n$fa-var-long-arrow-up: \\f176;\n$fa-var-arrow-up-right: \\e09f;\n$fa-var-arrow-up-right-and-arrow-down-left-from-center: \\e0a0;\n$fa-var-arrow-up-right-from-square: \\f08e;\n$fa-var-external-link: \\f08e;\n$fa-var-arrow-up-short-wide: \\f885;\n$fa-var-sort-amount-up-alt: \\f885;\n$fa-var-arrow-up-small-big: \\f88f;\n$fa-var-sort-size-up-alt: \\f88f;\n$fa-var-arrow-up-square-triangle: \\f88b;\n$fa-var-sort-shapes-up-alt: \\f88b;\n$fa-var-arrow-up-to-dotted-line: \\e0a1;\n$fa-var-arrow-up-to-line: \\f341;\n$fa-var-arrow-to-top: \\f341;\n$fa-var-arrow-up-triangle-square: \\f88a;\n$fa-var-sort-shapes-up: \\f88a;\n$fa-var-arrow-up-wide-short: \\f161;\n$fa-var-sort-amount-up: \\f161;\n$fa-var-arrow-up-z-a: \\f882;\n$fa-var-sort-alpha-up-alt: \\f882;\n$fa-var-arrows-cross: \\e0a2;\n$fa-var-arrows-from-dotted-line: \\e0a3;\n$fa-var-arrows-from-line: \\e0a4;\n$fa-var-arrows-left-right: \\f07e;\n$fa-var-arrows-h: \\f07e;\n$fa-var-arrows-maximize: \\f31d;\n$fa-var-expand-arrows: \\f31d;\n$fa-var-arrows-minimize: \\e0a5;\n$fa-var-compress-arrows: \\e0a5;\n$fa-var-arrows-repeat: \\f364;\n$fa-var-repeat-alt: \\f364;\n$fa-var-arrows-repeat-1: \\f366;\n$fa-var-repeat-1-alt: \\f366;\n$fa-var-arrows-retweet: \\f361;\n$fa-var-retweet-alt: \\f361;\n$fa-var-arrows-rotate: \\f021;\n$fa-var-refresh: \\f021;\n$fa-var-sync: \\f021;\n$fa-var-arrows-to-dotted-line: \\e0a6;\n$fa-var-arrows-to-line: \\e0a7;\n$fa-var-arrows-up-down: \\f07d;\n$fa-var-arrows-v: \\f07d;\n$fa-var-arrows-up-down-left-right: \\f047;\n$fa-var-arrows: \\f047;\n$fa-var-asterisk: \\2a;\n$fa-var-at: \\40;\n$fa-var-atom: \\f5d2;\n$fa-var-atom-simple: \\f5d3;\n$fa-var-atom-alt: \\f5d3;\n$fa-var-audio-description: \\f29e;\n$fa-var-audio-description-slash: \\e0a8;\n$fa-var-austral-sign: \\e0a9;\n$fa-var-avocado: \\e0aa;\n$fa-var-award: \\f559;\n$fa-var-award-simple: \\e0ab;\n$fa-var-axe: \\f6b2;\n$fa-var-axe-battle: \\f6b3;\n$fa-var-b: \\42;\n$fa-var-baby: \\f77c;\n$fa-var-baby-carriage: \\f77d;\n$fa-var-carriage-baby: \\f77d;\n$fa-var-backpack: \\f5d4;\n$fa-var-backward: \\f04a;\n$fa-var-backward-fast: \\f049;\n$fa-var-fast-backward: \\f049;\n$fa-var-backward-step: \\f048;\n$fa-var-step-backward: \\f048;\n$fa-var-bacon: \\f7e5;\n$fa-var-bacteria: \\e059;\n$fa-var-bacterium: \\e05a;\n$fa-var-badge: \\f335;\n$fa-var-badge-check: \\f336;\n$fa-var-badge-dollar: \\f645;\n$fa-var-badge-percent: \\f646;\n$fa-var-badge-sheriff: \\f8a2;\n$fa-var-badger-honey: \\f6b4;\n$fa-var-badminton: \\e33a;\n$fa-var-bag-shopping: \\f290;\n$fa-var-shopping-bag: \\f290;\n$fa-var-bagel: \\e3d7;\n$fa-var-bags-shopping: \\f847;\n$fa-var-baguette: \\e3d8;\n$fa-var-bahai: \\f666;\n$fa-var-baht-sign: \\e0ac;\n$fa-var-ball-pile: \\f77e;\n$fa-var-balloon: \\e2e3;\n$fa-var-balloons: \\e2e4;\n$fa-var-ballot: \\f732;\n$fa-var-ballot-check: \\f733;\n$fa-var-ban: \\f05e;\n$fa-var-cancel: \\f05e;\n$fa-var-ban-bug: \\f7f9;\n$fa-var-debug: \\f7f9;\n$fa-var-ban-parking: \\f616;\n$fa-var-parking-circle-slash: \\f616;\n$fa-var-ban-smoking: \\f54d;\n$fa-var-smoking-ban: \\f54d;\n$fa-var-banana: \\e2e5;\n$fa-var-bandage: \\f462;\n$fa-var-band-aid: \\f462;\n$fa-var-bangladeshi-taka-sign: \\e2e6;\n$fa-var-banjo: \\f8a3;\n$fa-var-bank: \\f19c;\n$fa-var-institution: \\f19c;\n$fa-var-university: \\f19c;\n$fa-var-barcode: \\f02a;\n$fa-var-barcode-read: \\f464;\n$fa-var-barcode-scan: \\f465;\n$fa-var-bars: \\f0c9;\n$fa-var-navicon: \\f0c9;\n$fa-var-bars-filter: \\e0ad;\n$fa-var-bars-progress: \\f828;\n$fa-var-tasks-alt: \\f828;\n$fa-var-bars-sort: \\e0ae;\n$fa-var-bars-staggered: \\f550;\n$fa-var-reorder: \\f550;\n$fa-var-stream: \\f550;\n$fa-var-baseball: \\f433;\n$fa-var-baseball-ball: \\f433;\n$fa-var-baseball-bat-ball: \\f432;\n$fa-var-basket-shopping: \\f291;\n$fa-var-shopping-basket: \\f291;\n$fa-var-basket-shopping-simple: \\e0af;\n$fa-var-shopping-basket-alt: \\e0af;\n$fa-var-basketball: \\f434;\n$fa-var-basketball-ball: \\f434;\n$fa-var-basketball-hoop: \\f435;\n$fa-var-bat: \\f6b5;\n$fa-var-bath: \\f2cd;\n$fa-var-bathtub: \\f2cd;\n$fa-var-battery-bolt: \\f376;\n$fa-var-battery-empty: \\f244;\n$fa-var-battery-0: \\f244;\n$fa-var-battery-exclamation: \\e0b0;\n$fa-var-battery-full: \\f240;\n$fa-var-battery: \\f240;\n$fa-var-battery-5: \\f240;\n$fa-var-battery-half: \\f242;\n$fa-var-battery-3: \\f242;\n$fa-var-battery-low: \\e0b1;\n$fa-var-battery-1: \\e0b1;\n$fa-var-battery-quarter: \\f243;\n$fa-var-battery-2: \\f243;\n$fa-var-battery-slash: \\f377;\n$fa-var-battery-three-quarters: \\f241;\n$fa-var-battery-4: \\f241;\n$fa-var-bed: \\f236;\n$fa-var-bed-bunk: \\f8f8;\n$fa-var-bed-empty: \\f8f9;\n$fa-var-bed-front: \\f8f7;\n$fa-var-bed-alt: \\f8f7;\n$fa-var-bed-pulse: \\f487;\n$fa-var-procedures: \\f487;\n$fa-var-bee: \\e0b2;\n$fa-var-beer-mug: \\e0b3;\n$fa-var-beer-foam: \\e0b3;\n$fa-var-beer-mug-empty: \\f0fc;\n$fa-var-beer: \\f0fc;\n$fa-var-bell: \\f0f3;\n$fa-var-bell-concierge: \\f562;\n$fa-var-concierge-bell: \\f562;\n$fa-var-bell-exclamation: \\f848;\n$fa-var-bell-on: \\f8fa;\n$fa-var-bell-plus: \\f849;\n$fa-var-bell-school: \\f5d5;\n$fa-var-bell-school-slash: \\f5d6;\n$fa-var-bell-slash: \\f1f6;\n$fa-var-bells: \\f77f;\n$fa-var-bench-tree: \\e2e7;\n$fa-var-bezier-curve: \\f55b;\n$fa-var-bicycle: \\f206;\n$fa-var-binary: \\e33b;\n$fa-var-binary-circle-check: \\e33c;\n$fa-var-binary-lock: \\e33d;\n$fa-var-binary-slash: \\e33e;\n$fa-var-binoculars: \\f1e5;\n$fa-var-biohazard: \\f780;\n$fa-var-bitcoin-sign: \\e0b4;\n$fa-var-blanket: \\f498;\n$fa-var-blanket-fire: \\e3da;\n$fa-var-blender: \\f517;\n$fa-var-blender-phone: \\f6b6;\n$fa-var-blinds: \\f8fb;\n$fa-var-blinds-open: \\f8fc;\n$fa-var-blinds-raised: \\f8fd;\n$fa-var-block-brick: \\e3db;\n$fa-var-wall-brick: \\e3db;\n$fa-var-block-brick-fire: \\e3dc;\n$fa-var-firewall: \\e3dc;\n$fa-var-block-question: \\e3dd;\n$fa-var-block-quote: \\e0b5;\n$fa-var-blog: \\f781;\n$fa-var-blueberries: \\e2e8;\n$fa-var-bold: \\f032;\n$fa-var-bolt: \\f0e7;\n$fa-var-flash: \\f0e7;\n$fa-var-bolt-auto: \\e0b6;\n$fa-var-bolt-lightning: \\e0b7;\n$fa-var-bolt-slash: \\e0b8;\n$fa-var-bomb: \\f1e2;\n$fa-var-bone: \\f5d7;\n$fa-var-bone-break: \\f5d8;\n$fa-var-bong: \\f55c;\n$fa-var-book: \\f02d;\n$fa-var-book-arrow-right: \\e0b9;\n$fa-var-book-arrow-up: \\e0ba;\n$fa-var-book-atlas: \\f558;\n$fa-var-atlas: \\f558;\n$fa-var-book-bible: \\f647;\n$fa-var-bible: \\f647;\n$fa-var-book-blank: \\f5d9;\n$fa-var-book-alt: \\f5d9;\n$fa-var-book-bookmark: \\e0bb;\n$fa-var-book-circle-arrow-right: \\e0bc;\n$fa-var-book-circle-arrow-up: \\e0bd;\n$fa-var-book-copy: \\e0be;\n$fa-var-book-font: \\e0bf;\n$fa-var-book-heart: \\f499;\n$fa-var-book-journal-whills: \\f66a;\n$fa-var-journal-whills: \\f66a;\n$fa-var-book-medical: \\f7e6;\n$fa-var-book-open: \\f518;\n$fa-var-book-open-cover: \\e0c0;\n$fa-var-book-open-alt: \\e0c0;\n$fa-var-book-open-reader: \\f5da;\n$fa-var-book-reader: \\f5da;\n$fa-var-book-quran: \\f687;\n$fa-var-quran: \\f687;\n$fa-var-book-section: \\e0c1;\n$fa-var-book-law: \\e0c1;\n$fa-var-book-skull: \\f6b7;\n$fa-var-book-dead: \\f6b7;\n$fa-var-book-sparkles: \\f6b8;\n$fa-var-book-spells: \\f6b8;\n$fa-var-book-tanakh: \\f827;\n$fa-var-tanakh: \\f827;\n$fa-var-book-user: \\f7e7;\n$fa-var-bookmark: \\f02e;\n$fa-var-bookmark-slash: \\e0c2;\n$fa-var-books: \\f5db;\n$fa-var-books-medical: \\f7e8;\n$fa-var-boombox: \\f8a5;\n$fa-var-boot: \\f782;\n$fa-var-boot-heeled: \\e33f;\n$fa-var-booth-curtain: \\f734;\n$fa-var-border-all: \\f84c;\n$fa-var-border-bottom: \\f84d;\n$fa-var-border-bottom-right: \\f854;\n$fa-var-border-style-alt: \\f854;\n$fa-var-border-center-h: \\f89c;\n$fa-var-border-center-v: \\f89d;\n$fa-var-border-inner: \\f84e;\n$fa-var-border-left: \\f84f;\n$fa-var-border-none: \\f850;\n$fa-var-border-outer: \\f851;\n$fa-var-border-right: \\f852;\n$fa-var-border-top: \\f855;\n$fa-var-border-top-left: \\f853;\n$fa-var-border-style: \\f853;\n$fa-var-bow-arrow: \\f6b9;\n$fa-var-bowl-chopsticks: \\e2e9;\n$fa-var-bowl-chopsticks-noodles: \\e2ea;\n$fa-var-bowl-hot: \\f823;\n$fa-var-soup: \\f823;\n$fa-var-bowl-rice: \\e2eb;\n$fa-var-bowl-scoop: \\e3de;\n$fa-var-bowl-shaved-ice: \\e3de;\n$fa-var-bowl-scoops: \\e3df;\n$fa-var-bowl-spoon: \\e3e0;\n$fa-var-bowling-ball: \\f436;\n$fa-var-bowling-ball-pin: \\e0c3;\n$fa-var-bowling-pins: \\f437;\n$fa-var-box: \\f466;\n$fa-var-box-archive: \\f187;\n$fa-var-archive: \\f187;\n$fa-var-box-ballot: \\f735;\n$fa-var-box-check: \\f467;\n$fa-var-box-circle-check: \\e0c4;\n$fa-var-box-dollar: \\f4a0;\n$fa-var-box-usd: \\f4a0;\n$fa-var-box-heart: \\f49d;\n$fa-var-box-open: \\f49e;\n$fa-var-box-open-full: \\f49c;\n$fa-var-box-full: \\f49c;\n$fa-var-box-taped: \\f49a;\n$fa-var-box-alt: \\f49a;\n$fa-var-box-tissue: \\e05b;\n$fa-var-boxes-stacked: \\f468;\n$fa-var-boxes: \\f468;\n$fa-var-boxes-alt: \\f468;\n$fa-var-boxing-glove: \\f438;\n$fa-var-glove-boxing: \\f438;\n$fa-var-bracket-curly: \\7b;\n$fa-var-bracket-curly-left: \\7b;\n$fa-var-bracket-curly-right: \\7d;\n$fa-var-bracket-round: \\28;\n$fa-var-parenthesis: \\28;\n$fa-var-bracket-round-right: \\29;\n$fa-var-bracket-square: \\5b;\n$fa-var-bracket: \\5b;\n$fa-var-bracket-left: \\5b;\n$fa-var-bracket-square-right: \\5d;\n$fa-var-brackets-curly: \\f7ea;\n$fa-var-brackets-round: \\e0c5;\n$fa-var-parentheses: \\e0c5;\n$fa-var-brackets-square: \\f7e9;\n$fa-var-brackets: \\f7e9;\n$fa-var-braille: \\f2a1;\n$fa-var-brain: \\f5dc;\n$fa-var-brain-arrow-curved-right: \\f677;\n$fa-var-mind-share: \\f677;\n$fa-var-brain-circuit: \\e0c6;\n$fa-var-brake-warning: \\e0c7;\n$fa-var-bread-loaf: \\f7eb;\n$fa-var-bread-slice: \\f7ec;\n$fa-var-bread-slice-butter: \\e3e1;\n$fa-var-briefcase: \\f0b1;\n$fa-var-briefcase-arrow-right: \\e2f2;\n$fa-var-briefcase-blank: \\e0c8;\n$fa-var-briefcase-medical: \\f469;\n$fa-var-brightness: \\e0c9;\n$fa-var-brightness-low: \\e0ca;\n$fa-var-bring-forward: \\f856;\n$fa-var-bring-front: \\f857;\n$fa-var-broccoli: \\e3e2;\n$fa-var-broom: \\f51a;\n$fa-var-browser: \\f37e;\n$fa-var-browsers: \\e0cb;\n$fa-var-brush: \\f55d;\n$fa-var-bug: \\f188;\n$fa-var-building: \\f1ad;\n$fa-var-buildings: \\e0cc;\n$fa-var-bullhorn: \\f0a1;\n$fa-var-bullseye: \\f140;\n$fa-var-bullseye-arrow: \\f648;\n$fa-var-bullseye-pointer: \\f649;\n$fa-var-burger: \\f805;\n$fa-var-hamburger: \\f805;\n$fa-var-burger-cheese: \\f7f1;\n$fa-var-cheeseburger: \\f7f1;\n$fa-var-burger-fries: \\e0cd;\n$fa-var-burger-glass: \\e0ce;\n$fa-var-burger-lettuce: \\e3e3;\n$fa-var-burger-soda: \\f858;\n$fa-var-burrito: \\f7ed;\n$fa-var-bus: \\f207;\n$fa-var-bus-school: \\f5dd;\n$fa-var-bus-simple: \\f55e;\n$fa-var-bus-alt: \\f55e;\n$fa-var-business-time: \\f64a;\n$fa-var-briefcase-clock: \\f64a;\n$fa-var-butter: \\e3e4;\n$fa-var-c: \\43;\n$fa-var-cabinet-filing: \\f64b;\n$fa-var-cable-car: \\e0cf;\n$fa-var-cactus: \\f8a7;\n$fa-var-cake-candles: \\f1fd;\n$fa-var-birthday-cake: \\f1fd;\n$fa-var-cake-slice: \\e3e5;\n$fa-var-shortcake: \\e3e5;\n$fa-var-calculator: \\f1ec;\n$fa-var-calculator-simple: \\f64c;\n$fa-var-calculator-alt: \\f64c;\n$fa-var-calendar: \\f133;\n$fa-var-calendar-arrow-down: \\e0d0;\n$fa-var-calendar-download: \\e0d0;\n$fa-var-calendar-arrow-up: \\e0d1;\n$fa-var-calendar-upload: \\e0d1;\n$fa-var-calendar-check: \\f274;\n$fa-var-calendar-clock: \\e0d2;\n$fa-var-calendar-time: \\e0d2;\n$fa-var-calendar-day: \\f783;\n$fa-var-calendar-days: \\f073;\n$fa-var-calendar-alt: \\f073;\n$fa-var-calendar-exclamation: \\f334;\n$fa-var-calendar-heart: \\e0d3;\n$fa-var-calendar-image: \\e0d4;\n$fa-var-calendar-lines: \\e0d5;\n$fa-var-calendar-note: \\e0d5;\n$fa-var-calendar-minus: \\f272;\n$fa-var-calendar-pen: \\f333;\n$fa-var-calendar-edit: \\f333;\n$fa-var-calendar-plus: \\f271;\n$fa-var-calendar-range: \\e0d6;\n$fa-var-calendar-star: \\f736;\n$fa-var-calendar-week: \\f784;\n$fa-var-calendar-xmark: \\f273;\n$fa-var-calendar-times: \\f273;\n$fa-var-calendars: \\e0d7;\n$fa-var-camcorder: \\f8a8;\n$fa-var-video-handheld: \\f8a8;\n$fa-var-camera: \\f030;\n$fa-var-camera-alt: \\f030;\n$fa-var-camera-cctv: \\f8ac;\n$fa-var-cctv: \\f8ac;\n$fa-var-camera-movie: \\f8a9;\n$fa-var-camera-polaroid: \\f8aa;\n$fa-var-camera-retro: \\f083;\n$fa-var-camera-rotate: \\e0d8;\n$fa-var-camera-security: \\f8fe;\n$fa-var-camera-home: \\f8fe;\n$fa-var-camera-slash: \\e0d9;\n$fa-var-camera-viewfinder: \\e0da;\n$fa-var-camera-web: \\f832;\n$fa-var-webcam: \\f832;\n$fa-var-camera-web-slash: \\f833;\n$fa-var-webcam-slash: \\f833;\n$fa-var-campfire: \\f6ba;\n$fa-var-campground: \\f6bb;\n$fa-var-can-food: \\e3e6;\n$fa-var-candle-holder: \\f6bc;\n$fa-var-candy: \\e3e7;\n$fa-var-candy-bar: \\e3e8;\n$fa-var-chocolate-bar: \\e3e8;\n$fa-var-candy-cane: \\f786;\n$fa-var-candy-corn: \\f6bd;\n$fa-var-cannabis: \\f55f;\n$fa-var-capsules: \\f46b;\n$fa-var-car: \\f1b9;\n$fa-var-automobile: \\f1b9;\n$fa-var-car-battery: \\f5df;\n$fa-var-battery-car: \\f5df;\n$fa-var-car-bolt: \\e341;\n$fa-var-car-building: \\f859;\n$fa-var-car-bump: \\f5e0;\n$fa-var-car-bus: \\f85a;\n$fa-var-car-circle-bolt: \\e342;\n$fa-var-car-crash: \\f5e1;\n$fa-var-car-garage: \\f5e2;\n$fa-var-car-mirrors: \\e343;\n$fa-var-car-rear: \\f5de;\n$fa-var-car-alt: \\f5de;\n$fa-var-car-side: \\f5e4;\n$fa-var-car-side-bolt: \\e344;\n$fa-var-car-tilt: \\f5e5;\n$fa-var-car-wash: \\f5e6;\n$fa-var-car-wrench: \\f5e3;\n$fa-var-car-mechanic: \\f5e3;\n$fa-var-caravan: \\f8ff;\n$fa-var-caravan-simple: \\e000;\n$fa-var-caravan-alt: \\e000;\n$fa-var-card-club: \\e3e9;\n$fa-var-card-diamond: \\e3ea;\n$fa-var-card-heart: \\e3eb;\n$fa-var-card-spade: \\e3ec;\n$fa-var-cards: \\e3ed;\n$fa-var-caret-down: \\f0d7;\n$fa-var-caret-left: \\f0d9;\n$fa-var-caret-right: \\f0da;\n$fa-var-caret-up: \\f0d8;\n$fa-var-carrot: \\f787;\n$fa-var-cars: \\f85b;\n$fa-var-cart-arrow-down: \\f218;\n$fa-var-cart-arrow-up: \\e3ee;\n$fa-var-cart-circle-arrow-down: \\e3ef;\n$fa-var-cart-circle-arrow-up: \\e3f0;\n$fa-var-cart-circle-check: \\e3f1;\n$fa-var-cart-circle-exclamation: \\e3f2;\n$fa-var-cart-circle-plus: \\e3f3;\n$fa-var-cart-circle-xmark: \\e3f4;\n$fa-var-cart-flatbed: \\f474;\n$fa-var-dolly-flatbed: \\f474;\n$fa-var-cart-flatbed-boxes: \\f475;\n$fa-var-dolly-flatbed-alt: \\f475;\n$fa-var-cart-flatbed-empty: \\f476;\n$fa-var-dolly-flatbed-empty: \\f476;\n$fa-var-cart-flatbed-suitcase: \\f59d;\n$fa-var-luggage-cart: \\f59d;\n$fa-var-cart-minus: \\e0db;\n$fa-var-cart-plus: \\f217;\n$fa-var-cart-shopping: \\f07a;\n$fa-var-shopping-cart: \\f07a;\n$fa-var-cart-shopping-fast: \\e0dc;\n$fa-var-cart-xmark: \\e0dd;\n$fa-var-cash-register: \\f788;\n$fa-var-cassette-betamax: \\f8a4;\n$fa-var-betamax: \\f8a4;\n$fa-var-cassette-tape: \\f8ab;\n$fa-var-cassette-vhs: \\f8ec;\n$fa-var-vhs: \\f8ec;\n$fa-var-castle: \\e0de;\n$fa-var-cat: \\f6be;\n$fa-var-cat-space: \\e001;\n$fa-var-cauldron: \\f6bf;\n$fa-var-cedi-sign: \\e0df;\n$fa-var-cent-sign: \\e3f5;\n$fa-var-certificate: \\f0a3;\n$fa-var-chair: \\f6c0;\n$fa-var-chair-office: \\f6c1;\n$fa-var-chalkboard: \\f51b;\n$fa-var-blackboard: \\f51b;\n$fa-var-chalkboard-user: \\f51c;\n$fa-var-chalkboard-teacher: \\f51c;\n$fa-var-champagne-glass: \\f79e;\n$fa-var-glass-champagne: \\f79e;\n$fa-var-champagne-glasses: \\f79f;\n$fa-var-glass-cheers: \\f79f;\n$fa-var-charging-station: \\f5e7;\n$fa-var-chart-area: \\f1fe;\n$fa-var-area-chart: \\f1fe;\n$fa-var-chart-bar: \\f080;\n$fa-var-bar-chart: \\f080;\n$fa-var-chart-bullet: \\e0e1;\n$fa-var-chart-candlestick: \\e0e2;\n$fa-var-chart-column: \\e0e3;\n$fa-var-chart-gantt: \\e0e4;\n$fa-var-chart-line: \\f201;\n$fa-var-line-chart: \\f201;\n$fa-var-chart-line-down: \\f64d;\n$fa-var-chart-line-up: \\e0e5;\n$fa-var-chart-mixed: \\f643;\n$fa-var-analytics: \\f643;\n$fa-var-chart-network: \\f78a;\n$fa-var-chart-pie: \\f200;\n$fa-var-pie-chart: \\f200;\n$fa-var-chart-pie-simple: \\f64e;\n$fa-var-chart-pie-alt: \\f64e;\n$fa-var-chart-pyramid: \\e0e6;\n$fa-var-chart-radar: \\e0e7;\n$fa-var-chart-scatter: \\f7ee;\n$fa-var-chart-scatter-3d: \\e0e8;\n$fa-var-chart-scatter-bubble: \\e0e9;\n$fa-var-chart-tree-map: \\e0ea;\n$fa-var-chart-user: \\f6a3;\n$fa-var-user-chart: \\f6a3;\n$fa-var-chart-waterfall: \\e0eb;\n$fa-var-check: \\f00c;\n$fa-var-check-double: \\f560;\n$fa-var-check-to-slot: \\f772;\n$fa-var-vote-yea: \\f772;\n$fa-var-cheese: \\f7ef;\n$fa-var-cheese-swiss: \\f7f0;\n$fa-var-cherries: \\e0ec;\n$fa-var-chess: \\f439;\n$fa-var-chess-bishop: \\f43a;\n$fa-var-chess-bishop-piece: \\f43b;\n$fa-var-chess-bishop-alt: \\f43b;\n$fa-var-chess-board: \\f43c;\n$fa-var-chess-clock: \\f43d;\n$fa-var-chess-clock-flip: \\f43e;\n$fa-var-chess-clock-alt: \\f43e;\n$fa-var-chess-king: \\f43f;\n$fa-var-chess-king-piece: \\f440;\n$fa-var-chess-king-alt: \\f440;\n$fa-var-chess-knight: \\f441;\n$fa-var-chess-knight-piece: \\f442;\n$fa-var-chess-knight-alt: \\f442;\n$fa-var-chess-pawn: \\f443;\n$fa-var-chess-pawn-piece: \\f444;\n$fa-var-chess-pawn-alt: \\f444;\n$fa-var-chess-queen: \\f445;\n$fa-var-chess-queen-piece: \\f446;\n$fa-var-chess-queen-alt: \\f446;\n$fa-var-chess-rook: \\f447;\n$fa-var-chess-rook-piece: \\f448;\n$fa-var-chess-rook-alt: \\f448;\n$fa-var-chestnut: \\e3f6;\n$fa-var-chevron-down: \\f078;\n$fa-var-chevron-left: \\f053;\n$fa-var-chevron-right: \\f054;\n$fa-var-chevron-up: \\f077;\n$fa-var-chevrons-down: \\f322;\n$fa-var-chevron-double-down: \\f322;\n$fa-var-chevrons-left: \\f323;\n$fa-var-chevron-double-left: \\f323;\n$fa-var-chevrons-right: \\f324;\n$fa-var-chevron-double-right: \\f324;\n$fa-var-chevrons-up: \\f325;\n$fa-var-chevron-double-up: \\f325;\n$fa-var-child: \\f1ae;\n$fa-var-chimney: \\f78b;\n$fa-var-chopsticks: \\e3f7;\n$fa-var-church: \\f51d;\n$fa-var-circle: \\f111;\n$fa-var-circle-0: \\e0ed;\n$fa-var-circle-1: \\e0ee;\n$fa-var-circle-2: \\e0ef;\n$fa-var-circle-3: \\e0f0;\n$fa-var-circle-4: \\e0f1;\n$fa-var-circle-5: \\e0f2;\n$fa-var-circle-6: \\e0f3;\n$fa-var-circle-7: \\e0f4;\n$fa-var-circle-8: \\e0f5;\n$fa-var-circle-9: \\e0f6;\n$fa-var-circle-a: \\e0f7;\n$fa-var-circle-ampersand: \\e0f8;\n$fa-var-circle-arrow-down: \\f0ab;\n$fa-var-arrow-circle-down: \\f0ab;\n$fa-var-circle-arrow-down-left: \\e0f9;\n$fa-var-circle-arrow-down-right: \\e0fa;\n$fa-var-circle-arrow-left: \\f0a8;\n$fa-var-arrow-circle-left: \\f0a8;\n$fa-var-circle-arrow-right: \\f0a9;\n$fa-var-arrow-circle-right: \\f0a9;\n$fa-var-circle-arrow-up: \\f0aa;\n$fa-var-arrow-circle-up: \\f0aa;\n$fa-var-circle-arrow-up-left: \\e0fb;\n$fa-var-circle-arrow-up-right: \\e0fc;\n$fa-var-circle-b: \\e0fd;\n$fa-var-circle-bolt: \\e0fe;\n$fa-var-circle-book-open: \\e0ff;\n$fa-var-book-circle: \\e0ff;\n$fa-var-circle-bookmark: \\e100;\n$fa-var-bookmark-circle: \\e100;\n$fa-var-circle-c: \\e101;\n$fa-var-circle-calendar: \\e102;\n$fa-var-calendar-circle: \\e102;\n$fa-var-circle-camera: \\e103;\n$fa-var-camera-circle: \\e103;\n$fa-var-circle-caret-down: \\f32d;\n$fa-var-caret-circle-down: \\f32d;\n$fa-var-circle-caret-left: \\f32e;\n$fa-var-caret-circle-left: \\f32e;\n$fa-var-circle-caret-right: \\f330;\n$fa-var-caret-circle-right: \\f330;\n$fa-var-circle-caret-up: \\f331;\n$fa-var-caret-circle-up: \\f331;\n$fa-var-circle-check: \\f058;\n$fa-var-check-circle: \\f058;\n$fa-var-circle-chevron-down: \\f13a;\n$fa-var-chevron-circle-down: \\f13a;\n$fa-var-circle-chevron-left: \\f137;\n$fa-var-chevron-circle-left: \\f137;\n$fa-var-circle-chevron-right: \\f138;\n$fa-var-chevron-circle-right: \\f138;\n$fa-var-circle-chevron-up: \\f139;\n$fa-var-chevron-circle-up: \\f139;\n$fa-var-circle-d: \\e104;\n$fa-var-circle-dashed: \\e105;\n$fa-var-circle-divide: \\e106;\n$fa-var-circle-dollar: \\f2e8;\n$fa-var-dollar-circle: \\f2e8;\n$fa-var-usd-circle: \\f2e8;\n$fa-var-circle-dollar-to-slot: \\f4b9;\n$fa-var-donate: \\f4b9;\n$fa-var-circle-dot: \\f192;\n$fa-var-dot-circle: \\f192;\n$fa-var-circle-down: \\f358;\n$fa-var-arrow-alt-circle-down: \\f358;\n$fa-var-circle-down-left: \\e107;\n$fa-var-circle-down-right: \\e108;\n$fa-var-circle-e: \\e109;\n$fa-var-circle-ellipsis: \\e10a;\n$fa-var-circle-ellipsis-vertical: \\e10b;\n$fa-var-circle-envelope: \\e10c;\n$fa-var-envelope-circle: \\e10c;\n$fa-var-circle-exclamation: \\f06a;\n$fa-var-exclamation-circle: \\f06a;\n$fa-var-circle-exclamation-check: \\e10d;\n$fa-var-circle-f: \\e10e;\n$fa-var-circle-g: \\e10f;\n$fa-var-circle-h: \\f47e;\n$fa-var-hospital-symbol: \\f47e;\n$fa-var-circle-half: \\e110;\n$fa-var-circle-half-stroke: \\f042;\n$fa-var-adjust: \\f042;\n$fa-var-circle-heart: \\f4c7;\n$fa-var-heart-circle: \\f4c7;\n$fa-var-circle-i: \\e111;\n$fa-var-circle-info: \\f05a;\n$fa-var-info-circle: \\f05a;\n$fa-var-circle-j: \\e112;\n$fa-var-circle-k: \\e113;\n$fa-var-circle-l: \\e114;\n$fa-var-circle-left: \\f359;\n$fa-var-arrow-alt-circle-left: \\f359;\n$fa-var-circle-location-arrow: \\f602;\n$fa-var-location-circle: \\f602;\n$fa-var-circle-m: \\e115;\n$fa-var-circle-microphone: \\e116;\n$fa-var-microphone-circle: \\e116;\n$fa-var-circle-microphone-lines: \\e117;\n$fa-var-microphone-circle-alt: \\e117;\n$fa-var-circle-minus: \\f056;\n$fa-var-minus-circle: \\f056;\n$fa-var-circle-n: \\e118;\n$fa-var-circle-notch: \\f1ce;\n$fa-var-circle-o: \\e119;\n$fa-var-circle-p: \\e11a;\n$fa-var-circle-parking: \\f615;\n$fa-var-parking-circle: \\f615;\n$fa-var-circle-pause: \\f28b;\n$fa-var-pause-circle: \\f28b;\n$fa-var-circle-phone: \\e11b;\n$fa-var-phone-circle: \\e11b;\n$fa-var-circle-phone-flip: \\e11c;\n$fa-var-phone-circle-alt: \\e11c;\n$fa-var-circle-phone-hangup: \\e11d;\n$fa-var-phone-circle-down: \\e11d;\n$fa-var-circle-play: \\f144;\n$fa-var-play-circle: \\f144;\n$fa-var-circle-plus: \\f055;\n$fa-var-plus-circle: \\f055;\n$fa-var-circle-q: \\e11e;\n$fa-var-circle-quarter: \\e11f;\n$fa-var-circle-quarters: \\e3f8;\n$fa-var-circle-question: \\f059;\n$fa-var-question-circle: \\f059;\n$fa-var-circle-r: \\e120;\n$fa-var-circle-radiation: \\f7ba;\n$fa-var-radiation-alt: \\f7ba;\n$fa-var-circle-right: \\f35a;\n$fa-var-arrow-alt-circle-right: \\f35a;\n$fa-var-circle-s: \\e121;\n$fa-var-circle-small: \\e122;\n$fa-var-circle-sort: \\e030;\n$fa-var-sort-circle: \\e030;\n$fa-var-circle-sort-down: \\e031;\n$fa-var-sort-circle-down: \\e031;\n$fa-var-circle-sort-up: \\e032;\n$fa-var-sort-circle-up: \\e032;\n$fa-var-circle-star: \\e123;\n$fa-var-star-circle: \\e123;\n$fa-var-circle-stop: \\f28d;\n$fa-var-stop-circle: \\f28d;\n$fa-var-circle-t: \\e124;\n$fa-var-circle-three-quarters: \\e125;\n$fa-var-circle-trash: \\e126;\n$fa-var-trash-circle: \\e126;\n$fa-var-circle-u: \\e127;\n$fa-var-circle-up: \\f35b;\n$fa-var-arrow-alt-circle-up: \\f35b;\n$fa-var-circle-up-left: \\e128;\n$fa-var-circle-up-right: \\e129;\n$fa-var-circle-user: \\f2bd;\n$fa-var-user-circle: \\f2bd;\n$fa-var-circle-v: \\e12a;\n$fa-var-circle-video: \\e12b;\n$fa-var-video-circle: \\e12b;\n$fa-var-circle-w: \\e12c;\n$fa-var-circle-waveform-lines: \\e12d;\n$fa-var-waveform-circle: \\e12d;\n$fa-var-circle-x: \\e12e;\n$fa-var-circle-xmark: \\f057;\n$fa-var-times-circle: \\f057;\n$fa-var-xmark-circle: \\f057;\n$fa-var-circle-y: \\e12f;\n$fa-var-circle-z: \\e130;\n$fa-var-citrus: \\e2f4;\n$fa-var-citrus-slice: \\e2f5;\n$fa-var-city: \\f64f;\n$fa-var-clapperboard: \\e131;\n$fa-var-clapperboard-play: \\e132;\n$fa-var-clarinet: \\f8ad;\n$fa-var-claw-marks: \\f6c2;\n$fa-var-clipboard: \\f328;\n$fa-var-clipboard-check: \\f46c;\n$fa-var-clipboard-list: \\f46d;\n$fa-var-clipboard-list-check: \\f737;\n$fa-var-clipboard-medical: \\e133;\n$fa-var-clipboard-prescription: \\f5e8;\n$fa-var-clipboard-user: \\f7f3;\n$fa-var-clock: \\f017;\n$fa-var-clock-four: \\f017;\n$fa-var-clock-desk: \\e134;\n$fa-var-clock-eight: \\e345;\n$fa-var-clock-eight-thirty: \\e346;\n$fa-var-clock-eleven: \\e347;\n$fa-var-clock-eleven-thirty: \\e348;\n$fa-var-clock-five: \\e349;\n$fa-var-clock-five-thirty: \\e34a;\n$fa-var-clock-four-thirty: \\e34b;\n$fa-var-clock-nine: \\e34c;\n$fa-var-clock-nine-thirty: \\e34d;\n$fa-var-clock-one: \\e34e;\n$fa-var-clock-one-thirty: \\e34f;\n$fa-var-clock-rotate-left: \\f1da;\n$fa-var-history: \\f1da;\n$fa-var-clock-seven: \\e350;\n$fa-var-clock-seven-thirty: \\e351;\n$fa-var-clock-six: \\e352;\n$fa-var-clock-six-thirty: \\e353;\n$fa-var-clock-ten: \\e354;\n$fa-var-clock-ten-thirty: \\e355;\n$fa-var-clock-three: \\e356;\n$fa-var-clock-three-thirty: \\e357;\n$fa-var-clock-twelve: \\e358;\n$fa-var-clock-twelve-thirty: \\e359;\n$fa-var-clock-two: \\e35a;\n$fa-var-clock-two-thirty: \\e35b;\n$fa-var-clone: \\f24d;\n$fa-var-closed-captioning: \\f20a;\n$fa-var-closed-captioning-slash: \\e135;\n$fa-var-clothes-hanger: \\e136;\n$fa-var-cloud: \\f0c2;\n$fa-var-cloud-arrow-down: \\f0ed;\n$fa-var-cloud-download: \\f0ed;\n$fa-var-cloud-download-alt: \\f0ed;\n$fa-var-cloud-arrow-up: \\f0ee;\n$fa-var-cloud-upload: \\f0ee;\n$fa-var-cloud-upload-alt: \\f0ee;\n$fa-var-cloud-bolt: \\f76c;\n$fa-var-thunderstorm: \\f76c;\n$fa-var-cloud-bolt-moon: \\f76d;\n$fa-var-thunderstorm-moon: \\f76d;\n$fa-var-cloud-bolt-sun: \\f76e;\n$fa-var-thunderstorm-sun: \\f76e;\n$fa-var-cloud-check: \\e35c;\n$fa-var-cloud-drizzle: \\f738;\n$fa-var-cloud-fog: \\f74e;\n$fa-var-fog: \\f74e;\n$fa-var-cloud-hail: \\f739;\n$fa-var-cloud-hail-mixed: \\f73a;\n$fa-var-cloud-meatball: \\f73b;\n$fa-var-cloud-minus: \\e35d;\n$fa-var-cloud-moon: \\f6c3;\n$fa-var-cloud-moon-rain: \\f73c;\n$fa-var-cloud-music: \\f8ae;\n$fa-var-cloud-plus: \\e35e;\n$fa-var-cloud-rain: \\f73d;\n$fa-var-cloud-rainbow: \\f73e;\n$fa-var-cloud-showers: \\f73f;\n$fa-var-cloud-showers-heavy: \\f740;\n$fa-var-cloud-slash: \\e137;\n$fa-var-cloud-sleet: \\f741;\n$fa-var-cloud-snow: \\f742;\n$fa-var-cloud-sun: \\f6c4;\n$fa-var-cloud-sun-rain: \\f743;\n$fa-var-cloud-word: \\e138;\n$fa-var-cloud-xmark: \\e35f;\n$fa-var-clouds: \\f744;\n$fa-var-clouds-moon: \\f745;\n$fa-var-clouds-sun: \\f746;\n$fa-var-clover: \\e139;\n$fa-var-club: \\f327;\n$fa-var-coconut: \\e2f6;\n$fa-var-code: \\f121;\n$fa-var-code-branch: \\f126;\n$fa-var-code-commit: \\f386;\n$fa-var-code-compare: \\e13a;\n$fa-var-code-fork: \\e13b;\n$fa-var-code-merge: \\f387;\n$fa-var-code-pull-request: \\e13c;\n$fa-var-code-pull-request-closed: \\e3f9;\n$fa-var-code-pull-request-draft: \\e3fa;\n$fa-var-code-simple: \\e13d;\n$fa-var-coffee-bean: \\e13e;\n$fa-var-coffee-beans: \\e13f;\n$fa-var-coffee-pot: \\e002;\n$fa-var-coffin: \\f6c6;\n$fa-var-coffin-cross: \\e051;\n$fa-var-coin: \\f85c;\n$fa-var-coin-blank: \\e3fb;\n$fa-var-coin-front: \\e3fc;\n$fa-var-coin-vertical: \\e3fd;\n$fa-var-coins: \\f51e;\n$fa-var-colon: \\3a;\n$fa-var-colon-sign: \\e140;\n$fa-var-columns-3: \\e361;\n$fa-var-comet: \\e003;\n$fa-var-comma: \\2c;\n$fa-var-command: \\e142;\n$fa-var-comment: \\f075;\n$fa-var-comment-arrow-down: \\e143;\n$fa-var-comment-arrow-up: \\e144;\n$fa-var-comment-arrow-up-right: \\e145;\n$fa-var-comment-captions: \\e146;\n$fa-var-comment-check: \\f4ac;\n$fa-var-comment-code: \\e147;\n$fa-var-comment-dollar: \\f651;\n$fa-var-comment-dots: \\f4ad;\n$fa-var-commenting: \\f4ad;\n$fa-var-comment-exclamation: \\f4af;\n$fa-var-comment-image: \\e148;\n$fa-var-comment-lines: \\f4b0;\n$fa-var-comment-medical: \\f7f5;\n$fa-var-comment-middle: \\e149;\n$fa-var-comment-middle-top: \\e14a;\n$fa-var-comment-minus: \\f4b1;\n$fa-var-comment-music: \\f8b0;\n$fa-var-comment-pen: \\f4ae;\n$fa-var-comment-edit: \\f4ae;\n$fa-var-comment-plus: \\f4b2;\n$fa-var-comment-question: \\e14b;\n$fa-var-comment-quote: \\e14c;\n$fa-var-comment-slash: \\f4b3;\n$fa-var-comment-smile: \\f4b4;\n$fa-var-comment-sms: \\f7cd;\n$fa-var-sms: \\f7cd;\n$fa-var-comment-text: \\e14d;\n$fa-var-comment-xmark: \\f4b5;\n$fa-var-comment-times: \\f4b5;\n$fa-var-comments: \\f086;\n$fa-var-comments-dollar: \\f653;\n$fa-var-comments-question: \\e14e;\n$fa-var-comments-question-check: \\e14f;\n$fa-var-compact-disc: \\f51f;\n$fa-var-compass: \\f14e;\n$fa-var-compass-drafting: \\f568;\n$fa-var-drafting-compass: \\f568;\n$fa-var-compass-slash: \\f5e9;\n$fa-var-compress: \\f066;\n$fa-var-compress-wide: \\f326;\n$fa-var-computer-classic: \\f8b1;\n$fa-var-computer-mouse: \\f8cc;\n$fa-var-mouse: \\f8cc;\n$fa-var-computer-mouse-scrollwheel: \\f8cd;\n$fa-var-mouse-alt: \\f8cd;\n$fa-var-computer-speaker: \\f8b2;\n$fa-var-container-storage: \\f4b7;\n$fa-var-conveyor-belt: \\f46e;\n$fa-var-conveyor-belt-boxes: \\f46f;\n$fa-var-conveyor-belt-alt: \\f46f;\n$fa-var-conveyor-belt-empty: \\e150;\n$fa-var-cookie: \\f563;\n$fa-var-cookie-bite: \\f564;\n$fa-var-copy: \\f0c5;\n$fa-var-copyright: \\f1f9;\n$fa-var-corn: \\f6c7;\n$fa-var-corner: \\e3fe;\n$fa-var-couch: \\f4b8;\n$fa-var-cow: \\f6c8;\n$fa-var-cowbell: \\f8b3;\n$fa-var-cowbell-circle-plus: \\f8b4;\n$fa-var-cowbell-more: \\f8b4;\n$fa-var-crab: \\e3ff;\n$fa-var-crate-apple: \\f6b1;\n$fa-var-apple-crate: \\f6b1;\n$fa-var-crate-empty: \\e151;\n$fa-var-credit-card: \\f09d;\n$fa-var-credit-card-alt: \\f09d;\n$fa-var-credit-card-blank: \\f389;\n$fa-var-credit-card-front: \\f38a;\n$fa-var-creemee: \\e400;\n$fa-var-soft-serve: \\e400;\n$fa-var-cricket-bat-ball: \\f449;\n$fa-var-cricket: \\f449;\n$fa-var-croissant: \\f7f6;\n$fa-var-crop: \\f125;\n$fa-var-crop-simple: \\f565;\n$fa-var-crop-alt: \\f565;\n$fa-var-cross: \\f654;\n$fa-var-crosshairs: \\f05b;\n$fa-var-crow: \\f520;\n$fa-var-crown: \\f521;\n$fa-var-crutch: \\f7f7;\n$fa-var-crutches: \\f7f8;\n$fa-var-cruzeiro-sign: \\e152;\n$fa-var-crystal-ball: \\e362;\n$fa-var-cube: \\f1b2;\n$fa-var-cubes: \\f1b3;\n$fa-var-cucumber: \\e401;\n$fa-var-cup-straw: \\e363;\n$fa-var-cup-straw-swoosh: \\e364;\n$fa-var-cup-togo: \\f6c5;\n$fa-var-coffee-togo: \\f6c5;\n$fa-var-cupcake: \\e402;\n$fa-var-curling-stone: \\f44a;\n$fa-var-curling: \\f44a;\n$fa-var-custard: \\e403;\n$fa-var-d: \\44;\n$fa-var-dagger: \\f6cb;\n$fa-var-dash: \\e404;\n$fa-var-database: \\f1c0;\n$fa-var-deer: \\f78e;\n$fa-var-deer-rudolph: \\f78f;\n$fa-var-delete-left: \\f55a;\n$fa-var-backspace: \\f55a;\n$fa-var-delete-right: \\e154;\n$fa-var-democrat: \\f747;\n$fa-var-desktop: \\f390;\n$fa-var-desktop-alt: \\f390;\n$fa-var-desktop-arrow-down: \\e155;\n$fa-var-dharmachakra: \\f655;\n$fa-var-diagram-lean-canvas: \\e156;\n$fa-var-diagram-nested: \\e157;\n$fa-var-diagram-project: \\f542;\n$fa-var-project-diagram: \\f542;\n$fa-var-diagram-sankey: \\e158;\n$fa-var-diagram-venn: \\e15a;\n$fa-var-dial: \\e15b;\n$fa-var-dial-med-high: \\e15b;\n$fa-var-dial-high: \\e15c;\n$fa-var-dial-low: \\e15d;\n$fa-var-dial-max: \\e15e;\n$fa-var-dial-med: \\e15f;\n$fa-var-dial-med-low: \\e160;\n$fa-var-dial-min: \\e161;\n$fa-var-dial-off: \\e162;\n$fa-var-diamond: \\f219;\n$fa-var-diamond-exclamation: \\e405;\n$fa-var-diamond-turn-right: \\f5eb;\n$fa-var-directions: \\f5eb;\n$fa-var-dice: \\f522;\n$fa-var-dice-d10: \\f6cd;\n$fa-var-dice-d12: \\f6ce;\n$fa-var-dice-d20: \\f6cf;\n$fa-var-dice-d4: \\f6d0;\n$fa-var-dice-d6: \\f6d1;\n$fa-var-dice-d8: \\f6d2;\n$fa-var-dice-five: \\f523;\n$fa-var-dice-four: \\f524;\n$fa-var-dice-one: \\f525;\n$fa-var-dice-six: \\f526;\n$fa-var-dice-three: \\f527;\n$fa-var-dice-two: \\f528;\n$fa-var-diploma: \\f5ea;\n$fa-var-scroll-ribbon: \\f5ea;\n$fa-var-disc-drive: \\f8b5;\n$fa-var-disease: \\f7fa;\n$fa-var-display: \\e163;\n$fa-var-display-arrow-down: \\e164;\n$fa-var-display-code: \\e165;\n$fa-var-desktop-code: \\e165;\n$fa-var-display-medical: \\e166;\n$fa-var-desktop-medical: \\e166;\n$fa-var-display-slash: \\e2fa;\n$fa-var-desktop-slash: \\e2fa;\n$fa-var-distribute-spacing-horizontal: \\e365;\n$fa-var-distribute-spacing-vertical: \\e366;\n$fa-var-ditto: \\22;\n$fa-var-divide: \\f529;\n$fa-var-dna: \\f471;\n$fa-var-do-not-enter: \\f5ec;\n$fa-var-dog: \\f6d3;\n$fa-var-dog-leashed: \\f6d4;\n$fa-var-dollar-sign: \\24;\n$fa-var-dollar: \\24;\n$fa-var-usd: \\24;\n$fa-var-dolly: \\f472;\n$fa-var-dolly-box: \\f472;\n$fa-var-dolly-empty: \\f473;\n$fa-var-dolphin: \\e168;\n$fa-var-dong-sign: \\e169;\n$fa-var-donut: \\e406;\n$fa-var-doughnut: \\e406;\n$fa-var-door-closed: \\f52a;\n$fa-var-door-open: \\f52b;\n$fa-var-dove: \\f4ba;\n$fa-var-down: \\f354;\n$fa-var-arrow-alt-down: \\f354;\n$fa-var-down-from-dotted-line: \\e407;\n$fa-var-down-from-line: \\f349;\n$fa-var-arrow-alt-from-top: \\f349;\n$fa-var-down-left: \\e16a;\n$fa-var-down-left-and-up-right-to-center: \\f422;\n$fa-var-compress-alt: \\f422;\n$fa-var-down-long: \\f309;\n$fa-var-long-arrow-alt-down: \\f309;\n$fa-var-down-right: \\e16b;\n$fa-var-down-to-dotted-line: \\e408;\n$fa-var-down-to-line: \\f34a;\n$fa-var-arrow-alt-to-bottom: \\f34a;\n$fa-var-download: \\f019;\n$fa-var-dragon: \\f6d5;\n$fa-var-draw-circle: \\f5ed;\n$fa-var-draw-polygon: \\f5ee;\n$fa-var-draw-square: \\f5ef;\n$fa-var-dreidel: \\f792;\n$fa-var-drone: \\f85f;\n$fa-var-drone-front: \\f860;\n$fa-var-drone-alt: \\f860;\n$fa-var-droplet: \\f043;\n$fa-var-tint: \\f043;\n$fa-var-droplet-degree: \\f748;\n$fa-var-dewpoint: \\f748;\n$fa-var-droplet-percent: \\f750;\n$fa-var-humidity: \\f750;\n$fa-var-droplet-slash: \\f5c7;\n$fa-var-tint-slash: \\f5c7;\n$fa-var-drum: \\f569;\n$fa-var-drum-steelpan: \\f56a;\n$fa-var-drumstick: \\f6d6;\n$fa-var-drumstick-bite: \\f6d7;\n$fa-var-dryer: \\f861;\n$fa-var-dryer-heat: \\f862;\n$fa-var-dryer-alt: \\f862;\n$fa-var-duck: \\f6d8;\n$fa-var-dumbbell: \\f44b;\n$fa-var-dumpster: \\f793;\n$fa-var-dumpster-fire: \\f794;\n$fa-var-dungeon: \\f6d9;\n$fa-var-e: \\45;\n$fa-var-ear: \\f5f0;\n$fa-var-ear-deaf: \\f2a4;\n$fa-var-deaf: \\f2a4;\n$fa-var-deafness: \\f2a4;\n$fa-var-hard-of-hearing: \\f2a4;\n$fa-var-ear-listen: \\f2a2;\n$fa-var-assistive-listening-systems: \\f2a2;\n$fa-var-ear-muffs: \\f795;\n$fa-var-earth-africa: \\f57c;\n$fa-var-globe-africa: \\f57c;\n$fa-var-earth-americas: \\f57d;\n$fa-var-earth: \\f57d;\n$fa-var-globe-americas: \\f57d;\n$fa-var-earth-asia: \\f57e;\n$fa-var-globe-asia: \\f57e;\n$fa-var-earth-europa: \\f7a2;\n$fa-var-globe-europe: \\f7a2;\n$fa-var-eclipse: \\f749;\n$fa-var-egg: \\f7fb;\n$fa-var-egg-fried: \\f7fc;\n$fa-var-eggplant: \\e16c;\n$fa-var-eject: \\f052;\n$fa-var-elephant: \\f6da;\n$fa-var-elevator: \\e16d;\n$fa-var-ellipsis: \\f141;\n$fa-var-ellipsis-h: \\f141;\n$fa-var-ellipsis-stroke: \\f39b;\n$fa-var-ellipsis-h-alt: \\f39b;\n$fa-var-ellipsis-stroke-vertical: \\f39c;\n$fa-var-ellipsis-v-alt: \\f39c;\n$fa-var-ellipsis-vertical: \\f142;\n$fa-var-ellipsis-v: \\f142;\n$fa-var-empty-set: \\f656;\n$fa-var-engine: \\e16e;\n$fa-var-engine-warning: \\f5f2;\n$fa-var-engine-exclamation: \\f5f2;\n$fa-var-envelope: \\f0e0;\n$fa-var-envelope-dot: \\e16f;\n$fa-var-envelope-badge: \\e16f;\n$fa-var-envelope-open: \\f2b6;\n$fa-var-envelope-open-dollar: \\f657;\n$fa-var-envelope-open-text: \\f658;\n$fa-var-envelopes: \\e170;\n$fa-var-envelopes-bulk: \\f674;\n$fa-var-mail-bulk: \\f674;\n$fa-var-equals: \\3d;\n$fa-var-eraser: \\f12d;\n$fa-var-escalator: \\e171;\n$fa-var-ethernet: \\f796;\n$fa-var-euro-sign: \\f153;\n$fa-var-eur: \\f153;\n$fa-var-euro: \\f153;\n$fa-var-exclamation: \\21;\n$fa-var-expand: \\f065;\n$fa-var-expand-wide: \\f320;\n$fa-var-eye: \\f06e;\n$fa-var-eye-dropper: \\f1fb;\n$fa-var-eye-dropper-empty: \\f1fb;\n$fa-var-eyedropper: \\f1fb;\n$fa-var-eye-dropper-full: \\e172;\n$fa-var-eye-dropper-half: \\e173;\n$fa-var-eye-evil: \\f6db;\n$fa-var-eye-low-vision: \\f2a8;\n$fa-var-low-vision: \\f2a8;\n$fa-var-eye-slash: \\f070;\n$fa-var-eyes: \\e367;\n$fa-var-f: \\46;\n$fa-var-face-angry: \\f556;\n$fa-var-angry: \\f556;\n$fa-var-face-angry-horns: \\e368;\n$fa-var-face-anguished: \\e369;\n$fa-var-face-anxious-sweat: \\e36a;\n$fa-var-face-astonished: \\e36b;\n$fa-var-face-awesome: \\e409;\n$fa-var-gave-dandy: \\e409;\n$fa-var-face-confounded: \\e36c;\n$fa-var-face-confused: \\e36d;\n$fa-var-face-cowboy-hat: \\e36e;\n$fa-var-face-disappointed: \\e36f;\n$fa-var-face-disguise: \\e370;\n$fa-var-face-dizzy: \\f567;\n$fa-var-dizzy: \\f567;\n$fa-var-face-downcast-sweat: \\e371;\n$fa-var-face-drooling: \\e372;\n$fa-var-face-explode: \\e2fe;\n$fa-var-exploding-head: \\e2fe;\n$fa-var-face-expressionless: \\e373;\n$fa-var-face-eyes-xmarks: \\e374;\n$fa-var-face-fearful: \\e375;\n$fa-var-face-flushed: \\f579;\n$fa-var-flushed: \\f579;\n$fa-var-face-frown: \\f119;\n$fa-var-frown: \\f119;\n$fa-var-face-frown-open: \\f57a;\n$fa-var-frown-open: \\f57a;\n$fa-var-face-frown-slight: \\e376;\n$fa-var-face-glasses: \\e377;\n$fa-var-face-grimace: \\f57f;\n$fa-var-grimace: \\f57f;\n$fa-var-face-grin: \\f580;\n$fa-var-grin: \\f580;\n$fa-var-face-grin-beam: \\f582;\n$fa-var-grin-beam: \\f582;\n$fa-var-face-grin-beam-sweat: \\f583;\n$fa-var-grin-beam-sweat: \\f583;\n$fa-var-face-grin-hearts: \\f584;\n$fa-var-grin-hearts: \\f584;\n$fa-var-face-grin-squint: \\f585;\n$fa-var-grin-squint: \\f585;\n$fa-var-face-grin-squint-tears: \\f586;\n$fa-var-grin-squint-tears: \\f586;\n$fa-var-face-grin-stars: \\f587;\n$fa-var-grin-stars: \\f587;\n$fa-var-face-grin-tears: \\f588;\n$fa-var-grin-tears: \\f588;\n$fa-var-face-grin-tongue: \\f589;\n$fa-var-grin-tongue: \\f589;\n$fa-var-face-grin-tongue-squint: \\f58a;\n$fa-var-grin-tongue-squint: \\f58a;\n$fa-var-face-grin-tongue-wink: \\f58b;\n$fa-var-grin-tongue-wink: \\f58b;\n$fa-var-face-grin-wide: \\f581;\n$fa-var-grin-alt: \\f581;\n$fa-var-face-grin-wink: \\f58c;\n$fa-var-grin-wink: \\f58c;\n$fa-var-face-hand-over-mouth: \\e378;\n$fa-var-face-hand-yawn: \\e379;\n$fa-var-face-head-bandage: \\e37a;\n$fa-var-face-hushed: \\e37b;\n$fa-var-face-icicles: \\e37c;\n$fa-var-face-kiss: \\f596;\n$fa-var-kiss: \\f596;\n$fa-var-face-kiss-beam: \\f597;\n$fa-var-kiss-beam: \\f597;\n$fa-var-face-kiss-closed-eyes: \\e37d;\n$fa-var-face-kiss-wink-heart: \\f598;\n$fa-var-kiss-wink-heart: \\f598;\n$fa-var-face-laugh: \\f599;\n$fa-var-laugh: \\f599;\n$fa-var-face-laugh-beam: \\f59a;\n$fa-var-laugh-beam: \\f59a;\n$fa-var-face-laugh-squint: \\f59b;\n$fa-var-laugh-squint: \\f59b;\n$fa-var-face-laugh-wink: \\f59c;\n$fa-var-laugh-wink: \\f59c;\n$fa-var-face-lying: \\e37e;\n$fa-var-face-mask: \\e37f;\n$fa-var-face-meh: \\f11a;\n$fa-var-meh: \\f11a;\n$fa-var-face-meh-blank: \\f5a4;\n$fa-var-meh-blank: \\f5a4;\n$fa-var-face-monocle: \\e380;\n$fa-var-face-nauseated: \\e381;\n$fa-var-face-nose-steam: \\e382;\n$fa-var-face-party: \\e383;\n$fa-var-face-pensive: \\e384;\n$fa-var-face-persevering: \\e385;\n$fa-var-face-pleading: \\e386;\n$fa-var-face-pouting: \\e387;\n$fa-var-face-raised-eyebrow: \\e388;\n$fa-var-face-relieved: \\e389;\n$fa-var-face-rolling-eyes: \\f5a5;\n$fa-var-meh-rolling-eyes: \\f5a5;\n$fa-var-face-sad-cry: \\f5b3;\n$fa-var-sad-cry: \\f5b3;\n$fa-var-face-sad-sweat: \\e38a;\n$fa-var-face-sad-tear: \\f5b4;\n$fa-var-sad-tear: \\f5b4;\n$fa-var-face-scream: \\e38b;\n$fa-var-face-shush: \\e38c;\n$fa-var-face-sleeping: \\e38d;\n$fa-var-face-sleepy: \\e38e;\n$fa-var-face-smile: \\f118;\n$fa-var-smile: \\f118;\n$fa-var-face-smile-beam: \\f5b8;\n$fa-var-smile-beam: \\f5b8;\n$fa-var-face-smile-halo: \\e38f;\n$fa-var-face-smile-hearts: \\e390;\n$fa-var-face-smile-horns: \\e391;\n$fa-var-face-smile-plus: \\f5b9;\n$fa-var-smile-plus: \\f5b9;\n$fa-var-face-smile-relaxed: \\e392;\n$fa-var-face-smile-tear: \\e393;\n$fa-var-face-smile-tongue: \\e394;\n$fa-var-face-smile-upside-down: \\e395;\n$fa-var-face-smile-wink: \\f4da;\n$fa-var-smile-wink: \\f4da;\n$fa-var-face-smiling-hands: \\e396;\n$fa-var-face-smirking: \\e397;\n$fa-var-face-sunglasses: \\e398;\n$fa-var-face-surprise: \\f5c2;\n$fa-var-surprise: \\f5c2;\n$fa-var-face-swear: \\e399;\n$fa-var-face-thermometer: \\e39a;\n$fa-var-face-thinking: \\e39b;\n$fa-var-face-tired: \\f5c8;\n$fa-var-tired: \\f5c8;\n$fa-var-face-tissue: \\e39c;\n$fa-var-face-tongue-money: \\e39d;\n$fa-var-face-tongue-sweat: \\e39e;\n$fa-var-face-unamused: \\e39f;\n$fa-var-face-viewfinder: \\e2ff;\n$fa-var-face-vomit: \\e3a0;\n$fa-var-face-weary: \\e3a1;\n$fa-var-face-woozy: \\e3a2;\n$fa-var-face-worried: \\e3a3;\n$fa-var-face-zany: \\e3a4;\n$fa-var-face-zipper: \\e3a5;\n$fa-var-falafel: \\e40a;\n$fa-var-family: \\e300;\n$fa-var-family-dress: \\e301;\n$fa-var-family-pants: \\e302;\n$fa-var-fan: \\f863;\n$fa-var-fan-table: \\e004;\n$fa-var-farm: \\f864;\n$fa-var-barn-silo: \\f864;\n$fa-var-faucet: \\e005;\n$fa-var-faucet-drip: \\e006;\n$fa-var-fax: \\f1ac;\n$fa-var-feather: \\f52d;\n$fa-var-feather-pointed: \\f56b;\n$fa-var-feather-alt: \\f56b;\n$fa-var-fence: \\e303;\n$fa-var-ferris-wheel: \\e174;\n$fa-var-field-hockey-stick-ball: \\f44c;\n$fa-var-field-hockey: \\f44c;\n$fa-var-file: \\f15b;\n$fa-var-file-arrow-down: \\f56d;\n$fa-var-file-download: \\f56d;\n$fa-var-file-arrow-up: \\f574;\n$fa-var-file-upload: \\f574;\n$fa-var-file-audio: \\f1c7;\n$fa-var-file-binary: \\e175;\n$fa-var-file-certificate: \\f5f3;\n$fa-var-file-award: \\f5f3;\n$fa-var-file-chart-column: \\f659;\n$fa-var-file-chart-line: \\f659;\n$fa-var-file-chart-pie: \\f65a;\n$fa-var-file-check: \\f316;\n$fa-var-file-code: \\f1c9;\n$fa-var-file-contract: \\f56c;\n$fa-var-file-csv: \\f6dd;\n$fa-var-file-dashed-line: \\f877;\n$fa-var-page-break: \\f877;\n$fa-var-file-excel: \\f1c3;\n$fa-var-file-exclamation: \\f31a;\n$fa-var-file-export: \\f56e;\n$fa-var-arrow-right-from-file: \\f56e;\n$fa-var-file-heart: \\e176;\n$fa-var-file-image: \\f1c5;\n$fa-var-file-import: \\f56f;\n$fa-var-arrow-right-to-file: \\f56f;\n$fa-var-file-invoice: \\f570;\n$fa-var-file-invoice-dollar: \\f571;\n$fa-var-file-lines: \\f15c;\n$fa-var-file-alt: \\f15c;\n$fa-var-file-text: \\f15c;\n$fa-var-file-lock: \\e3a6;\n$fa-var-file-magnifying-glass: \\f865;\n$fa-var-file-search: \\f865;\n$fa-var-file-medical: \\f477;\n$fa-var-file-minus: \\f318;\n$fa-var-file-music: \\f8b6;\n$fa-var-file-pdf: \\f1c1;\n$fa-var-file-pen: \\f31c;\n$fa-var-file-edit: \\f31c;\n$fa-var-file-plus: \\f319;\n$fa-var-file-plus-minus: \\e177;\n$fa-var-file-powerpoint: \\f1c4;\n$fa-var-file-prescription: \\f572;\n$fa-var-file-signature: \\f573;\n$fa-var-file-slash: \\e3a7;\n$fa-var-file-spreadsheet: \\f65b;\n$fa-var-file-user: \\f65c;\n$fa-var-file-video: \\f1c8;\n$fa-var-file-waveform: \\f478;\n$fa-var-file-medical-alt: \\f478;\n$fa-var-file-word: \\f1c2;\n$fa-var-file-xmark: \\f317;\n$fa-var-file-times: \\f317;\n$fa-var-file-zipper: \\f1c6;\n$fa-var-file-archive: \\f1c6;\n$fa-var-files: \\e178;\n$fa-var-files-medical: \\f7fd;\n$fa-var-fill: \\f575;\n$fa-var-fill-drip: \\f576;\n$fa-var-film: \\f008;\n$fa-var-film-canister: \\f8b7;\n$fa-var-film-simple: \\f3a0;\n$fa-var-film-alt: \\f3a0;\n$fa-var-film-slash: \\e179;\n$fa-var-films: \\e17a;\n$fa-var-filter: \\f0b0;\n$fa-var-filter-circle-dollar: \\f662;\n$fa-var-funnel-dollar: \\f662;\n$fa-var-filter-circle-xmark: \\e17b;\n$fa-var-filter-list: \\e17c;\n$fa-var-filter-slash: \\e17d;\n$fa-var-filters: \\e17e;\n$fa-var-fingerprint: \\f577;\n$fa-var-fire: \\f06d;\n$fa-var-fire-extinguisher: \\f134;\n$fa-var-fire-flame: \\f6df;\n$fa-var-flame: \\f6df;\n$fa-var-fire-flame-curved: \\f7e4;\n$fa-var-fire-alt: \\f7e4;\n$fa-var-fire-flame-simple: \\f46a;\n$fa-var-burn: \\f46a;\n$fa-var-fire-hydrant: \\e17f;\n$fa-var-fire-smoke: \\f74b;\n$fa-var-fireplace: \\f79a;\n$fa-var-fish: \\f578;\n$fa-var-fish-bones: \\e304;\n$fa-var-fish-cooked: \\f7fe;\n$fa-var-fishing-rod: \\e3a8;\n$fa-var-flag: \\f024;\n$fa-var-flag-checkered: \\f11e;\n$fa-var-flag-pennant: \\f456;\n$fa-var-pennant: \\f456;\n$fa-var-flag-swallowtail: \\f74c;\n$fa-var-flag-alt: \\f74c;\n$fa-var-flag-usa: \\f74d;\n$fa-var-flashlight: \\f8b8;\n$fa-var-flask: \\f0c3;\n$fa-var-flask-round-poison: \\f6e0;\n$fa-var-flask-poison: \\f6e0;\n$fa-var-flask-round-potion: \\f6e1;\n$fa-var-flask-potion: \\f6e1;\n$fa-var-flatbread: \\e40b;\n$fa-var-flatbread-stuffed: \\e40c;\n$fa-var-floppy-disk: \\f0c7;\n$fa-var-save: \\f0c7;\n$fa-var-floppy-disk-circle-arrow-right: \\e180;\n$fa-var-save-circle-arrow-right: \\e180;\n$fa-var-floppy-disk-circle-xmark: \\e181;\n$fa-var-floppy-disk-times: \\e181;\n$fa-var-save-circle-xmark: \\e181;\n$fa-var-save-times: \\e181;\n$fa-var-floppy-disk-pen: \\e182;\n$fa-var-floppy-disks: \\e183;\n$fa-var-florin-sign: \\e184;\n$fa-var-flower: \\f7ff;\n$fa-var-flower-daffodil: \\f800;\n$fa-var-flower-tulip: \\f801;\n$fa-var-flute: \\f8b9;\n$fa-var-flux-capacitor: \\f8ba;\n$fa-var-flying-disc: \\e3a9;\n$fa-var-folder: \\f07b;\n$fa-var-folder-arrow-down: \\e053;\n$fa-var-folder-download: \\e053;\n$fa-var-folder-arrow-up: \\e054;\n$fa-var-folder-upload: \\e054;\n$fa-var-folder-blank: \\e185;\n$fa-var-folder-bookmark: \\e186;\n$fa-var-folder-gear: \\e187;\n$fa-var-folder-cog: \\e187;\n$fa-var-folder-grid: \\e188;\n$fa-var-folder-heart: \\e189;\n$fa-var-folder-image: \\e18a;\n$fa-var-folder-magnifying-glass: \\e18b;\n$fa-var-folder-search: \\e18b;\n$fa-var-folder-medical: \\e18c;\n$fa-var-folder-minus: \\f65d;\n$fa-var-folder-music: \\e18d;\n$fa-var-folder-open: \\f07c;\n$fa-var-folder-plus: \\f65e;\n$fa-var-folder-tree: \\f802;\n$fa-var-folder-user: \\e18e;\n$fa-var-folder-xmark: \\f65f;\n$fa-var-folder-times: \\f65f;\n$fa-var-folders: \\f660;\n$fa-var-fondue-pot: \\e40d;\n$fa-var-font: \\f031;\n$fa-var-font-case: \\f866;\n$fa-var-football: \\f44e;\n$fa-var-football-ball: \\f44e;\n$fa-var-football-helmet: \\f44f;\n$fa-var-fork: \\f2e3;\n$fa-var-utensil-fork: \\f2e3;\n$fa-var-fork-knife: \\f2e6;\n$fa-var-utensils-alt: \\f2e6;\n$fa-var-forklift: \\f47a;\n$fa-var-forward: \\f04e;\n$fa-var-forward-fast: \\f050;\n$fa-var-fast-forward: \\f050;\n$fa-var-forward-step: \\f051;\n$fa-var-step-forward: \\f051;\n$fa-var-franc-sign: \\e18f;\n$fa-var-french-fries: \\f803;\n$fa-var-frog: \\f52e;\n$fa-var-function: \\f661;\n$fa-var-futbol: \\f1e3;\n$fa-var-futbol-ball: \\f1e3;\n$fa-var-soccer-ball: \\f1e3;\n$fa-var-g: \\47;\n$fa-var-galaxy: \\e008;\n$fa-var-gallery-thumbnails: \\e3aa;\n$fa-var-game-board: \\f867;\n$fa-var-game-board-simple: \\f868;\n$fa-var-game-board-alt: \\f868;\n$fa-var-game-console-handheld: \\f8bb;\n$fa-var-gamepad: \\f11b;\n$fa-var-gamepad-modern: \\f8bc;\n$fa-var-gamepad-alt: \\f8bc;\n$fa-var-garage: \\e009;\n$fa-var-garage-car: \\e00a;\n$fa-var-garage-open: \\e00b;\n$fa-var-garlic: \\e40e;\n$fa-var-gas-pump: \\f52f;\n$fa-var-gas-pump-slash: \\f5f4;\n$fa-var-gauge: \\f625;\n$fa-var-dashboard: \\f625;\n$fa-var-gauge-high: \\f625;\n$fa-var-tachometer-alt: \\f625;\n$fa-var-tachometer-alt-fast: \\f625;\n$fa-var-gauge-low: \\f627;\n$fa-var-tachometer-alt-slow: \\f627;\n$fa-var-gauge-max: \\f626;\n$fa-var-tachometer-alt-fastest: \\f626;\n$fa-var-gauge-med: \\f624;\n$fa-var-tachometer-alt-average: \\f624;\n$fa-var-gauge-min: \\f628;\n$fa-var-tachometer-alt-slowest: \\f628;\n$fa-var-gauge-simple: \\f62a;\n$fa-var-gauge-simple-high: \\f62a;\n$fa-var-tachometer: \\f62a;\n$fa-var-gauge-simple-low: \\f62c;\n$fa-var-tachometer-slow: \\f62c;\n$fa-var-gauge-simple-max: \\f62b;\n$fa-var-tachometer-fastest: \\f62b;\n$fa-var-gauge-simple-med: \\f629;\n$fa-var-tachometer-average: \\f629;\n$fa-var-gauge-simple-min: \\f62d;\n$fa-var-tachometer-slowest: \\f62d;\n$fa-var-gavel: \\f0e3;\n$fa-var-legal: \\f0e3;\n$fa-var-gear: \\f013;\n$fa-var-cog: \\f013;\n$fa-var-gears: \\f085;\n$fa-var-cogs: \\f085;\n$fa-var-gem: \\f3a5;\n$fa-var-genderless: \\f22d;\n$fa-var-ghost: \\f6e2;\n$fa-var-gif: \\e190;\n$fa-var-gift: \\f06b;\n$fa-var-gift-card: \\f663;\n$fa-var-gifts: \\f79c;\n$fa-var-gingerbread-man: \\f79d;\n$fa-var-glass: \\f804;\n$fa-var-glass-citrus: \\f869;\n$fa-var-glass-empty: \\e191;\n$fa-var-glass-half: \\e192;\n$fa-var-glass-half-empty: \\e192;\n$fa-var-glass-half-full: \\e192;\n$fa-var-glasses: \\f530;\n$fa-var-glasses-round: \\f5f5;\n$fa-var-glasses-alt: \\f5f5;\n$fa-var-globe: \\f0ac;\n$fa-var-globe-snow: \\f7a3;\n$fa-var-globe-stand: \\f5f6;\n$fa-var-goal-net: \\e3ab;\n$fa-var-golf-ball-tee: \\f450;\n$fa-var-golf-ball: \\f450;\n$fa-var-golf-club: \\f451;\n$fa-var-golf-flag-hole: \\e3ac;\n$fa-var-gopuram: \\f664;\n$fa-var-graduation-cap: \\f19d;\n$fa-var-mortar-board: \\f19d;\n$fa-var-gramophone: \\f8bd;\n$fa-var-grapes: \\e306;\n$fa-var-grate: \\e193;\n$fa-var-grate-droplet: \\e194;\n$fa-var-greater-than: \\3e;\n$fa-var-greater-than-equal: \\f532;\n$fa-var-grid: \\e195;\n$fa-var-grid-3: \\e195;\n$fa-var-grid-2: \\e196;\n$fa-var-grid-2-plus: \\e197;\n$fa-var-grid-4: \\e198;\n$fa-var-grid-5: \\e199;\n$fa-var-grid-dividers: \\e3ad;\n$fa-var-grid-horizontal: \\e307;\n$fa-var-grip: \\f58d;\n$fa-var-grip-horizontal: \\f58d;\n$fa-var-grip-dots: \\e410;\n$fa-var-grip-dots-vertical: \\e411;\n$fa-var-grip-lines: \\f7a4;\n$fa-var-grip-lines-vertical: \\f7a5;\n$fa-var-grip-vertical: \\f58e;\n$fa-var-guarani-sign: \\e19a;\n$fa-var-guitar: \\f7a6;\n$fa-var-guitar-electric: \\f8be;\n$fa-var-guitars: \\f8bf;\n$fa-var-gun: \\e19b;\n$fa-var-gun-slash: \\e19c;\n$fa-var-gun-squirt: \\e19d;\n$fa-var-h: \\48;\n$fa-var-h1: \\f313;\n$fa-var-h2: \\f314;\n$fa-var-h3: \\f315;\n$fa-var-h4: \\f86a;\n$fa-var-h5: \\e412;\n$fa-var-h6: \\e413;\n$fa-var-hammer: \\f6e3;\n$fa-var-hammer-crash: \\e414;\n$fa-var-hammer-war: \\f6e4;\n$fa-var-hamsa: \\f665;\n$fa-var-hand: \\f256;\n$fa-var-hand-paper: \\f256;\n$fa-var-hand-back-fist: \\f255;\n$fa-var-hand-rock: \\f255;\n$fa-var-hand-back-point-down: \\e19e;\n$fa-var-hand-back-point-left: \\e19f;\n$fa-var-hand-back-point-ribbon: \\e1a0;\n$fa-var-hand-back-point-right: \\e1a1;\n$fa-var-hand-back-point-up: \\e1a2;\n$fa-var-hand-dots: \\f461;\n$fa-var-allergies: \\f461;\n$fa-var-hand-fingers-crossed: \\e1a3;\n$fa-var-hand-fist: \\f6de;\n$fa-var-fist-raised: \\f6de;\n$fa-var-hand-heart: \\f4bc;\n$fa-var-hand-holding: \\f4bd;\n$fa-var-hand-holding-box: \\f47b;\n$fa-var-hand-holding-dollar: \\f4c0;\n$fa-var-hand-holding-usd: \\f4c0;\n$fa-var-hand-holding-droplet: \\f4c1;\n$fa-var-hand-holding-water: \\f4c1;\n$fa-var-hand-holding-heart: \\f4be;\n$fa-var-hand-holding-magic: \\f6e5;\n$fa-var-hand-holding-medical: \\e05c;\n$fa-var-hand-holding-seedling: \\f4bf;\n$fa-var-hand-holding-skull: \\e1a4;\n$fa-var-hand-horns: \\e1a9;\n$fa-var-hand-lizard: \\f258;\n$fa-var-hand-love: \\e1a5;\n$fa-var-hand-middle-finger: \\f806;\n$fa-var-hand-peace: \\f25b;\n$fa-var-hand-point-down: \\f0a7;\n$fa-var-hand-point-left: \\f0a5;\n$fa-var-hand-point-ribbon: \\e1a6;\n$fa-var-hand-point-right: \\f0a4;\n$fa-var-hand-point-up: \\f0a6;\n$fa-var-hand-pointer: \\f25a;\n$fa-var-hand-scissors: \\f257;\n$fa-var-hand-sparkles: \\e05d;\n$fa-var-hand-spock: \\f259;\n$fa-var-hand-wave: \\e1a7;\n$fa-var-hands: \\f2a7;\n$fa-var-sign-language: \\f2a7;\n$fa-var-signing: \\f2a7;\n$fa-var-hands-asl-interpreting: \\f2a3;\n$fa-var-american-sign-language-interpreting: \\f2a3;\n$fa-var-asl-interpreting: \\f2a3;\n$fa-var-hands-american-sign-language-interpreting: \\f2a3;\n$fa-var-hands-bubbles: \\e05e;\n$fa-var-hands-wash: \\e05e;\n$fa-var-hands-clapping: \\e1a8;\n$fa-var-hands-holding: \\f4c2;\n$fa-var-hands-holding-diamond: \\f47c;\n$fa-var-hand-receiving: \\f47c;\n$fa-var-hands-holding-dollar: \\f4c5;\n$fa-var-hands-usd: \\f4c5;\n$fa-var-hands-holding-heart: \\f4c3;\n$fa-var-hands-heart: \\f4c3;\n$fa-var-hands-praying: \\f684;\n$fa-var-praying-hands: \\f684;\n$fa-var-handshake: \\f2b5;\n$fa-var-handshake-angle: \\f4c4;\n$fa-var-hands-helping: \\f4c4;\n$fa-var-handshake-simple: \\f4c6;\n$fa-var-handshake-alt: \\f4c6;\n$fa-var-handshake-simple-slash: \\e05f;\n$fa-var-handshake-alt-slash: \\e05f;\n$fa-var-handshake-slash: \\e060;\n$fa-var-hanukiah: \\f6e6;\n$fa-var-hard-drive: \\f0a0;\n$fa-var-hdd: \\f0a0;\n$fa-var-hashtag: \\23;\n$fa-var-hashtag-lock: \\e415;\n$fa-var-hat-chef: \\f86b;\n$fa-var-hat-cowboy: \\f8c0;\n$fa-var-hat-cowboy-side: \\f8c1;\n$fa-var-hat-santa: \\f7a7;\n$fa-var-hat-winter: \\f7a8;\n$fa-var-hat-witch: \\f6e7;\n$fa-var-hat-wizard: \\f6e8;\n$fa-var-head-side: \\f6e9;\n$fa-var-head-side-brain: \\f808;\n$fa-var-head-side-cough: \\e061;\n$fa-var-head-side-cough-slash: \\e062;\n$fa-var-head-side-goggles: \\f6ea;\n$fa-var-head-vr: \\f6ea;\n$fa-var-head-side-headphones: \\f8c2;\n$fa-var-head-side-heart: \\e1aa;\n$fa-var-head-side-mask: \\e063;\n$fa-var-head-side-medical: \\f809;\n$fa-var-head-side-virus: \\e064;\n$fa-var-heading: \\f1dc;\n$fa-var-header: \\f1dc;\n$fa-var-headphones: \\f025;\n$fa-var-headphones-simple: \\f58f;\n$fa-var-headphones-alt: \\f58f;\n$fa-var-headset: \\f590;\n$fa-var-heart: \\f004;\n$fa-var-heart-crack: \\f7a9;\n$fa-var-heart-broken: \\f7a9;\n$fa-var-heart-half: \\e1ab;\n$fa-var-heart-half-stroke: \\e1ac;\n$fa-var-heart-half-alt: \\e1ac;\n$fa-var-heart-pulse: \\f21e;\n$fa-var-heartbeat: \\f21e;\n$fa-var-heat: \\e00c;\n$fa-var-helicopter: \\f533;\n$fa-var-helmet-battle: \\f6eb;\n$fa-var-helmet-safety: \\f807;\n$fa-var-hard-hat: \\f807;\n$fa-var-hat-hard: \\f807;\n$fa-var-hexagon: \\f312;\n$fa-var-hexagon-check: \\e416;\n$fa-var-hexagon-divide: \\e1ad;\n$fa-var-hexagon-exclamation: \\e417;\n$fa-var-hexagon-minus: \\f307;\n$fa-var-minus-hexagon: \\f307;\n$fa-var-hexagon-plus: \\f300;\n$fa-var-plus-hexagon: \\f300;\n$fa-var-hexagon-xmark: \\f2ee;\n$fa-var-times-hexagon: \\f2ee;\n$fa-var-xmark-hexagon: \\f2ee;\n$fa-var-high-definition: \\e1ae;\n$fa-var-rectangle-hd: \\e1ae;\n$fa-var-highlighter: \\f591;\n$fa-var-highlighter-line: \\e1af;\n$fa-var-hippo: \\f6ed;\n$fa-var-hockey-mask: \\f6ee;\n$fa-var-hockey-puck: \\f453;\n$fa-var-hockey-stick-puck: \\e3ae;\n$fa-var-hockey-sticks: \\f454;\n$fa-var-holly-berry: \\f7aa;\n$fa-var-honey-pot: \\e418;\n$fa-var-hood-cloak: \\f6ef;\n$fa-var-horizontal-rule: \\f86c;\n$fa-var-horse: \\f6f0;\n$fa-var-horse-head: \\f7ab;\n$fa-var-horse-saddle: \\f8c3;\n$fa-var-hose: \\e419;\n$fa-var-hose-reel: \\e41a;\n$fa-var-hospital: \\f0f8;\n$fa-var-hospital-user: \\f80d;\n$fa-var-hospital-wide: \\f47d;\n$fa-var-hospital-alt: \\f47d;\n$fa-var-hospitals: \\f80e;\n$fa-var-hot-tub-person: \\f593;\n$fa-var-hot-tub: \\f593;\n$fa-var-hotdog: \\f80f;\n$fa-var-hotel: \\f594;\n$fa-var-hourglass: \\f254;\n$fa-var-hourglass-2: \\f254;\n$fa-var-hourglass-half: \\f254;\n$fa-var-hourglass-clock: \\e41b;\n$fa-var-hourglass-empty: \\f252;\n$fa-var-hourglass-end: \\f253;\n$fa-var-hourglass-3: \\f253;\n$fa-var-hourglass-start: \\f251;\n$fa-var-hourglass-1: \\f251;\n$fa-var-house: \\f015;\n$fa-var-home: \\f015;\n$fa-var-house-blank: \\f80a;\n$fa-var-home-blank: \\f80a;\n$fa-var-home-lg-alt: \\f80a;\n$fa-var-house-building: \\e1b1;\n$fa-var-house-chimney: \\e3af;\n$fa-var-home-lg: \\e3af;\n$fa-var-house-chimney-blank: \\e3b0;\n$fa-var-house-chimney-crack: \\f6f1;\n$fa-var-house-damage: \\f6f1;\n$fa-var-house-chimney-heart: \\e1b2;\n$fa-var-house-chimney-medical: \\f7f2;\n$fa-var-clinic-medical: \\f7f2;\n$fa-var-house-chimney-user: \\e065;\n$fa-var-house-chimney-window: \\e00d;\n$fa-var-house-crack: \\e3b1;\n$fa-var-house-day: \\e00e;\n$fa-var-house-flood: \\f74f;\n$fa-var-house-heart: \\f4c9;\n$fa-var-home-heart: \\f4c9;\n$fa-var-house-laptop: \\e066;\n$fa-var-laptop-house: \\e066;\n$fa-var-house-medical: \\e3b2;\n$fa-var-house-night: \\e010;\n$fa-var-house-person-leave: \\e00f;\n$fa-var-house-person-depart: \\e00f;\n$fa-var-house-person-return: \\e011;\n$fa-var-house-person-arrive: \\e011;\n$fa-var-house-signal: \\e012;\n$fa-var-house-tree: \\e1b3;\n$fa-var-house-turret: \\e1b4;\n$fa-var-house-user: \\e1b0;\n$fa-var-home-user: \\e1b0;\n$fa-var-house-window: \\e3b3;\n$fa-var-hryvnia-sign: \\f6f2;\n$fa-var-hryvnia: \\f6f2;\n$fa-var-hundred-points: \\e41c;\n$fa-var-100: \\e41c;\n$fa-var-hurricane: \\f751;\n$fa-var-hyphen: \\2d;\n$fa-var-i: \\49;\n$fa-var-i-cursor: \\f246;\n$fa-var-ice-cream: \\f810;\n$fa-var-ice-skate: \\f7ac;\n$fa-var-icicles: \\f7ad;\n$fa-var-icons: \\f86d;\n$fa-var-heart-music-camera-bolt: \\f86d;\n$fa-var-id-badge: \\f2c1;\n$fa-var-id-card: \\f2c2;\n$fa-var-drivers-license: \\f2c2;\n$fa-var-id-card-clip: \\f47f;\n$fa-var-id-card-alt: \\f47f;\n$fa-var-igloo: \\f7ae;\n$fa-var-image: \\f03e;\n$fa-var-image-landscape: \\e1b5;\n$fa-var-landscape: \\e1b5;\n$fa-var-image-polaroid: \\f8c4;\n$fa-var-image-polaroid-user: \\e1b6;\n$fa-var-image-portrait: \\f3e0;\n$fa-var-portrait: \\f3e0;\n$fa-var-image-slash: \\e1b7;\n$fa-var-image-user: \\e1b8;\n$fa-var-images: \\f302;\n$fa-var-images-user: \\e1b9;\n$fa-var-inbox: \\f01c;\n$fa-var-inbox-full: \\e1ba;\n$fa-var-inbox-in: \\f310;\n$fa-var-inbox-arrow-down: \\f310;\n$fa-var-inbox-out: \\f311;\n$fa-var-inbox-arrow-up: \\f311;\n$fa-var-inboxes: \\e1bb;\n$fa-var-indent: \\f03c;\n$fa-var-indian-rupee-sign: \\e1bc;\n$fa-var-indian-rupee: \\e1bc;\n$fa-var-inr: \\e1bc;\n$fa-var-industry: \\f275;\n$fa-var-industry-windows: \\f3b3;\n$fa-var-industry-alt: \\f3b3;\n$fa-var-infinity: \\f534;\n$fa-var-info: \\f129;\n$fa-var-inhaler: \\f5f9;\n$fa-var-input-numeric: \\e1bd;\n$fa-var-input-pipe: \\e1be;\n$fa-var-input-text: \\e1bf;\n$fa-var-integral: \\f667;\n$fa-var-intersection: \\f668;\n$fa-var-island-tropical: \\f811;\n$fa-var-island-tree-palm: \\f811;\n$fa-var-italic: \\f033;\n$fa-var-j: \\4a;\n$fa-var-jack-o-lantern: \\f30e;\n$fa-var-jedi: \\f669;\n$fa-var-jet-fighter: \\f0fb;\n$fa-var-fighter-jet: \\f0fb;\n$fa-var-joint: \\f595;\n$fa-var-joystick: \\f8c5;\n$fa-var-jug: \\f8c6;\n$fa-var-k: \\4b;\n$fa-var-kaaba: \\f66b;\n$fa-var-kazoo: \\f8c7;\n$fa-var-kerning: \\f86f;\n$fa-var-key: \\f084;\n$fa-var-key-skeleton: \\f6f3;\n$fa-var-key-skeleton-left-right: \\e3b4;\n$fa-var-keyboard: \\f11c;\n$fa-var-keyboard-brightness: \\e1c0;\n$fa-var-keyboard-brightness-low: \\e1c1;\n$fa-var-keyboard-down: \\e1c2;\n$fa-var-keyboard-left: \\e1c3;\n$fa-var-keynote: \\f66c;\n$fa-var-khanda: \\f66d;\n$fa-var-kidneys: \\f5fb;\n$fa-var-kip-sign: \\e1c4;\n$fa-var-kit-medical: \\f479;\n$fa-var-first-aid: \\f479;\n$fa-var-kite: \\f6f4;\n$fa-var-kiwi-bird: \\f535;\n$fa-var-kiwi-fruit: \\e30c;\n$fa-var-knife: \\f2e4;\n$fa-var-utensil-knife: \\f2e4;\n$fa-var-knife-kitchen: \\f6f5;\n$fa-var-l: \\4c;\n$fa-var-lacrosse-stick: \\e3b5;\n$fa-var-lacrosse-stick-ball: \\e3b6;\n$fa-var-lambda: \\f66e;\n$fa-var-lamp: \\f4ca;\n$fa-var-lamp-desk: \\e014;\n$fa-var-lamp-floor: \\e015;\n$fa-var-lamp-street: \\e1c5;\n$fa-var-landmark: \\f66f;\n$fa-var-landmark-dome: \\f752;\n$fa-var-landmark-alt: \\f752;\n$fa-var-language: \\f1ab;\n$fa-var-laptop: \\f109;\n$fa-var-laptop-arrow-down: \\e1c6;\n$fa-var-laptop-code: \\f5fc;\n$fa-var-laptop-medical: \\f812;\n$fa-var-laptop-mobile: \\f87a;\n$fa-var-phone-laptop: \\f87a;\n$fa-var-laptop-slash: \\e1c7;\n$fa-var-lari-sign: \\e1c8;\n$fa-var-lasso: \\f8c8;\n$fa-var-lasso-sparkles: \\e1c9;\n$fa-var-layer-group: \\f5fd;\n$fa-var-layer-minus: \\f5fe;\n$fa-var-layer-group-minus: \\f5fe;\n$fa-var-layer-plus: \\f5ff;\n$fa-var-layer-group-plus: \\f5ff;\n$fa-var-leaf: \\f06c;\n$fa-var-leaf-heart: \\f4cb;\n$fa-var-leaf-maple: \\f6f6;\n$fa-var-leaf-oak: \\f6f7;\n$fa-var-leafy-green: \\e41d;\n$fa-var-left: \\f355;\n$fa-var-arrow-alt-left: \\f355;\n$fa-var-left-from-line: \\f348;\n$fa-var-arrow-alt-from-right: \\f348;\n$fa-var-left-long: \\f30a;\n$fa-var-long-arrow-alt-left: \\f30a;\n$fa-var-left-long-to-line: \\e41e;\n$fa-var-left-right: \\f337;\n$fa-var-arrows-alt-h: \\f337;\n$fa-var-left-to-line: \\f34b;\n$fa-var-arrow-alt-to-left: \\f34b;\n$fa-var-lemon: \\f094;\n$fa-var-less-than: \\3c;\n$fa-var-less-than-equal: \\f537;\n$fa-var-life-ring: \\f1cd;\n$fa-var-light-ceiling: \\e016;\n$fa-var-light-emergency: \\e41f;\n$fa-var-light-emergency-on: \\e420;\n$fa-var-light-switch: \\e017;\n$fa-var-light-switch-off: \\e018;\n$fa-var-light-switch-on: \\e019;\n$fa-var-lightbulb: \\f0eb;\n$fa-var-lightbulb-dollar: \\f670;\n$fa-var-lightbulb-exclamation: \\f671;\n$fa-var-lightbulb-exclamation-on: \\e1ca;\n$fa-var-lightbulb-on: \\f672;\n$fa-var-lightbulb-slash: \\f673;\n$fa-var-lights-holiday: \\f7b2;\n$fa-var-line-columns: \\f870;\n$fa-var-line-height: \\f871;\n$fa-var-link: \\f0c1;\n$fa-var-chain: \\f0c1;\n$fa-var-link-horizontal: \\e1cb;\n$fa-var-chain-horizontal: \\e1cb;\n$fa-var-link-horizontal-slash: \\e1cc;\n$fa-var-chain-horizontal-slash: \\e1cc;\n$fa-var-link-simple: \\e1cd;\n$fa-var-link-simple-slash: \\e1ce;\n$fa-var-link-slash: \\f127;\n$fa-var-chain-broken: \\f127;\n$fa-var-chain-slash: \\f127;\n$fa-var-unlink: \\f127;\n$fa-var-lips: \\f600;\n$fa-var-lira-sign: \\f195;\n$fa-var-list: \\f03a;\n$fa-var-list-squares: \\f03a;\n$fa-var-list-check: \\f0ae;\n$fa-var-tasks: \\f0ae;\n$fa-var-list-dropdown: \\e1cf;\n$fa-var-list-music: \\f8c9;\n$fa-var-list-ol: \\f0cb;\n$fa-var-list-1-2: \\f0cb;\n$fa-var-list-numeric: \\f0cb;\n$fa-var-list-radio: \\e1d0;\n$fa-var-list-timeline: \\e1d1;\n$fa-var-list-tree: \\e1d2;\n$fa-var-list-ul: \\f0ca;\n$fa-var-list-dots: \\f0ca;\n$fa-var-litecoin-sign: \\e1d3;\n$fa-var-loader: \\e1d4;\n$fa-var-lobster: \\e421;\n$fa-var-location-arrow: \\f124;\n$fa-var-location-check: \\f606;\n$fa-var-map-marker-check: \\f606;\n$fa-var-location-crosshairs: \\f601;\n$fa-var-location: \\f601;\n$fa-var-location-crosshairs-slash: \\f603;\n$fa-var-location-slash: \\f603;\n$fa-var-location-dot: \\f3c5;\n$fa-var-map-marker-alt: \\f3c5;\n$fa-var-location-dot-slash: \\f605;\n$fa-var-map-marker-alt-slash: \\f605;\n$fa-var-location-exclamation: \\f608;\n$fa-var-map-marker-exclamation: \\f608;\n$fa-var-location-minus: \\f609;\n$fa-var-map-marker-minus: \\f609;\n$fa-var-location-pen: \\f607;\n$fa-var-map-marker-edit: \\f607;\n$fa-var-location-pin: \\f041;\n$fa-var-map-marker: \\f041;\n$fa-var-location-pin-slash: \\f60c;\n$fa-var-map-marker-slash: \\f60c;\n$fa-var-location-plus: \\f60a;\n$fa-var-map-marker-plus: \\f60a;\n$fa-var-location-question: \\f60b;\n$fa-var-map-marker-question: \\f60b;\n$fa-var-location-smile: \\f60d;\n$fa-var-map-marker-smile: \\f60d;\n$fa-var-location-xmark: \\f60e;\n$fa-var-map-marker-times: \\f60e;\n$fa-var-map-marker-xmark: \\f60e;\n$fa-var-lock: \\f023;\n$fa-var-lock-a: \\e422;\n$fa-var-lock-hashtag: \\e423;\n$fa-var-lock-keyhole: \\f30d;\n$fa-var-lock-alt: \\f30d;\n$fa-var-lock-keyhole-open: \\f3c2;\n$fa-var-lock-open-alt: \\f3c2;\n$fa-var-lock-open: \\f3c1;\n$fa-var-lollipop: \\e424;\n$fa-var-lollypop: \\e424;\n$fa-var-loveseat: \\f4cc;\n$fa-var-couch-small: \\f4cc;\n$fa-var-luchador-mask: \\f455;\n$fa-var-luchador: \\f455;\n$fa-var-mask-luchador: \\f455;\n$fa-var-lungs: \\f604;\n$fa-var-lungs-virus: \\e067;\n$fa-var-m: \\4d;\n$fa-var-mace: \\f6f8;\n$fa-var-magnet: \\f076;\n$fa-var-magnifying-glass: \\f002;\n$fa-var-search: \\f002;\n$fa-var-magnifying-glass-dollar: \\f688;\n$fa-var-search-dollar: \\f688;\n$fa-var-magnifying-glass-location: \\f689;\n$fa-var-search-location: \\f689;\n$fa-var-magnifying-glass-minus: \\f010;\n$fa-var-search-minus: \\f010;\n$fa-var-magnifying-glass-plus: \\f00e;\n$fa-var-search-plus: \\f00e;\n$fa-var-mailbox: \\f813;\n$fa-var-manat-sign: \\e1d5;\n$fa-var-mandolin: \\f6f9;\n$fa-var-mango: \\e30f;\n$fa-var-manhole: \\e1d6;\n$fa-var-map: \\f279;\n$fa-var-map-location: \\f59f;\n$fa-var-map-marked: \\f59f;\n$fa-var-map-location-dot: \\f5a0;\n$fa-var-map-marked-alt: \\f5a0;\n$fa-var-map-pin: \\f276;\n$fa-var-marker: \\f5a1;\n$fa-var-mars: \\f222;\n$fa-var-mars-and-venus: \\f224;\n$fa-var-mars-double: \\f227;\n$fa-var-mars-stroke: \\f229;\n$fa-var-mars-stroke-right: \\f22b;\n$fa-var-mars-stroke-h: \\f22b;\n$fa-var-mars-stroke-up: \\f22a;\n$fa-var-mars-stroke-v: \\f22a;\n$fa-var-martini-glass: \\f57b;\n$fa-var-glass-martini-alt: \\f57b;\n$fa-var-martini-glass-citrus: \\f561;\n$fa-var-cocktail: \\f561;\n$fa-var-martini-glass-empty: \\f000;\n$fa-var-glass-martini: \\f000;\n$fa-var-mask: \\f6fa;\n$fa-var-mask-face: \\e1d7;\n$fa-var-mask-snorkel: \\e3b7;\n$fa-var-masks-theater: \\f630;\n$fa-var-theater-masks: \\f630;\n$fa-var-maximize: \\f31e;\n$fa-var-expand-arrows-alt: \\f31e;\n$fa-var-meat: \\f814;\n$fa-var-medal: \\f5a2;\n$fa-var-megaphone: \\f675;\n$fa-var-melon: \\e310;\n$fa-var-melon-slice: \\e311;\n$fa-var-memo: \\e1d8;\n$fa-var-memo-circle-check: \\e1d9;\n$fa-var-memo-pad: \\e1da;\n$fa-var-memory: \\f538;\n$fa-var-menorah: \\f676;\n$fa-var-mercury: \\f223;\n$fa-var-message: \\f27a;\n$fa-var-comment-alt: \\f27a;\n$fa-var-message-arrow-down: \\e1db;\n$fa-var-comment-alt-arrow-down: \\e1db;\n$fa-var-message-arrow-up: \\e1dc;\n$fa-var-comment-alt-arrow-up: \\e1dc;\n$fa-var-message-arrow-up-right: \\e1dd;\n$fa-var-message-bot: \\e3b8;\n$fa-var-message-captions: \\e1de;\n$fa-var-comment-alt-captions: \\e1de;\n$fa-var-message-check: \\f4a2;\n$fa-var-comment-alt-check: \\f4a2;\n$fa-var-message-code: \\e1df;\n$fa-var-message-dollar: \\f650;\n$fa-var-comment-alt-dollar: \\f650;\n$fa-var-message-dots: \\f4a3;\n$fa-var-comment-alt-dots: \\f4a3;\n$fa-var-messaging: \\f4a3;\n$fa-var-message-exclamation: \\f4a5;\n$fa-var-comment-alt-exclamation: \\f4a5;\n$fa-var-message-image: \\e1e0;\n$fa-var-comment-alt-image: \\e1e0;\n$fa-var-message-lines: \\f4a6;\n$fa-var-comment-alt-lines: \\f4a6;\n$fa-var-message-medical: \\f7f4;\n$fa-var-comment-alt-medical: \\f7f4;\n$fa-var-message-middle: \\e1e1;\n$fa-var-comment-middle-alt: \\e1e1;\n$fa-var-message-middle-top: \\e1e2;\n$fa-var-comment-middle-top-alt: \\e1e2;\n$fa-var-message-minus: \\f4a7;\n$fa-var-comment-alt-minus: \\f4a7;\n$fa-var-message-music: \\f8af;\n$fa-var-comment-alt-music: \\f8af;\n$fa-var-message-pen: \\f4a4;\n$fa-var-comment-alt-edit: \\f4a4;\n$fa-var-message-edit: \\f4a4;\n$fa-var-message-plus: \\f4a8;\n$fa-var-comment-alt-plus: \\f4a8;\n$fa-var-message-question: \\e1e3;\n$fa-var-message-quote: \\e1e4;\n$fa-var-comment-alt-quote: \\e1e4;\n$fa-var-message-slash: \\f4a9;\n$fa-var-comment-alt-slash: \\f4a9;\n$fa-var-message-smile: \\f4aa;\n$fa-var-comment-alt-smile: \\f4aa;\n$fa-var-message-sms: \\e1e5;\n$fa-var-message-text: \\e1e6;\n$fa-var-comment-alt-text: \\e1e6;\n$fa-var-message-xmark: \\f4ab;\n$fa-var-comment-alt-times: \\f4ab;\n$fa-var-message-times: \\f4ab;\n$fa-var-messages: \\f4b6;\n$fa-var-comments-alt: \\f4b6;\n$fa-var-messages-dollar: \\f652;\n$fa-var-comments-alt-dollar: \\f652;\n$fa-var-messages-question: \\e1e7;\n$fa-var-meteor: \\f753;\n$fa-var-meter: \\e1e8;\n$fa-var-meter-bolt: \\e1e9;\n$fa-var-meter-droplet: \\e1ea;\n$fa-var-meter-fire: \\e1eb;\n$fa-var-microchip: \\f2db;\n$fa-var-microchip-ai: \\e1ec;\n$fa-var-microphone: \\f130;\n$fa-var-microphone-lines: \\f3c9;\n$fa-var-microphone-alt: \\f3c9;\n$fa-var-microphone-lines-slash: \\f539;\n$fa-var-microphone-alt-slash: \\f539;\n$fa-var-microphone-slash: \\f131;\n$fa-var-microphone-stand: \\f8cb;\n$fa-var-microscope: \\f610;\n$fa-var-microwave: \\e01b;\n$fa-var-mill-sign: \\e1ed;\n$fa-var-minimize: \\f78c;\n$fa-var-compress-arrows-alt: \\f78c;\n$fa-var-minus: \\f068;\n$fa-var-subtract: \\f068;\n$fa-var-mistletoe: \\f7b4;\n$fa-var-mitten: \\f7b5;\n$fa-var-mobile: \\f3ce;\n$fa-var-mobile-android: \\f3ce;\n$fa-var-mobile-phone: \\f3ce;\n$fa-var-mobile-button: \\f10b;\n$fa-var-mobile-notch: \\e1ee;\n$fa-var-mobile-iphone: \\e1ee;\n$fa-var-mobile-screen: \\f3cf;\n$fa-var-mobile-android-alt: \\f3cf;\n$fa-var-mobile-screen-button: \\f3cd;\n$fa-var-mobile-alt: \\f3cd;\n$fa-var-mobile-signal: \\e1ef;\n$fa-var-mobile-signal-out: \\e1f0;\n$fa-var-money-bill: \\f0d6;\n$fa-var-money-bill-1: \\f3d1;\n$fa-var-money-bill-alt: \\f3d1;\n$fa-var-money-bill-1-wave: \\f53b;\n$fa-var-money-bill-wave-alt: \\f53b;\n$fa-var-money-bill-simple: \\e1f1;\n$fa-var-money-bill-simple-wave: \\e1f2;\n$fa-var-money-bill-wave: \\f53a;\n$fa-var-money-bills: \\e1f3;\n$fa-var-money-bills-simple: \\e1f4;\n$fa-var-money-bills-alt: \\e1f4;\n$fa-var-money-check: \\f53c;\n$fa-var-money-check-dollar: \\f53d;\n$fa-var-money-check-alt: \\f53d;\n$fa-var-money-check-dollar-pen: \\f873;\n$fa-var-money-check-edit-alt: \\f873;\n$fa-var-money-check-pen: \\f872;\n$fa-var-money-check-edit: \\f872;\n$fa-var-money-from-bracket: \\e312;\n$fa-var-money-simple-from-bracket: \\e313;\n$fa-var-monitor-waveform: \\f611;\n$fa-var-monitor-heart-rate: \\f611;\n$fa-var-monkey: \\f6fb;\n$fa-var-monument: \\f5a6;\n$fa-var-moon: \\f186;\n$fa-var-moon-cloud: \\f754;\n$fa-var-moon-over-sun: \\f74a;\n$fa-var-eclipse-alt: \\f74a;\n$fa-var-moon-stars: \\f755;\n$fa-var-moped: \\e3b9;\n$fa-var-mortar-pestle: \\f5a7;\n$fa-var-mosque: \\f678;\n$fa-var-motorcycle: \\f21c;\n$fa-var-mountain: \\f6fc;\n$fa-var-mountains: \\f6fd;\n$fa-var-mp3-player: \\f8ce;\n$fa-var-mug: \\f874;\n$fa-var-mug-hot: \\f7b6;\n$fa-var-mug-marshmallows: \\f7b7;\n$fa-var-mug-saucer: \\f0f4;\n$fa-var-coffee: \\f0f4;\n$fa-var-mug-tea: \\f875;\n$fa-var-mug-tea-saucer: \\e1f5;\n$fa-var-mushroom: \\e425;\n$fa-var-music: \\f001;\n$fa-var-music-note: \\f8cf;\n$fa-var-music-alt: \\f8cf;\n$fa-var-music-note-slash: \\f8d0;\n$fa-var-music-alt-slash: \\f8d0;\n$fa-var-music-slash: \\f8d1;\n$fa-var-n: \\4e;\n$fa-var-naira-sign: \\e1f6;\n$fa-var-narwhal: \\f6fe;\n$fa-var-nesting-dolls: \\e3ba;\n$fa-var-network-wired: \\f6ff;\n$fa-var-neuter: \\f22c;\n$fa-var-newspaper: \\f1ea;\n$fa-var-nfc: \\e1f7;\n$fa-var-nfc-lock: \\e1f8;\n$fa-var-nfc-magnifying-glass: \\e1f9;\n$fa-var-nfc-pen: \\e1fa;\n$fa-var-nfc-signal: \\e1fb;\n$fa-var-nfc-slash: \\e1fc;\n$fa-var-nfc-trash: \\e1fd;\n$fa-var-not-equal: \\f53e;\n$fa-var-notdef: \\e1fe;\n$fa-var-note: \\e1ff;\n$fa-var-note-medical: \\e200;\n$fa-var-note-sticky: \\f249;\n$fa-var-sticky-note: \\f249;\n$fa-var-notebook: \\e201;\n$fa-var-notes: \\e202;\n$fa-var-notes-medical: \\f481;\n$fa-var-o: \\4f;\n$fa-var-object-group: \\f247;\n$fa-var-object-ungroup: \\f248;\n$fa-var-objects-align-bottom: \\e3bb;\n$fa-var-objects-align-center-horizontal: \\e3bc;\n$fa-var-objects-align-center-vertical: \\e3bd;\n$fa-var-objects-align-left: \\e3be;\n$fa-var-objects-align-right: \\e3bf;\n$fa-var-objects-align-top: \\e3c0;\n$fa-var-objects-column: \\e3c1;\n$fa-var-octagon: \\f306;\n$fa-var-octagon-check: \\e426;\n$fa-var-octagon-divide: \\e203;\n$fa-var-octagon-exclamation: \\e204;\n$fa-var-octagon-minus: \\f308;\n$fa-var-minus-octagon: \\f308;\n$fa-var-octagon-plus: \\f301;\n$fa-var-plus-octagon: \\f301;\n$fa-var-octagon-xmark: \\f2f0;\n$fa-var-times-octagon: \\f2f0;\n$fa-var-xmark-octagon: \\f2f0;\n$fa-var-oil-can: \\f613;\n$fa-var-oil-can-drip: \\e205;\n$fa-var-oil-temperature: \\f614;\n$fa-var-oil-temp: \\f614;\n$fa-var-olive: \\e316;\n$fa-var-olive-branch: \\e317;\n$fa-var-om: \\f679;\n$fa-var-omega: \\f67a;\n$fa-var-onion: \\e427;\n$fa-var-option: \\e318;\n$fa-var-ornament: \\f7b8;\n$fa-var-otter: \\f700;\n$fa-var-outdent: \\f03b;\n$fa-var-dedent: \\f03b;\n$fa-var-outlet: \\e01c;\n$fa-var-oven: \\e01d;\n$fa-var-overline: \\f876;\n$fa-var-p: \\50;\n$fa-var-page: \\e428;\n$fa-var-page-caret-down: \\e429;\n$fa-var-file-caret-down: \\e429;\n$fa-var-page-caret-up: \\e42a;\n$fa-var-file-caret-up: \\e42a;\n$fa-var-pager: \\f815;\n$fa-var-paint-brush: \\f1fc;\n$fa-var-paint-brush-fine: \\f5a9;\n$fa-var-paint-brush-alt: \\f5a9;\n$fa-var-paint-roller: \\f5aa;\n$fa-var-paintbrush-pencil: \\e206;\n$fa-var-palette: \\f53f;\n$fa-var-pallet: \\f482;\n$fa-var-pallet-box: \\e208;\n$fa-var-pallet-boxes: \\f483;\n$fa-var-palette-boxes: \\f483;\n$fa-var-pallet-alt: \\f483;\n$fa-var-pan-food: \\e42b;\n$fa-var-pan-frying: \\e42c;\n$fa-var-pancakes: \\e42d;\n$fa-var-panel-ews: \\e42e;\n$fa-var-panel-fire: \\e42f;\n$fa-var-panorama: \\e209;\n$fa-var-paper-plane: \\f1d8;\n$fa-var-paper-plane-top: \\e20a;\n$fa-var-paper-plane-alt: \\e20a;\n$fa-var-send: \\e20a;\n$fa-var-paperclip: \\f0c6;\n$fa-var-paperclip-vertical: \\e3c2;\n$fa-var-parachute-box: \\f4cd;\n$fa-var-paragraph: \\f1dd;\n$fa-var-paragraph-left: \\f878;\n$fa-var-paragraph-rtl: \\f878;\n$fa-var-party-bell: \\e31a;\n$fa-var-party-horn: \\e31b;\n$fa-var-passport: \\f5ab;\n$fa-var-paste: \\f0ea;\n$fa-var-file-clipboard: \\f0ea;\n$fa-var-pause: \\f04c;\n$fa-var-paw: \\f1b0;\n$fa-var-paw-claws: \\f702;\n$fa-var-paw-simple: \\f701;\n$fa-var-paw-alt: \\f701;\n$fa-var-peace: \\f67c;\n$fa-var-peach: \\e20b;\n$fa-var-peanut: \\e430;\n$fa-var-peanuts: \\e431;\n$fa-var-peapod: \\e31c;\n$fa-var-pear: \\e20c;\n$fa-var-pedestal: \\e20d;\n$fa-var-pegasus: \\f703;\n$fa-var-pen: \\f304;\n$fa-var-pen-circle: \\e20e;\n$fa-var-pen-clip: \\f305;\n$fa-var-pen-alt: \\f305;\n$fa-var-pen-clip-slash: \\e20f;\n$fa-var-pen-alt-slash: \\e20f;\n$fa-var-pen-fancy: \\f5ac;\n$fa-var-pen-fancy-slash: \\e210;\n$fa-var-pen-field: \\e211;\n$fa-var-pen-line: \\e212;\n$fa-var-pen-nib: \\f5ad;\n$fa-var-pen-paintbrush: \\f618;\n$fa-var-pencil-paintbrush: \\f618;\n$fa-var-pen-ruler: \\f5ae;\n$fa-var-pencil-ruler: \\f5ae;\n$fa-var-pen-slash: \\e213;\n$fa-var-pen-swirl: \\e214;\n$fa-var-pen-to-square: \\f044;\n$fa-var-edit: \\f044;\n$fa-var-pencil: \\f303;\n$fa-var-pencil-alt: \\f303;\n$fa-var-pencil-slash: \\e215;\n$fa-var-people: \\e216;\n$fa-var-people-arrows-left-right: \\e068;\n$fa-var-people-arrows: \\e068;\n$fa-var-people-carry-box: \\f4ce;\n$fa-var-people-carry: \\f4ce;\n$fa-var-people-dress: \\e217;\n$fa-var-people-dress-simple: \\e218;\n$fa-var-people-pants: \\e219;\n$fa-var-people-pants-simple: \\e21a;\n$fa-var-people-simple: \\e21b;\n$fa-var-pepper: \\e432;\n$fa-var-pepper-hot: \\f816;\n$fa-var-percent: \\25;\n$fa-var-percentage: \\25;\n$fa-var-period: \\2e;\n$fa-var-person: \\f183;\n$fa-var-male: \\f183;\n$fa-var-person-biking: \\f84a;\n$fa-var-biking: \\f84a;\n$fa-var-person-biking-mountain: \\f84b;\n$fa-var-biking-mountain: \\f84b;\n$fa-var-person-booth: \\f756;\n$fa-var-person-carry-box: \\f4cf;\n$fa-var-person-carry: \\f4cf;\n$fa-var-person-digging: \\f85e;\n$fa-var-digging: \\f85e;\n$fa-var-person-dolly: \\f4d0;\n$fa-var-person-dolly-empty: \\f4d1;\n$fa-var-person-dots-from-line: \\f470;\n$fa-var-diagnoses: \\f470;\n$fa-var-person-dress: \\f182;\n$fa-var-female: \\f182;\n$fa-var-person-dress-simple: \\e21c;\n$fa-var-person-from-portal: \\e023;\n$fa-var-portal-exit: \\e023;\n$fa-var-person-hiking: \\f6ec;\n$fa-var-hiking: \\f6ec;\n$fa-var-person-pinball: \\e21d;\n$fa-var-person-praying: \\f683;\n$fa-var-pray: \\f683;\n$fa-var-person-pregnant: \\e31e;\n$fa-var-person-running: \\f70c;\n$fa-var-running: \\f70c;\n$fa-var-person-seat: \\e21e;\n$fa-var-person-seat-reclined: \\e21f;\n$fa-var-person-sign: \\f757;\n$fa-var-person-simple: \\e220;\n$fa-var-person-skating: \\f7c5;\n$fa-var-skating: \\f7c5;\n$fa-var-person-ski-jumping: \\f7c7;\n$fa-var-ski-jump: \\f7c7;\n$fa-var-person-ski-lift: \\f7c8;\n$fa-var-ski-lift: \\f7c8;\n$fa-var-person-skiing: \\f7c9;\n$fa-var-skiing: \\f7c9;\n$fa-var-person-skiing-nordic: \\f7ca;\n$fa-var-skiing-nordic: \\f7ca;\n$fa-var-person-sledding: \\f7cb;\n$fa-var-sledding: \\f7cb;\n$fa-var-person-snowboarding: \\f7ce;\n$fa-var-snowboarding: \\f7ce;\n$fa-var-person-snowmobiling: \\f7d1;\n$fa-var-snowmobile: \\f7d1;\n$fa-var-person-swimming: \\f5c4;\n$fa-var-swimmer: \\f5c4;\n$fa-var-person-to-door: \\e433;\n$fa-var-person-to-portal: \\e022;\n$fa-var-portal-enter: \\e022;\n$fa-var-person-walking: \\f554;\n$fa-var-walking: \\f554;\n$fa-var-person-walking-with-cane: \\f29d;\n$fa-var-blind: \\f29d;\n$fa-var-peseta-sign: \\e221;\n$fa-var-peso-sign: \\e222;\n$fa-var-phone: \\f095;\n$fa-var-phone-arrow-down-left: \\e223;\n$fa-var-phone-arrow-down: \\e223;\n$fa-var-phone-incoming: \\e223;\n$fa-var-phone-arrow-up-right: \\e224;\n$fa-var-phone-arrow-up: \\e224;\n$fa-var-phone-outgoing: \\e224;\n$fa-var-phone-flip: \\f879;\n$fa-var-phone-alt: \\f879;\n$fa-var-phone-hangup: \\e225;\n$fa-var-phone-intercom: \\e434;\n$fa-var-phone-missed: \\e226;\n$fa-var-phone-office: \\f67d;\n$fa-var-phone-plus: \\f4d2;\n$fa-var-phone-rotary: \\f8d3;\n$fa-var-phone-slash: \\f3dd;\n$fa-var-phone-volume: \\f2a0;\n$fa-var-volume-control-phone: \\f2a0;\n$fa-var-phone-xmark: \\e227;\n$fa-var-photo-film: \\f87c;\n$fa-var-photo-video: \\f87c;\n$fa-var-photo-film-music: \\e228;\n$fa-var-pi: \\f67e;\n$fa-var-piano: \\f8d4;\n$fa-var-piano-keyboard: \\f8d5;\n$fa-var-pickleball: \\e435;\n$fa-var-pie: \\f705;\n$fa-var-pig: \\f706;\n$fa-var-piggy-bank: \\f4d3;\n$fa-var-pills: \\f484;\n$fa-var-pinata: \\e3c3;\n$fa-var-pinball: \\e229;\n$fa-var-pineapple: \\e31f;\n$fa-var-pipe: \\7c;\n$fa-var-pipe-circle-check: \\e436;\n$fa-var-pipe-collar: \\e437;\n$fa-var-pipe-section: \\e438;\n$fa-var-pipe-smoking: \\e3c4;\n$fa-var-pipe-valve: \\e439;\n$fa-var-pizza: \\f817;\n$fa-var-pizza-slice: \\f818;\n$fa-var-place-of-worship: \\f67f;\n$fa-var-plane: \\f072;\n$fa-var-plane-arrival: \\f5af;\n$fa-var-plane-departure: \\f5b0;\n$fa-var-plane-engines: \\f3de;\n$fa-var-plane-alt: \\f3de;\n$fa-var-plane-prop: \\e22b;\n$fa-var-plane-slash: \\e069;\n$fa-var-plane-tail: \\e22c;\n$fa-var-plane-up: \\e22d;\n$fa-var-plane-up-slash: \\e22e;\n$fa-var-planet-moon: \\e01f;\n$fa-var-planet-ringed: \\e020;\n$fa-var-plate-utensils: \\e43b;\n$fa-var-play: \\f04b;\n$fa-var-play-pause: \\e22f;\n$fa-var-plug: \\f1e6;\n$fa-var-plus: \\2b;\n$fa-var-add: \\2b;\n$fa-var-plus-minus: \\e43c;\n$fa-var-podcast: \\f2ce;\n$fa-var-podium: \\f680;\n$fa-var-podium-star: \\f758;\n$fa-var-police-box: \\e021;\n$fa-var-poll-people: \\f759;\n$fa-var-pompebled: \\e43d;\n$fa-var-poo: \\f2fe;\n$fa-var-poo-storm: \\f75a;\n$fa-var-poo-bolt: \\f75a;\n$fa-var-pool-8-ball: \\e3c5;\n$fa-var-poop: \\f619;\n$fa-var-popcorn: \\f819;\n$fa-var-popsicle: \\e43e;\n$fa-var-pot-food: \\e43f;\n$fa-var-potato: \\e440;\n$fa-var-power-off: \\f011;\n$fa-var-prescription: \\f5b1;\n$fa-var-prescription-bottle: \\f485;\n$fa-var-prescription-bottle-medical: \\f486;\n$fa-var-prescription-bottle-alt: \\f486;\n$fa-var-presentation-screen: \\f685;\n$fa-var-presentation: \\f685;\n$fa-var-pretzel: \\e441;\n$fa-var-print: \\f02f;\n$fa-var-print-magnifying-glass: \\f81a;\n$fa-var-print-search: \\f81a;\n$fa-var-print-slash: \\f686;\n$fa-var-projector: \\f8d6;\n$fa-var-pump: \\e442;\n$fa-var-pump-medical: \\e06a;\n$fa-var-pump-soap: \\e06b;\n$fa-var-pumpkin: \\f707;\n$fa-var-puzzle: \\e443;\n$fa-var-puzzle-piece: \\f12e;\n$fa-var-puzzle-piece-simple: \\e231;\n$fa-var-puzzle-piece-alt: \\e231;\n$fa-var-q: \\51;\n$fa-var-qrcode: \\f029;\n$fa-var-question: \\3f;\n$fa-var-quidditch: \\f458;\n$fa-var-broom-ball: \\f458;\n$fa-var-quidditch-broom-ball: \\f458;\n$fa-var-quote-left: \\f10d;\n$fa-var-quote-left-alt: \\f10d;\n$fa-var-quote-right: \\f10e;\n$fa-var-quote-right-alt: \\f10e;\n$fa-var-quotes: \\e234;\n$fa-var-r: \\52;\n$fa-var-rabbit: \\f708;\n$fa-var-rabbit-running: \\f709;\n$fa-var-rabbit-fast: \\f709;\n$fa-var-racquet: \\f45a;\n$fa-var-radar: \\e024;\n$fa-var-radiation: \\f7b9;\n$fa-var-radio: \\f8d7;\n$fa-var-radio-tuner: \\f8d8;\n$fa-var-radio-alt: \\f8d8;\n$fa-var-rainbow: \\f75b;\n$fa-var-raindrops: \\f75c;\n$fa-var-ram: \\f70a;\n$fa-var-ramp-loading: \\f4d4;\n$fa-var-raygun: \\e025;\n$fa-var-receipt: \\f543;\n$fa-var-record-vinyl: \\f8d9;\n$fa-var-rectangle: \\f2fa;\n$fa-var-rectangle-landscape: \\f2fa;\n$fa-var-rectangle-ad: \\f641;\n$fa-var-ad: \\f641;\n$fa-var-rectangle-barcode: \\f463;\n$fa-var-barcode-alt: \\f463;\n$fa-var-rectangle-code: \\e322;\n$fa-var-rectangle-list: \\f022;\n$fa-var-list-alt: \\f022;\n$fa-var-rectangle-pro: \\e235;\n$fa-var-pro: \\e235;\n$fa-var-rectangle-terminal: \\e236;\n$fa-var-rectangle-vertical: \\f2fb;\n$fa-var-rectangle-portrait: \\f2fb;\n$fa-var-rectangle-vertical-history: \\e237;\n$fa-var-rectangle-wide: \\f2fc;\n$fa-var-rectangle-xmark: \\f410;\n$fa-var-rectangle-times: \\f410;\n$fa-var-times-rectangle: \\f410;\n$fa-var-window-close: \\f410;\n$fa-var-rectangles-mixed: \\e323;\n$fa-var-recycle: \\f1b8;\n$fa-var-reel: \\e238;\n$fa-var-refrigerator: \\e026;\n$fa-var-registered: \\f25d;\n$fa-var-repeat: \\f363;\n$fa-var-repeat-1: \\f365;\n$fa-var-reply: \\f3e5;\n$fa-var-mail-reply: \\f3e5;\n$fa-var-reply-all: \\f122;\n$fa-var-mail-reply-all: \\f122;\n$fa-var-reply-clock: \\e239;\n$fa-var-reply-time: \\e239;\n$fa-var-republican: \\f75e;\n$fa-var-restroom: \\f7bd;\n$fa-var-restroom-simple: \\e23a;\n$fa-var-retweet: \\f079;\n$fa-var-rhombus: \\e23b;\n$fa-var-ribbon: \\f4d6;\n$fa-var-right: \\f356;\n$fa-var-arrow-alt-right: \\f356;\n$fa-var-right-from-bracket: \\f2f5;\n$fa-var-sign-out-alt: \\f2f5;\n$fa-var-right-from-line: \\f347;\n$fa-var-arrow-alt-from-left: \\f347;\n$fa-var-right-left: \\f362;\n$fa-var-exchange-alt: \\f362;\n$fa-var-right-long: \\f30b;\n$fa-var-long-arrow-alt-right: \\f30b;\n$fa-var-right-long-to-line: \\e444;\n$fa-var-right-to-bracket: \\f2f6;\n$fa-var-sign-in-alt: \\f2f6;\n$fa-var-right-to-line: \\f34c;\n$fa-var-arrow-alt-to-right: \\f34c;\n$fa-var-ring: \\f70b;\n$fa-var-rings-wedding: \\f81b;\n$fa-var-road: \\f018;\n$fa-var-robot: \\f544;\n$fa-var-robot-astromech: \\e2d2;\n$fa-var-rocket: \\f135;\n$fa-var-rocket-launch: \\e027;\n$fa-var-roller-coaster: \\e324;\n$fa-var-rotate: \\f2f1;\n$fa-var-sync-alt: \\f2f1;\n$fa-var-rotate-exclamation: \\e23c;\n$fa-var-rotate-left: \\f2ea;\n$fa-var-rotate-back: \\f2ea;\n$fa-var-rotate-backward: \\f2ea;\n$fa-var-undo-alt: \\f2ea;\n$fa-var-rotate-right: \\f2f9;\n$fa-var-redo-alt: \\f2f9;\n$fa-var-rotate-forward: \\f2f9;\n$fa-var-route: \\f4d7;\n$fa-var-route-highway: \\f61a;\n$fa-var-route-interstate: \\f61b;\n$fa-var-router: \\f8da;\n$fa-var-rss: \\f09e;\n$fa-var-feed: \\f09e;\n$fa-var-ruble-sign: \\f158;\n$fa-var-rouble: \\f158;\n$fa-var-rub: \\f158;\n$fa-var-ruble: \\f158;\n$fa-var-rugby-ball: \\e3c6;\n$fa-var-ruler: \\f545;\n$fa-var-ruler-combined: \\f546;\n$fa-var-ruler-horizontal: \\f547;\n$fa-var-ruler-triangle: \\f61c;\n$fa-var-ruler-vertical: \\f548;\n$fa-var-rupee-sign: \\f156;\n$fa-var-rupee: \\f156;\n$fa-var-rupiah-sign: \\e23d;\n$fa-var-rv: \\f7be;\n$fa-var-s: \\53;\n$fa-var-sack: \\f81c;\n$fa-var-sack-dollar: \\f81d;\n$fa-var-sailboat: \\e445;\n$fa-var-salad: \\f81e;\n$fa-var-bowl-salad: \\f81e;\n$fa-var-salt-shaker: \\e446;\n$fa-var-sandwich: \\f81f;\n$fa-var-satellite: \\f7bf;\n$fa-var-satellite-dish: \\f7c0;\n$fa-var-sausage: \\f820;\n$fa-var-saxophone: \\f8dc;\n$fa-var-saxophone-fire: \\f8db;\n$fa-var-sax-hot: \\f8db;\n$fa-var-scale-balanced: \\f24e;\n$fa-var-balance-scale: \\f24e;\n$fa-var-scale-unbalanced: \\f515;\n$fa-var-balance-scale-left: \\f515;\n$fa-var-scale-unbalanced-flip: \\f516;\n$fa-var-balance-scale-right: \\f516;\n$fa-var-scalpel: \\f61d;\n$fa-var-scalpel-line-dashed: \\f61e;\n$fa-var-scalpel-path: \\f61e;\n$fa-var-scanner: \\f8f3;\n$fa-var-scanner-image: \\f8f3;\n$fa-var-scanner-gun: \\f488;\n$fa-var-scanner-keyboard: \\f489;\n$fa-var-scanner-touchscreen: \\f48a;\n$fa-var-scarecrow: \\f70d;\n$fa-var-scarf: \\f7c1;\n$fa-var-school: \\f549;\n$fa-var-scissors: \\f0c4;\n$fa-var-cut: \\f0c4;\n$fa-var-screen-users: \\f63d;\n$fa-var-users-class: \\f63d;\n$fa-var-screencast: \\e23e;\n$fa-var-screwdriver: \\f54a;\n$fa-var-screwdriver-wrench: \\f7d9;\n$fa-var-tools: \\f7d9;\n$fa-var-scribble: \\e23f;\n$fa-var-scroll: \\f70e;\n$fa-var-scroll-old: \\f70f;\n$fa-var-scroll-torah: \\f6a0;\n$fa-var-torah: \\f6a0;\n$fa-var-scrubber: \\f2f8;\n$fa-var-scythe: \\f710;\n$fa-var-sd-card: \\f7c2;\n$fa-var-sd-cards: \\e240;\n$fa-var-seal: \\e241;\n$fa-var-seal-exclamation: \\e242;\n$fa-var-seal-question: \\e243;\n$fa-var-seat-airline: \\e244;\n$fa-var-section: \\e447;\n$fa-var-seedling: \\f4d8;\n$fa-var-sprout: \\f4d8;\n$fa-var-semicolon: \\3b;\n$fa-var-send-back: \\f87e;\n$fa-var-send-backward: \\f87f;\n$fa-var-sensor: \\e028;\n$fa-var-sensor-cloud: \\e02c;\n$fa-var-sensor-smoke: \\e02c;\n$fa-var-sensor-fire: \\e02a;\n$fa-var-sensor-on: \\e02b;\n$fa-var-sensor-triangle-exclamation: \\e029;\n$fa-var-sensor-alert: \\e029;\n$fa-var-server: \\f233;\n$fa-var-shapes: \\f61f;\n$fa-var-triangle-circle-square: \\f61f;\n$fa-var-share: \\f064;\n$fa-var-arrow-turn-right: \\f064;\n$fa-var-mail-forward: \\f064;\n$fa-var-share-all: \\f367;\n$fa-var-arrows-turn-right: \\f367;\n$fa-var-share-from-square: \\f14d;\n$fa-var-share-square: \\f14d;\n$fa-var-share-nodes: \\f1e0;\n$fa-var-share-alt: \\f1e0;\n$fa-var-sheep: \\f711;\n$fa-var-shekel-sign: \\f20b;\n$fa-var-ils: \\f20b;\n$fa-var-shekel: \\f20b;\n$fa-var-sheqel: \\f20b;\n$fa-var-sheqel-sign: \\f20b;\n$fa-var-shelves: \\f480;\n$fa-var-inventory: \\f480;\n$fa-var-shelves-empty: \\e246;\n$fa-var-shield: \\f132;\n$fa-var-shield-blank: \\f3ed;\n$fa-var-shield-alt: \\f3ed;\n$fa-var-shield-check: \\f2f7;\n$fa-var-shield-cross: \\f712;\n$fa-var-shield-exclamation: \\e247;\n$fa-var-shield-keyhole: \\e248;\n$fa-var-shield-minus: \\e249;\n$fa-var-shield-plus: \\e24a;\n$fa-var-shield-slash: \\e24b;\n$fa-var-shield-virus: \\e06c;\n$fa-var-shield-xmark: \\e24c;\n$fa-var-shield-times: \\e24c;\n$fa-var-ship: \\f21a;\n$fa-var-shirt: \\f553;\n$fa-var-t-shirt: \\f553;\n$fa-var-tshirt: \\f553;\n$fa-var-shirt-long-sleeve: \\e3c7;\n$fa-var-shirt-running: \\e3c8;\n$fa-var-shirt-tank-top: \\e3c9;\n$fa-var-shish-kebab: \\f821;\n$fa-var-shoe-prints: \\f54b;\n$fa-var-shop: \\f54f;\n$fa-var-store-alt: \\f54f;\n$fa-var-shop-slash: \\e070;\n$fa-var-store-alt-slash: \\e070;\n$fa-var-shovel: \\f713;\n$fa-var-shovel-snow: \\f7c3;\n$fa-var-shower: \\f2cc;\n$fa-var-shower-down: \\e24d;\n$fa-var-shower-alt: \\e24d;\n$fa-var-shredder: \\f68a;\n$fa-var-shrimp: \\e448;\n$fa-var-shuffle: \\f074;\n$fa-var-random: \\f074;\n$fa-var-shutters: \\e449;\n$fa-var-shuttle-space: \\f197;\n$fa-var-space-shuttle: \\f197;\n$fa-var-shuttlecock: \\f45b;\n$fa-var-sickle: \\f822;\n$fa-var-sidebar: \\e24e;\n$fa-var-sidebar-flip: \\e24f;\n$fa-var-sigma: \\f68b;\n$fa-var-sign-hanging: \\f4d9;\n$fa-var-sign: \\f4d9;\n$fa-var-signal: \\f012;\n$fa-var-signal-5: \\f012;\n$fa-var-signal-perfect: \\f012;\n$fa-var-signal-bars: \\f690;\n$fa-var-signal-alt: \\f690;\n$fa-var-signal-alt-4: \\f690;\n$fa-var-signal-bars-strong: \\f690;\n$fa-var-signal-bars-fair: \\f692;\n$fa-var-signal-alt-2: \\f692;\n$fa-var-signal-bars-good: \\f693;\n$fa-var-signal-alt-3: \\f693;\n$fa-var-signal-bars-slash: \\f694;\n$fa-var-signal-alt-slash: \\f694;\n$fa-var-signal-bars-weak: \\f691;\n$fa-var-signal-alt-1: \\f691;\n$fa-var-signal-fair: \\f68d;\n$fa-var-signal-2: \\f68d;\n$fa-var-signal-good: \\f68e;\n$fa-var-signal-3: \\f68e;\n$fa-var-signal-slash: \\f695;\n$fa-var-signal-stream: \\f8dd;\n$fa-var-signal-stream-slash: \\e250;\n$fa-var-signal-strong: \\f68f;\n$fa-var-signal-4: \\f68f;\n$fa-var-signal-weak: \\f68c;\n$fa-var-signal-1: \\f68c;\n$fa-var-signature: \\f5b7;\n$fa-var-signature-lock: \\e3ca;\n$fa-var-signature-slash: \\e3cb;\n$fa-var-signs-post: \\f277;\n$fa-var-map-signs: \\f277;\n$fa-var-sim-card: \\f7c4;\n$fa-var-sim-cards: \\e251;\n$fa-var-sink: \\e06d;\n$fa-var-siren: \\e02d;\n$fa-var-siren-on: \\e02e;\n$fa-var-sitemap: \\f0e8;\n$fa-var-skeleton: \\f620;\n$fa-var-ski-boot: \\e3cc;\n$fa-var-ski-boot-ski: \\e3cd;\n$fa-var-skull: \\f54c;\n$fa-var-skull-cow: \\f8de;\n$fa-var-skull-crossbones: \\f714;\n$fa-var-slash: \\f715;\n$fa-var-slash-back: \\5c;\n$fa-var-slash-forward: \\2f;\n$fa-var-sleigh: \\f7cc;\n$fa-var-slider: \\e252;\n$fa-var-sliders: \\f1de;\n$fa-var-sliders-h: \\f1de;\n$fa-var-sliders-simple: \\e253;\n$fa-var-sliders-up: \\f3f1;\n$fa-var-sliders-v: \\f3f1;\n$fa-var-slot-machine: \\e3ce;\n$fa-var-smog: \\f75f;\n$fa-var-smoke: \\f760;\n$fa-var-smoking: \\f48d;\n$fa-var-snake: \\f716;\n$fa-var-snooze: \\f880;\n$fa-var-zzz: \\f880;\n$fa-var-snow-blowing: \\f761;\n$fa-var-snowflake: \\f2dc;\n$fa-var-snowflakes: \\f7cf;\n$fa-var-snowman: \\f7d0;\n$fa-var-snowman-head: \\f79b;\n$fa-var-frosty-head: \\f79b;\n$fa-var-snowplow: \\f7d2;\n$fa-var-soap: \\e06e;\n$fa-var-socks: \\f696;\n$fa-var-solar-panel: \\f5ba;\n$fa-var-solar-system: \\e02f;\n$fa-var-sort: \\f0dc;\n$fa-var-unsorted: \\f0dc;\n$fa-var-sort-down: \\f0dd;\n$fa-var-sort-desc: \\f0dd;\n$fa-var-sort-up: \\f0de;\n$fa-var-sort-asc: \\f0de;\n$fa-var-spa: \\f5bb;\n$fa-var-space-station-moon: \\e033;\n$fa-var-space-station-moon-construction: \\e034;\n$fa-var-space-station-moon-alt: \\e034;\n$fa-var-spade: \\f2f4;\n$fa-var-spaghetti-monster-flying: \\f67b;\n$fa-var-pastafarianism: \\f67b;\n$fa-var-sparkles: \\f890;\n$fa-var-speaker: \\f8df;\n$fa-var-speakers: \\f8e0;\n$fa-var-spell-check: \\f891;\n$fa-var-spider: \\f717;\n$fa-var-spider-black-widow: \\f718;\n$fa-var-spider-web: \\f719;\n$fa-var-spinner: \\f110;\n$fa-var-spinner-third: \\f3f4;\n$fa-var-split: \\e254;\n$fa-var-splotch: \\f5bc;\n$fa-var-spoon: \\f2e5;\n$fa-var-utensil-spoon: \\f2e5;\n$fa-var-sportsball: \\e44b;\n$fa-var-spray-can: \\f5bd;\n$fa-var-spray-can-sparkles: \\f5d0;\n$fa-var-air-freshener: \\f5d0;\n$fa-var-sprinkler: \\e035;\n$fa-var-sprinkler-ceiling: \\e44c;\n$fa-var-square: \\f0c8;\n$fa-var-square-0: \\e255;\n$fa-var-square-1: \\e256;\n$fa-var-square-2: \\e257;\n$fa-var-square-3: \\e258;\n$fa-var-square-4: \\e259;\n$fa-var-square-5: \\e25a;\n$fa-var-square-6: \\e25b;\n$fa-var-square-7: \\e25c;\n$fa-var-square-8: \\e25d;\n$fa-var-square-9: \\e25e;\n$fa-var-square-a: \\e25f;\n$fa-var-square-a-lock: \\e44d;\n$fa-var-square-ampersand: \\e260;\n$fa-var-square-arrow-down: \\f339;\n$fa-var-arrow-square-down: \\f339;\n$fa-var-square-arrow-down-left: \\e261;\n$fa-var-square-arrow-down-right: \\e262;\n$fa-var-square-arrow-left: \\f33a;\n$fa-var-arrow-square-left: \\f33a;\n$fa-var-square-arrow-right: \\f33b;\n$fa-var-arrow-square-right: \\f33b;\n$fa-var-square-arrow-up: \\f33c;\n$fa-var-arrow-square-up: \\f33c;\n$fa-var-square-arrow-up-left: \\e263;\n$fa-var-square-arrow-up-right: \\f14c;\n$fa-var-external-link-square: \\f14c;\n$fa-var-square-b: \\e264;\n$fa-var-square-bolt: \\e265;\n$fa-var-square-c: \\e266;\n$fa-var-square-caret-down: \\f150;\n$fa-var-caret-square-down: \\f150;\n$fa-var-square-caret-left: \\f191;\n$fa-var-caret-square-left: \\f191;\n$fa-var-square-caret-right: \\f152;\n$fa-var-caret-square-right: \\f152;\n$fa-var-square-caret-up: \\f151;\n$fa-var-caret-square-up: \\f151;\n$fa-var-square-check: \\f14a;\n$fa-var-check-square: \\f14a;\n$fa-var-square-chevron-down: \\f329;\n$fa-var-chevron-square-down: \\f329;\n$fa-var-square-chevron-left: \\f32a;\n$fa-var-chevron-square-left: \\f32a;\n$fa-var-square-chevron-right: \\f32b;\n$fa-var-chevron-square-right: \\f32b;\n$fa-var-square-chevron-up: \\f32c;\n$fa-var-chevron-square-up: \\f32c;\n$fa-var-square-code: \\e267;\n$fa-var-square-d: \\e268;\n$fa-var-square-dashed: \\e269;\n$fa-var-square-divide: \\e26a;\n$fa-var-square-dollar: \\f2e9;\n$fa-var-dollar-square: \\f2e9;\n$fa-var-usd-square: \\f2e9;\n$fa-var-square-down: \\f350;\n$fa-var-arrow-alt-square-down: \\f350;\n$fa-var-square-down-left: \\e26b;\n$fa-var-square-down-right: \\e26c;\n$fa-var-square-e: \\e26d;\n$fa-var-square-ellipsis: \\e26e;\n$fa-var-square-ellipsis-vertical: \\e26f;\n$fa-var-square-envelope: \\f199;\n$fa-var-envelope-square: \\f199;\n$fa-var-square-exclamation: \\f321;\n$fa-var-exclamation-square: \\f321;\n$fa-var-square-f: \\e270;\n$fa-var-square-fragile: \\f49b;\n$fa-var-box-fragile: \\f49b;\n$fa-var-square-wine-glass-crack: \\f49b;\n$fa-var-square-full: \\f45c;\n$fa-var-square-g: \\e271;\n$fa-var-square-h: \\f0fd;\n$fa-var-h-square: \\f0fd;\n$fa-var-square-heart: \\f4c8;\n$fa-var-heart-square: \\f4c8;\n$fa-var-square-i: \\e272;\n$fa-var-square-info: \\f30f;\n$fa-var-info-square: \\f30f;\n$fa-var-square-j: \\e273;\n$fa-var-square-k: \\e274;\n$fa-var-square-l: \\e275;\n$fa-var-square-left: \\f351;\n$fa-var-arrow-alt-square-left: \\f351;\n$fa-var-square-m: \\e276;\n$fa-var-square-minus: \\f146;\n$fa-var-minus-square: \\f146;\n$fa-var-square-n: \\e277;\n$fa-var-square-o: \\e278;\n$fa-var-square-p: \\e279;\n$fa-var-square-parking: \\f540;\n$fa-var-parking: \\f540;\n$fa-var-square-parking-slash: \\f617;\n$fa-var-parking-slash: \\f617;\n$fa-var-square-pen: \\f14b;\n$fa-var-pen-square: \\f14b;\n$fa-var-pencil-square: \\f14b;\n$fa-var-square-phone: \\f098;\n$fa-var-phone-square: \\f098;\n$fa-var-square-phone-flip: \\f87b;\n$fa-var-phone-square-alt: \\f87b;\n$fa-var-square-phone-hangup: \\e27a;\n$fa-var-phone-square-down: \\e27a;\n$fa-var-square-plus: \\f0fe;\n$fa-var-plus-square: \\f0fe;\n$fa-var-square-poll-horizontal: \\f682;\n$fa-var-poll-h: \\f682;\n$fa-var-square-poll-vertical: \\f681;\n$fa-var-poll: \\f681;\n$fa-var-square-q: \\e27b;\n$fa-var-square-quarters: \\e44e;\n$fa-var-square-question: \\f2fd;\n$fa-var-question-square: \\f2fd;\n$fa-var-square-quote: \\e329;\n$fa-var-square-r: \\e27c;\n$fa-var-square-right: \\f352;\n$fa-var-arrow-alt-square-right: \\f352;\n$fa-var-square-ring: \\e44f;\n$fa-var-square-root: \\f697;\n$fa-var-square-root-variable: \\f698;\n$fa-var-square-root-alt: \\f698;\n$fa-var-square-rss: \\f143;\n$fa-var-rss-square: \\f143;\n$fa-var-square-s: \\e27d;\n$fa-var-square-share-nodes: \\f1e1;\n$fa-var-share-alt-square: \\f1e1;\n$fa-var-square-sliders: \\f3f0;\n$fa-var-sliders-h-square: \\f3f0;\n$fa-var-square-sliders-vertical: \\f3f2;\n$fa-var-sliders-v-square: \\f3f2;\n$fa-var-square-small: \\e27e;\n$fa-var-square-star: \\e27f;\n$fa-var-square-t: \\e280;\n$fa-var-square-terminal: \\e32a;\n$fa-var-square-this-way-up: \\f49f;\n$fa-var-box-up: \\f49f;\n$fa-var-square-u: \\e281;\n$fa-var-square-up: \\f353;\n$fa-var-arrow-alt-square-up: \\f353;\n$fa-var-square-up-left: \\e282;\n$fa-var-square-up-right: \\f360;\n$fa-var-external-link-square-alt: \\f360;\n$fa-var-square-user: \\e283;\n$fa-var-square-v: \\e284;\n$fa-var-square-w: \\e285;\n$fa-var-square-x: \\e286;\n$fa-var-square-xmark: \\f2d3;\n$fa-var-times-square: \\f2d3;\n$fa-var-xmark-square: \\f2d3;\n$fa-var-square-y: \\e287;\n$fa-var-square-z: \\e288;\n$fa-var-squid: \\e450;\n$fa-var-squirrel: \\f71a;\n$fa-var-staff: \\f71b;\n$fa-var-stairs: \\e289;\n$fa-var-stamp: \\f5bf;\n$fa-var-standard-definition: \\e28a;\n$fa-var-rectangle-sd: \\e28a;\n$fa-var-star: \\f005;\n$fa-var-star-and-crescent: \\f699;\n$fa-var-star-christmas: \\f7d4;\n$fa-var-star-exclamation: \\f2f3;\n$fa-var-star-half: \\f089;\n$fa-var-star-half-stroke: \\f5c0;\n$fa-var-star-half-alt: \\f5c0;\n$fa-var-star-of-david: \\f69a;\n$fa-var-star-of-life: \\f621;\n$fa-var-star-sharp: \\e28b;\n$fa-var-star-sharp-half: \\e28c;\n$fa-var-star-sharp-half-stroke: \\e28d;\n$fa-var-star-sharp-half-alt: \\e28d;\n$fa-var-star-shooting: \\e036;\n$fa-var-starfighter: \\e037;\n$fa-var-starfighter-twin-ion-engine: \\e038;\n$fa-var-starfighter-alt: \\e038;\n$fa-var-starfighter-twin-ion-engine-advanced: \\e28e;\n$fa-var-starfighter-alt-advanced: \\e28e;\n$fa-var-stars: \\f762;\n$fa-var-starship: \\e039;\n$fa-var-starship-freighter: \\e03a;\n$fa-var-steak: \\f824;\n$fa-var-steering-wheel: \\f622;\n$fa-var-sterling-sign: \\f154;\n$fa-var-gbp: \\f154;\n$fa-var-pound-sign: \\f154;\n$fa-var-stethoscope: \\f0f1;\n$fa-var-stocking: \\f7d5;\n$fa-var-stomach: \\f623;\n$fa-var-stop: \\f04d;\n$fa-var-stopwatch: \\f2f2;\n$fa-var-stopwatch-20: \\e06f;\n$fa-var-store: \\f54e;\n$fa-var-store-slash: \\e071;\n$fa-var-strawberry: \\e32b;\n$fa-var-street-view: \\f21d;\n$fa-var-stretcher: \\f825;\n$fa-var-strikethrough: \\f0cc;\n$fa-var-stroopwafel: \\f551;\n$fa-var-subscript: \\f12c;\n$fa-var-suitcase: \\f0f2;\n$fa-var-suitcase-medical: \\f0fa;\n$fa-var-medkit: \\f0fa;\n$fa-var-suitcase-rolling: \\f5c1;\n$fa-var-sun: \\f185;\n$fa-var-sun-bright: \\e28f;\n$fa-var-sun-alt: \\e28f;\n$fa-var-sun-cloud: \\f763;\n$fa-var-sun-dust: \\f764;\n$fa-var-sun-haze: \\f765;\n$fa-var-sunglasses: \\f892;\n$fa-var-sunrise: \\f766;\n$fa-var-sunset: \\f767;\n$fa-var-superscript: \\f12b;\n$fa-var-swatchbook: \\f5c3;\n$fa-var-sword: \\f71c;\n$fa-var-sword-laser: \\e03b;\n$fa-var-sword-laser-alt: \\e03c;\n$fa-var-swords: \\f71d;\n$fa-var-swords-laser: \\e03d;\n$fa-var-symbols: \\f86e;\n$fa-var-icons-alt: \\f86e;\n$fa-var-synagogue: \\f69b;\n$fa-var-syringe: \\f48e;\n$fa-var-t: \\54;\n$fa-var-table: \\f0ce;\n$fa-var-table-cells: \\f00a;\n$fa-var-th: \\f00a;\n$fa-var-table-cells-large: \\f009;\n$fa-var-th-large: \\f009;\n$fa-var-table-columns: \\f0db;\n$fa-var-columns: \\f0db;\n$fa-var-table-layout: \\e290;\n$fa-var-table-list: \\f00b;\n$fa-var-th-list: \\f00b;\n$fa-var-table-picnic: \\e32d;\n$fa-var-table-pivot: \\e291;\n$fa-var-table-rows: \\e292;\n$fa-var-rows: \\e292;\n$fa-var-table-tennis-paddle-ball: \\f45d;\n$fa-var-ping-pong-paddle-ball: \\f45d;\n$fa-var-table-tennis: \\f45d;\n$fa-var-table-tree: \\e293;\n$fa-var-tablet: \\f3fb;\n$fa-var-tablet-android: \\f3fb;\n$fa-var-tablet-button: \\f10a;\n$fa-var-tablet-rugged: \\f48f;\n$fa-var-tablet-screen: \\f3fc;\n$fa-var-tablet-android-alt: \\f3fc;\n$fa-var-tablet-screen-button: \\f3fa;\n$fa-var-tablet-alt: \\f3fa;\n$fa-var-tablets: \\f490;\n$fa-var-tachograph-digital: \\f566;\n$fa-var-digital-tachograph: \\f566;\n$fa-var-taco: \\f826;\n$fa-var-tag: \\f02b;\n$fa-var-tags: \\f02c;\n$fa-var-tally: \\f69c;\n$fa-var-tally-5: \\f69c;\n$fa-var-tally-1: \\e294;\n$fa-var-tally-2: \\e295;\n$fa-var-tally-3: \\e296;\n$fa-var-tally-4: \\e297;\n$fa-var-tamale: \\e451;\n$fa-var-tank-water: \\e452;\n$fa-var-tape: \\f4db;\n$fa-var-taxi: \\f1ba;\n$fa-var-cab: \\f1ba;\n$fa-var-taxi-bus: \\e298;\n$fa-var-teddy-bear: \\e3cf;\n$fa-var-teeth: \\f62e;\n$fa-var-teeth-open: \\f62f;\n$fa-var-telescope: \\e03e;\n$fa-var-temperature-arrow-down: \\e03f;\n$fa-var-temperature-down: \\e03f;\n$fa-var-temperature-arrow-up: \\e040;\n$fa-var-temperature-up: \\e040;\n$fa-var-temperature-empty: \\f2cb;\n$fa-var-temperature-0: \\f2cb;\n$fa-var-thermometer-0: \\f2cb;\n$fa-var-thermometer-empty: \\f2cb;\n$fa-var-temperature-full: \\f2c7;\n$fa-var-temperature-4: \\f2c7;\n$fa-var-thermometer-4: \\f2c7;\n$fa-var-thermometer-full: \\f2c7;\n$fa-var-temperature-half: \\f2c9;\n$fa-var-temperature-2: \\f2c9;\n$fa-var-thermometer-2: \\f2c9;\n$fa-var-thermometer-half: \\f2c9;\n$fa-var-temperature-high: \\f769;\n$fa-var-temperature-list: \\e299;\n$fa-var-temperature-low: \\f76b;\n$fa-var-temperature-quarter: \\f2ca;\n$fa-var-temperature-1: \\f2ca;\n$fa-var-thermometer-1: \\f2ca;\n$fa-var-thermometer-quarter: \\f2ca;\n$fa-var-temperature-snow: \\f768;\n$fa-var-temperature-frigid: \\f768;\n$fa-var-temperature-sun: \\f76a;\n$fa-var-temperature-hot: \\f76a;\n$fa-var-temperature-three-quarters: \\f2c8;\n$fa-var-temperature-3: \\f2c8;\n$fa-var-thermometer-3: \\f2c8;\n$fa-var-thermometer-three-quarters: \\f2c8;\n$fa-var-tenge-sign: \\f7d7;\n$fa-var-tenge: \\f7d7;\n$fa-var-tennis-ball: \\f45e;\n$fa-var-terminal: \\f120;\n$fa-var-text: \\f893;\n$fa-var-text-height: \\f034;\n$fa-var-text-size: \\f894;\n$fa-var-text-slash: \\f87d;\n$fa-var-remove-format: \\f87d;\n$fa-var-text-width: \\f035;\n$fa-var-thermometer: \\f491;\n$fa-var-theta: \\f69e;\n$fa-var-thought-bubble: \\e32e;\n$fa-var-thumbs-down: \\f165;\n$fa-var-thumbs-up: \\f164;\n$fa-var-thumbtack: \\f08d;\n$fa-var-thumb-tack: \\f08d;\n$fa-var-tick: \\e32f;\n$fa-var-ticket: \\f145;\n$fa-var-ticket-airline: \\e29a;\n$fa-var-ticket-simple: \\f3ff;\n$fa-var-ticket-alt: \\f3ff;\n$fa-var-tickets-airline: \\e29b;\n$fa-var-tilde: \\7e;\n$fa-var-timeline: \\e29c;\n$fa-var-timeline-arrow: \\e29d;\n$fa-var-timer: \\e29e;\n$fa-var-tire: \\f631;\n$fa-var-tire-flat: \\f632;\n$fa-var-tire-pressure-warning: \\f633;\n$fa-var-tire-rugged: \\f634;\n$fa-var-toggle-off: \\f204;\n$fa-var-toggle-on: \\f205;\n$fa-var-toilet: \\f7d8;\n$fa-var-toilet-paper: \\f71e;\n$fa-var-toilet-paper-blank: \\f71f;\n$fa-var-toilet-paper-alt: \\f71f;\n$fa-var-toilet-paper-blank-under: \\e29f;\n$fa-var-toilet-paper-reverse-alt: \\e29f;\n$fa-var-toilet-paper-slash: \\e072;\n$fa-var-toilet-paper-under: \\e2a0;\n$fa-var-toilet-paper-reverse: \\e2a0;\n$fa-var-toilet-paper-under-slash: \\e2a1;\n$fa-var-toilet-paper-reverse-slash: \\e2a1;\n$fa-var-tomato: \\e330;\n$fa-var-tombstone: \\f720;\n$fa-var-tombstone-blank: \\f721;\n$fa-var-tombstone-alt: \\f721;\n$fa-var-toolbox: \\f552;\n$fa-var-tooth: \\f5c9;\n$fa-var-toothbrush: \\f635;\n$fa-var-torii-gate: \\f6a1;\n$fa-var-tornado: \\f76f;\n$fa-var-tower-broadcast: \\f519;\n$fa-var-broadcast-tower: \\f519;\n$fa-var-tower-control: \\e2a2;\n$fa-var-tractor: \\f722;\n$fa-var-trademark: \\f25c;\n$fa-var-traffic-cone: \\f636;\n$fa-var-traffic-light: \\f637;\n$fa-var-traffic-light-go: \\f638;\n$fa-var-traffic-light-slow: \\f639;\n$fa-var-traffic-light-stop: \\f63a;\n$fa-var-trailer: \\e041;\n$fa-var-train: \\f238;\n$fa-var-train-subway: \\f239;\n$fa-var-subway: \\f239;\n$fa-var-train-subway-tunnel: \\e2a3;\n$fa-var-subway-tunnel: \\e2a3;\n$fa-var-train-track: \\e453;\n$fa-var-train-tram: \\f7da;\n$fa-var-tram: \\f7da;\n$fa-var-train-tunnel: \\e454;\n$fa-var-transformer-bolt: \\e2a4;\n$fa-var-transgender: \\f225;\n$fa-var-transgender-alt: \\f225;\n$fa-var-transporter: \\e042;\n$fa-var-transporter-1: \\e043;\n$fa-var-transporter-2: \\e044;\n$fa-var-transporter-3: \\e045;\n$fa-var-transporter-4: \\e2a5;\n$fa-var-transporter-5: \\e2a6;\n$fa-var-transporter-6: \\e2a7;\n$fa-var-transporter-7: \\e2a8;\n$fa-var-transporter-empty: \\e046;\n$fa-var-trash: \\f1f8;\n$fa-var-trash-arrow-up: \\f829;\n$fa-var-trash-restore: \\f829;\n$fa-var-trash-can: \\f2ed;\n$fa-var-trash-alt: \\f2ed;\n$fa-var-trash-can-arrow-up: \\f82a;\n$fa-var-trash-restore-alt: \\f82a;\n$fa-var-trash-can-check: \\e2a9;\n$fa-var-trash-can-clock: \\e2aa;\n$fa-var-trash-can-list: \\e2ab;\n$fa-var-trash-can-plus: \\e2ac;\n$fa-var-trash-can-slash: \\e2ad;\n$fa-var-trash-alt-slash: \\e2ad;\n$fa-var-trash-can-undo: \\f896;\n$fa-var-trash-can-arrow-turn-left: \\f896;\n$fa-var-trash-undo-alt: \\f896;\n$fa-var-trash-can-xmark: \\e2ae;\n$fa-var-trash-check: \\e2af;\n$fa-var-trash-clock: \\e2b0;\n$fa-var-trash-list: \\e2b1;\n$fa-var-trash-plus: \\e2b2;\n$fa-var-trash-slash: \\e2b3;\n$fa-var-trash-undo: \\f895;\n$fa-var-trash-arrow-turn-left: \\f895;\n$fa-var-trash-xmark: \\e2b4;\n$fa-var-treasure-chest: \\f723;\n$fa-var-tree: \\f1bb;\n$fa-var-tree-christmas: \\f7db;\n$fa-var-tree-deciduous: \\f400;\n$fa-var-tree-alt: \\f400;\n$fa-var-tree-decorated: \\f7dc;\n$fa-var-tree-large: \\f7dd;\n$fa-var-tree-palm: \\f82b;\n$fa-var-trees: \\f724;\n$fa-var-triangle: \\f2ec;\n$fa-var-triangle-exclamation: \\f071;\n$fa-var-exclamation-triangle: \\f071;\n$fa-var-warning: \\f071;\n$fa-var-triangle-instrument: \\f8e2;\n$fa-var-triangle-music: \\f8e2;\n$fa-var-triangle-person-digging: \\f85d;\n$fa-var-construction: \\f85d;\n$fa-var-trophy: \\f091;\n$fa-var-trophy-star: \\f2eb;\n$fa-var-trophy-alt: \\f2eb;\n$fa-var-truck: \\f0d1;\n$fa-var-truck-bolt: \\e3d0;\n$fa-var-truck-clock: \\f48c;\n$fa-var-shipping-timed: \\f48c;\n$fa-var-truck-container: \\f4dc;\n$fa-var-truck-container-empty: \\e2b5;\n$fa-var-truck-fast: \\f48b;\n$fa-var-shipping-fast: \\f48b;\n$fa-var-truck-flatbed: \\e2b6;\n$fa-var-truck-front: \\e2b7;\n$fa-var-truck-medical: \\f0f9;\n$fa-var-ambulance: \\f0f9;\n$fa-var-truck-monster: \\f63b;\n$fa-var-truck-moving: \\f4df;\n$fa-var-truck-pickup: \\f63c;\n$fa-var-truck-plow: \\f7de;\n$fa-var-truck-ramp: \\f4e0;\n$fa-var-truck-ramp-box: \\f4de;\n$fa-var-truck-loading: \\f4de;\n$fa-var-truck-ramp-couch: \\f4dd;\n$fa-var-truck-couch: \\f4dd;\n$fa-var-truck-tow: \\e2b8;\n$fa-var-trumpet: \\f8e3;\n$fa-var-tty: \\f1e4;\n$fa-var-teletype: \\f1e4;\n$fa-var-tty-answer: \\e2b9;\n$fa-var-teletype-answer: \\e2b9;\n$fa-var-tugrik-sign: \\e2ba;\n$fa-var-turkey: \\f725;\n$fa-var-turkish-lira-sign: \\e2bb;\n$fa-var-try: \\e2bb;\n$fa-var-turkish-lira: \\e2bb;\n$fa-var-turn-down: \\f3be;\n$fa-var-level-down-alt: \\f3be;\n$fa-var-turn-down-left: \\e331;\n$fa-var-turn-down-right: \\e455;\n$fa-var-turn-up: \\f3bf;\n$fa-var-level-up-alt: \\f3bf;\n$fa-var-turntable: \\f8e4;\n$fa-var-turtle: \\f726;\n$fa-var-tv: \\f26c;\n$fa-var-television: \\f26c;\n$fa-var-tv-alt: \\f26c;\n$fa-var-tv-music: \\f8e6;\n$fa-var-tv-retro: \\f401;\n$fa-var-typewriter: \\f8e7;\n$fa-var-u: \\55;\n$fa-var-ufo: \\e047;\n$fa-var-ufo-beam: \\e048;\n$fa-var-umbrella: \\f0e9;\n$fa-var-umbrella-beach: \\f5ca;\n$fa-var-umbrella-simple: \\e2bc;\n$fa-var-umbrella-alt: \\e2bc;\n$fa-var-underline: \\f0cd;\n$fa-var-unicorn: \\f727;\n$fa-var-uniform-martial-arts: \\e3d1;\n$fa-var-union: \\f6a2;\n$fa-var-universal-access: \\f29a;\n$fa-var-unlock: \\f09c;\n$fa-var-unlock-keyhole: \\f13e;\n$fa-var-unlock-alt: \\f13e;\n$fa-var-up: \\f357;\n$fa-var-arrow-alt-up: \\f357;\n$fa-var-up-down: \\f338;\n$fa-var-arrows-alt-v: \\f338;\n$fa-var-up-down-left-right: \\f0b2;\n$fa-var-arrows-alt: \\f0b2;\n$fa-var-up-from-dotted-line: \\e456;\n$fa-var-up-from-line: \\f346;\n$fa-var-arrow-alt-from-bottom: \\f346;\n$fa-var-up-left: \\e2bd;\n$fa-var-up-long: \\f30c;\n$fa-var-long-arrow-alt-up: \\f30c;\n$fa-var-up-right: \\e2be;\n$fa-var-up-right-and-down-left-from-center: \\f424;\n$fa-var-expand-alt: \\f424;\n$fa-var-up-right-from-square: \\f35d;\n$fa-var-external-link-alt: \\f35d;\n$fa-var-up-to-dotted-line: \\e457;\n$fa-var-up-to-line: \\f34d;\n$fa-var-arrow-alt-to-top: \\f34d;\n$fa-var-upload: \\f093;\n$fa-var-usb-drive: \\f8e9;\n$fa-var-user: \\f007;\n$fa-var-user-alien: \\e04a;\n$fa-var-user-astronaut: \\f4fb;\n$fa-var-user-bounty-hunter: \\e2bf;\n$fa-var-user-check: \\f4fc;\n$fa-var-user-chef: \\e3d2;\n$fa-var-user-clock: \\f4fd;\n$fa-var-user-cowboy: \\f8ea;\n$fa-var-user-crown: \\f6a4;\n$fa-var-user-doctor: \\f0f0;\n$fa-var-user-md: \\f0f0;\n$fa-var-user-doctor-hair: \\e458;\n$fa-var-user-doctor-hair-long: \\e459;\n$fa-var-user-doctor-message: \\f82e;\n$fa-var-user-md-chat: \\f82e;\n$fa-var-user-gear: \\f4fe;\n$fa-var-user-cog: \\f4fe;\n$fa-var-user-graduate: \\f501;\n$fa-var-user-group: \\f500;\n$fa-var-user-friends: \\f500;\n$fa-var-user-group-crown: \\f6a5;\n$fa-var-users-crown: \\f6a5;\n$fa-var-user-hair: \\e45a;\n$fa-var-user-hair-buns: \\e3d3;\n$fa-var-user-hair-long: \\e45b;\n$fa-var-user-hair-mullet: \\e45c;\n$fa-var-business-front: \\e45c;\n$fa-var-party-back: \\e45c;\n$fa-var-trian-balbot: \\e45c;\n$fa-var-user-headset: \\f82d;\n$fa-var-user-helmet-safety: \\f82c;\n$fa-var-user-construction: \\f82c;\n$fa-var-user-hard-hat: \\f82c;\n$fa-var-user-injured: \\f728;\n$fa-var-user-large: \\f406;\n$fa-var-user-alt: \\f406;\n$fa-var-user-large-slash: \\f4fa;\n$fa-var-user-alt-slash: \\f4fa;\n$fa-var-user-lock: \\f502;\n$fa-var-user-minus: \\f503;\n$fa-var-user-music: \\f8eb;\n$fa-var-user-ninja: \\f504;\n$fa-var-user-nurse: \\f82f;\n$fa-var-user-nurse-hair: \\e45d;\n$fa-var-user-nurse-hair-long: \\e45e;\n$fa-var-user-pen: \\f4ff;\n$fa-var-user-edit: \\f4ff;\n$fa-var-user-pilot: \\e2c0;\n$fa-var-user-pilot-tie: \\e2c1;\n$fa-var-user-plus: \\f234;\n$fa-var-user-police: \\e333;\n$fa-var-user-police-tie: \\e334;\n$fa-var-user-robot: \\e04b;\n$fa-var-user-secret: \\f21b;\n$fa-var-user-shakespeare: \\e2c2;\n$fa-var-user-shield: \\f505;\n$fa-var-user-slash: \\f506;\n$fa-var-user-tag: \\f507;\n$fa-var-user-tie: \\f508;\n$fa-var-user-tie-hair: \\e45f;\n$fa-var-user-tie-hair-long: \\e460;\n$fa-var-user-unlock: \\e058;\n$fa-var-user-visor: \\e04c;\n$fa-var-user-vneck: \\e461;\n$fa-var-user-vneck-hair: \\e462;\n$fa-var-user-vneck-hair-long: \\e463;\n$fa-var-user-xmark: \\f235;\n$fa-var-user-times: \\f235;\n$fa-var-users: \\f0c0;\n$fa-var-group: \\f0c0;\n$fa-var-users-gear: \\f509;\n$fa-var-users-cog: \\f509;\n$fa-var-users-medical: \\f830;\n$fa-var-users-slash: \\e073;\n$fa-var-utensils: \\f2e7;\n$fa-var-cutlery: \\f2e7;\n$fa-var-utensils-slash: \\e464;\n$fa-var-utility-pole: \\e2c3;\n$fa-var-utility-pole-double: \\e2c4;\n$fa-var-v: \\56;\n$fa-var-vacuum: \\e04d;\n$fa-var-vacuum-robot: \\e04e;\n$fa-var-value-absolute: \\f6a6;\n$fa-var-van-shuttle: \\f5b6;\n$fa-var-shuttle-van: \\f5b6;\n$fa-var-vault: \\e2c5;\n$fa-var-vector-circle: \\e2c6;\n$fa-var-vector-polygon: \\e2c7;\n$fa-var-vector-square: \\f5cb;\n$fa-var-vent-damper: \\e465;\n$fa-var-venus: \\f221;\n$fa-var-venus-double: \\f226;\n$fa-var-venus-mars: \\f228;\n$fa-var-vest: \\e085;\n$fa-var-vest-patches: \\e086;\n$fa-var-vial: \\f492;\n$fa-var-vials: \\f493;\n$fa-var-video: \\f03d;\n$fa-var-video-camera: \\f03d;\n$fa-var-video-arrow-down-left: \\e2c8;\n$fa-var-video-arrow-up-right: \\e2c9;\n$fa-var-video-plus: \\f4e1;\n$fa-var-video-slash: \\f4e2;\n$fa-var-vihara: \\f6a7;\n$fa-var-violin: \\f8ed;\n$fa-var-virus: \\e074;\n$fa-var-virus-slash: \\e075;\n$fa-var-viruses: \\e076;\n$fa-var-voicemail: \\f897;\n$fa-var-volcano: \\f770;\n$fa-var-volleyball: \\f45f;\n$fa-var-volleyball-ball: \\f45f;\n$fa-var-volume: \\f6a8;\n$fa-var-volume-medium: \\f6a8;\n$fa-var-volume-high: \\f028;\n$fa-var-volume-up: \\f028;\n$fa-var-volume-low: \\f027;\n$fa-var-volume-down: \\f027;\n$fa-var-volume-off: \\f026;\n$fa-var-volume-slash: \\f2e2;\n$fa-var-volume-xmark: \\f6a9;\n$fa-var-volume-mute: \\f6a9;\n$fa-var-volume-times: \\f6a9;\n$fa-var-vr-cardboard: \\f729;\n$fa-var-w: \\57;\n$fa-var-waffle: \\e466;\n$fa-var-wagon-covered: \\f8ee;\n$fa-var-walker: \\f831;\n$fa-var-walkie-talkie: \\f8ef;\n$fa-var-wallet: \\f555;\n$fa-var-wand: \\f72a;\n$fa-var-wand-magic: \\f0d0;\n$fa-var-magic: \\f0d0;\n$fa-var-wand-magic-sparkles: \\e2ca;\n$fa-var-magic-wand-sparkles: \\e2ca;\n$fa-var-wand-sparkles: \\f72b;\n$fa-var-warehouse: \\f494;\n$fa-var-warehouse-full: \\f495;\n$fa-var-warehouse-alt: \\f495;\n$fa-var-washing-machine: \\f898;\n$fa-var-washer: \\f898;\n$fa-var-watch: \\f2e1;\n$fa-var-watch-apple: \\e2cb;\n$fa-var-watch-calculator: \\f8f0;\n$fa-var-watch-fitness: \\f63e;\n$fa-var-watch-smart: \\e2cc;\n$fa-var-water: \\f773;\n$fa-var-water-arrow-down: \\f774;\n$fa-var-water-lower: \\f774;\n$fa-var-water-arrow-up: \\f775;\n$fa-var-water-rise: \\f775;\n$fa-var-water-ladder: \\f5c5;\n$fa-var-ladder-water: \\f5c5;\n$fa-var-swimming-pool: \\f5c5;\n$fa-var-watermelon-slice: \\e337;\n$fa-var-wave-pulse: \\f5f8;\n$fa-var-heart-rate: \\f5f8;\n$fa-var-wave-sine: \\f899;\n$fa-var-wave-square: \\f83e;\n$fa-var-wave-triangle: \\f89a;\n$fa-var-waveform: \\f8f1;\n$fa-var-waveform-lines: \\f8f2;\n$fa-var-weight-hanging: \\f5cd;\n$fa-var-weight-scale: \\f496;\n$fa-var-weight: \\f496;\n$fa-var-whale: \\f72c;\n$fa-var-wheat: \\f72d;\n$fa-var-wheat-awn: \\e2cd;\n$fa-var-wheat-alt: \\e2cd;\n$fa-var-wheat-awn-slash: \\e338;\n$fa-var-wheat-slash: \\e339;\n$fa-var-wheelchair: \\f193;\n$fa-var-wheelchair-move: \\e2ce;\n$fa-var-wheelchair-alt: \\e2ce;\n$fa-var-whiskey-glass: \\f7a0;\n$fa-var-glass-whiskey: \\f7a0;\n$fa-var-whiskey-glass-ice: \\f7a1;\n$fa-var-glass-whiskey-rocks: \\f7a1;\n$fa-var-whistle: \\f460;\n$fa-var-wifi: \\f1eb;\n$fa-var-wifi-3: \\f1eb;\n$fa-var-wifi-strong: \\f1eb;\n$fa-var-wifi-exclamation: \\e2cf;\n$fa-var-wifi-fair: \\f6ab;\n$fa-var-wifi-2: \\f6ab;\n$fa-var-wifi-slash: \\f6ac;\n$fa-var-wifi-weak: \\f6aa;\n$fa-var-wifi-1: \\f6aa;\n$fa-var-wind: \\f72e;\n$fa-var-wind-turbine: \\f89b;\n$fa-var-wind-warning: \\f776;\n$fa-var-wind-circle-exclamation: \\f776;\n$fa-var-window: \\f40e;\n$fa-var-window-flip: \\f40f;\n$fa-var-window-alt: \\f40f;\n$fa-var-window-frame: \\e04f;\n$fa-var-window-frame-open: \\e050;\n$fa-var-window-maximize: \\f2d0;\n$fa-var-window-minimize: \\f2d1;\n$fa-var-window-restore: \\f2d2;\n$fa-var-windsock: \\f777;\n$fa-var-wine-bottle: \\f72f;\n$fa-var-wine-glass: \\f4e3;\n$fa-var-wine-glass-crack: \\f4bb;\n$fa-var-fragile: \\f4bb;\n$fa-var-wine-glass-empty: \\f5ce;\n$fa-var-wine-glass-alt: \\f5ce;\n$fa-var-won-sign: \\f159;\n$fa-var-krw: \\f159;\n$fa-var-won: \\f159;\n$fa-var-wreath: \\f7e2;\n$fa-var-wrench: \\f0ad;\n$fa-var-wrench-simple: \\e2d1;\n$fa-var-x: \\58;\n$fa-var-x-ray: \\f497;\n$fa-var-xmark: \\f00d;\n$fa-var-close: \\f00d;\n$fa-var-multiply: \\f00d;\n$fa-var-remove: \\f00d;\n$fa-var-times: \\f00d;\n$fa-var-xmark-to-slot: \\f771;\n$fa-var-times-to-slot: \\f771;\n$fa-var-vote-nay: \\f771;\n$fa-var-y: \\59;\n$fa-var-yen-sign: \\f157;\n$fa-var-cny: \\f157;\n$fa-var-jpy: \\f157;\n$fa-var-rmb: \\f157;\n$fa-var-yen: \\f157;\n$fa-var-yin-yang: \\f6ad;\n$fa-var-z: \\5a;\n\n$fa-var-42-group: \\e080;\n$fa-var-innosoft: \\e080;\n$fa-var-500px: \\f26e;\n$fa-var-accessible-icon: \\f368;\n$fa-var-accusoft: \\f369;\n$fa-var-acquisitions-incorporated: \\f6af;\n$fa-var-adn: \\f170;\n$fa-var-adversal: \\f36a;\n$fa-var-affiliatetheme: \\f36b;\n$fa-var-airbnb: \\f834;\n$fa-var-algolia: \\f36c;\n$fa-var-alipay: \\f642;\n$fa-var-amazon: \\f270;\n$fa-var-amazon-pay: \\f42c;\n$fa-var-amilia: \\f36d;\n$fa-var-android: \\f17b;\n$fa-var-angellist: \\f209;\n$fa-var-angrycreative: \\f36e;\n$fa-var-angular: \\f420;\n$fa-var-app-store: \\f36f;\n$fa-var-app-store-ios: \\f370;\n$fa-var-apper: \\f371;\n$fa-var-apple: \\f179;\n$fa-var-apple-pay: \\f415;\n$fa-var-artstation: \\f77a;\n$fa-var-asymmetrik: \\f372;\n$fa-var-atlassian: \\f77b;\n$fa-var-audible: \\f373;\n$fa-var-autoprefixer: \\f41c;\n$fa-var-avianex: \\f374;\n$fa-var-aviato: \\f421;\n$fa-var-aws: \\f375;\n$fa-var-bandcamp: \\f2d5;\n$fa-var-battle-net: \\f835;\n$fa-var-behance: \\f1b4;\n$fa-var-behance-square: \\f1b5;\n$fa-var-bilibili: \\e3d9;\n$fa-var-bimobject: \\f378;\n$fa-var-bitbucket: \\f171;\n$fa-var-bitcoin: \\f379;\n$fa-var-bity: \\f37a;\n$fa-var-black-tie: \\f27e;\n$fa-var-blackberry: \\f37b;\n$fa-var-blogger: \\f37c;\n$fa-var-blogger-b: \\f37d;\n$fa-var-bluetooth: \\f293;\n$fa-var-bluetooth-b: \\f294;\n$fa-var-bootstrap: \\f836;\n$fa-var-bots: \\e340;\n$fa-var-btc: \\f15a;\n$fa-var-buffer: \\f837;\n$fa-var-buromobelexperte: \\f37f;\n$fa-var-buy-n-large: \\f8a6;\n$fa-var-buysellads: \\f20d;\n$fa-var-canadian-maple-leaf: \\f785;\n$fa-var-cc-amazon-pay: \\f42d;\n$fa-var-cc-amex: \\f1f3;\n$fa-var-cc-apple-pay: \\f416;\n$fa-var-cc-diners-club: \\f24c;\n$fa-var-cc-discover: \\f1f2;\n$fa-var-cc-jcb: \\f24b;\n$fa-var-cc-mastercard: \\f1f1;\n$fa-var-cc-paypal: \\f1f4;\n$fa-var-cc-stripe: \\f1f5;\n$fa-var-cc-visa: \\f1f0;\n$fa-var-centercode: \\f380;\n$fa-var-centos: \\f789;\n$fa-var-chrome: \\f268;\n$fa-var-chromecast: \\f838;\n$fa-var-cloudflare: \\e07d;\n$fa-var-cloudscale: \\f383;\n$fa-var-cloudsmith: \\f384;\n$fa-var-cloudversify: \\f385;\n$fa-var-cmplid: \\e360;\n$fa-var-codepen: \\f1cb;\n$fa-var-codiepie: \\f284;\n$fa-var-confluence: \\f78d;\n$fa-var-connectdevelop: \\f20e;\n$fa-var-contao: \\f26d;\n$fa-var-cotton-bureau: \\f89e;\n$fa-var-cpanel: \\f388;\n$fa-var-creative-commons: \\f25e;\n$fa-var-creative-commons-by: \\f4e7;\n$fa-var-creative-commons-nc: \\f4e8;\n$fa-var-creative-commons-nc-eu: \\f4e9;\n$fa-var-creative-commons-nc-jp: \\f4ea;\n$fa-var-creative-commons-nd: \\f4eb;\n$fa-var-creative-commons-pd: \\f4ec;\n$fa-var-creative-commons-pd-alt: \\f4ed;\n$fa-var-creative-commons-remix: \\f4ee;\n$fa-var-creative-commons-sa: \\f4ef;\n$fa-var-creative-commons-sampling: \\f4f0;\n$fa-var-creative-commons-sampling-plus: \\f4f1;\n$fa-var-creative-commons-share: \\f4f2;\n$fa-var-creative-commons-zero: \\f4f3;\n$fa-var-critical-role: \\f6c9;\n$fa-var-css3: \\f13c;\n$fa-var-css3-alt: \\f38b;\n$fa-var-cuttlefish: \\f38c;\n$fa-var-d-and-d: \\f38d;\n$fa-var-d-and-d-beyond: \\f6ca;\n$fa-var-dailymotion: \\e052;\n$fa-var-dashcube: \\f210;\n$fa-var-deezer: \\e077;\n$fa-var-delicious: \\f1a5;\n$fa-var-deploydog: \\f38e;\n$fa-var-deskpro: \\f38f;\n$fa-var-dev: \\f6cc;\n$fa-var-deviantart: \\f1bd;\n$fa-var-dhl: \\f790;\n$fa-var-diaspora: \\f791;\n$fa-var-digg: \\f1a6;\n$fa-var-digital-ocean: \\f391;\n$fa-var-discord: \\f392;\n$fa-var-discourse: \\f393;\n$fa-var-dochub: \\f394;\n$fa-var-docker: \\f395;\n$fa-var-draft2digital: \\f396;\n$fa-var-dribbble: \\f17d;\n$fa-var-dribbble-square: \\f397;\n$fa-var-dropbox: \\f16b;\n$fa-var-drupal: \\f1a9;\n$fa-var-dyalog: \\f399;\n$fa-var-earlybirds: \\f39a;\n$fa-var-ebay: \\f4f4;\n$fa-var-edge: \\f282;\n$fa-var-edge-legacy: \\e078;\n$fa-var-elementor: \\f430;\n$fa-var-ello: \\f5f1;\n$fa-var-ember: \\f423;\n$fa-var-empire: \\f1d1;\n$fa-var-envira: \\f299;\n$fa-var-erlang: \\f39d;\n$fa-var-ethereum: \\f42e;\n$fa-var-etsy: \\f2d7;\n$fa-var-evernote: \\f839;\n$fa-var-expeditedssl: \\f23e;\n$fa-var-facebook: \\f09a;\n$fa-var-facebook-f: \\f39e;\n$fa-var-facebook-messenger: \\f39f;\n$fa-var-facebook-square: \\f082;\n$fa-var-fantasy-flight-games: \\f6dc;\n$fa-var-fedex: \\f797;\n$fa-var-fedora: \\f798;\n$fa-var-figma: \\f799;\n$fa-var-firefox: \\f269;\n$fa-var-firefox-browser: \\e007;\n$fa-var-first-order: \\f2b0;\n$fa-var-first-order-alt: \\f50a;\n$fa-var-firstdraft: \\f3a1;\n$fa-var-flickr: \\f16e;\n$fa-var-flipboard: \\f44d;\n$fa-var-fly: \\f417;\n$fa-var-font-awesome: \\f2b4;\n$fa-var-font-awesome-flag: \\f2b4;\n$fa-var-font-awesome-logo-full: \\f2b4;\n$fa-var-fonticons: \\f280;\n$fa-var-fonticons-fi: \\f3a2;\n$fa-var-fort-awesome: \\f286;\n$fa-var-fort-awesome-alt: \\f3a3;\n$fa-var-forumbee: \\f211;\n$fa-var-foursquare: \\f180;\n$fa-var-free-code-camp: \\f2c5;\n$fa-var-freebsd: \\f3a4;\n$fa-var-fulcrum: \\f50b;\n$fa-var-galactic-republic: \\f50c;\n$fa-var-galactic-senate: \\f50d;\n$fa-var-get-pocket: \\f265;\n$fa-var-gg: \\f260;\n$fa-var-gg-circle: \\f261;\n$fa-var-git: \\f1d3;\n$fa-var-git-alt: \\f841;\n$fa-var-git-square: \\f1d2;\n$fa-var-github: \\f09b;\n$fa-var-github-alt: \\f113;\n$fa-var-github-square: \\f092;\n$fa-var-gitkraken: \\f3a6;\n$fa-var-gitlab: \\f296;\n$fa-var-gitter: \\f426;\n$fa-var-glide: \\f2a5;\n$fa-var-glide-g: \\f2a6;\n$fa-var-gofore: \\f3a7;\n$fa-var-golang: \\e40f;\n$fa-var-goodreads: \\f3a8;\n$fa-var-goodreads-g: \\f3a9;\n$fa-var-google: \\f1a0;\n$fa-var-google-drive: \\f3aa;\n$fa-var-google-pay: \\e079;\n$fa-var-google-play: \\f3ab;\n$fa-var-google-plus: \\f2b3;\n$fa-var-google-plus-g: \\f0d5;\n$fa-var-google-plus-square: \\f0d4;\n$fa-var-google-wallet: \\f1ee;\n$fa-var-gratipay: \\f184;\n$fa-var-grav: \\f2d6;\n$fa-var-gripfire: \\f3ac;\n$fa-var-grunt: \\f3ad;\n$fa-var-guilded: \\e07e;\n$fa-var-gulp: \\f3ae;\n$fa-var-hacker-news: \\f1d4;\n$fa-var-hacker-news-square: \\f3af;\n$fa-var-hackerrank: \\f5f7;\n$fa-var-hips: \\f452;\n$fa-var-hire-a-helper: \\f3b0;\n$fa-var-hive: \\e07f;\n$fa-var-hooli: \\f427;\n$fa-var-hornbill: \\f592;\n$fa-var-hotjar: \\f3b1;\n$fa-var-houzz: \\f27c;\n$fa-var-html5: \\f13b;\n$fa-var-hubspot: \\f3b2;\n$fa-var-ideal: \\e013;\n$fa-var-imdb: \\f2d8;\n$fa-var-instagram: \\f16d;\n$fa-var-instagram-square: \\e055;\n$fa-var-instalod: \\e081;\n$fa-var-intercom: \\f7af;\n$fa-var-internet-explorer: \\f26b;\n$fa-var-invision: \\f7b0;\n$fa-var-ioxhost: \\f208;\n$fa-var-itch-io: \\f83a;\n$fa-var-itunes: \\f3b4;\n$fa-var-itunes-note: \\f3b5;\n$fa-var-java: \\f4e4;\n$fa-var-jedi-order: \\f50e;\n$fa-var-jenkins: \\f3b6;\n$fa-var-jira: \\f7b1;\n$fa-var-joget: \\f3b7;\n$fa-var-joomla: \\f1aa;\n$fa-var-js: \\f3b8;\n$fa-var-js-square: \\f3b9;\n$fa-var-jsfiddle: \\f1cc;\n$fa-var-kaggle: \\f5fa;\n$fa-var-keybase: \\f4f5;\n$fa-var-keycdn: \\f3ba;\n$fa-var-kickstarter: \\f3bb;\n$fa-var-kickstarter-k: \\f3bc;\n$fa-var-korvue: \\f42f;\n$fa-var-laravel: \\f3bd;\n$fa-var-lastfm: \\f202;\n$fa-var-lastfm-square: \\f203;\n$fa-var-leanpub: \\f212;\n$fa-var-less: \\f41d;\n$fa-var-line: \\f3c0;\n$fa-var-linkedin: \\f08c;\n$fa-var-linkedin-in: \\f0e1;\n$fa-var-linode: \\f2b8;\n$fa-var-linux: \\f17c;\n$fa-var-lyft: \\f3c3;\n$fa-var-magento: \\f3c4;\n$fa-var-mailchimp: \\f59e;\n$fa-var-mandalorian: \\f50f;\n$fa-var-markdown: \\f60f;\n$fa-var-mastodon: \\f4f6;\n$fa-var-maxcdn: \\f136;\n$fa-var-mdb: \\f8ca;\n$fa-var-medapps: \\f3c6;\n$fa-var-medium: \\f23a;\n$fa-var-medium-m: \\f23a;\n$fa-var-medrt: \\f3c8;\n$fa-var-meetup: \\f2e0;\n$fa-var-megaport: \\f5a3;\n$fa-var-mendeley: \\f7b3;\n$fa-var-microblog: \\e01a;\n$fa-var-microsoft: \\f3ca;\n$fa-var-mix: \\f3cb;\n$fa-var-mixcloud: \\f289;\n$fa-var-mixer: \\e056;\n$fa-var-mizuni: \\f3cc;\n$fa-var-modx: \\f285;\n$fa-var-monero: \\f3d0;\n$fa-var-napster: \\f3d2;\n$fa-var-neos: \\f612;\n$fa-var-nimblr: \\f5a8;\n$fa-var-node: \\f419;\n$fa-var-node-js: \\f3d3;\n$fa-var-npm: \\f3d4;\n$fa-var-ns8: \\f3d5;\n$fa-var-nutritionix: \\f3d6;\n$fa-var-octopus-deploy: \\e082;\n$fa-var-odnoklassniki: \\f263;\n$fa-var-odnoklassniki-square: \\f264;\n$fa-var-old-republic: \\f510;\n$fa-var-opencart: \\f23d;\n$fa-var-openid: \\f19b;\n$fa-var-opera: \\f26a;\n$fa-var-optin-monster: \\f23c;\n$fa-var-orcid: \\f8d2;\n$fa-var-osi: \\f41a;\n$fa-var-page4: \\f3d7;\n$fa-var-pagelines: \\f18c;\n$fa-var-palfed: \\f3d8;\n$fa-var-patreon: \\f3d9;\n$fa-var-paypal: \\f1ed;\n$fa-var-penny-arcade: \\f704;\n$fa-var-perbyte: \\e083;\n$fa-var-periscope: \\f3da;\n$fa-var-phabricator: \\f3db;\n$fa-var-phoenix-framework: \\f3dc;\n$fa-var-phoenix-squadron: \\f511;\n$fa-var-php: \\f457;\n$fa-var-pied-piper: \\f2ae;\n$fa-var-pied-piper-alt: \\f1a8;\n$fa-var-pied-piper-hat: \\f4e5;\n$fa-var-pied-piper-pp: \\f1a7;\n$fa-var-pied-piper-square: \\e01e;\n$fa-var-pinterest: \\f0d2;\n$fa-var-pinterest-p: \\f231;\n$fa-var-pinterest-square: \\f0d3;\n$fa-var-pix: \\e43a;\n$fa-var-playstation: \\f3df;\n$fa-var-product-hunt: \\f288;\n$fa-var-pushed: \\f3e1;\n$fa-var-python: \\f3e2;\n$fa-var-qq: \\f1d6;\n$fa-var-quinscape: \\f459;\n$fa-var-quora: \\f2c4;\n$fa-var-r-project: \\f4f7;\n$fa-var-raspberry-pi: \\f7bb;\n$fa-var-ravelry: \\f2d9;\n$fa-var-react: \\f41b;\n$fa-var-reacteurope: \\f75d;\n$fa-var-readme: \\f4d5;\n$fa-var-rebel: \\f1d0;\n$fa-var-red-river: \\f3e3;\n$fa-var-reddit: \\f1a1;\n$fa-var-reddit-alien: \\f281;\n$fa-var-reddit-square: \\f1a2;\n$fa-var-redhat: \\f7bc;\n$fa-var-renren: \\f18b;\n$fa-var-replyd: \\f3e6;\n$fa-var-researchgate: \\f4f8;\n$fa-var-resolving: \\f3e7;\n$fa-var-rev: \\f5b2;\n$fa-var-rocketchat: \\f3e8;\n$fa-var-rockrms: \\f3e9;\n$fa-var-rust: \\e07a;\n$fa-var-safari: \\f267;\n$fa-var-salesforce: \\f83b;\n$fa-var-sass: \\f41e;\n$fa-var-schlix: \\f3ea;\n$fa-var-scribd: \\f28a;\n$fa-var-searchengin: \\f3eb;\n$fa-var-sellcast: \\f2da;\n$fa-var-sellsy: \\f213;\n$fa-var-servicestack: \\f3ec;\n$fa-var-shirtsinbulk: \\f214;\n$fa-var-shopify: \\e057;\n$fa-var-shopware: \\f5b5;\n$fa-var-simplybuilt: \\f215;\n$fa-var-sistrix: \\f3ee;\n$fa-var-sith: \\f512;\n$fa-var-sitrox: \\e44a;\n$fa-var-sketch: \\f7c6;\n$fa-var-skyatlas: \\f216;\n$fa-var-skype: \\f17e;\n$fa-var-slack: \\f198;\n$fa-var-slack-hash: \\f198;\n$fa-var-slideshare: \\f1e7;\n$fa-var-snapchat: \\f2ab;\n$fa-var-snapchat-ghost: \\f2ab;\n$fa-var-snapchat-square: \\f2ad;\n$fa-var-soundcloud: \\f1be;\n$fa-var-sourcetree: \\f7d3;\n$fa-var-speakap: \\f3f3;\n$fa-var-speaker-deck: \\f83c;\n$fa-var-spotify: \\f1bc;\n$fa-var-square-font-awesome: \\f425;\n$fa-var-square-font-awesome-stroke: \\f35c;\n$fa-var-font-awesome-alt: \\f35c;\n$fa-var-squarespace: \\f5be;\n$fa-var-stack-exchange: \\f18d;\n$fa-var-stack-overflow: \\f16c;\n$fa-var-stackpath: \\f842;\n$fa-var-staylinked: \\f3f5;\n$fa-var-steam: \\f1b6;\n$fa-var-steam-square: \\f1b7;\n$fa-var-steam-symbol: \\f3f6;\n$fa-var-sticker-mule: \\f3f7;\n$fa-var-strava: \\f428;\n$fa-var-stripe: \\f429;\n$fa-var-stripe-s: \\f42a;\n$fa-var-studiovinari: \\f3f8;\n$fa-var-stumbleupon: \\f1a4;\n$fa-var-stumbleupon-circle: \\f1a3;\n$fa-var-superpowers: \\f2dd;\n$fa-var-supple: \\f3f9;\n$fa-var-suse: \\f7d6;\n$fa-var-swift: \\f8e1;\n$fa-var-symfony: \\f83d;\n$fa-var-teamspeak: \\f4f9;\n$fa-var-telegram: \\f2c6;\n$fa-var-telegram-plane: \\f2c6;\n$fa-var-tencent-weibo: \\f1d5;\n$fa-var-the-red-yeti: \\f69d;\n$fa-var-themeco: \\f5c6;\n$fa-var-themeisle: \\f2b2;\n$fa-var-think-peaks: \\f731;\n$fa-var-tiktok: \\e07b;\n$fa-var-trade-federation: \\f513;\n$fa-var-trello: \\f181;\n$fa-var-tumblr: \\f173;\n$fa-var-tumblr-square: \\f174;\n$fa-var-twitch: \\f1e8;\n$fa-var-twitter: \\f099;\n$fa-var-twitter-square: \\f081;\n$fa-var-typo3: \\f42b;\n$fa-var-uber: \\f402;\n$fa-var-ubuntu: \\f7df;\n$fa-var-uikit: \\f403;\n$fa-var-umbraco: \\f8e8;\n$fa-var-uncharted: \\e084;\n$fa-var-uniregistry: \\f404;\n$fa-var-unity: \\e049;\n$fa-var-unsplash: \\e07c;\n$fa-var-untappd: \\f405;\n$fa-var-ups: \\f7e0;\n$fa-var-usb: \\f287;\n$fa-var-usps: \\f7e1;\n$fa-var-ussunnah: \\f407;\n$fa-var-vaadin: \\f408;\n$fa-var-viacoin: \\f237;\n$fa-var-viadeo: \\f2a9;\n$fa-var-viadeo-square: \\f2aa;\n$fa-var-viber: \\f409;\n$fa-var-vimeo: \\f40a;\n$fa-var-vimeo-square: \\f194;\n$fa-var-vimeo-v: \\f27d;\n$fa-var-vine: \\f1ca;\n$fa-var-vk: \\f189;\n$fa-var-vnv: \\f40b;\n$fa-var-vuejs: \\f41f;\n$fa-var-watchman-monitoring: \\e087;\n$fa-var-waze: \\f83f;\n$fa-var-weebly: \\f5cc;\n$fa-var-weibo: \\f18a;\n$fa-var-weixin: \\f1d7;\n$fa-var-whatsapp: \\f232;\n$fa-var-whatsapp-square: \\f40c;\n$fa-var-whmcs: \\f40d;\n$fa-var-wikipedia-w: \\f266;\n$fa-var-windows: \\f17a;\n$fa-var-wirsindhandwerk: \\e2d0;\n$fa-var-wsh: \\e2d0;\n$fa-var-wix: \\f5cf;\n$fa-var-wizards-of-the-coast: \\f730;\n$fa-var-wodu: \\e088;\n$fa-var-wolf-pack-battalion: \\f514;\n$fa-var-wordpress: \\f19a;\n$fa-var-wordpress-simple: \\f411;\n$fa-var-wpbeginner: \\f297;\n$fa-var-wpexplorer: \\f2de;\n$fa-var-wpforms: \\f298;\n$fa-var-wpressr: \\f3e4;\n$fa-var-xbox: \\f412;\n$fa-var-xing: \\f168;\n$fa-var-xing-square: \\f169;\n$fa-var-y-combinator: \\f23b;\n$fa-var-yahoo: \\f19e;\n$fa-var-yammer: \\f840;\n$fa-var-yandex: \\f413;\n$fa-var-yandex-international: \\f414;\n$fa-var-yarn: \\f7e3;\n$fa-var-yelp: \\f1e9;\n$fa-var-yoast: \\f2b1;\n$fa-var-youtube: \\f167;\n$fa-var-youtube-square: \\f431;\n$fa-var-zhihu: \\f63f;\n\n$fa-icons: (\n  \"0\": $fa-var-0,\n  \"1\": $fa-var-1,\n  \"2\": $fa-var-2,\n  \"3\": $fa-var-3,\n  \"4\": $fa-var-4,\n  \"5\": $fa-var-5,\n  \"6\": $fa-var-6,\n  \"7\": $fa-var-7,\n  \"8\": $fa-var-8,\n  \"9\": $fa-var-9,\n  \"360-degrees\": $fa-var-360-degrees,\n  \"a\": $fa-var-a,\n  \"abacus\": $fa-var-abacus,\n  \"accent-grave\": $fa-var-accent-grave,\n  \"acorn\": $fa-var-acorn,\n  \"address-book\": $fa-var-address-book,\n  \"contact-book\": $fa-var-contact-book,\n  \"address-card\": $fa-var-address-card,\n  \"contact-card\": $fa-var-contact-card,\n  \"vcard\": $fa-var-vcard,\n  \"air-conditioner\": $fa-var-air-conditioner,\n  \"airplay\": $fa-var-airplay,\n  \"alarm-clock\": $fa-var-alarm-clock,\n  \"alarm-exclamation\": $fa-var-alarm-exclamation,\n  \"alarm-plus\": $fa-var-alarm-plus,\n  \"alarm-snooze\": $fa-var-alarm-snooze,\n  \"album\": $fa-var-album,\n  \"album-collection\": $fa-var-album-collection,\n  \"alicorn\": $fa-var-alicorn,\n  \"alien\": $fa-var-alien,\n  \"alien-8bit\": $fa-var-alien-8bit,\n  \"alien-monster\": $fa-var-alien-monster,\n  \"align-center\": $fa-var-align-center,\n  \"align-justify\": $fa-var-align-justify,\n  \"align-left\": $fa-var-align-left,\n  \"align-right\": $fa-var-align-right,\n  \"align-slash\": $fa-var-align-slash,\n  \"alt\": $fa-var-alt,\n  \"amp-guitar\": $fa-var-amp-guitar,\n  \"ampersand\": $fa-var-ampersand,\n  \"anchor\": $fa-var-anchor,\n  \"angel\": $fa-var-angel,\n  \"angle\": $fa-var-angle,\n  \"angle-90\": $fa-var-angle-90,\n  \"angle-down\": $fa-var-angle-down,\n  \"angle-left\": $fa-var-angle-left,\n  \"angle-right\": $fa-var-angle-right,\n  \"angle-up\": $fa-var-angle-up,\n  \"angles-down\": $fa-var-angles-down,\n  \"angle-double-down\": $fa-var-angle-double-down,\n  \"angles-left\": $fa-var-angles-left,\n  \"angle-double-left\": $fa-var-angle-double-left,\n  \"angles-right\": $fa-var-angles-right,\n  \"angle-double-right\": $fa-var-angle-double-right,\n  \"angles-up\": $fa-var-angles-up,\n  \"angle-double-up\": $fa-var-angle-double-up,\n  \"ankh\": $fa-var-ankh,\n  \"aperture\": $fa-var-aperture,\n  \"apostrophe\": $fa-var-apostrophe,\n  \"apple-core\": $fa-var-apple-core,\n  \"apple-whole\": $fa-var-apple-whole,\n  \"apple-alt\": $fa-var-apple-alt,\n  \"archway\": $fa-var-archway,\n  \"arrow-down\": $fa-var-arrow-down,\n  \"arrow-down-1-9\": $fa-var-arrow-down-1-9,\n  \"sort-numeric-asc\": $fa-var-sort-numeric-asc,\n  \"sort-numeric-down\": $fa-var-sort-numeric-down,\n  \"arrow-down-9-1\": $fa-var-arrow-down-9-1,\n  \"sort-numeric-desc\": $fa-var-sort-numeric-desc,\n  \"sort-numeric-down-alt\": $fa-var-sort-numeric-down-alt,\n  \"arrow-down-a-z\": $fa-var-arrow-down-a-z,\n  \"sort-alpha-asc\": $fa-var-sort-alpha-asc,\n  \"sort-alpha-down\": $fa-var-sort-alpha-down,\n  \"arrow-down-arrow-up\": $fa-var-arrow-down-arrow-up,\n  \"sort-alt\": $fa-var-sort-alt,\n  \"arrow-down-big-small\": $fa-var-arrow-down-big-small,\n  \"sort-size-down\": $fa-var-sort-size-down,\n  \"arrow-down-from-dotted-line\": $fa-var-arrow-down-from-dotted-line,\n  \"arrow-down-from-line\": $fa-var-arrow-down-from-line,\n  \"arrow-from-top\": $fa-var-arrow-from-top,\n  \"arrow-down-left\": $fa-var-arrow-down-left,\n  \"arrow-down-left-and-arrow-up-right-to-center\": $fa-var-arrow-down-left-and-arrow-up-right-to-center,\n  \"arrow-down-long\": $fa-var-arrow-down-long,\n  \"long-arrow-down\": $fa-var-long-arrow-down,\n  \"arrow-down-right\": $fa-var-arrow-down-right,\n  \"arrow-down-short-wide\": $fa-var-arrow-down-short-wide,\n  \"sort-amount-desc\": $fa-var-sort-amount-desc,\n  \"sort-amount-down-alt\": $fa-var-sort-amount-down-alt,\n  \"arrow-down-small-big\": $fa-var-arrow-down-small-big,\n  \"sort-size-down-alt\": $fa-var-sort-size-down-alt,\n  \"arrow-down-square-triangle\": $fa-var-arrow-down-square-triangle,\n  \"sort-shapes-down-alt\": $fa-var-sort-shapes-down-alt,\n  \"arrow-down-to-bracket\": $fa-var-arrow-down-to-bracket,\n  \"arrow-down-to-dotted-line\": $fa-var-arrow-down-to-dotted-line,\n  \"arrow-down-to-line\": $fa-var-arrow-down-to-line,\n  \"arrow-to-bottom\": $fa-var-arrow-to-bottom,\n  \"arrow-down-to-square\": $fa-var-arrow-down-to-square,\n  \"arrow-down-triangle-square\": $fa-var-arrow-down-triangle-square,\n  \"sort-shapes-down\": $fa-var-sort-shapes-down,\n  \"arrow-down-wide-short\": $fa-var-arrow-down-wide-short,\n  \"sort-amount-asc\": $fa-var-sort-amount-asc,\n  \"sort-amount-down\": $fa-var-sort-amount-down,\n  \"arrow-down-z-a\": $fa-var-arrow-down-z-a,\n  \"sort-alpha-desc\": $fa-var-sort-alpha-desc,\n  \"sort-alpha-down-alt\": $fa-var-sort-alpha-down-alt,\n  \"arrow-left\": $fa-var-arrow-left,\n  \"arrow-left-from-line\": $fa-var-arrow-left-from-line,\n  \"arrow-from-right\": $fa-var-arrow-from-right,\n  \"arrow-left-long\": $fa-var-arrow-left-long,\n  \"long-arrow-left\": $fa-var-long-arrow-left,\n  \"arrow-left-long-to-line\": $fa-var-arrow-left-long-to-line,\n  \"arrow-left-to-line\": $fa-var-arrow-left-to-line,\n  \"arrow-to-left\": $fa-var-arrow-to-left,\n  \"arrow-pointer\": $fa-var-arrow-pointer,\n  \"mouse-pointer\": $fa-var-mouse-pointer,\n  \"arrow-right\": $fa-var-arrow-right,\n  \"arrow-right-arrow-left\": $fa-var-arrow-right-arrow-left,\n  \"exchange\": $fa-var-exchange,\n  \"arrow-right-from-bracket\": $fa-var-arrow-right-from-bracket,\n  \"sign-out\": $fa-var-sign-out,\n  \"arrow-right-from-line\": $fa-var-arrow-right-from-line,\n  \"arrow-from-left\": $fa-var-arrow-from-left,\n  \"arrow-right-long\": $fa-var-arrow-right-long,\n  \"long-arrow-right\": $fa-var-long-arrow-right,\n  \"arrow-right-long-to-line\": $fa-var-arrow-right-long-to-line,\n  \"arrow-right-to-bracket\": $fa-var-arrow-right-to-bracket,\n  \"sign-in\": $fa-var-sign-in,\n  \"arrow-right-to-line\": $fa-var-arrow-right-to-line,\n  \"arrow-to-right\": $fa-var-arrow-to-right,\n  \"arrow-rotate-left\": $fa-var-arrow-rotate-left,\n  \"arrow-left-rotate\": $fa-var-arrow-left-rotate,\n  \"arrow-rotate-back\": $fa-var-arrow-rotate-back,\n  \"arrow-rotate-backward\": $fa-var-arrow-rotate-backward,\n  \"undo\": $fa-var-undo,\n  \"arrow-rotate-right\": $fa-var-arrow-rotate-right,\n  \"arrow-right-rotate\": $fa-var-arrow-right-rotate,\n  \"arrow-rotate-forward\": $fa-var-arrow-rotate-forward,\n  \"redo\": $fa-var-redo,\n  \"arrow-trend-down\": $fa-var-arrow-trend-down,\n  \"arrow-trend-up\": $fa-var-arrow-trend-up,\n  \"arrow-turn-down\": $fa-var-arrow-turn-down,\n  \"level-down\": $fa-var-level-down,\n  \"arrow-turn-down-left\": $fa-var-arrow-turn-down-left,\n  \"arrow-turn-down-right\": $fa-var-arrow-turn-down-right,\n  \"arrow-turn-up\": $fa-var-arrow-turn-up,\n  \"level-up\": $fa-var-level-up,\n  \"arrow-up\": $fa-var-arrow-up,\n  \"arrow-up-1-9\": $fa-var-arrow-up-1-9,\n  \"sort-numeric-up\": $fa-var-sort-numeric-up,\n  \"arrow-up-9-1\": $fa-var-arrow-up-9-1,\n  \"sort-numeric-up-alt\": $fa-var-sort-numeric-up-alt,\n  \"arrow-up-a-z\": $fa-var-arrow-up-a-z,\n  \"sort-alpha-up\": $fa-var-sort-alpha-up,\n  \"arrow-up-arrow-down\": $fa-var-arrow-up-arrow-down,\n  \"sort-up-down\": $fa-var-sort-up-down,\n  \"arrow-up-big-small\": $fa-var-arrow-up-big-small,\n  \"sort-size-up\": $fa-var-sort-size-up,\n  \"arrow-up-from-bracket\": $fa-var-arrow-up-from-bracket,\n  \"arrow-up-from-dotted-line\": $fa-var-arrow-up-from-dotted-line,\n  \"arrow-up-from-line\": $fa-var-arrow-up-from-line,\n  \"arrow-from-bottom\": $fa-var-arrow-from-bottom,\n  \"arrow-up-from-square\": $fa-var-arrow-up-from-square,\n  \"arrow-up-left\": $fa-var-arrow-up-left,\n  \"arrow-up-left-from-circle\": $fa-var-arrow-up-left-from-circle,\n  \"arrow-up-long\": $fa-var-arrow-up-long,\n  \"long-arrow-up\": $fa-var-long-arrow-up,\n  \"arrow-up-right\": $fa-var-arrow-up-right,\n  \"arrow-up-right-and-arrow-down-left-from-center\": $fa-var-arrow-up-right-and-arrow-down-left-from-center,\n  \"arrow-up-right-from-square\": $fa-var-arrow-up-right-from-square,\n  \"external-link\": $fa-var-external-link,\n  \"arrow-up-short-wide\": $fa-var-arrow-up-short-wide,\n  \"sort-amount-up-alt\": $fa-var-sort-amount-up-alt,\n  \"arrow-up-small-big\": $fa-var-arrow-up-small-big,\n  \"sort-size-up-alt\": $fa-var-sort-size-up-alt,\n  \"arrow-up-square-triangle\": $fa-var-arrow-up-square-triangle,\n  \"sort-shapes-up-alt\": $fa-var-sort-shapes-up-alt,\n  \"arrow-up-to-dotted-line\": $fa-var-arrow-up-to-dotted-line,\n  \"arrow-up-to-line\": $fa-var-arrow-up-to-line,\n  \"arrow-to-top\": $fa-var-arrow-to-top,\n  \"arrow-up-triangle-square\": $fa-var-arrow-up-triangle-square,\n  \"sort-shapes-up\": $fa-var-sort-shapes-up,\n  \"arrow-up-wide-short\": $fa-var-arrow-up-wide-short,\n  \"sort-amount-up\": $fa-var-sort-amount-up,\n  \"arrow-up-z-a\": $fa-var-arrow-up-z-a,\n  \"sort-alpha-up-alt\": $fa-var-sort-alpha-up-alt,\n  \"arrows-cross\": $fa-var-arrows-cross,\n  \"arrows-from-dotted-line\": $fa-var-arrows-from-dotted-line,\n  \"arrows-from-line\": $fa-var-arrows-from-line,\n  \"arrows-left-right\": $fa-var-arrows-left-right,\n  \"arrows-h\": $fa-var-arrows-h,\n  \"arrows-maximize\": $fa-var-arrows-maximize,\n  \"expand-arrows\": $fa-var-expand-arrows,\n  \"arrows-minimize\": $fa-var-arrows-minimize,\n  \"compress-arrows\": $fa-var-compress-arrows,\n  \"arrows-repeat\": $fa-var-arrows-repeat,\n  \"repeat-alt\": $fa-var-repeat-alt,\n  \"arrows-repeat-1\": $fa-var-arrows-repeat-1,\n  \"repeat-1-alt\": $fa-var-repeat-1-alt,\n  \"arrows-retweet\": $fa-var-arrows-retweet,\n  \"retweet-alt\": $fa-var-retweet-alt,\n  \"arrows-rotate\": $fa-var-arrows-rotate,\n  \"refresh\": $fa-var-refresh,\n  \"sync\": $fa-var-sync,\n  \"arrows-to-dotted-line\": $fa-var-arrows-to-dotted-line,\n  \"arrows-to-line\": $fa-var-arrows-to-line,\n  \"arrows-up-down\": $fa-var-arrows-up-down,\n  \"arrows-v\": $fa-var-arrows-v,\n  \"arrows-up-down-left-right\": $fa-var-arrows-up-down-left-right,\n  \"arrows\": $fa-var-arrows,\n  \"asterisk\": $fa-var-asterisk,\n  \"at\": $fa-var-at,\n  \"atom\": $fa-var-atom,\n  \"atom-simple\": $fa-var-atom-simple,\n  \"atom-alt\": $fa-var-atom-alt,\n  \"audio-description\": $fa-var-audio-description,\n  \"audio-description-slash\": $fa-var-audio-description-slash,\n  \"austral-sign\": $fa-var-austral-sign,\n  \"avocado\": $fa-var-avocado,\n  \"award\": $fa-var-award,\n  \"award-simple\": $fa-var-award-simple,\n  \"axe\": $fa-var-axe,\n  \"axe-battle\": $fa-var-axe-battle,\n  \"b\": $fa-var-b,\n  \"baby\": $fa-var-baby,\n  \"baby-carriage\": $fa-var-baby-carriage,\n  \"carriage-baby\": $fa-var-carriage-baby,\n  \"backpack\": $fa-var-backpack,\n  \"backward\": $fa-var-backward,\n  \"backward-fast\": $fa-var-backward-fast,\n  \"fast-backward\": $fa-var-fast-backward,\n  \"backward-step\": $fa-var-backward-step,\n  \"step-backward\": $fa-var-step-backward,\n  \"bacon\": $fa-var-bacon,\n  \"bacteria\": $fa-var-bacteria,\n  \"bacterium\": $fa-var-bacterium,\n  \"badge\": $fa-var-badge,\n  \"badge-check\": $fa-var-badge-check,\n  \"badge-dollar\": $fa-var-badge-dollar,\n  \"badge-percent\": $fa-var-badge-percent,\n  \"badge-sheriff\": $fa-var-badge-sheriff,\n  \"badger-honey\": $fa-var-badger-honey,\n  \"badminton\": $fa-var-badminton,\n  \"bag-shopping\": $fa-var-bag-shopping,\n  \"shopping-bag\": $fa-var-shopping-bag,\n  \"bagel\": $fa-var-bagel,\n  \"bags-shopping\": $fa-var-bags-shopping,\n  \"baguette\": $fa-var-baguette,\n  \"bahai\": $fa-var-bahai,\n  \"baht-sign\": $fa-var-baht-sign,\n  \"ball-pile\": $fa-var-ball-pile,\n  \"balloon\": $fa-var-balloon,\n  \"balloons\": $fa-var-balloons,\n  \"ballot\": $fa-var-ballot,\n  \"ballot-check\": $fa-var-ballot-check,\n  \"ban\": $fa-var-ban,\n  \"cancel\": $fa-var-cancel,\n  \"ban-bug\": $fa-var-ban-bug,\n  \"debug\": $fa-var-debug,\n  \"ban-parking\": $fa-var-ban-parking,\n  \"parking-circle-slash\": $fa-var-parking-circle-slash,\n  \"ban-smoking\": $fa-var-ban-smoking,\n  \"smoking-ban\": $fa-var-smoking-ban,\n  \"banana\": $fa-var-banana,\n  \"bandage\": $fa-var-bandage,\n  \"band-aid\": $fa-var-band-aid,\n  \"bangladeshi-taka-sign\": $fa-var-bangladeshi-taka-sign,\n  \"banjo\": $fa-var-banjo,\n  \"bank\": $fa-var-bank,\n  \"institution\": $fa-var-institution,\n  \"university\": $fa-var-university,\n  \"barcode\": $fa-var-barcode,\n  \"barcode-read\": $fa-var-barcode-read,\n  \"barcode-scan\": $fa-var-barcode-scan,\n  \"bars\": $fa-var-bars,\n  \"navicon\": $fa-var-navicon,\n  \"bars-filter\": $fa-var-bars-filter,\n  \"bars-progress\": $fa-var-bars-progress,\n  \"tasks-alt\": $fa-var-tasks-alt,\n  \"bars-sort\": $fa-var-bars-sort,\n  \"bars-staggered\": $fa-var-bars-staggered,\n  \"reorder\": $fa-var-reorder,\n  \"stream\": $fa-var-stream,\n  \"baseball\": $fa-var-baseball,\n  \"baseball-ball\": $fa-var-baseball-ball,\n  \"baseball-bat-ball\": $fa-var-baseball-bat-ball,\n  \"basket-shopping\": $fa-var-basket-shopping,\n  \"shopping-basket\": $fa-var-shopping-basket,\n  \"basket-shopping-simple\": $fa-var-basket-shopping-simple,\n  \"shopping-basket-alt\": $fa-var-shopping-basket-alt,\n  \"basketball\": $fa-var-basketball,\n  \"basketball-ball\": $fa-var-basketball-ball,\n  \"basketball-hoop\": $fa-var-basketball-hoop,\n  \"bat\": $fa-var-bat,\n  \"bath\": $fa-var-bath,\n  \"bathtub\": $fa-var-bathtub,\n  \"battery-bolt\": $fa-var-battery-bolt,\n  \"battery-empty\": $fa-var-battery-empty,\n  \"battery-0\": $fa-var-battery-0,\n  \"battery-exclamation\": $fa-var-battery-exclamation,\n  \"battery-full\": $fa-var-battery-full,\n  \"battery\": $fa-var-battery,\n  \"battery-5\": $fa-var-battery-5,\n  \"battery-half\": $fa-var-battery-half,\n  \"battery-3\": $fa-var-battery-3,\n  \"battery-low\": $fa-var-battery-low,\n  \"battery-1\": $fa-var-battery-1,\n  \"battery-quarter\": $fa-var-battery-quarter,\n  \"battery-2\": $fa-var-battery-2,\n  \"battery-slash\": $fa-var-battery-slash,\n  \"battery-three-quarters\": $fa-var-battery-three-quarters,\n  \"battery-4\": $fa-var-battery-4,\n  \"bed\": $fa-var-bed,\n  \"bed-bunk\": $fa-var-bed-bunk,\n  \"bed-empty\": $fa-var-bed-empty,\n  \"bed-front\": $fa-var-bed-front,\n  \"bed-alt\": $fa-var-bed-alt,\n  \"bed-pulse\": $fa-var-bed-pulse,\n  \"procedures\": $fa-var-procedures,\n  \"bee\": $fa-var-bee,\n  \"beer-mug\": $fa-var-beer-mug,\n  \"beer-foam\": $fa-var-beer-foam,\n  \"beer-mug-empty\": $fa-var-beer-mug-empty,\n  \"beer\": $fa-var-beer,\n  \"bell\": $fa-var-bell,\n  \"bell-concierge\": $fa-var-bell-concierge,\n  \"concierge-bell\": $fa-var-concierge-bell,\n  \"bell-exclamation\": $fa-var-bell-exclamation,\n  \"bell-on\": $fa-var-bell-on,\n  \"bell-plus\": $fa-var-bell-plus,\n  \"bell-school\": $fa-var-bell-school,\n  \"bell-school-slash\": $fa-var-bell-school-slash,\n  \"bell-slash\": $fa-var-bell-slash,\n  \"bells\": $fa-var-bells,\n  \"bench-tree\": $fa-var-bench-tree,\n  \"bezier-curve\": $fa-var-bezier-curve,\n  \"bicycle\": $fa-var-bicycle,\n  \"binary\": $fa-var-binary,\n  \"binary-circle-check\": $fa-var-binary-circle-check,\n  \"binary-lock\": $fa-var-binary-lock,\n  \"binary-slash\": $fa-var-binary-slash,\n  \"binoculars\": $fa-var-binoculars,\n  \"biohazard\": $fa-var-biohazard,\n  \"bitcoin-sign\": $fa-var-bitcoin-sign,\n  \"blanket\": $fa-var-blanket,\n  \"blanket-fire\": $fa-var-blanket-fire,\n  \"blender\": $fa-var-blender,\n  \"blender-phone\": $fa-var-blender-phone,\n  \"blinds\": $fa-var-blinds,\n  \"blinds-open\": $fa-var-blinds-open,\n  \"blinds-raised\": $fa-var-blinds-raised,\n  \"block-brick\": $fa-var-block-brick,\n  \"wall-brick\": $fa-var-wall-brick,\n  \"block-brick-fire\": $fa-var-block-brick-fire,\n  \"firewall\": $fa-var-firewall,\n  \"block-question\": $fa-var-block-question,\n  \"block-quote\": $fa-var-block-quote,\n  \"blog\": $fa-var-blog,\n  \"blueberries\": $fa-var-blueberries,\n  \"bold\": $fa-var-bold,\n  \"bolt\": $fa-var-bolt,\n  \"flash\": $fa-var-flash,\n  \"bolt-auto\": $fa-var-bolt-auto,\n  \"bolt-lightning\": $fa-var-bolt-lightning,\n  \"bolt-slash\": $fa-var-bolt-slash,\n  \"bomb\": $fa-var-bomb,\n  \"bone\": $fa-var-bone,\n  \"bone-break\": $fa-var-bone-break,\n  \"bong\": $fa-var-bong,\n  \"book\": $fa-var-book,\n  \"book-arrow-right\": $fa-var-book-arrow-right,\n  \"book-arrow-up\": $fa-var-book-arrow-up,\n  \"book-atlas\": $fa-var-book-atlas,\n  \"atlas\": $fa-var-atlas,\n  \"book-bible\": $fa-var-book-bible,\n  \"bible\": $fa-var-bible,\n  \"book-blank\": $fa-var-book-blank,\n  \"book-alt\": $fa-var-book-alt,\n  \"book-bookmark\": $fa-var-book-bookmark,\n  \"book-circle-arrow-right\": $fa-var-book-circle-arrow-right,\n  \"book-circle-arrow-up\": $fa-var-book-circle-arrow-up,\n  \"book-copy\": $fa-var-book-copy,\n  \"book-font\": $fa-var-book-font,\n  \"book-heart\": $fa-var-book-heart,\n  \"book-journal-whills\": $fa-var-book-journal-whills,\n  \"journal-whills\": $fa-var-journal-whills,\n  \"book-medical\": $fa-var-book-medical,\n  \"book-open\": $fa-var-book-open,\n  \"book-open-cover\": $fa-var-book-open-cover,\n  \"book-open-alt\": $fa-var-book-open-alt,\n  \"book-open-reader\": $fa-var-book-open-reader,\n  \"book-reader\": $fa-var-book-reader,\n  \"book-quran\": $fa-var-book-quran,\n  \"quran\": $fa-var-quran,\n  \"book-section\": $fa-var-book-section,\n  \"book-law\": $fa-var-book-law,\n  \"book-skull\": $fa-var-book-skull,\n  \"book-dead\": $fa-var-book-dead,\n  \"book-sparkles\": $fa-var-book-sparkles,\n  \"book-spells\": $fa-var-book-spells,\n  \"book-tanakh\": $fa-var-book-tanakh,\n  \"tanakh\": $fa-var-tanakh,\n  \"book-user\": $fa-var-book-user,\n  \"bookmark\": $fa-var-bookmark,\n  \"bookmark-slash\": $fa-var-bookmark-slash,\n  \"books\": $fa-var-books,\n  \"books-medical\": $fa-var-books-medical,\n  \"boombox\": $fa-var-boombox,\n  \"boot\": $fa-var-boot,\n  \"boot-heeled\": $fa-var-boot-heeled,\n  \"booth-curtain\": $fa-var-booth-curtain,\n  \"border-all\": $fa-var-border-all,\n  \"border-bottom\": $fa-var-border-bottom,\n  \"border-bottom-right\": $fa-var-border-bottom-right,\n  \"border-style-alt\": $fa-var-border-style-alt,\n  \"border-center-h\": $fa-var-border-center-h,\n  \"border-center-v\": $fa-var-border-center-v,\n  \"border-inner\": $fa-var-border-inner,\n  \"border-left\": $fa-var-border-left,\n  \"border-none\": $fa-var-border-none,\n  \"border-outer\": $fa-var-border-outer,\n  \"border-right\": $fa-var-border-right,\n  \"border-top\": $fa-var-border-top,\n  \"border-top-left\": $fa-var-border-top-left,\n  \"border-style\": $fa-var-border-style,\n  \"bow-arrow\": $fa-var-bow-arrow,\n  \"bowl-chopsticks\": $fa-var-bowl-chopsticks,\n  \"bowl-chopsticks-noodles\": $fa-var-bowl-chopsticks-noodles,\n  \"bowl-hot\": $fa-var-bowl-hot,\n  \"soup\": $fa-var-soup,\n  \"bowl-rice\": $fa-var-bowl-rice,\n  \"bowl-scoop\": $fa-var-bowl-scoop,\n  \"bowl-shaved-ice\": $fa-var-bowl-shaved-ice,\n  \"bowl-scoops\": $fa-var-bowl-scoops,\n  \"bowl-spoon\": $fa-var-bowl-spoon,\n  \"bowling-ball\": $fa-var-bowling-ball,\n  \"bowling-ball-pin\": $fa-var-bowling-ball-pin,\n  \"bowling-pins\": $fa-var-bowling-pins,\n  \"box\": $fa-var-box,\n  \"box-archive\": $fa-var-box-archive,\n  \"archive\": $fa-var-archive,\n  \"box-ballot\": $fa-var-box-ballot,\n  \"box-check\": $fa-var-box-check,\n  \"box-circle-check\": $fa-var-box-circle-check,\n  \"box-dollar\": $fa-var-box-dollar,\n  \"box-usd\": $fa-var-box-usd,\n  \"box-heart\": $fa-var-box-heart,\n  \"box-open\": $fa-var-box-open,\n  \"box-open-full\": $fa-var-box-open-full,\n  \"box-full\": $fa-var-box-full,\n  \"box-taped\": $fa-var-box-taped,\n  \"box-alt\": $fa-var-box-alt,\n  \"box-tissue\": $fa-var-box-tissue,\n  \"boxes-stacked\": $fa-var-boxes-stacked,\n  \"boxes\": $fa-var-boxes,\n  \"boxes-alt\": $fa-var-boxes-alt,\n  \"boxing-glove\": $fa-var-boxing-glove,\n  \"glove-boxing\": $fa-var-glove-boxing,\n  \"bracket-curly\": $fa-var-bracket-curly,\n  \"bracket-curly-left\": $fa-var-bracket-curly-left,\n  \"bracket-curly-right\": $fa-var-bracket-curly-right,\n  \"bracket-round\": $fa-var-bracket-round,\n  \"parenthesis\": $fa-var-parenthesis,\n  \"bracket-round-right\": $fa-var-bracket-round-right,\n  \"bracket-square\": $fa-var-bracket-square,\n  \"bracket\": $fa-var-bracket,\n  \"bracket-left\": $fa-var-bracket-left,\n  \"bracket-square-right\": $fa-var-bracket-square-right,\n  \"brackets-curly\": $fa-var-brackets-curly,\n  \"brackets-round\": $fa-var-brackets-round,\n  \"parentheses\": $fa-var-parentheses,\n  \"brackets-square\": $fa-var-brackets-square,\n  \"brackets\": $fa-var-brackets,\n  \"braille\": $fa-var-braille,\n  \"brain\": $fa-var-brain,\n  \"brain-arrow-curved-right\": $fa-var-brain-arrow-curved-right,\n  \"mind-share\": $fa-var-mind-share,\n  \"brain-circuit\": $fa-var-brain-circuit,\n  \"brake-warning\": $fa-var-brake-warning,\n  \"bread-loaf\": $fa-var-bread-loaf,\n  \"bread-slice\": $fa-var-bread-slice,\n  \"bread-slice-butter\": $fa-var-bread-slice-butter,\n  \"briefcase\": $fa-var-briefcase,\n  \"briefcase-arrow-right\": $fa-var-briefcase-arrow-right,\n  \"briefcase-blank\": $fa-var-briefcase-blank,\n  \"briefcase-medical\": $fa-var-briefcase-medical,\n  \"brightness\": $fa-var-brightness,\n  \"brightness-low\": $fa-var-brightness-low,\n  \"bring-forward\": $fa-var-bring-forward,\n  \"bring-front\": $fa-var-bring-front,\n  \"broccoli\": $fa-var-broccoli,\n  \"broom\": $fa-var-broom,\n  \"browser\": $fa-var-browser,\n  \"browsers\": $fa-var-browsers,\n  \"brush\": $fa-var-brush,\n  \"bug\": $fa-var-bug,\n  \"building\": $fa-var-building,\n  \"buildings\": $fa-var-buildings,\n  \"bullhorn\": $fa-var-bullhorn,\n  \"bullseye\": $fa-var-bullseye,\n  \"bullseye-arrow\": $fa-var-bullseye-arrow,\n  \"bullseye-pointer\": $fa-var-bullseye-pointer,\n  \"burger\": $fa-var-burger,\n  \"hamburger\": $fa-var-hamburger,\n  \"burger-cheese\": $fa-var-burger-cheese,\n  \"cheeseburger\": $fa-var-cheeseburger,\n  \"burger-fries\": $fa-var-burger-fries,\n  \"burger-glass\": $fa-var-burger-glass,\n  \"burger-lettuce\": $fa-var-burger-lettuce,\n  \"burger-soda\": $fa-var-burger-soda,\n  \"burrito\": $fa-var-burrito,\n  \"bus\": $fa-var-bus,\n  \"bus-school\": $fa-var-bus-school,\n  \"bus-simple\": $fa-var-bus-simple,\n  \"bus-alt\": $fa-var-bus-alt,\n  \"business-time\": $fa-var-business-time,\n  \"briefcase-clock\": $fa-var-briefcase-clock,\n  \"butter\": $fa-var-butter,\n  \"c\": $fa-var-c,\n  \"cabinet-filing\": $fa-var-cabinet-filing,\n  \"cable-car\": $fa-var-cable-car,\n  \"cactus\": $fa-var-cactus,\n  \"cake-candles\": $fa-var-cake-candles,\n  \"birthday-cake\": $fa-var-birthday-cake,\n  \"cake-slice\": $fa-var-cake-slice,\n  \"shortcake\": $fa-var-shortcake,\n  \"calculator\": $fa-var-calculator,\n  \"calculator-simple\": $fa-var-calculator-simple,\n  \"calculator-alt\": $fa-var-calculator-alt,\n  \"calendar\": $fa-var-calendar,\n  \"calendar-arrow-down\": $fa-var-calendar-arrow-down,\n  \"calendar-download\": $fa-var-calendar-download,\n  \"calendar-arrow-up\": $fa-var-calendar-arrow-up,\n  \"calendar-upload\": $fa-var-calendar-upload,\n  \"calendar-check\": $fa-var-calendar-check,\n  \"calendar-clock\": $fa-var-calendar-clock,\n  \"calendar-time\": $fa-var-calendar-time,\n  \"calendar-day\": $fa-var-calendar-day,\n  \"calendar-days\": $fa-var-calendar-days,\n  \"calendar-alt\": $fa-var-calendar-alt,\n  \"calendar-exclamation\": $fa-var-calendar-exclamation,\n  \"calendar-heart\": $fa-var-calendar-heart,\n  \"calendar-image\": $fa-var-calendar-image,\n  \"calendar-lines\": $fa-var-calendar-lines,\n  \"calendar-note\": $fa-var-calendar-note,\n  \"calendar-minus\": $fa-var-calendar-minus,\n  \"calendar-pen\": $fa-var-calendar-pen,\n  \"calendar-edit\": $fa-var-calendar-edit,\n  \"calendar-plus\": $fa-var-calendar-plus,\n  \"calendar-range\": $fa-var-calendar-range,\n  \"calendar-star\": $fa-var-calendar-star,\n  \"calendar-week\": $fa-var-calendar-week,\n  \"calendar-xmark\": $fa-var-calendar-xmark,\n  \"calendar-times\": $fa-var-calendar-times,\n  \"calendars\": $fa-var-calendars,\n  \"camcorder\": $fa-var-camcorder,\n  \"video-handheld\": $fa-var-video-handheld,\n  \"camera\": $fa-var-camera,\n  \"camera-alt\": $fa-var-camera-alt,\n  \"camera-cctv\": $fa-var-camera-cctv,\n  \"cctv\": $fa-var-cctv,\n  \"camera-movie\": $fa-var-camera-movie,\n  \"camera-polaroid\": $fa-var-camera-polaroid,\n  \"camera-retro\": $fa-var-camera-retro,\n  \"camera-rotate\": $fa-var-camera-rotate,\n  \"camera-security\": $fa-var-camera-security,\n  \"camera-home\": $fa-var-camera-home,\n  \"camera-slash\": $fa-var-camera-slash,\n  \"camera-viewfinder\": $fa-var-camera-viewfinder,\n  \"camera-web\": $fa-var-camera-web,\n  \"webcam\": $fa-var-webcam,\n  \"camera-web-slash\": $fa-var-camera-web-slash,\n  \"webcam-slash\": $fa-var-webcam-slash,\n  \"campfire\": $fa-var-campfire,\n  \"campground\": $fa-var-campground,\n  \"can-food\": $fa-var-can-food,\n  \"candle-holder\": $fa-var-candle-holder,\n  \"candy\": $fa-var-candy,\n  \"candy-bar\": $fa-var-candy-bar,\n  \"chocolate-bar\": $fa-var-chocolate-bar,\n  \"candy-cane\": $fa-var-candy-cane,\n  \"candy-corn\": $fa-var-candy-corn,\n  \"cannabis\": $fa-var-cannabis,\n  \"capsules\": $fa-var-capsules,\n  \"car\": $fa-var-car,\n  \"automobile\": $fa-var-automobile,\n  \"car-battery\": $fa-var-car-battery,\n  \"battery-car\": $fa-var-battery-car,\n  \"car-bolt\": $fa-var-car-bolt,\n  \"car-building\": $fa-var-car-building,\n  \"car-bump\": $fa-var-car-bump,\n  \"car-bus\": $fa-var-car-bus,\n  \"car-circle-bolt\": $fa-var-car-circle-bolt,\n  \"car-crash\": $fa-var-car-crash,\n  \"car-garage\": $fa-var-car-garage,\n  \"car-mirrors\": $fa-var-car-mirrors,\n  \"car-rear\": $fa-var-car-rear,\n  \"car-alt\": $fa-var-car-alt,\n  \"car-side\": $fa-var-car-side,\n  \"car-side-bolt\": $fa-var-car-side-bolt,\n  \"car-tilt\": $fa-var-car-tilt,\n  \"car-wash\": $fa-var-car-wash,\n  \"car-wrench\": $fa-var-car-wrench,\n  \"car-mechanic\": $fa-var-car-mechanic,\n  \"caravan\": $fa-var-caravan,\n  \"caravan-simple\": $fa-var-caravan-simple,\n  \"caravan-alt\": $fa-var-caravan-alt,\n  \"card-club\": $fa-var-card-club,\n  \"card-diamond\": $fa-var-card-diamond,\n  \"card-heart\": $fa-var-card-heart,\n  \"card-spade\": $fa-var-card-spade,\n  \"cards\": $fa-var-cards,\n  \"caret-down\": $fa-var-caret-down,\n  \"caret-left\": $fa-var-caret-left,\n  \"caret-right\": $fa-var-caret-right,\n  \"caret-up\": $fa-var-caret-up,\n  \"carrot\": $fa-var-carrot,\n  \"cars\": $fa-var-cars,\n  \"cart-arrow-down\": $fa-var-cart-arrow-down,\n  \"cart-arrow-up\": $fa-var-cart-arrow-up,\n  \"cart-circle-arrow-down\": $fa-var-cart-circle-arrow-down,\n  \"cart-circle-arrow-up\": $fa-var-cart-circle-arrow-up,\n  \"cart-circle-check\": $fa-var-cart-circle-check,\n  \"cart-circle-exclamation\": $fa-var-cart-circle-exclamation,\n  \"cart-circle-plus\": $fa-var-cart-circle-plus,\n  \"cart-circle-xmark\": $fa-var-cart-circle-xmark,\n  \"cart-flatbed\": $fa-var-cart-flatbed,\n  \"dolly-flatbed\": $fa-var-dolly-flatbed,\n  \"cart-flatbed-boxes\": $fa-var-cart-flatbed-boxes,\n  \"dolly-flatbed-alt\": $fa-var-dolly-flatbed-alt,\n  \"cart-flatbed-empty\": $fa-var-cart-flatbed-empty,\n  \"dolly-flatbed-empty\": $fa-var-dolly-flatbed-empty,\n  \"cart-flatbed-suitcase\": $fa-var-cart-flatbed-suitcase,\n  \"luggage-cart\": $fa-var-luggage-cart,\n  \"cart-minus\": $fa-var-cart-minus,\n  \"cart-plus\": $fa-var-cart-plus,\n  \"cart-shopping\": $fa-var-cart-shopping,\n  \"shopping-cart\": $fa-var-shopping-cart,\n  \"cart-shopping-fast\": $fa-var-cart-shopping-fast,\n  \"cart-xmark\": $fa-var-cart-xmark,\n  \"cash-register\": $fa-var-cash-register,\n  \"cassette-betamax\": $fa-var-cassette-betamax,\n  \"betamax\": $fa-var-betamax,\n  \"cassette-tape\": $fa-var-cassette-tape,\n  \"cassette-vhs\": $fa-var-cassette-vhs,\n  \"vhs\": $fa-var-vhs,\n  \"castle\": $fa-var-castle,\n  \"cat\": $fa-var-cat,\n  \"cat-space\": $fa-var-cat-space,\n  \"cauldron\": $fa-var-cauldron,\n  \"cedi-sign\": $fa-var-cedi-sign,\n  \"cent-sign\": $fa-var-cent-sign,\n  \"certificate\": $fa-var-certificate,\n  \"chair\": $fa-var-chair,\n  \"chair-office\": $fa-var-chair-office,\n  \"chalkboard\": $fa-var-chalkboard,\n  \"blackboard\": $fa-var-blackboard,\n  \"chalkboard-user\": $fa-var-chalkboard-user,\n  \"chalkboard-teacher\": $fa-var-chalkboard-teacher,\n  \"champagne-glass\": $fa-var-champagne-glass,\n  \"glass-champagne\": $fa-var-glass-champagne,\n  \"champagne-glasses\": $fa-var-champagne-glasses,\n  \"glass-cheers\": $fa-var-glass-cheers,\n  \"charging-station\": $fa-var-charging-station,\n  \"chart-area\": $fa-var-chart-area,\n  \"area-chart\": $fa-var-area-chart,\n  \"chart-bar\": $fa-var-chart-bar,\n  \"bar-chart\": $fa-var-bar-chart,\n  \"chart-bullet\": $fa-var-chart-bullet,\n  \"chart-candlestick\": $fa-var-chart-candlestick,\n  \"chart-column\": $fa-var-chart-column,\n  \"chart-gantt\": $fa-var-chart-gantt,\n  \"chart-line\": $fa-var-chart-line,\n  \"line-chart\": $fa-var-line-chart,\n  \"chart-line-down\": $fa-var-chart-line-down,\n  \"chart-line-up\": $fa-var-chart-line-up,\n  \"chart-mixed\": $fa-var-chart-mixed,\n  \"analytics\": $fa-var-analytics,\n  \"chart-network\": $fa-var-chart-network,\n  \"chart-pie\": $fa-var-chart-pie,\n  \"pie-chart\": $fa-var-pie-chart,\n  \"chart-pie-simple\": $fa-var-chart-pie-simple,\n  \"chart-pie-alt\": $fa-var-chart-pie-alt,\n  \"chart-pyramid\": $fa-var-chart-pyramid,\n  \"chart-radar\": $fa-var-chart-radar,\n  \"chart-scatter\": $fa-var-chart-scatter,\n  \"chart-scatter-3d\": $fa-var-chart-scatter-3d,\n  \"chart-scatter-bubble\": $fa-var-chart-scatter-bubble,\n  \"chart-tree-map\": $fa-var-chart-tree-map,\n  \"chart-user\": $fa-var-chart-user,\n  \"user-chart\": $fa-var-user-chart,\n  \"chart-waterfall\": $fa-var-chart-waterfall,\n  \"check\": $fa-var-check,\n  \"check-double\": $fa-var-check-double,\n  \"check-to-slot\": $fa-var-check-to-slot,\n  \"vote-yea\": $fa-var-vote-yea,\n  \"cheese\": $fa-var-cheese,\n  \"cheese-swiss\": $fa-var-cheese-swiss,\n  \"cherries\": $fa-var-cherries,\n  \"chess\": $fa-var-chess,\n  \"chess-bishop\": $fa-var-chess-bishop,\n  \"chess-bishop-piece\": $fa-var-chess-bishop-piece,\n  \"chess-bishop-alt\": $fa-var-chess-bishop-alt,\n  \"chess-board\": $fa-var-chess-board,\n  \"chess-clock\": $fa-var-chess-clock,\n  \"chess-clock-flip\": $fa-var-chess-clock-flip,\n  \"chess-clock-alt\": $fa-var-chess-clock-alt,\n  \"chess-king\": $fa-var-chess-king,\n  \"chess-king-piece\": $fa-var-chess-king-piece,\n  \"chess-king-alt\": $fa-var-chess-king-alt,\n  \"chess-knight\": $fa-var-chess-knight,\n  \"chess-knight-piece\": $fa-var-chess-knight-piece,\n  \"chess-knight-alt\": $fa-var-chess-knight-alt,\n  \"chess-pawn\": $fa-var-chess-pawn,\n  \"chess-pawn-piece\": $fa-var-chess-pawn-piece,\n  \"chess-pawn-alt\": $fa-var-chess-pawn-alt,\n  \"chess-queen\": $fa-var-chess-queen,\n  \"chess-queen-piece\": $fa-var-chess-queen-piece,\n  \"chess-queen-alt\": $fa-var-chess-queen-alt,\n  \"chess-rook\": $fa-var-chess-rook,\n  \"chess-rook-piece\": $fa-var-chess-rook-piece,\n  \"chess-rook-alt\": $fa-var-chess-rook-alt,\n  \"chestnut\": $fa-var-chestnut,\n  \"chevron-down\": $fa-var-chevron-down,\n  \"chevron-left\": $fa-var-chevron-left,\n  \"chevron-right\": $fa-var-chevron-right,\n  \"chevron-up\": $fa-var-chevron-up,\n  \"chevrons-down\": $fa-var-chevrons-down,\n  \"chevron-double-down\": $fa-var-chevron-double-down,\n  \"chevrons-left\": $fa-var-chevrons-left,\n  \"chevron-double-left\": $fa-var-chevron-double-left,\n  \"chevrons-right\": $fa-var-chevrons-right,\n  \"chevron-double-right\": $fa-var-chevron-double-right,\n  \"chevrons-up\": $fa-var-chevrons-up,\n  \"chevron-double-up\": $fa-var-chevron-double-up,\n  \"child\": $fa-var-child,\n  \"chimney\": $fa-var-chimney,\n  \"chopsticks\": $fa-var-chopsticks,\n  \"church\": $fa-var-church,\n  \"circle\": $fa-var-circle,\n  \"circle-0\": $fa-var-circle-0,\n  \"circle-1\": $fa-var-circle-1,\n  \"circle-2\": $fa-var-circle-2,\n  \"circle-3\": $fa-var-circle-3,\n  \"circle-4\": $fa-var-circle-4,\n  \"circle-5\": $fa-var-circle-5,\n  \"circle-6\": $fa-var-circle-6,\n  \"circle-7\": $fa-var-circle-7,\n  \"circle-8\": $fa-var-circle-8,\n  \"circle-9\": $fa-var-circle-9,\n  \"circle-a\": $fa-var-circle-a,\n  \"circle-ampersand\": $fa-var-circle-ampersand,\n  \"circle-arrow-down\": $fa-var-circle-arrow-down,\n  \"arrow-circle-down\": $fa-var-arrow-circle-down,\n  \"circle-arrow-down-left\": $fa-var-circle-arrow-down-left,\n  \"circle-arrow-down-right\": $fa-var-circle-arrow-down-right,\n  \"circle-arrow-left\": $fa-var-circle-arrow-left,\n  \"arrow-circle-left\": $fa-var-arrow-circle-left,\n  \"circle-arrow-right\": $fa-var-circle-arrow-right,\n  \"arrow-circle-right\": $fa-var-arrow-circle-right,\n  \"circle-arrow-up\": $fa-var-circle-arrow-up,\n  \"arrow-circle-up\": $fa-var-arrow-circle-up,\n  \"circle-arrow-up-left\": $fa-var-circle-arrow-up-left,\n  \"circle-arrow-up-right\": $fa-var-circle-arrow-up-right,\n  \"circle-b\": $fa-var-circle-b,\n  \"circle-bolt\": $fa-var-circle-bolt,\n  \"circle-book-open\": $fa-var-circle-book-open,\n  \"book-circle\": $fa-var-book-circle,\n  \"circle-bookmark\": $fa-var-circle-bookmark,\n  \"bookmark-circle\": $fa-var-bookmark-circle,\n  \"circle-c\": $fa-var-circle-c,\n  \"circle-calendar\": $fa-var-circle-calendar,\n  \"calendar-circle\": $fa-var-calendar-circle,\n  \"circle-camera\": $fa-var-circle-camera,\n  \"camera-circle\": $fa-var-camera-circle,\n  \"circle-caret-down\": $fa-var-circle-caret-down,\n  \"caret-circle-down\": $fa-var-caret-circle-down,\n  \"circle-caret-left\": $fa-var-circle-caret-left,\n  \"caret-circle-left\": $fa-var-caret-circle-left,\n  \"circle-caret-right\": $fa-var-circle-caret-right,\n  \"caret-circle-right\": $fa-var-caret-circle-right,\n  \"circle-caret-up\": $fa-var-circle-caret-up,\n  \"caret-circle-up\": $fa-var-caret-circle-up,\n  \"circle-check\": $fa-var-circle-check,\n  \"check-circle\": $fa-var-check-circle,\n  \"circle-chevron-down\": $fa-var-circle-chevron-down,\n  \"chevron-circle-down\": $fa-var-chevron-circle-down,\n  \"circle-chevron-left\": $fa-var-circle-chevron-left,\n  \"chevron-circle-left\": $fa-var-chevron-circle-left,\n  \"circle-chevron-right\": $fa-var-circle-chevron-right,\n  \"chevron-circle-right\": $fa-var-chevron-circle-right,\n  \"circle-chevron-up\": $fa-var-circle-chevron-up,\n  \"chevron-circle-up\": $fa-var-chevron-circle-up,\n  \"circle-d\": $fa-var-circle-d,\n  \"circle-dashed\": $fa-var-circle-dashed,\n  \"circle-divide\": $fa-var-circle-divide,\n  \"circle-dollar\": $fa-var-circle-dollar,\n  \"dollar-circle\": $fa-var-dollar-circle,\n  \"usd-circle\": $fa-var-usd-circle,\n  \"circle-dollar-to-slot\": $fa-var-circle-dollar-to-slot,\n  \"donate\": $fa-var-donate,\n  \"circle-dot\": $fa-var-circle-dot,\n  \"dot-circle\": $fa-var-dot-circle,\n  \"circle-down\": $fa-var-circle-down,\n  \"arrow-alt-circle-down\": $fa-var-arrow-alt-circle-down,\n  \"circle-down-left\": $fa-var-circle-down-left,\n  \"circle-down-right\": $fa-var-circle-down-right,\n  \"circle-e\": $fa-var-circle-e,\n  \"circle-ellipsis\": $fa-var-circle-ellipsis,\n  \"circle-ellipsis-vertical\": $fa-var-circle-ellipsis-vertical,\n  \"circle-envelope\": $fa-var-circle-envelope,\n  \"envelope-circle\": $fa-var-envelope-circle,\n  \"circle-exclamation\": $fa-var-circle-exclamation,\n  \"exclamation-circle\": $fa-var-exclamation-circle,\n  \"circle-exclamation-check\": $fa-var-circle-exclamation-check,\n  \"circle-f\": $fa-var-circle-f,\n  \"circle-g\": $fa-var-circle-g,\n  \"circle-h\": $fa-var-circle-h,\n  \"hospital-symbol\": $fa-var-hospital-symbol,\n  \"circle-half\": $fa-var-circle-half,\n  \"circle-half-stroke\": $fa-var-circle-half-stroke,\n  \"adjust\": $fa-var-adjust,\n  \"circle-heart\": $fa-var-circle-heart,\n  \"heart-circle\": $fa-var-heart-circle,\n  \"circle-i\": $fa-var-circle-i,\n  \"circle-info\": $fa-var-circle-info,\n  \"info-circle\": $fa-var-info-circle,\n  \"circle-j\": $fa-var-circle-j,\n  \"circle-k\": $fa-var-circle-k,\n  \"circle-l\": $fa-var-circle-l,\n  \"circle-left\": $fa-var-circle-left,\n  \"arrow-alt-circle-left\": $fa-var-arrow-alt-circle-left,\n  \"circle-location-arrow\": $fa-var-circle-location-arrow,\n  \"location-circle\": $fa-var-location-circle,\n  \"circle-m\": $fa-var-circle-m,\n  \"circle-microphone\": $fa-var-circle-microphone,\n  \"microphone-circle\": $fa-var-microphone-circle,\n  \"circle-microphone-lines\": $fa-var-circle-microphone-lines,\n  \"microphone-circle-alt\": $fa-var-microphone-circle-alt,\n  \"circle-minus\": $fa-var-circle-minus,\n  \"minus-circle\": $fa-var-minus-circle,\n  \"circle-n\": $fa-var-circle-n,\n  \"circle-notch\": $fa-var-circle-notch,\n  \"circle-o\": $fa-var-circle-o,\n  \"circle-p\": $fa-var-circle-p,\n  \"circle-parking\": $fa-var-circle-parking,\n  \"parking-circle\": $fa-var-parking-circle,\n  \"circle-pause\": $fa-var-circle-pause,\n  \"pause-circle\": $fa-var-pause-circle,\n  \"circle-phone\": $fa-var-circle-phone,\n  \"phone-circle\": $fa-var-phone-circle,\n  \"circle-phone-flip\": $fa-var-circle-phone-flip,\n  \"phone-circle-alt\": $fa-var-phone-circle-alt,\n  \"circle-phone-hangup\": $fa-var-circle-phone-hangup,\n  \"phone-circle-down\": $fa-var-phone-circle-down,\n  \"circle-play\": $fa-var-circle-play,\n  \"play-circle\": $fa-var-play-circle,\n  \"circle-plus\": $fa-var-circle-plus,\n  \"plus-circle\": $fa-var-plus-circle,\n  \"circle-q\": $fa-var-circle-q,\n  \"circle-quarter\": $fa-var-circle-quarter,\n  \"circle-quarters\": $fa-var-circle-quarters,\n  \"circle-question\": $fa-var-circle-question,\n  \"question-circle\": $fa-var-question-circle,\n  \"circle-r\": $fa-var-circle-r,\n  \"circle-radiation\": $fa-var-circle-radiation,\n  \"radiation-alt\": $fa-var-radiation-alt,\n  \"circle-right\": $fa-var-circle-right,\n  \"arrow-alt-circle-right\": $fa-var-arrow-alt-circle-right,\n  \"circle-s\": $fa-var-circle-s,\n  \"circle-small\": $fa-var-circle-small,\n  \"circle-sort\": $fa-var-circle-sort,\n  \"sort-circle\": $fa-var-sort-circle,\n  \"circle-sort-down\": $fa-var-circle-sort-down,\n  \"sort-circle-down\": $fa-var-sort-circle-down,\n  \"circle-sort-up\": $fa-var-circle-sort-up,\n  \"sort-circle-up\": $fa-var-sort-circle-up,\n  \"circle-star\": $fa-var-circle-star,\n  \"star-circle\": $fa-var-star-circle,\n  \"circle-stop\": $fa-var-circle-stop,\n  \"stop-circle\": $fa-var-stop-circle,\n  \"circle-t\": $fa-var-circle-t,\n  \"circle-three-quarters\": $fa-var-circle-three-quarters,\n  \"circle-trash\": $fa-var-circle-trash,\n  \"trash-circle\": $fa-var-trash-circle,\n  \"circle-u\": $fa-var-circle-u,\n  \"circle-up\": $fa-var-circle-up,\n  \"arrow-alt-circle-up\": $fa-var-arrow-alt-circle-up,\n  \"circle-up-left\": $fa-var-circle-up-left,\n  \"circle-up-right\": $fa-var-circle-up-right,\n  \"circle-user\": $fa-var-circle-user,\n  \"user-circle\": $fa-var-user-circle,\n  \"circle-v\": $fa-var-circle-v,\n  \"circle-video\": $fa-var-circle-video,\n  \"video-circle\": $fa-var-video-circle,\n  \"circle-w\": $fa-var-circle-w,\n  \"circle-waveform-lines\": $fa-var-circle-waveform-lines,\n  \"waveform-circle\": $fa-var-waveform-circle,\n  \"circle-x\": $fa-var-circle-x,\n  \"circle-xmark\": $fa-var-circle-xmark,\n  \"times-circle\": $fa-var-times-circle,\n  \"xmark-circle\": $fa-var-xmark-circle,\n  \"circle-y\": $fa-var-circle-y,\n  \"circle-z\": $fa-var-circle-z,\n  \"citrus\": $fa-var-citrus,\n  \"citrus-slice\": $fa-var-citrus-slice,\n  \"city\": $fa-var-city,\n  \"clapperboard\": $fa-var-clapperboard,\n  \"clapperboard-play\": $fa-var-clapperboard-play,\n  \"clarinet\": $fa-var-clarinet,\n  \"claw-marks\": $fa-var-claw-marks,\n  \"clipboard\": $fa-var-clipboard,\n  \"clipboard-check\": $fa-var-clipboard-check,\n  \"clipboard-list\": $fa-var-clipboard-list,\n  \"clipboard-list-check\": $fa-var-clipboard-list-check,\n  \"clipboard-medical\": $fa-var-clipboard-medical,\n  \"clipboard-prescription\": $fa-var-clipboard-prescription,\n  \"clipboard-user\": $fa-var-clipboard-user,\n  \"clock\": $fa-var-clock,\n  \"clock-four\": $fa-var-clock-four,\n  \"clock-desk\": $fa-var-clock-desk,\n  \"clock-eight\": $fa-var-clock-eight,\n  \"clock-eight-thirty\": $fa-var-clock-eight-thirty,\n  \"clock-eleven\": $fa-var-clock-eleven,\n  \"clock-eleven-thirty\": $fa-var-clock-eleven-thirty,\n  \"clock-five\": $fa-var-clock-five,\n  \"clock-five-thirty\": $fa-var-clock-five-thirty,\n  \"clock-four-thirty\": $fa-var-clock-four-thirty,\n  \"clock-nine\": $fa-var-clock-nine,\n  \"clock-nine-thirty\": $fa-var-clock-nine-thirty,\n  \"clock-one\": $fa-var-clock-one,\n  \"clock-one-thirty\": $fa-var-clock-one-thirty,\n  \"clock-rotate-left\": $fa-var-clock-rotate-left,\n  \"history\": $fa-var-history,\n  \"clock-seven\": $fa-var-clock-seven,\n  \"clock-seven-thirty\": $fa-var-clock-seven-thirty,\n  \"clock-six\": $fa-var-clock-six,\n  \"clock-six-thirty\": $fa-var-clock-six-thirty,\n  \"clock-ten\": $fa-var-clock-ten,\n  \"clock-ten-thirty\": $fa-var-clock-ten-thirty,\n  \"clock-three\": $fa-var-clock-three,\n  \"clock-three-thirty\": $fa-var-clock-three-thirty,\n  \"clock-twelve\": $fa-var-clock-twelve,\n  \"clock-twelve-thirty\": $fa-var-clock-twelve-thirty,\n  \"clock-two\": $fa-var-clock-two,\n  \"clock-two-thirty\": $fa-var-clock-two-thirty,\n  \"clone\": $fa-var-clone,\n  \"closed-captioning\": $fa-var-closed-captioning,\n  \"closed-captioning-slash\": $fa-var-closed-captioning-slash,\n  \"clothes-hanger\": $fa-var-clothes-hanger,\n  \"cloud\": $fa-var-cloud,\n  \"cloud-arrow-down\": $fa-var-cloud-arrow-down,\n  \"cloud-download\": $fa-var-cloud-download,\n  \"cloud-download-alt\": $fa-var-cloud-download-alt,\n  \"cloud-arrow-up\": $fa-var-cloud-arrow-up,\n  \"cloud-upload\": $fa-var-cloud-upload,\n  \"cloud-upload-alt\": $fa-var-cloud-upload-alt,\n  \"cloud-bolt\": $fa-var-cloud-bolt,\n  \"thunderstorm\": $fa-var-thunderstorm,\n  \"cloud-bolt-moon\": $fa-var-cloud-bolt-moon,\n  \"thunderstorm-moon\": $fa-var-thunderstorm-moon,\n  \"cloud-bolt-sun\": $fa-var-cloud-bolt-sun,\n  \"thunderstorm-sun\": $fa-var-thunderstorm-sun,\n  \"cloud-check\": $fa-var-cloud-check,\n  \"cloud-drizzle\": $fa-var-cloud-drizzle,\n  \"cloud-fog\": $fa-var-cloud-fog,\n  \"fog\": $fa-var-fog,\n  \"cloud-hail\": $fa-var-cloud-hail,\n  \"cloud-hail-mixed\": $fa-var-cloud-hail-mixed,\n  \"cloud-meatball\": $fa-var-cloud-meatball,\n  \"cloud-minus\": $fa-var-cloud-minus,\n  \"cloud-moon\": $fa-var-cloud-moon,\n  \"cloud-moon-rain\": $fa-var-cloud-moon-rain,\n  \"cloud-music\": $fa-var-cloud-music,\n  \"cloud-plus\": $fa-var-cloud-plus,\n  \"cloud-rain\": $fa-var-cloud-rain,\n  \"cloud-rainbow\": $fa-var-cloud-rainbow,\n  \"cloud-showers\": $fa-var-cloud-showers,\n  \"cloud-showers-heavy\": $fa-var-cloud-showers-heavy,\n  \"cloud-slash\": $fa-var-cloud-slash,\n  \"cloud-sleet\": $fa-var-cloud-sleet,\n  \"cloud-snow\": $fa-var-cloud-snow,\n  \"cloud-sun\": $fa-var-cloud-sun,\n  \"cloud-sun-rain\": $fa-var-cloud-sun-rain,\n  \"cloud-word\": $fa-var-cloud-word,\n  \"cloud-xmark\": $fa-var-cloud-xmark,\n  \"clouds\": $fa-var-clouds,\n  \"clouds-moon\": $fa-var-clouds-moon,\n  \"clouds-sun\": $fa-var-clouds-sun,\n  \"clover\": $fa-var-clover,\n  \"club\": $fa-var-club,\n  \"coconut\": $fa-var-coconut,\n  \"code\": $fa-var-code,\n  \"code-branch\": $fa-var-code-branch,\n  \"code-commit\": $fa-var-code-commit,\n  \"code-compare\": $fa-var-code-compare,\n  \"code-fork\": $fa-var-code-fork,\n  \"code-merge\": $fa-var-code-merge,\n  \"code-pull-request\": $fa-var-code-pull-request,\n  \"code-pull-request-closed\": $fa-var-code-pull-request-closed,\n  \"code-pull-request-draft\": $fa-var-code-pull-request-draft,\n  \"code-simple\": $fa-var-code-simple,\n  \"coffee-bean\": $fa-var-coffee-bean,\n  \"coffee-beans\": $fa-var-coffee-beans,\n  \"coffee-pot\": $fa-var-coffee-pot,\n  \"coffin\": $fa-var-coffin,\n  \"coffin-cross\": $fa-var-coffin-cross,\n  \"coin\": $fa-var-coin,\n  \"coin-blank\": $fa-var-coin-blank,\n  \"coin-front\": $fa-var-coin-front,\n  \"coin-vertical\": $fa-var-coin-vertical,\n  \"coins\": $fa-var-coins,\n  \"colon\": $fa-var-colon,\n  \"colon-sign\": $fa-var-colon-sign,\n  \"columns-3\": $fa-var-columns-3,\n  \"comet\": $fa-var-comet,\n  \"comma\": $fa-var-comma,\n  \"command\": $fa-var-command,\n  \"comment\": $fa-var-comment,\n  \"comment-arrow-down\": $fa-var-comment-arrow-down,\n  \"comment-arrow-up\": $fa-var-comment-arrow-up,\n  \"comment-arrow-up-right\": $fa-var-comment-arrow-up-right,\n  \"comment-captions\": $fa-var-comment-captions,\n  \"comment-check\": $fa-var-comment-check,\n  \"comment-code\": $fa-var-comment-code,\n  \"comment-dollar\": $fa-var-comment-dollar,\n  \"comment-dots\": $fa-var-comment-dots,\n  \"commenting\": $fa-var-commenting,\n  \"comment-exclamation\": $fa-var-comment-exclamation,\n  \"comment-image\": $fa-var-comment-image,\n  \"comment-lines\": $fa-var-comment-lines,\n  \"comment-medical\": $fa-var-comment-medical,\n  \"comment-middle\": $fa-var-comment-middle,\n  \"comment-middle-top\": $fa-var-comment-middle-top,\n  \"comment-minus\": $fa-var-comment-minus,\n  \"comment-music\": $fa-var-comment-music,\n  \"comment-pen\": $fa-var-comment-pen,\n  \"comment-edit\": $fa-var-comment-edit,\n  \"comment-plus\": $fa-var-comment-plus,\n  \"comment-question\": $fa-var-comment-question,\n  \"comment-quote\": $fa-var-comment-quote,\n  \"comment-slash\": $fa-var-comment-slash,\n  \"comment-smile\": $fa-var-comment-smile,\n  \"comment-sms\": $fa-var-comment-sms,\n  \"sms\": $fa-var-sms,\n  \"comment-text\": $fa-var-comment-text,\n  \"comment-xmark\": $fa-var-comment-xmark,\n  \"comment-times\": $fa-var-comment-times,\n  \"comments\": $fa-var-comments,\n  \"comments-dollar\": $fa-var-comments-dollar,\n  \"comments-question\": $fa-var-comments-question,\n  \"comments-question-check\": $fa-var-comments-question-check,\n  \"compact-disc\": $fa-var-compact-disc,\n  \"compass\": $fa-var-compass,\n  \"compass-drafting\": $fa-var-compass-drafting,\n  \"drafting-compass\": $fa-var-drafting-compass,\n  \"compass-slash\": $fa-var-compass-slash,\n  \"compress\": $fa-var-compress,\n  \"compress-wide\": $fa-var-compress-wide,\n  \"computer-classic\": $fa-var-computer-classic,\n  \"computer-mouse\": $fa-var-computer-mouse,\n  \"mouse\": $fa-var-mouse,\n  \"computer-mouse-scrollwheel\": $fa-var-computer-mouse-scrollwheel,\n  \"mouse-alt\": $fa-var-mouse-alt,\n  \"computer-speaker\": $fa-var-computer-speaker,\n  \"container-storage\": $fa-var-container-storage,\n  \"conveyor-belt\": $fa-var-conveyor-belt,\n  \"conveyor-belt-boxes\": $fa-var-conveyor-belt-boxes,\n  \"conveyor-belt-alt\": $fa-var-conveyor-belt-alt,\n  \"conveyor-belt-empty\": $fa-var-conveyor-belt-empty,\n  \"cookie\": $fa-var-cookie,\n  \"cookie-bite\": $fa-var-cookie-bite,\n  \"copy\": $fa-var-copy,\n  \"copyright\": $fa-var-copyright,\n  \"corn\": $fa-var-corn,\n  \"corner\": $fa-var-corner,\n  \"couch\": $fa-var-couch,\n  \"cow\": $fa-var-cow,\n  \"cowbell\": $fa-var-cowbell,\n  \"cowbell-circle-plus\": $fa-var-cowbell-circle-plus,\n  \"cowbell-more\": $fa-var-cowbell-more,\n  \"crab\": $fa-var-crab,\n  \"crate-apple\": $fa-var-crate-apple,\n  \"apple-crate\": $fa-var-apple-crate,\n  \"crate-empty\": $fa-var-crate-empty,\n  \"credit-card\": $fa-var-credit-card,\n  \"credit-card-alt\": $fa-var-credit-card-alt,\n  \"credit-card-blank\": $fa-var-credit-card-blank,\n  \"credit-card-front\": $fa-var-credit-card-front,\n  \"creemee\": $fa-var-creemee,\n  \"soft-serve\": $fa-var-soft-serve,\n  \"cricket-bat-ball\": $fa-var-cricket-bat-ball,\n  \"cricket\": $fa-var-cricket,\n  \"croissant\": $fa-var-croissant,\n  \"crop\": $fa-var-crop,\n  \"crop-simple\": $fa-var-crop-simple,\n  \"crop-alt\": $fa-var-crop-alt,\n  \"cross\": $fa-var-cross,\n  \"crosshairs\": $fa-var-crosshairs,\n  \"crow\": $fa-var-crow,\n  \"crown\": $fa-var-crown,\n  \"crutch\": $fa-var-crutch,\n  \"crutches\": $fa-var-crutches,\n  \"cruzeiro-sign\": $fa-var-cruzeiro-sign,\n  \"crystal-ball\": $fa-var-crystal-ball,\n  \"cube\": $fa-var-cube,\n  \"cubes\": $fa-var-cubes,\n  \"cucumber\": $fa-var-cucumber,\n  \"cup-straw\": $fa-var-cup-straw,\n  \"cup-straw-swoosh\": $fa-var-cup-straw-swoosh,\n  \"cup-togo\": $fa-var-cup-togo,\n  \"coffee-togo\": $fa-var-coffee-togo,\n  \"cupcake\": $fa-var-cupcake,\n  \"curling-stone\": $fa-var-curling-stone,\n  \"curling\": $fa-var-curling,\n  \"custard\": $fa-var-custard,\n  \"d\": $fa-var-d,\n  \"dagger\": $fa-var-dagger,\n  \"dash\": $fa-var-dash,\n  \"database\": $fa-var-database,\n  \"deer\": $fa-var-deer,\n  \"deer-rudolph\": $fa-var-deer-rudolph,\n  \"delete-left\": $fa-var-delete-left,\n  \"backspace\": $fa-var-backspace,\n  \"delete-right\": $fa-var-delete-right,\n  \"democrat\": $fa-var-democrat,\n  \"desktop\": $fa-var-desktop,\n  \"desktop-alt\": $fa-var-desktop-alt,\n  \"desktop-arrow-down\": $fa-var-desktop-arrow-down,\n  \"dharmachakra\": $fa-var-dharmachakra,\n  \"diagram-lean-canvas\": $fa-var-diagram-lean-canvas,\n  \"diagram-nested\": $fa-var-diagram-nested,\n  \"diagram-project\": $fa-var-diagram-project,\n  \"project-diagram\": $fa-var-project-diagram,\n  \"diagram-sankey\": $fa-var-diagram-sankey,\n  \"diagram-venn\": $fa-var-diagram-venn,\n  \"dial\": $fa-var-dial,\n  \"dial-med-high\": $fa-var-dial-med-high,\n  \"dial-high\": $fa-var-dial-high,\n  \"dial-low\": $fa-var-dial-low,\n  \"dial-max\": $fa-var-dial-max,\n  \"dial-med\": $fa-var-dial-med,\n  \"dial-med-low\": $fa-var-dial-med-low,\n  \"dial-min\": $fa-var-dial-min,\n  \"dial-off\": $fa-var-dial-off,\n  \"diamond\": $fa-var-diamond,\n  \"diamond-exclamation\": $fa-var-diamond-exclamation,\n  \"diamond-turn-right\": $fa-var-diamond-turn-right,\n  \"directions\": $fa-var-directions,\n  \"dice\": $fa-var-dice,\n  \"dice-d10\": $fa-var-dice-d10,\n  \"dice-d12\": $fa-var-dice-d12,\n  \"dice-d20\": $fa-var-dice-d20,\n  \"dice-d4\": $fa-var-dice-d4,\n  \"dice-d6\": $fa-var-dice-d6,\n  \"dice-d8\": $fa-var-dice-d8,\n  \"dice-five\": $fa-var-dice-five,\n  \"dice-four\": $fa-var-dice-four,\n  \"dice-one\": $fa-var-dice-one,\n  \"dice-six\": $fa-var-dice-six,\n  \"dice-three\": $fa-var-dice-three,\n  \"dice-two\": $fa-var-dice-two,\n  \"diploma\": $fa-var-diploma,\n  \"scroll-ribbon\": $fa-var-scroll-ribbon,\n  \"disc-drive\": $fa-var-disc-drive,\n  \"disease\": $fa-var-disease,\n  \"display\": $fa-var-display,\n  \"display-arrow-down\": $fa-var-display-arrow-down,\n  \"display-code\": $fa-var-display-code,\n  \"desktop-code\": $fa-var-desktop-code,\n  \"display-medical\": $fa-var-display-medical,\n  \"desktop-medical\": $fa-var-desktop-medical,\n  \"display-slash\": $fa-var-display-slash,\n  \"desktop-slash\": $fa-var-desktop-slash,\n  \"distribute-spacing-horizontal\": $fa-var-distribute-spacing-horizontal,\n  \"distribute-spacing-vertical\": $fa-var-distribute-spacing-vertical,\n  \"ditto\": $fa-var-ditto,\n  \"divide\": $fa-var-divide,\n  \"dna\": $fa-var-dna,\n  \"do-not-enter\": $fa-var-do-not-enter,\n  \"dog\": $fa-var-dog,\n  \"dog-leashed\": $fa-var-dog-leashed,\n  \"dollar-sign\": $fa-var-dollar-sign,\n  \"dollar\": $fa-var-dollar,\n  \"usd\": $fa-var-usd,\n  \"dolly\": $fa-var-dolly,\n  \"dolly-box\": $fa-var-dolly-box,\n  \"dolly-empty\": $fa-var-dolly-empty,\n  \"dolphin\": $fa-var-dolphin,\n  \"dong-sign\": $fa-var-dong-sign,\n  \"donut\": $fa-var-donut,\n  \"doughnut\": $fa-var-doughnut,\n  \"door-closed\": $fa-var-door-closed,\n  \"door-open\": $fa-var-door-open,\n  \"dove\": $fa-var-dove,\n  \"down\": $fa-var-down,\n  \"arrow-alt-down\": $fa-var-arrow-alt-down,\n  \"down-from-dotted-line\": $fa-var-down-from-dotted-line,\n  \"down-from-line\": $fa-var-down-from-line,\n  \"arrow-alt-from-top\": $fa-var-arrow-alt-from-top,\n  \"down-left\": $fa-var-down-left,\n  \"down-left-and-up-right-to-center\": $fa-var-down-left-and-up-right-to-center,\n  \"compress-alt\": $fa-var-compress-alt,\n  \"down-long\": $fa-var-down-long,\n  \"long-arrow-alt-down\": $fa-var-long-arrow-alt-down,\n  \"down-right\": $fa-var-down-right,\n  \"down-to-dotted-line\": $fa-var-down-to-dotted-line,\n  \"down-to-line\": $fa-var-down-to-line,\n  \"arrow-alt-to-bottom\": $fa-var-arrow-alt-to-bottom,\n  \"download\": $fa-var-download,\n  \"dragon\": $fa-var-dragon,\n  \"draw-circle\": $fa-var-draw-circle,\n  \"draw-polygon\": $fa-var-draw-polygon,\n  \"draw-square\": $fa-var-draw-square,\n  \"dreidel\": $fa-var-dreidel,\n  \"drone\": $fa-var-drone,\n  \"drone-front\": $fa-var-drone-front,\n  \"drone-alt\": $fa-var-drone-alt,\n  \"droplet\": $fa-var-droplet,\n  \"tint\": $fa-var-tint,\n  \"droplet-degree\": $fa-var-droplet-degree,\n  \"dewpoint\": $fa-var-dewpoint,\n  \"droplet-percent\": $fa-var-droplet-percent,\n  \"humidity\": $fa-var-humidity,\n  \"droplet-slash\": $fa-var-droplet-slash,\n  \"tint-slash\": $fa-var-tint-slash,\n  \"drum\": $fa-var-drum,\n  \"drum-steelpan\": $fa-var-drum-steelpan,\n  \"drumstick\": $fa-var-drumstick,\n  \"drumstick-bite\": $fa-var-drumstick-bite,\n  \"dryer\": $fa-var-dryer,\n  \"dryer-heat\": $fa-var-dryer-heat,\n  \"dryer-alt\": $fa-var-dryer-alt,\n  \"duck\": $fa-var-duck,\n  \"dumbbell\": $fa-var-dumbbell,\n  \"dumpster\": $fa-var-dumpster,\n  \"dumpster-fire\": $fa-var-dumpster-fire,\n  \"dungeon\": $fa-var-dungeon,\n  \"e\": $fa-var-e,\n  \"ear\": $fa-var-ear,\n  \"ear-deaf\": $fa-var-ear-deaf,\n  \"deaf\": $fa-var-deaf,\n  \"deafness\": $fa-var-deafness,\n  \"hard-of-hearing\": $fa-var-hard-of-hearing,\n  \"ear-listen\": $fa-var-ear-listen,\n  \"assistive-listening-systems\": $fa-var-assistive-listening-systems,\n  \"ear-muffs\": $fa-var-ear-muffs,\n  \"earth-africa\": $fa-var-earth-africa,\n  \"globe-africa\": $fa-var-globe-africa,\n  \"earth-americas\": $fa-var-earth-americas,\n  \"earth\": $fa-var-earth,\n  \"globe-americas\": $fa-var-globe-americas,\n  \"earth-asia\": $fa-var-earth-asia,\n  \"globe-asia\": $fa-var-globe-asia,\n  \"earth-europa\": $fa-var-earth-europa,\n  \"globe-europe\": $fa-var-globe-europe,\n  \"eclipse\": $fa-var-eclipse,\n  \"egg\": $fa-var-egg,\n  \"egg-fried\": $fa-var-egg-fried,\n  \"eggplant\": $fa-var-eggplant,\n  \"eject\": $fa-var-eject,\n  \"elephant\": $fa-var-elephant,\n  \"elevator\": $fa-var-elevator,\n  \"ellipsis\": $fa-var-ellipsis,\n  \"ellipsis-h\": $fa-var-ellipsis-h,\n  \"ellipsis-stroke\": $fa-var-ellipsis-stroke,\n  \"ellipsis-h-alt\": $fa-var-ellipsis-h-alt,\n  \"ellipsis-stroke-vertical\": $fa-var-ellipsis-stroke-vertical,\n  \"ellipsis-v-alt\": $fa-var-ellipsis-v-alt,\n  \"ellipsis-vertical\": $fa-var-ellipsis-vertical,\n  \"ellipsis-v\": $fa-var-ellipsis-v,\n  \"empty-set\": $fa-var-empty-set,\n  \"engine\": $fa-var-engine,\n  \"engine-warning\": $fa-var-engine-warning,\n  \"engine-exclamation\": $fa-var-engine-exclamation,\n  \"envelope\": $fa-var-envelope,\n  \"envelope-dot\": $fa-var-envelope-dot,\n  \"envelope-badge\": $fa-var-envelope-badge,\n  \"envelope-open\": $fa-var-envelope-open,\n  \"envelope-open-dollar\": $fa-var-envelope-open-dollar,\n  \"envelope-open-text\": $fa-var-envelope-open-text,\n  \"envelopes\": $fa-var-envelopes,\n  \"envelopes-bulk\": $fa-var-envelopes-bulk,\n  \"mail-bulk\": $fa-var-mail-bulk,\n  \"equals\": $fa-var-equals,\n  \"eraser\": $fa-var-eraser,\n  \"escalator\": $fa-var-escalator,\n  \"ethernet\": $fa-var-ethernet,\n  \"euro-sign\": $fa-var-euro-sign,\n  \"eur\": $fa-var-eur,\n  \"euro\": $fa-var-euro,\n  \"exclamation\": $fa-var-exclamation,\n  \"expand\": $fa-var-expand,\n  \"expand-wide\": $fa-var-expand-wide,\n  \"eye\": $fa-var-eye,\n  \"eye-dropper\": $fa-var-eye-dropper,\n  \"eye-dropper-empty\": $fa-var-eye-dropper-empty,\n  \"eyedropper\": $fa-var-eyedropper,\n  \"eye-dropper-full\": $fa-var-eye-dropper-full,\n  \"eye-dropper-half\": $fa-var-eye-dropper-half,\n  \"eye-evil\": $fa-var-eye-evil,\n  \"eye-low-vision\": $fa-var-eye-low-vision,\n  \"low-vision\": $fa-var-low-vision,\n  \"eye-slash\": $fa-var-eye-slash,\n  \"eyes\": $fa-var-eyes,\n  \"f\": $fa-var-f,\n  \"face-angry\": $fa-var-face-angry,\n  \"angry\": $fa-var-angry,\n  \"face-angry-horns\": $fa-var-face-angry-horns,\n  \"face-anguished\": $fa-var-face-anguished,\n  \"face-anxious-sweat\": $fa-var-face-anxious-sweat,\n  \"face-astonished\": $fa-var-face-astonished,\n  \"face-awesome\": $fa-var-face-awesome,\n  \"gave-dandy\": $fa-var-gave-dandy,\n  \"face-confounded\": $fa-var-face-confounded,\n  \"face-confused\": $fa-var-face-confused,\n  \"face-cowboy-hat\": $fa-var-face-cowboy-hat,\n  \"face-disappointed\": $fa-var-face-disappointed,\n  \"face-disguise\": $fa-var-face-disguise,\n  \"face-dizzy\": $fa-var-face-dizzy,\n  \"dizzy\": $fa-var-dizzy,\n  \"face-downcast-sweat\": $fa-var-face-downcast-sweat,\n  \"face-drooling\": $fa-var-face-drooling,\n  \"face-explode\": $fa-var-face-explode,\n  \"exploding-head\": $fa-var-exploding-head,\n  \"face-expressionless\": $fa-var-face-expressionless,\n  \"face-eyes-xmarks\": $fa-var-face-eyes-xmarks,\n  \"face-fearful\": $fa-var-face-fearful,\n  \"face-flushed\": $fa-var-face-flushed,\n  \"flushed\": $fa-var-flushed,\n  \"face-frown\": $fa-var-face-frown,\n  \"frown\": $fa-var-frown,\n  \"face-frown-open\": $fa-var-face-frown-open,\n  \"frown-open\": $fa-var-frown-open,\n  \"face-frown-slight\": $fa-var-face-frown-slight,\n  \"face-glasses\": $fa-var-face-glasses,\n  \"face-grimace\": $fa-var-face-grimace,\n  \"grimace\": $fa-var-grimace,\n  \"face-grin\": $fa-var-face-grin,\n  \"grin\": $fa-var-grin,\n  \"face-grin-beam\": $fa-var-face-grin-beam,\n  \"grin-beam\": $fa-var-grin-beam,\n  \"face-grin-beam-sweat\": $fa-var-face-grin-beam-sweat,\n  \"grin-beam-sweat\": $fa-var-grin-beam-sweat,\n  \"face-grin-hearts\": $fa-var-face-grin-hearts,\n  \"grin-hearts\": $fa-var-grin-hearts,\n  \"face-grin-squint\": $fa-var-face-grin-squint,\n  \"grin-squint\": $fa-var-grin-squint,\n  \"face-grin-squint-tears\": $fa-var-face-grin-squint-tears,\n  \"grin-squint-tears\": $fa-var-grin-squint-tears,\n  \"face-grin-stars\": $fa-var-face-grin-stars,\n  \"grin-stars\": $fa-var-grin-stars,\n  \"face-grin-tears\": $fa-var-face-grin-tears,\n  \"grin-tears\": $fa-var-grin-tears,\n  \"face-grin-tongue\": $fa-var-face-grin-tongue,\n  \"grin-tongue\": $fa-var-grin-tongue,\n  \"face-grin-tongue-squint\": $fa-var-face-grin-tongue-squint,\n  \"grin-tongue-squint\": $fa-var-grin-tongue-squint,\n  \"face-grin-tongue-wink\": $fa-var-face-grin-tongue-wink,\n  \"grin-tongue-wink\": $fa-var-grin-tongue-wink,\n  \"face-grin-wide\": $fa-var-face-grin-wide,\n  \"grin-alt\": $fa-var-grin-alt,\n  \"face-grin-wink\": $fa-var-face-grin-wink,\n  \"grin-wink\": $fa-var-grin-wink,\n  \"face-hand-over-mouth\": $fa-var-face-hand-over-mouth,\n  \"face-hand-yawn\": $fa-var-face-hand-yawn,\n  \"face-head-bandage\": $fa-var-face-head-bandage,\n  \"face-hushed\": $fa-var-face-hushed,\n  \"face-icicles\": $fa-var-face-icicles,\n  \"face-kiss\": $fa-var-face-kiss,\n  \"kiss\": $fa-var-kiss,\n  \"face-kiss-beam\": $fa-var-face-kiss-beam,\n  \"kiss-beam\": $fa-var-kiss-beam,\n  \"face-kiss-closed-eyes\": $fa-var-face-kiss-closed-eyes,\n  \"face-kiss-wink-heart\": $fa-var-face-kiss-wink-heart,\n  \"kiss-wink-heart\": $fa-var-kiss-wink-heart,\n  \"face-laugh\": $fa-var-face-laugh,\n  \"laugh\": $fa-var-laugh,\n  \"face-laugh-beam\": $fa-var-face-laugh-beam,\n  \"laugh-beam\": $fa-var-laugh-beam,\n  \"face-laugh-squint\": $fa-var-face-laugh-squint,\n  \"laugh-squint\": $fa-var-laugh-squint,\n  \"face-laugh-wink\": $fa-var-face-laugh-wink,\n  \"laugh-wink\": $fa-var-laugh-wink,\n  \"face-lying\": $fa-var-face-lying,\n  \"face-mask\": $fa-var-face-mask,\n  \"face-meh\": $fa-var-face-meh,\n  \"meh\": $fa-var-meh,\n  \"face-meh-blank\": $fa-var-face-meh-blank,\n  \"meh-blank\": $fa-var-meh-blank,\n  \"face-monocle\": $fa-var-face-monocle,\n  \"face-nauseated\": $fa-var-face-nauseated,\n  \"face-nose-steam\": $fa-var-face-nose-steam,\n  \"face-party\": $fa-var-face-party,\n  \"face-pensive\": $fa-var-face-pensive,\n  \"face-persevering\": $fa-var-face-persevering,\n  \"face-pleading\": $fa-var-face-pleading,\n  \"face-pouting\": $fa-var-face-pouting,\n  \"face-raised-eyebrow\": $fa-var-face-raised-eyebrow,\n  \"face-relieved\": $fa-var-face-relieved,\n  \"face-rolling-eyes\": $fa-var-face-rolling-eyes,\n  \"meh-rolling-eyes\": $fa-var-meh-rolling-eyes,\n  \"face-sad-cry\": $fa-var-face-sad-cry,\n  \"sad-cry\": $fa-var-sad-cry,\n  \"face-sad-sweat\": $fa-var-face-sad-sweat,\n  \"face-sad-tear\": $fa-var-face-sad-tear,\n  \"sad-tear\": $fa-var-sad-tear,\n  \"face-scream\": $fa-var-face-scream,\n  \"face-shush\": $fa-var-face-shush,\n  \"face-sleeping\": $fa-var-face-sleeping,\n  \"face-sleepy\": $fa-var-face-sleepy,\n  \"face-smile\": $fa-var-face-smile,\n  \"smile\": $fa-var-smile,\n  \"face-smile-beam\": $fa-var-face-smile-beam,\n  \"smile-beam\": $fa-var-smile-beam,\n  \"face-smile-halo\": $fa-var-face-smile-halo,\n  \"face-smile-hearts\": $fa-var-face-smile-hearts,\n  \"face-smile-horns\": $fa-var-face-smile-horns,\n  \"face-smile-plus\": $fa-var-face-smile-plus,\n  \"smile-plus\": $fa-var-smile-plus,\n  \"face-smile-relaxed\": $fa-var-face-smile-relaxed,\n  \"face-smile-tear\": $fa-var-face-smile-tear,\n  \"face-smile-tongue\": $fa-var-face-smile-tongue,\n  \"face-smile-upside-down\": $fa-var-face-smile-upside-down,\n  \"face-smile-wink\": $fa-var-face-smile-wink,\n  \"smile-wink\": $fa-var-smile-wink,\n  \"face-smiling-hands\": $fa-var-face-smiling-hands,\n  \"face-smirking\": $fa-var-face-smirking,\n  \"face-sunglasses\": $fa-var-face-sunglasses,\n  \"face-surprise\": $fa-var-face-surprise,\n  \"surprise\": $fa-var-surprise,\n  \"face-swear\": $fa-var-face-swear,\n  \"face-thermometer\": $fa-var-face-thermometer,\n  \"face-thinking\": $fa-var-face-thinking,\n  \"face-tired\": $fa-var-face-tired,\n  \"tired\": $fa-var-tired,\n  \"face-tissue\": $fa-var-face-tissue,\n  \"face-tongue-money\": $fa-var-face-tongue-money,\n  \"face-tongue-sweat\": $fa-var-face-tongue-sweat,\n  \"face-unamused\": $fa-var-face-unamused,\n  \"face-viewfinder\": $fa-var-face-viewfinder,\n  \"face-vomit\": $fa-var-face-vomit,\n  \"face-weary\": $fa-var-face-weary,\n  \"face-woozy\": $fa-var-face-woozy,\n  \"face-worried\": $fa-var-face-worried,\n  \"face-zany\": $fa-var-face-zany,\n  \"face-zipper\": $fa-var-face-zipper,\n  \"falafel\": $fa-var-falafel,\n  \"family\": $fa-var-family,\n  \"family-dress\": $fa-var-family-dress,\n  \"family-pants\": $fa-var-family-pants,\n  \"fan\": $fa-var-fan,\n  \"fan-table\": $fa-var-fan-table,\n  \"farm\": $fa-var-farm,\n  \"barn-silo\": $fa-var-barn-silo,\n  \"faucet\": $fa-var-faucet,\n  \"faucet-drip\": $fa-var-faucet-drip,\n  \"fax\": $fa-var-fax,\n  \"feather\": $fa-var-feather,\n  \"feather-pointed\": $fa-var-feather-pointed,\n  \"feather-alt\": $fa-var-feather-alt,\n  \"fence\": $fa-var-fence,\n  \"ferris-wheel\": $fa-var-ferris-wheel,\n  \"field-hockey-stick-ball\": $fa-var-field-hockey-stick-ball,\n  \"field-hockey\": $fa-var-field-hockey,\n  \"file\": $fa-var-file,\n  \"file-arrow-down\": $fa-var-file-arrow-down,\n  \"file-download\": $fa-var-file-download,\n  \"file-arrow-up\": $fa-var-file-arrow-up,\n  \"file-upload\": $fa-var-file-upload,\n  \"file-audio\": $fa-var-file-audio,\n  \"file-binary\": $fa-var-file-binary,\n  \"file-certificate\": $fa-var-file-certificate,\n  \"file-award\": $fa-var-file-award,\n  \"file-chart-column\": $fa-var-file-chart-column,\n  \"file-chart-line\": $fa-var-file-chart-line,\n  \"file-chart-pie\": $fa-var-file-chart-pie,\n  \"file-check\": $fa-var-file-check,\n  \"file-code\": $fa-var-file-code,\n  \"file-contract\": $fa-var-file-contract,\n  \"file-csv\": $fa-var-file-csv,\n  \"file-dashed-line\": $fa-var-file-dashed-line,\n  \"page-break\": $fa-var-page-break,\n  \"file-excel\": $fa-var-file-excel,\n  \"file-exclamation\": $fa-var-file-exclamation,\n  \"file-export\": $fa-var-file-export,\n  \"arrow-right-from-file\": $fa-var-arrow-right-from-file,\n  \"file-heart\": $fa-var-file-heart,\n  \"file-image\": $fa-var-file-image,\n  \"file-import\": $fa-var-file-import,\n  \"arrow-right-to-file\": $fa-var-arrow-right-to-file,\n  \"file-invoice\": $fa-var-file-invoice,\n  \"file-invoice-dollar\": $fa-var-file-invoice-dollar,\n  \"file-lines\": $fa-var-file-lines,\n  \"file-alt\": $fa-var-file-alt,\n  \"file-text\": $fa-var-file-text,\n  \"file-lock\": $fa-var-file-lock,\n  \"file-magnifying-glass\": $fa-var-file-magnifying-glass,\n  \"file-search\": $fa-var-file-search,\n  \"file-medical\": $fa-var-file-medical,\n  \"file-minus\": $fa-var-file-minus,\n  \"file-music\": $fa-var-file-music,\n  \"file-pdf\": $fa-var-file-pdf,\n  \"file-pen\": $fa-var-file-pen,\n  \"file-edit\": $fa-var-file-edit,\n  \"file-plus\": $fa-var-file-plus,\n  \"file-plus-minus\": $fa-var-file-plus-minus,\n  \"file-powerpoint\": $fa-var-file-powerpoint,\n  \"file-prescription\": $fa-var-file-prescription,\n  \"file-signature\": $fa-var-file-signature,\n  \"file-slash\": $fa-var-file-slash,\n  \"file-spreadsheet\": $fa-var-file-spreadsheet,\n  \"file-user\": $fa-var-file-user,\n  \"file-video\": $fa-var-file-video,\n  \"file-waveform\": $fa-var-file-waveform,\n  \"file-medical-alt\": $fa-var-file-medical-alt,\n  \"file-word\": $fa-var-file-word,\n  \"file-xmark\": $fa-var-file-xmark,\n  \"file-times\": $fa-var-file-times,\n  \"file-zipper\": $fa-var-file-zipper,\n  \"file-archive\": $fa-var-file-archive,\n  \"files\": $fa-var-files,\n  \"files-medical\": $fa-var-files-medical,\n  \"fill\": $fa-var-fill,\n  \"fill-drip\": $fa-var-fill-drip,\n  \"film\": $fa-var-film,\n  \"film-canister\": $fa-var-film-canister,\n  \"film-simple\": $fa-var-film-simple,\n  \"film-alt\": $fa-var-film-alt,\n  \"film-slash\": $fa-var-film-slash,\n  \"films\": $fa-var-films,\n  \"filter\": $fa-var-filter,\n  \"filter-circle-dollar\": $fa-var-filter-circle-dollar,\n  \"funnel-dollar\": $fa-var-funnel-dollar,\n  \"filter-circle-xmark\": $fa-var-filter-circle-xmark,\n  \"filter-list\": $fa-var-filter-list,\n  \"filter-slash\": $fa-var-filter-slash,\n  \"filters\": $fa-var-filters,\n  \"fingerprint\": $fa-var-fingerprint,\n  \"fire\": $fa-var-fire,\n  \"fire-extinguisher\": $fa-var-fire-extinguisher,\n  \"fire-flame\": $fa-var-fire-flame,\n  \"flame\": $fa-var-flame,\n  \"fire-flame-curved\": $fa-var-fire-flame-curved,\n  \"fire-alt\": $fa-var-fire-alt,\n  \"fire-flame-simple\": $fa-var-fire-flame-simple,\n  \"burn\": $fa-var-burn,\n  \"fire-hydrant\": $fa-var-fire-hydrant,\n  \"fire-smoke\": $fa-var-fire-smoke,\n  \"fireplace\": $fa-var-fireplace,\n  \"fish\": $fa-var-fish,\n  \"fish-bones\": $fa-var-fish-bones,\n  \"fish-cooked\": $fa-var-fish-cooked,\n  \"fishing-rod\": $fa-var-fishing-rod,\n  \"flag\": $fa-var-flag,\n  \"flag-checkered\": $fa-var-flag-checkered,\n  \"flag-pennant\": $fa-var-flag-pennant,\n  \"pennant\": $fa-var-pennant,\n  \"flag-swallowtail\": $fa-var-flag-swallowtail,\n  \"flag-alt\": $fa-var-flag-alt,\n  \"flag-usa\": $fa-var-flag-usa,\n  \"flashlight\": $fa-var-flashlight,\n  \"flask\": $fa-var-flask,\n  \"flask-round-poison\": $fa-var-flask-round-poison,\n  \"flask-poison\": $fa-var-flask-poison,\n  \"flask-round-potion\": $fa-var-flask-round-potion,\n  \"flask-potion\": $fa-var-flask-potion,\n  \"flatbread\": $fa-var-flatbread,\n  \"flatbread-stuffed\": $fa-var-flatbread-stuffed,\n  \"floppy-disk\": $fa-var-floppy-disk,\n  \"save\": $fa-var-save,\n  \"floppy-disk-circle-arrow-right\": $fa-var-floppy-disk-circle-arrow-right,\n  \"save-circle-arrow-right\": $fa-var-save-circle-arrow-right,\n  \"floppy-disk-circle-xmark\": $fa-var-floppy-disk-circle-xmark,\n  \"floppy-disk-times\": $fa-var-floppy-disk-times,\n  \"save-circle-xmark\": $fa-var-save-circle-xmark,\n  \"save-times\": $fa-var-save-times,\n  \"floppy-disk-pen\": $fa-var-floppy-disk-pen,\n  \"floppy-disks\": $fa-var-floppy-disks,\n  \"florin-sign\": $fa-var-florin-sign,\n  \"flower\": $fa-var-flower,\n  \"flower-daffodil\": $fa-var-flower-daffodil,\n  \"flower-tulip\": $fa-var-flower-tulip,\n  \"flute\": $fa-var-flute,\n  \"flux-capacitor\": $fa-var-flux-capacitor,\n  \"flying-disc\": $fa-var-flying-disc,\n  \"folder\": $fa-var-folder,\n  \"folder-arrow-down\": $fa-var-folder-arrow-down,\n  \"folder-download\": $fa-var-folder-download,\n  \"folder-arrow-up\": $fa-var-folder-arrow-up,\n  \"folder-upload\": $fa-var-folder-upload,\n  \"folder-blank\": $fa-var-folder-blank,\n  \"folder-bookmark\": $fa-var-folder-bookmark,\n  \"folder-gear\": $fa-var-folder-gear,\n  \"folder-cog\": $fa-var-folder-cog,\n  \"folder-grid\": $fa-var-folder-grid,\n  \"folder-heart\": $fa-var-folder-heart,\n  \"folder-image\": $fa-var-folder-image,\n  \"folder-magnifying-glass\": $fa-var-folder-magnifying-glass,\n  \"folder-search\": $fa-var-folder-search,\n  \"folder-medical\": $fa-var-folder-medical,\n  \"folder-minus\": $fa-var-folder-minus,\n  \"folder-music\": $fa-var-folder-music,\n  \"folder-open\": $fa-var-folder-open,\n  \"folder-plus\": $fa-var-folder-plus,\n  \"folder-tree\": $fa-var-folder-tree,\n  \"folder-user\": $fa-var-folder-user,\n  \"folder-xmark\": $fa-var-folder-xmark,\n  \"folder-times\": $fa-var-folder-times,\n  \"folders\": $fa-var-folders,\n  \"fondue-pot\": $fa-var-fondue-pot,\n  \"font\": $fa-var-font,\n  \"font-case\": $fa-var-font-case,\n  \"football\": $fa-var-football,\n  \"football-ball\": $fa-var-football-ball,\n  \"football-helmet\": $fa-var-football-helmet,\n  \"fork\": $fa-var-fork,\n  \"utensil-fork\": $fa-var-utensil-fork,\n  \"fork-knife\": $fa-var-fork-knife,\n  \"utensils-alt\": $fa-var-utensils-alt,\n  \"forklift\": $fa-var-forklift,\n  \"forward\": $fa-var-forward,\n  \"forward-fast\": $fa-var-forward-fast,\n  \"fast-forward\": $fa-var-fast-forward,\n  \"forward-step\": $fa-var-forward-step,\n  \"step-forward\": $fa-var-step-forward,\n  \"franc-sign\": $fa-var-franc-sign,\n  \"french-fries\": $fa-var-french-fries,\n  \"frog\": $fa-var-frog,\n  \"function\": $fa-var-function,\n  \"futbol\": $fa-var-futbol,\n  \"futbol-ball\": $fa-var-futbol-ball,\n  \"soccer-ball\": $fa-var-soccer-ball,\n  \"g\": $fa-var-g,\n  \"galaxy\": $fa-var-galaxy,\n  \"gallery-thumbnails\": $fa-var-gallery-thumbnails,\n  \"game-board\": $fa-var-game-board,\n  \"game-board-simple\": $fa-var-game-board-simple,\n  \"game-board-alt\": $fa-var-game-board-alt,\n  \"game-console-handheld\": $fa-var-game-console-handheld,\n  \"gamepad\": $fa-var-gamepad,\n  \"gamepad-modern\": $fa-var-gamepad-modern,\n  \"gamepad-alt\": $fa-var-gamepad-alt,\n  \"garage\": $fa-var-garage,\n  \"garage-car\": $fa-var-garage-car,\n  \"garage-open\": $fa-var-garage-open,\n  \"garlic\": $fa-var-garlic,\n  \"gas-pump\": $fa-var-gas-pump,\n  \"gas-pump-slash\": $fa-var-gas-pump-slash,\n  \"gauge\": $fa-var-gauge,\n  \"dashboard\": $fa-var-dashboard,\n  \"gauge-high\": $fa-var-gauge-high,\n  \"tachometer-alt\": $fa-var-tachometer-alt,\n  \"tachometer-alt-fast\": $fa-var-tachometer-alt-fast,\n  \"gauge-low\": $fa-var-gauge-low,\n  \"tachometer-alt-slow\": $fa-var-tachometer-alt-slow,\n  \"gauge-max\": $fa-var-gauge-max,\n  \"tachometer-alt-fastest\": $fa-var-tachometer-alt-fastest,\n  \"gauge-med\": $fa-var-gauge-med,\n  \"tachometer-alt-average\": $fa-var-tachometer-alt-average,\n  \"gauge-min\": $fa-var-gauge-min,\n  \"tachometer-alt-slowest\": $fa-var-tachometer-alt-slowest,\n  \"gauge-simple\": $fa-var-gauge-simple,\n  \"gauge-simple-high\": $fa-var-gauge-simple-high,\n  \"tachometer\": $fa-var-tachometer,\n  \"gauge-simple-low\": $fa-var-gauge-simple-low,\n  \"tachometer-slow\": $fa-var-tachometer-slow,\n  \"gauge-simple-max\": $fa-var-gauge-simple-max,\n  \"tachometer-fastest\": $fa-var-tachometer-fastest,\n  \"gauge-simple-med\": $fa-var-gauge-simple-med,\n  \"tachometer-average\": $fa-var-tachometer-average,\n  \"gauge-simple-min\": $fa-var-gauge-simple-min,\n  \"tachometer-slowest\": $fa-var-tachometer-slowest,\n  \"gavel\": $fa-var-gavel,\n  \"legal\": $fa-var-legal,\n  \"gear\": $fa-var-gear,\n  \"cog\": $fa-var-cog,\n  \"gears\": $fa-var-gears,\n  \"cogs\": $fa-var-cogs,\n  \"gem\": $fa-var-gem,\n  \"genderless\": $fa-var-genderless,\n  \"ghost\": $fa-var-ghost,\n  \"gif\": $fa-var-gif,\n  \"gift\": $fa-var-gift,\n  \"gift-card\": $fa-var-gift-card,\n  \"gifts\": $fa-var-gifts,\n  \"gingerbread-man\": $fa-var-gingerbread-man,\n  \"glass\": $fa-var-glass,\n  \"glass-citrus\": $fa-var-glass-citrus,\n  \"glass-empty\": $fa-var-glass-empty,\n  \"glass-half\": $fa-var-glass-half,\n  \"glass-half-empty\": $fa-var-glass-half-empty,\n  \"glass-half-full\": $fa-var-glass-half-full,\n  \"glasses\": $fa-var-glasses,\n  \"glasses-round\": $fa-var-glasses-round,\n  \"glasses-alt\": $fa-var-glasses-alt,\n  \"globe\": $fa-var-globe,\n  \"globe-snow\": $fa-var-globe-snow,\n  \"globe-stand\": $fa-var-globe-stand,\n  \"goal-net\": $fa-var-goal-net,\n  \"golf-ball-tee\": $fa-var-golf-ball-tee,\n  \"golf-ball\": $fa-var-golf-ball,\n  \"golf-club\": $fa-var-golf-club,\n  \"golf-flag-hole\": $fa-var-golf-flag-hole,\n  \"gopuram\": $fa-var-gopuram,\n  \"graduation-cap\": $fa-var-graduation-cap,\n  \"mortar-board\": $fa-var-mortar-board,\n  \"gramophone\": $fa-var-gramophone,\n  \"grapes\": $fa-var-grapes,\n  \"grate\": $fa-var-grate,\n  \"grate-droplet\": $fa-var-grate-droplet,\n  \"greater-than\": $fa-var-greater-than,\n  \"greater-than-equal\": $fa-var-greater-than-equal,\n  \"grid\": $fa-var-grid,\n  \"grid-3\": $fa-var-grid-3,\n  \"grid-2\": $fa-var-grid-2,\n  \"grid-2-plus\": $fa-var-grid-2-plus,\n  \"grid-4\": $fa-var-grid-4,\n  \"grid-5\": $fa-var-grid-5,\n  \"grid-dividers\": $fa-var-grid-dividers,\n  \"grid-horizontal\": $fa-var-grid-horizontal,\n  \"grip\": $fa-var-grip,\n  \"grip-horizontal\": $fa-var-grip-horizontal,\n  \"grip-dots\": $fa-var-grip-dots,\n  \"grip-dots-vertical\": $fa-var-grip-dots-vertical,\n  \"grip-lines\": $fa-var-grip-lines,\n  \"grip-lines-vertical\": $fa-var-grip-lines-vertical,\n  \"grip-vertical\": $fa-var-grip-vertical,\n  \"guarani-sign\": $fa-var-guarani-sign,\n  \"guitar\": $fa-var-guitar,\n  \"guitar-electric\": $fa-var-guitar-electric,\n  \"guitars\": $fa-var-guitars,\n  \"gun\": $fa-var-gun,\n  \"gun-slash\": $fa-var-gun-slash,\n  \"gun-squirt\": $fa-var-gun-squirt,\n  \"h\": $fa-var-h,\n  \"h1\": $fa-var-h1,\n  \"h2\": $fa-var-h2,\n  \"h3\": $fa-var-h3,\n  \"h4\": $fa-var-h4,\n  \"h5\": $fa-var-h5,\n  \"h6\": $fa-var-h6,\n  \"hammer\": $fa-var-hammer,\n  \"hammer-crash\": $fa-var-hammer-crash,\n  \"hammer-war\": $fa-var-hammer-war,\n  \"hamsa\": $fa-var-hamsa,\n  \"hand\": $fa-var-hand,\n  \"hand-paper\": $fa-var-hand-paper,\n  \"hand-back-fist\": $fa-var-hand-back-fist,\n  \"hand-rock\": $fa-var-hand-rock,\n  \"hand-back-point-down\": $fa-var-hand-back-point-down,\n  \"hand-back-point-left\": $fa-var-hand-back-point-left,\n  \"hand-back-point-ribbon\": $fa-var-hand-back-point-ribbon,\n  \"hand-back-point-right\": $fa-var-hand-back-point-right,\n  \"hand-back-point-up\": $fa-var-hand-back-point-up,\n  \"hand-dots\": $fa-var-hand-dots,\n  \"allergies\": $fa-var-allergies,\n  \"hand-fingers-crossed\": $fa-var-hand-fingers-crossed,\n  \"hand-fist\": $fa-var-hand-fist,\n  \"fist-raised\": $fa-var-fist-raised,\n  \"hand-heart\": $fa-var-hand-heart,\n  \"hand-holding\": $fa-var-hand-holding,\n  \"hand-holding-box\": $fa-var-hand-holding-box,\n  \"hand-holding-dollar\": $fa-var-hand-holding-dollar,\n  \"hand-holding-usd\": $fa-var-hand-holding-usd,\n  \"hand-holding-droplet\": $fa-var-hand-holding-droplet,\n  \"hand-holding-water\": $fa-var-hand-holding-water,\n  \"hand-holding-heart\": $fa-var-hand-holding-heart,\n  \"hand-holding-magic\": $fa-var-hand-holding-magic,\n  \"hand-holding-medical\": $fa-var-hand-holding-medical,\n  \"hand-holding-seedling\": $fa-var-hand-holding-seedling,\n  \"hand-holding-skull\": $fa-var-hand-holding-skull,\n  \"hand-horns\": $fa-var-hand-horns,\n  \"hand-lizard\": $fa-var-hand-lizard,\n  \"hand-love\": $fa-var-hand-love,\n  \"hand-middle-finger\": $fa-var-hand-middle-finger,\n  \"hand-peace\": $fa-var-hand-peace,\n  \"hand-point-down\": $fa-var-hand-point-down,\n  \"hand-point-left\": $fa-var-hand-point-left,\n  \"hand-point-ribbon\": $fa-var-hand-point-ribbon,\n  \"hand-point-right\": $fa-var-hand-point-right,\n  \"hand-point-up\": $fa-var-hand-point-up,\n  \"hand-pointer\": $fa-var-hand-pointer,\n  \"hand-scissors\": $fa-var-hand-scissors,\n  \"hand-sparkles\": $fa-var-hand-sparkles,\n  \"hand-spock\": $fa-var-hand-spock,\n  \"hand-wave\": $fa-var-hand-wave,\n  \"hands\": $fa-var-hands,\n  \"sign-language\": $fa-var-sign-language,\n  \"signing\": $fa-var-signing,\n  \"hands-asl-interpreting\": $fa-var-hands-asl-interpreting,\n  \"american-sign-language-interpreting\": $fa-var-american-sign-language-interpreting,\n  \"asl-interpreting\": $fa-var-asl-interpreting,\n  \"hands-american-sign-language-interpreting\": $fa-var-hands-american-sign-language-interpreting,\n  \"hands-bubbles\": $fa-var-hands-bubbles,\n  \"hands-wash\": $fa-var-hands-wash,\n  \"hands-clapping\": $fa-var-hands-clapping,\n  \"hands-holding\": $fa-var-hands-holding,\n  \"hands-holding-diamond\": $fa-var-hands-holding-diamond,\n  \"hand-receiving\": $fa-var-hand-receiving,\n  \"hands-holding-dollar\": $fa-var-hands-holding-dollar,\n  \"hands-usd\": $fa-var-hands-usd,\n  \"hands-holding-heart\": $fa-var-hands-holding-heart,\n  \"hands-heart\": $fa-var-hands-heart,\n  \"hands-praying\": $fa-var-hands-praying,\n  \"praying-hands\": $fa-var-praying-hands,\n  \"handshake\": $fa-var-handshake,\n  \"handshake-angle\": $fa-var-handshake-angle,\n  \"hands-helping\": $fa-var-hands-helping,\n  \"handshake-simple\": $fa-var-handshake-simple,\n  \"handshake-alt\": $fa-var-handshake-alt,\n  \"handshake-simple-slash\": $fa-var-handshake-simple-slash,\n  \"handshake-alt-slash\": $fa-var-handshake-alt-slash,\n  \"handshake-slash\": $fa-var-handshake-slash,\n  \"hanukiah\": $fa-var-hanukiah,\n  \"hard-drive\": $fa-var-hard-drive,\n  \"hdd\": $fa-var-hdd,\n  \"hashtag\": $fa-var-hashtag,\n  \"hashtag-lock\": $fa-var-hashtag-lock,\n  \"hat-chef\": $fa-var-hat-chef,\n  \"hat-cowboy\": $fa-var-hat-cowboy,\n  \"hat-cowboy-side\": $fa-var-hat-cowboy-side,\n  \"hat-santa\": $fa-var-hat-santa,\n  \"hat-winter\": $fa-var-hat-winter,\n  \"hat-witch\": $fa-var-hat-witch,\n  \"hat-wizard\": $fa-var-hat-wizard,\n  \"head-side\": $fa-var-head-side,\n  \"head-side-brain\": $fa-var-head-side-brain,\n  \"head-side-cough\": $fa-var-head-side-cough,\n  \"head-side-cough-slash\": $fa-var-head-side-cough-slash,\n  \"head-side-goggles\": $fa-var-head-side-goggles,\n  \"head-vr\": $fa-var-head-vr,\n  \"head-side-headphones\": $fa-var-head-side-headphones,\n  \"head-side-heart\": $fa-var-head-side-heart,\n  \"head-side-mask\": $fa-var-head-side-mask,\n  \"head-side-medical\": $fa-var-head-side-medical,\n  \"head-side-virus\": $fa-var-head-side-virus,\n  \"heading\": $fa-var-heading,\n  \"header\": $fa-var-header,\n  \"headphones\": $fa-var-headphones,\n  \"headphones-simple\": $fa-var-headphones-simple,\n  \"headphones-alt\": $fa-var-headphones-alt,\n  \"headset\": $fa-var-headset,\n  \"heart\": $fa-var-heart,\n  \"heart-crack\": $fa-var-heart-crack,\n  \"heart-broken\": $fa-var-heart-broken,\n  \"heart-half\": $fa-var-heart-half,\n  \"heart-half-stroke\": $fa-var-heart-half-stroke,\n  \"heart-half-alt\": $fa-var-heart-half-alt,\n  \"heart-pulse\": $fa-var-heart-pulse,\n  \"heartbeat\": $fa-var-heartbeat,\n  \"heat\": $fa-var-heat,\n  \"helicopter\": $fa-var-helicopter,\n  \"helmet-battle\": $fa-var-helmet-battle,\n  \"helmet-safety\": $fa-var-helmet-safety,\n  \"hard-hat\": $fa-var-hard-hat,\n  \"hat-hard\": $fa-var-hat-hard,\n  \"hexagon\": $fa-var-hexagon,\n  \"hexagon-check\": $fa-var-hexagon-check,\n  \"hexagon-divide\": $fa-var-hexagon-divide,\n  \"hexagon-exclamation\": $fa-var-hexagon-exclamation,\n  \"hexagon-minus\": $fa-var-hexagon-minus,\n  \"minus-hexagon\": $fa-var-minus-hexagon,\n  \"hexagon-plus\": $fa-var-hexagon-plus,\n  \"plus-hexagon\": $fa-var-plus-hexagon,\n  \"hexagon-xmark\": $fa-var-hexagon-xmark,\n  \"times-hexagon\": $fa-var-times-hexagon,\n  \"xmark-hexagon\": $fa-var-xmark-hexagon,\n  \"high-definition\": $fa-var-high-definition,\n  \"rectangle-hd\": $fa-var-rectangle-hd,\n  \"highlighter\": $fa-var-highlighter,\n  \"highlighter-line\": $fa-var-highlighter-line,\n  \"hippo\": $fa-var-hippo,\n  \"hockey-mask\": $fa-var-hockey-mask,\n  \"hockey-puck\": $fa-var-hockey-puck,\n  \"hockey-stick-puck\": $fa-var-hockey-stick-puck,\n  \"hockey-sticks\": $fa-var-hockey-sticks,\n  \"holly-berry\": $fa-var-holly-berry,\n  \"honey-pot\": $fa-var-honey-pot,\n  \"hood-cloak\": $fa-var-hood-cloak,\n  \"horizontal-rule\": $fa-var-horizontal-rule,\n  \"horse\": $fa-var-horse,\n  \"horse-head\": $fa-var-horse-head,\n  \"horse-saddle\": $fa-var-horse-saddle,\n  \"hose\": $fa-var-hose,\n  \"hose-reel\": $fa-var-hose-reel,\n  \"hospital\": $fa-var-hospital,\n  \"hospital-user\": $fa-var-hospital-user,\n  \"hospital-wide\": $fa-var-hospital-wide,\n  \"hospital-alt\": $fa-var-hospital-alt,\n  \"hospitals\": $fa-var-hospitals,\n  \"hot-tub-person\": $fa-var-hot-tub-person,\n  \"hot-tub\": $fa-var-hot-tub,\n  \"hotdog\": $fa-var-hotdog,\n  \"hotel\": $fa-var-hotel,\n  \"hourglass\": $fa-var-hourglass,\n  \"hourglass-2\": $fa-var-hourglass-2,\n  \"hourglass-half\": $fa-var-hourglass-half,\n  \"hourglass-clock\": $fa-var-hourglass-clock,\n  \"hourglass-empty\": $fa-var-hourglass-empty,\n  \"hourglass-end\": $fa-var-hourglass-end,\n  \"hourglass-3\": $fa-var-hourglass-3,\n  \"hourglass-start\": $fa-var-hourglass-start,\n  \"hourglass-1\": $fa-var-hourglass-1,\n  \"house\": $fa-var-house,\n  \"home\": $fa-var-home,\n  \"house-blank\": $fa-var-house-blank,\n  \"home-blank\": $fa-var-home-blank,\n  \"home-lg-alt\": $fa-var-home-lg-alt,\n  \"house-building\": $fa-var-house-building,\n  \"house-chimney\": $fa-var-house-chimney,\n  \"home-lg\": $fa-var-home-lg,\n  \"house-chimney-blank\": $fa-var-house-chimney-blank,\n  \"house-chimney-crack\": $fa-var-house-chimney-crack,\n  \"house-damage\": $fa-var-house-damage,\n  \"house-chimney-heart\": $fa-var-house-chimney-heart,\n  \"house-chimney-medical\": $fa-var-house-chimney-medical,\n  \"clinic-medical\": $fa-var-clinic-medical,\n  \"house-chimney-user\": $fa-var-house-chimney-user,\n  \"house-chimney-window\": $fa-var-house-chimney-window,\n  \"house-crack\": $fa-var-house-crack,\n  \"house-day\": $fa-var-house-day,\n  \"house-flood\": $fa-var-house-flood,\n  \"house-heart\": $fa-var-house-heart,\n  \"home-heart\": $fa-var-home-heart,\n  \"house-laptop\": $fa-var-house-laptop,\n  \"laptop-house\": $fa-var-laptop-house,\n  \"house-medical\": $fa-var-house-medical,\n  \"house-night\": $fa-var-house-night,\n  \"house-person-leave\": $fa-var-house-person-leave,\n  \"house-person-depart\": $fa-var-house-person-depart,\n  \"house-person-return\": $fa-var-house-person-return,\n  \"house-person-arrive\": $fa-var-house-person-arrive,\n  \"house-signal\": $fa-var-house-signal,\n  \"house-tree\": $fa-var-house-tree,\n  \"house-turret\": $fa-var-house-turret,\n  \"house-user\": $fa-var-house-user,\n  \"home-user\": $fa-var-home-user,\n  \"house-window\": $fa-var-house-window,\n  \"hryvnia-sign\": $fa-var-hryvnia-sign,\n  \"hryvnia\": $fa-var-hryvnia,\n  \"hundred-points\": $fa-var-hundred-points,\n  \"100\": $fa-var-100,\n  \"hurricane\": $fa-var-hurricane,\n  \"hyphen\": $fa-var-hyphen,\n  \"i\": $fa-var-i,\n  \"i-cursor\": $fa-var-i-cursor,\n  \"ice-cream\": $fa-var-ice-cream,\n  \"ice-skate\": $fa-var-ice-skate,\n  \"icicles\": $fa-var-icicles,\n  \"icons\": $fa-var-icons,\n  \"heart-music-camera-bolt\": $fa-var-heart-music-camera-bolt,\n  \"id-badge\": $fa-var-id-badge,\n  \"id-card\": $fa-var-id-card,\n  \"drivers-license\": $fa-var-drivers-license,\n  \"id-card-clip\": $fa-var-id-card-clip,\n  \"id-card-alt\": $fa-var-id-card-alt,\n  \"igloo\": $fa-var-igloo,\n  \"image\": $fa-var-image,\n  \"image-landscape\": $fa-var-image-landscape,\n  \"landscape\": $fa-var-landscape,\n  \"image-polaroid\": $fa-var-image-polaroid,\n  \"image-polaroid-user\": $fa-var-image-polaroid-user,\n  \"image-portrait\": $fa-var-image-portrait,\n  \"portrait\": $fa-var-portrait,\n  \"image-slash\": $fa-var-image-slash,\n  \"image-user\": $fa-var-image-user,\n  \"images\": $fa-var-images,\n  \"images-user\": $fa-var-images-user,\n  \"inbox\": $fa-var-inbox,\n  \"inbox-full\": $fa-var-inbox-full,\n  \"inbox-in\": $fa-var-inbox-in,\n  \"inbox-arrow-down\": $fa-var-inbox-arrow-down,\n  \"inbox-out\": $fa-var-inbox-out,\n  \"inbox-arrow-up\": $fa-var-inbox-arrow-up,\n  \"inboxes\": $fa-var-inboxes,\n  \"indent\": $fa-var-indent,\n  \"indian-rupee-sign\": $fa-var-indian-rupee-sign,\n  \"indian-rupee\": $fa-var-indian-rupee,\n  \"inr\": $fa-var-inr,\n  \"industry\": $fa-var-industry,\n  \"industry-windows\": $fa-var-industry-windows,\n  \"industry-alt\": $fa-var-industry-alt,\n  \"infinity\": $fa-var-infinity,\n  \"info\": $fa-var-info,\n  \"inhaler\": $fa-var-inhaler,\n  \"input-numeric\": $fa-var-input-numeric,\n  \"input-pipe\": $fa-var-input-pipe,\n  \"input-text\": $fa-var-input-text,\n  \"integral\": $fa-var-integral,\n  \"intersection\": $fa-var-intersection,\n  \"island-tropical\": $fa-var-island-tropical,\n  \"island-tree-palm\": $fa-var-island-tree-palm,\n  \"italic\": $fa-var-italic,\n  \"j\": $fa-var-j,\n  \"jack-o-lantern\": $fa-var-jack-o-lantern,\n  \"jedi\": $fa-var-jedi,\n  \"jet-fighter\": $fa-var-jet-fighter,\n  \"fighter-jet\": $fa-var-fighter-jet,\n  \"joint\": $fa-var-joint,\n  \"joystick\": $fa-var-joystick,\n  \"jug\": $fa-var-jug,\n  \"k\": $fa-var-k,\n  \"kaaba\": $fa-var-kaaba,\n  \"kazoo\": $fa-var-kazoo,\n  \"kerning\": $fa-var-kerning,\n  \"key\": $fa-var-key,\n  \"key-skeleton\": $fa-var-key-skeleton,\n  \"key-skeleton-left-right\": $fa-var-key-skeleton-left-right,\n  \"keyboard\": $fa-var-keyboard,\n  \"keyboard-brightness\": $fa-var-keyboard-brightness,\n  \"keyboard-brightness-low\": $fa-var-keyboard-brightness-low,\n  \"keyboard-down\": $fa-var-keyboard-down,\n  \"keyboard-left\": $fa-var-keyboard-left,\n  \"keynote\": $fa-var-keynote,\n  \"khanda\": $fa-var-khanda,\n  \"kidneys\": $fa-var-kidneys,\n  \"kip-sign\": $fa-var-kip-sign,\n  \"kit-medical\": $fa-var-kit-medical,\n  \"first-aid\": $fa-var-first-aid,\n  \"kite\": $fa-var-kite,\n  \"kiwi-bird\": $fa-var-kiwi-bird,\n  \"kiwi-fruit\": $fa-var-kiwi-fruit,\n  \"knife\": $fa-var-knife,\n  \"utensil-knife\": $fa-var-utensil-knife,\n  \"knife-kitchen\": $fa-var-knife-kitchen,\n  \"l\": $fa-var-l,\n  \"lacrosse-stick\": $fa-var-lacrosse-stick,\n  \"lacrosse-stick-ball\": $fa-var-lacrosse-stick-ball,\n  \"lambda\": $fa-var-lambda,\n  \"lamp\": $fa-var-lamp,\n  \"lamp-desk\": $fa-var-lamp-desk,\n  \"lamp-floor\": $fa-var-lamp-floor,\n  \"lamp-street\": $fa-var-lamp-street,\n  \"landmark\": $fa-var-landmark,\n  \"landmark-dome\": $fa-var-landmark-dome,\n  \"landmark-alt\": $fa-var-landmark-alt,\n  \"language\": $fa-var-language,\n  \"laptop\": $fa-var-laptop,\n  \"laptop-arrow-down\": $fa-var-laptop-arrow-down,\n  \"laptop-code\": $fa-var-laptop-code,\n  \"laptop-medical\": $fa-var-laptop-medical,\n  \"laptop-mobile\": $fa-var-laptop-mobile,\n  \"phone-laptop\": $fa-var-phone-laptop,\n  \"laptop-slash\": $fa-var-laptop-slash,\n  \"lari-sign\": $fa-var-lari-sign,\n  \"lasso\": $fa-var-lasso,\n  \"lasso-sparkles\": $fa-var-lasso-sparkles,\n  \"layer-group\": $fa-var-layer-group,\n  \"layer-minus\": $fa-var-layer-minus,\n  \"layer-group-minus\": $fa-var-layer-group-minus,\n  \"layer-plus\": $fa-var-layer-plus,\n  \"layer-group-plus\": $fa-var-layer-group-plus,\n  \"leaf\": $fa-var-leaf,\n  \"leaf-heart\": $fa-var-leaf-heart,\n  \"leaf-maple\": $fa-var-leaf-maple,\n  \"leaf-oak\": $fa-var-leaf-oak,\n  \"leafy-green\": $fa-var-leafy-green,\n  \"left\": $fa-var-left,\n  \"arrow-alt-left\": $fa-var-arrow-alt-left,\n  \"left-from-line\": $fa-var-left-from-line,\n  \"arrow-alt-from-right\": $fa-var-arrow-alt-from-right,\n  \"left-long\": $fa-var-left-long,\n  \"long-arrow-alt-left\": $fa-var-long-arrow-alt-left,\n  \"left-long-to-line\": $fa-var-left-long-to-line,\n  \"left-right\": $fa-var-left-right,\n  \"arrows-alt-h\": $fa-var-arrows-alt-h,\n  \"left-to-line\": $fa-var-left-to-line,\n  \"arrow-alt-to-left\": $fa-var-arrow-alt-to-left,\n  \"lemon\": $fa-var-lemon,\n  \"less-than\": $fa-var-less-than,\n  \"less-than-equal\": $fa-var-less-than-equal,\n  \"life-ring\": $fa-var-life-ring,\n  \"light-ceiling\": $fa-var-light-ceiling,\n  \"light-emergency\": $fa-var-light-emergency,\n  \"light-emergency-on\": $fa-var-light-emergency-on,\n  \"light-switch\": $fa-var-light-switch,\n  \"light-switch-off\": $fa-var-light-switch-off,\n  \"light-switch-on\": $fa-var-light-switch-on,\n  \"lightbulb\": $fa-var-lightbulb,\n  \"lightbulb-dollar\": $fa-var-lightbulb-dollar,\n  \"lightbulb-exclamation\": $fa-var-lightbulb-exclamation,\n  \"lightbulb-exclamation-on\": $fa-var-lightbulb-exclamation-on,\n  \"lightbulb-on\": $fa-var-lightbulb-on,\n  \"lightbulb-slash\": $fa-var-lightbulb-slash,\n  \"lights-holiday\": $fa-var-lights-holiday,\n  \"line-columns\": $fa-var-line-columns,\n  \"line-height\": $fa-var-line-height,\n  \"link\": $fa-var-link,\n  \"chain\": $fa-var-chain,\n  \"link-horizontal\": $fa-var-link-horizontal,\n  \"chain-horizontal\": $fa-var-chain-horizontal,\n  \"link-horizontal-slash\": $fa-var-link-horizontal-slash,\n  \"chain-horizontal-slash\": $fa-var-chain-horizontal-slash,\n  \"link-simple\": $fa-var-link-simple,\n  \"link-simple-slash\": $fa-var-link-simple-slash,\n  \"link-slash\": $fa-var-link-slash,\n  \"chain-broken\": $fa-var-chain-broken,\n  \"chain-slash\": $fa-var-chain-slash,\n  \"unlink\": $fa-var-unlink,\n  \"lips\": $fa-var-lips,\n  \"lira-sign\": $fa-var-lira-sign,\n  \"list\": $fa-var-list,\n  \"list-squares\": $fa-var-list-squares,\n  \"list-check\": $fa-var-list-check,\n  \"tasks\": $fa-var-tasks,\n  \"list-dropdown\": $fa-var-list-dropdown,\n  \"list-music\": $fa-var-list-music,\n  \"list-ol\": $fa-var-list-ol,\n  \"list-1-2\": $fa-var-list-1-2,\n  \"list-numeric\": $fa-var-list-numeric,\n  \"list-radio\": $fa-var-list-radio,\n  \"list-timeline\": $fa-var-list-timeline,\n  \"list-tree\": $fa-var-list-tree,\n  \"list-ul\": $fa-var-list-ul,\n  \"list-dots\": $fa-var-list-dots,\n  \"litecoin-sign\": $fa-var-litecoin-sign,\n  \"loader\": $fa-var-loader,\n  \"lobster\": $fa-var-lobster,\n  \"location-arrow\": $fa-var-location-arrow,\n  \"location-check\": $fa-var-location-check,\n  \"map-marker-check\": $fa-var-map-marker-check,\n  \"location-crosshairs\": $fa-var-location-crosshairs,\n  \"location\": $fa-var-location,\n  \"location-crosshairs-slash\": $fa-var-location-crosshairs-slash,\n  \"location-slash\": $fa-var-location-slash,\n  \"location-dot\": $fa-var-location-dot,\n  \"map-marker-alt\": $fa-var-map-marker-alt,\n  \"location-dot-slash\": $fa-var-location-dot-slash,\n  \"map-marker-alt-slash\": $fa-var-map-marker-alt-slash,\n  \"location-exclamation\": $fa-var-location-exclamation,\n  \"map-marker-exclamation\": $fa-var-map-marker-exclamation,\n  \"location-minus\": $fa-var-location-minus,\n  \"map-marker-minus\": $fa-var-map-marker-minus,\n  \"location-pen\": $fa-var-location-pen,\n  \"map-marker-edit\": $fa-var-map-marker-edit,\n  \"location-pin\": $fa-var-location-pin,\n  \"map-marker\": $fa-var-map-marker,\n  \"location-pin-slash\": $fa-var-location-pin-slash,\n  \"map-marker-slash\": $fa-var-map-marker-slash,\n  \"location-plus\": $fa-var-location-plus,\n  \"map-marker-plus\": $fa-var-map-marker-plus,\n  \"location-question\": $fa-var-location-question,\n  \"map-marker-question\": $fa-var-map-marker-question,\n  \"location-smile\": $fa-var-location-smile,\n  \"map-marker-smile\": $fa-var-map-marker-smile,\n  \"location-xmark\": $fa-var-location-xmark,\n  \"map-marker-times\": $fa-var-map-marker-times,\n  \"map-marker-xmark\": $fa-var-map-marker-xmark,\n  \"lock\": $fa-var-lock,\n  \"lock-a\": $fa-var-lock-a,\n  \"lock-hashtag\": $fa-var-lock-hashtag,\n  \"lock-keyhole\": $fa-var-lock-keyhole,\n  \"lock-alt\": $fa-var-lock-alt,\n  \"lock-keyhole-open\": $fa-var-lock-keyhole-open,\n  \"lock-open-alt\": $fa-var-lock-open-alt,\n  \"lock-open\": $fa-var-lock-open,\n  \"lollipop\": $fa-var-lollipop,\n  \"lollypop\": $fa-var-lollypop,\n  \"loveseat\": $fa-var-loveseat,\n  \"couch-small\": $fa-var-couch-small,\n  \"luchador-mask\": $fa-var-luchador-mask,\n  \"luchador\": $fa-var-luchador,\n  \"mask-luchador\": $fa-var-mask-luchador,\n  \"lungs\": $fa-var-lungs,\n  \"lungs-virus\": $fa-var-lungs-virus,\n  \"m\": $fa-var-m,\n  \"mace\": $fa-var-mace,\n  \"magnet\": $fa-var-magnet,\n  \"magnifying-glass\": $fa-var-magnifying-glass,\n  \"search\": $fa-var-search,\n  \"magnifying-glass-dollar\": $fa-var-magnifying-glass-dollar,\n  \"search-dollar\": $fa-var-search-dollar,\n  \"magnifying-glass-location\": $fa-var-magnifying-glass-location,\n  \"search-location\": $fa-var-search-location,\n  \"magnifying-glass-minus\": $fa-var-magnifying-glass-minus,\n  \"search-minus\": $fa-var-search-minus,\n  \"magnifying-glass-plus\": $fa-var-magnifying-glass-plus,\n  \"search-plus\": $fa-var-search-plus,\n  \"mailbox\": $fa-var-mailbox,\n  \"manat-sign\": $fa-var-manat-sign,\n  \"mandolin\": $fa-var-mandolin,\n  \"mango\": $fa-var-mango,\n  \"manhole\": $fa-var-manhole,\n  \"map\": $fa-var-map,\n  \"map-location\": $fa-var-map-location,\n  \"map-marked\": $fa-var-map-marked,\n  \"map-location-dot\": $fa-var-map-location-dot,\n  \"map-marked-alt\": $fa-var-map-marked-alt,\n  \"map-pin\": $fa-var-map-pin,\n  \"marker\": $fa-var-marker,\n  \"mars\": $fa-var-mars,\n  \"mars-and-venus\": $fa-var-mars-and-venus,\n  \"mars-double\": $fa-var-mars-double,\n  \"mars-stroke\": $fa-var-mars-stroke,\n  \"mars-stroke-right\": $fa-var-mars-stroke-right,\n  \"mars-stroke-h\": $fa-var-mars-stroke-h,\n  \"mars-stroke-up\": $fa-var-mars-stroke-up,\n  \"mars-stroke-v\": $fa-var-mars-stroke-v,\n  \"martini-glass\": $fa-var-martini-glass,\n  \"glass-martini-alt\": $fa-var-glass-martini-alt,\n  \"martini-glass-citrus\": $fa-var-martini-glass-citrus,\n  \"cocktail\": $fa-var-cocktail,\n  \"martini-glass-empty\": $fa-var-martini-glass-empty,\n  \"glass-martini\": $fa-var-glass-martini,\n  \"mask\": $fa-var-mask,\n  \"mask-face\": $fa-var-mask-face,\n  \"mask-snorkel\": $fa-var-mask-snorkel,\n  \"masks-theater\": $fa-var-masks-theater,\n  \"theater-masks\": $fa-var-theater-masks,\n  \"maximize\": $fa-var-maximize,\n  \"expand-arrows-alt\": $fa-var-expand-arrows-alt,\n  \"meat\": $fa-var-meat,\n  \"medal\": $fa-var-medal,\n  \"megaphone\": $fa-var-megaphone,\n  \"melon\": $fa-var-melon,\n  \"melon-slice\": $fa-var-melon-slice,\n  \"memo\": $fa-var-memo,\n  \"memo-circle-check\": $fa-var-memo-circle-check,\n  \"memo-pad\": $fa-var-memo-pad,\n  \"memory\": $fa-var-memory,\n  \"menorah\": $fa-var-menorah,\n  \"mercury\": $fa-var-mercury,\n  \"message\": $fa-var-message,\n  \"comment-alt\": $fa-var-comment-alt,\n  \"message-arrow-down\": $fa-var-message-arrow-down,\n  \"comment-alt-arrow-down\": $fa-var-comment-alt-arrow-down,\n  \"message-arrow-up\": $fa-var-message-arrow-up,\n  \"comment-alt-arrow-up\": $fa-var-comment-alt-arrow-up,\n  \"message-arrow-up-right\": $fa-var-message-arrow-up-right,\n  \"message-bot\": $fa-var-message-bot,\n  \"message-captions\": $fa-var-message-captions,\n  \"comment-alt-captions\": $fa-var-comment-alt-captions,\n  \"message-check\": $fa-var-message-check,\n  \"comment-alt-check\": $fa-var-comment-alt-check,\n  \"message-code\": $fa-var-message-code,\n  \"message-dollar\": $fa-var-message-dollar,\n  \"comment-alt-dollar\": $fa-var-comment-alt-dollar,\n  \"message-dots\": $fa-var-message-dots,\n  \"comment-alt-dots\": $fa-var-comment-alt-dots,\n  \"messaging\": $fa-var-messaging,\n  \"message-exclamation\": $fa-var-message-exclamation,\n  \"comment-alt-exclamation\": $fa-var-comment-alt-exclamation,\n  \"message-image\": $fa-var-message-image,\n  \"comment-alt-image\": $fa-var-comment-alt-image,\n  \"message-lines\": $fa-var-message-lines,\n  \"comment-alt-lines\": $fa-var-comment-alt-lines,\n  \"message-medical\": $fa-var-message-medical,\n  \"comment-alt-medical\": $fa-var-comment-alt-medical,\n  \"message-middle\": $fa-var-message-middle,\n  \"comment-middle-alt\": $fa-var-comment-middle-alt,\n  \"message-middle-top\": $fa-var-message-middle-top,\n  \"comment-middle-top-alt\": $fa-var-comment-middle-top-alt,\n  \"message-minus\": $fa-var-message-minus,\n  \"comment-alt-minus\": $fa-var-comment-alt-minus,\n  \"message-music\": $fa-var-message-music,\n  \"comment-alt-music\": $fa-var-comment-alt-music,\n  \"message-pen\": $fa-var-message-pen,\n  \"comment-alt-edit\": $fa-var-comment-alt-edit,\n  \"message-edit\": $fa-var-message-edit,\n  \"message-plus\": $fa-var-message-plus,\n  \"comment-alt-plus\": $fa-var-comment-alt-plus,\n  \"message-question\": $fa-var-message-question,\n  \"message-quote\": $fa-var-message-quote,\n  \"comment-alt-quote\": $fa-var-comment-alt-quote,\n  \"message-slash\": $fa-var-message-slash,\n  \"comment-alt-slash\": $fa-var-comment-alt-slash,\n  \"message-smile\": $fa-var-message-smile,\n  \"comment-alt-smile\": $fa-var-comment-alt-smile,\n  \"message-sms\": $fa-var-message-sms,\n  \"message-text\": $fa-var-message-text,\n  \"comment-alt-text\": $fa-var-comment-alt-text,\n  \"message-xmark\": $fa-var-message-xmark,\n  \"comment-alt-times\": $fa-var-comment-alt-times,\n  \"message-times\": $fa-var-message-times,\n  \"messages\": $fa-var-messages,\n  \"comments-alt\": $fa-var-comments-alt,\n  \"messages-dollar\": $fa-var-messages-dollar,\n  \"comments-alt-dollar\": $fa-var-comments-alt-dollar,\n  \"messages-question\": $fa-var-messages-question,\n  \"meteor\": $fa-var-meteor,\n  \"meter\": $fa-var-meter,\n  \"meter-bolt\": $fa-var-meter-bolt,\n  \"meter-droplet\": $fa-var-meter-droplet,\n  \"meter-fire\": $fa-var-meter-fire,\n  \"microchip\": $fa-var-microchip,\n  \"microchip-ai\": $fa-var-microchip-ai,\n  \"microphone\": $fa-var-microphone,\n  \"microphone-lines\": $fa-var-microphone-lines,\n  \"microphone-alt\": $fa-var-microphone-alt,\n  \"microphone-lines-slash\": $fa-var-microphone-lines-slash,\n  \"microphone-alt-slash\": $fa-var-microphone-alt-slash,\n  \"microphone-slash\": $fa-var-microphone-slash,\n  \"microphone-stand\": $fa-var-microphone-stand,\n  \"microscope\": $fa-var-microscope,\n  \"microwave\": $fa-var-microwave,\n  \"mill-sign\": $fa-var-mill-sign,\n  \"minimize\": $fa-var-minimize,\n  \"compress-arrows-alt\": $fa-var-compress-arrows-alt,\n  \"minus\": $fa-var-minus,\n  \"subtract\": $fa-var-subtract,\n  \"mistletoe\": $fa-var-mistletoe,\n  \"mitten\": $fa-var-mitten,\n  \"mobile\": $fa-var-mobile,\n  \"mobile-android\": $fa-var-mobile-android,\n  \"mobile-phone\": $fa-var-mobile-phone,\n  \"mobile-button\": $fa-var-mobile-button,\n  \"mobile-notch\": $fa-var-mobile-notch,\n  \"mobile-iphone\": $fa-var-mobile-iphone,\n  \"mobile-screen\": $fa-var-mobile-screen,\n  \"mobile-android-alt\": $fa-var-mobile-android-alt,\n  \"mobile-screen-button\": $fa-var-mobile-screen-button,\n  \"mobile-alt\": $fa-var-mobile-alt,\n  \"mobile-signal\": $fa-var-mobile-signal,\n  \"mobile-signal-out\": $fa-var-mobile-signal-out,\n  \"money-bill\": $fa-var-money-bill,\n  \"money-bill-1\": $fa-var-money-bill-1,\n  \"money-bill-alt\": $fa-var-money-bill-alt,\n  \"money-bill-1-wave\": $fa-var-money-bill-1-wave,\n  \"money-bill-wave-alt\": $fa-var-money-bill-wave-alt,\n  \"money-bill-simple\": $fa-var-money-bill-simple,\n  \"money-bill-simple-wave\": $fa-var-money-bill-simple-wave,\n  \"money-bill-wave\": $fa-var-money-bill-wave,\n  \"money-bills\": $fa-var-money-bills,\n  \"money-bills-simple\": $fa-var-money-bills-simple,\n  \"money-bills-alt\": $fa-var-money-bills-alt,\n  \"money-check\": $fa-var-money-check,\n  \"money-check-dollar\": $fa-var-money-check-dollar,\n  \"money-check-alt\": $fa-var-money-check-alt,\n  \"money-check-dollar-pen\": $fa-var-money-check-dollar-pen,\n  \"money-check-edit-alt\": $fa-var-money-check-edit-alt,\n  \"money-check-pen\": $fa-var-money-check-pen,\n  \"money-check-edit\": $fa-var-money-check-edit,\n  \"money-from-bracket\": $fa-var-money-from-bracket,\n  \"money-simple-from-bracket\": $fa-var-money-simple-from-bracket,\n  \"monitor-waveform\": $fa-var-monitor-waveform,\n  \"monitor-heart-rate\": $fa-var-monitor-heart-rate,\n  \"monkey\": $fa-var-monkey,\n  \"monument\": $fa-var-monument,\n  \"moon\": $fa-var-moon,\n  \"moon-cloud\": $fa-var-moon-cloud,\n  \"moon-over-sun\": $fa-var-moon-over-sun,\n  \"eclipse-alt\": $fa-var-eclipse-alt,\n  \"moon-stars\": $fa-var-moon-stars,\n  \"moped\": $fa-var-moped,\n  \"mortar-pestle\": $fa-var-mortar-pestle,\n  \"mosque\": $fa-var-mosque,\n  \"motorcycle\": $fa-var-motorcycle,\n  \"mountain\": $fa-var-mountain,\n  \"mountains\": $fa-var-mountains,\n  \"mp3-player\": $fa-var-mp3-player,\n  \"mug\": $fa-var-mug,\n  \"mug-hot\": $fa-var-mug-hot,\n  \"mug-marshmallows\": $fa-var-mug-marshmallows,\n  \"mug-saucer\": $fa-var-mug-saucer,\n  \"coffee\": $fa-var-coffee,\n  \"mug-tea\": $fa-var-mug-tea,\n  \"mug-tea-saucer\": $fa-var-mug-tea-saucer,\n  \"mushroom\": $fa-var-mushroom,\n  \"music\": $fa-var-music,\n  \"music-note\": $fa-var-music-note,\n  \"music-alt\": $fa-var-music-alt,\n  \"music-note-slash\": $fa-var-music-note-slash,\n  \"music-alt-slash\": $fa-var-music-alt-slash,\n  \"music-slash\": $fa-var-music-slash,\n  \"n\": $fa-var-n,\n  \"naira-sign\": $fa-var-naira-sign,\n  \"narwhal\": $fa-var-narwhal,\n  \"nesting-dolls\": $fa-var-nesting-dolls,\n  \"network-wired\": $fa-var-network-wired,\n  \"neuter\": $fa-var-neuter,\n  \"newspaper\": $fa-var-newspaper,\n  \"nfc\": $fa-var-nfc,\n  \"nfc-lock\": $fa-var-nfc-lock,\n  \"nfc-magnifying-glass\": $fa-var-nfc-magnifying-glass,\n  \"nfc-pen\": $fa-var-nfc-pen,\n  \"nfc-signal\": $fa-var-nfc-signal,\n  \"nfc-slash\": $fa-var-nfc-slash,\n  \"nfc-trash\": $fa-var-nfc-trash,\n  \"not-equal\": $fa-var-not-equal,\n  \"notdef\": $fa-var-notdef,\n  \"note\": $fa-var-note,\n  \"note-medical\": $fa-var-note-medical,\n  \"note-sticky\": $fa-var-note-sticky,\n  \"sticky-note\": $fa-var-sticky-note,\n  \"notebook\": $fa-var-notebook,\n  \"notes\": $fa-var-notes,\n  \"notes-medical\": $fa-var-notes-medical,\n  \"o\": $fa-var-o,\n  \"object-group\": $fa-var-object-group,\n  \"object-ungroup\": $fa-var-object-ungroup,\n  \"objects-align-bottom\": $fa-var-objects-align-bottom,\n  \"objects-align-center-horizontal\": $fa-var-objects-align-center-horizontal,\n  \"objects-align-center-vertical\": $fa-var-objects-align-center-vertical,\n  \"objects-align-left\": $fa-var-objects-align-left,\n  \"objects-align-right\": $fa-var-objects-align-right,\n  \"objects-align-top\": $fa-var-objects-align-top,\n  \"objects-column\": $fa-var-objects-column,\n  \"octagon\": $fa-var-octagon,\n  \"octagon-check\": $fa-var-octagon-check,\n  \"octagon-divide\": $fa-var-octagon-divide,\n  \"octagon-exclamation\": $fa-var-octagon-exclamation,\n  \"octagon-minus\": $fa-var-octagon-minus,\n  \"minus-octagon\": $fa-var-minus-octagon,\n  \"octagon-plus\": $fa-var-octagon-plus,\n  \"plus-octagon\": $fa-var-plus-octagon,\n  \"octagon-xmark\": $fa-var-octagon-xmark,\n  \"times-octagon\": $fa-var-times-octagon,\n  \"xmark-octagon\": $fa-var-xmark-octagon,\n  \"oil-can\": $fa-var-oil-can,\n  \"oil-can-drip\": $fa-var-oil-can-drip,\n  \"oil-temperature\": $fa-var-oil-temperature,\n  \"oil-temp\": $fa-var-oil-temp,\n  \"olive\": $fa-var-olive,\n  \"olive-branch\": $fa-var-olive-branch,\n  \"om\": $fa-var-om,\n  \"omega\": $fa-var-omega,\n  \"onion\": $fa-var-onion,\n  \"option\": $fa-var-option,\n  \"ornament\": $fa-var-ornament,\n  \"otter\": $fa-var-otter,\n  \"outdent\": $fa-var-outdent,\n  \"dedent\": $fa-var-dedent,\n  \"outlet\": $fa-var-outlet,\n  \"oven\": $fa-var-oven,\n  \"overline\": $fa-var-overline,\n  \"p\": $fa-var-p,\n  \"page\": $fa-var-page,\n  \"page-caret-down\": $fa-var-page-caret-down,\n  \"file-caret-down\": $fa-var-file-caret-down,\n  \"page-caret-up\": $fa-var-page-caret-up,\n  \"file-caret-up\": $fa-var-file-caret-up,\n  \"pager\": $fa-var-pager,\n  \"paint-brush\": $fa-var-paint-brush,\n  \"paint-brush-fine\": $fa-var-paint-brush-fine,\n  \"paint-brush-alt\": $fa-var-paint-brush-alt,\n  \"paint-roller\": $fa-var-paint-roller,\n  \"paintbrush-pencil\": $fa-var-paintbrush-pencil,\n  \"palette\": $fa-var-palette,\n  \"pallet\": $fa-var-pallet,\n  \"pallet-box\": $fa-var-pallet-box,\n  \"pallet-boxes\": $fa-var-pallet-boxes,\n  \"palette-boxes\": $fa-var-palette-boxes,\n  \"pallet-alt\": $fa-var-pallet-alt,\n  \"pan-food\": $fa-var-pan-food,\n  \"pan-frying\": $fa-var-pan-frying,\n  \"pancakes\": $fa-var-pancakes,\n  \"panel-ews\": $fa-var-panel-ews,\n  \"panel-fire\": $fa-var-panel-fire,\n  \"panorama\": $fa-var-panorama,\n  \"paper-plane\": $fa-var-paper-plane,\n  \"paper-plane-top\": $fa-var-paper-plane-top,\n  \"paper-plane-alt\": $fa-var-paper-plane-alt,\n  \"send\": $fa-var-send,\n  \"paperclip\": $fa-var-paperclip,\n  \"paperclip-vertical\": $fa-var-paperclip-vertical,\n  \"parachute-box\": $fa-var-parachute-box,\n  \"paragraph\": $fa-var-paragraph,\n  \"paragraph-left\": $fa-var-paragraph-left,\n  \"paragraph-rtl\": $fa-var-paragraph-rtl,\n  \"party-bell\": $fa-var-party-bell,\n  \"party-horn\": $fa-var-party-horn,\n  \"passport\": $fa-var-passport,\n  \"paste\": $fa-var-paste,\n  \"file-clipboard\": $fa-var-file-clipboard,\n  \"pause\": $fa-var-pause,\n  \"paw\": $fa-var-paw,\n  \"paw-claws\": $fa-var-paw-claws,\n  \"paw-simple\": $fa-var-paw-simple,\n  \"paw-alt\": $fa-var-paw-alt,\n  \"peace\": $fa-var-peace,\n  \"peach\": $fa-var-peach,\n  \"peanut\": $fa-var-peanut,\n  \"peanuts\": $fa-var-peanuts,\n  \"peapod\": $fa-var-peapod,\n  \"pear\": $fa-var-pear,\n  \"pedestal\": $fa-var-pedestal,\n  \"pegasus\": $fa-var-pegasus,\n  \"pen\": $fa-var-pen,\n  \"pen-circle\": $fa-var-pen-circle,\n  \"pen-clip\": $fa-var-pen-clip,\n  \"pen-alt\": $fa-var-pen-alt,\n  \"pen-clip-slash\": $fa-var-pen-clip-slash,\n  \"pen-alt-slash\": $fa-var-pen-alt-slash,\n  \"pen-fancy\": $fa-var-pen-fancy,\n  \"pen-fancy-slash\": $fa-var-pen-fancy-slash,\n  \"pen-field\": $fa-var-pen-field,\n  \"pen-line\": $fa-var-pen-line,\n  \"pen-nib\": $fa-var-pen-nib,\n  \"pen-paintbrush\": $fa-var-pen-paintbrush,\n  \"pencil-paintbrush\": $fa-var-pencil-paintbrush,\n  \"pen-ruler\": $fa-var-pen-ruler,\n  \"pencil-ruler\": $fa-var-pencil-ruler,\n  \"pen-slash\": $fa-var-pen-slash,\n  \"pen-swirl\": $fa-var-pen-swirl,\n  \"pen-to-square\": $fa-var-pen-to-square,\n  \"edit\": $fa-var-edit,\n  \"pencil\": $fa-var-pencil,\n  \"pencil-alt\": $fa-var-pencil-alt,\n  \"pencil-slash\": $fa-var-pencil-slash,\n  \"people\": $fa-var-people,\n  \"people-arrows-left-right\": $fa-var-people-arrows-left-right,\n  \"people-arrows\": $fa-var-people-arrows,\n  \"people-carry-box\": $fa-var-people-carry-box,\n  \"people-carry\": $fa-var-people-carry,\n  \"people-dress\": $fa-var-people-dress,\n  \"people-dress-simple\": $fa-var-people-dress-simple,\n  \"people-pants\": $fa-var-people-pants,\n  \"people-pants-simple\": $fa-var-people-pants-simple,\n  \"people-simple\": $fa-var-people-simple,\n  \"pepper\": $fa-var-pepper,\n  \"pepper-hot\": $fa-var-pepper-hot,\n  \"percent\": $fa-var-percent,\n  \"percentage\": $fa-var-percentage,\n  \"period\": $fa-var-period,\n  \"person\": $fa-var-person,\n  \"male\": $fa-var-male,\n  \"person-biking\": $fa-var-person-biking,\n  \"biking\": $fa-var-biking,\n  \"person-biking-mountain\": $fa-var-person-biking-mountain,\n  \"biking-mountain\": $fa-var-biking-mountain,\n  \"person-booth\": $fa-var-person-booth,\n  \"person-carry-box\": $fa-var-person-carry-box,\n  \"person-carry\": $fa-var-person-carry,\n  \"person-digging\": $fa-var-person-digging,\n  \"digging\": $fa-var-digging,\n  \"person-dolly\": $fa-var-person-dolly,\n  \"person-dolly-empty\": $fa-var-person-dolly-empty,\n  \"person-dots-from-line\": $fa-var-person-dots-from-line,\n  \"diagnoses\": $fa-var-diagnoses,\n  \"person-dress\": $fa-var-person-dress,\n  \"female\": $fa-var-female,\n  \"person-dress-simple\": $fa-var-person-dress-simple,\n  \"person-from-portal\": $fa-var-person-from-portal,\n  \"portal-exit\": $fa-var-portal-exit,\n  \"person-hiking\": $fa-var-person-hiking,\n  \"hiking\": $fa-var-hiking,\n  \"person-pinball\": $fa-var-person-pinball,\n  \"person-praying\": $fa-var-person-praying,\n  \"pray\": $fa-var-pray,\n  \"person-pregnant\": $fa-var-person-pregnant,\n  \"person-running\": $fa-var-person-running,\n  \"running\": $fa-var-running,\n  \"person-seat\": $fa-var-person-seat,\n  \"person-seat-reclined\": $fa-var-person-seat-reclined,\n  \"person-sign\": $fa-var-person-sign,\n  \"person-simple\": $fa-var-person-simple,\n  \"person-skating\": $fa-var-person-skating,\n  \"skating\": $fa-var-skating,\n  \"person-ski-jumping\": $fa-var-person-ski-jumping,\n  \"ski-jump\": $fa-var-ski-jump,\n  \"person-ski-lift\": $fa-var-person-ski-lift,\n  \"ski-lift\": $fa-var-ski-lift,\n  \"person-skiing\": $fa-var-person-skiing,\n  \"skiing\": $fa-var-skiing,\n  \"person-skiing-nordic\": $fa-var-person-skiing-nordic,\n  \"skiing-nordic\": $fa-var-skiing-nordic,\n  \"person-sledding\": $fa-var-person-sledding,\n  \"sledding\": $fa-var-sledding,\n  \"person-snowboarding\": $fa-var-person-snowboarding,\n  \"snowboarding\": $fa-var-snowboarding,\n  \"person-snowmobiling\": $fa-var-person-snowmobiling,\n  \"snowmobile\": $fa-var-snowmobile,\n  \"person-swimming\": $fa-var-person-swimming,\n  \"swimmer\": $fa-var-swimmer,\n  \"person-to-door\": $fa-var-person-to-door,\n  \"person-to-portal\": $fa-var-person-to-portal,\n  \"portal-enter\": $fa-var-portal-enter,\n  \"person-walking\": $fa-var-person-walking,\n  \"walking\": $fa-var-walking,\n  \"person-walking-with-cane\": $fa-var-person-walking-with-cane,\n  \"blind\": $fa-var-blind,\n  \"peseta-sign\": $fa-var-peseta-sign,\n  \"peso-sign\": $fa-var-peso-sign,\n  \"phone\": $fa-var-phone,\n  \"phone-arrow-down-left\": $fa-var-phone-arrow-down-left,\n  \"phone-arrow-down\": $fa-var-phone-arrow-down,\n  \"phone-incoming\": $fa-var-phone-incoming,\n  \"phone-arrow-up-right\": $fa-var-phone-arrow-up-right,\n  \"phone-arrow-up\": $fa-var-phone-arrow-up,\n  \"phone-outgoing\": $fa-var-phone-outgoing,\n  \"phone-flip\": $fa-var-phone-flip,\n  \"phone-alt\": $fa-var-phone-alt,\n  \"phone-hangup\": $fa-var-phone-hangup,\n  \"phone-intercom\": $fa-var-phone-intercom,\n  \"phone-missed\": $fa-var-phone-missed,\n  \"phone-office\": $fa-var-phone-office,\n  \"phone-plus\": $fa-var-phone-plus,\n  \"phone-rotary\": $fa-var-phone-rotary,\n  \"phone-slash\": $fa-var-phone-slash,\n  \"phone-volume\": $fa-var-phone-volume,\n  \"volume-control-phone\": $fa-var-volume-control-phone,\n  \"phone-xmark\": $fa-var-phone-xmark,\n  \"photo-film\": $fa-var-photo-film,\n  \"photo-video\": $fa-var-photo-video,\n  \"photo-film-music\": $fa-var-photo-film-music,\n  \"pi\": $fa-var-pi,\n  \"piano\": $fa-var-piano,\n  \"piano-keyboard\": $fa-var-piano-keyboard,\n  \"pickleball\": $fa-var-pickleball,\n  \"pie\": $fa-var-pie,\n  \"pig\": $fa-var-pig,\n  \"piggy-bank\": $fa-var-piggy-bank,\n  \"pills\": $fa-var-pills,\n  \"pinata\": $fa-var-pinata,\n  \"pinball\": $fa-var-pinball,\n  \"pineapple\": $fa-var-pineapple,\n  \"pipe\": $fa-var-pipe,\n  \"pipe-circle-check\": $fa-var-pipe-circle-check,\n  \"pipe-collar\": $fa-var-pipe-collar,\n  \"pipe-section\": $fa-var-pipe-section,\n  \"pipe-smoking\": $fa-var-pipe-smoking,\n  \"pipe-valve\": $fa-var-pipe-valve,\n  \"pizza\": $fa-var-pizza,\n  \"pizza-slice\": $fa-var-pizza-slice,\n  \"place-of-worship\": $fa-var-place-of-worship,\n  \"plane\": $fa-var-plane,\n  \"plane-arrival\": $fa-var-plane-arrival,\n  \"plane-departure\": $fa-var-plane-departure,\n  \"plane-engines\": $fa-var-plane-engines,\n  \"plane-alt\": $fa-var-plane-alt,\n  \"plane-prop\": $fa-var-plane-prop,\n  \"plane-slash\": $fa-var-plane-slash,\n  \"plane-tail\": $fa-var-plane-tail,\n  \"plane-up\": $fa-var-plane-up,\n  \"plane-up-slash\": $fa-var-plane-up-slash,\n  \"planet-moon\": $fa-var-planet-moon,\n  \"planet-ringed\": $fa-var-planet-ringed,\n  \"plate-utensils\": $fa-var-plate-utensils,\n  \"play\": $fa-var-play,\n  \"play-pause\": $fa-var-play-pause,\n  \"plug\": $fa-var-plug,\n  \"plus\": $fa-var-plus,\n  \"add\": $fa-var-add,\n  \"plus-minus\": $fa-var-plus-minus,\n  \"podcast\": $fa-var-podcast,\n  \"podium\": $fa-var-podium,\n  \"podium-star\": $fa-var-podium-star,\n  \"police-box\": $fa-var-police-box,\n  \"poll-people\": $fa-var-poll-people,\n  \"pompebled\": $fa-var-pompebled,\n  \"poo\": $fa-var-poo,\n  \"poo-storm\": $fa-var-poo-storm,\n  \"poo-bolt\": $fa-var-poo-bolt,\n  \"pool-8-ball\": $fa-var-pool-8-ball,\n  \"poop\": $fa-var-poop,\n  \"popcorn\": $fa-var-popcorn,\n  \"popsicle\": $fa-var-popsicle,\n  \"pot-food\": $fa-var-pot-food,\n  \"potato\": $fa-var-potato,\n  \"power-off\": $fa-var-power-off,\n  \"prescription\": $fa-var-prescription,\n  \"prescription-bottle\": $fa-var-prescription-bottle,\n  \"prescription-bottle-medical\": $fa-var-prescription-bottle-medical,\n  \"prescription-bottle-alt\": $fa-var-prescription-bottle-alt,\n  \"presentation-screen\": $fa-var-presentation-screen,\n  \"presentation\": $fa-var-presentation,\n  \"pretzel\": $fa-var-pretzel,\n  \"print\": $fa-var-print,\n  \"print-magnifying-glass\": $fa-var-print-magnifying-glass,\n  \"print-search\": $fa-var-print-search,\n  \"print-slash\": $fa-var-print-slash,\n  \"projector\": $fa-var-projector,\n  \"pump\": $fa-var-pump,\n  \"pump-medical\": $fa-var-pump-medical,\n  \"pump-soap\": $fa-var-pump-soap,\n  \"pumpkin\": $fa-var-pumpkin,\n  \"puzzle\": $fa-var-puzzle,\n  \"puzzle-piece\": $fa-var-puzzle-piece,\n  \"puzzle-piece-simple\": $fa-var-puzzle-piece-simple,\n  \"puzzle-piece-alt\": $fa-var-puzzle-piece-alt,\n  \"q\": $fa-var-q,\n  \"qrcode\": $fa-var-qrcode,\n  \"question\": $fa-var-question,\n  \"quidditch\": $fa-var-quidditch,\n  \"broom-ball\": $fa-var-broom-ball,\n  \"quidditch-broom-ball\": $fa-var-quidditch-broom-ball,\n  \"quote-left\": $fa-var-quote-left,\n  \"quote-left-alt\": $fa-var-quote-left-alt,\n  \"quote-right\": $fa-var-quote-right,\n  \"quote-right-alt\": $fa-var-quote-right-alt,\n  \"quotes\": $fa-var-quotes,\n  \"r\": $fa-var-r,\n  \"rabbit\": $fa-var-rabbit,\n  \"rabbit-running\": $fa-var-rabbit-running,\n  \"rabbit-fast\": $fa-var-rabbit-fast,\n  \"racquet\": $fa-var-racquet,\n  \"radar\": $fa-var-radar,\n  \"radiation\": $fa-var-radiation,\n  \"radio\": $fa-var-radio,\n  \"radio-tuner\": $fa-var-radio-tuner,\n  \"radio-alt\": $fa-var-radio-alt,\n  \"rainbow\": $fa-var-rainbow,\n  \"raindrops\": $fa-var-raindrops,\n  \"ram\": $fa-var-ram,\n  \"ramp-loading\": $fa-var-ramp-loading,\n  \"raygun\": $fa-var-raygun,\n  \"receipt\": $fa-var-receipt,\n  \"record-vinyl\": $fa-var-record-vinyl,\n  \"rectangle\": $fa-var-rectangle,\n  \"rectangle-landscape\": $fa-var-rectangle-landscape,\n  \"rectangle-ad\": $fa-var-rectangle-ad,\n  \"ad\": $fa-var-ad,\n  \"rectangle-barcode\": $fa-var-rectangle-barcode,\n  \"barcode-alt\": $fa-var-barcode-alt,\n  \"rectangle-code\": $fa-var-rectangle-code,\n  \"rectangle-list\": $fa-var-rectangle-list,\n  \"list-alt\": $fa-var-list-alt,\n  \"rectangle-pro\": $fa-var-rectangle-pro,\n  \"pro\": $fa-var-pro,\n  \"rectangle-terminal\": $fa-var-rectangle-terminal,\n  \"rectangle-vertical\": $fa-var-rectangle-vertical,\n  \"rectangle-portrait\": $fa-var-rectangle-portrait,\n  \"rectangle-vertical-history\": $fa-var-rectangle-vertical-history,\n  \"rectangle-wide\": $fa-var-rectangle-wide,\n  \"rectangle-xmark\": $fa-var-rectangle-xmark,\n  \"rectangle-times\": $fa-var-rectangle-times,\n  \"times-rectangle\": $fa-var-times-rectangle,\n  \"window-close\": $fa-var-window-close,\n  \"rectangles-mixed\": $fa-var-rectangles-mixed,\n  \"recycle\": $fa-var-recycle,\n  \"reel\": $fa-var-reel,\n  \"refrigerator\": $fa-var-refrigerator,\n  \"registered\": $fa-var-registered,\n  \"repeat\": $fa-var-repeat,\n  \"repeat-1\": $fa-var-repeat-1,\n  \"reply\": $fa-var-reply,\n  \"mail-reply\": $fa-var-mail-reply,\n  \"reply-all\": $fa-var-reply-all,\n  \"mail-reply-all\": $fa-var-mail-reply-all,\n  \"reply-clock\": $fa-var-reply-clock,\n  \"reply-time\": $fa-var-reply-time,\n  \"republican\": $fa-var-republican,\n  \"restroom\": $fa-var-restroom,\n  \"restroom-simple\": $fa-var-restroom-simple,\n  \"retweet\": $fa-var-retweet,\n  \"rhombus\": $fa-var-rhombus,\n  \"ribbon\": $fa-var-ribbon,\n  \"right\": $fa-var-right,\n  \"arrow-alt-right\": $fa-var-arrow-alt-right,\n  \"right-from-bracket\": $fa-var-right-from-bracket,\n  \"sign-out-alt\": $fa-var-sign-out-alt,\n  \"right-from-line\": $fa-var-right-from-line,\n  \"arrow-alt-from-left\": $fa-var-arrow-alt-from-left,\n  \"right-left\": $fa-var-right-left,\n  \"exchange-alt\": $fa-var-exchange-alt,\n  \"right-long\": $fa-var-right-long,\n  \"long-arrow-alt-right\": $fa-var-long-arrow-alt-right,\n  \"right-long-to-line\": $fa-var-right-long-to-line,\n  \"right-to-bracket\": $fa-var-right-to-bracket,\n  \"sign-in-alt\": $fa-var-sign-in-alt,\n  \"right-to-line\": $fa-var-right-to-line,\n  \"arrow-alt-to-right\": $fa-var-arrow-alt-to-right,\n  \"ring\": $fa-var-ring,\n  \"rings-wedding\": $fa-var-rings-wedding,\n  \"road\": $fa-var-road,\n  \"robot\": $fa-var-robot,\n  \"robot-astromech\": $fa-var-robot-astromech,\n  \"rocket\": $fa-var-rocket,\n  \"rocket-launch\": $fa-var-rocket-launch,\n  \"roller-coaster\": $fa-var-roller-coaster,\n  \"rotate\": $fa-var-rotate,\n  \"sync-alt\": $fa-var-sync-alt,\n  \"rotate-exclamation\": $fa-var-rotate-exclamation,\n  \"rotate-left\": $fa-var-rotate-left,\n  \"rotate-back\": $fa-var-rotate-back,\n  \"rotate-backward\": $fa-var-rotate-backward,\n  \"undo-alt\": $fa-var-undo-alt,\n  \"rotate-right\": $fa-var-rotate-right,\n  \"redo-alt\": $fa-var-redo-alt,\n  \"rotate-forward\": $fa-var-rotate-forward,\n  \"route\": $fa-var-route,\n  \"route-highway\": $fa-var-route-highway,\n  \"route-interstate\": $fa-var-route-interstate,\n  \"router\": $fa-var-router,\n  \"rss\": $fa-var-rss,\n  \"feed\": $fa-var-feed,\n  \"ruble-sign\": $fa-var-ruble-sign,\n  \"rouble\": $fa-var-rouble,\n  \"rub\": $fa-var-rub,\n  \"ruble\": $fa-var-ruble,\n  \"rugby-ball\": $fa-var-rugby-ball,\n  \"ruler\": $fa-var-ruler,\n  \"ruler-combined\": $fa-var-ruler-combined,\n  \"ruler-horizontal\": $fa-var-ruler-horizontal,\n  \"ruler-triangle\": $fa-var-ruler-triangle,\n  \"ruler-vertical\": $fa-var-ruler-vertical,\n  \"rupee-sign\": $fa-var-rupee-sign,\n  \"rupee\": $fa-var-rupee,\n  \"rupiah-sign\": $fa-var-rupiah-sign,\n  \"rv\": $fa-var-rv,\n  \"s\": $fa-var-s,\n  \"sack\": $fa-var-sack,\n  \"sack-dollar\": $fa-var-sack-dollar,\n  \"sailboat\": $fa-var-sailboat,\n  \"salad\": $fa-var-salad,\n  \"bowl-salad\": $fa-var-bowl-salad,\n  \"salt-shaker\": $fa-var-salt-shaker,\n  \"sandwich\": $fa-var-sandwich,\n  \"satellite\": $fa-var-satellite,\n  \"satellite-dish\": $fa-var-satellite-dish,\n  \"sausage\": $fa-var-sausage,\n  \"saxophone\": $fa-var-saxophone,\n  \"saxophone-fire\": $fa-var-saxophone-fire,\n  \"sax-hot\": $fa-var-sax-hot,\n  \"scale-balanced\": $fa-var-scale-balanced,\n  \"balance-scale\": $fa-var-balance-scale,\n  \"scale-unbalanced\": $fa-var-scale-unbalanced,\n  \"balance-scale-left\": $fa-var-balance-scale-left,\n  \"scale-unbalanced-flip\": $fa-var-scale-unbalanced-flip,\n  \"balance-scale-right\": $fa-var-balance-scale-right,\n  \"scalpel\": $fa-var-scalpel,\n  \"scalpel-line-dashed\": $fa-var-scalpel-line-dashed,\n  \"scalpel-path\": $fa-var-scalpel-path,\n  \"scanner\": $fa-var-scanner,\n  \"scanner-image\": $fa-var-scanner-image,\n  \"scanner-gun\": $fa-var-scanner-gun,\n  \"scanner-keyboard\": $fa-var-scanner-keyboard,\n  \"scanner-touchscreen\": $fa-var-scanner-touchscreen,\n  \"scarecrow\": $fa-var-scarecrow,\n  \"scarf\": $fa-var-scarf,\n  \"school\": $fa-var-school,\n  \"scissors\": $fa-var-scissors,\n  \"cut\": $fa-var-cut,\n  \"screen-users\": $fa-var-screen-users,\n  \"users-class\": $fa-var-users-class,\n  \"screencast\": $fa-var-screencast,\n  \"screwdriver\": $fa-var-screwdriver,\n  \"screwdriver-wrench\": $fa-var-screwdriver-wrench,\n  \"tools\": $fa-var-tools,\n  \"scribble\": $fa-var-scribble,\n  \"scroll\": $fa-var-scroll,\n  \"scroll-old\": $fa-var-scroll-old,\n  \"scroll-torah\": $fa-var-scroll-torah,\n  \"torah\": $fa-var-torah,\n  \"scrubber\": $fa-var-scrubber,\n  \"scythe\": $fa-var-scythe,\n  \"sd-card\": $fa-var-sd-card,\n  \"sd-cards\": $fa-var-sd-cards,\n  \"seal\": $fa-var-seal,\n  \"seal-exclamation\": $fa-var-seal-exclamation,\n  \"seal-question\": $fa-var-seal-question,\n  \"seat-airline\": $fa-var-seat-airline,\n  \"section\": $fa-var-section,\n  \"seedling\": $fa-var-seedling,\n  \"sprout\": $fa-var-sprout,\n  \"semicolon\": $fa-var-semicolon,\n  \"send-back\": $fa-var-send-back,\n  \"send-backward\": $fa-var-send-backward,\n  \"sensor\": $fa-var-sensor,\n  \"sensor-cloud\": $fa-var-sensor-cloud,\n  \"sensor-smoke\": $fa-var-sensor-smoke,\n  \"sensor-fire\": $fa-var-sensor-fire,\n  \"sensor-on\": $fa-var-sensor-on,\n  \"sensor-triangle-exclamation\": $fa-var-sensor-triangle-exclamation,\n  \"sensor-alert\": $fa-var-sensor-alert,\n  \"server\": $fa-var-server,\n  \"shapes\": $fa-var-shapes,\n  \"triangle-circle-square\": $fa-var-triangle-circle-square,\n  \"share\": $fa-var-share,\n  \"arrow-turn-right\": $fa-var-arrow-turn-right,\n  \"mail-forward\": $fa-var-mail-forward,\n  \"share-all\": $fa-var-share-all,\n  \"arrows-turn-right\": $fa-var-arrows-turn-right,\n  \"share-from-square\": $fa-var-share-from-square,\n  \"share-square\": $fa-var-share-square,\n  \"share-nodes\": $fa-var-share-nodes,\n  \"share-alt\": $fa-var-share-alt,\n  \"sheep\": $fa-var-sheep,\n  \"shekel-sign\": $fa-var-shekel-sign,\n  \"ils\": $fa-var-ils,\n  \"shekel\": $fa-var-shekel,\n  \"sheqel\": $fa-var-sheqel,\n  \"sheqel-sign\": $fa-var-sheqel-sign,\n  \"shelves\": $fa-var-shelves,\n  \"inventory\": $fa-var-inventory,\n  \"shelves-empty\": $fa-var-shelves-empty,\n  \"shield\": $fa-var-shield,\n  \"shield-blank\": $fa-var-shield-blank,\n  \"shield-alt\": $fa-var-shield-alt,\n  \"shield-check\": $fa-var-shield-check,\n  \"shield-cross\": $fa-var-shield-cross,\n  \"shield-exclamation\": $fa-var-shield-exclamation,\n  \"shield-keyhole\": $fa-var-shield-keyhole,\n  \"shield-minus\": $fa-var-shield-minus,\n  \"shield-plus\": $fa-var-shield-plus,\n  \"shield-slash\": $fa-var-shield-slash,\n  \"shield-virus\": $fa-var-shield-virus,\n  \"shield-xmark\": $fa-var-shield-xmark,\n  \"shield-times\": $fa-var-shield-times,\n  \"ship\": $fa-var-ship,\n  \"shirt\": $fa-var-shirt,\n  \"t-shirt\": $fa-var-t-shirt,\n  \"tshirt\": $fa-var-tshirt,\n  \"shirt-long-sleeve\": $fa-var-shirt-long-sleeve,\n  \"shirt-running\": $fa-var-shirt-running,\n  \"shirt-tank-top\": $fa-var-shirt-tank-top,\n  \"shish-kebab\": $fa-var-shish-kebab,\n  \"shoe-prints\": $fa-var-shoe-prints,\n  \"shop\": $fa-var-shop,\n  \"store-alt\": $fa-var-store-alt,\n  \"shop-slash\": $fa-var-shop-slash,\n  \"store-alt-slash\": $fa-var-store-alt-slash,\n  \"shovel\": $fa-var-shovel,\n  \"shovel-snow\": $fa-var-shovel-snow,\n  \"shower\": $fa-var-shower,\n  \"shower-down\": $fa-var-shower-down,\n  \"shower-alt\": $fa-var-shower-alt,\n  \"shredder\": $fa-var-shredder,\n  \"shrimp\": $fa-var-shrimp,\n  \"shuffle\": $fa-var-shuffle,\n  \"random\": $fa-var-random,\n  \"shutters\": $fa-var-shutters,\n  \"shuttle-space\": $fa-var-shuttle-space,\n  \"space-shuttle\": $fa-var-space-shuttle,\n  \"shuttlecock\": $fa-var-shuttlecock,\n  \"sickle\": $fa-var-sickle,\n  \"sidebar\": $fa-var-sidebar,\n  \"sidebar-flip\": $fa-var-sidebar-flip,\n  \"sigma\": $fa-var-sigma,\n  \"sign-hanging\": $fa-var-sign-hanging,\n  \"sign\": $fa-var-sign,\n  \"signal\": $fa-var-signal,\n  \"signal-5\": $fa-var-signal-5,\n  \"signal-perfect\": $fa-var-signal-perfect,\n  \"signal-bars\": $fa-var-signal-bars,\n  \"signal-alt\": $fa-var-signal-alt,\n  \"signal-alt-4\": $fa-var-signal-alt-4,\n  \"signal-bars-strong\": $fa-var-signal-bars-strong,\n  \"signal-bars-fair\": $fa-var-signal-bars-fair,\n  \"signal-alt-2\": $fa-var-signal-alt-2,\n  \"signal-bars-good\": $fa-var-signal-bars-good,\n  \"signal-alt-3\": $fa-var-signal-alt-3,\n  \"signal-bars-slash\": $fa-var-signal-bars-slash,\n  \"signal-alt-slash\": $fa-var-signal-alt-slash,\n  \"signal-bars-weak\": $fa-var-signal-bars-weak,\n  \"signal-alt-1\": $fa-var-signal-alt-1,\n  \"signal-fair\": $fa-var-signal-fair,\n  \"signal-2\": $fa-var-signal-2,\n  \"signal-good\": $fa-var-signal-good,\n  \"signal-3\": $fa-var-signal-3,\n  \"signal-slash\": $fa-var-signal-slash,\n  \"signal-stream\": $fa-var-signal-stream,\n  \"signal-stream-slash\": $fa-var-signal-stream-slash,\n  \"signal-strong\": $fa-var-signal-strong,\n  \"signal-4\": $fa-var-signal-4,\n  \"signal-weak\": $fa-var-signal-weak,\n  \"signal-1\": $fa-var-signal-1,\n  \"signature\": $fa-var-signature,\n  \"signature-lock\": $fa-var-signature-lock,\n  \"signature-slash\": $fa-var-signature-slash,\n  \"signs-post\": $fa-var-signs-post,\n  \"map-signs\": $fa-var-map-signs,\n  \"sim-card\": $fa-var-sim-card,\n  \"sim-cards\": $fa-var-sim-cards,\n  \"sink\": $fa-var-sink,\n  \"siren\": $fa-var-siren,\n  \"siren-on\": $fa-var-siren-on,\n  \"sitemap\": $fa-var-sitemap,\n  \"skeleton\": $fa-var-skeleton,\n  \"ski-boot\": $fa-var-ski-boot,\n  \"ski-boot-ski\": $fa-var-ski-boot-ski,\n  \"skull\": $fa-var-skull,\n  \"skull-cow\": $fa-var-skull-cow,\n  \"skull-crossbones\": $fa-var-skull-crossbones,\n  \"slash\": $fa-var-slash,\n  \"slash-back\": $fa-var-slash-back,\n  \"slash-forward\": $fa-var-slash-forward,\n  \"sleigh\": $fa-var-sleigh,\n  \"slider\": $fa-var-slider,\n  \"sliders\": $fa-var-sliders,\n  \"sliders-h\": $fa-var-sliders-h,\n  \"sliders-simple\": $fa-var-sliders-simple,\n  \"sliders-up\": $fa-var-sliders-up,\n  \"sliders-v\": $fa-var-sliders-v,\n  \"slot-machine\": $fa-var-slot-machine,\n  \"smog\": $fa-var-smog,\n  \"smoke\": $fa-var-smoke,\n  \"smoking\": $fa-var-smoking,\n  \"snake\": $fa-var-snake,\n  \"snooze\": $fa-var-snooze,\n  \"zzz\": $fa-var-zzz,\n  \"snow-blowing\": $fa-var-snow-blowing,\n  \"snowflake\": $fa-var-snowflake,\n  \"snowflakes\": $fa-var-snowflakes,\n  \"snowman\": $fa-var-snowman,\n  \"snowman-head\": $fa-var-snowman-head,\n  \"frosty-head\": $fa-var-frosty-head,\n  \"snowplow\": $fa-var-snowplow,\n  \"soap\": $fa-var-soap,\n  \"socks\": $fa-var-socks,\n  \"solar-panel\": $fa-var-solar-panel,\n  \"solar-system\": $fa-var-solar-system,\n  \"sort\": $fa-var-sort,\n  \"unsorted\": $fa-var-unsorted,\n  \"sort-down\": $fa-var-sort-down,\n  \"sort-desc\": $fa-var-sort-desc,\n  \"sort-up\": $fa-var-sort-up,\n  \"sort-asc\": $fa-var-sort-asc,\n  \"spa\": $fa-var-spa,\n  \"space-station-moon\": $fa-var-space-station-moon,\n  \"space-station-moon-construction\": $fa-var-space-station-moon-construction,\n  \"space-station-moon-alt\": $fa-var-space-station-moon-alt,\n  \"spade\": $fa-var-spade,\n  \"spaghetti-monster-flying\": $fa-var-spaghetti-monster-flying,\n  \"pastafarianism\": $fa-var-pastafarianism,\n  \"sparkles\": $fa-var-sparkles,\n  \"speaker\": $fa-var-speaker,\n  \"speakers\": $fa-var-speakers,\n  \"spell-check\": $fa-var-spell-check,\n  \"spider\": $fa-var-spider,\n  \"spider-black-widow\": $fa-var-spider-black-widow,\n  \"spider-web\": $fa-var-spider-web,\n  \"spinner\": $fa-var-spinner,\n  \"spinner-third\": $fa-var-spinner-third,\n  \"split\": $fa-var-split,\n  \"splotch\": $fa-var-splotch,\n  \"spoon\": $fa-var-spoon,\n  \"utensil-spoon\": $fa-var-utensil-spoon,\n  \"sportsball\": $fa-var-sportsball,\n  \"spray-can\": $fa-var-spray-can,\n  \"spray-can-sparkles\": $fa-var-spray-can-sparkles,\n  \"air-freshener\": $fa-var-air-freshener,\n  \"sprinkler\": $fa-var-sprinkler,\n  \"sprinkler-ceiling\": $fa-var-sprinkler-ceiling,\n  \"square\": $fa-var-square,\n  \"square-0\": $fa-var-square-0,\n  \"square-1\": $fa-var-square-1,\n  \"square-2\": $fa-var-square-2,\n  \"square-3\": $fa-var-square-3,\n  \"square-4\": $fa-var-square-4,\n  \"square-5\": $fa-var-square-5,\n  \"square-6\": $fa-var-square-6,\n  \"square-7\": $fa-var-square-7,\n  \"square-8\": $fa-var-square-8,\n  \"square-9\": $fa-var-square-9,\n  \"square-a\": $fa-var-square-a,\n  \"square-a-lock\": $fa-var-square-a-lock,\n  \"square-ampersand\": $fa-var-square-ampersand,\n  \"square-arrow-down\": $fa-var-square-arrow-down,\n  \"arrow-square-down\": $fa-var-arrow-square-down,\n  \"square-arrow-down-left\": $fa-var-square-arrow-down-left,\n  \"square-arrow-down-right\": $fa-var-square-arrow-down-right,\n  \"square-arrow-left\": $fa-var-square-arrow-left,\n  \"arrow-square-left\": $fa-var-arrow-square-left,\n  \"square-arrow-right\": $fa-var-square-arrow-right,\n  \"arrow-square-right\": $fa-var-arrow-square-right,\n  \"square-arrow-up\": $fa-var-square-arrow-up,\n  \"arrow-square-up\": $fa-var-arrow-square-up,\n  \"square-arrow-up-left\": $fa-var-square-arrow-up-left,\n  \"square-arrow-up-right\": $fa-var-square-arrow-up-right,\n  \"external-link-square\": $fa-var-external-link-square,\n  \"square-b\": $fa-var-square-b,\n  \"square-bolt\": $fa-var-square-bolt,\n  \"square-c\": $fa-var-square-c,\n  \"square-caret-down\": $fa-var-square-caret-down,\n  \"caret-square-down\": $fa-var-caret-square-down,\n  \"square-caret-left\": $fa-var-square-caret-left,\n  \"caret-square-left\": $fa-var-caret-square-left,\n  \"square-caret-right\": $fa-var-square-caret-right,\n  \"caret-square-right\": $fa-var-caret-square-right,\n  \"square-caret-up\": $fa-var-square-caret-up,\n  \"caret-square-up\": $fa-var-caret-square-up,\n  \"square-check\": $fa-var-square-check,\n  \"check-square\": $fa-var-check-square,\n  \"square-chevron-down\": $fa-var-square-chevron-down,\n  \"chevron-square-down\": $fa-var-chevron-square-down,\n  \"square-chevron-left\": $fa-var-square-chevron-left,\n  \"chevron-square-left\": $fa-var-chevron-square-left,\n  \"square-chevron-right\": $fa-var-square-chevron-right,\n  \"chevron-square-right\": $fa-var-chevron-square-right,\n  \"square-chevron-up\": $fa-var-square-chevron-up,\n  \"chevron-square-up\": $fa-var-chevron-square-up,\n  \"square-code\": $fa-var-square-code,\n  \"square-d\": $fa-var-square-d,\n  \"square-dashed\": $fa-var-square-dashed,\n  \"square-divide\": $fa-var-square-divide,\n  \"square-dollar\": $fa-var-square-dollar,\n  \"dollar-square\": $fa-var-dollar-square,\n  \"usd-square\": $fa-var-usd-square,\n  \"square-down\": $fa-var-square-down,\n  \"arrow-alt-square-down\": $fa-var-arrow-alt-square-down,\n  \"square-down-left\": $fa-var-square-down-left,\n  \"square-down-right\": $fa-var-square-down-right,\n  \"square-e\": $fa-var-square-e,\n  \"square-ellipsis\": $fa-var-square-ellipsis,\n  \"square-ellipsis-vertical\": $fa-var-square-ellipsis-vertical,\n  \"square-envelope\": $fa-var-square-envelope,\n  \"envelope-square\": $fa-var-envelope-square,\n  \"square-exclamation\": $fa-var-square-exclamation,\n  \"exclamation-square\": $fa-var-exclamation-square,\n  \"square-f\": $fa-var-square-f,\n  \"square-fragile\": $fa-var-square-fragile,\n  \"box-fragile\": $fa-var-box-fragile,\n  \"square-wine-glass-crack\": $fa-var-square-wine-glass-crack,\n  \"square-full\": $fa-var-square-full,\n  \"square-g\": $fa-var-square-g,\n  \"square-h\": $fa-var-square-h,\n  \"h-square\": $fa-var-h-square,\n  \"square-heart\": $fa-var-square-heart,\n  \"heart-square\": $fa-var-heart-square,\n  \"square-i\": $fa-var-square-i,\n  \"square-info\": $fa-var-square-info,\n  \"info-square\": $fa-var-info-square,\n  \"square-j\": $fa-var-square-j,\n  \"square-k\": $fa-var-square-k,\n  \"square-l\": $fa-var-square-l,\n  \"square-left\": $fa-var-square-left,\n  \"arrow-alt-square-left\": $fa-var-arrow-alt-square-left,\n  \"square-m\": $fa-var-square-m,\n  \"square-minus\": $fa-var-square-minus,\n  \"minus-square\": $fa-var-minus-square,\n  \"square-n\": $fa-var-square-n,\n  \"square-o\": $fa-var-square-o,\n  \"square-p\": $fa-var-square-p,\n  \"square-parking\": $fa-var-square-parking,\n  \"parking\": $fa-var-parking,\n  \"square-parking-slash\": $fa-var-square-parking-slash,\n  \"parking-slash\": $fa-var-parking-slash,\n  \"square-pen\": $fa-var-square-pen,\n  \"pen-square\": $fa-var-pen-square,\n  \"pencil-square\": $fa-var-pencil-square,\n  \"square-phone\": $fa-var-square-phone,\n  \"phone-square\": $fa-var-phone-square,\n  \"square-phone-flip\": $fa-var-square-phone-flip,\n  \"phone-square-alt\": $fa-var-phone-square-alt,\n  \"square-phone-hangup\": $fa-var-square-phone-hangup,\n  \"phone-square-down\": $fa-var-phone-square-down,\n  \"square-plus\": $fa-var-square-plus,\n  \"plus-square\": $fa-var-plus-square,\n  \"square-poll-horizontal\": $fa-var-square-poll-horizontal,\n  \"poll-h\": $fa-var-poll-h,\n  \"square-poll-vertical\": $fa-var-square-poll-vertical,\n  \"poll\": $fa-var-poll,\n  \"square-q\": $fa-var-square-q,\n  \"square-quarters\": $fa-var-square-quarters,\n  \"square-question\": $fa-var-square-question,\n  \"question-square\": $fa-var-question-square,\n  \"square-quote\": $fa-var-square-quote,\n  \"square-r\": $fa-var-square-r,\n  \"square-right\": $fa-var-square-right,\n  \"arrow-alt-square-right\": $fa-var-arrow-alt-square-right,\n  \"square-ring\": $fa-var-square-ring,\n  \"square-root\": $fa-var-square-root,\n  \"square-root-variable\": $fa-var-square-root-variable,\n  \"square-root-alt\": $fa-var-square-root-alt,\n  \"square-rss\": $fa-var-square-rss,\n  \"rss-square\": $fa-var-rss-square,\n  \"square-s\": $fa-var-square-s,\n  \"square-share-nodes\": $fa-var-square-share-nodes,\n  \"share-alt-square\": $fa-var-share-alt-square,\n  \"square-sliders\": $fa-var-square-sliders,\n  \"sliders-h-square\": $fa-var-sliders-h-square,\n  \"square-sliders-vertical\": $fa-var-square-sliders-vertical,\n  \"sliders-v-square\": $fa-var-sliders-v-square,\n  \"square-small\": $fa-var-square-small,\n  \"square-star\": $fa-var-square-star,\n  \"square-t\": $fa-var-square-t,\n  \"square-terminal\": $fa-var-square-terminal,\n  \"square-this-way-up\": $fa-var-square-this-way-up,\n  \"box-up\": $fa-var-box-up,\n  \"square-u\": $fa-var-square-u,\n  \"square-up\": $fa-var-square-up,\n  \"arrow-alt-square-up\": $fa-var-arrow-alt-square-up,\n  \"square-up-left\": $fa-var-square-up-left,\n  \"square-up-right\": $fa-var-square-up-right,\n  \"external-link-square-alt\": $fa-var-external-link-square-alt,\n  \"square-user\": $fa-var-square-user,\n  \"square-v\": $fa-var-square-v,\n  \"square-w\": $fa-var-square-w,\n  \"square-x\": $fa-var-square-x,\n  \"square-xmark\": $fa-var-square-xmark,\n  \"times-square\": $fa-var-times-square,\n  \"xmark-square\": $fa-var-xmark-square,\n  \"square-y\": $fa-var-square-y,\n  \"square-z\": $fa-var-square-z,\n  \"squid\": $fa-var-squid,\n  \"squirrel\": $fa-var-squirrel,\n  \"staff\": $fa-var-staff,\n  \"stairs\": $fa-var-stairs,\n  \"stamp\": $fa-var-stamp,\n  \"standard-definition\": $fa-var-standard-definition,\n  \"rectangle-sd\": $fa-var-rectangle-sd,\n  \"star\": $fa-var-star,\n  \"star-and-crescent\": $fa-var-star-and-crescent,\n  \"star-christmas\": $fa-var-star-christmas,\n  \"star-exclamation\": $fa-var-star-exclamation,\n  \"star-half\": $fa-var-star-half,\n  \"star-half-stroke\": $fa-var-star-half-stroke,\n  \"star-half-alt\": $fa-var-star-half-alt,\n  \"star-of-david\": $fa-var-star-of-david,\n  \"star-of-life\": $fa-var-star-of-life,\n  \"star-sharp\": $fa-var-star-sharp,\n  \"star-sharp-half\": $fa-var-star-sharp-half,\n  \"star-sharp-half-stroke\": $fa-var-star-sharp-half-stroke,\n  \"star-sharp-half-alt\": $fa-var-star-sharp-half-alt,\n  \"star-shooting\": $fa-var-star-shooting,\n  \"starfighter\": $fa-var-starfighter,\n  \"starfighter-twin-ion-engine\": $fa-var-starfighter-twin-ion-engine,\n  \"starfighter-alt\": $fa-var-starfighter-alt,\n  \"starfighter-twin-ion-engine-advanced\": $fa-var-starfighter-twin-ion-engine-advanced,\n  \"starfighter-alt-advanced\": $fa-var-starfighter-alt-advanced,\n  \"stars\": $fa-var-stars,\n  \"starship\": $fa-var-starship,\n  \"starship-freighter\": $fa-var-starship-freighter,\n  \"steak\": $fa-var-steak,\n  \"steering-wheel\": $fa-var-steering-wheel,\n  \"sterling-sign\": $fa-var-sterling-sign,\n  \"gbp\": $fa-var-gbp,\n  \"pound-sign\": $fa-var-pound-sign,\n  \"stethoscope\": $fa-var-stethoscope,\n  \"stocking\": $fa-var-stocking,\n  \"stomach\": $fa-var-stomach,\n  \"stop\": $fa-var-stop,\n  \"stopwatch\": $fa-var-stopwatch,\n  \"stopwatch-20\": $fa-var-stopwatch-20,\n  \"store\": $fa-var-store,\n  \"store-slash\": $fa-var-store-slash,\n  \"strawberry\": $fa-var-strawberry,\n  \"street-view\": $fa-var-street-view,\n  \"stretcher\": $fa-var-stretcher,\n  \"strikethrough\": $fa-var-strikethrough,\n  \"stroopwafel\": $fa-var-stroopwafel,\n  \"subscript\": $fa-var-subscript,\n  \"suitcase\": $fa-var-suitcase,\n  \"suitcase-medical\": $fa-var-suitcase-medical,\n  \"medkit\": $fa-var-medkit,\n  \"suitcase-rolling\": $fa-var-suitcase-rolling,\n  \"sun\": $fa-var-sun,\n  \"sun-bright\": $fa-var-sun-bright,\n  \"sun-alt\": $fa-var-sun-alt,\n  \"sun-cloud\": $fa-var-sun-cloud,\n  \"sun-dust\": $fa-var-sun-dust,\n  \"sun-haze\": $fa-var-sun-haze,\n  \"sunglasses\": $fa-var-sunglasses,\n  \"sunrise\": $fa-var-sunrise,\n  \"sunset\": $fa-var-sunset,\n  \"superscript\": $fa-var-superscript,\n  \"swatchbook\": $fa-var-swatchbook,\n  \"sword\": $fa-var-sword,\n  \"sword-laser\": $fa-var-sword-laser,\n  \"sword-laser-alt\": $fa-var-sword-laser-alt,\n  \"swords\": $fa-var-swords,\n  \"swords-laser\": $fa-var-swords-laser,\n  \"symbols\": $fa-var-symbols,\n  \"icons-alt\": $fa-var-icons-alt,\n  \"synagogue\": $fa-var-synagogue,\n  \"syringe\": $fa-var-syringe,\n  \"t\": $fa-var-t,\n  \"table\": $fa-var-table,\n  \"table-cells\": $fa-var-table-cells,\n  \"th\": $fa-var-th,\n  \"table-cells-large\": $fa-var-table-cells-large,\n  \"th-large\": $fa-var-th-large,\n  \"table-columns\": $fa-var-table-columns,\n  \"columns\": $fa-var-columns,\n  \"table-layout\": $fa-var-table-layout,\n  \"table-list\": $fa-var-table-list,\n  \"th-list\": $fa-var-th-list,\n  \"table-picnic\": $fa-var-table-picnic,\n  \"table-pivot\": $fa-var-table-pivot,\n  \"table-rows\": $fa-var-table-rows,\n  \"rows\": $fa-var-rows,\n  \"table-tennis-paddle-ball\": $fa-var-table-tennis-paddle-ball,\n  \"ping-pong-paddle-ball\": $fa-var-ping-pong-paddle-ball,\n  \"table-tennis\": $fa-var-table-tennis,\n  \"table-tree\": $fa-var-table-tree,\n  \"tablet\": $fa-var-tablet,\n  \"tablet-android\": $fa-var-tablet-android,\n  \"tablet-button\": $fa-var-tablet-button,\n  \"tablet-rugged\": $fa-var-tablet-rugged,\n  \"tablet-screen\": $fa-var-tablet-screen,\n  \"tablet-android-alt\": $fa-var-tablet-android-alt,\n  \"tablet-screen-button\": $fa-var-tablet-screen-button,\n  \"tablet-alt\": $fa-var-tablet-alt,\n  \"tablets\": $fa-var-tablets,\n  \"tachograph-digital\": $fa-var-tachograph-digital,\n  \"digital-tachograph\": $fa-var-digital-tachograph,\n  \"taco\": $fa-var-taco,\n  \"tag\": $fa-var-tag,\n  \"tags\": $fa-var-tags,\n  \"tally\": $fa-var-tally,\n  \"tally-5\": $fa-var-tally-5,\n  \"tally-1\": $fa-var-tally-1,\n  \"tally-2\": $fa-var-tally-2,\n  \"tally-3\": $fa-var-tally-3,\n  \"tally-4\": $fa-var-tally-4,\n  \"tamale\": $fa-var-tamale,\n  \"tank-water\": $fa-var-tank-water,\n  \"tape\": $fa-var-tape,\n  \"taxi\": $fa-var-taxi,\n  \"cab\": $fa-var-cab,\n  \"taxi-bus\": $fa-var-taxi-bus,\n  \"teddy-bear\": $fa-var-teddy-bear,\n  \"teeth\": $fa-var-teeth,\n  \"teeth-open\": $fa-var-teeth-open,\n  \"telescope\": $fa-var-telescope,\n  \"temperature-arrow-down\": $fa-var-temperature-arrow-down,\n  \"temperature-down\": $fa-var-temperature-down,\n  \"temperature-arrow-up\": $fa-var-temperature-arrow-up,\n  \"temperature-up\": $fa-var-temperature-up,\n  \"temperature-empty\": $fa-var-temperature-empty,\n  \"temperature-0\": $fa-var-temperature-0,\n  \"thermometer-0\": $fa-var-thermometer-0,\n  \"thermometer-empty\": $fa-var-thermometer-empty,\n  \"temperature-full\": $fa-var-temperature-full,\n  \"temperature-4\": $fa-var-temperature-4,\n  \"thermometer-4\": $fa-var-thermometer-4,\n  \"thermometer-full\": $fa-var-thermometer-full,\n  \"temperature-half\": $fa-var-temperature-half,\n  \"temperature-2\": $fa-var-temperature-2,\n  \"thermometer-2\": $fa-var-thermometer-2,\n  \"thermometer-half\": $fa-var-thermometer-half,\n  \"temperature-high\": $fa-var-temperature-high,\n  \"temperature-list\": $fa-var-temperature-list,\n  \"temperature-low\": $fa-var-temperature-low,\n  \"temperature-quarter\": $fa-var-temperature-quarter,\n  \"temperature-1\": $fa-var-temperature-1,\n  \"thermometer-1\": $fa-var-thermometer-1,\n  \"thermometer-quarter\": $fa-var-thermometer-quarter,\n  \"temperature-snow\": $fa-var-temperature-snow,\n  \"temperature-frigid\": $fa-var-temperature-frigid,\n  \"temperature-sun\": $fa-var-temperature-sun,\n  \"temperature-hot\": $fa-var-temperature-hot,\n  \"temperature-three-quarters\": $fa-var-temperature-three-quarters,\n  \"temperature-3\": $fa-var-temperature-3,\n  \"thermometer-3\": $fa-var-thermometer-3,\n  \"thermometer-three-quarters\": $fa-var-thermometer-three-quarters,\n  \"tenge-sign\": $fa-var-tenge-sign,\n  \"tenge\": $fa-var-tenge,\n  \"tennis-ball\": $fa-var-tennis-ball,\n  \"terminal\": $fa-var-terminal,\n  \"text\": $fa-var-text,\n  \"text-height\": $fa-var-text-height,\n  \"text-size\": $fa-var-text-size,\n  \"text-slash\": $fa-var-text-slash,\n  \"remove-format\": $fa-var-remove-format,\n  \"text-width\": $fa-var-text-width,\n  \"thermometer\": $fa-var-thermometer,\n  \"theta\": $fa-var-theta,\n  \"thought-bubble\": $fa-var-thought-bubble,\n  \"thumbs-down\": $fa-var-thumbs-down,\n  \"thumbs-up\": $fa-var-thumbs-up,\n  \"thumbtack\": $fa-var-thumbtack,\n  \"thumb-tack\": $fa-var-thumb-tack,\n  \"tick\": $fa-var-tick,\n  \"ticket\": $fa-var-ticket,\n  \"ticket-airline\": $fa-var-ticket-airline,\n  \"ticket-simple\": $fa-var-ticket-simple,\n  \"ticket-alt\": $fa-var-ticket-alt,\n  \"tickets-airline\": $fa-var-tickets-airline,\n  \"tilde\": $fa-var-tilde,\n  \"timeline\": $fa-var-timeline,\n  \"timeline-arrow\": $fa-var-timeline-arrow,\n  \"timer\": $fa-var-timer,\n  \"tire\": $fa-var-tire,\n  \"tire-flat\": $fa-var-tire-flat,\n  \"tire-pressure-warning\": $fa-var-tire-pressure-warning,\n  \"tire-rugged\": $fa-var-tire-rugged,\n  \"toggle-off\": $fa-var-toggle-off,\n  \"toggle-on\": $fa-var-toggle-on,\n  \"toilet\": $fa-var-toilet,\n  \"toilet-paper\": $fa-var-toilet-paper,\n  \"toilet-paper-blank\": $fa-var-toilet-paper-blank,\n  \"toilet-paper-alt\": $fa-var-toilet-paper-alt,\n  \"toilet-paper-blank-under\": $fa-var-toilet-paper-blank-under,\n  \"toilet-paper-reverse-alt\": $fa-var-toilet-paper-reverse-alt,\n  \"toilet-paper-slash\": $fa-var-toilet-paper-slash,\n  \"toilet-paper-under\": $fa-var-toilet-paper-under,\n  \"toilet-paper-reverse\": $fa-var-toilet-paper-reverse,\n  \"toilet-paper-under-slash\": $fa-var-toilet-paper-under-slash,\n  \"toilet-paper-reverse-slash\": $fa-var-toilet-paper-reverse-slash,\n  \"tomato\": $fa-var-tomato,\n  \"tombstone\": $fa-var-tombstone,\n  \"tombstone-blank\": $fa-var-tombstone-blank,\n  \"tombstone-alt\": $fa-var-tombstone-alt,\n  \"toolbox\": $fa-var-toolbox,\n  \"tooth\": $fa-var-tooth,\n  \"toothbrush\": $fa-var-toothbrush,\n  \"torii-gate\": $fa-var-torii-gate,\n  \"tornado\": $fa-var-tornado,\n  \"tower-broadcast\": $fa-var-tower-broadcast,\n  \"broadcast-tower\": $fa-var-broadcast-tower,\n  \"tower-control\": $fa-var-tower-control,\n  \"tractor\": $fa-var-tractor,\n  \"trademark\": $fa-var-trademark,\n  \"traffic-cone\": $fa-var-traffic-cone,\n  \"traffic-light\": $fa-var-traffic-light,\n  \"traffic-light-go\": $fa-var-traffic-light-go,\n  \"traffic-light-slow\": $fa-var-traffic-light-slow,\n  \"traffic-light-stop\": $fa-var-traffic-light-stop,\n  \"trailer\": $fa-var-trailer,\n  \"train\": $fa-var-train,\n  \"train-subway\": $fa-var-train-subway,\n  \"subway\": $fa-var-subway,\n  \"train-subway-tunnel\": $fa-var-train-subway-tunnel,\n  \"subway-tunnel\": $fa-var-subway-tunnel,\n  \"train-track\": $fa-var-train-track,\n  \"train-tram\": $fa-var-train-tram,\n  \"tram\": $fa-var-tram,\n  \"train-tunnel\": $fa-var-train-tunnel,\n  \"transformer-bolt\": $fa-var-transformer-bolt,\n  \"transgender\": $fa-var-transgender,\n  \"transgender-alt\": $fa-var-transgender-alt,\n  \"transporter\": $fa-var-transporter,\n  \"transporter-1\": $fa-var-transporter-1,\n  \"transporter-2\": $fa-var-transporter-2,\n  \"transporter-3\": $fa-var-transporter-3,\n  \"transporter-4\": $fa-var-transporter-4,\n  \"transporter-5\": $fa-var-transporter-5,\n  \"transporter-6\": $fa-var-transporter-6,\n  \"transporter-7\": $fa-var-transporter-7,\n  \"transporter-empty\": $fa-var-transporter-empty,\n  \"trash\": $fa-var-trash,\n  \"trash-arrow-up\": $fa-var-trash-arrow-up,\n  \"trash-restore\": $fa-var-trash-restore,\n  \"trash-can\": $fa-var-trash-can,\n  \"trash-alt\": $fa-var-trash-alt,\n  \"trash-can-arrow-up\": $fa-var-trash-can-arrow-up,\n  \"trash-restore-alt\": $fa-var-trash-restore-alt,\n  \"trash-can-check\": $fa-var-trash-can-check,\n  \"trash-can-clock\": $fa-var-trash-can-clock,\n  \"trash-can-list\": $fa-var-trash-can-list,\n  \"trash-can-plus\": $fa-var-trash-can-plus,\n  \"trash-can-slash\": $fa-var-trash-can-slash,\n  \"trash-alt-slash\": $fa-var-trash-alt-slash,\n  \"trash-can-undo\": $fa-var-trash-can-undo,\n  \"trash-can-arrow-turn-left\": $fa-var-trash-can-arrow-turn-left,\n  \"trash-undo-alt\": $fa-var-trash-undo-alt,\n  \"trash-can-xmark\": $fa-var-trash-can-xmark,\n  \"trash-check\": $fa-var-trash-check,\n  \"trash-clock\": $fa-var-trash-clock,\n  \"trash-list\": $fa-var-trash-list,\n  \"trash-plus\": $fa-var-trash-plus,\n  \"trash-slash\": $fa-var-trash-slash,\n  \"trash-undo\": $fa-var-trash-undo,\n  \"trash-arrow-turn-left\": $fa-var-trash-arrow-turn-left,\n  \"trash-xmark\": $fa-var-trash-xmark,\n  \"treasure-chest\": $fa-var-treasure-chest,\n  \"tree\": $fa-var-tree,\n  \"tree-christmas\": $fa-var-tree-christmas,\n  \"tree-deciduous\": $fa-var-tree-deciduous,\n  \"tree-alt\": $fa-var-tree-alt,\n  \"tree-decorated\": $fa-var-tree-decorated,\n  \"tree-large\": $fa-var-tree-large,\n  \"tree-palm\": $fa-var-tree-palm,\n  \"trees\": $fa-var-trees,\n  \"triangle\": $fa-var-triangle,\n  \"triangle-exclamation\": $fa-var-triangle-exclamation,\n  \"exclamation-triangle\": $fa-var-exclamation-triangle,\n  \"warning\": $fa-var-warning,\n  \"triangle-instrument\": $fa-var-triangle-instrument,\n  \"triangle-music\": $fa-var-triangle-music,\n  \"triangle-person-digging\": $fa-var-triangle-person-digging,\n  \"construction\": $fa-var-construction,\n  \"trophy\": $fa-var-trophy,\n  \"trophy-star\": $fa-var-trophy-star,\n  \"trophy-alt\": $fa-var-trophy-alt,\n  \"truck\": $fa-var-truck,\n  \"truck-bolt\": $fa-var-truck-bolt,\n  \"truck-clock\": $fa-var-truck-clock,\n  \"shipping-timed\": $fa-var-shipping-timed,\n  \"truck-container\": $fa-var-truck-container,\n  \"truck-container-empty\": $fa-var-truck-container-empty,\n  \"truck-fast\": $fa-var-truck-fast,\n  \"shipping-fast\": $fa-var-shipping-fast,\n  \"truck-flatbed\": $fa-var-truck-flatbed,\n  \"truck-front\": $fa-var-truck-front,\n  \"truck-medical\": $fa-var-truck-medical,\n  \"ambulance\": $fa-var-ambulance,\n  \"truck-monster\": $fa-var-truck-monster,\n  \"truck-moving\": $fa-var-truck-moving,\n  \"truck-pickup\": $fa-var-truck-pickup,\n  \"truck-plow\": $fa-var-truck-plow,\n  \"truck-ramp\": $fa-var-truck-ramp,\n  \"truck-ramp-box\": $fa-var-truck-ramp-box,\n  \"truck-loading\": $fa-var-truck-loading,\n  \"truck-ramp-couch\": $fa-var-truck-ramp-couch,\n  \"truck-couch\": $fa-var-truck-couch,\n  \"truck-tow\": $fa-var-truck-tow,\n  \"trumpet\": $fa-var-trumpet,\n  \"tty\": $fa-var-tty,\n  \"teletype\": $fa-var-teletype,\n  \"tty-answer\": $fa-var-tty-answer,\n  \"teletype-answer\": $fa-var-teletype-answer,\n  \"tugrik-sign\": $fa-var-tugrik-sign,\n  \"turkey\": $fa-var-turkey,\n  \"turkish-lira-sign\": $fa-var-turkish-lira-sign,\n  \"try\": $fa-var-try,\n  \"turkish-lira\": $fa-var-turkish-lira,\n  \"turn-down\": $fa-var-turn-down,\n  \"level-down-alt\": $fa-var-level-down-alt,\n  \"turn-down-left\": $fa-var-turn-down-left,\n  \"turn-down-right\": $fa-var-turn-down-right,\n  \"turn-up\": $fa-var-turn-up,\n  \"level-up-alt\": $fa-var-level-up-alt,\n  \"turntable\": $fa-var-turntable,\n  \"turtle\": $fa-var-turtle,\n  \"tv\": $fa-var-tv,\n  \"television\": $fa-var-television,\n  \"tv-alt\": $fa-var-tv-alt,\n  \"tv-music\": $fa-var-tv-music,\n  \"tv-retro\": $fa-var-tv-retro,\n  \"typewriter\": $fa-var-typewriter,\n  \"u\": $fa-var-u,\n  \"ufo\": $fa-var-ufo,\n  \"ufo-beam\": $fa-var-ufo-beam,\n  \"umbrella\": $fa-var-umbrella,\n  \"umbrella-beach\": $fa-var-umbrella-beach,\n  \"umbrella-simple\": $fa-var-umbrella-simple,\n  \"umbrella-alt\": $fa-var-umbrella-alt,\n  \"underline\": $fa-var-underline,\n  \"unicorn\": $fa-var-unicorn,\n  \"uniform-martial-arts\": $fa-var-uniform-martial-arts,\n  \"union\": $fa-var-union,\n  \"universal-access\": $fa-var-universal-access,\n  \"unlock\": $fa-var-unlock,\n  \"unlock-keyhole\": $fa-var-unlock-keyhole,\n  \"unlock-alt\": $fa-var-unlock-alt,\n  \"up\": $fa-var-up,\n  \"arrow-alt-up\": $fa-var-arrow-alt-up,\n  \"up-down\": $fa-var-up-down,\n  \"arrows-alt-v\": $fa-var-arrows-alt-v,\n  \"up-down-left-right\": $fa-var-up-down-left-right,\n  \"arrows-alt\": $fa-var-arrows-alt,\n  \"up-from-dotted-line\": $fa-var-up-from-dotted-line,\n  \"up-from-line\": $fa-var-up-from-line,\n  \"arrow-alt-from-bottom\": $fa-var-arrow-alt-from-bottom,\n  \"up-left\": $fa-var-up-left,\n  \"up-long\": $fa-var-up-long,\n  \"long-arrow-alt-up\": $fa-var-long-arrow-alt-up,\n  \"up-right\": $fa-var-up-right,\n  \"up-right-and-down-left-from-center\": $fa-var-up-right-and-down-left-from-center,\n  \"expand-alt\": $fa-var-expand-alt,\n  \"up-right-from-square\": $fa-var-up-right-from-square,\n  \"external-link-alt\": $fa-var-external-link-alt,\n  \"up-to-dotted-line\": $fa-var-up-to-dotted-line,\n  \"up-to-line\": $fa-var-up-to-line,\n  \"arrow-alt-to-top\": $fa-var-arrow-alt-to-top,\n  \"upload\": $fa-var-upload,\n  \"usb-drive\": $fa-var-usb-drive,\n  \"user\": $fa-var-user,\n  \"user-alien\": $fa-var-user-alien,\n  \"user-astronaut\": $fa-var-user-astronaut,\n  \"user-bounty-hunter\": $fa-var-user-bounty-hunter,\n  \"user-check\": $fa-var-user-check,\n  \"user-chef\": $fa-var-user-chef,\n  \"user-clock\": $fa-var-user-clock,\n  \"user-cowboy\": $fa-var-user-cowboy,\n  \"user-crown\": $fa-var-user-crown,\n  \"user-doctor\": $fa-var-user-doctor,\n  \"user-md\": $fa-var-user-md,\n  \"user-doctor-hair\": $fa-var-user-doctor-hair,\n  \"user-doctor-hair-long\": $fa-var-user-doctor-hair-long,\n  \"user-doctor-message\": $fa-var-user-doctor-message,\n  \"user-md-chat\": $fa-var-user-md-chat,\n  \"user-gear\": $fa-var-user-gear,\n  \"user-cog\": $fa-var-user-cog,\n  \"user-graduate\": $fa-var-user-graduate,\n  \"user-group\": $fa-var-user-group,\n  \"user-friends\": $fa-var-user-friends,\n  \"user-group-crown\": $fa-var-user-group-crown,\n  \"users-crown\": $fa-var-users-crown,\n  \"user-hair\": $fa-var-user-hair,\n  \"user-hair-buns\": $fa-var-user-hair-buns,\n  \"user-hair-long\": $fa-var-user-hair-long,\n  \"user-hair-mullet\": $fa-var-user-hair-mullet,\n  \"business-front\": $fa-var-business-front,\n  \"party-back\": $fa-var-party-back,\n  \"trian-balbot\": $fa-var-trian-balbot,\n  \"user-headset\": $fa-var-user-headset,\n  \"user-helmet-safety\": $fa-var-user-helmet-safety,\n  \"user-construction\": $fa-var-user-construction,\n  \"user-hard-hat\": $fa-var-user-hard-hat,\n  \"user-injured\": $fa-var-user-injured,\n  \"user-large\": $fa-var-user-large,\n  \"user-alt\": $fa-var-user-alt,\n  \"user-large-slash\": $fa-var-user-large-slash,\n  \"user-alt-slash\": $fa-var-user-alt-slash,\n  \"user-lock\": $fa-var-user-lock,\n  \"user-minus\": $fa-var-user-minus,\n  \"user-music\": $fa-var-user-music,\n  \"user-ninja\": $fa-var-user-ninja,\n  \"user-nurse\": $fa-var-user-nurse,\n  \"user-nurse-hair\": $fa-var-user-nurse-hair,\n  \"user-nurse-hair-long\": $fa-var-user-nurse-hair-long,\n  \"user-pen\": $fa-var-user-pen,\n  \"user-edit\": $fa-var-user-edit,\n  \"user-pilot\": $fa-var-user-pilot,\n  \"user-pilot-tie\": $fa-var-user-pilot-tie,\n  \"user-plus\": $fa-var-user-plus,\n  \"user-police\": $fa-var-user-police,\n  \"user-police-tie\": $fa-var-user-police-tie,\n  \"user-robot\": $fa-var-user-robot,\n  \"user-secret\": $fa-var-user-secret,\n  \"user-shakespeare\": $fa-var-user-shakespeare,\n  \"user-shield\": $fa-var-user-shield,\n  \"user-slash\": $fa-var-user-slash,\n  \"user-tag\": $fa-var-user-tag,\n  \"user-tie\": $fa-var-user-tie,\n  \"user-tie-hair\": $fa-var-user-tie-hair,\n  \"user-tie-hair-long\": $fa-var-user-tie-hair-long,\n  \"user-unlock\": $fa-var-user-unlock,\n  \"user-visor\": $fa-var-user-visor,\n  \"user-vneck\": $fa-var-user-vneck,\n  \"user-vneck-hair\": $fa-var-user-vneck-hair,\n  \"user-vneck-hair-long\": $fa-var-user-vneck-hair-long,\n  \"user-xmark\": $fa-var-user-xmark,\n  \"user-times\": $fa-var-user-times,\n  \"users\": $fa-var-users,\n  \"group\": $fa-var-group,\n  \"users-gear\": $fa-var-users-gear,\n  \"users-cog\": $fa-var-users-cog,\n  \"users-medical\": $fa-var-users-medical,\n  \"users-slash\": $fa-var-users-slash,\n  \"utensils\": $fa-var-utensils,\n  \"cutlery\": $fa-var-cutlery,\n  \"utensils-slash\": $fa-var-utensils-slash,\n  \"utility-pole\": $fa-var-utility-pole,\n  \"utility-pole-double\": $fa-var-utility-pole-double,\n  \"v\": $fa-var-v,\n  \"vacuum\": $fa-var-vacuum,\n  \"vacuum-robot\": $fa-var-vacuum-robot,\n  \"value-absolute\": $fa-var-value-absolute,\n  \"van-shuttle\": $fa-var-van-shuttle,\n  \"shuttle-van\": $fa-var-shuttle-van,\n  \"vault\": $fa-var-vault,\n  \"vector-circle\": $fa-var-vector-circle,\n  \"vector-polygon\": $fa-var-vector-polygon,\n  \"vector-square\": $fa-var-vector-square,\n  \"vent-damper\": $fa-var-vent-damper,\n  \"venus\": $fa-var-venus,\n  \"venus-double\": $fa-var-venus-double,\n  \"venus-mars\": $fa-var-venus-mars,\n  \"vest\": $fa-var-vest,\n  \"vest-patches\": $fa-var-vest-patches,\n  \"vial\": $fa-var-vial,\n  \"vials\": $fa-var-vials,\n  \"video\": $fa-var-video,\n  \"video-camera\": $fa-var-video-camera,\n  \"video-arrow-down-left\": $fa-var-video-arrow-down-left,\n  \"video-arrow-up-right\": $fa-var-video-arrow-up-right,\n  \"video-plus\": $fa-var-video-plus,\n  \"video-slash\": $fa-var-video-slash,\n  \"vihara\": $fa-var-vihara,\n  \"violin\": $fa-var-violin,\n  \"virus\": $fa-var-virus,\n  \"virus-slash\": $fa-var-virus-slash,\n  \"viruses\": $fa-var-viruses,\n  \"voicemail\": $fa-var-voicemail,\n  \"volcano\": $fa-var-volcano,\n  \"volleyball\": $fa-var-volleyball,\n  \"volleyball-ball\": $fa-var-volleyball-ball,\n  \"volume\": $fa-var-volume,\n  \"volume-medium\": $fa-var-volume-medium,\n  \"volume-high\": $fa-var-volume-high,\n  \"volume-up\": $fa-var-volume-up,\n  \"volume-low\": $fa-var-volume-low,\n  \"volume-down\": $fa-var-volume-down,\n  \"volume-off\": $fa-var-volume-off,\n  \"volume-slash\": $fa-var-volume-slash,\n  \"volume-xmark\": $fa-var-volume-xmark,\n  \"volume-mute\": $fa-var-volume-mute,\n  \"volume-times\": $fa-var-volume-times,\n  \"vr-cardboard\": $fa-var-vr-cardboard,\n  \"w\": $fa-var-w,\n  \"waffle\": $fa-var-waffle,\n  \"wagon-covered\": $fa-var-wagon-covered,\n  \"walker\": $fa-var-walker,\n  \"walkie-talkie\": $fa-var-walkie-talkie,\n  \"wallet\": $fa-var-wallet,\n  \"wand\": $fa-var-wand,\n  \"wand-magic\": $fa-var-wand-magic,\n  \"magic\": $fa-var-magic,\n  \"wand-magic-sparkles\": $fa-var-wand-magic-sparkles,\n  \"magic-wand-sparkles\": $fa-var-magic-wand-sparkles,\n  \"wand-sparkles\": $fa-var-wand-sparkles,\n  \"warehouse\": $fa-var-warehouse,\n  \"warehouse-full\": $fa-var-warehouse-full,\n  \"warehouse-alt\": $fa-var-warehouse-alt,\n  \"washing-machine\": $fa-var-washing-machine,\n  \"washer\": $fa-var-washer,\n  \"watch\": $fa-var-watch,\n  \"watch-apple\": $fa-var-watch-apple,\n  \"watch-calculator\": $fa-var-watch-calculator,\n  \"watch-fitness\": $fa-var-watch-fitness,\n  \"watch-smart\": $fa-var-watch-smart,\n  \"water\": $fa-var-water,\n  \"water-arrow-down\": $fa-var-water-arrow-down,\n  \"water-lower\": $fa-var-water-lower,\n  \"water-arrow-up\": $fa-var-water-arrow-up,\n  \"water-rise\": $fa-var-water-rise,\n  \"water-ladder\": $fa-var-water-ladder,\n  \"ladder-water\": $fa-var-ladder-water,\n  \"swimming-pool\": $fa-var-swimming-pool,\n  \"watermelon-slice\": $fa-var-watermelon-slice,\n  \"wave-pulse\": $fa-var-wave-pulse,\n  \"heart-rate\": $fa-var-heart-rate,\n  \"wave-sine\": $fa-var-wave-sine,\n  \"wave-square\": $fa-var-wave-square,\n  \"wave-triangle\": $fa-var-wave-triangle,\n  \"waveform\": $fa-var-waveform,\n  \"waveform-lines\": $fa-var-waveform-lines,\n  \"weight-hanging\": $fa-var-weight-hanging,\n  \"weight-scale\": $fa-var-weight-scale,\n  \"weight\": $fa-var-weight,\n  \"whale\": $fa-var-whale,\n  \"wheat\": $fa-var-wheat,\n  \"wheat-awn\": $fa-var-wheat-awn,\n  \"wheat-alt\": $fa-var-wheat-alt,\n  \"wheat-awn-slash\": $fa-var-wheat-awn-slash,\n  \"wheat-slash\": $fa-var-wheat-slash,\n  \"wheelchair\": $fa-var-wheelchair,\n  \"wheelchair-move\": $fa-var-wheelchair-move,\n  \"wheelchair-alt\": $fa-var-wheelchair-alt,\n  \"whiskey-glass\": $fa-var-whiskey-glass,\n  \"glass-whiskey\": $fa-var-glass-whiskey,\n  \"whiskey-glass-ice\": $fa-var-whiskey-glass-ice,\n  \"glass-whiskey-rocks\": $fa-var-glass-whiskey-rocks,\n  \"whistle\": $fa-var-whistle,\n  \"wifi\": $fa-var-wifi,\n  \"wifi-3\": $fa-var-wifi-3,\n  \"wifi-strong\": $fa-var-wifi-strong,\n  \"wifi-exclamation\": $fa-var-wifi-exclamation,\n  \"wifi-fair\": $fa-var-wifi-fair,\n  \"wifi-2\": $fa-var-wifi-2,\n  \"wifi-slash\": $fa-var-wifi-slash,\n  \"wifi-weak\": $fa-var-wifi-weak,\n  \"wifi-1\": $fa-var-wifi-1,\n  \"wind\": $fa-var-wind,\n  \"wind-turbine\": $fa-var-wind-turbine,\n  \"wind-warning\": $fa-var-wind-warning,\n  \"wind-circle-exclamation\": $fa-var-wind-circle-exclamation,\n  \"window\": $fa-var-window,\n  \"window-flip\": $fa-var-window-flip,\n  \"window-alt\": $fa-var-window-alt,\n  \"window-frame\": $fa-var-window-frame,\n  \"window-frame-open\": $fa-var-window-frame-open,\n  \"window-maximize\": $fa-var-window-maximize,\n  \"window-minimize\": $fa-var-window-minimize,\n  \"window-restore\": $fa-var-window-restore,\n  \"windsock\": $fa-var-windsock,\n  \"wine-bottle\": $fa-var-wine-bottle,\n  \"wine-glass\": $fa-var-wine-glass,\n  \"wine-glass-crack\": $fa-var-wine-glass-crack,\n  \"fragile\": $fa-var-fragile,\n  \"wine-glass-empty\": $fa-var-wine-glass-empty,\n  \"wine-glass-alt\": $fa-var-wine-glass-alt,\n  \"won-sign\": $fa-var-won-sign,\n  \"krw\": $fa-var-krw,\n  \"won\": $fa-var-won,\n  \"wreath\": $fa-var-wreath,\n  \"wrench\": $fa-var-wrench,\n  \"wrench-simple\": $fa-var-wrench-simple,\n  \"x\": $fa-var-x,\n  \"x-ray\": $fa-var-x-ray,\n  \"xmark\": $fa-var-xmark,\n  \"close\": $fa-var-close,\n  \"multiply\": $fa-var-multiply,\n  \"remove\": $fa-var-remove,\n  \"times\": $fa-var-times,\n  \"xmark-to-slot\": $fa-var-xmark-to-slot,\n  \"times-to-slot\": $fa-var-times-to-slot,\n  \"vote-nay\": $fa-var-vote-nay,\n  \"y\": $fa-var-y,\n  \"yen-sign\": $fa-var-yen-sign,\n  \"cny\": $fa-var-cny,\n  \"jpy\": $fa-var-jpy,\n  \"rmb\": $fa-var-rmb,\n  \"yen\": $fa-var-yen,\n  \"yin-yang\": $fa-var-yin-yang,\n  \"z\": $fa-var-z,\n);\n\n$fa-brand-icons: (\n  \"42-group\": $fa-var-42-group,\n  \"innosoft\": $fa-var-innosoft,\n  \"500px\": $fa-var-500px,\n  \"accessible-icon\": $fa-var-accessible-icon,\n  \"accusoft\": $fa-var-accusoft,\n  \"acquisitions-incorporated\": $fa-var-acquisitions-incorporated,\n  \"adn\": $fa-var-adn,\n  \"adversal\": $fa-var-adversal,\n  \"affiliatetheme\": $fa-var-affiliatetheme,\n  \"airbnb\": $fa-var-airbnb,\n  \"algolia\": $fa-var-algolia,\n  \"alipay\": $fa-var-alipay,\n  \"amazon\": $fa-var-amazon,\n  \"amazon-pay\": $fa-var-amazon-pay,\n  \"amilia\": $fa-var-amilia,\n  \"android\": $fa-var-android,\n  \"angellist\": $fa-var-angellist,\n  \"angrycreative\": $fa-var-angrycreative,\n  \"angular\": $fa-var-angular,\n  \"app-store\": $fa-var-app-store,\n  \"app-store-ios\": $fa-var-app-store-ios,\n  \"apper\": $fa-var-apper,\n  \"apple\": $fa-var-apple,\n  \"apple-pay\": $fa-var-apple-pay,\n  \"artstation\": $fa-var-artstation,\n  \"asymmetrik\": $fa-var-asymmetrik,\n  \"atlassian\": $fa-var-atlassian,\n  \"audible\": $fa-var-audible,\n  \"autoprefixer\": $fa-var-autoprefixer,\n  \"avianex\": $fa-var-avianex,\n  \"aviato\": $fa-var-aviato,\n  \"aws\": $fa-var-aws,\n  \"bandcamp\": $fa-var-bandcamp,\n  \"battle-net\": $fa-var-battle-net,\n  \"behance\": $fa-var-behance,\n  \"behance-square\": $fa-var-behance-square,\n  \"bilibili\": $fa-var-bilibili,\n  \"bimobject\": $fa-var-bimobject,\n  \"bitbucket\": $fa-var-bitbucket,\n  \"bitcoin\": $fa-var-bitcoin,\n  \"bity\": $fa-var-bity,\n  \"black-tie\": $fa-var-black-tie,\n  \"blackberry\": $fa-var-blackberry,\n  \"blogger\": $fa-var-blogger,\n  \"blogger-b\": $fa-var-blogger-b,\n  \"bluetooth\": $fa-var-bluetooth,\n  \"bluetooth-b\": $fa-var-bluetooth-b,\n  \"bootstrap\": $fa-var-bootstrap,\n  \"bots\": $fa-var-bots,\n  \"btc\": $fa-var-btc,\n  \"buffer\": $fa-var-buffer,\n  \"buromobelexperte\": $fa-var-buromobelexperte,\n  \"buy-n-large\": $fa-var-buy-n-large,\n  \"buysellads\": $fa-var-buysellads,\n  \"canadian-maple-leaf\": $fa-var-canadian-maple-leaf,\n  \"cc-amazon-pay\": $fa-var-cc-amazon-pay,\n  \"cc-amex\": $fa-var-cc-amex,\n  \"cc-apple-pay\": $fa-var-cc-apple-pay,\n  \"cc-diners-club\": $fa-var-cc-diners-club,\n  \"cc-discover\": $fa-var-cc-discover,\n  \"cc-jcb\": $fa-var-cc-jcb,\n  \"cc-mastercard\": $fa-var-cc-mastercard,\n  \"cc-paypal\": $fa-var-cc-paypal,\n  \"cc-stripe\": $fa-var-cc-stripe,\n  \"cc-visa\": $fa-var-cc-visa,\n  \"centercode\": $fa-var-centercode,\n  \"centos\": $fa-var-centos,\n  \"chrome\": $fa-var-chrome,\n  \"chromecast\": $fa-var-chromecast,\n  \"cloudflare\": $fa-var-cloudflare,\n  \"cloudscale\": $fa-var-cloudscale,\n  \"cloudsmith\": $fa-var-cloudsmith,\n  \"cloudversify\": $fa-var-cloudversify,\n  \"cmplid\": $fa-var-cmplid,\n  \"codepen\": $fa-var-codepen,\n  \"codiepie\": $fa-var-codiepie,\n  \"confluence\": $fa-var-confluence,\n  \"connectdevelop\": $fa-var-connectdevelop,\n  \"contao\": $fa-var-contao,\n  \"cotton-bureau\": $fa-var-cotton-bureau,\n  \"cpanel\": $fa-var-cpanel,\n  \"creative-commons\": $fa-var-creative-commons,\n  \"creative-commons-by\": $fa-var-creative-commons-by,\n  \"creative-commons-nc\": $fa-var-creative-commons-nc,\n  \"creative-commons-nc-eu\": $fa-var-creative-commons-nc-eu,\n  \"creative-commons-nc-jp\": $fa-var-creative-commons-nc-jp,\n  \"creative-commons-nd\": $fa-var-creative-commons-nd,\n  \"creative-commons-pd\": $fa-var-creative-commons-pd,\n  \"creative-commons-pd-alt\": $fa-var-creative-commons-pd-alt,\n  \"creative-commons-remix\": $fa-var-creative-commons-remix,\n  \"creative-commons-sa\": $fa-var-creative-commons-sa,\n  \"creative-commons-sampling\": $fa-var-creative-commons-sampling,\n  \"creative-commons-sampling-plus\": $fa-var-creative-commons-sampling-plus,\n  \"creative-commons-share\": $fa-var-creative-commons-share,\n  \"creative-commons-zero\": $fa-var-creative-commons-zero,\n  \"critical-role\": $fa-var-critical-role,\n  \"css3\": $fa-var-css3,\n  \"css3-alt\": $fa-var-css3-alt,\n  \"cuttlefish\": $fa-var-cuttlefish,\n  \"d-and-d\": $fa-var-d-and-d,\n  \"d-and-d-beyond\": $fa-var-d-and-d-beyond,\n  \"dailymotion\": $fa-var-dailymotion,\n  \"dashcube\": $fa-var-dashcube,\n  \"deezer\": $fa-var-deezer,\n  \"delicious\": $fa-var-delicious,\n  \"deploydog\": $fa-var-deploydog,\n  \"deskpro\": $fa-var-deskpro,\n  \"dev\": $fa-var-dev,\n  \"deviantart\": $fa-var-deviantart,\n  \"dhl\": $fa-var-dhl,\n  \"diaspora\": $fa-var-diaspora,\n  \"digg\": $fa-var-digg,\n  \"digital-ocean\": $fa-var-digital-ocean,\n  \"discord\": $fa-var-discord,\n  \"discourse\": $fa-var-discourse,\n  \"dochub\": $fa-var-dochub,\n  \"docker\": $fa-var-docker,\n  \"draft2digital\": $fa-var-draft2digital,\n  \"dribbble\": $fa-var-dribbble,\n  \"dribbble-square\": $fa-var-dribbble-square,\n  \"dropbox\": $fa-var-dropbox,\n  \"drupal\": $fa-var-drupal,\n  \"dyalog\": $fa-var-dyalog,\n  \"earlybirds\": $fa-var-earlybirds,\n  \"ebay\": $fa-var-ebay,\n  \"edge\": $fa-var-edge,\n  \"edge-legacy\": $fa-var-edge-legacy,\n  \"elementor\": $fa-var-elementor,\n  \"ello\": $fa-var-ello,\n  \"ember\": $fa-var-ember,\n  \"empire\": $fa-var-empire,\n  \"envira\": $fa-var-envira,\n  \"erlang\": $fa-var-erlang,\n  \"ethereum\": $fa-var-ethereum,\n  \"etsy\": $fa-var-etsy,\n  \"evernote\": $fa-var-evernote,\n  \"expeditedssl\": $fa-var-expeditedssl,\n  \"facebook\": $fa-var-facebook,\n  \"facebook-f\": $fa-var-facebook-f,\n  \"facebook-messenger\": $fa-var-facebook-messenger,\n  \"facebook-square\": $fa-var-facebook-square,\n  \"fantasy-flight-games\": $fa-var-fantasy-flight-games,\n  \"fedex\": $fa-var-fedex,\n  \"fedora\": $fa-var-fedora,\n  \"figma\": $fa-var-figma,\n  \"firefox\": $fa-var-firefox,\n  \"firefox-browser\": $fa-var-firefox-browser,\n  \"first-order\": $fa-var-first-order,\n  \"first-order-alt\": $fa-var-first-order-alt,\n  \"firstdraft\": $fa-var-firstdraft,\n  \"flickr\": $fa-var-flickr,\n  \"flipboard\": $fa-var-flipboard,\n  \"fly\": $fa-var-fly,\n  \"font-awesome\": $fa-var-font-awesome,\n  \"font-awesome-flag\": $fa-var-font-awesome-flag,\n  \"font-awesome-logo-full\": $fa-var-font-awesome-logo-full,\n  \"fonticons\": $fa-var-fonticons,\n  \"fonticons-fi\": $fa-var-fonticons-fi,\n  \"fort-awesome\": $fa-var-fort-awesome,\n  \"fort-awesome-alt\": $fa-var-fort-awesome-alt,\n  \"forumbee\": $fa-var-forumbee,\n  \"foursquare\": $fa-var-foursquare,\n  \"free-code-camp\": $fa-var-free-code-camp,\n  \"freebsd\": $fa-var-freebsd,\n  \"fulcrum\": $fa-var-fulcrum,\n  \"galactic-republic\": $fa-var-galactic-republic,\n  \"galactic-senate\": $fa-var-galactic-senate,\n  \"get-pocket\": $fa-var-get-pocket,\n  \"gg\": $fa-var-gg,\n  \"gg-circle\": $fa-var-gg-circle,\n  \"git\": $fa-var-git,\n  \"git-alt\": $fa-var-git-alt,\n  \"git-square\": $fa-var-git-square,\n  \"github\": $fa-var-github,\n  \"github-alt\": $fa-var-github-alt,\n  \"github-square\": $fa-var-github-square,\n  \"gitkraken\": $fa-var-gitkraken,\n  \"gitlab\": $fa-var-gitlab,\n  \"gitter\": $fa-var-gitter,\n  \"glide\": $fa-var-glide,\n  \"glide-g\": $fa-var-glide-g,\n  \"gofore\": $fa-var-gofore,\n  \"golang\": $fa-var-golang,\n  \"goodreads\": $fa-var-goodreads,\n  \"goodreads-g\": $fa-var-goodreads-g,\n  \"google\": $fa-var-google,\n  \"google-drive\": $fa-var-google-drive,\n  \"google-pay\": $fa-var-google-pay,\n  \"google-play\": $fa-var-google-play,\n  \"google-plus\": $fa-var-google-plus,\n  \"google-plus-g\": $fa-var-google-plus-g,\n  \"google-plus-square\": $fa-var-google-plus-square,\n  \"google-wallet\": $fa-var-google-wallet,\n  \"gratipay\": $fa-var-gratipay,\n  \"grav\": $fa-var-grav,\n  \"gripfire\": $fa-var-gripfire,\n  \"grunt\": $fa-var-grunt,\n  \"guilded\": $fa-var-guilded,\n  \"gulp\": $fa-var-gulp,\n  \"hacker-news\": $fa-var-hacker-news,\n  \"hacker-news-square\": $fa-var-hacker-news-square,\n  \"hackerrank\": $fa-var-hackerrank,\n  \"hips\": $fa-var-hips,\n  \"hire-a-helper\": $fa-var-hire-a-helper,\n  \"hive\": $fa-var-hive,\n  \"hooli\": $fa-var-hooli,\n  \"hornbill\": $fa-var-hornbill,\n  \"hotjar\": $fa-var-hotjar,\n  \"houzz\": $fa-var-houzz,\n  \"html5\": $fa-var-html5,\n  \"hubspot\": $fa-var-hubspot,\n  \"ideal\": $fa-var-ideal,\n  \"imdb\": $fa-var-imdb,\n  \"instagram\": $fa-var-instagram,\n  \"instagram-square\": $fa-var-instagram-square,\n  \"instalod\": $fa-var-instalod,\n  \"intercom\": $fa-var-intercom,\n  \"internet-explorer\": $fa-var-internet-explorer,\n  \"invision\": $fa-var-invision,\n  \"ioxhost\": $fa-var-ioxhost,\n  \"itch-io\": $fa-var-itch-io,\n  \"itunes\": $fa-var-itunes,\n  \"itunes-note\": $fa-var-itunes-note,\n  \"java\": $fa-var-java,\n  \"jedi-order\": $fa-var-jedi-order,\n  \"jenkins\": $fa-var-jenkins,\n  \"jira\": $fa-var-jira,\n  \"joget\": $fa-var-joget,\n  \"joomla\": $fa-var-joomla,\n  \"js\": $fa-var-js,\n  \"js-square\": $fa-var-js-square,\n  \"jsfiddle\": $fa-var-jsfiddle,\n  \"kaggle\": $fa-var-kaggle,\n  \"keybase\": $fa-var-keybase,\n  \"keycdn\": $fa-var-keycdn,\n  \"kickstarter\": $fa-var-kickstarter,\n  \"kickstarter-k\": $fa-var-kickstarter-k,\n  \"korvue\": $fa-var-korvue,\n  \"laravel\": $fa-var-laravel,\n  \"lastfm\": $fa-var-lastfm,\n  \"lastfm-square\": $fa-var-lastfm-square,\n  \"leanpub\": $fa-var-leanpub,\n  \"less\": $fa-var-less,\n  \"line\": $fa-var-line,\n  \"linkedin\": $fa-var-linkedin,\n  \"linkedin-in\": $fa-var-linkedin-in,\n  \"linode\": $fa-var-linode,\n  \"linux\": $fa-var-linux,\n  \"lyft\": $fa-var-lyft,\n  \"magento\": $fa-var-magento,\n  \"mailchimp\": $fa-var-mailchimp,\n  \"mandalorian\": $fa-var-mandalorian,\n  \"markdown\": $fa-var-markdown,\n  \"mastodon\": $fa-var-mastodon,\n  \"maxcdn\": $fa-var-maxcdn,\n  \"mdb\": $fa-var-mdb,\n  \"medapps\": $fa-var-medapps,\n  \"medium\": $fa-var-medium,\n  \"medium-m\": $fa-var-medium-m,\n  \"medrt\": $fa-var-medrt,\n  \"meetup\": $fa-var-meetup,\n  \"megaport\": $fa-var-megaport,\n  \"mendeley\": $fa-var-mendeley,\n  \"microblog\": $fa-var-microblog,\n  \"microsoft\": $fa-var-microsoft,\n  \"mix\": $fa-var-mix,\n  \"mixcloud\": $fa-var-mixcloud,\n  \"mixer\": $fa-var-mixer,\n  \"mizuni\": $fa-var-mizuni,\n  \"modx\": $fa-var-modx,\n  \"monero\": $fa-var-monero,\n  \"napster\": $fa-var-napster,\n  \"neos\": $fa-var-neos,\n  \"nimblr\": $fa-var-nimblr,\n  \"node\": $fa-var-node,\n  \"node-js\": $fa-var-node-js,\n  \"npm\": $fa-var-npm,\n  \"ns8\": $fa-var-ns8,\n  \"nutritionix\": $fa-var-nutritionix,\n  \"octopus-deploy\": $fa-var-octopus-deploy,\n  \"odnoklassniki\": $fa-var-odnoklassniki,\n  \"odnoklassniki-square\": $fa-var-odnoklassniki-square,\n  \"old-republic\": $fa-var-old-republic,\n  \"opencart\": $fa-var-opencart,\n  \"openid\": $fa-var-openid,\n  \"opera\": $fa-var-opera,\n  \"optin-monster\": $fa-var-optin-monster,\n  \"orcid\": $fa-var-orcid,\n  \"osi\": $fa-var-osi,\n  \"page4\": $fa-var-page4,\n  \"pagelines\": $fa-var-pagelines,\n  \"palfed\": $fa-var-palfed,\n  \"patreon\": $fa-var-patreon,\n  \"paypal\": $fa-var-paypal,\n  \"penny-arcade\": $fa-var-penny-arcade,\n  \"perbyte\": $fa-var-perbyte,\n  \"periscope\": $fa-var-periscope,\n  \"phabricator\": $fa-var-phabricator,\n  \"phoenix-framework\": $fa-var-phoenix-framework,\n  \"phoenix-squadron\": $fa-var-phoenix-squadron,\n  \"php\": $fa-var-php,\n  \"pied-piper\": $fa-var-pied-piper,\n  \"pied-piper-alt\": $fa-var-pied-piper-alt,\n  \"pied-piper-hat\": $fa-var-pied-piper-hat,\n  \"pied-piper-pp\": $fa-var-pied-piper-pp,\n  \"pied-piper-square\": $fa-var-pied-piper-square,\n  \"pinterest\": $fa-var-pinterest,\n  \"pinterest-p\": $fa-var-pinterest-p,\n  \"pinterest-square\": $fa-var-pinterest-square,\n  \"pix\": $fa-var-pix,\n  \"playstation\": $fa-var-playstation,\n  \"product-hunt\": $fa-var-product-hunt,\n  \"pushed\": $fa-var-pushed,\n  \"python\": $fa-var-python,\n  \"qq\": $fa-var-qq,\n  \"quinscape\": $fa-var-quinscape,\n  \"quora\": $fa-var-quora,\n  \"r-project\": $fa-var-r-project,\n  \"raspberry-pi\": $fa-var-raspberry-pi,\n  \"ravelry\": $fa-var-ravelry,\n  \"react\": $fa-var-react,\n  \"reacteurope\": $fa-var-reacteurope,\n  \"readme\": $fa-var-readme,\n  \"rebel\": $fa-var-rebel,\n  \"red-river\": $fa-var-red-river,\n  \"reddit\": $fa-var-reddit,\n  \"reddit-alien\": $fa-var-reddit-alien,\n  \"reddit-square\": $fa-var-reddit-square,\n  \"redhat\": $fa-var-redhat,\n  \"renren\": $fa-var-renren,\n  \"replyd\": $fa-var-replyd,\n  \"researchgate\": $fa-var-researchgate,\n  \"resolving\": $fa-var-resolving,\n  \"rev\": $fa-var-rev,\n  \"rocketchat\": $fa-var-rocketchat,\n  \"rockrms\": $fa-var-rockrms,\n  \"rust\": $fa-var-rust,\n  \"safari\": $fa-var-safari,\n  \"salesforce\": $fa-var-salesforce,\n  \"sass\": $fa-var-sass,\n  \"schlix\": $fa-var-schlix,\n  \"scribd\": $fa-var-scribd,\n  \"searchengin\": $fa-var-searchengin,\n  \"sellcast\": $fa-var-sellcast,\n  \"sellsy\": $fa-var-sellsy,\n  \"servicestack\": $fa-var-servicestack,\n  \"shirtsinbulk\": $fa-var-shirtsinbulk,\n  \"shopify\": $fa-var-shopify,\n  \"shopware\": $fa-var-shopware,\n  \"simplybuilt\": $fa-var-simplybuilt,\n  \"sistrix\": $fa-var-sistrix,\n  \"sith\": $fa-var-sith,\n  \"sitrox\": $fa-var-sitrox,\n  \"sketch\": $fa-var-sketch,\n  \"skyatlas\": $fa-var-skyatlas,\n  \"skype\": $fa-var-skype,\n  \"slack\": $fa-var-slack,\n  \"slack-hash\": $fa-var-slack-hash,\n  \"slideshare\": $fa-var-slideshare,\n  \"snapchat\": $fa-var-snapchat,\n  \"snapchat-ghost\": $fa-var-snapchat-ghost,\n  \"snapchat-square\": $fa-var-snapchat-square,\n  \"soundcloud\": $fa-var-soundcloud,\n  \"sourcetree\": $fa-var-sourcetree,\n  \"speakap\": $fa-var-speakap,\n  \"speaker-deck\": $fa-var-speaker-deck,\n  \"spotify\": $fa-var-spotify,\n  \"square-font-awesome\": $fa-var-square-font-awesome,\n  \"square-font-awesome-stroke\": $fa-var-square-font-awesome-stroke,\n  \"font-awesome-alt\": $fa-var-font-awesome-alt,\n  \"squarespace\": $fa-var-squarespace,\n  \"stack-exchange\": $fa-var-stack-exchange,\n  \"stack-overflow\": $fa-var-stack-overflow,\n  \"stackpath\": $fa-var-stackpath,\n  \"staylinked\": $fa-var-staylinked,\n  \"steam\": $fa-var-steam,\n  \"steam-square\": $fa-var-steam-square,\n  \"steam-symbol\": $fa-var-steam-symbol,\n  \"sticker-mule\": $fa-var-sticker-mule,\n  \"strava\": $fa-var-strava,\n  \"stripe\": $fa-var-stripe,\n  \"stripe-s\": $fa-var-stripe-s,\n  \"studiovinari\": $fa-var-studiovinari,\n  \"stumbleupon\": $fa-var-stumbleupon,\n  \"stumbleupon-circle\": $fa-var-stumbleupon-circle,\n  \"superpowers\": $fa-var-superpowers,\n  \"supple\": $fa-var-supple,\n  \"suse\": $fa-var-suse,\n  \"swift\": $fa-var-swift,\n  \"symfony\": $fa-var-symfony,\n  \"teamspeak\": $fa-var-teamspeak,\n  \"telegram\": $fa-var-telegram,\n  \"telegram-plane\": $fa-var-telegram-plane,\n  \"tencent-weibo\": $fa-var-tencent-weibo,\n  \"the-red-yeti\": $fa-var-the-red-yeti,\n  \"themeco\": $fa-var-themeco,\n  \"themeisle\": $fa-var-themeisle,\n  \"think-peaks\": $fa-var-think-peaks,\n  \"tiktok\": $fa-var-tiktok,\n  \"trade-federation\": $fa-var-trade-federation,\n  \"trello\": $fa-var-trello,\n  \"tumblr\": $fa-var-tumblr,\n  \"tumblr-square\": $fa-var-tumblr-square,\n  \"twitch\": $fa-var-twitch,\n  \"twitter\": $fa-var-twitter,\n  \"twitter-square\": $fa-var-twitter-square,\n  \"typo3\": $fa-var-typo3,\n  \"uber\": $fa-var-uber,\n  \"ubuntu\": $fa-var-ubuntu,\n  \"uikit\": $fa-var-uikit,\n  \"umbraco\": $fa-var-umbraco,\n  \"uncharted\": $fa-var-uncharted,\n  \"uniregistry\": $fa-var-uniregistry,\n  \"unity\": $fa-var-unity,\n  \"unsplash\": $fa-var-unsplash,\n  \"untappd\": $fa-var-untappd,\n  \"ups\": $fa-var-ups,\n  \"usb\": $fa-var-usb,\n  \"usps\": $fa-var-usps,\n  \"ussunnah\": $fa-var-ussunnah,\n  \"vaadin\": $fa-var-vaadin,\n  \"viacoin\": $fa-var-viacoin,\n  \"viadeo\": $fa-var-viadeo,\n  \"viadeo-square\": $fa-var-viadeo-square,\n  \"viber\": $fa-var-viber,\n  \"vimeo\": $fa-var-vimeo,\n  \"vimeo-square\": $fa-var-vimeo-square,\n  \"vimeo-v\": $fa-var-vimeo-v,\n  \"vine\": $fa-var-vine,\n  \"vk\": $fa-var-vk,\n  \"vnv\": $fa-var-vnv,\n  \"vuejs\": $fa-var-vuejs,\n  \"watchman-monitoring\": $fa-var-watchman-monitoring,\n  \"waze\": $fa-var-waze,\n  \"weebly\": $fa-var-weebly,\n  \"weibo\": $fa-var-weibo,\n  \"weixin\": $fa-var-weixin,\n  \"whatsapp\": $fa-var-whatsapp,\n  \"whatsapp-square\": $fa-var-whatsapp-square,\n  \"whmcs\": $fa-var-whmcs,\n  \"wikipedia-w\": $fa-var-wikipedia-w,\n  \"windows\": $fa-var-windows,\n  \"wirsindhandwerk\": $fa-var-wirsindhandwerk,\n  \"wsh\": $fa-var-wsh,\n  \"wix\": $fa-var-wix,\n  \"wizards-of-the-coast\": $fa-var-wizards-of-the-coast,\n  \"wodu\": $fa-var-wodu,\n  \"wolf-pack-battalion\": $fa-var-wolf-pack-battalion,\n  \"wordpress\": $fa-var-wordpress,\n  \"wordpress-simple\": $fa-var-wordpress-simple,\n  \"wpbeginner\": $fa-var-wpbeginner,\n  \"wpexplorer\": $fa-var-wpexplorer,\n  \"wpforms\": $fa-var-wpforms,\n  \"wpressr\": $fa-var-wpressr,\n  \"xbox\": $fa-var-xbox,\n  \"xing\": $fa-var-xing,\n  \"xing-square\": $fa-var-xing-square,\n  \"y-combinator\": $fa-var-y-combinator,\n  \"yahoo\": $fa-var-yahoo,\n  \"yammer\": $fa-var-yammer,\n  \"yandex\": $fa-var-yandex,\n  \"yandex-international\": $fa-var-yandex-international,\n  \"yarn\": $fa-var-yarn,\n  \"yelp\": $fa-var-yelp,\n  \"yoast\": $fa-var-yoast,\n  \"youtube\": $fa-var-youtube,\n  \"youtube-square\": $fa-var-youtube-square,\n  \"zhihu\": $fa-var-zhihu,\n);\n","// icons in a list\n// -------------------------\n\n.#{$fa-css-prefix}-ul {\n  list-style-type: none;\n  margin-left: var(--#{$fa-css-prefix}-li-margin, #{$fa-li-margin});\n  padding-left: 0;\n\n  > li { position: relative; }\n}\n\n.#{$fa-css-prefix}-li {\n  left: calc(var(--#{$fa-css-prefix}-li-width, #{$fa-li-width}) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--#{$fa-css-prefix}-li-width, #{$fa-li-width});\n  line-height: inherit;\n}\n","// bordered + pulled icons\n// -------------------------\n\n.#{$fa-css-prefix}-border {\n  border-color: var(--#{$fa-css-prefix}-border-color, #{$fa-border-color});\n  border-radius: var(--#{$fa-css-prefix}-border-radius, #{$fa-border-radius});\n  border-style: var(--#{$fa-css-prefix}-border-style, #{$fa-border-style});\n  border-width: var(--#{$fa-css-prefix}-border-width, #{$fa-border-width});\n  padding: var(--#{$fa-css-prefix}-border-padding, #{$fa-border-padding});\n}\n\n.#{$fa-css-prefix}-pull-left { \n  float: left;\n  margin-right: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n\n.#{$fa-css-prefix}-pull-right { \n  float: right;\n  margin-left: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n","// animating icons\n// --------------------------\n\n.#{$fa-css-prefix}-beat {\n  animation-name: #{$fa-css-prefix}-beat;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-fade {\n  animation-name: #{$fa-css-prefix}-fade;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-flash {\n  animation-name: #{$fa-css-prefix}-flash;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-flip {\n  animation-name: #{$fa-css-prefix}-flip;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-spin {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 2s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, linear);\n}\n\n.#{$fa-css-prefix}-spin-reverse {\n  --#{$fa-css-prefix}-animation-direction: reverse;\n}\n\n.#{$fa-css-prefix}-pulse,\n.#{$fa-css-prefix}-spin-pulse {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, steps(8));\n}\n\n// if agent or operating system prefers reduced motion, disable animations\n// see: https://www.smashingmagazine.com/2020/09/design-reduced-motion-sensitivities/\n// see: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion\n@media (prefers-reduced-motion: reduce) {\n  .#{$fa-css-prefix}-beat,\n  .#{$fa-css-prefix}-fade,\n  .#{$fa-css-prefix}-flash,\n  .#{$fa-css-prefix}-flip,\n  .#{$fa-css-prefix}-pulse,\n  .#{$fa-css-prefix}-spin,\n  .#{$fa-css-prefix}-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n\n@keyframes #{$fa-css-prefix}-beat {\n  0%, 90% { transform: scale(1); }\n  45% { transform: scale(var(--#{$fa-css-prefix}-beat-scale, 1.25)); }\n}\n\n@keyframes #{$fa-css-prefix}-fade {\n  50% { opacity: var(--#{$fa-css-prefix}-fade-opacity, 0.4); }\n}\n\n@keyframes #{$fa-css-prefix}-flash {\n  0%, 100% {\n    opacity: var(--#{$fa-css-prefix}-flash-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--#{$fa-css-prefix}-flash-scale, 1.125));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-flip {\n  50% {\n    transform: rotate3d(var(--#{$fa-css-prefix}-flip-x, 0), var(--#{$fa-css-prefix}-flip-y, 1), var(--#{$fa-css-prefix}-flip-z, 0), var(--#{$fa-css-prefix}-flip-angle, -180deg));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n","// rotating + flipping icons\n// -------------------------\n\n.#{$fa-css-prefix}-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.#{$fa-css-prefix}-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.#{$fa-css-prefix}-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.#{$fa-css-prefix}-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.#{$fa-css-prefix}-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.#{$fa-css-prefix}-flip-both,\n.#{$fa-css-prefix}-flip-horizontal.#{$fa-css-prefix}-flip-vertical { \n  transform: scale(-1, -1);\n}\n\n.#{$fa-css-prefix}-rotate-by {\n  transform: rotate(var(--#{$fa-css-prefix}-rotate-angle, none));\n}\n","// stacking icons\n// -------------------------\n\n.#{$fa-css-prefix}-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: $fa-stack-vertical-align;\n  width: $fa-stack-width;\n}\n\n.#{$fa-css-prefix}-stack-1x,\n.#{$fa-css-prefix}-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  z-index: var(--#{$fa-css-prefix}-stack-z-index, #{$fa-stack-z-index});\n}\n\n.#{$fa-css-prefix}-stack-1x {\n  line-height: inherit;\n}\n\n.#{$fa-css-prefix}-stack-2x {\n  font-size: 2em;\n}\n\n.#{$fa-css-prefix}-inverse {\n  color: var(--#{$fa-css-prefix}-inverse, #{$fa-inverse});\n}\n","// specific icon class definition\n// -------------------------\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n\n@each $name, $icon in $fa-icons {\n  .#{$fa-css-prefix}-#{$name}::before { content: fa-content($icon); }\n}\n","// screen-reader utilities\n// -------------------------\n\n// only display content to screen readers\n.sr-only,\n.fa-sr-only {\n  @include fa-sr-only;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n.sr-only-focusable,\n.fa-sr-only-focusable {\n  @include fa-sr-only-focusable;\n}\n","/*!\n * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@import 'functions';\n@import 'variables';\n\n@font-face {\n  font-family: 'Font Awesome 6 Brands';\n  font-style: normal;\n  font-weight: 400;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-brands-400.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-brands-400.ttf') format('truetype');\n}\n\n.fab,\n.fa-brands {\n  font-family: 'Font Awesome 6 Brands';\n  font-weight: 400;\n}\n\n@each $name, $icon in $fa-brand-icons {\n  .#{$fa-css-prefix}-#{$name}:before { content: fa-content($icon); }\n}\n","/*!\n * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@import 'functions';\n@import 'variables';\n\n@font-face {\n  font-family: 'Font Awesome 6 Pro';\n  font-style: normal;\n  font-weight: 900;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-solid-900.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-solid-900.ttf') format('truetype');\n}\n\n.fas,\n.fa-solid {\n  font-family: 'Font Awesome 6 Pro';\n  font-weight: 900;\n}\n","/*!\n * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@import 'functions';\n@import 'variables';\n\n@font-face {\n  font-family: 'Font Awesome 6 Pro';\n  font-style: normal;\n  font-weight: 300;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-light-300.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-light-300.ttf') format('truetype');\n}\n\n.fal,\n.fa-light {\n  font-family: 'Font Awesome 6 Pro';\n  font-weight: 300;\n}\n","/*!\n * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@import 'functions';\n@import 'variables';\n\n@font-face {\n  font-family: 'Font Awesome 6 Pro';\n  font-style: normal;\n  font-weight: 400;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-regular-400.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-regular-400.ttf') format('truetype');\n}\n\n.far,\n.fa-regular {\n  font-family: 'Font Awesome 6 Pro';\n  font-weight: 400;\n}\n","/*!\n * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@import 'functions';\n@import 'variables';\n\n@font-face {\n  font-family: 'Font Awesome 6 Pro';\n  font-style: normal;\n  font-weight: 100;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-thin-100.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-thin-100.ttf') format('truetype');\n}\n\n.fat,\n.fa-thin {\n  font-family: 'Font Awesome 6 Pro';\n  font-weight: 100;\n}\n","@import \"../fontawesome/scss/all.scss\";\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 100 900;\n  font-display: swap;\n  font-style: normal;\n  font-named-instance: \"Regular\";\n  src: url(\"~assets/NEW/font/Inter.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 200;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-extraleicht.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 300;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-leicht.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 400;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-buch.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 500;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-kraftig.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 600;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-halbfett.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 700;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-dreiviertelfett.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 800;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-fett.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 900;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-extrafett.woff2\");\n}\n",".skeleton1 {\n  animation: pulse1 2.3s cubic-bezier(.4,0,.6,1) infinite;\n}\n.skeleton2 {\n  animation: pulse2 1.5s cubic-bezier(.4,0,.6,1) infinite;\n}\n.skeleton3 {\n  animation: pulse3 2.7s cubic-bezier(.4,0,.6,1) infinite;\n}\n.skeleton4 {\n  animation: pulse4 1.9s cubic-bezier(.4,0,.6,1) infinite;\n}\n.skeleton5 {\n  animation: pulse5 2.3s cubic-bezier(.4,0,.6,1) infinite;\n}\n.skeleton6 {\n  animation: pulse6 2.5s cubic-bezier(.4,0,.6,1) infinite;\n}\n.skeleton7 {\n  animation: pulse7 3.5s cubic-bezier(.4,0,.6,1) infinite;\n}\n\n\n.skeleton {\n  background: var(--black3);\n  height: 20px;\n  border-radius: .5rem;\n\n  &.medium {\n    background: var(--black2);\n    height: 15px;\n    border-radius: .25rem;\n  }\n\n  &.small {\n    background: var(--black2);\n    height: 10px;\n    border-radius: .25rem;\n  }\n\n  &.static {\n    animation: none;\n  }\n}\n\n@keyframes pulse1 {\n  0%, 100% {\n    opacity: .1;\n  }\n\n  50% {\n    opacity: .2;\n  }\n}\n@keyframes pulse2 {\n  0%, 100% {\n    opacity: .3;\n  }\n\n  50% {\n    opacity: .5;\n  }\n}\n@keyframes pulse3 {\n  0%, 100% {\n    opacity: .2;\n  }\n\n  50% {\n    opacity: .3;\n  }\n}\n@keyframes pulse4 {\n  0%, 100% {\n    opacity: .3;\n  }\n\n  50% {\n    opacity: .05;\n  }\n}\n@keyframes pulse5 {\n  0%, 100% {\n    opacity: .05;\n  }\n\n  50% {\n    opacity: .2;\n  }\n}\n@keyframes pulse6 {\n  0%, 100% {\n    opacity: .15;\n  }\n\n  50% {\n    opacity: .05;\n  }\n}\n\n@keyframes pulse7 {\n  0%, 100% {\n    opacity: .2;\n  }\n\n  50% {\n    opacity: .15;\n  }\n}\n\n\n","html {\n  width: 100vw;\n  margin-left: 0;\n  background-color: white;\n  overflow-x: hidden;\n\n  &.embed {\n    background-color: transparent !important;\n\n    #app {\n      background-color: transparent !important;\n    }\n  }\n}\n\n\n* {\n  box-sizing: border-box;\n}\n\nh1 {\n  margin-top: 0;\n}\n\nh2 {\n  margin-top: 0;\n  margin-bottom: .5rem;\n}\n\nh4 {\n  margin-top: 0;\n  margin-bottom: .5rem;\n}\n\nh6 {\n  margin-top: 0;\n  margin-bottom: .5rem;\n}\n\nh5 {\n  font-size: 1.25rem;\n}\n\nbody {\n  transition: background .9s;\n  background-color: #0000;\n  font-size: 14px;\n  -webkit-font-smoothing: antialiased;\n  font-family: \"Inter\", sans-serif !important;\n  margin: 0;\n}\n\n\n*::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n  background-color: transparent;\n\n  &-track {\n    background-color: transparent;\n  }\n\n  &-thumb {\n    background-color: rgba(0, 0, 0, 0.3);\n  }\n}\n\n.uppercase {\n  text-transform: lowercase;\n\n  &:first-letter {\n    text-transform: uppercase;\n  }\n}\n\n@media (max-width: 375px) {\n  .g-recaptcha {\n    margin: 0 auto;\n    transform: scale(0.98);\n    -webkit-transform: scale(0.98);\n    transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n  }\n}\n\n@media (max-width: 360px) {\n  .g-recaptcha {\n    margin: 0 auto;\n    transform: scale(0.92);\n    -webkit-transform: scale(0.92);\n    transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n  }\n}\n\n@media (max-width: 320px) {\n  .g-recaptcha {\n    margin: 0 auto;\n    transform: scale(0.8);\n    -webkit-transform: scale(0.8);\n    transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n  }\n}\n\n.selectable {\n  -webkit-user-select: text;\n  -khtml-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n\n.underline {\n  text-decoration: underline !important;\n}\n\n.transparent-bg {\n  background-color: transparent;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n\n.notransition * {\n  -webkit-transition: none !important;\n  -moz-transition: none !important;\n  -o-transition: none !important;\n  -ms-transition: none !important;\n  transition: none !important;\n}\n\na {\n  color: #6a32e6;\n  text-decoration: none;\n  background-color: transparent;\n}\n\n.is-invalid ~ .invalid-feedback {\n  display: block;\n}\n\nh4 {\n  font-size: 18px;\n}\n\n\n.flag-icon {\n  position: relative;\n  display: inline-block;\n  width: 3rem;\n  height: 2rem;\n  line-height: 1em;\n  border-radius: .25rem;\n  object-fit: cover;\n\n  &:before {\n    content: '\\00a0';\n  }\n}\n\n.flag-icon {\n  position: relative;\n  display: inline-block;\n  width: calc((4 / 3) * 1em);\n  line-height: 1em;\n  object-fit: cover;\n\n  &:before {\n    content: '\\00a0';\n  }\n}\n\n.text-green {\n  color: #28a745 !important;\n}\n\n.text-gold {\n  color: gold !important;\n}\n\n.text-grey {\n  color: dimgrey !important;\n}\n\n.text-red {\n  color: #dc3545 !important;\n}\n\n.grecaptcha-badge {\n  visibility: hidden;\n}\n\n.unselectable {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -webkit-user-drag: none;\n  user-select: none;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.overflow-scroll {\n  overflow: scroll;\n}\n\n.notransition * {\n  -webkit-transition: none;\n  -moz-transition: none;\n  -o-transition: none;\n  transition: none;\n}\n\nhr {\n  width: 100%;\n}\n\n\n\n.button {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  user-select: none;\n  border: 1px solid #0000;\n  line-height: 1.5;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 0 20px;\n  //min-height: 48px;\n  white-space: nowrap;\n  background-color: var(--purple6);\n  font-family: \"Inter\", sans-serif !important;\n\n  &:hover {\n    opacity: .9;\n  }\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: default;\n  }\n\n  &.thin {\n    min-height: 30px;\n    font-size: 12px;\n    padding: 0 10px;\n    border-radius: 6px;\n  }\n}\n\n.button-ghost {\n  background: #0000;\n  border-color: var(--black1);\n  border-radius: .5rem;\n  color: var(--black9);\n\n  &:hover {\n    background: var(--black1);\n  }\n}\n\n\n.w-90 {\n  width: 90% !important;\n}\n.w-80 {\n  width: 80% !important;\n}\n.w-70 {\n  width: 70% !important;\n}\n.w-60 {\n  width: 60%;\n}\n.w-50 {\n  width: 50%;\n}\n.w-40 {\n  width: 40%;\n}\n.w-30 {\n  width: 30% !important;\n}\n.w-20 {\n  width: 20%;\n}\n.w-10 {\n  width: 10%;\n}\n\n\n\n.purple-color {\n  color: var(--purple6) !important;\n}\n\n.text-nowrap {\n  white-space: nowrap;\n}\n\n.w-max {\n  width: max-content !important;\n}\n\n.link-like {\n  color: var(--purple6);\n  text-decoration: underline;\n  cursor: pointer;\n}",".recharts-cartesian {\n\n  &-axis-tick text {\n    fill: var(--black3) !important;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    text-transform: uppercase;\n  }\n\n  &-axis-tick-line {\n    display: none;\n  }\n\n  &-grid-horizontal line {\n    stroke: var(--black1);\n    stroke-dasharray: 3 3;\n  }\n}\n\n.recharts-xAxis line {\n  display: none;\n}\n\n.recharts-yAxis line {\n  display: none;\n}\n\n\n.recharts-custom-tooltip {\n  border-radius: .25rem;\n  padding: 0;\n  overflow: hidden;\n  padding-bottom: .5rem;\n  background: var(--black7);\n  color: var(--white);\n  width: 180px;\n  padding-bottom: 0;\n\n  .label {\n    padding: .75rem 1rem;\n    border-bottom: 1px solid var(--black6);\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 16px;\n    color: var(--white);\n    margin-bottom: 0;\n  }\n\n  .intro {\n    padding: 1rem;\n    display: flex;\n    align-items: center;\n    margin: 0;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 15px;\n    justify-content: space-between;\n\n    & > span {\n      display: flex;\n      align-items: center;\n    }\n\n    &:last-child {\n      padding-top: 0;\n      padding-bottom: 0;\n      margin-bottom: 0;\n    }\n\n    &:last-of-type i {\n      background: var(--purple6);\n    }\n\n    i {\n      display: flex;\n      margin-right: .5rem;\n      width: 10px;\n      height: 10px;\n      border-radius: 100%;\n      background: var(--black5);\n    }\n\n    &:last-child {\n      padding-bottom: 1rem;\n    }\n  }\n}",".screen {\n\n  &-title {\n    margin-top: .5rem;\n    margin-bottom: 0;\n    font-size: 1.5rem !important;\n    white-space: nowrap;\n    align-items: center;\n    display: flex;\n    margin-right: 1.5rem;\n    width: auto;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    line-height: 29px;\n    color: var(--black9) !important;\n\n    & + div {\n      width: auto;\n      display: flex;\n      justify-content: flex-end;\n    }\n\n    @media (max-width: 768px) {\n      font-weight: 500;\n      font-size: 1.5rem !important;\n    }\n\n    &-container {\n      display: flex;\n\n      @media (max-width: 768px) {\n        flex-wrap: wrap;\n      }\n    }\n  }\n\n  &-note {\n    margin: 1rem 0;\n    font-size: 0.8rem;\n    line-height: 1.2rem;\n    color: var(--black9);\n\n    @media (max-width: 768px) {\n      margin: .5rem 0;\n    }\n  }\n\n  &-header {\n    padding: 1.5rem 0;\n    align-items: flex-end;\n    justify-content: space-between;\n    display: flex;\n    position: relative;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      align-items: flex-start;\n      padding: 1rem 0;\n    }\n  }\n\n  &-filters {\n    display: flex;\n    justify-content: flex-end;\n    flex-wrap: wrap-reverse;\n    gap: .75rem;\n\n    &-button {\n      margin-left: 1rem;\n\n      @media (max-width: 768px) {\n        margin-left: 0;\n      }\n    }\n\n    @media (max-width: 768px) {\n      width: 100%;\n      margin-top: .25rem;\n      display: flex;\n      flex-direction: column;\n    }\n\n    .paylixecommerce-date-picker {\n      @media (max-width: 768px) {\n        width: 100%;\n        justify-content: center;\n      }\n    }\n  }\n\n  &-select {\n    max-width: 30%;\n\n    &.long {\n      max-width: 50%;\n    }\n  }\n\n}\n\n@media (max-width: 768px) {\n  .screen {\n\n    &-title {\n      font-weight: 500;\n      font-size: 1.5rem !important;\n\n      & + div {\n\n      }\n\n      &-container {\n        flex-wrap: wrap;\n      }\n    }\n\n    &-note {\n      margin: .5rem 0;\n    }\n\n    &-header {\n      flex-direction: column;\n      align-items: flex-start;\n      padding: 1rem 0;\n    }\n\n    &-filters {\n      width: 100%;\n      margin-top: 1rem;\n      margin-bottom: .25rem;\n      display: flex;\n      flex-direction: column;\n\n      & > .paylixecommerce-select, .paylixecommerce-input {\n\n      }\n\n      &-button {\n        margin-left: 0;\n      }\n\n      .paylixecommerce-date-picker {\n        width: 100%;\n        justify-content: center;\n      }\n    }\n\n    &-select {\n\n      &.long {\n\n      }\n    }\n\n  }\n\n\n}\n\n",".badge {\n  width: fit-content;\n  padding-left: 6px;\n  padding-right: 6px;\n  height: 20px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  white-space: nowrap;\n  text-transform: capitalize;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 15px;\n  color: var(--purple6);\n\n  img {\n    margin-right: .3rem;\n  }\n}\n\n.badge-pending, .badge-waiting-for-seller-response, .badge-file, .badge-ip, .badge-customer_dispute_ongoing {\n  background: var(--orange0) !important;\n  color: var(--orange6) !important;\n}\n\n.badge-asn, .badge-info-card, .badge-info, .badge-waiting_for_confirmations {\n  background: var(--orange0) !important;\n  color: var(--orange6) !important;\n}\n\n.badge-cancelled, .badge-voided, .badge-canceled, .badge-disabled, .badge-rejected, .badge-error, .badge-failed, .badge-none, .badge-unverified, .badge-bad {\n  background: var(--red0) !important;\n  color: var(--red6) !important;\n}\n\n.badge-completed, .badge-subscription, .badge-active, .badge-approved, .badge-isp, .badge-success, .badge-verified, .badge-good {\n  background: var(--green0) !important;\n  color: var(--green6) !important;\n}\n\n.badge-confirmation, .badge-country, .badge-partial {\n  background: var(--cyan0) !important;\n  color: var(--cyan6) !important;\n}\n\n.badge-trialing, .badge-waiting, .badge-dns, .badge-serials, .badge-developer, .badge-waiting_shop_action {\n  background: var(--blue0) !important;\n  color: var(--blue6) !important;\n}\n\n.badge-reversed, .badge-dynamic, .badge-host, .badge-reason {\n  background: var(--pink0) !important;\n  color: var(--pink6) !important;\n}\n\n.badge-refunded {\n  background: #3F4A6014 !important;\n  color: #3F4A60 !important;\n}\n\n.badge-ongoing, .badge-email, .badge-warning, .badge-service, .badge-paylixecommerce {\n  background: var(--purple1) !important;\n  color: var(--purple6) !important;\n}\n\n.badge-mark {\n  line-height: 26px;\n  text-align: center;\n  border-radius: 4px;\n  font-size: 16px !important;\n  font-weight: normal;\n  padding: 3px 10px;\n  margin: 2px;\n  vertical-align: middle;\n  background-color: var(--purple1) !important;\n  color: var(--purple6) !important;\n\n  &.gray {\n    background-color: var(--purple0)!important;\n    color: var(--black6)!important;\n  }\n}\n",".dark {\n\n  .paylixecommerce-select {\n    background-color: var(--black1);\n    //border-color: var(--black6);\n  }\n\n  .paylixecommerce-label {\n    color: var(--black);\n  }\n\n  .paylixecommerce-input {\n    background-color: var(--black1);\n    //border-color: var(--black6);\n  }\n\n  textarea.paylixecommerce-input {\n    background-color: var(--black1);\n    //border-color: var(--black6);\n  }\n\n  .react-mde {\n    .mde-textarea-wrapper {\n      textarea.mde-text {\n        background-color: var(--black1);\n        border-color: var(--black6);\n        border-bottom: none;\n        border-right: none;\n        border-left: none;\n      }\n    }\n\n    .mde-header {\n      background-color: var(--black1);\n      //border-color: var(--black6);\n    }\n\n  }\n\n  .switcher input:checked + .switcher-slider::before {\n    background: var(--black);\n  }\n\n  .switcher .switcher-slider {\n    background: var(--black3);\n  }\n\n}\n\n\n\n.paylixecommerce-note {\n  display: block;\n  align-items: end;\n  margin-top: .75rem;\n  margin-bottom: 0;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 15px;\n  color: var(--black5);\n\n  @media (max-width: 768px) {\n    font-weight: 400;\n  }\n\n  b {\n    color: var(--black9) !important;\n    font-weight: 600 !important;\n  }\n  a {\n    color: var(--purple6) !important;\n    font-weight: 600 !important;\n  }\n}\n\n.paylixecommerce-note-big {\n  display: block;\n  align-items: end;\n  margin-top: .75rem;\n  margin-bottom: 0;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: var(--black5);\n\n  b {\n    color: var(--black9) !important;\n    font-weight: 500 !important;\n  }\n  a {\n    color: var(--purple6) !important;\n    font-weight: 600 !important;\n  }\n}\n\n.d-block {\n  display: block;\n}\n\n\n.paylixecommerce-label {\n  margin-bottom: .75rem;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 17px;\n  color: var(--black5);\n  display: flex;\n\n  align-items: center;\n}\n\n.paylixecommerce-input-visible {\n  position: absolute;\n  right: 1rem;\n  bottom: .6rem;\n  cursor: pointer;\n}\n\n.paylixecommerce-input-prefix {\n  position: absolute;\n  height: 40px;\n  bottom: 0;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 1rem;\n  font-weight: bold;\n  color: var(--black9);\n  top: 29px;\n  right: 0;\n  border-left: 1px solid var(--black2);\n\n  & + div input {\n    padding-right: 2.5rem;\n  }\n}\n\n.paylixecommerce-select {\n  cursor: pointer;\n  padding: 0 2rem 0 14px;\n  height: 40px;\n  max-height: 40px;\n  width: 100%;\n  transition: border .3s ease;\n  outline: none;\n  border-radius: .5rem;\n  appearance: none;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  margin: 0;\n  color: var(--black9);\n  border: 1px solid var(--black2);\n  box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.05);\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: transparent;\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSA3LjVMMTAgMTIuNUwxNSA3LjUiIHN0cm9rZT0iI0EyQUFCNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==');\n  background-repeat: no-repeat;\n  background-position-x: calc(100% - 1rem);\n  background-position-y: 0.5rem;\n\n  &[disabled] {\n    background: var(--black0);\n    border-color: var(--black2);\n    cursor: default;\n  }\n\n  &:active {\n    border-color: var(--purple6);\n  }\n  &:focus {\n    border-color: var(--purple6);\n  }\n  &:hover {\n    border-color: var(--purple6);\n  }\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &.is-invalid {\n    border: 1px solid var(--red6) !important;\n\n    &:hover {\n      border-color: var(--red6) !important;\n    }\n    &:focus {\n      border-color: var(--red6) !important;\n    }\n  }\n}\n\n\n.switcher {\n  width: 2.75rem;\n  min-width: 2.75rem;\n  height: 1.5rem;\n  margin: 0 0 0 1rem;\n\n  &-label {\n    cursor: pointer;\n    width: calc(100% - 3.75rem);\n\n    .paylixecommerce-note {\n      font-weight: 400;\n      margin: 0;\n    }\n  }\n\n  &.left {\n    margin-right: 0;\n  }\n\n  &-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    width: 100%;\n\n    &.withBorder {\n      margin-bottom: 1rem;\n      padding-bottom: 1rem;\n      border-bottom: 1px solid var(--black1);\n    }\n\n    &.right {\n      .switcher {\n        margin-left: 0;\n        margin-right: 1rem;\n\n        &-label {\n          width: calc(100% - 3.75rem);\n        }\n      }\n    }\n  }\n\n  input {\n    display: none;\n    position: absolute;\n    margin-top: 0.3rem;\n    margin-left: -1.25rem;\n    width: 50px;\n\n    &:checked ~ .switcher-slider::before {\n      transform: translateX(19px);\n    }\n    &:checked + .switcher-slider {\n      background-color: var(--purple6);\n      border-color: var(--purple6);\n\n      &::before {\n        border-color: var(--purple6);\n      }\n    }\n  }\n\n  .switcher-slider {\n    background-color: var(--black1);\n    border: none;\n    border-radius: 50em;\n    font-size: 12px;\n    position: relative;\n    display: block;\n    height: inherit;\n    cursor: pointer;\n    transition: .15s ease-out;\n\n    &:before {\n      width: 20px;\n      height: 20px;\n      top: 2px;\n      border-radius: 100%;\n      position: absolute;\n      left: 2px;\n      box-sizing: border-box;\n      content: \"\";\n      background-color: var(--white);\n      border: 1px solid var(--black1);\n      transition: .15s ease-out;\n      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);\n    }\n\n    span {\n      border-radius: 50em;\n      font-size: 12px;\n      background-color: var(--black0);\n      border: none;\n      position: relative;\n      display: block;\n      height: inherit;\n      cursor: pointer;\n      transition: .15s ease-out;\n    }\n  }\n}\n\n.paylixecommerce-input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 1px solid var(--black2);\n  box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.05);\n  border-radius: .5rem;\n  background: var(--white);\n  width: 100%;\n  padding: 0 14px;\n  transition: border .3s ease !important;\n  height: 40px;\n  max-height: 40px;\n  outline: none;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--black9);\n\n  &.textarea {\n    height: auto;\n    max-height: none;\n    padding: .75rem 1rem;\n    border-radius: .5rem;\n    border: 1px solid var(--black2);\n    box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.05);\n    min-height: 80px;\n  }\n\n  &.is-invalid {\n    border: 1px solid var(--red6) !important;\n\n    &:hover {\n      border-color: var(--red6) !important;\n    }\n    &:focus {\n      border-color: var(--red6) !important;\n    }\n  }\n\n  &:active {\n    border-color: var(--purple6);\n  }\n  &:focus {\n    border-color: var(--purple6);\n  }\n  &:hover {\n    border-color: var(--purple6) !important;\n  }\n\n  &::placeholder {\n    color: var(--black3);\n  }\n\n  &[disabled] {\n    background: var(--black0);\n    border-color: var(--black2);\n\n    &:focus {\n      border-color: var(--black2);\n    }\n  }\n}\n\n.paylixecommerce-checkbox {\n  background-color: #0000;\n  border: 1px solid #0000;\n  position: relative;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5rem;\n  cursor: pointer;\n  font-weight: 500;\n  margin-bottom: 1rem;\n  margin-right: 1.5rem;\n\n  input {\n    box-sizing: border-box;\n    padding: 0;\n    position: absolute;\n    z-index: -1;\n    opacity: 0;\n\n    &:not(:disabled):active ~ label::before {\n      color: #fff;\n      background-color: var(--black0);\n      border-color: var(--black3);\n    }\n\n    &:focus ~ label::before {\n      border-color: var(--purple6);\n      box-shadow: 0 0 0 0.2rem rgb(97 59 234 / 25%);\n    }\n\n    &:checked ~ label::before {\n      color: #fff;\n      border-color: var(--purple6);\n      background-color: var(--purple6);\n    }\n\n    &:checked ~ label {\n      color: var(--black9);\n    }\n\n    &:checked ~ label::after {\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\") !important;\n      border: 1px solid var(--purple6);\n    }\n  }\n\n  label {\n    position: relative;\n    margin-bottom: 0;\n    font-weight: 400;\n    //cursor: pointer;\n    //font-family: 'Inter';\n    //font-style: normal;\n    //font-weight: 500;\n    //font-size: 14px;\n    //line-height: 17px;\n    //color: var(--black4);\n\n    &:before {\n      position: absolute;\n      cursor: pointer;\n      display: block;\n      pointer-events: none;\n      content: \"\";\n      background-color: var(--white);\n      top: 50%;\n      transform: translateY(-50%);\n      border-radius: 2px;\n      transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n      width: 18px;\n      height: 18px;\n      left: -1.75rem;\n      border: 1px solid var(--black5) !important;\n    }\n\n    &:after {\n      top: 50%;\n      cursor: pointer;\n      transform: translateY(-50%);\n      position: absolute;\n      display: block;\n      content: \"\";\n      background: no-repeat 50%/50% 50%;\n      width: 18px;\n      height: 18px;\n      left: -1.75rem;\n      border-radius: 2px;\n    }\n  }\n}\n\n\n.is-invalid .react-mde {\n  textarea {\n    border: 1px solid var(--red6) !important;\n    &:focus {\n      border-color: var(--red6) !important;\n    }\n  }\n}\n\n.react-mde {\n  border: none;\n  border-radius: .5rem;\n\n  .grip {\n    border-top: none;\n    background: var(--black9)\n  }\n\n  ul.mde-header-group {\n    padding: 0 .5rem;\n    margin: .5rem 0;\n\n    li {\n      display: flex !important;\n      align-items: center;\n    }\n  }\n\n  .mde-header {\n    background: var(--white);\n    border: 1px solid var(--black2);\n    border-radius: .5rem .5rem 0 0;\n    border-bottom: none;\n\n    svg {\n      path {\n        fill: var(--black5);\n      }\n    }\n\n    i {\n      color: var(--black5);\n    }\n\n    .mde-tabs {\n      button {\n        border: none;\n        text-align: center;\n        margin: .5rem;\n        position: relative;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        cursor: pointer;\n        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n        padding: 0 1rem;\n        text-align: center;\n        font-family: \"Inter\" !important;\n        border-radius: 0.5rem;\n        font-size: 0.875rem;\n        line-height: 18px;\n        box-sizing: border-box;\n        user-select: none;\n        border: none;\n        color: var(--white);\n        background-color: var(--black9);\n        font-weight: 600;\n        height: 1.75rem;\n        font-size: 0.813rem;\n\n\n        &.selected {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .mde-textarea-wrapper {\n    textarea.mde-text {\n      padding: 1rem !important;\n      border: 1px solid var(--black2);\n      border-radius: 0 0 .5rem .5rem;\n      box-shadow: inset 0px 1px 2px rgba(16, 24, 40, 0.05);\n      height: 100px;\n      font-size: 14px;\n      background: var(--white);\n      color: var(--black9) !important;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n\n    &:focus {\n        outline: none;\n        border-color: var(--purple6);\n      }\n    }\n  }\n\n}\n\n\n.invalid-feedback {\n  width: 100%;\n  margin-top: .25rem;\n  font-size: 80%;\n  color: var(--red6);\n}\n\n.paylixecommerce-text, div.mde-preview div.mde-preview-content {\n  color: var(--black6);\n\n  h1 {\n    font-size: 1.6rem;\n    line-height: 3rem;\n  }\n  h2 {\n    font-size: 1.4rem;\n    line-height: 2.5rem;\n  }\n  h3 {\n    font-size: 1.3rem;\n    line-height: 2.4rem;\n  }\n  h4 {\n    font-size: 1.1rem;\n    line-height: 2rem;\n  }\n  h6 {\n    font-weight: 500;\n  }\n\n  p {\n    font-size: .9rem;\n    margin: 0;\n    line-height: 1.2rem;\n    margin-bottom: .6rem;\n    color: var(--black9);\n  }\n\n  input[type=checkbox] {\n    width: 30px;\n    height: 20px;\n    cursor: pointer;\n    font-size: 21px;\n    visibility: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 1rem -2rem;\n    transform: scale(1.25);\n\n    &:after {\n      content: \" \";\n      background-color: #fff;\n      display: inline-block;\n      margin-left: 10px;\n      padding-bottom: 5px;\n      color: #221d3e;\n      width: 17px;\n      height: 17px;\n      visibility: visible;\n      border: 2px solid #181432;\n      padding-left: 3px;\n      border-radius: 2px;\n    }\n\n    &:checked:after {\n      content: \"x\";\n      font-weight: bold;\n      font-size: .8rem;\n      color: #181432;\n      position: relative;\n      padding-bottom: 0;\n      text-align: center;\n      display: flex;\n      align-items: center;\n      justify-content: left;\n      cursor: pointer;\n    }\n  }\n\n  pre {\n    padding: 1rem;\n    border-radius: 2px;\n    margin-top: 1rem;\n    overflow: auto;\n    display: block;\n    line-height: 1rem;\n  }\n\n  ul, ol {\n    line-height: 1.5rem;\n    padding-left: 1.5rem;\n\n    li {\n\n    }\n  }\n\n  ol {\n    list-style: auto;\n    padding-top: 0.5rem;\n  }\n\n  img {\n    max-width: 100%;\n    border-radius: .5rem;\n  }\n}\n\n.dark {\n\n  .edit-modal {\n\n    .info-table {\n      background: var(--white);\n      border: 1px solid var(--black2);\n\n      .info-table-header {\n        background: var(--black1);\n      }\n      .info-table-body > div:not(.paylixecommerce-table-container) {\n        border-color: var(--black2);\n      }\n\n      &.table {\n        .info-table-header {\n          background: var(--black1);\n          border-bottom-color: var(--black0);\n\n          .screen-search input {\n            background: var(--black0);\n          }\n        }\n        .info-table-body {\n          background-color: var(--black1);\n          border-radius: 0 0 .5rem .5rem;\n        }\n      }\n    }\n\n  }\n\n  .info-table {\n    background: var(--white);\n    border-color: transparent;\n\n    .info-table-header {\n      background: var(--black1);\n    }\n    .info-table-body > div:not(.paylixecommerce-table-container) {\n      border-color: var(--black1);\n    }\n\n    &.table {\n      .info-table-header {\n        background: var(--black1);\n        border-bottom-color: var(--black0);\n\n        .screen-search input {\n          background: var(--black0);\n        }\n      }\n      .info-table-body {\n        background-color: var(--black1);\n        border-radius: 0 0 .5rem .5rem;\n      }\n    }\n  }\n}\n\n.info-table {\n  display: flex !important;\n  flex-direction: column;\n  width: 100%;\n  background: var(--white);\n  border-radius: .5rem;\n  border: 1px solid var(--black1);\n  margin-bottom: 1rem;\n  margin-top: 0;\n\n  &.table {\n    .paylixecommerce-table-container {\n      padding: 0;\n      box-shadow: none;\n\n      .paylixecommerce-table {\n        padding: 0;\n        box-shadow: none;\n\n        table {\n          thead th {\n            padding: .5rem 0.75rem;\n          }\n          tbody tr td {\n            border-top-color: var(--black1) !important;\n          }\n        }\n\n        &-container {\n          padding: 0;\n        }\n      }\n    }\n  }\n\n  &.with-shadow {\n    box-shadow: 0px 1px 3px rgb(7 14 35 / 6%), 0px 2px 8px -1px rgb(7 14 35 / 5%);\n    border: none;\n  }\n\n  &.collapsed {\n    .info-table-header {\n      border-bottom: none;\n      border-radius: .5rem .5rem .5rem .5rem;\n    }\n  }\n\n  &-header {\n    padding: 1.25rem;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--black9);\n    cursor: pointer;\n    border-radius: .5rem .5rem 0 0;\n\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--black1);\n  }\n\n  &-body {\n    & > div:not(.paylixecommerce-table-container) {\n      display: flex;\n      width: 100%;\n      border-top: 1px solid var(--black1);\n      padding: 1rem 1.25rem;\n      justify-content: space-between;\n      color: var(--black4);\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 13px;\n      line-height: 16px;\n      border-radius: 0 0 .5rem .5rem;\n\n      &:first-child {\n        border-top: none;\n      }\n\n      span:first-child {\n        width: 30%;\n      }\n\n      span:last-child {\n        width: 70%;\n        text-align: right;\n        color: var(--black9);\n        word-break: break-word;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n\n  .info-table {\n\n    &.table {\n      .paylixecommerce-table-container {\n\n        .paylixecommerce-table {\n\n          table {\n            thead th {\n              padding: .5rem 0.75rem;\n            }\n            tbody tr td {\n            }\n          }\n\n          &-container {\n\n          }\n        }\n      }\n    }\n\n    &.with-shadow {\n\n    }\n\n    &.collapsed {\n      .info-table-header {\n\n      }\n    }\n\n    &-header {\n      padding: 1rem;\n    }\n\n    &-body {\n      & > div:not(.paylixecommerce-table-container) {\n        padding: .75rem 1rem;\n\n        &:first-child {\n\n        }\n\n        span:first-child {\n\n        }\n\n        span:last-child {\n\n        }\n      }\n    }\n  }\n}\n\n\n.is-invalid-select > div:first-of-type {\n  border: 1px solid var(--red6) !important;\n\n  &:hover {\n    border-color: var(--red6) !important;\n  }\n  &:focus {\n    border-color: var(--red6) !important;\n  }\n}",".mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.d-none {\n  display: none !important;\n}\n.d-flex {\n  display: flex !important;\n}\n.gap-1 {\n  gap: .25rem;\n}\n.gap-2 {\n  gap: .5rem;\n}\n.gap-3 {\n  gap: .75rem;\n}\n.gap-4 {\n  gap: 1rem;\n}\n.gap-5 {\n  gap: 1.25rem;\n}\n.gap-6 {\n  gap: 1.5rem;\n}\n\n.d-inline {\n  display: inline-flex !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.my-1 {\n  margin-top: .25rem !important;\n  margin-bottom: .25rem !important;\n}\n.my-2 {\n  margin-top: .5rem !important;\n  margin-bottom: .5rem !important;\n}\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n.mx-1 {\n  margin-right: .25rem !important;\n  margin-left: .25rem !important;\n}\n.mx-2 {\n  margin-right: .5rem !important;\n  margin-left: .5rem !important;\n}\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.py-1 {\n  padding-top: .25rem !important;\n  padding-bottom: .25rem !important;\n}\n.py-2 {\n  padding-top: .5rem !important;\n  padding-bottom: .5rem !important;\n}\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n.px-1 {\n  padding-right: .25rem !important;\n  padding-left: .25rem !important;\n}\n.px-2 {\n  padding-right: .5rem !important;\n  padding-left: .5rem !important;\n}\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n.p-1 {\n  padding: .25rem;\n}\n.p-2 {\n  padding: .5rem;\n}\n.p-3 {\n  padding: 1rem;\n}\n.p-4 {\n  padding: 1.5rem;\n}\n.p-5 {\n  padding: 1.5rem;\n}\n.p-0 {\n  padding: 0;\n}\n\n.m-1 {\n  margin: .25rem;\n}\n.m-2 {\n  margin: .5rem;\n}\n.m-3 {\n  margin: 1rem;\n}\n.m-4 {\n  margin: 1.5rem;\n}\n.m-5 {\n  margin: 1.5rem;\n}\n.m-0 {\n  margin: 0;\n}\n\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.mb-1 {\n  margin-bottom: .25rem !important;\n}\n.mb-2 {\n  margin-bottom: .5rem !important;\n}\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n.mt-1 {\n  margin-top: .25rem !important;\n}\n.mt-2 {\n  margin-top: .5rem !important;\n}\n.mt-3 {\n  margin-top: 1rem !important;\n}\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n\n.m-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.mr-0 {\n  margin-right: 0 !important;\n}\n.mr-1 {\n  margin-right: .25rem !important;\n}\n.mr-2 {\n  margin-right: .5rem !important;\n}\n.mr-3 {\n  margin-right: 1rem !important;\n}\n.mr-4 {\n  margin-right: 1.5rem !important;\n}\n.mr-5 {\n  margin-right: 3rem !important;\n}\n\n\n.ml-0 {\n  margin-left: 0 !important;\n}\n.ml-1 {\n  margin-left: .25rem !important;\n}\n.ml-2 {\n  margin-left: .5rem !important;\n}\n.ml-3 {\n  margin-left: 1rem !important;\n}\n.ml-4 {\n  margin-left: 1.5rem !important;\n}\n.ml-5 {\n  margin-left: 3rem !important;\n}\n\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n.pb-1 {\n  padding-bottom: .25rem !important;\n}\n.pb-2 {\n  padding-bottom: .5rem !important;\n}\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.ml-auto {\n  margin-left: auto;\n}\n.mr-auto {\n  margin-right: auto;\n}\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n.pt-0 {\n  padding-top: 0 !important;\n}\n.pt-1 {\n  padding-top: .25rem !important;\n}\n.pt-2 {\n  padding-top: .5rem !important;\n}\n.pt-3 {\n  padding-top: 1rem !important;\n}\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n\n.pr-0 {\n  padding-right: 0 !important;\n}\n.pr-1 {\n  padding-right: .25rem !important;\n}\n.pr-2 {\n  padding-right: .5rem !important;\n}\n.pr-3 {\n  padding-right: 1rem !important;\n}\n.pr-4 {\n  padding-right: 1.5rem !important;\n}\n.pr-5 {\n  padding-right: 3rem !important;\n}\n\n\n.pl-0 {\n  padding-left: 0 !important;\n}\n.pl-1 {\n  padding-left: .25rem !important;\n}\n.pl-2 {\n  padding-left: .5rem !important;\n}\n.pl-3 {\n  padding-left: 1rem !important;\n}\n.pl-4 {\n  padding-left: 1.5rem !important;\n}\n.pl-5 {\n  padding-left: 3rem !important;\n}\n\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.d-none {\n  display: none !important;\n}\n.d-flex {\n  display: flex !important;\n}\n.gap-1 {\n  gap: .25rem;\n}\n.gap-2 {\n  gap: .5rem;\n}\n.gap-3 {\n  gap: .75rem;\n}\n.gap-4 {\n  gap: 1rem;\n}\n.gap-5 {\n  gap: 1.25rem;\n}\n.gap-6 {\n  gap: 1.5rem;\n}\n\n.d-inline {\n  display: inline-flex !important;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-bottom: .5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh3 {\n  font-size: 1.75rem;\n}\n\nh6 {\n  font-size: 1rem;\n}\n\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid var(--black1);\n}\n\nsmall {\n  font-size: 80%;\n  font-weight: 400;\n}\n\nlabel {\n  //margin-bottom: .5rem;\n}\n\na {\n  color: #6a3ce2;\n  text-decoration: none;\n  background-color: #0000;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n.flex-row            { flex-direction: row !important; }\n.flex-column         { flex-direction: column !important; }\n.flex-row-reverse    { flex-direction: row-reverse !important; }\n.flex-column-reverse { flex-direction: column-reverse !important; }\n\n.flex-wrap         { flex-wrap: wrap !important; }\n.flex-nowrap       { flex-wrap: nowrap !important; }\n.flex-wrap-reverse { flex-wrap: wrap-reverse !important; }\n.flex-fill         { flex: 1 1 auto !important; }\n\n.justify-content-start   { justify-content: flex-start !important; }\n.justify-content-end     { justify-content: flex-end !important; }\n.justify-content-center  { justify-content: center !important; }\n.justify-content-between { justify-content: space-between !important; }\n.justify-content-around  { justify-content: space-around !important; }\n\n.align-items-start    { align-items: flex-start !important; }\n.align-items-end      { align-items: flex-end !important; }\n.align-items-center   { align-items: center !important; }\n.align-items-baseline { align-items: baseline !important; }\n.align-items-stretch  { align-items: stretch !important; }\n\n.align-content-start   { align-content: flex-start !important; }\n.align-content-end     { align-content: flex-end !important; }\n.align-content-center  { align-content: center !important; }\n.align-content-between { align-content: space-between !important; }\n.align-content-around  { align-content: space-around !important; }\n.align-content-stretch { align-content: stretch !important; }\n\n.align-self-auto     { align-self: auto !important; }\n.align-self-start    { align-self: flex-start !important; }\n.align-self-end      { align-self: flex-end !important; }\n.align-self-center   { align-self: center !important; }\n.align-self-baseline { align-self: baseline !important; }\n.align-self-stretch  { align-self: stretch !important; }\n\n.w-100 {\n  width: 100% !important;\n}\n.w-auto {\n  width: auto !important;\n}",".__react-grand-tour__highlight {\n  transition: transform .5s ease, height .3s ease, width .3s ease !important;\n}\n\n.__react-grand-tour__modal-position-track {\n  transition: all .3s !important;\n}\n\n.dark .__react-grand-tour__highlight {\n  box-shadow: 0 0 0 calc(200vh + 200vw) rgba(0, 0, 0, .7) !important;\n}\n\n\n.__react-grand-tour__highlight {\n  box-shadow: 0 0 0 calc(200vh + 200vw) rgba(255, 255, 255, .92) !important;\n  position: relative;\n\n  &.left {\n    &:after {\n      right: auto;\n      top: calc(50% - 8px);\n      left: calc(100% - 8px);\n    }\n  }\n\n  &.top {\n    &:after {\n      left: calc(50% - 8px);\n      top: -10px;\n    }\n  }\n\n  &.right {\n    &:after {\n      right: calc(100% - 10px);\n      top: calc(50% - 8px);\n      left: auto;\n    }\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    background: var(--purple6);\n    border-radius: 100%;\n    border: 1px solid var(--purple6);\n    box-shadow: 0 0 0 2px inset var(--white);\n    left: calc(100% - 12px);\n    top: calc(50% - 10px);\n  }\n}\n\n.paylixecommerce-onboarding-container {\n\n}\n\n\n.paylixecommerce-onboarding {\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--black5);\n\n  b {\n    display: flex;\n    width: 100%;\n    margin-bottom: .5rem;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 16px;\n    color: var(--black9);\n  }\n\n  &-navigation {\n    margin-top: 1.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-width: 296px;\n    width: 100%;\n\n    &-note {\n      font-size: 0.7rem;\n      color: var(--black4);\n      text-align: center;\n      margin-top: .5rem;\n    }\n\n    &-dots {\n      display: flex;\n      flex-wrap: wrap;\n      margin: 0 .5rem;\n      gap: .25rem;\n\n      & > div {\n        width: 1rem;\n        height: 1rem;\n        border: 1px solid var(--black3);\n        border-radius: .25rem;\n        cursor: pointer;\n\n        &:nth-child(11n) {\n          margin-right: 0;\n        }\n\n        &.active {\n          background: var(--purple6);\n          border: 1px solid var(--purple6);\n        }\n      }\n    }\n\n    i {\n      cursor: pointer;\n    }\n  }\n\n  &-close {\n    position: relative;\n    font-size: 1rem !important;\n    color: var(--black4) !important;\n  }\n\n  &-container {\n    background: var(--white);\n    border: 1px solid var(--black2);\n    padding: 1.25rem;\n    border-radius: .5rem;\n    color: var(--black9);\n    position: relative;\n\n    .__react-grand-tour__close-button {\n      background: var(--black1);\n      width: 1.5rem;\n      height: 1.5rem;\n      border-radius: 100%;\n      top: 1.25rem;\n      right: 1.25rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n  }\n}",".dark {\n  .edit-modal-footer {\n    background: var(--black0);\n  }\n  .edit-modal-header {\n    background: var(--black0);\n  }\n}\n\n.edit-modal {\n  position: fixed;\n  top: 1rem;\n  height: calc(100vh - 2rem);\n  max-height: calc(100vh - 2rem);\n  min-height: calc(100vh - 2rem);\n  overflow: auto;\n  width: 50vw;\n  right: 1rem;\n  background: var(--white);\n  padding: 2rem;\n  border-radius: 0.5rem;\n  z-index: 999999999;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n\n  &-body {\n    //overflow: auto;\n    //width: 100%;\n    //max-height: 500px;\n    //background:\n    //        linear-gradient(white 30%, rgba(255, 255, 255, 0)), linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%, /* Shadows */\n    //        radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, .2), rgba(0, 0, 0, 0)), radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, .2), rgba(0, 0, 0, 0)) 0 100%;\n    //background-repeat: no-repeat;\n    //background-color: white;\n    //background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;\n    //background-attachment: local, local, scroll, scroll;\n\n\n    &::-webkit-scrollbar {\n      width: 0;\n      height: 0;\n      background-color: transparent;\n\n      &-track {\n        background-color: transparent;\n      }\n\n      &-thumb {\n        background-color: rgba(0, 0, 0, 0.3);\n      }\n    }\n  }\n\n\n  &::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n    background-color: transparent;\n\n    &-track {\n      background-color: transparent;\n    }\n\n    &-thumb {\n      background-color: rgba(0, 0, 0, 0.3);\n    }\n  }\n\n  &-header {\n    padding: 0;\n    flex-shrink: 0;\n    position: relative;\n\n    &-title {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 24px;\n      line-height: 29px;\n      color: var(--black9);\n    }\n\n    &-badge {\n      position: absolute;\n      top: 1.75rem;\n      right: 2rem;\n    }\n\n    &-ref {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 20px;\n      color: var(--black5);\n      border-bottom: 1px solid var(--black1);\n      margin-bottom: 2rem;\n      margin-top: .5rem;\n\n      p {\n        margin-bottom: 1rem;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n\n  &-body {\n    flex-grow: 1;\n    padding-bottom: calc(5rem - 1px) !important;\n  }\n\n  &-footer {\n    flex-shrink: 0;\n    display: flex;\n    padding: 1.25rem;\n    box-shadow: 0px -1px 3px rgba(7, 14, 35, 0.04), 0px -4px 8px -1px rgba(7, 14, 35, 0.04);\n    justify-content: flex-end;\n    height: calc(5rem - 1px);\n    position: fixed;\n    bottom: 1rem;\n    width: 50%;\n    background: var(--white);\n    border-radius: 0 0 0.5rem 0.5rem;\n    z-index: 2;\n    gap: 1rem;\n  }\n\n  &.padding {\n    padding: 0;\n\n    .edit-modal-header {\n      padding: 1.5rem 1.5rem 1.5rem 1.5rem;\n      border-bottom: 1px solid var(--black2);\n    }\n\n    .edit-modal-header-ref {\n      margin-bottom: 0;\n      border-bottom: 0;\n    }\n  }\n\n  &-overlay {\n    position: fixed;\n    background: #00000050;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    right: 0;\n    cursor: pointer;\n    z-index: 999999999;\n    backdrop-filter: blur(2px);\n  }\n}\n\n\n@media (max-width: 768px) {\n  .edit-modal {\n    width: 100vw;\n    height: 100%;\n    max-height: 100%;\n    min-height: 100%;\n    border-radius: 0;\n    top: 0;\n    right: 0;\n    padding: 1.25rem 1rem;\n\n    &-body {\n      padding-bottom: 6rem !important;\n    }\n\n    &-header {\n      padding: 1.25rem 1rem;\n\n      &-title {\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 19px;\n      }\n\n      &-badge {\n        top: 1rem;\n        right: 1rem;\n      }\n\n      &-ref {\n        font-weight: 400;\n        font-size: 13px;\n        line-height: 18px;\n        margin-top: .75rem;\n\n        p {\n\n          &:last-child {\n\n          }\n        }\n      }\n    }\n\n    &-footer {\n      position: fixed;\n      bottom: 0;\n      width: 100%;\n      background: var(--white);\n      z-index: 9;\n\n      button {\n\n\n        &.white {\n\n        }\n        &.button-ghost  {\n\n        }\n      }\n    }\n\n    &.padding {\n\n      .edit-modal-header {\n        padding: 1rem 1.25rem;\n      }\n\n      .edit-modal-header-ref {\n\n      }\n    }\n\n    &-overlay {\n\n    }\n  }\n}","\n\n.table-mobile-card {\n  background: var(--white);\n  box-shadow: 0 1px 3px rgb(7 14 35 / 6%), 0 2px 8px -1px rgb(7 14 35 / 5%);\n  border-radius: .5rem;\n  margin-bottom: 1rem;\n\n  &-header {\n    display: flex;\n    justify-content: space-between;\n    padding: 1rem;\n    border-bottom: 1px solid var(--black1);\n\n    &-main {\n      display: flex;\n      flex-direction: column;\n\n      & > a {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 18px;\n        color: var(--black9);\n        display: flex;\n      }\n\n      div {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 15px;\n        color: var(--black4);\n        display: flex;\n        margin-top: .25rem;\n      }\n    }\n\n    &-icon {\n      background: var(--black0);\n      width: 2.5rem;\n      height: 2.5rem;\n      border-radius: .5rem;\n      object-fit: fill;\n      margin-right: .75rem;\n      background: var(--black0);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      svg * {\n        stroke: var(--black3);\n      }\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: fill;\n        overflow: hidden;\n        border-radius: 0.5rem;\n      }\n    }\n  }\n\n  &-body {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n\n    &-list {\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n\n      & > div {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 13px;\n        line-height: 16px;\n        color: var(--black5);\n        margin-bottom: .75rem;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n\n        & > div {\n          &:first-child {\n            padding-right: 1rem;\n          }\n          &:last-child {\n            color: var(--black9);\n          }\n        }\n      }\n    }\n\n    &-info {\n      align-items: center;\n      display: flex;\n      flex-wrap: wrap;\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 13px;\n      line-height: 16px;\n      color: var(--black9);\n\n      @media (max-width: 360px) {\n        div {\n          width: 100%;\n          margin-bottom: .5rem;\n          margin-right: 0 !important;\n          display: flex;\n          justify-content: flex-end;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n  }\n\n  &-footer {\n    display: flex;\n    padding: 1rem;\n    padding-top: 0;\n    justify-content: space-between;\n\n    button {\n      width: calc(50% - .5rem);\n    }\n  }\n\n}",".react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {\n  border-color: #ccc;\n  border-style: solid;\n  border-width: 3px 3px 0 0;\n  content: \"\";\n  display: block;\n  height: 9px;\n  position: absolute;\n  top: 6px;\n  width: 9px;\n}\n\n.react-datepicker__header.react-datepicker__header--time.react-datepicker__header--time--only {\n  padding-top: .75rem;\n  padding-left: 0;\n  padding-right: 0;\n}\n.react-datepicker__time-container .react-datepicker__time {\n  padding-top: .5rem;\n  background-color: var(--black0) !important;\n\n  .react-datepicker__time-box {\n    background: var(--black0);\n    color: var(--black9);\n    width: 100%;\n\n    ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n      background-color: var(--black1) !important;\n    }\n  }\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  margin-left: -4px;\n  position: absolute;\n  width: 0;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  box-sizing: content-box;\n  position: absolute;\n  border: 8px solid transparent;\n  height: 0;\n  width: 1px;\n  content: \"\";\n  z-index: -1;\n  border-width: 8px;\n  left: -8px;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  top: 0;\n  margin-top: -8px;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  border-top: none;\n  border-bottom-color: #f0f0f0;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  top: 0;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  top: -1px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {\n  bottom: 0;\n  margin-bottom: -8px;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {\n  border-bottom: none;\n  border-top-color: #fff;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {\n  bottom: 0;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {\n  bottom: -1px;\n  border-top-color: #aeaeae;\n}\n\n.react-datepicker-wrapper {\n  display: inline-block;\n  padding: 0;\n  border: 0;\n}\n\n.react-datepicker {\n  font-family: \"Helvetica Neue\", helvetica, arial, sans-serif;\n  font-size: 0.8rem;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  display: inline-block;\n  position: relative;\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n  left: 35px;\n}\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n.react-datepicker--time-only .react-datepicker__time,\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 1;\n}\n.react-datepicker-popper[data-placement^=bottom] {\n  padding-top: 10px;\n}\n.react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle, .react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle {\n  left: auto;\n  right: 50px;\n}\n.react-datepicker-popper[data-placement^=top] {\n  padding-bottom: 10px;\n}\n.react-datepicker-popper[data-placement^=right] {\n  padding-left: 8px;\n}\n.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {\n  left: auto;\n  right: 42px;\n}\n.react-datepicker-popper[data-placement^=left] {\n  padding-right: 8px;\n}\n.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {\n  left: 42px;\n  right: auto;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid #aeaeae;\n  border-top-left-radius: 0.3rem;\n  padding: 8px 0;\n  position: relative;\n}\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n  border-top-left-radius: 0;\n}\n.react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 15px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n  color: #000;\n  font-weight: bold;\n  font-size: 0.944rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  align-items: center;\n  background: none;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 2px;\n  padding: 0;\n  border: none;\n  z-index: 1;\n  height: 32px;\n  width: 32px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n.react-datepicker__navigation--previous {\n  left: 2px;\n}\n.react-datepicker__navigation--next {\n  right: 2px;\n}\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 85px;\n}\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n}\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n}\n.react-datepicker__navigation:hover *::before {\n  border-color: #a6a6a6;\n}\n\n.react-datepicker__navigation-icon {\n  position: relative;\n  top: -1px;\n  font-size: 20px;\n  width: 0;\n}\n.react-datepicker__navigation-icon--next {\n  left: -2px;\n}\n.react-datepicker__navigation-icon--next::before {\n  transform: rotate(45deg);\n  left: -7px;\n}\n.react-datepicker__navigation-icon--previous {\n  right: -2px;\n}\n.react-datepicker__navigation-icon--previous::before {\n  transform: rotate(225deg);\n  right: -7px;\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__year {\n  margin: 0.4rem;\n  text-align: center;\n}\n.react-datepicker__year-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 180px;\n}\n.react-datepicker__year .react-datepicker__year-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__month {\n  margin: 0.4rem;\n  text-align: center;\n}\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__input-time-container {\n  clear: both;\n  width: 100%;\n  float: left;\n  margin: 5px 0 10px 15px;\n  text-align: left;\n}\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n  display: inline-block;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container {\n  display: inline-block;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n  display: inline-block;\n  margin-left: 10px;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {\n  width: auto;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {\n  -moz-appearance: textfield;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {\n  margin-left: 5px;\n  display: inline-block;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #aeaeae;\n  width: 85px;\n}\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -87px;\n  top: 0;\n}\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 85px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  height: calc(195px + (1.7rem / 2));\n  overflow-y: scroll;\n  padding-right: 0;\n  padding-left: 0;\n  width: 100%;\n  box-sizing: content-box;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  height: 30px;\n  padding: 5px 10px;\n  white-space: nowrap;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #f0f0f0;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #216ba5;\n  color: white;\n  font-weight: bold;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #216ba5;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #ccc;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ccc;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #000;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text,\n.react-datepicker__year-text {\n  cursor: pointer;\n}\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover,\n.react-datepicker__year-text:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today {\n  font-weight: bold;\n}\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted,\n.react-datepicker__year-text--highlighted {\n  border-radius: 0.3rem;\n  background-color: #3dcc4a;\n  color: #fff;\n}\n.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover,\n.react-datepicker__quarter-text--highlighted:hover,\n.react-datepicker__year-text--highlighted:hover {\n  background-color: #32be3f;\n}\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1,\n.react-datepicker__year-text--highlighted-custom-1 {\n  color: magenta;\n}\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2,\n.react-datepicker__year-text--highlighted-custom-2 {\n  color: green;\n}\n.react-datepicker__day--holidays,\n.react-datepicker__month-text--holidays,\n.react-datepicker__quarter-text--holidays,\n.react-datepicker__year-text--holidays {\n  position: relative;\n  border-radius: 0.3rem;\n  background-color: #ff6803;\n  color: #fff;\n}\n.react-datepicker__day--holidays .holiday-overlay,\n.react-datepicker__month-text--holidays .holiday-overlay,\n.react-datepicker__quarter-text--holidays .holiday-overlay,\n.react-datepicker__year-text--holidays .holiday-overlay {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #333;\n  color: #fff;\n  padding: 4px;\n  border-radius: 4px;\n  white-space: nowrap;\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s, opacity 0.3s ease-in-out;\n}\n.react-datepicker__day--holidays:hover,\n.react-datepicker__month-text--holidays:hover,\n.react-datepicker__quarter-text--holidays:hover,\n.react-datepicker__year-text--holidays:hover {\n  background-color: #cf5300;\n}\n.react-datepicker__day--holidays:hover .holiday-overlay,\n.react-datepicker__month-text--holidays:hover .holiday-overlay,\n.react-datepicker__quarter-text--holidays:hover .holiday-overlay,\n.react-datepicker__year-text--holidays:hover .holiday-overlay {\n  visibility: visible;\n  opacity: 1;\n}\n.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover {\n  background-color: #1d5d90;\n}\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #bad9f1;\n  color: rgb(0, 0, 0);\n}\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover,\n.react-datepicker__year-text--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range) {\n  background-color: rgba(33, 107, 165, 0.5);\n}\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range), .react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range) {\n  background-color: #f0f0f0;\n  color: #000;\n}\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled,\n.react-datepicker__year-text--disabled {\n  cursor: default;\n  color: #ccc;\n}\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover,\n.react-datepicker__quarter-text--disabled:hover,\n.react-datepicker__year-text--disabled:hover {\n  background-color: transparent;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n.react-datepicker__input-container .react-datepicker__calendar-icon {\n  position: absolute;\n  padding: 0.5rem;\n}\n\n.react-datepicker__view-calendar-icon input {\n  padding: 6px 10px 5px 25px;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n  position: relative;\n}\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: #b3b3b3;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  transform: rotate(135deg);\n  right: -16px;\n  top: 0;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ccc;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: #b3b3b3;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: #b3b3b3;\n}\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  padding: 0 6px 0 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n}\n.react-datepicker__close-icon::after {\n  cursor: pointer;\n  background-color: #216ba5;\n  color: #fff;\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  padding: 2px;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n  content: \"×\";\n}\n\n.react-datepicker__today-button {\n  background: #f0f0f0;\n  border-top: 1px solid #aeaeae;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n}\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.44rem;\n}\n\n.react-datepicker__children-container {\n  width: 13.8rem;\n  margin: 0.4rem;\n  padding-right: 0.2rem;\n  padding-left: 0.2rem;\n  height: auto;\n}\n\n.react-datepicker__aria-live {\n  position: absolute;\n  clip-path: circle(0);\n  border: 0;\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  width: 1px;\n  white-space: nowrap;\n}\n\n.react-datepicker__calendar-icon {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.125em;\n}\n\n.react-datepicker-popper {\n  z-index: 2;\n}\n\n.paylixecommerce-date-picker-wrapper {\n  width: 100%;\n}\n\n.react-datepicker {\n  --mainBackPicker: white;\n  --mainColorPicker: #121417;\n\n  background-color: white;\n}\n\n.dark {\n  .react-datepicker {\n    --mainBackPicker: #121417 !important;\n    --mainColorPicker: white !important;\n\n    background-color: #121417;\n  }\n\n  .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n    border-bottom-color: #131417;\n  }\n  .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {\n    border-top-color: #131417;\n  }\n}\n\n.react-datepicker__triangle {\n  position: absolute !important;\n  left: 50% !important;\n  transform: translateX(-50%) !important;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::before {\n  border-bottom-color: white !important;\n}\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle::before {\n  border-top-color: white !important;\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  --mainBackPicker: #454C56;\n  --mainColorPicker: white;\n  border-bottom-color: white;\n}\n\n\n\n.react-datepicker-popper[data-placement^=\"left\"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=\"left\"] .react-datepicker__triangle::before {\n  border-bottom-color: var(--mainBackPicker) !important;\n}\n.react-datepicker-popper[data-placement^=\"right\"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=\"right\"] .react-datepicker__triangle::before {\n  border-top-color: var(--mainBackPicker) !important;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #6a3ce2;\n  color: white;\n\n\n  &:hover {\n    background-color: #6a3ce2;\n  }\n}\n\n.react-datepicker-popper {\n  background: transparent;\n//box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 3px -2px rgba(0, 0, 0, 0.12) !important;\n  border-radius: 3px;\n\n  .react-datepicker {\n    box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08), 0 2px 24px -2px rgba(7, 14, 35, 0.12);\n    border-radius: .5rem;\n    border: none;\n\n    &__triangle::before {\n    //box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 3px -2px rgba(0, 0, 0, 0.12) !important;\n      border: none !important;\n    }\n\n    &__header {\n      border-bottom: 0;\n      border-radius: .5rem .5rem 0 0;\n      background: var(--mainBackPicker);\n      padding-top: 1.25rem;\n    }\n\n    &__day--keyboard-selected {\n      border-radius: 100% !important;\n      background-color: #6a3ce2 !important;\n    }\n\n    &__day {\n      &:hover {\n        border-radius: 100% !important;\n        background-color: #a191f4 !important;\n        color: white;\n      }\n    }\n\n\n    &__day--disabled,\n    &__month-text--disabled,\n    &__quarter-text--disabled {\n      color: #b4aebc !important;\n    }\n\n    &__day--selected,\n    &__day--in-selecting-range,\n    &__day--in-range,\n    &__month-text--selected,\n    &__month-text--in-selecting-range,\n    &__month-text--in-range,\n    &__quarter-text--selected,\n    &__quarter-text--in-selecting-range,\n    &__quarter-text--in-range {\n      background: #6a3ce2;\n      color: white !important;\n      font-weight: 600;\n    }\n\n    &__day--selected:hover,\n    &__day--in-selecting-range:hover,\n    &__day--in-range:hover,\n    &__month-text--selected:hover,\n    &__month-text--in-selecting-range:hover,\n    &__month-text--in-range:hover,\n    &__quarter-text--selected:hover,\n    &__quarter-text--in-selecting-range:hover,\n    &__quarter-text--in-range:hover {\n      background-color: #6a3ce2;\n    }\n\n    &__current-month,\n    &-time__header,\n    &-year-header {\n      color: var(--mainColorPicker);\n      font-family: \"Inter\", sans-serif;\n      font-style: normal;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 17px;\n    }\n\n    &__navigation {\n      top: .75rem;\n\n      &:focus {\n        outline: none;\n      //box-shadow: 0 0 0 0.2rem rgba(97, 59, 234, 0.25);\n        border-radius: 3px;\n      }\n\n\n      &--next {\n        //border-left-color: var(--mainColorPicker);\n\n        &:hover {\n          //border-left-color: var(--mainColorPicker);\n        }\n      }\n\n      &--previous {\n        //border-right-color: var(--mainColorPicker);\n\n        &:hover {\n          //border-right-color: var(--mainColorPicker);\n        }\n      }\n    }\n\n\n    &__day-names {\n      padding-top: .5rem;\n      padding-bottom: 0;\n      color: var(--mainColorPicker);\n      margin: 0;\n    }\n\n    &__day-name,\n    &__day,\n    &__time-name {\n      height: 40px;\n      width: 40px;\n      line-height: 40px;\n      font-size: 13px;\n      font-weight: 500;\n      margin: 0;\n      border-radius: 100%;\n      //color: #121417 !important;\n      background-color: #6a3ce2;\n\n      &:focus {\n      //box-shadow: 0 0 0 0.2rem rgba(97, 59, 234, 0.25);\n        border-radius: 3px;\n      }\n    }\n  }\n}\n\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::before {\n  border-bottom-color: var(--mainBackPicker) !important;\n}\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle::before {\n  border-top-color: var(--mainBackPicker) !important;\n}\n\n\n.react-datepicker-popper[data-placement^=\"left\"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=\"left\"] .react-datepicker__triangle::before {\n  border-bottom-color: var(--mainBackPicker) !important;\n}\n.react-datepicker-popper[data-placement^=\"right\"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=\"right\"] .react-datepicker__triangle::before {\n  border-top-color: var(--mainBackPicker) !important;\n}\n\n\n\n.dark .react-datepicker-popper {\n  .react-datepicker {\n\n    &__day--selected,\n    &__day--in-selecting-range,\n    &__day--in-range,\n    &__month-text--selected,\n    &__month-text--in-selecting-range,\n    &__month-text--in-range,\n    &__quarter-text--selected,\n    &__quarter-text--in-selecting-range,\n    &__quarter-text--in-range {\n      background: var(--mainColorPicker);\n      color: white !important;\n      border-radius: 100%;\n    }\n\n    &__day--selected:hover,\n    &__day--in-selecting-range:hover,\n    &__day--in-range:hover,\n    &__month-text--selected:hover,\n    &__month-text--in-selecting-range:hover,\n    &__month-text--in-range:hover,\n    &__quarter-text--selected:hover,\n    &__quarter-text--in-selecting-range:hover,\n    &__quarter-text--in-range:hover {\n      background: var(--mainColorPicker);\n      color: var(--mainBackPicker) !important;\n    }\n\n    &__current-month,\n    &-time__header,\n    &-year-header {\n      color: var(--mainColorPicker);\n    }\n\n    &__day-name,\n    &__day,\n    &__time-name {\n      color: white;\n      background-color: var(--mainBackPicker);\n    }\n  }\n}\n\n.react-datepicker-popper {\n\n  .react-datepicker {\n    border: none;\n\n    &__header {\n      background: var(--mainBackPicker);\n      padding-top: 1.5rem;\n      padding-left: 1.5rem;\n      padding-right: 1.5rem;\n      padding-bottom: 0;\n      border: none;\n    }\n\n    &__day--disabled,\n    &__month-text--disabled,\n    &__quarter-text--disabled {\n      color: #b4aebc !important;\n    }\n\n    &__day--selected,\n    &__day--in-selecting-range,\n    &__day--in-range,\n    &__month-text--selected,\n    &__month-text--in-selecting-range,\n    &__month-text--in-range,\n    &__quarter-text--selected,\n    &__quarter-text--in-selecting-range,\n    &__quarter-text--in-range {\n      background: var(--mainColorPicker);\n      color: white !important;\n      border-radius: 100%;\n    }\n\n    &__day--selected:hover,\n    &__day--in-selecting-range:hover,\n    &__day--in-range:hover,\n    &__month-text--selected:hover,\n    &__month-text--in-selecting-range:hover,\n    &__month-text--in-range:hover,\n    &__quarter-text--selected:hover,\n    &__quarter-text--in-selecting-range:hover,\n    &__quarter-text--in-range:hover {\n      background: var(--mainColorPicker);\n      color: var(--mainBackPicker) !important;\n    }\n\n    &__current-month,\n    &-time__header,\n    &-year-header {\n      color: var(--mainColorPicker);\n    }\n\n    &__day-name,\n    &__day,\n    &__time-name {\n      color: #121417;\n      background-color: var(--mainBackPicker);\n\n      &--selected {\n        background-color: #6a3ce2 !important;\n      }\n    }\n  }\n}\n\n\n\n\n.react-datepicker-popper .react-datepicker__navigation {\n  top: 1rem;\n}\n\n.react-datepicker__navigation-icon {\n  width: 20px;\n  height: 20px;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n.react-datepicker__navigation.react-datepicker__navigation--previous {\n  left: 1.5rem;\n  right: auto;\n}\n.dark .react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous:before {\n  background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none' viewBox='0 0 20 20'%3E%3Cpath d='M12.5 5L7.5 10L12.5 15' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E \");\n}\n.react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous:before {\n  background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none' viewBox='0 0 20 20'%3E%3Cpath d='M12.5 5L7.5 10L12.5 15' stroke='%23555D67' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E \");\n  width: 20px;\n  height: 20px;\n  border: none;\n  transform: none;\n  left: 0;\n  top: 0;\n}\n.react-datepicker__navigation.react-datepicker__navigation--next {\n  right: 1.5rem;\n  left: auto;\n}\n.dark .react-datepicker__navigation-icon.react-datepicker__navigation-icon--next:before {\n  background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none' viewBox='0 0 20 20'%3E%3Cpath d='M7.5 5L12.5 10L7.5 15' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E \");\n}\n.react-datepicker__navigation-icon.react-datepicker__navigation-icon--next:before {\n  background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none' viewBox='0 0 20 20'%3E%3Cpath d='M7.5 5L12.5 10L7.5 15' stroke='%23555D67' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  width: 20px;\n  height: 20px;\n  border: none;\n  transform: none;\n  left: 0;\n  top: 0;\n}\n\n.react-datepicker__month {\n  margin: 0;\n  padding-bottom: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
